[
  {
    "id": "dura_77",
    "brand": "Duratiles",
    "title": "ALBERO Açık 30x180",
    "seriesName": "ALBERO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "77",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5612731662236101.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5612731662236101.jpg"
    ],
    "size": "30x180",
    "color": "Açık",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "V4",
      "Ticari Alanlar",
      "Balkon Teras",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu, mat yüzeyi ile Albero Serisi dingin ama etkileyici yaşam alanları vadediyor. İki ayrı renk seçeneği sunan serinin fonksiyonel yapısı, kendinizi rahatça yansıtabileceğiniz özgür tasarımların yolunu açmakta.</span>",
    "descriptionClean": "Ahşap dokusu, mat yüzeyi ile Albero Serisi dingin ama etkileyici yaşam alanları vadediyor. İki ayrı renk seçeneği sunan serinin fonksiyonel yapısı, kendinizi rahatça yansıtabileceğiniz özgür tasarımların yolunu açmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_78",
    "brand": "Duratiles",
    "title": "ALBERO Koyu 30x180",
    "seriesName": "ALBERO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "78",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6339986030146776.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6339986030146776.jpg"
    ],
    "size": "30x180",
    "color": "Koyu",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "V4",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu, mat yüzeyi ile Albero Serisi dingin ama etkileyici yaşam alanları vadediyor. İki ayrı renk seçeneği sunan serinin fonksiyonel yapısı, kendinizi rahatça yansıtabileceğiniz özgür tasarımların yolunu açmakta.</span>",
    "descriptionClean": "Ahşap dokusu, mat yüzeyi ile Albero Serisi dingin ama etkileyici yaşam alanları vadediyor. İki ayrı renk seçeneği sunan serinin fonksiyonel yapısı, kendinizi rahatça yansıtabileceğiniz özgür tasarımların yolunu açmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_79",
    "brand": "Duratiles",
    "title": "ATELIER Bej 15x60",
    "seriesName": "ATELIER",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "79671",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8973637064125544.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8973637064125544.jpg"
    ],
    "size": "15x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap trendini seramiğin avantajlarıyla buluşturan Atelier Porselen Karoları doğal renk skalasıyla mekanlara naturel bir hava katıyor.</span>",
    "descriptionClean": "Ahşap trendini seramiğin avantajlarıyla buluşturan Atelier Porselen Karoları doğal renk skalasıyla mekanlara naturel bir hava katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_80",
    "brand": "Duratiles",
    "title": "ATELIER Gri 15x60",
    "seriesName": "ATELIER",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "80",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.37662892851855134.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.37662892851855134.jpg"
    ],
    "size": "15x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Balkon/Teras & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap trendini seramiğin avantajlarıyla buluşturan Atelier Porselen Karoları doğal renk skalasıyla mekanlara naturel bir hava katıyor.</span>",
    "descriptionClean": "Ahşap trendini seramiğin avantajlarıyla buluşturan Atelier Porselen Karoları doğal renk skalasıyla mekanlara naturel bir hava katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_83",
    "brand": "Duratiles",
    "title": "ATELIER Koyu Gri 15x60",
    "seriesName": "ATELIER",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "83",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7728432527757099.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7728432527757099.jpg"
    ],
    "size": "15x60",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap trendini seramiğin avantajlarıyla buluşturan Atelier Porselen Karoları doğal renk skalasıyla mekanlara naturel bir hava katıyor.</span>",
    "descriptionClean": "Ahşap trendini seramiğin avantajlarıyla buluşturan Atelier Porselen Karoları doğal renk skalasıyla mekanlara naturel bir hava katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_81",
    "brand": "Duratiles",
    "title": "ATELIER Fildişi 15x60",
    "seriesName": "ATELIER",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "81",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9445500131837165.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9445500131837165.jpg"
    ],
    "size": "15x60",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Balkon/Teras & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap trendini seramiğin avantajlarıyla buluşturan Atelier Porselen Karoları doğal renk skalasıyla mekanlara naturel bir hava katıyor.</span>",
    "descriptionClean": "Ahşap trendini seramiğin avantajlarıyla buluşturan Atelier Porselen Karoları doğal renk skalasıyla mekanlara naturel bir hava katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_82",
    "brand": "Duratiles",
    "title": "ATELIER Kahve 15x60",
    "seriesName": "ATELIER",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "82",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9274271893564829.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9274271893564829.jpg"
    ],
    "size": "15x60",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap trendini seramiğin avantajlarıyla buluşturan Atelier Porselen Karoları doğal renk skalasıyla mekanlara naturel bir hava katıyor.</span>",
    "descriptionClean": "Ahşap trendini seramiğin avantajlarıyla buluşturan Atelier Porselen Karoları doğal renk skalasıyla mekanlara naturel bir hava katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_84",
    "brand": "Duratiles",
    "title": "AVENUE Avenue 15x90",
    "seriesName": "AVENUE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "84",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16363980194567807.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16363980194567807.jpg"
    ],
    "size": "15x90",
    "color": "Avenue",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sadeliği ile mekanlara çağdaş bir görünüm kazandıran Avenue Serisi özgün mekanlar yaratır.</span><br><div style=\"text-align: center;\"><br></div>",
    "descriptionClean": "Sadeliği ile mekanlara çağdaş bir görünüm kazandıran Avenue Serisi özgün mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_85",
    "brand": "Duratiles",
    "title": "BANZAI Rigor 15x90",
    "seriesName": "BANZAI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "74000",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14363732367923565.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14363732367923565.jpg"
    ],
    "size": "15x90",
    "color": "Rigor",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Banyo ve mutfak gibi ıslak hacimlerde bile ahşabın o sıcak görünüme kavuşmak Banzai Porselen Karoları ile mümkün. Ahşabın sıcaklığı seramiğin kullanım kolaylığı ile harmanlandı.</span>",
    "descriptionClean": "Banyo ve mutfak gibi ıslak hacimlerde bile ahşabın o sıcak görünüme kavuşmak Banzai Porselen Karoları ile mümkün. Ahşabın sıcaklığı seramiğin kullanım kolaylığı ile harmanlandı.",
    "source": "duratiles"
  },
  {
    "id": "dura_86",
    "brand": "Duratiles",
    "title": "BANZAI Ardor 15x90",
    "seriesName": "BANZAI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "86",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9289220876058076.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9289220876058076.jpg"
    ],
    "size": "15x90",
    "color": "Ardor",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Banyo ve mutfak gibi ıslak hacimlerde bile ahşabın o sıcak görünüme kavuşmak Banzai Porselen Karoları ile mümkün. Ahşabın sıcaklığı seramiğin kullanım kolaylığı ile harmanlandı.</span>",
    "descriptionClean": "Banyo ve mutfak gibi ıslak hacimlerde bile ahşabın o sıcak görünüme kavuşmak Banzai Porselen Karoları ile mümkün. Ahşabın sıcaklığı seramiğin kullanım kolaylığı ile harmanlandı.",
    "source": "duratiles"
  },
  {
    "id": "dura_87",
    "brand": "Duratiles",
    "title": "BANZAI Valor 15x90",
    "seriesName": "BANZAI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "87",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11067257326398261.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11067257326398261.jpg"
    ],
    "size": "15x90",
    "color": "Valor",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Banyo ve mutfak gibi ıslak hacimlerde bile ahşabın o sıcak görünüme kavuşmak Banzai Porselen Karoları ile mümkün. Ahşabın sıcaklığı seramiğin kullanım kolaylığı ile harmanlandı.</span>",
    "descriptionClean": "Banyo ve mutfak gibi ıslak hacimlerde bile ahşabın o sıcak görünüme kavuşmak Banzai Porselen Karoları ile mümkün. Ahşabın sıcaklığı seramiğin kullanım kolaylığı ile harmanlandı.",
    "source": "duratiles"
  },
  {
    "id": "dura_88",
    "brand": "Duratiles",
    "title": "BANZAI Fervor 15x90",
    "seriesName": "BANZAI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "88",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6540393925058289.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6540393925058289.jpg"
    ],
    "size": "15x90",
    "color": "Fervor",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Banyo ve mutfak gibi ıslak hacimlerde bile ahşabın o sıcak görünüme kavuşmak Banzai Porselen Karoları ile mümkün. Ahşabın sıcaklığı seramiğin kullanım kolaylığı ile harmanlandı.</span>",
    "descriptionClean": "Banyo ve mutfak gibi ıslak hacimlerde bile ahşabın o sıcak görünüme kavuşmak Banzai Porselen Karoları ile mümkün. Ahşabın sıcaklığı seramiğin kullanım kolaylığı ile harmanlandı.",
    "source": "duratiles"
  },
  {
    "id": "dura_89",
    "brand": "Duratiles",
    "title": "BAROK Çam 60x60",
    "seriesName": "BAROK",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "89",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4859482644246256.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4859482644246256.jpg"
    ],
    "size": "60x60",
    "color": "Çam",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Aşınmayan, solmayan renkleri, ve ahşap dokusuyla Barok Serisi, rafine tasarım anlayışını yaşam alanlarınıza taşıyor.</span>",
    "descriptionClean": "Aşınmayan, solmayan renkleri, ve ahşap dokusuyla Barok Serisi, rafine tasarım anlayışını yaşam alanlarınıza taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_90",
    "brand": "Duratiles",
    "title": "BAROK Meşe 60x60",
    "seriesName": "BAROK",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "90",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.660662839993997.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.660662839993997.jpg"
    ],
    "size": "60x60",
    "color": "Meşe",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Aşınmayan, solmayan renkleri, ve ahşap dokusuyla Barok Serisi, rafine tasarım anlayışını yaşam alanlarınıza taşıyor.</span>",
    "descriptionClean": "Aşınmayan, solmayan renkleri, ve ahşap dokusuyla Barok Serisi, rafine tasarım anlayışını yaşam alanlarınıza taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_91",
    "brand": "Duratiles",
    "title": "BAROK Ceviz 60x60",
    "seriesName": "BAROK",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "91",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6163173529644416.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6163173529644416.jpg"
    ],
    "size": "60x60",
    "color": "Ceviz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Aşınmayan, solmayan renkleri, ve ahşap dokusuyla Barok Serisi, rafine tasarım anlayışını yaşam alanlarınıza taşıyor.</span>",
    "descriptionClean": "Aşınmayan, solmayan renkleri, ve ahşap dokusuyla Barok Serisi, rafine tasarım anlayışını yaşam alanlarınıza taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_92",
    "brand": "Duratiles",
    "title": "BAUM Kahve 60x90",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "92",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30065828192187516.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30065828192187516.jpg"
    ],
    "size": "60x90",
    "color": "Kahve",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_93",
    "brand": "Duratiles",
    "title": "BAUM Koyu 60x90",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "93",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8513824980570148.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8513824980570148.jpg"
    ],
    "size": "60x90",
    "color": "Koyu",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_94",
    "brand": "Duratiles",
    "title": "BAUM Açık 60x90",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "94",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8124947971594372.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8124947971594372.jpg"
    ],
    "size": "60x90",
    "color": "Açık",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_95",
    "brand": "Duratiles",
    "title": "BAUM Kahve 45x90",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "95",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9577668771301143.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9577668771301143.jpg"
    ],
    "size": "45x90",
    "color": "Kahve",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_96",
    "brand": "Duratiles",
    "title": "BAUM Açık 45x90",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "96",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03771641264080683.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03771641264080683.jpg"
    ],
    "size": "45x90",
    "color": "Açık",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_97",
    "brand": "Duratiles",
    "title": "BAUM Koyu 45x90",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "97",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6998260840976472.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6998260840976472.jpg"
    ],
    "size": "45x90",
    "color": "Koyu",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Havuz & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_98",
    "brand": "Duratiles",
    "title": "BAUM Koyu 60x120",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "98",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11806434699341817.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11806434699341817.jpg"
    ],
    "size": "60x120",
    "color": "Koyu",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_99",
    "brand": "Duratiles",
    "title": "BAUM Açık 60x120",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "99",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07445810046381673.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07445810046381673.jpg"
    ],
    "size": "60x120",
    "color": "Açık",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_100",
    "brand": "Duratiles",
    "title": "BAUM Kahve 60x120",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "100",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.058450180903161786.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.058450180903161786.jpg"
    ],
    "size": "60x120",
    "color": "Kahve",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_101",
    "brand": "Duratiles",
    "title": "BAUM Açık 40x120",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "101",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.02063073141113303.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.02063073141113303.jpg"
    ],
    "size": "40x120",
    "color": "Açık",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_102",
    "brand": "Duratiles",
    "title": "BAUM Koyu 40x120",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "102",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.006674027775236069.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.006674027775236069.jpg"
    ],
    "size": "40x120",
    "color": "Koyu",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_103",
    "brand": "Duratiles",
    "title": "BAUM Kahve 40x120",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "103",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8287735957854812.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8287735957854812.jpg"
    ],
    "size": "40x120",
    "color": "Kahve",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_104",
    "brand": "Duratiles",
    "title": "BAUM Açık 30x120",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "104",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6604725702403742.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6604725702403742.jpg"
    ],
    "size": "30x120",
    "color": "Açık",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_105",
    "brand": "Duratiles",
    "title": "BAUM Koyu 30x120",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "105",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7315591305840625.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7315591305840625.jpg"
    ],
    "size": "30x120",
    "color": "Koyu",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_106",
    "brand": "Duratiles",
    "title": "BAUM Kahve 30x120",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "106",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7699062206571515.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7699062206571515.jpg"
    ],
    "size": "30x120",
    "color": "Kahve",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_113",
    "brand": "Duratiles",
    "title": "BAUM Açık 60x60",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "113",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8539525624376518.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8539525624376518.jpg"
    ],
    "size": "60x60",
    "color": "Açık",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_115",
    "brand": "Duratiles",
    "title": "BAUM Kahve 60x60",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "115",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9673845631457649.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9673845631457649.jpg"
    ],
    "size": "60x60",
    "color": "Kahve",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_114",
    "brand": "Duratiles",
    "title": "BAUM Koyu 60x60",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "114",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8108640168323279.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8108640168323279.jpg"
    ],
    "size": "60x60",
    "color": "Koyu",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_107",
    "brand": "Duratiles",
    "title": "BAUM Açık 80x80",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "107",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48173245569220713.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48173245569220713.jpg"
    ],
    "size": "80x80",
    "color": "Açık",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_108",
    "brand": "Duratiles",
    "title": "BAUM Koyu 80x80",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "108",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4692909449394108.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4692909449394108.jpg"
    ],
    "size": "80x80",
    "color": "Koyu",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_109",
    "brand": "Duratiles",
    "title": "BAUM Kahve 80x80",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "109",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.32919887789424207.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.32919887789424207.jpg"
    ],
    "size": "80x80",
    "color": "Kahve",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_112",
    "brand": "Duratiles",
    "title": "BAUM Kahve 40x80",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "112",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46066450591827934.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46066450591827934.jpg"
    ],
    "size": "40x80",
    "color": "Kahve",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_111",
    "brand": "Duratiles",
    "title": "BAUM Koyu 40x80",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "111",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8884633574712824.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8884633574712824.jpg"
    ],
    "size": "40x80",
    "color": "Koyu",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_110",
    "brand": "Duratiles",
    "title": "BAUM Açık 40x80",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "110",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3874571692820268.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3874571692820268.jpg"
    ],
    "size": "40x80",
    "color": "Açık",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_116",
    "brand": "Duratiles",
    "title": "BAUM Açık 40x40",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "116",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1830373525406056.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1830373525406056.jpg"
    ],
    "size": "40x40",
    "color": "Açık",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_117",
    "brand": "Duratiles",
    "title": "BAUM Koyu 40x40",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "117",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15273518519645535.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15273518519645535.jpg"
    ],
    "size": "40x40",
    "color": "Koyu",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_118",
    "brand": "Duratiles",
    "title": "BAUM Kahve 40x40",
    "seriesName": "BAUM",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "118",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7779629211578404.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7779629211578404.jpg"
    ],
    "size": "40x40",
    "color": "Kahve",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Kuru döşeme alternatifine sahip olan Baum Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_137",
    "brand": "Duratiles",
    "title": "BEECHWOOD Akçaağaç 15x60",
    "seriesName": "BEECHWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "137",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4595573760386664.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4595573760386664.jpg"
    ],
    "size": "15x60",
    "color": "Akçaağaç",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Her adımda seramiğin dokusunu hissedin. Ahşap görünüm, seramik doku Beechwood serisinde buluştu. Geniş renk seçeneği ile her zevke hitap eden seri mat yüzeyi ile pekiştirdiği doğallığını solmayan renkleriyle arttırmakta.</span>",
    "descriptionClean": "Her adımda seramiğin dokusunu hissedin. Ahşap görünüm, seramik doku Beechwood serisinde buluştu. Geniş renk seçeneği ile her zevke hitap eden seri mat yüzeyi ile pekiştirdiği doğallığını solmayan renkleriyle arttırmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_138",
    "brand": "Duratiles",
    "title": "BEECHWOOD Kiraz 15x60",
    "seriesName": "BEECHWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "138",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.47354173330838545.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.47354173330838545.jpg"
    ],
    "size": "15x60",
    "color": "Kiraz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Her adımda seramiğin dokusunu hissedin. Ahşap görünüm, seramik doku Beechwood serisinde buluştu. Geniş renk seçeneği ile her zevke hitap eden seri mat yüzeyi ile pekiştirdiği doğallığını solmayan renkleriyle arttırmakta.</span>",
    "descriptionClean": "Her adımda seramiğin dokusunu hissedin. Ahşap görünüm, seramik doku Beechwood serisinde buluştu. Geniş renk seçeneği ile her zevke hitap eden seri mat yüzeyi ile pekiştirdiği doğallığını solmayan renkleriyle arttırmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_139",
    "brand": "Duratiles",
    "title": "BEECHWOOD Ceviz 15x60",
    "seriesName": "BEECHWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "139",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5285993780966377.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5285993780966377.jpg"
    ],
    "size": "15x60",
    "color": "Ceviz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Her adımda seramiğin dokusunu hissedin. Ahşap görünüm, seramik doku Beechwood serisinde buluştu. Geniş renk seçeneği ile her zevke hitap eden seri mat yüzeyi ile pekiştirdiği doğallığını solmayan renkleriyle arttırmakta.</span>",
    "descriptionClean": "Her adımda seramiğin dokusunu hissedin. Ahşap görünüm, seramik doku Beechwood serisinde buluştu. Geniş renk seçeneği ile her zevke hitap eden seri mat yüzeyi ile pekiştirdiği doğallığını solmayan renkleriyle arttırmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_140",
    "brand": "Duratiles",
    "title": "BEECHWOOD Meşe 15x60",
    "seriesName": "BEECHWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "140",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7075054601193215.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7075054601193215.jpg"
    ],
    "size": "15x60",
    "color": "Meşe",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V2",
      "Balkon Teras",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Her adımda seramiğin dokusunu hissedin. Ahşap görünüm, seramik doku Beechwood serisinde buluştu. Geniş renk seçeneği ile her zevke hitap eden seri mat yüzeyi ile pekiştirdiği doğallığını solmayan renkleriyle arttırmakta.</span>",
    "descriptionClean": "Her adımda seramiğin dokusunu hissedin. Ahşap görünüm, seramik doku Beechwood serisinde buluştu. Geniş renk seçeneği ile her zevke hitap eden seri mat yüzeyi ile pekiştirdiği doğallığını solmayan renkleriyle arttırmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_141",
    "brand": "Duratiles",
    "title": "BEECHWOOD Gümüş 15x60",
    "seriesName": "BEECHWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "141",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8751250862408069.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8751250862408069.jpg"
    ],
    "size": "15x60",
    "color": "Gümüş",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V2",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Her adımda seramiğin dokusunu hissedin. Ahşap görünüm, seramik doku Beechwood serisinde buluştu. Geniş renk seçeneği ile her zevke hitap eden seri mat yüzeyi ile pekiştirdiği doğallığını solmayan renkleriyle arttırmakta.</span>",
    "descriptionClean": "Her adımda seramiğin dokusunu hissedin. Ahşap görünüm, seramik doku Beechwood serisinde buluştu. Geniş renk seçeneği ile her zevke hitap eden seri mat yüzeyi ile pekiştirdiği doğallığını solmayan renkleriyle arttırmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_142",
    "brand": "Duratiles",
    "title": "BEECHWOOD Wenge 15x60",
    "seriesName": "BEECHWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "142",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09535647550303039.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09535647550303039.jpg"
    ],
    "size": "15x60",
    "color": "Wenge",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V2",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Her adımda seramiğin dokusunu hissedin. Ahşap görünüm, seramik doku Beechwood serisinde buluştu. Geniş renk seçeneği ile her zevke hitap eden seri mat yüzeyi ile pekiştirdiği doğallığını solmayan renkleriyle arttırmakta.</span>",
    "descriptionClean": "Her adımda seramiğin dokusunu hissedin. Ahşap görünüm, seramik doku Beechwood serisinde buluştu. Geniş renk seçeneği ile her zevke hitap eden seri mat yüzeyi ile pekiştirdiği doğallığını solmayan renkleriyle arttırmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_127",
    "brand": "Duratiles",
    "title": "GLAMOUR Multi Dekor 60x60",
    "seriesName": "GLAMOUR",
    "collection": "Tekstil",
    "category": "Tekstil",
    "sku": "127",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36982974520126144.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36982974520126144.jpg"
    ],
    "size": "60x60",
    "color": "Multi Dekor",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Uygulandığı mekâna zengin ve zarif bir görünüm kazandıran Glamour serisi ile özgün bir tasarımın mimarı olabilirsiniz.</span>",
    "descriptionClean": "Uygulandığı mekâna zengin ve zarif bir görünüm kazandıran Glamour serisi ile özgün bir tasarımın mimarı olabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_126",
    "brand": "Duratiles",
    "title": "GLAMOUR Antrasit 60x60",
    "seriesName": "GLAMOUR",
    "collection": "Tekstil",
    "category": "Tekstil",
    "sku": "126",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12118682900013689.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12118682900013689.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Uygulandığı mekâna zengin ve zarif bir görünüm kazandıran Glamour serisi ile özgün bir tasarımın mimarı olabilirsiniz.</span>",
    "descriptionClean": "Uygulandığı mekâna zengin ve zarif bir görünüm kazandıran Glamour serisi ile özgün bir tasarımın mimarı olabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_125",
    "brand": "Duratiles",
    "title": "GLAMOUR Gri 60x60",
    "seriesName": "GLAMOUR",
    "collection": "Tekstil",
    "category": "Tekstil",
    "sku": "125",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.671777800884877.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.671777800884877.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Uygulandığı mekâna zengin ve zarif bir görünüm kazandıran Glamour serisi ile özgün bir tasarımın mimarı olabilirsiniz.</span>",
    "descriptionClean": "Uygulandığı mekâna zengin ve zarif bir görünüm kazandıran Glamour serisi ile özgün bir tasarımın mimarı olabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_143",
    "brand": "Duratiles",
    "title": "BONSAI Orjinal 15x90",
    "seriesName": "BONSAI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "143",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1503063282498206.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1503063282498206.jpg"
    ],
    "size": "15x90",
    "color": "Orjinal",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Balkon/Teras & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "Resistant",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bonsai, ahşabın zamansız güzelliğini modern yaşamla buluşturarak mekânlarda doğal bir uyum ve sıcaklık yaratıyor.</span>",
    "descriptionClean": "Bonsai, ahşabın zamansız güzelliğini modern yaşamla buluşturarak mekânlarda doğal bir uyum ve sıcaklık yaratıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_144",
    "brand": "Duratiles",
    "title": "BREMEN Kahve 60x120",
    "seriesName": "BREMEN",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "144",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4226924563531341.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4226924563531341.jpg"
    ],
    "size": "60x120",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "Bremen porselen karoları, her mekana uyum sağlayan tasarımlarıyla evlere mutluluk ve huzur getiriyor.",
    "descriptionClean": "Bremen porselen karoları, her mekana uyum sağlayan tasarımlarıyla evlere mutluluk ve huzur getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_145",
    "brand": "Duratiles",
    "title": "BUDAK Akçaağaç 45x45",
    "seriesName": "BUDAK",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "145",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4608217526091045.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4608217526091045.jpg"
    ],
    "size": "45x45",
    "color": "Akçaağaç",
    "surface": "Parlak",
    "thickness": "",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ahşabın sıcaklığını ,doğallığını renk ve dokusuna taşıyıp ,seramiğin dayanıklı ve fonksiyonel yapısıyla harmanlayan Budak Serisi Akçaağaç ve Çam renklerini 45x45 ebadıyla mekanlarınıza taşımakta. Solmayan renkleri ,suya ,ısıya dayanıklı yapısıyla kullanım kolaylığı sunan Budak Serisi doğayı yaşam alanlarınıza taşıyacak.</span>",
    "descriptionClean": "Ahşabın sıcaklığını ,doğallığını renk ve dokusuna taşıyıp ,seramiğin dayanıklı ve fonksiyonel yapısıyla harmanlayan Budak Serisi Akçaağaç ve Çam renklerini 45x45 ebadıyla mekanlarınıza taşımakta. Solmayan renkleri ,suya ,ısıya dayanıklı yapısıyla kullanım kolaylığı sunan Budak Serisi doğayı yaşam alanlarınıza taşıyacak.",
    "source": "duratiles"
  },
  {
    "id": "dura_146",
    "brand": "Duratiles",
    "title": "BUDAK Çam 45x45",
    "seriesName": "BUDAK",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "146",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7511404485946166.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7511404485946166.jpg"
    ],
    "size": "45x45",
    "color": "Çam",
    "surface": "Parlak",
    "thickness": "",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ahşabın sıcaklığını ,doğallığını renk ve dokusuna taşıyıp ,seramiğin dayanıklı ve fonksiyonel yapısıyla harmanlayan Budak Serisi Akçaağaç ve Çam renklerini 45x45 ebadıyla mekanlarınıza taşımakta. Solmayan renkleri ,suya ,ısıya dayanıklı yapısıyla kullanım kolaylığı sunan Budak Serisi doğayı yaşam alanlarınıza taşıyacak.</span>",
    "descriptionClean": "Ahşabın sıcaklığını ,doğallığını renk ve dokusuna taşıyıp ,seramiğin dayanıklı ve fonksiyonel yapısıyla harmanlayan Budak Serisi Akçaağaç ve Çam renklerini 45x45 ebadıyla mekanlarınıza taşımakta. Solmayan renkleri ,suya ,ısıya dayanıklı yapısıyla kullanım kolaylığı sunan Budak Serisi doğayı yaşam alanlarınıza taşıyacak.",
    "source": "duratiles"
  },
  {
    "id": "dura_170",
    "brand": "Duratiles",
    "title": "CADORE Cadore 60x60",
    "seriesName": "CADORE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "170",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5521488831549262.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5521488831549262.jpg"
    ],
    "size": "60x60",
    "color": "Cadore",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ahşap görünümü, sofistike tasarımı ve doğal renkleri ile Cadore Serisi görsel bir şölen ve sofistike bir atmosferi mekânlara getiriyor.</span>",
    "descriptionClean": "Ahşap görünümü, sofistike tasarımı ve doğal renkleri ile Cadore Serisi görsel bir şölen ve sofistike bir atmosferi mekânlara getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_171",
    "brand": "Duratiles",
    "title": "CAROLINE TIMBER Bej 15x60",
    "seriesName": "CAROLINE TIMBER",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "171",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8494379825219888.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8494379825219888.jpg"
    ],
    "size": "15x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Banyo & Balkon/Teras & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşabın büyüleyici atmosferini mekanlara taşıyan Caroline Timber Porselen Karoları mekanlara göz alıcı bir hava katmak için tasarlandı</span>",
    "descriptionClean": "Ahşabın büyüleyici atmosferini mekanlara taşıyan Caroline Timber Porselen Karoları mekanlara göz alıcı bir hava katmak için tasarlandı",
    "source": "duratiles"
  },
  {
    "id": "dura_172",
    "brand": "Duratiles",
    "title": "CAROLINE TIMBER Gri 15x60",
    "seriesName": "CAROLINE TIMBER",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "172",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2485340776377668.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2485340776377668.jpg"
    ],
    "size": "15x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Banyo & Balkon/Teras & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşabın büyüleyici atmosferini mekanlara taşıyan Caroline Timber Porselen Karoları mekanlara göz alıcı bir hava katmak için tasarlandı</span>",
    "descriptionClean": "Ahşabın büyüleyici atmosferini mekanlara taşıyan Caroline Timber Porselen Karoları mekanlara göz alıcı bir hava katmak için tasarlandı",
    "source": "duratiles"
  },
  {
    "id": "dura_173",
    "brand": "Duratiles",
    "title": "CAROLINE TIMBER Beyaz 15x60",
    "seriesName": "CAROLINE TIMBER",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "173",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6525234290759031.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6525234290759031.jpg"
    ],
    "size": "15x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Banyo & Balkon/Teras & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşabın büyüleyici atmosferini mekanlara taşıyan Caroline Timber Porselen Karoları mekanlara göz alıcı bir hava katmak için tasarlandı</span>",
    "descriptionClean": "Ahşabın büyüleyici atmosferini mekanlara taşıyan Caroline Timber Porselen Karoları mekanlara göz alıcı bir hava katmak için tasarlandı",
    "source": "duratiles"
  },
  {
    "id": "dura_174",
    "brand": "Duratiles",
    "title": "COLOR WOOD İce 15x90",
    "seriesName": "COLOR WOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "174",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7295760481879106.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7295760481879106.jpg"
    ],
    "size": "15x90",
    "color": "İce",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Color wood Serisi ile renklerin ahengi ahşabın dokusuyla buluşup seramiğin konforuyla harmanlandı.</span>",
    "descriptionClean": "Color wood Serisi ile renklerin ahengi ahşabın dokusuyla buluşup seramiğin konforuyla harmanlandı.",
    "source": "duratiles"
  },
  {
    "id": "dura_175",
    "brand": "Duratiles",
    "title": "COLOR WOOD Mavi 15x90",
    "seriesName": "COLOR WOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "175",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8075381511208771.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8075381511208771.jpg"
    ],
    "size": "15x90",
    "color": "Mavi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Color wood Serisi ile renklerin ahengi ahşabın dokusuyla buluşup seramiğin konforuyla harmanlandı.</span>",
    "descriptionClean": "Color wood Serisi ile renklerin ahengi ahşabın dokusuyla buluşup seramiğin konforuyla harmanlandı.",
    "source": "duratiles"
  },
  {
    "id": "dura_176",
    "brand": "Duratiles",
    "title": "COLOR WOOD Bone 15x90",
    "seriesName": "COLOR WOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "176",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9207763312894729.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9207763312894729.jpg"
    ],
    "size": "15x90",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Color wood Serisi ile renklerin ahengi ahşabın dokusuyla buluşup seramiğin konforuyla harmanlandı.</span>",
    "descriptionClean": "Color wood Serisi ile renklerin ahengi ahşabın dokusuyla buluşup seramiğin konforuyla harmanlandı.",
    "source": "duratiles"
  },
  {
    "id": "dura_177",
    "brand": "Duratiles",
    "title": "COLOR WOOD Kahve 15x90",
    "seriesName": "COLOR WOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "65881",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6946541876469386.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6946541876469386.jpg"
    ],
    "size": "15x90",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Color wood Serisi ile renklerin ahengi ahşabın dokusuyla buluşup seramiğin konforuyla harmanlandı.</span>",
    "descriptionClean": "Color wood Serisi ile renklerin ahengi ahşabın dokusuyla buluşup seramiğin konforuyla harmanlandı.",
    "source": "duratiles"
  },
  {
    "id": "dura_179",
    "brand": "Duratiles",
    "title": "COLOR WOOD İce 15x60",
    "seriesName": "COLOR WOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "179",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6695937937207873.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6695937937207873.jpg"
    ],
    "size": "15x60",
    "color": "İce",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Color wood Serisi ile renklerin ahengi ahşabın dokusuyla buluşup seramiğin konforuyla harmanlandı.</span>",
    "descriptionClean": "Color wood Serisi ile renklerin ahengi ahşabın dokusuyla buluşup seramiğin konforuyla harmanlandı.",
    "source": "duratiles"
  },
  {
    "id": "dura_178",
    "brand": "Duratiles",
    "title": "COLOR WOOD Bone 15x60",
    "seriesName": "COLOR WOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "178",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7517060758778348.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7517060758778348.jpg"
    ],
    "size": "15x60",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Color wood Serisi ile renklerin ahengi ahşabın dokusuyla buluşup seramiğin konforuyla harmanlandı.</span>",
    "descriptionClean": "Color wood Serisi ile renklerin ahengi ahşabın dokusuyla buluşup seramiğin konforuyla harmanlandı.",
    "source": "duratiles"
  },
  {
    "id": "dura_181",
    "brand": "Duratiles",
    "title": "COLOR WOOD Mavi 15x60",
    "seriesName": "COLOR WOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "181",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2665317429864681.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2665317429864681.jpg"
    ],
    "size": "15x60",
    "color": "Mavi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Color wood Serisi ile renklerin ahengi ahşabın dokusuyla buluşup seramiğin konforuyla harmanlandı.</span>",
    "descriptionClean": "Color wood Serisi ile renklerin ahengi ahşabın dokusuyla buluşup seramiğin konforuyla harmanlandı.",
    "source": "duratiles"
  },
  {
    "id": "dura_180",
    "brand": "Duratiles",
    "title": "COLOR WOOD Kahve 15x60",
    "seriesName": "COLOR WOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "180",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.628625249446605.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.628625249446605.jpg"
    ],
    "size": "15x60",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Color wood Serisi ile renklerin ahengi ahşabın dokusuyla buluşup seramiğin konforuyla harmanlandı.</span>",
    "descriptionClean": "Color wood Serisi ile renklerin ahengi ahşabın dokusuyla buluşup seramiğin konforuyla harmanlandı.",
    "source": "duratiles"
  },
  {
    "id": "dura_182",
    "brand": "Duratiles",
    "title": "COTTAGE Smoke 20x120",
    "seriesName": "COTTAGE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "182",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9620434401742071.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9620434401742071.jpg"
    ],
    "size": "20x120",
    "color": "Smoke",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin & Balkon/Teras & Banyo & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Balkon Teras",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Huzur verici renk paletiyle Cottage porselen karoları sofistike ve rahatlatıcı mekanlar oluşturur.</span>",
    "descriptionClean": "Huzur verici renk paletiyle Cottage porselen karoları sofistike ve rahatlatıcı mekanlar oluşturur.",
    "source": "duratiles"
  },
  {
    "id": "dura_183",
    "brand": "Duratiles",
    "title": "DURAWOOD Akçaağaç 60x120",
    "seriesName": "DURAWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "183",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7783814829684063.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7783814829684063.jpg"
    ],
    "size": "60x120",
    "color": "Akçaağaç",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap görünümünü üç farklı renk seçeneği ile zenginleştiren Durawood Serisi modern ve şık mekanlar vadediyor.</span>",
    "descriptionClean": "Ahşap görünümünü üç farklı renk seçeneği ile zenginleştiren Durawood Serisi modern ve şık mekanlar vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_184",
    "brand": "Duratiles",
    "title": "DURAWOOD Ceviz 60x120",
    "seriesName": "DURAWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "184",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8514192165646023.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8514192165646023.jpg"
    ],
    "size": "60x120",
    "color": "Ceviz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap görünümünü üç farklı renk seçeneği ile zenginleştiren Durawood Serisi modern ve şık mekanlar vadediyor.</span>",
    "descriptionClean": "Ahşap görünümünü üç farklı renk seçeneği ile zenginleştiren Durawood Serisi modern ve şık mekanlar vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_185",
    "brand": "Duratiles",
    "title": "DURAWOOD Ocean Blue 60x120",
    "seriesName": "DURAWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "185",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3396406510148724.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3396406510148724.jpg"
    ],
    "size": "60x120",
    "color": "Ocean Blue",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap görünümünü üç farklı renk seçeneği ile zenginleştiren Durawood Serisi modern ve şık mekanlar vadediyor.</span>",
    "descriptionClean": "Ahşap görünümünü üç farklı renk seçeneği ile zenginleştiren Durawood Serisi modern ve şık mekanlar vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_186",
    "brand": "Duratiles",
    "title": "EICHEWEIS Kahve 22x90",
    "seriesName": "EICHEWEIS",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "186",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.726516031738812.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.726516031738812.jpg"
    ],
    "size": "22x90",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Balkon/Teras & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğanın kusursuz uyumunu yansıtan Eicheweis Porselen Karosu dingin ve yalın iç mekan kurguları yaratır.</span>",
    "descriptionClean": "Doğanın kusursuz uyumunu yansıtan Eicheweis Porselen Karosu dingin ve yalın iç mekan kurguları yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_187",
    "brand": "Duratiles",
    "title": "EICHEWEIS Miele 22x90",
    "seriesName": "EICHEWEIS",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "187",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20444116371957.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20444116371957.jpg"
    ],
    "size": "22x90",
    "color": "Miele",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Balkon/Teras & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğanın kusursuz uyumunu yansıtan Eicheweis Porselen Karosu dingin ve yalın iç mekan kurguları yaratır.</span>",
    "descriptionClean": "Doğanın kusursuz uyumunu yansıtan Eicheweis Porselen Karosu dingin ve yalın iç mekan kurguları yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_189",
    "brand": "Duratiles",
    "title": "ELHAMRA Dekofon 45x45",
    "seriesName": "ELHAMRA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "189",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3310917661176934.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3310917661176934.jpg"
    ],
    "size": "45x45",
    "color": "Dekofon",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V2",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlhamını aldığı sarayın egzotik havasını modern çizgilerle buluşturan Elhamra Serisi hareketli ahşap dokusunu desenli dekor alternatifiyle çeşitlendirerek yaşam alanlarında fark yaratmak isteyenlere çözümler sunmaktadır.</span>",
    "descriptionClean": "İlhamını aldığı sarayın egzotik havasını modern çizgilerle buluşturan Elhamra Serisi hareketli ahşap dokusunu desenli dekor alternatifiyle çeşitlendirerek yaşam alanlarında fark yaratmak isteyenlere çözümler sunmaktadır.",
    "source": "duratiles"
  },
  {
    "id": "dura_188",
    "brand": "Duratiles",
    "title": "ELHAMRA Kahve 45x45",
    "seriesName": "ELHAMRA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "188",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2643127235943047.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2643127235943047.jpg"
    ],
    "size": "45x45",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V2",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlhamını aldığı sarayın egzotik havasını modern çizgilerle buluşturan Elhamra Serisi hareketli ahşap dokusunu desenli dekor alternatifiyle çeşitlendirerek yaşam alanlarında fark yaratmak isteyenlere çözümler sunmaktadır.</span>",
    "descriptionClean": "İlhamını aldığı sarayın egzotik havasını modern çizgilerle buluşturan Elhamra Serisi hareketli ahşap dokusunu desenli dekor alternatifiyle çeşitlendirerek yaşam alanlarında fark yaratmak isteyenlere çözümler sunmaktadır.",
    "source": "duratiles"
  },
  {
    "id": "dura_190",
    "brand": "Duratiles",
    "title": "ELITE Beyaz 15x60",
    "seriesName": "ELITE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "190",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9976401380735597.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9976401380735597.jpg"
    ],
    "size": "15x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar & Duvar & Yer",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğanın renk kartelasını ahşabın sıcak deseni ve renkleriyle yaşam alanlarına taşıyan Elite Serisi beş renk seçeneği ile size özel mekanlar yaratmakta. Hiç solmayan renkleri , ısıya, suya ve ışığa dirençli yapısıyla Elite Serisi natürel kurgular yaratabileceğiniz fonksiyonellikte.</span>",
    "descriptionClean": "Doğanın renk kartelasını ahşabın sıcak deseni ve renkleriyle yaşam alanlarına taşıyan Elite Serisi beş renk seçeneği ile size özel mekanlar yaratmakta. Hiç solmayan renkleri , ısıya, suya ve ışığa dirençli yapısıyla Elite Serisi natürel kurgular yaratabileceğiniz fonksiyonellikte.",
    "source": "duratiles"
  },
  {
    "id": "dura_191",
    "brand": "Duratiles",
    "title": "ELITE Koyu Gri 15x60",
    "seriesName": "ELITE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "191",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8212757102815403.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8212757102815403.jpg"
    ],
    "size": "15x60",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar & Duvar & Yer",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğanın renk kartelasını ahşabın sıcak deseni ve renkleriyle yaşam alanlarına taşıyan Elite Serisi beş renk seçeneği ile size özel mekanlar yaratmakta. Hiç solmayan renkleri , ısıya, suya ve ışığa dirençli yapısıyla Elite Serisi natürel kurgular yaratabileceğiniz fonksiyonellikte.</span>",
    "descriptionClean": "Doğanın renk kartelasını ahşabın sıcak deseni ve renkleriyle yaşam alanlarına taşıyan Elite Serisi beş renk seçeneği ile size özel mekanlar yaratmakta. Hiç solmayan renkleri , ısıya, suya ve ışığa dirençli yapısıyla Elite Serisi natürel kurgular yaratabileceğiniz fonksiyonellikte.",
    "source": "duratiles"
  },
  {
    "id": "dura_192",
    "brand": "Duratiles",
    "title": "ELITE Kayın 15x60",
    "seriesName": "ELITE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "192",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7894372937431609.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7894372937431609.jpg"
    ],
    "size": "15x60",
    "color": "Kayın",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Duvar & Yer & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğanın renk kartelasını ahşabın sıcak deseni ve renkleriyle yaşam alanlarına taşıyan Elite Serisi beş renk seçeneği ile size özel mekanlar yaratmakta. Hiç solmayan renkleri , ısıya, suya ve ışığa dirençli yapısıyla Elite Serisi natürel kurgular yaratabileceğiniz fonksiyonellikte.</span>",
    "descriptionClean": "Doğanın renk kartelasını ahşabın sıcak deseni ve renkleriyle yaşam alanlarına taşıyan Elite Serisi beş renk seçeneği ile size özel mekanlar yaratmakta. Hiç solmayan renkleri , ısıya, suya ve ışığa dirençli yapısıyla Elite Serisi natürel kurgular yaratabileceğiniz fonksiyonellikte.",
    "source": "duratiles"
  },
  {
    "id": "dura_193",
    "brand": "Duratiles",
    "title": "ELITE Ceviz 15x60",
    "seriesName": "ELITE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "193",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.45294647469530214.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.45294647469530214.jpg"
    ],
    "size": "15x60",
    "color": "Ceviz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Duvar & Yer & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V2",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğanın renk kartelasını ahşabın sıcak deseni ve renkleriyle yaşam alanlarına taşıyan Elite Serisi beş renk seçeneği ile size özel mekanlar yaratmakta. Hiç solmayan renkleri , ısıya, suya ve ışığa dirençli yapısıyla Elite Serisi natürel kurgular yaratabileceğiniz fonksiyonellikte.</span>",
    "descriptionClean": "Doğanın renk kartelasını ahşabın sıcak deseni ve renkleriyle yaşam alanlarına taşıyan Elite Serisi beş renk seçeneği ile size özel mekanlar yaratmakta. Hiç solmayan renkleri , ısıya, suya ve ışığa dirençli yapısıyla Elite Serisi natürel kurgular yaratabileceğiniz fonksiyonellikte.",
    "source": "duratiles"
  },
  {
    "id": "dura_194",
    "brand": "Duratiles",
    "title": "ELITE Çam 15x60",
    "seriesName": "ELITE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "30774",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46789131228279046.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46789131228279046.jpg"
    ],
    "size": "15x60",
    "color": "Çam",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Duvar & Yer",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğanın renk kartelasını ahşabın sıcak deseni ve renkleriyle yaşam alanlarına taşıyan Elite Serisi beş renk seçeneği ile size özel mekanlar yaratmakta. Hiç solmayan renkleri , ısıya, suya ve ışığa dirençli yapısıyla Elite Serisi natürel kurgular yaratabileceğiniz fonksiyonellikte.</span>",
    "descriptionClean": "Doğanın renk kartelasını ahşabın sıcak deseni ve renkleriyle yaşam alanlarına taşıyan Elite Serisi beş renk seçeneği ile size özel mekanlar yaratmakta. Hiç solmayan renkleri , ısıya, suya ve ışığa dirençli yapısıyla Elite Serisi natürel kurgular yaratabileceğiniz fonksiyonellikte.",
    "source": "duratiles"
  },
  {
    "id": "dura_195",
    "brand": "Duratiles",
    "title": "ELIWOODI Kahve 20x120",
    "seriesName": "ELIWOODI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "195",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5663741327845343.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5663741327845343.jpg"
    ],
    "size": "20x120",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Eliwoodi serisi ile yaşam alanlarınıza natürel bir şıklık kazandırabilirsiniz. Yanmaz, solmaz , su geçirmez ve hijyenik yapısıyla Eliwoodi'yi her alanda güvenle kullanabilirsiniz</span>",
    "descriptionClean": "Eliwoodi serisi ile yaşam alanlarınıza natürel bir şıklık kazandırabilirsiniz. Yanmaz, solmaz , su geçirmez ve hijyenik yapısıyla Eliwoodi'yi her alanda güvenle kullanabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_196",
    "brand": "Duratiles",
    "title": "ELIWOODI Latte 20x120",
    "seriesName": "ELIWOODI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "196",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.05647268051039733.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.05647268051039733.jpg"
    ],
    "size": "20x120",
    "color": "Latte",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Eliwoodi serisi ile yaşam alanlarınıza natürel bir şıklık kazandırabilirsiniz. Yanmaz, solmaz , su geçirmez ve hijyenik yapısıyla Eliwoodi'yi her alanda güvenle kullanabilirsiniz</span>",
    "descriptionClean": "Eliwoodi serisi ile yaşam alanlarınıza natürel bir şıklık kazandırabilirsiniz. Yanmaz, solmaz , su geçirmez ve hijyenik yapısıyla Eliwoodi'yi her alanda güvenle kullanabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_197",
    "brand": "Duratiles",
    "title": "ELIWOODI Smoke 20x120",
    "seriesName": "ELIWOODI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "197",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1584875088217882.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1584875088217882.jpg"
    ],
    "size": "20x120",
    "color": "Smoke",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Eliwoodi serisi ile yaşam alanlarınıza natürel bir şıklık kazandırabilirsiniz. Yanmaz, solmaz , su geçirmez ve hijyenik yapısıyla Eliwoodi'yi her alanda güvenle kullanabilirsiniz</span>",
    "descriptionClean": "Eliwoodi serisi ile yaşam alanlarınıza natürel bir şıklık kazandırabilirsiniz. Yanmaz, solmaz , su geçirmez ve hijyenik yapısıyla Eliwoodi'yi her alanda güvenle kullanabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_198",
    "brand": "Duratiles",
    "title": "ELIWOODI Wenge 20x120",
    "seriesName": "ELIWOODI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "198",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6237383751633805.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6237383751633805.jpg"
    ],
    "size": "20x120",
    "color": "Wenge",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Eliwoodi serisi ile yaşam alanlarınıza natürel bir şıklık kazandırabilirsiniz. Yanmaz, solmaz , su geçirmez ve hijyenik yapısıyla Eliwoodi'yi her alanda güvenle kullanabilirsiniz</span>",
    "descriptionClean": "Eliwoodi serisi ile yaşam alanlarınıza natürel bir şıklık kazandırabilirsiniz. Yanmaz, solmaz , su geçirmez ve hijyenik yapısıyla Eliwoodi'yi her alanda güvenle kullanabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_199",
    "brand": "Duratiles",
    "title": "ELIWOODI Smoke 15x60",
    "seriesName": "ELIWOODI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "64344",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44143316440461733.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44143316440461733.jpg"
    ],
    "size": "15x60",
    "color": "Smoke",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Eliwoodi serisi ile yaşam alanlarınıza natürel bir şıklık kazandırabilirsiniz. Yanmaz, solmaz , su geçirmez ve hijyenik yapısıyla Eliwoodi'yi her alanda güvenle kullanabilirsiniz</span>",
    "descriptionClean": "Eliwoodi serisi ile yaşam alanlarınıza natürel bir şıklık kazandırabilirsiniz. Yanmaz, solmaz , su geçirmez ve hijyenik yapısıyla Eliwoodi'yi her alanda güvenle kullanabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_200",
    "brand": "Duratiles",
    "title": "ELIWOODI Kahve 15x60",
    "seriesName": "ELIWOODI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "200",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11076390136418235.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11076390136418235.jpg"
    ],
    "size": "15x60",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Ev içi Zemin & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Eliwoodi serisi ile yaşam alanlarınıza natürel bir şıklık kazandırabilirsiniz. Yanmaz, solmaz , su geçirmez ve hijyenik yapısıyla Eliwoodi'yi her alanda güvenle kullanabilirsiniz</span>",
    "descriptionClean": "Eliwoodi serisi ile yaşam alanlarınıza natürel bir şıklık kazandırabilirsiniz. Yanmaz, solmaz , su geçirmez ve hijyenik yapısıyla Eliwoodi'yi her alanda güvenle kullanabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_201",
    "brand": "Duratiles",
    "title": "ELIWOODI Wenge 15x60",
    "seriesName": "ELIWOODI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "201",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19980494607553456.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19980494607553456.jpg"
    ],
    "size": "15x60",
    "color": "Wenge",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Ev içi Zemin & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Eliwoodi serisi ile yaşam alanlarınıza natürel bir şıklık kazandırabilirsiniz. Yanmaz, solmaz , su geçirmez ve hijyenik yapısıyla Eliwoodi'yi her alanda güvenle kullanabilirsiniz</span>",
    "descriptionClean": "Eliwoodi serisi ile yaşam alanlarınıza natürel bir şıklık kazandırabilirsiniz. Yanmaz, solmaz , su geçirmez ve hijyenik yapısıyla Eliwoodi'yi her alanda güvenle kullanabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_202",
    "brand": "Duratiles",
    "title": "ERAMOSA Noce 60x120",
    "seriesName": "ERAMOSA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "202",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6862867011928251.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6862867011928251.jpg"
    ],
    "size": "60x120",
    "color": "Noce",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Balkon/Teras & Banyo & Dış Cephe & Duvar & Yer & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mekanlara farklı bir soluk ve dinamizm taşıyan Nolita Serisi etkileyici yaşam alanları tasarlerken stilinizi ortaya çıkarmanızı da sağlayacaktır.</span>",
    "descriptionClean": "Mekanlara farklı bir soluk ve dinamizm taşıyan Nolita Serisi etkileyici yaşam alanları tasarlerken stilinizi ortaya çıkarmanızı da sağlayacaktır.",
    "source": "duratiles"
  },
  {
    "id": "dura_211",
    "brand": "Duratiles",
    "title": "ESSENCE Meşe 15x60",
    "seriesName": "ESSENCE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "211",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7819383435974279.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7819383435974279.jpg"
    ],
    "size": "15x60",
    "color": "Meşe",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaşama ahşabın özel görünümünü katın. Essence serisi ile doğal görünümü her alana taşıyın. Doğanın keyif veren enerjisi yaşam alanlarınızı sarsın.</span>",
    "descriptionClean": "Yaşama ahşabın özel görünümünü katın. Essence serisi ile doğal görünümü her alana taşıyın. Doğanın keyif veren enerjisi yaşam alanlarınızı sarsın.",
    "source": "duratiles"
  },
  {
    "id": "dura_212",
    "brand": "Duratiles",
    "title": "ESSENCE Tono 15x60",
    "seriesName": "ESSENCE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "212",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2477928198433429.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2477928198433429.jpg"
    ],
    "size": "15x60",
    "color": "Tono",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaşama ahşabın özel görünümünü katın. Essence serisi ile doğal görünümü her alana taşıyın. Doğanın keyif veren enerjisi yaşam alanlarınızı sarsın.</span>",
    "descriptionClean": "Yaşama ahşabın özel görünümünü katın. Essence serisi ile doğal görünümü her alana taşıyın. Doğanın keyif veren enerjisi yaşam alanlarınızı sarsın.",
    "source": "duratiles"
  },
  {
    "id": "dura_210",
    "brand": "Duratiles",
    "title": "ESSENCE Aria 15x60",
    "seriesName": "ESSENCE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "210",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14048220683327706.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14048220683327706.jpg"
    ],
    "size": "15x60",
    "color": "Aria",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaşama ahşabın özel görünümünü katın. Essence serisi ile doğal görünümü her alana taşıyın. Doğanın keyif veren enerjisi yaşam alanlarınızı sarsın.</span>",
    "descriptionClean": "Yaşama ahşabın özel görünümünü katın. Essence serisi ile doğal görünümü her alana taşıyın. Doğanın keyif veren enerjisi yaşam alanlarınızı sarsın.",
    "source": "duratiles"
  },
  {
    "id": "dura_209",
    "brand": "Duratiles",
    "title": "ESSENCE Tono 15x90",
    "seriesName": "ESSENCE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "209",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8330898291730983.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8330898291730983.jpg"
    ],
    "size": "15x90",
    "color": "Tono",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaşama ahşabın özel görünümünü katın. Essence serisi ile doğal görünümü her alana taşıyın. Doğanın keyif veren enerjisi yaşam alanlarınızı sarsın.</span>",
    "descriptionClean": "Yaşama ahşabın özel görünümünü katın. Essence serisi ile doğal görünümü her alana taşıyın. Doğanın keyif veren enerjisi yaşam alanlarınızı sarsın.",
    "source": "duratiles"
  },
  {
    "id": "dura_208",
    "brand": "Duratiles",
    "title": "ESSENCE Biondo 15x90",
    "seriesName": "ESSENCE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "208",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8620859100993312.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8620859100993312.jpg"
    ],
    "size": "15x90",
    "color": "Biondo",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaşama ahşabın özel görünümünü katın. Essence serisi ile doğal görünümü her alana taşıyın. Doğanın keyif veren enerjisi yaşam alanlarınızı sarsın.</span>",
    "descriptionClean": "Yaşama ahşabın özel görünümünü katın. Essence serisi ile doğal görünümü her alana taşıyın. Doğanın keyif veren enerjisi yaşam alanlarınızı sarsın.",
    "source": "duratiles"
  },
  {
    "id": "dura_207",
    "brand": "Duratiles",
    "title": "ESSENCE Aria 15x90",
    "seriesName": "ESSENCE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "207",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.033241076256482205.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.033241076256482205.jpg"
    ],
    "size": "15x90",
    "color": "Aria",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaşama ahşabın özel görünümünü katın. Essence serisi ile doğal görünümü her alana taşıyın. Doğanın keyif veren enerjisi yaşam alanlarınızı sarsın.</span>",
    "descriptionClean": "Yaşama ahşabın özel görünümünü katın. Essence serisi ile doğal görünümü her alana taşıyın. Doğanın keyif veren enerjisi yaşam alanlarınızı sarsın.",
    "source": "duratiles"
  },
  {
    "id": "dura_206",
    "brand": "Duratiles",
    "title": "ESSENCE Tono 20x120",
    "seriesName": "ESSENCE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "65757",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09057343745551283.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09057343745551283.jpg"
    ],
    "size": "20x120",
    "color": "Tono",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaşama ahşabın özel görünümünü katın. Essence serisi ile doğal görünümü her alana taşıyın. Doğanın keyif veren enerjisi yaşam alanlarınızı sarsın.</span>",
    "descriptionClean": "Yaşama ahşabın özel görünümünü katın. Essence serisi ile doğal görünümü her alana taşıyın. Doğanın keyif veren enerjisi yaşam alanlarınızı sarsın.",
    "source": "duratiles"
  },
  {
    "id": "dura_205",
    "brand": "Duratiles",
    "title": "ESSENCE Meşe 20x120",
    "seriesName": "ESSENCE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "205",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2660886070862094.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2660886070862094.jpg"
    ],
    "size": "20x120",
    "color": "Meşe",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaşama ahşabın özel görünümünü katın. Essence serisi ile doğal görünümü her alana taşıyın. Doğanın keyif veren enerjisi yaşam alanlarınızı sarsın.</span>",
    "descriptionClean": "Yaşama ahşabın özel görünümünü katın. Essence serisi ile doğal görünümü her alana taşıyın. Doğanın keyif veren enerjisi yaşam alanlarınızı sarsın.",
    "source": "duratiles"
  },
  {
    "id": "dura_204",
    "brand": "Duratiles",
    "title": "ESSENCE Biondo 20x120",
    "seriesName": "ESSENCE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "204",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36256797005472186.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36256797005472186.jpg"
    ],
    "size": "20x120",
    "color": "Biondo",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaşama ahşabın özel görünümünü katın. Essence serisi ile doğal görünümü her alana taşıyın. Doğanın keyif veren enerjisi yaşam alanlarınızı sarsın.</span>",
    "descriptionClean": "Yaşama ahşabın özel görünümünü katın. Essence serisi ile doğal görünümü her alana taşıyın. Doğanın keyif veren enerjisi yaşam alanlarınızı sarsın.",
    "source": "duratiles"
  },
  {
    "id": "dura_203",
    "brand": "Duratiles",
    "title": "ESSENCE Aria 20x120",
    "seriesName": "ESSENCE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "203",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11102317273022266.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11102317273022266.jpg"
    ],
    "size": "20x120",
    "color": "Aria",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaşama ahşabın özel görünümünü katın. Essence serisi ile doğal görünümü her alana taşıyın. Doğanın keyif veren enerjisi yaşam alanlarınızı sarsın.</span>",
    "descriptionClean": "Yaşama ahşabın özel görünümünü katın. Essence serisi ile doğal görünümü her alana taşıyın. Doğanın keyif veren enerjisi yaşam alanlarınızı sarsın.",
    "source": "duratiles"
  },
  {
    "id": "dura_213",
    "brand": "Duratiles",
    "title": "EVOLA Evola 15x90",
    "seriesName": "EVOLA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "213",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5631406788811738.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5631406788811738.jpg"
    ],
    "size": "15x90",
    "color": "Evola",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Evola Porselen Karoları zamanın ötesinde bir tarz yakalamak isteyenlere hitap ediyor.</span>",
    "descriptionClean": "Evola Porselen Karoları zamanın ötesinde bir tarz yakalamak isteyenlere hitap ediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_220",
    "brand": "Duratiles",
    "title": "EXPLORER Barcelona 15x90",
    "seriesName": "EXPLORER",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "220",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9310588406364761.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9310588406364761.jpg"
    ],
    "size": "15x90",
    "color": "Barcelona",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Banyo & Balkon/Teras & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V2",
      "Banyo",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşabın en yumuşak tonlarından esinlenerek oluşturulan ürün yelpazesine sahip Explorer Serisi ile sıradanlığa meydan okuyabilirsiniz</span>",
    "descriptionClean": "Ahşabın en yumuşak tonlarından esinlenerek oluşturulan ürün yelpazesine sahip Explorer Serisi ile sıradanlığa meydan okuyabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_219",
    "brand": "Duratiles",
    "title": "EXPLORER London 15x90",
    "seriesName": "EXPLORER",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "219",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14590477426713722.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14590477426713722.jpg"
    ],
    "size": "15x90",
    "color": "London",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Banyo & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V2",
      "Banyo",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşabın en yumuşak tonlarından esinlenerek oluşturulan ürün yelpazesine sahip Explorer Serisi ile sıradanlığa meydan okuyabilirsiniz</span>",
    "descriptionClean": "Ahşabın en yumuşak tonlarından esinlenerek oluşturulan ürün yelpazesine sahip Explorer Serisi ile sıradanlığa meydan okuyabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_218",
    "brand": "Duratiles",
    "title": "EXPLORER Milan 15x90",
    "seriesName": "EXPLORER",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "218",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40851229513447007.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40851229513447007.jpg"
    ],
    "size": "15x90",
    "color": "Milan",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Banyo & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V2",
      "Banyo",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşabın en yumuşak tonlarından esinlenerek oluşturulan ürün yelpazesine sahip Explorer Serisi ile sıradanlığa meydan okuyabilirsiniz</span>",
    "descriptionClean": "Ahşabın en yumuşak tonlarından esinlenerek oluşturulan ürün yelpazesine sahip Explorer Serisi ile sıradanlığa meydan okuyabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_217",
    "brand": "Duratiles",
    "title": "EXPLORER Paris 15x90",
    "seriesName": "EXPLORER",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "217",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7232890023455328.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7232890023455328.jpg"
    ],
    "size": "15x90",
    "color": "Paris",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Banyo & Balkon/Teras & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V2",
      "Banyo",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşabın en yumuşak tonlarından esinlenerek oluşturulan ürün yelpazesine sahip Explorer Serisi ile sıradanlığa meydan okuyabilirsiniz</span>",
    "descriptionClean": "Ahşabın en yumuşak tonlarından esinlenerek oluşturulan ürün yelpazesine sahip Explorer Serisi ile sıradanlığa meydan okuyabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_216",
    "brand": "Duratiles",
    "title": "EXPLORER Paris 30x60",
    "seriesName": "EXPLORER",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "216",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.31426475144791566.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.31426475144791566.jpg"
    ],
    "size": "30x60",
    "color": "Paris",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Banyo & Balkon/Teras & Ev içi Zemin & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V2",
      "Banyo",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşabın en yumuşak tonlarından esinlenerek oluşturulan ürün yelpazesine sahip Explorer Serisi ile sıradanlığa meydan okuyabilirsiniz</span>",
    "descriptionClean": "Ahşabın en yumuşak tonlarından esinlenerek oluşturulan ürün yelpazesine sahip Explorer Serisi ile sıradanlığa meydan okuyabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_215",
    "brand": "Duratiles",
    "title": "EXPLORER Milan 30x60",
    "seriesName": "EXPLORER",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "215",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.00015719831337390744.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.00015719831337390744.jpg"
    ],
    "size": "30x60",
    "color": "Milan",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Banyo & Balkon/Teras & Ev içi Zemin & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V2",
      "Banyo",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşabın en yumuşak tonlarından esinlenerek oluşturulan ürün yelpazesine sahip Explorer Serisi ile sıradanlığa meydan okuyabilirsiniz</span>",
    "descriptionClean": "Ahşabın en yumuşak tonlarından esinlenerek oluşturulan ürün yelpazesine sahip Explorer Serisi ile sıradanlığa meydan okuyabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_214",
    "brand": "Duratiles",
    "title": "EXPLORER London 30x60",
    "seriesName": "EXPLORER",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "214",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20269855894513678.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20269855894513678.jpg"
    ],
    "size": "30x60",
    "color": "London",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Banyo & Balkon/Teras & Ev içi Zemin & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V2",
      "Banyo",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşabın en yumuşak tonlarından esinlenerek oluşturulan ürün yelpazesine sahip Explorer Serisi ile sıradanlığa meydan okuyabilirsiniz</span>",
    "descriptionClean": "Ahşabın en yumuşak tonlarından esinlenerek oluşturulan ürün yelpazesine sahip Explorer Serisi ile sıradanlığa meydan okuyabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_221",
    "brand": "Duratiles",
    "title": "FERVOR Fervor 20x120",
    "seriesName": "FERVOR",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "221",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.996509245917055.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.996509245917055.jpg"
    ],
    "size": "20x120",
    "color": "Fervor",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Duvar & Yer",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğanın kusursuz uyumunu yansıtan Fervor Porselen Karosu dingin ve yalın iç mekan kurguları yaratır.</span>",
    "descriptionClean": "Doğanın kusursuz uyumunu yansıtan Fervor Porselen Karosu dingin ve yalın iç mekan kurguları yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_222",
    "brand": "Duratiles",
    "title": "FERVOR Fervor 15x90",
    "seriesName": "FERVOR",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "222",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.021630706906399788.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.021630706906399788.jpg"
    ],
    "size": "15x90",
    "color": "Fervor",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Duvar & Yer",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğanın kusursuz uyumunu yansıtan Fervor Porselen Karosu dingin ve yalın iç mekan kurguları yaratır.</span>",
    "descriptionClean": "Doğanın kusursuz uyumunu yansıtan Fervor Porselen Karosu dingin ve yalın iç mekan kurguları yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_223",
    "brand": "Duratiles",
    "title": "FONTANA Krem 20x120",
    "seriesName": "FONTANA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "223",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.33958848402396147.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.33958848402396147.jpg"
    ],
    "size": "20x120",
    "color": "Krem",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ahşap görünümlü seramik koleksiyonu Fontana Serisi kişilikli tasarımıyla fark yaratarak mekanlara doğanın cazibesini taşıyor. Hem duvarda hem de zeminde kullanabileceğiniz Fontana Serisi kolay temizlenme özelliği ile tekniği ve sanatı bir araya getiriyor</span>",
    "descriptionClean": "Ahşap görünümlü seramik koleksiyonu Fontana Serisi kişilikli tasarımıyla fark yaratarak mekanlara doğanın cazibesini taşıyor. Hem duvarda hem de zeminde kullanabileceğiniz Fontana Serisi kolay temizlenme özelliği ile tekniği ve sanatı bir araya getiriyor",
    "source": "duratiles"
  },
  {
    "id": "dura_224",
    "brand": "Duratiles",
    "title": "FONTANA Honey 20x120",
    "seriesName": "FONTANA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "224",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6467282815580709.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6467282815580709.jpg"
    ],
    "size": "20x120",
    "color": "Honey",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ahşap görünümlü seramik koleksiyonu Fontana Serisi kişilikli tasarımıyla fark yaratarak mekanlara doğanın cazibesini taşıyor. Hem duvarda hem de zeminde kullanabileceğiniz Fontana Serisi kolay temizlenme özelliği ile tekniği ve sanatı bir araya getiriyor</span>",
    "descriptionClean": "Ahşap görünümlü seramik koleksiyonu Fontana Serisi kişilikli tasarımıyla fark yaratarak mekanlara doğanın cazibesini taşıyor. Hem duvarda hem de zeminde kullanabileceğiniz Fontana Serisi kolay temizlenme özelliği ile tekniği ve sanatı bir araya getiriyor",
    "source": "duratiles"
  },
  {
    "id": "dura_225",
    "brand": "Duratiles",
    "title": "FONTANA Latte 20x120",
    "seriesName": "FONTANA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "225",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9129392756167921.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9129392756167921.jpg"
    ],
    "size": "20x120",
    "color": "Latte",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ahşap görünümlü seramik koleksiyonu Fontana Serisi kişilikli tasarımıyla fark yaratarak mekanlara doğanın cazibesini taşıyor. Hem duvarda hem de zeminde kullanabileceğiniz Fontana Serisi kolay temizlenme özelliği ile tekniği ve sanatı bir araya getiriyor</span>",
    "descriptionClean": "Ahşap görünümlü seramik koleksiyonu Fontana Serisi kişilikli tasarımıyla fark yaratarak mekanlara doğanın cazibesini taşıyor. Hem duvarda hem de zeminde kullanabileceğiniz Fontana Serisi kolay temizlenme özelliği ile tekniği ve sanatı bir araya getiriyor",
    "source": "duratiles"
  },
  {
    "id": "dura_226",
    "brand": "Duratiles",
    "title": "FONTANA Noce 20x120",
    "seriesName": "FONTANA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "226",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12187937788762315.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12187937788762315.jpg"
    ],
    "size": "20x120",
    "color": "Noce",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ahşap görün��mlü seramik koleksiyonu Fontana Serisi kişilikli tasarımıyla fark yaratarak mekanlara doğanın cazibesini taşıyor. Hem duvarda hem de zeminde kullanabileceğiniz Fontana Serisi kolay temizlenme özelliği ile tekniği ve sanatı bir araya getiriyor</span>",
    "descriptionClean": "Ahşap görün��mlü seramik koleksiyonu Fontana Serisi kişilikli tasarımıyla fark yaratarak mekanlara doğanın cazibesini taşıyor. Hem duvarda hem de zeminde kullanabileceğiniz Fontana Serisi kolay temizlenme özelliği ile tekniği ve sanatı bir araya getiriyor",
    "source": "duratiles"
  },
  {
    "id": "dura_230",
    "brand": "Duratiles",
    "title": "GLOVER Natural 22x90",
    "seriesName": "GLOVER",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "230",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7277638921022441.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7277638921022441.jpg"
    ],
    "size": "22x90",
    "color": "Natural",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Glover Serisi yalın güzelliği ile yaşam alanlarınıza kolayca uyum sağlarken şıklığı ve estetiği beraberinde getiriyor.</span>",
    "descriptionClean": "Glover Serisi yalın güzelliği ile yaşam alanlarınıza kolayca uyum sağlarken şıklığı ve estetiği beraberinde getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_229",
    "brand": "Duratiles",
    "title": "GLOVER Wenge 22x90",
    "seriesName": "GLOVER",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "229",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7445141514153301.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7445141514153301.jpg"
    ],
    "size": "22x90",
    "color": "Wenge",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V2",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Glover Serisi yalın güzelliği ile yaşam alanlarınıza kolayca uyum sağlarken şıklığı ve estetiği beraberinde getiriyor.</span>",
    "descriptionClean": "Glover Serisi yalın güzelliği ile yaşam alanlarınıza kolayca uyum sağlarken şıklığı ve estetiği beraberinde getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_227",
    "brand": "Duratiles",
    "title": "GLOVER Gri 22x90",
    "seriesName": "GLOVER",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "227",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5776482176931035.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5776482176931035.jpg"
    ],
    "size": "22x90",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V2",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Glover Serisi yalın güzelliği ile yaşam alanlarınıza kolayca uyum sağlarken şıklığı ve estetiği beraberinde getiriyor.</span>",
    "descriptionClean": "Glover Serisi yalın güzelliği ile yaşam alanlarınıza kolayca uyum sağlarken şıklığı ve estetiği beraberinde getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_228",
    "brand": "Duratiles",
    "title": "GLOVER Fildişi 22x90",
    "seriesName": "GLOVER",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "228",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03236861525879042.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03236861525879042.jpg"
    ],
    "size": "22x90",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V2",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Glover Serisi yalın güzelliği ile yaşam alanlarınıza kolayca uyum sağlarken şıklığı ve estetiği beraberinde getiriyor.</span>",
    "descriptionClean": "Glover Serisi yalın güzelliği ile yaşam alanlarınıza kolayca uyum sağlarken şıklığı ve estetiği beraberinde getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_231",
    "brand": "Duratiles",
    "title": "HABIT Gümüş 15x60",
    "seriesName": "HABIT",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "231",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6420165304670065.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6420165304670065.jpg"
    ],
    "size": "15x60",
    "color": "Gümüş",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Habit Serisiyle sıradanlığa meydan okuyun.</span>",
    "descriptionClean": "İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Habit Serisiyle sıradanlığa meydan okuyun.",
    "source": "duratiles"
  },
  {
    "id": "dura_235",
    "brand": "Duratiles",
    "title": "HERRINGBONE Meşe 60x120",
    "seriesName": "HERRINGBONE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "235",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7601515790576732.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7601515790576732.jpg"
    ],
    "size": "60x120",
    "color": "Meşe",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Habit Serisiyle sıradanlığa meydan okuyun.</span>",
    "descriptionClean": "İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Habit Serisiyle sıradanlığa meydan okuyun.",
    "source": "duratiles"
  },
  {
    "id": "dura_234",
    "brand": "Duratiles",
    "title": "HERRINGBONE Kahve 60x120",
    "seriesName": "HERRINGBONE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "234",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8076735107827591.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8076735107827591.jpg"
    ],
    "size": "60x120",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Habit Serisiyle sıradanlığa meydan okuyun.</span>",
    "descriptionClean": "İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Habit Serisiyle sıradanlığa meydan okuyun.",
    "source": "duratiles"
  },
  {
    "id": "dura_233",
    "brand": "Duratiles",
    "title": "HERRINGBONE Çam 60x120",
    "seriesName": "HERRINGBONE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "233",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5717437734098888.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5717437734098888.jpg"
    ],
    "size": "60x120",
    "color": "Çam",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Habit Serisiyle sıradanlığa meydan okuyun.</span>",
    "descriptionClean": "İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Habit Serisiyle sıradanlığa meydan okuyun.",
    "source": "duratiles"
  },
  {
    "id": "dura_232",
    "brand": "Duratiles",
    "title": "HERRINGBONE Bej 60x120",
    "seriesName": "HERRINGBONE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "232",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14761356367836043.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14761356367836043.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Habit Serisiyle sıradanlığa meydan okuyun.</span>",
    "descriptionClean": "İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Habit Serisiyle sıradanlığa meydan okuyun.",
    "source": "duratiles"
  },
  {
    "id": "dura_239",
    "brand": "Duratiles",
    "title": "HINOKI Koyu Kahve 15x60",
    "seriesName": "HINOKI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "239",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10942332524637033.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10942332524637033.jpg"
    ],
    "size": "15x60",
    "color": "Koyu Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İnceliğin yeni şekli Hinoki. Her zaman zarafetin temsilcisi olarak yaşam alanlarınızı süsleyecek. Şıklığınızın ömrünü uzatan tasarımlar bu seride...</span>",
    "descriptionClean": "İnceliğin yeni şekli Hinoki. Her zaman zarafetin temsilcisi olarak yaşam alanlarınızı süsleyecek. Şıklığınızın ömrünü uzatan tasarımlar bu seride...",
    "source": "duratiles"
  },
  {
    "id": "dura_237",
    "brand": "Duratiles",
    "title": "HINOKI Gri 15x60",
    "seriesName": "HINOKI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "237",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8164556480537708.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8164556480537708.jpg"
    ],
    "size": "15x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İnceliğin yeni şekli Hinoki. Her zaman zarafetin temsilcisi olarak yaşam alanlarınızı süsleyecek. Şıklığınızın ömrünü uzatan tasarımlar bu seride...</span>",
    "descriptionClean": "İnceliğin yeni şekli Hinoki. Her zaman zarafetin temsilcisi olarak yaşam alanlarınızı süsleyecek. Şıklığınızın ömrünü uzatan tasarımlar bu seride...",
    "source": "duratiles"
  },
  {
    "id": "dura_240",
    "brand": "Duratiles",
    "title": "HINOKI Rover 15x60",
    "seriesName": "HINOKI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "240",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.804036318082913.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.804036318082913.jpg"
    ],
    "size": "15x60",
    "color": "Rover",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İnceliğin yeni şekli Hinoki. Her zaman zarafetin temsilcisi olarak yaşam alanlarınızı süsleyecek. Şıklığınızın ömrünü uzatan tasarımlar bu seride...</span>",
    "descriptionClean": "İnceliğin yeni şekli Hinoki. Her zaman zarafetin temsilcisi olarak yaşam alanlarınızı süsleyecek. Şıklığınızın ömrünü uzatan tasarımlar bu seride...",
    "source": "duratiles"
  },
  {
    "id": "dura_238",
    "brand": "Duratiles",
    "title": "HINOKI Kahve 15x60",
    "seriesName": "HINOKI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "238",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6745156450617892.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6745156450617892.jpg"
    ],
    "size": "15x60",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İnceliğin yeni şekli Hinoki. Her zaman zarafetin temsilcisi olarak yaşam alanlarınızı süsleyecek. Şıklığınızın ömrünü uzatan tasarımlar bu seride...</span>",
    "descriptionClean": "İnceliğin yeni şekli Hinoki. Her zaman zarafetin temsilcisi olarak yaşam alanlarınızı süsleyecek. Şıklığınızın ömrünü uzatan tasarımlar bu seride...",
    "source": "duratiles"
  },
  {
    "id": "dura_236",
    "brand": "Duratiles",
    "title": "HINOKI Meşe 15x60",
    "seriesName": "HINOKI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "236",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6063428397767635.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6063428397767635.jpg"
    ],
    "size": "15x60",
    "color": "Meşe",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İnceliğin yeni şekli Hinoki. Her zaman zarafetin temsilcisi olarak yaşam alanlarınızı süsleyecek. Şıklığınızın ömrünü uzatan tasarımlar bu seride...</span>",
    "descriptionClean": "İnceliğin yeni şekli Hinoki. Her zaman zarafetin temsilcisi olarak yaşam alanlarınızı süsleyecek. Şıklığınızın ömrünü uzatan tasarımlar bu seride...",
    "source": "duratiles"
  },
  {
    "id": "dura_241",
    "brand": "Duratiles",
    "title": "IRATI Fildişi 22x90",
    "seriesName": "IRATI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "241",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9932676775221888.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9932676775221888.jpg"
    ],
    "size": "22x90",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Irati Serisi fonksiyonel ve üstün teknik performansı ile yaşam alanlarınızı hayallerinizde ki görünüme kavuşturuyor.</span>",
    "descriptionClean": "Irati Serisi fonksiyonel ve üstün teknik performansı ile yaşam alanlarınızı hayallerinizde ki görünüme kavuşturuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_242",
    "brand": "Duratiles",
    "title": "IRATI Kahve 22x90",
    "seriesName": "IRATI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "242",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44864991367144436.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44864991367144436.jpg"
    ],
    "size": "22x90",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Irati Serisi fonksiyonel ve üstün teknik performansı ile yaşam alanlarınızı hayallerinizde ki görünüme kavuşturuyor.</span>",
    "descriptionClean": "Irati Serisi fonksiyonel ve üstün teknik performansı ile yaşam alanlarınızı hayallerinizde ki görünüme kavuşturuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_245",
    "brand": "Duratiles",
    "title": "JAKARANDA Kahve 60x120",
    "seriesName": "JAKARANDA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "245",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9820817958285111.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9820817958285111.jpg"
    ],
    "size": "60x120",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Hayatın dinamik akışından ilham alan Jakaranda porselen karoları konfordan ödün vermeyen tasarımlarıyla evinizin enerjisini yükseltir.</span>",
    "descriptionClean": "Hayatın dinamik akışından ilham alan Jakaranda porselen karoları konfordan ödün vermeyen tasarımlarıyla evinizin enerjisini yükseltir.",
    "source": "duratiles"
  },
  {
    "id": "dura_244",
    "brand": "Duratiles",
    "title": "JAKARANDA Kahve 22x90",
    "seriesName": "JAKARANDA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "244",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7333135747918461.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7333135747918461.jpg"
    ],
    "size": "22x90",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Hayatın dinamik akışından ilham alan Jakaranda porselen karoları konfordan ödün vermeyen tasarımlarıyla evinizin enerjisini yükseltir.</span>",
    "descriptionClean": "Hayatın dinamik akışından ilham alan Jakaranda porselen karoları konfordan ödün vermeyen tasarımlarıyla evinizin enerjisini yükseltir.",
    "source": "duratiles"
  },
  {
    "id": "dura_243",
    "brand": "Duratiles",
    "title": "JAKARANDA Fildişi 22x90",
    "seriesName": "JAKARANDA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "243",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.32724325964975687.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.32724325964975687.jpg"
    ],
    "size": "22x90",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Hayatın dinamik akışından ilham alan Jakaranda porselen karoları konfordan ödün vermeyen tasarımlarıyla evinizin enerjisini yükseltir.</span>",
    "descriptionClean": "Hayatın dinamik akışından ilham alan Jakaranda porselen karoları konfordan ödün vermeyen tasarımlarıyla evinizin enerjisini yükseltir.",
    "source": "duratiles"
  },
  {
    "id": "dura_246",
    "brand": "Duratiles",
    "title": "KONGO Mavi 22x90",
    "seriesName": "KONGO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "246",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9614925280078741.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9614925280078741.jpg"
    ],
    "size": "22x90",
    "color": "Mavi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Eskitme ahşap görünümü ile yaşam alanlarına modern bir dokunuş katan Kongo Porselen Karoları çizilmeye ,suya ve güneşe olan dayanıklılığı ile hayatınızı kolaylaştırır.</span>",
    "descriptionClean": "Eskitme ahşap görünümü ile yaşam alanlarına modern bir dokunuş katan Kongo Porselen Karoları çizilmeye ,suya ve güneşe olan dayanıklılığı ile hayatınızı kolaylaştırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_247",
    "brand": "Duratiles",
    "title": "KONGO Siyah 22x90",
    "seriesName": "KONGO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "247",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.25516501984746387.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.25516501984746387.jpg"
    ],
    "size": "22x90",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Eskitme ahşap görünümü ile yaşam alanlarına modern bir dokunuş katan Kongo Porselen Karoları çizilmeye ,suya ve güneşe olan dayanıklılığı ile hayatınızı kolaylaştırır.</span>",
    "descriptionClean": "Eskitme ahşap görünümü ile yaşam alanlarına modern bir dokunuş katan Kongo Porselen Karoları çizilmeye ,suya ve güneşe olan dayanıklılığı ile hayatınızı kolaylaştırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_248",
    "brand": "Duratiles",
    "title": "LAKEWOOD Graphite 60x120",
    "seriesName": "LAKEWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "248",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7798929083311188.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7798929083311188.jpg"
    ],
    "size": "60x120",
    "color": "Graphite",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Eskitme ahşap görünümü ile yaşam alanlarına modern bir dokunuş katan Kongo Porselen Karoları çizilmeye ,suya ve güneşe olan dayanıklılığı ile hayatınızı kolaylaştırır.</span>",
    "descriptionClean": "Eskitme ahşap görünümü ile yaşam alanlarına modern bir dokunuş katan Kongo Porselen Karoları çizilmeye ,suya ve güneşe olan dayanıklılığı ile hayatınızı kolaylaştırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_249",
    "brand": "Duratiles",
    "title": "LAKEWOOD Kahve 60x120",
    "seriesName": "LAKEWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "249",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18371883706075787.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18371883706075787.jpg"
    ],
    "size": "60x120",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Eskitme ahşap görünümü ile yaşam alanlarına modern bir dokunuş katan Kongo Porselen Karoları çizilmeye ,suya ve güneşe olan dayanıklılığı ile hayatınızı kolaylaştırır.</span>",
    "descriptionClean": "Eskitme ahşap görünümü ile yaşam alanlarına modern bir dokunuş katan Kongo Porselen Karoları çizilmeye ,suya ve güneşe olan dayanıklılığı ile hayatınızı kolaylaştırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_250",
    "brand": "Duratiles",
    "title": "LAKEWOOD Meşe 60x120",
    "seriesName": "LAKEWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "250",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5338765389201212.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5338765389201212.jpg"
    ],
    "size": "60x120",
    "color": "Meşe",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Eskitme ahşap görünümü ile yaşam alanlarına modern bir dokunuş katan Kongo Porselen Karoları çizilmeye ,suya ve güneşe olan dayanıklılığı ile hayatınızı kolaylaştırır.</span>",
    "descriptionClean": "Eskitme ahşap görünümü ile yaşam alanlarına modern bir dokunuş katan Kongo Porselen Karoları çizilmeye ,suya ve güneşe olan dayanıklılığı ile hayatınızı kolaylaştırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_251",
    "brand": "Duratiles",
    "title": "LANDE Siyah 15x60",
    "seriesName": "LANDE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "251",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.169319456902986.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.169319456902986.jpg"
    ],
    "size": "15x60",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Lande Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.</span>",
    "descriptionClean": "Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Lande Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_252",
    "brand": "Duratiles",
    "title": "LINEWOOD Ultra Beyaz 60x120",
    "seriesName": "LINEWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "252",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4974808528460337.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4974808528460337.jpg"
    ],
    "size": "60x120",
    "color": "Ultra Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğadan ilham alan tasarımlarıyla Linewood Porselen Karoları ,rafine tasarım anlayışını yaşam alanlarına taşır.</span>",
    "descriptionClean": "Doğadan ilham alan tasarımlarıyla Linewood Porselen Karoları ,rafine tasarım anlayışını yaşam alanlarına taşır.",
    "source": "duratiles"
  },
  {
    "id": "dura_253",
    "brand": "Duratiles",
    "title": "LINEWOOD Sky 60x120",
    "seriesName": "LINEWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "253",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5088606876603391.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5088606876603391.jpg"
    ],
    "size": "60x120",
    "color": "Sky",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğadan ilham alan tasarımlarıyla Linewood Porselen Karoları ,rafine tasarım anlayışını yaşam alanlarına taşır.</span>",
    "descriptionClean": "Doğadan ilham alan tasarımlarıyla Linewood Porselen Karoları ,rafine tasarım anlayışını yaşam alanlarına taşır.",
    "source": "duratiles"
  },
  {
    "id": "dura_254",
    "brand": "Duratiles",
    "title": "LINEWOOD Beyaz 60x120",
    "seriesName": "LINEWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "254",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14077228985740342.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14077228985740342.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğadan ilham alan tasarımlarıyla Linewood Porselen Karoları ,rafine tasarım anlayışını yaşam alanlarına taşır.</span>",
    "descriptionClean": "Doğadan ilham alan tasarımlarıyla Linewood Porselen Karoları ,rafine tasarım anlayışını yaşam alanlarına taşır.",
    "source": "duratiles"
  },
  {
    "id": "dura_255",
    "brand": "Duratiles",
    "title": "LINEWOOD Fildişi 60x120",
    "seriesName": "LINEWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "255",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23143632591049812.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23143632591049812.jpg"
    ],
    "size": "60x120",
    "color": "Fildişi",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğadan ilham alan tasarımlarıyla Linewood Porselen Karoları ,rafine tasarım anlayışını yaşam alanlarına taşır.</span>",
    "descriptionClean": "Doğadan ilham alan tasarımlarıyla Linewood Porselen Karoları ,rafine tasarım anlayışını yaşam alanlarına taşır.",
    "source": "duratiles"
  },
  {
    "id": "dura_256",
    "brand": "Duratiles",
    "title": "LINEWOOD Krem 60x120",
    "seriesName": "LINEWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "77464",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8461038804025679.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8461038804025679.jpg"
    ],
    "size": "60x120",
    "color": "Krem",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğadan ilham alan tasarımlarıyla Linewood Porselen Karoları ,rafine tasarım anlayışını yaşam alanlarına taşır.</span>",
    "descriptionClean": "Doğadan ilham alan tasarımlarıyla Linewood Porselen Karoları ,rafine tasarım anlayışını yaşam alanlarına taşır.",
    "source": "duratiles"
  },
  {
    "id": "dura_257",
    "brand": "Duratiles",
    "title": "LINEWOOD Bej 60x120",
    "seriesName": "LINEWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "77458",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10327779959552164.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10327779959552164.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğadan ilham alan tasarımlarıyla Linewood Porselen Karoları ,rafine tasarım anlayışını yaşam alanlarına taşır.</span>",
    "descriptionClean": "Doğadan ilham alan tasarımlarıyla Linewood Porselen Karoları ,rafine tasarım anlayışını yaşam alanlarına taşır.",
    "source": "duratiles"
  },
  {
    "id": "dura_258",
    "brand": "Duratiles",
    "title": "LINEWOOD Gri 60x120",
    "seriesName": "LINEWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "77466",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4878304889575591.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4878304889575591.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğadan ilham alan tasarımlarıyla Linewood Porselen Karoları ,rafine tasarım anlayışını yaşam alanlarına taşır.</span>",
    "descriptionClean": "Doğadan ilham alan tasarımlarıyla Linewood Porselen Karoları ,rafine tasarım anlayışını yaşam alanlarına taşır.",
    "source": "duratiles"
  },
  {
    "id": "dura_259",
    "brand": "Duratiles",
    "title": "LINEWOOD Kahve 60x120",
    "seriesName": "LINEWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "259",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5306374883620328.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5306374883620328.jpg"
    ],
    "size": "60x120",
    "color": "Kahve",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğadan ilham alan tasarımlarıyla Linewood Porselen Karoları ,rafine tasarım anlayışını yaşam alanlarına taşır.</span>",
    "descriptionClean": "Doğadan ilham alan tasarımlarıyla Linewood Porselen Karoları ,rafine tasarım anlayışını yaşam alanlarına taşır.",
    "source": "duratiles"
  },
  {
    "id": "dura_260",
    "brand": "Duratiles",
    "title": "LINEWOOD Siyah 60x120",
    "seriesName": "LINEWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "77460",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2539159926626584.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2539159926626584.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğadan ilham alan tasarımlarıyla Linewood Porselen Karoları ,rafine tasarım anlayışını yaşam alanlarına taşır.</span>",
    "descriptionClean": "Doğadan ilham alan tasarımlarıyla Linewood Porselen Karoları ,rafine tasarım anlayışını yaşam alanlarına taşır.",
    "source": "duratiles"
  },
  {
    "id": "dura_263",
    "brand": "Duratiles",
    "title": "LUCCA Ebony 40x120",
    "seriesName": "LUCCA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "263",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43807029945131926.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43807029945131926.jpg"
    ],
    "size": "40x120",
    "color": "Ebony",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Yer & Duvar & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yüksek teknik performansa sahip olan Lucca Serisi , teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Yüksek teknik performansa sahip olan Lucca Serisi , teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_262",
    "brand": "Duratiles",
    "title": "LUCCA Grau 40x120",
    "seriesName": "LUCCA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "262",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7635888459759468.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7635888459759468.jpg"
    ],
    "size": "40x120",
    "color": "Grau",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Yer & Duvar & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yüksek teknik performansa sahip olan Lucca Serisi , teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Yüksek teknik performansa sahip olan Lucca Serisi , teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_261",
    "brand": "Duratiles",
    "title": "LUCCA Meşe 40x120",
    "seriesName": "LUCCA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "261",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11911187721151661.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11911187721151661.jpg"
    ],
    "size": "40x120",
    "color": "Meşe",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Yer & Duvar & Balkon/Teras & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yüksek teknik performansa sahip olan Lucca Serisi , teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Yüksek teknik performansa sahip olan Lucca Serisi , teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_265",
    "brand": "Duratiles",
    "title": "LYNBROOK Dover 22x90",
    "seriesName": "LYNBROOK",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "265",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8992931850490886.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8992931850490886.jpg"
    ],
    "size": "22x90",
    "color": "Dover",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Lynbrook Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Lynbrook Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_266",
    "brand": "Duratiles",
    "title": "LYNBROOK Hester 22x90",
    "seriesName": "LYNBROOK",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "266",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.04233559762160344.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.04233559762160344.jpg"
    ],
    "size": "22x90",
    "color": "Hester",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Lynbrook Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Lynbrook Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_264",
    "brand": "Duratiles",
    "title": "LYNBROOK Arden 22x90",
    "seriesName": "LYNBROOK",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "264",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3415553383374532.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3415553383374532.jpg"
    ],
    "size": "22x90",
    "color": "Arden",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Lynbrook Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Lynbrook Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_268",
    "brand": "Duratiles",
    "title": "MADERA Nut 33x33",
    "seriesName": "MADERA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "268",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6585013506297951.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6585013506297951.jpg"
    ],
    "size": "33x33",
    "color": "Nut",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Duvar Yer Karosu",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V4"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İddialı yaşam alanlarının yeni gözdesi Madera Porselen Karoları ahşap dokusuyla mekanlara rakipsiz bir davetkarlık getiriyor.</span>",
    "descriptionClean": "İddialı yaşam alanlarının yeni gözdesi Madera Porselen Karoları ahşap dokusuyla mekanlara rakipsiz bir davetkarlık getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_269",
    "brand": "Duratiles",
    "title": "MADERA Teak 33x33",
    "seriesName": "MADERA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "269",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4778489318946928.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4778489318946928.jpg"
    ],
    "size": "33x33",
    "color": "Teak",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Duvar Yer Karosu",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V4"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İddialı yaşam alanlarının yeni gözdesi Madera Porselen Karoları ahşap dokusuyla mekanlara rakipsiz bir davetkarlık getiriyor.</span>",
    "descriptionClean": "İddialı yaşam alanlarının yeni gözdesi Madera Porselen Karoları ahşap dokusuyla mekanlara rakipsiz bir davetkarlık getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_270",
    "brand": "Duratiles",
    "title": "MADERA Oak 33x33",
    "seriesName": "MADERA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "270",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.32608217082033975.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.32608217082033975.jpg"
    ],
    "size": "33x33",
    "color": "Oak",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Duvar Yer Karosu",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V4"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İddialı yaşam alanlarının yeni gözdesi Madera Porselen Karoları ahşap dokusuyla mekanlara rakipsiz bir davetkarlık getiriyor.</span>",
    "descriptionClean": "İddialı yaşam alanlarının yeni gözdesi Madera Porselen Karoları ahşap dokusuyla mekanlara rakipsiz bir davetkarlık getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_267",
    "brand": "Duratiles",
    "title": "MADERA Blanco 33x33",
    "seriesName": "MADERA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "267",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5535059054029514.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5535059054029514.jpg"
    ],
    "size": "33x33",
    "color": "Blanco",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Duvar Yer Karosu",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V4"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İddialı yaşam alanlarının yeni gözdesi Madera Porselen Karoları ahşap dokusuyla mekanlara rakipsiz bir davetkarlık getiriyor.</span>",
    "descriptionClean": "İddialı yaşam alanlarının yeni gözdesi Madera Porselen Karoları ahşap dokusuyla mekanlara rakipsiz bir davetkarlık getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_272",
    "brand": "Duratiles",
    "title": "MARINE Ceviz 60x60",
    "seriesName": "MARINE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "272",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1864722398883223.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1864722398883223.jpg"
    ],
    "size": "60x60",
    "color": "Ceviz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Dikey ahşabın karakteristik özelliği seramik ile buluştu ve ortaya Marine serisi çıktı. Ahşabın dokusunu, özgün renklerini Marine serisi ile sizlere sunuyoruz. Seramiği düşleyenlere ahşabın dokusundan vazgeçmeyenlere özel bir tasarım.</span>",
    "descriptionClean": "Dikey ahşabın karakteristik özelliği seramik ile buluştu ve ortaya Marine serisi çıktı. Ahşabın dokusunu, özgün renklerini Marine serisi ile sizlere sunuyoruz. Seramiği düşleyenlere ahşabın dokusundan vazgeçmeyenlere özel bir tasarım.",
    "source": "duratiles"
  },
  {
    "id": "dura_273",
    "brand": "Duratiles",
    "title": "MARINE Maun 60x60",
    "seriesName": "MARINE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "273",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6998055454660571.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6998055454660571.jpg"
    ],
    "size": "60x60",
    "color": "Maun",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Dikey ahşabın karakteristik özelliği seramik ile buluştu ve ortaya Marine serisi çıktı. Ahşabın dokusunu, özgün renklerini Marine serisi ile sizlere sunuyoruz. Seramiği düşleyenlere ahşabın dokusundan vazgeçmeyenlere özel bir tasarım.</span>",
    "descriptionClean": "Dikey ahşabın karakteristik özelliği seramik ile buluştu ve ortaya Marine serisi çıktı. Ahşabın dokusunu, özgün renklerini Marine serisi ile sizlere sunuyoruz. Seramiği düşleyenlere ahşabın dokusundan vazgeçmeyenlere özel bir tasarım.",
    "source": "duratiles"
  },
  {
    "id": "dura_271",
    "brand": "Duratiles",
    "title": "MARINE Bone 60x60",
    "seriesName": "MARINE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "271",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9734152332529832.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9734152332529832.jpg"
    ],
    "size": "60x60",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Dikey ahşabın karakteristik özelliği seramik ile buluştu ve ortaya Marine serisi çıktı. Ahşabın dokusunu, özgün renklerini Marine serisi ile sizlere sunuyoruz. Seramiği düşleyenlere ahşabın dokusundan vazgeçmeyenlere özel bir tasarım.</span>",
    "descriptionClean": "Dikey ahşabın karakteristik özelliği seramik ile buluştu ve ortaya Marine serisi çıktı. Ahşabın dokusunu, özgün renklerini Marine serisi ile sizlere sunuyoruz. Seramiği düşleyenlere ahşabın dokusundan vazgeçmeyenlere özel bir tasarım.",
    "source": "duratiles"
  },
  {
    "id": "dura_274",
    "brand": "Duratiles",
    "title": "MARINE Gri 60x60",
    "seriesName": "MARINE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "274",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9064090794726332.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9064090794726332.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Dikey ahşabın karakteristik özelliği seramik ile buluştu ve ortaya Marine serisi çıktı. Ahşabın dokusunu, özgün renklerini Marine serisi ile sizlere sunuyoruz. Seramiği düşleyenlere ahşabın dokusundan vazgeçmeyenlere özel bir tasarım.</span>",
    "descriptionClean": "Dikey ahşabın karakteristik özelliği seramik ile buluştu ve ortaya Marine serisi çıktı. Ahşabın dokusunu, özgün renklerini Marine serisi ile sizlere sunuyoruz. Seramiği düşleyenlere ahşabın dokusundan vazgeçmeyenlere özel bir tasarım.",
    "source": "duratiles"
  },
  {
    "id": "dura_275",
    "brand": "Duratiles",
    "title": "MASIF Masif 22x90",
    "seriesName": "MASIF",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "275",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6781034426314418.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6781034426314418.jpg"
    ],
    "size": "22x90",
    "color": "Masif",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Masif Porselen Karoları ...</span>",
    "descriptionClean": "Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Masif Porselen Karoları ...",
    "source": "duratiles"
  },
  {
    "id": "dura_277",
    "brand": "Duratiles",
    "title": "MINDO Ceviz 22x90",
    "seriesName": "MINDO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "277",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19349497659073844.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19349497659073844.jpg"
    ],
    "size": "22x90",
    "color": "Ceviz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Pozitif enerjinin ve mutluluğun hakim olduğu mekanlar yaratan Mindo Serisi özgün mekanlar yaratmanız için biçilmiş kaftan</span>",
    "descriptionClean": "Pozitif enerjinin ve mutluluğun hakim olduğu mekanlar yaratan Mindo Serisi özgün mekanlar yaratmanız için biçilmiş kaftan",
    "source": "duratiles"
  },
  {
    "id": "dura_278",
    "brand": "Duratiles",
    "title": "MINDO Meşe 22x90",
    "seriesName": "MINDO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "278",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16809286098380338.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16809286098380338.jpg"
    ],
    "size": "22x90",
    "color": "Meşe",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Pozitif enerjinin ve mutluluğun hakim olduğu mekanlar yaratan Mindo Serisi özgün mekanlar yaratmanız için biçilmiş kaftan</span>",
    "descriptionClean": "Pozitif enerjinin ve mutluluğun hakim olduğu mekanlar yaratan Mindo Serisi özgün mekanlar yaratmanız için biçilmiş kaftan",
    "source": "duratiles"
  },
  {
    "id": "dura_276",
    "brand": "Duratiles",
    "title": "MINDO Bone 22x90",
    "seriesName": "MINDO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "276",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11771325566238966.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11771325566238966.jpg"
    ],
    "size": "22x90",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Pozitif enerjinin ve mutluluğun hakim olduğu mekanlar yaratan Mindo Serisi özgün mekanlar yaratmanız için biçilmiş kaftan</span>",
    "descriptionClean": "Pozitif enerjinin ve mutluluğun hakim olduğu mekanlar yaratan Mindo Serisi özgün mekanlar yaratmanız için biçilmiş kaftan",
    "source": "duratiles"
  },
  {
    "id": "dura_279",
    "brand": "Duratiles",
    "title": "MINESOTA WOOD Beyaz 60x120",
    "seriesName": "MINESOTA WOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "279",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2780528557059321.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2780528557059321.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin & Dış Cephe & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3",
      "Endüstriyel Zemin",
      "Dış Cephe",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Lüks algısını yediden yorumlayan Minesota Wood Porselen Karoları renk alternatifi ile yaratıcılığınızı özgürleştiriyor</span>",
    "descriptionClean": "Lüks algısını yediden yorumlayan Minesota Wood Porselen Karoları renk alternatifi ile yaratıcılığınızı özgürleştiriyor",
    "source": "duratiles"
  },
  {
    "id": "dura_280",
    "brand": "Duratiles",
    "title": "MINESOTA WOOD Antrasit 60x120",
    "seriesName": "MINESOTA WOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "280",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18717661676898278.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18717661676898278.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ticari Alanlar & Dış Cephe & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Lüks algısını yediden yorumlayan Minesota Wood Porselen Karoları renk alternatifi ile yaratıcılığınızı özgürleştiriyor</span>",
    "descriptionClean": "Lüks algısını yediden yorumlayan Minesota Wood Porselen Karoları renk alternatifi ile yaratıcılığınızı özgürleştiriyor",
    "source": "duratiles"
  },
  {
    "id": "dura_282",
    "brand": "Duratiles",
    "title": "MIRA Kahve 22x90",
    "seriesName": "MIRA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "282",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2077588440097139.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2077588440097139.jpg"
    ],
    "size": "22x90",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3",
      "Ev İçi Zemin",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mira Porselen Karoları bulunduğu alanda stil sahibi bir tasarım anlayışının altını çiziyor</span>",
    "descriptionClean": "Mira Porselen Karoları bulunduğu alanda stil sahibi bir tasarım anlayışının altını çiziyor",
    "source": "duratiles"
  },
  {
    "id": "dura_283",
    "brand": "Duratiles",
    "title": "MIRA Miele 22x90",
    "seriesName": "MIRA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "283",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7478966280213998.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7478966280213998.jpg"
    ],
    "size": "22x90",
    "color": "Miele",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mira Porselen Karoları bulunduğu alanda stil sahibi bir tasarım anlayışının altını çiziyor</span>",
    "descriptionClean": "Mira Porselen Karoları bulunduğu alanda stil sahibi bir tasarım anlayışının altını çiziyor",
    "source": "duratiles"
  },
  {
    "id": "dura_281",
    "brand": "Duratiles",
    "title": "MIRA Beyaz 22x90",
    "seriesName": "MIRA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "281",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28570182387499643.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28570182387499643.jpg"
    ],
    "size": "22x90",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3",
      "Ev İçi Zemin",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mira Porselen Karoları bulunduğu alanda stil sahibi bir tasarım anlayışının altını çiziyor</span>",
    "descriptionClean": "Mira Porselen Karoları bulunduğu alanda stil sahibi bir tasarım anlayışının altını çiziyor",
    "source": "duratiles"
  },
  {
    "id": "dura_284",
    "brand": "Duratiles",
    "title": "MONTEVERDE Rigor 22x90",
    "seriesName": "MONTEVERDE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "284",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13839253286213948.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13839253286213948.jpg"
    ],
    "size": "22x90",
    "color": "Rigor",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ticari Alanlar & Ev içi Zemin & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3",
      "Ev İçi Zemin",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Monteverde, ahşap dokusunun tüm gerçekliğini modern tasarım diliyle porselen karoya aktarıyor.</span>",
    "descriptionClean": "Monteverde, ahşap dokusunun tüm gerçekliğini modern tasarım diliyle porselen karoya aktarıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_285",
    "brand": "Duratiles",
    "title": "NATURAL OAK Kahve 15x90",
    "seriesName": "NATURAL OAK",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "285",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5384456754841289.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5384456754841289.jpg"
    ],
    "size": "15x90",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal ahşabın sıcak ve zarif dokusunu modern tasarımla buluşturan Natural Oak, mekânlara samimi ve huzurlu bir atmosfer katar.</span>",
    "descriptionClean": "Doğal ahşabın sıcak ve zarif dokusunu modern tasarımla buluşturan Natural Oak, mekânlara samimi ve huzurlu bir atmosfer katar.",
    "source": "duratiles"
  },
  {
    "id": "dura_286",
    "brand": "Duratiles",
    "title": "NATURAL OAK Kahve 15x60",
    "seriesName": "NATURAL OAK",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "286",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.008657523508683984.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.008657523508683984.jpg"
    ],
    "size": "15x60",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal ahşabın sıcak ve zarif dokusunu modern tasarımla buluşturan Natural Oak, mekânlara samimi ve huzurlu bir atmosfer katar.</span>",
    "descriptionClean": "Doğal ahşabın sıcak ve zarif dokusunu modern tasarımla buluşturan Natural Oak, mekânlara samimi ve huzurlu bir atmosfer katar.",
    "source": "duratiles"
  },
  {
    "id": "dura_287",
    "brand": "Duratiles",
    "title": "NATURALIA Avario 20x120",
    "seriesName": "NATURALIA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "287",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16059944319466657.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16059944319466657.jpg"
    ],
    "size": "20x120",
    "color": "Avario",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Dış Cephe & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Banyo",
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.</span>",
    "descriptionClean": "Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.",
    "source": "duratiles"
  },
  {
    "id": "dura_288",
    "brand": "Duratiles",
    "title": "NATURALIA Bruno 20x120",
    "seriesName": "NATURALIA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "57588",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7126421894647728.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7126421894647728.jpg"
    ],
    "size": "20x120",
    "color": "Bruno",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Banyo",
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.</span>",
    "descriptionClean": "Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.",
    "source": "duratiles"
  },
  {
    "id": "dura_289",
    "brand": "Duratiles",
    "title": "NATURALIA Grigio 20x120",
    "seriesName": "NATURALIA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "289",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.31308429125422366.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.31308429125422366.jpg"
    ],
    "size": "20x120",
    "color": "Grigio",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Banyo",
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.</span>",
    "descriptionClean": "Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.",
    "source": "duratiles"
  },
  {
    "id": "dura_2320",
    "brand": "Duratiles",
    "title": "NATURALIA Miele 20x120",
    "seriesName": "NATURALIA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "2320",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9697736589316821.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9697736589316821.jpg"
    ],
    "size": "20x120",
    "color": "Miele",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Banyo",
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.</span>",
    "descriptionClean": "Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.",
    "source": "duratiles"
  },
  {
    "id": "dura_2321",
    "brand": "Duratiles",
    "title": "NATURALIA Koyu Gri 20x120",
    "seriesName": "NATURALIA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "2321",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7805399430289115.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7805399430289115.jpg"
    ],
    "size": "20x120",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.</span>",
    "descriptionClean": "Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.",
    "source": "duratiles"
  },
  {
    "id": "dura_2325",
    "brand": "Duratiles",
    "title": "NATURALIA Avario 15x90",
    "seriesName": "NATURALIA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "2325",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9547843958416502.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9547843958416502.jpg"
    ],
    "size": "15x90",
    "color": "Avario",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.</span>",
    "descriptionClean": "Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.",
    "source": "duratiles"
  },
  {
    "id": "dura_2323",
    "brand": "Duratiles",
    "title": "NATURALIA Miele 15x90",
    "seriesName": "NATURALIA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "2323",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8759486428742647.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8759486428742647.jpg"
    ],
    "size": "15x90",
    "color": "Miele",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.</span>",
    "descriptionClean": "Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.",
    "source": "duratiles"
  },
  {
    "id": "dura_2322",
    "brand": "Duratiles",
    "title": "NATURALIA Gri 15x90",
    "seriesName": "NATURALIA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "2322",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9252953081207815.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9252953081207815.jpg"
    ],
    "size": "15x90",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.</span>",
    "descriptionClean": "Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.",
    "source": "duratiles"
  },
  {
    "id": "dura_2324",
    "brand": "Duratiles",
    "title": "NATURALIA Bruno 15x90",
    "seriesName": "NATURALIA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "2324",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.06735123595698245.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.06735123595698245.jpg"
    ],
    "size": "15x90",
    "color": "Bruno",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.</span>",
    "descriptionClean": "Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.",
    "source": "duratiles"
  },
  {
    "id": "dura_2329",
    "brand": "Duratiles",
    "title": "NATURALIA Bruno 15x60",
    "seriesName": "NATURALIA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "57588",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9704722779908233.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9704722779908233.jpg"
    ],
    "size": "15x60",
    "color": "Bruno",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.</span>",
    "descriptionClean": "Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.",
    "source": "duratiles"
  },
  {
    "id": "dura_2328",
    "brand": "Duratiles",
    "title": "NATURALIA Miele 15x60",
    "seriesName": "NATURALIA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "2328",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6094585258444716.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6094585258444716.jpg"
    ],
    "size": "15x60",
    "color": "Miele",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.</span>",
    "descriptionClean": "Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.",
    "source": "duratiles"
  },
  {
    "id": "dura_2327",
    "brand": "Duratiles",
    "title": "NATURALIA Avario 15x60",
    "seriesName": "NATURALIA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "2327",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9048927733877791.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9048927733877791.jpg"
    ],
    "size": "15x60",
    "color": "Avario",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.</span>",
    "descriptionClean": "Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.",
    "source": "duratiles"
  },
  {
    "id": "dura_2326",
    "brand": "Duratiles",
    "title": "NATURALIA Gri 15x60",
    "seriesName": "NATURALIA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "2326",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.819350505512665.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.819350505512665.jpg"
    ],
    "size": "15x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.</span>",
    "descriptionClean": "Naturalia serisi ahşabın sıcaklığını, seramiğin konforuyla bezeyerek evlerinize getiriyor. Çizilmeyen ,rengi solmayan ama ahşap gibi görünen Naturalia serisi hijyenik yapısı ile her evin vazgeçilmezi olmaya aday.",
    "source": "duratiles"
  },
  {
    "id": "dura_291",
    "brand": "Duratiles",
    "title": "NATURAWOOD Açık 20x120",
    "seriesName": "NATURAWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "64677",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.551624577936699.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.551624577936699.jpg"
    ],
    "size": "20x120",
    "color": "Açık",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Banyo",
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşabın doğal görünümünü isteyenlere, seramikten vazgeçmeyenlere özel... Naturawood serisi ile düşleriniz gerçek oluyor. Ahşap görünümlü seramik bu özel seride sizlerle.</span>",
    "descriptionClean": "Ahşabın doğal görünümünü isteyenlere, seramikten vazgeçmeyenlere özel... Naturawood serisi ile düşleriniz gerçek oluyor. Ahşap görünümlü seramik bu özel seride sizlerle.",
    "source": "duratiles"
  },
  {
    "id": "dura_290",
    "brand": "Duratiles",
    "title": "NATURAWOOD Koyu 20x120",
    "seriesName": "NATURAWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "290",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8429649057453006.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8429649057453006.jpg"
    ],
    "size": "20x120",
    "color": "Koyu",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Banyo",
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşabın doğal görünümünü isteyenlere, seramikten vazgeçmeyenlere özel... Naturawood serisi ile düşleriniz gerçek oluyor. Ahşap görünümlü seramik bu özel seride sizlerle.</span>",
    "descriptionClean": "Ahşabın doğal görünümünü isteyenlere, seramikten vazgeçmeyenlere özel... Naturawood serisi ile düşleriniz gerçek oluyor. Ahşap görünümlü seramik bu özel seride sizlerle.",
    "source": "duratiles"
  },
  {
    "id": "dura_292",
    "brand": "Duratiles",
    "title": "NUEVO Kahve 22x90",
    "seriesName": "NUEVO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "292",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.083236827891639.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.083236827891639.jpg"
    ],
    "size": "22x90",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Nuevo Porselen Karoları güçlü ve doğal tonlarıyla mekanlarınıza karakteristik bir görünüm kazandıracak!</span>",
    "descriptionClean": "Nuevo Porselen Karoları güçlü ve doğal tonlarıyla mekanlarınıza karakteristik bir görünüm kazandıracak!",
    "source": "duratiles"
  },
  {
    "id": "dura_293",
    "brand": "Duratiles",
    "title": "OAKWOOD Kahve 60x120",
    "seriesName": "OAKWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "293",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8099703678344045.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8099703678344045.jpg"
    ],
    "size": "60x120",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Rafine bir dekorasyon tarzına hayat vermek için en büyük yardımcınız ahşap dokusu ile Oakwood Serisi olacaktır. Darbeye ,çizilmeye karşı dirençli olduğu kadar ısı ve ışıktan etkilenmeyen yapısıyla Oakwood yeni nesil evlerin ilk tercihi.</span>",
    "descriptionClean": "Rafine bir dekorasyon tarzına hayat vermek için en büyük yardımcınız ahşap dokusu ile Oakwood Serisi olacaktır. Darbeye ,çizilmeye karşı dirençli olduğu kadar ısı ve ışıktan etkilenmeyen yapısıyla Oakwood yeni nesil evlerin ilk tercihi.",
    "source": "duratiles"
  },
  {
    "id": "dura_294",
    "brand": "Duratiles",
    "title": "OAKWOOD Kırmızı 60x120",
    "seriesName": "OAKWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "294",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.42314476581975013.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.42314476581975013.jpg"
    ],
    "size": "60x120",
    "color": "Kırmızı",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Rafine bir dekorasyon tarzına hayat vermek için en büyük yardımcınız ahşap dokusu ile Oakwood Serisi olacaktır. Darbeye ,çizilmeye karşı dirençli olduğu kadar ısı ve ışıktan etkilenmeyen yapısıyla Oakwood yeni nesil evlerin ilk tercihi.</span>",
    "descriptionClean": "Rafine bir dekorasyon tarzına hayat vermek için en büyük yardımcınız ahşap dokusu ile Oakwood Serisi olacaktır. Darbeye ,çizilmeye karşı dirençli olduğu kadar ısı ve ışıktan etkilenmeyen yapısıyla Oakwood yeni nesil evlerin ilk tercihi.",
    "source": "duratiles"
  },
  {
    "id": "dura_295",
    "brand": "Duratiles",
    "title": "OHIO Fildişi 22x90",
    "seriesName": "OHIO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "295",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.758128449840837.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.758128449840837.jpg"
    ],
    "size": "22x90",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Rafine bir dekorasyon tarzına hayat vermek için en büyük yardımcınız ahşap dokusu ile Oakwood Serisi olacaktır. Darbeye ,çizilmeye karşı dirençli olduğu kadar ısı ve ışıktan etkilenmeyen yapısıyla Oakwood yeni nesil evlerin ilk tercihi.</span>",
    "descriptionClean": "Rafine bir dekorasyon tarzına hayat vermek için en büyük yardımcınız ahşap dokusu ile Oakwood Serisi olacaktır. Darbeye ,çizilmeye karşı dirençli olduğu kadar ısı ve ışıktan etkilenmeyen yapısıyla Oakwood yeni nesil evlerin ilk tercihi.",
    "source": "duratiles"
  },
  {
    "id": "dura_296",
    "brand": "Duratiles",
    "title": "OHIO Wenge 22x90",
    "seriesName": "OHIO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "296",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7257416358004382.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7257416358004382.jpg"
    ],
    "size": "22x90",
    "color": "Wenge",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ohio Porselen Karoları , yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin aydınlık tercihi .</span>",
    "descriptionClean": "Ohio Porselen Karoları , yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin aydınlık tercihi .",
    "source": "duratiles"
  },
  {
    "id": "dura_297",
    "brand": "Duratiles",
    "title": "OLTRE Oltre 60x120",
    "seriesName": "OLTRE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "297",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8482092930360706.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8482092930360706.jpg"
    ],
    "size": "60x120",
    "color": "Oltre",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Leke,çizilme ve darbe dayanımı ile öne çıkan Oltre Porselen Karo estetikten ödün vermeden fonksiyonel yüzeyleri yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Leke,çizilme ve darbe dayanımı ile öne çıkan Oltre Porselen Karo estetikten ödün vermeden fonksiyonel yüzeyleri yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_301",
    "brand": "Duratiles",
    "title": "OTTOWA Noce 20x120",
    "seriesName": "OTTOWA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "301",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7058626805232706.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7058626805232706.jpg"
    ],
    "size": "20x120",
    "color": "Noce",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaşam alanlarınıza Ottowa Serisi ile yeni bir soluk, yeni bir tarz katın. Doğal ahşap görünümüyle Ottova seri farklı renk seçenekleri ile her zevke uygun</span>",
    "descriptionClean": "Yaşam alanlarınıza Ottowa Serisi ile yeni bir soluk, yeni bir tarz katın. Doğal ahşap görünümüyle Ottova seri farklı renk seçenekleri ile her zevke uygun",
    "source": "duratiles"
  },
  {
    "id": "dura_298",
    "brand": "Duratiles",
    "title": "OTTOWA Krema 20x120",
    "seriesName": "OTTOWA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "298",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.33684171274029495.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.33684171274029495.jpg"
    ],
    "size": "20x120",
    "color": "Krema",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaşam alanlarınıza Ottowa Serisi ile yeni bir soluk, yeni bir tarz katın. Doğal ahşap görünümüyle Ottova seri farklı renk seçenekleri ile her zevke uygun</span>",
    "descriptionClean": "Yaşam alanlarınıza Ottowa Serisi ile yeni bir soluk, yeni bir tarz katın. Doğal ahşap görünümüyle Ottova seri farklı renk seçenekleri ile her zevke uygun",
    "source": "duratiles"
  },
  {
    "id": "dura_300",
    "brand": "Duratiles",
    "title": "OTTOWA Latte 20x120",
    "seriesName": "OTTOWA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "300",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2882709161496789.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2882709161496789.jpg"
    ],
    "size": "20x120",
    "color": "Latte",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaşam alanlarınıza Ottowa Serisi ile yeni bir soluk, yeni bir tarz katın. Doğal ahşap görünümüyle Ottova seri farklı renk seçenekleri ile her zevke uygun</span>",
    "descriptionClean": "Yaşam alanlarınıza Ottowa Serisi ile yeni bir soluk, yeni bir tarz katın. Doğal ahşap görünümüyle Ottova seri farklı renk seçenekleri ile her zevke uygun",
    "source": "duratiles"
  },
  {
    "id": "dura_299",
    "brand": "Duratiles",
    "title": "OTTOWA Honey 20x120",
    "seriesName": "OTTOWA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "299",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6614872187712197.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6614872187712197.jpg"
    ],
    "size": "20x120",
    "color": "Honey",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaşam alanlarınıza Ottowa Serisi ile yeni bir soluk, yeni bir tarz katın. Doğal ahşap görünümüyle Ottova seri farklı renk seçenekleri ile her zevke uygun</span>",
    "descriptionClean": "Yaşam alanlarınıza Ottowa Serisi ile yeni bir soluk, yeni bir tarz katın. Doğal ahşap görünümüyle Ottova seri farklı renk seçenekleri ile her zevke uygun",
    "source": "duratiles"
  },
  {
    "id": "dura_305",
    "brand": "Duratiles",
    "title": "OZARK Noce 15x90",
    "seriesName": "OZARK",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "305",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5530256702067486.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5530256702067486.jpg"
    ],
    "size": "15x90",
    "color": "Noce",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamanın ruhunu, naturel dokunuşlarla resmeden Ozark Porselen Karoları üst düzey lüks tanımını değiştirmeye hazırlanıyor.</span>",
    "descriptionClean": "Zamanın ruhunu, naturel dokunuşlarla resmeden Ozark Porselen Karoları üst düzey lüks tanımını değiştirmeye hazırlanıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_304",
    "brand": "Duratiles",
    "title": "OZARK Fildişi 15x90",
    "seriesName": "OZARK",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "304",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4227422924805526.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4227422924805526.jpg"
    ],
    "size": "15x90",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamanın ruhunu, naturel dokunuşlarla resmeden Ozark Porselen Karoları üst düzey lüks tanımını değiştirmeye hazırlanıyor.</span>",
    "descriptionClean": "Zamanın ruhunu, naturel dokunuşlarla resmeden Ozark Porselen Karoları üst düzey lüks tanımını değiştirmeye hazırlanıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_302",
    "brand": "Duratiles",
    "title": "OZARK Gri 15x90",
    "seriesName": "OZARK",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "65192",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2701851545824264.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2701851545824264.jpg"
    ],
    "size": "15x90",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamanın ruhunu, naturel dokunuşlarla resmeden Ozark Porselen Karoları üst düzey lüks tanımını değiştirmeye hazırlanıyor.</span>",
    "descriptionClean": "Zamanın ruhunu, naturel dokunuşlarla resmeden Ozark Porselen Karoları üst düzey lüks tanımını değiştirmeye hazırlanıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_303",
    "brand": "Duratiles",
    "title": "OZARK Bej 15x90",
    "seriesName": "OZARK",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "303",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9069966105272933.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9069966105272933.jpg"
    ],
    "size": "15x90",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamanın ruhunu, naturel dokunuşlarla resmeden Ozark Porselen Karoları üst düzey lüks tanımını değiştirmeye hazırlanıyor.</span>",
    "descriptionClean": "Zamanın ruhunu, naturel dokunuşlarla resmeden Ozark Porselen Karoları üst düzey lüks tanımını değiştirmeye hazırlanıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_306",
    "brand": "Duratiles",
    "title": "PALMWOOD Ceviz 60x120",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "306",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28768339403923426.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28768339403923426.jpg"
    ],
    "size": "60x120",
    "color": "Ceviz",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_307",
    "brand": "Duratiles",
    "title": "PALMWOOD Beyaz 60x120",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "307",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3264567733308973.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3264567733308973.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_308",
    "brand": "Duratiles",
    "title": "PALMWOOD Antrasit 60x120",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "308",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8832302057060648.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8832302057060648.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_309",
    "brand": "Duratiles",
    "title": "PALMWOOD Oak 60x120",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "309",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12532944307210325.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12532944307210325.jpg"
    ],
    "size": "60x120",
    "color": "Oak",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_318",
    "brand": "Duratiles",
    "title": "PALMWOOD Ceviz 60x60",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "318",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5729335658201812.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5729335658201812.jpg"
    ],
    "size": "60x60",
    "color": "Ceviz",
    "surface": "Mat",
    "thickness": "30mm & 20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_319",
    "brand": "Duratiles",
    "title": "PALMWOOD Beyaz 60x60",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "319",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13955060954648613.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13955060954648613.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_320",
    "brand": "Duratiles",
    "title": "PALMWOOD Antrasit 60x60",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "320",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.946175487323718.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.946175487323718.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_321",
    "brand": "Duratiles",
    "title": "PALMWOOD Oak 60x60",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "321",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6036203256947795.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6036203256947795.jpg"
    ],
    "size": "60x60",
    "color": "Oak",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_314",
    "brand": "Duratiles",
    "title": "PALMWOOD Ceviz 40x80",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "314",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5831840456139167.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5831840456139167.jpg"
    ],
    "size": "40x80",
    "color": "Ceviz",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_315",
    "brand": "Duratiles",
    "title": "PALMWOOD Beyaz 40x80",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "315",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9553674894118674.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9553674894118674.jpg"
    ],
    "size": "40x80",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_316",
    "brand": "Duratiles",
    "title": "PALMWOOD Antrasit 40x80",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "316",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40754855123726075.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40754855123726075.jpg"
    ],
    "size": "40x80",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_317",
    "brand": "Duratiles",
    "title": "PALMWOOD Oak 40x80",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "317",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.925836854505222.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.925836854505222.jpg"
    ],
    "size": "40x80",
    "color": "Oak",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_322",
    "brand": "Duratiles",
    "title": "PALMWOOD Ceviz 40x40",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "322",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8054893792339836.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8054893792339836.jpg"
    ],
    "size": "40x40",
    "color": "Ceviz",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_323",
    "brand": "Duratiles",
    "title": "PALMWOOD Beyaz 40x40",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "323",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8347435598329489.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8347435598329489.jpg"
    ],
    "size": "40x40",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_324",
    "brand": "Duratiles",
    "title": "PALMWOOD Antrasit 40x40",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "324",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.030086888099557285.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.030086888099557285.jpg"
    ],
    "size": "40x40",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_325",
    "brand": "Duratiles",
    "title": "PALMWOOD Oak 40x40",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "325",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3882087103043783.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3882087103043783.jpg"
    ],
    "size": "40x40",
    "color": "Oak",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_310",
    "brand": "Duratiles",
    "title": "PALMWOOD Ceviz 30x120",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "310",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5333853114959288.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5333853114959288.jpg"
    ],
    "size": "30x120",
    "color": "Ceviz",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_311",
    "brand": "Duratiles",
    "title": "PALMWOOD Beyaz 30x120",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "311",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4724861161865481.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4724861161865481.jpg"
    ],
    "size": "30x120",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_312",
    "brand": "Duratiles",
    "title": "PALMWOOD Antrasit 30x120",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "312",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9394528865826507.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9394528865826507.jpg"
    ],
    "size": "30x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_313",
    "brand": "Duratiles",
    "title": "PALMWOOD Oak 30x120",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "313",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23655601778147206.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23655601778147206.jpg"
    ],
    "size": "30x120",
    "color": "Oak",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_326",
    "brand": "Duratiles",
    "title": "PALMWOOD Biondo 15x90",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "326",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6269094667794848.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6269094667794848.jpg"
    ],
    "size": "15x90",
    "color": "Biondo",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_327",
    "brand": "Duratiles",
    "title": "PALMWOOD Mocha 15x90",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "327",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12098942599151707.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12098942599151707.jpg"
    ],
    "size": "15x90",
    "color": "Mocha",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Banyo & Dış Cephe & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "V2",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_328",
    "brand": "Duratiles",
    "title": "PALMWOOD Kırmızı 15x90",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "328",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.33038817814670995.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.33038817814670995.jpg"
    ],
    "size": "15x90",
    "color": "Kırmızı",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Banyo & Dış Cephe & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "V2",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_329",
    "brand": "Duratiles",
    "title": "PALMWOOD Teak 15x90",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "329",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4413279835039291.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4413279835039291.jpg"
    ],
    "size": "15x90",
    "color": "Teak",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Banyo & Dış Cephe & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "V2",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_330",
    "brand": "Duratiles",
    "title": "PALMWOOD Biondo 15x60",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "330",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40855542569185777.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40855542569185777.jpg"
    ],
    "size": "15x60",
    "color": "Biondo",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_331",
    "brand": "Duratiles",
    "title": "PALMWOOD Teak 15x60",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "331",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4745163177506312.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4745163177506312.jpg"
    ],
    "size": "15x60",
    "color": "Teak",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_332",
    "brand": "Duratiles",
    "title": "PALMWOOD Kırmızı 15x60",
    "seriesName": "PALMWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "332",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.029909025075359308.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.029909025075359308.jpg"
    ],
    "size": "15x60",
    "color": "Kırmızı",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.</span>",
    "descriptionClean": "Ahşap dokusu ile mekanlara doğallık getiren Palmwood serisi su geçirmez , ısı ve ışıktan etkilenmez yapısı ile konforlu bir yaşam vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_333",
    "brand": "Duratiles",
    "title": "PARKE Stone 45x45",
    "seriesName": "PARKE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "333",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.255782655488919.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.255782655488919.jpg"
    ],
    "size": "45x45",
    "color": "Stone",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V2",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ahşap dokusu ve klasik çizgileriyle Parke serisi mekanlara doğallığı getirirken, solmadan ,aşınmadan , ilk günkü gibi kalarak ömürlük kullanım sağlıyor</span>",
    "descriptionClean": "Ahşap dokusu ve klasik çizgileriyle Parke serisi mekanlara doğallığı getirirken, solmadan ,aşınmadan , ilk günkü gibi kalarak ömürlük kullanım sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_334",
    "brand": "Duratiles",
    "title": "PARKE Real 45x45",
    "seriesName": "PARKE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "334",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13839317721447553.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13839317721447553.jpg"
    ],
    "size": "45x45",
    "color": "Real",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V2",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ahşap dokusu ve klasik çizgileriyle Parke serisi mekanlara doğallığı getirirken, solmadan ,aşınmadan , ilk günkü gibi kalarak ömürlük kullanım sağlıyor</span>",
    "descriptionClean": "Ahşap dokusu ve klasik çizgileriyle Parke serisi mekanlara doğallığı getirirken, solmadan ,aşınmadan , ilk günkü gibi kalarak ömürlük kullanım sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_335",
    "brand": "Duratiles",
    "title": "PARKE SOLID WOOD Açık 45x45",
    "seriesName": "PARKE SOLID WOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "335",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1808421726128835.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1808421726128835.jpg"
    ],
    "size": "45x45",
    "color": "Açık",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V2",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">İç içe geçen parke görünümlü Parke Solid Wood ahşabın uyumunu mekanlarınıza taşıyarak natürel kurgular yaratmanızı sağlıyor.</span>",
    "descriptionClean": "İç içe geçen parke görünümlü Parke Solid Wood ahşabın uyumunu mekanlarınıza taşıyarak natürel kurgular yaratmanızı sağlıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_336",
    "brand": "Duratiles",
    "title": "PARKE SOLID WOOD Koyu 45x45",
    "seriesName": "PARKE SOLID WOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "336",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09012687267713004.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09012687267713004.jpg"
    ],
    "size": "45x45",
    "color": "Koyu",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V2",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">İç içe geçen parke görünümlü Parke Solid Wood ahşabın uyumunu mekanlarınıza taşıyarak natürel kurgular yaratmanızı sağlıyor.</span>",
    "descriptionClean": "İç içe geçen parke görünümlü Parke Solid Wood ahşabın uyumunu mekanlarınıza taşıyarak natürel kurgular yaratmanızı sağlıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_342",
    "brand": "Duratiles",
    "title": "PASIFICO Natural 60x120",
    "seriesName": "PASIFICO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "342",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48078026811770735.webp",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48078026811770735.webp"
    ],
    "size": "60x120",
    "color": "Natural",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_341",
    "brand": "Duratiles",
    "title": "PASIFICO Avana 60x120",
    "seriesName": "PASIFICO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "341",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1023192484242803.webp",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1023192484242803.webp"
    ],
    "size": "60x120",
    "color": "Avana",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_340",
    "brand": "Duratiles",
    "title": "PASIFICO Grigio 60x120",
    "seriesName": "PASIFICO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "340",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.332847751128699.webp",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.332847751128699.webp"
    ],
    "size": "60x120",
    "color": "Grigio",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_337",
    "brand": "Duratiles",
    "title": "PASIFICO Avana 45x90",
    "seriesName": "PASIFICO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "337",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18549417256489886.webp",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18549417256489886.webp"
    ],
    "size": "45x90",
    "color": "Avana",
    "surface": "Mat , Sırlı Body",
    "thickness": "30mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_338",
    "brand": "Duratiles",
    "title": "PASIFICO Natural 45x90",
    "seriesName": "PASIFICO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "338",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9048821359532974.webp",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9048821359532974.webp"
    ],
    "size": "45x90",
    "color": "Natural",
    "surface": "Mat , Sırlı Body",
    "thickness": "30mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_339",
    "brand": "Duratiles",
    "title": "PASIFICO Grigio 45x90",
    "seriesName": "PASIFICO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "339",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3744197971579295.webp",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3744197971579295.webp"
    ],
    "size": "45x90",
    "color": "Grigio",
    "surface": "Mat , Sırlı Body",
    "thickness": "30mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_344",
    "brand": "Duratiles",
    "title": "PASIFICO Avana 80x80",
    "seriesName": "PASIFICO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "344",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3970472577524934.webp",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3970472577524934.webp"
    ],
    "size": "80x80",
    "color": "Avana",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_345",
    "brand": "Duratiles",
    "title": "PASIFICO Natural 80x80",
    "seriesName": "PASIFICO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "345",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.25097656343243147.webp",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.25097656343243147.webp"
    ],
    "size": "80x80",
    "color": "Natural",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_343",
    "brand": "Duratiles",
    "title": "PASIFICO Grigio 80x80",
    "seriesName": "PASIFICO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "343",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0757176303661724.webp",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0757176303661724.webp"
    ],
    "size": "80x80",
    "color": "Grigio",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_351",
    "brand": "Duratiles",
    "title": "PASIFICO Avana 40x40",
    "seriesName": "PASIFICO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "351",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5646475826771098.webp",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5646475826771098.webp"
    ],
    "size": "40x40",
    "color": "Avana",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_350",
    "brand": "Duratiles",
    "title": "PASIFICO Natural 40x40",
    "seriesName": "PASIFICO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "350",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4509577789342327.webp",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4509577789342327.webp"
    ],
    "size": "40x40",
    "color": "Natural",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_349",
    "brand": "Duratiles",
    "title": "PASIFICO Grigio 40x40",
    "seriesName": "PASIFICO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "349",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.848931831056249.webp",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.848931831056249.webp"
    ],
    "size": "40x40",
    "color": "Grigio",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_348",
    "brand": "Duratiles",
    "title": "PASIFICO Avana 40x80",
    "seriesName": "PASIFICO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "348",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6330757213056787.webp",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6330757213056787.webp"
    ],
    "size": "40x80",
    "color": "Avana",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_347",
    "brand": "Duratiles",
    "title": "PASIFICO Natural 40x80",
    "seriesName": "PASIFICO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "347",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1336571402410709.webp",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1336571402410709.webp"
    ],
    "size": "40x80",
    "color": "Natural",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_346",
    "brand": "Duratiles",
    "title": "PASIFICO Grigio 40x80",
    "seriesName": "PASIFICO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "346",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5598973499147031.webp",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5598973499147031.webp"
    ],
    "size": "40x80",
    "color": "Grigio",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Pasifico Serisi, ses ve ısı izolasyonuna katkı sağlar , fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_353",
    "brand": "Duratiles",
    "title": "PERO Gri 20x120",
    "seriesName": "PERO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "353",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.696315603729532.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.696315603729532.jpg"
    ],
    "size": "20x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap görünümlü Pero serisi ile hayatınızda yeni bir sayfa açın, yaşam alanlarınızı baştan yaratın</span>",
    "descriptionClean": "Ahşap görünümlü Pero serisi ile hayatınızda yeni bir sayfa açın, yaşam alanlarınızı baştan yaratın",
    "source": "duratiles"
  },
  {
    "id": "dura_352",
    "brand": "Duratiles",
    "title": "PERO Bone 20x120",
    "seriesName": "PERO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "352",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36415595097420816.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36415595097420816.jpg"
    ],
    "size": "20x120",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşap görünümlü Pero serisi ile hayatınızda yeni bir sayfa açın, yaşam alanlarınızı baştan yaratın</span>",
    "descriptionClean": "Ahşap görünümlü Pero serisi ile hayatınızda yeni bir sayfa açın, yaşam alanlarınızı baştan yaratın",
    "source": "duratiles"
  },
  {
    "id": "dura_355",
    "brand": "Duratiles",
    "title": "POCONO Kakao 15x90",
    "seriesName": "POCONO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "355",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7521994957426418.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7521994957426418.jpg"
    ],
    "size": "15x90",
    "color": "Kakao",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "V3",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pocono Serisi yalın çizgileri ile sadelikle buluşan zarafeti simgeler gibi.</span>",
    "descriptionClean": "Pocono Serisi yalın çizgileri ile sadelikle buluşan zarafeti simgeler gibi.",
    "source": "duratiles"
  },
  {
    "id": "dura_354",
    "brand": "Duratiles",
    "title": "POCONO Smoke 15x90",
    "seriesName": "POCONO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "354",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5768175967181195.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5768175967181195.jpg"
    ],
    "size": "15x90",
    "color": "Smoke",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "V3",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pocono Serisi yalın çizgileri ile sadelikle buluşan zarafeti simgeler gibi.</span>",
    "descriptionClean": "Pocono Serisi yalın çizgileri ile sadelikle buluşan zarafeti simgeler gibi.",
    "source": "duratiles"
  },
  {
    "id": "dura_359",
    "brand": "Duratiles",
    "title": "POCONO Meşe 15x90",
    "seriesName": "POCONO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "57440",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6825796013288941.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6825796013288941.jpg"
    ],
    "size": "15x90",
    "color": "Meşe",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "V3",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pocono Serisi yalın çizgileri ile sadelikle buluşan zarafeti simgeler gibi.</span>",
    "descriptionClean": "Pocono Serisi yalın çizgileri ile sadelikle buluşan zarafeti simgeler gibi.",
    "source": "duratiles"
  },
  {
    "id": "dura_358",
    "brand": "Duratiles",
    "title": "POCONO Kakao 15x60",
    "seriesName": "POCONO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "358",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5207021450912788.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5207021450912788.jpg"
    ],
    "size": "15x60",
    "color": "Kakao",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pocono Serisi yalın çizgileri ile sadelikle buluşan zarafeti simgeler gibi.</span>",
    "descriptionClean": "Pocono Serisi yalın çizgileri ile sadelikle buluşan zarafeti simgeler gibi.",
    "source": "duratiles"
  },
  {
    "id": "dura_356",
    "brand": "Duratiles",
    "title": "POCONO Smoke 15x60",
    "seriesName": "POCONO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "356",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21867270207728595.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21867270207728595.jpg"
    ],
    "size": "15x60",
    "color": "Smoke",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pocono Serisi yalın çizgileri ile sadelikle buluşan zarafeti simgeler gibi.</span>",
    "descriptionClean": "Pocono Serisi yalın çizgileri ile sadelikle buluşan zarafeti simgeler gibi.",
    "source": "duratiles"
  },
  {
    "id": "dura_357",
    "brand": "Duratiles",
    "title": "POCONO Meşe 15x60",
    "seriesName": "POCONO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "357",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6122115160457406.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6122115160457406.jpg"
    ],
    "size": "15x60",
    "color": "Meşe",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pocono Serisi yalın çizgileri ile sadelikle buluşan zarafeti simgeler gibi.</span>",
    "descriptionClean": "Pocono Serisi yalın çizgileri ile sadelikle buluşan zarafeti simgeler gibi.",
    "source": "duratiles"
  },
  {
    "id": "dura_360",
    "brand": "Duratiles",
    "title": "POPLARWOOD Sand 15x60",
    "seriesName": "POPLARWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "360",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.32770126275372957.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.32770126275372957.jpg"
    ],
    "size": "15x60",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pocono Serisi yalın çizgileri ile sadelikle buluşan zarafeti simgeler gibi.</span>",
    "descriptionClean": "Pocono Serisi yalın çizgileri ile sadelikle buluşan zarafeti simgeler gibi.",
    "source": "duratiles"
  },
  {
    "id": "dura_361",
    "brand": "Duratiles",
    "title": "PREMERY Premery 15x90",
    "seriesName": "PREMERY",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "361",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.167119359904234.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.167119359904234.jpg"
    ],
    "size": "15x90",
    "color": "Premery",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ahşap görünümlü seramik koleksiyonu Premery Serisi kişilikli tasarımıyla fark yaratarak mekanlara doğanın cazibesini taşıyor. Hem duvarda hem de zeminde kullanabileceğiniz Premery Serisi kolay temizlenme özelliği ile tekniği ve sanatı bir araya getiriyor</span>",
    "descriptionClean": "Ahşap görünümlü seramik koleksiyonu Premery Serisi kişilikli tasarımıyla fark yaratarak mekanlara doğanın cazibesini taşıyor. Hem duvarda hem de zeminde kullanabileceğiniz Premery Serisi kolay temizlenme özelliği ile tekniği ve sanatı bir araya getiriyor",
    "source": "duratiles"
  },
  {
    "id": "dura_362",
    "brand": "Duratiles",
    "title": "PROCIDA Fildişi 22x90",
    "seriesName": "PROCIDA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "362",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07105089278986432.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07105089278986432.jpg"
    ],
    "size": "22x90",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Evinize estetik bir dokunuş katacak olan Procida Serisi ile seramiğin doğallığı her mekânda sizinle. Tarzınızı tamamlayan detayların bütünü bu seride saklı.</span>",
    "descriptionClean": "Evinize estetik bir dokunuş katacak olan Procida Serisi ile seramiğin doğallığı her mekânda sizinle. Tarzınızı tamamlayan detayların bütünü bu seride saklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_366",
    "brand": "Duratiles",
    "title": "RIVERDALE Noce Decofon 15x90",
    "seriesName": "RIVERDALE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "366",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3661676534312852.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3661676534312852.jpg"
    ],
    "size": "15x90",
    "color": "Noce Decofon",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Tasarıma özgünlük kattık ve Riverdale Serisini tasarladık.Dekofonlarda yer alan şehir isimleriyle mekanlarınıza fark katma olanağı sunan serinin iki farklı renk seçeneği mevcut.</span>",
    "descriptionClean": "Tasarıma özgünlük kattık ve Riverdale Serisini tasarladık.Dekofonlarda yer alan şehir isimleriyle mekanlarınıza fark katma olanağı sunan serinin iki farklı renk seçeneği mevcut.",
    "source": "duratiles"
  },
  {
    "id": "dura_365",
    "brand": "Duratiles",
    "title": "RIVERDALE Red Decofon 15x90",
    "seriesName": "RIVERDALE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "365",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.47935076591585524.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.47935076591585524.jpg"
    ],
    "size": "15x90",
    "color": "Red Decofon",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Tasarıma özgünlük kattık ve Riverdale Serisini tasarladık.Dekofonlarda yer alan şehir isimleriyle mekanlarınıza fark katma olanağı sunan serinin iki farklı renk seçeneği mevcut.</span>",
    "descriptionClean": "Tasarıma özgünlük kattık ve Riverdale Serisini tasarladık.Dekofonlarda yer alan şehir isimleriyle mekanlarınıza fark katma olanağı sunan serinin iki farklı renk seçeneği mevcut.",
    "source": "duratiles"
  },
  {
    "id": "dura_364",
    "brand": "Duratiles",
    "title": "RIVERDALE Kırmızı 15x90",
    "seriesName": "RIVERDALE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "364",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8090874609670974.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8090874609670974.jpg"
    ],
    "size": "15x90",
    "color": "Kırmızı",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "V3",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Tasarıma özgünlük kattık ve Riverdale Serisini tasarladık.Dekofonlarda yer alan şehir isimleriyle mekanlarınıza fark katma olanağı sunan serinin iki farklı renk seçeneği mevcut.</span>",
    "descriptionClean": "Tasarıma özgünlük kattık ve Riverdale Serisini tasarladık.Dekofonlarda yer alan şehir isimleriyle mekanlarınıza fark katma olanağı sunan serinin iki farklı renk seçeneği mevcut.",
    "source": "duratiles"
  },
  {
    "id": "dura_363",
    "brand": "Duratiles",
    "title": "RIVERDALE Noce 15x90",
    "seriesName": "RIVERDALE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "363",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12065700495932341.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12065700495932341.jpg"
    ],
    "size": "15x90",
    "color": "Noce",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Tasarıma özgünlük kattık ve Riverdale Serisini tasarladık.Dekofonlarda yer alan şehir isimleriyle mekanlarınıza fark katma olanağı sunan serinin iki farklı renk seçeneği mevcut.</span>",
    "descriptionClean": "Tasarıma özgünlük kattık ve Riverdale Serisini tasarladık.Dekofonlarda yer alan şehir isimleriyle mekanlarınıza fark katma olanağı sunan serinin iki farklı renk seçeneği mevcut.",
    "source": "duratiles"
  },
  {
    "id": "dura_368",
    "brand": "Duratiles",
    "title": "RIZZI Koyu 45x45",
    "seriesName": "RIZZI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "368",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9438804846484586.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9438804846484586.jpg"
    ],
    "size": "45x45",
    "color": "Koyu",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Seramiğin en özel halini barındıran Rizzi serisi ile yeniliğe bir adım atın. Desenlerin özgünlüğü ile yaşam alanlarınıza fark katın.</span>",
    "descriptionClean": "Seramiğin en özel halini barındıran Rizzi serisi ile yeniliğe bir adım atın. Desenlerin özgünlüğü ile yaşam alanlarınıza fark katın.",
    "source": "duratiles"
  },
  {
    "id": "dura_367",
    "brand": "Duratiles",
    "title": "RIZZI Açık 45x45",
    "seriesName": "RIZZI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "367",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9951292578296004.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9951292578296004.jpg"
    ],
    "size": "45x45",
    "color": "Açık",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Seramiğin en özel halini barındıran Rizzi serisi ile yeniliğe bir adım atın. Desenlerin özgünlüğü ile yaşam alanlarınıza fark katın.</span>",
    "descriptionClean": "Seramiğin en özel halini barındıran Rizzi serisi ile yeniliğe bir adım atın. Desenlerin özgünlüğü ile yaşam alanlarınıza fark katın.",
    "source": "duratiles"
  },
  {
    "id": "dura_369",
    "brand": "Duratiles",
    "title": "ROVERE Argento 15x90",
    "seriesName": "ROVERE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "369",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.719013583191613.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.719013583191613.jpg"
    ],
    "size": "15x90",
    "color": "Argento",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Seramiğin avantajını ahşabın sıcaklığı ve doğallığı ile buluşturan Rovere Porselen Karoları farklı ebat ve ton alternatifleriyle dingin iç mekan kurguları için ideal bir seçenek.</span>",
    "descriptionClean": "Seramiğin avantajını ahşabın sıcaklığı ve doğallığı ile buluşturan Rovere Porselen Karoları farklı ebat ve ton alternatifleriyle dingin iç mekan kurguları için ideal bir seçenek.",
    "source": "duratiles"
  },
  {
    "id": "dura_690",
    "brand": "Duratiles",
    "title": "ROVERE Altın 15x90",
    "seriesName": "ROVERE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "75344",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9641577939430068.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9641577939430068.jpg"
    ],
    "size": "15x90",
    "color": "Altın",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Balkon/Teras & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Seramiğin avantajını ahşabın sıcaklığı ve doğallığı ile buluşturan Rovere Porselen Karoları farklı ebat ve ton alternatifleriyle dingin iç mekan kurguları için ideal bir seçenek.</span>",
    "descriptionClean": "Seramiğin avantajını ahşabın sıcaklığı ve doğallığı ile buluşturan Rovere Porselen Karoları farklı ebat ve ton alternatifleriyle dingin iç mekan kurguları için ideal bir seçenek.",
    "source": "duratiles"
  },
  {
    "id": "dura_691",
    "brand": "Duratiles",
    "title": "ROVERE Noce 15x90",
    "seriesName": "ROVERE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "691",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5020606660876644.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5020606660876644.jpg"
    ],
    "size": "15x90",
    "color": "Noce",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Balkon/Teras & Ev içi Zemin & Dış Cephe & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "V3",
      "Banyo",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Seramiğin avantajını ahşabın sıcaklığı ve doğallığı ile buluşturan Rovere Porselen Karoları farklı ebat ve ton alternatifleriyle dingin iç mekan kurguları için ideal bir seçenek.</span>",
    "descriptionClean": "Seramiğin avantajını ahşabın sıcaklığı ve doğallığı ile buluşturan Rovere Porselen Karoları farklı ebat ve ton alternatifleriyle dingin iç mekan kurguları için ideal bir seçenek.",
    "source": "duratiles"
  },
  {
    "id": "dura_370",
    "brand": "Duratiles",
    "title": "SANCTUARY Açık 22x90",
    "seriesName": "SANCTUARY",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "370",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16469417838882472.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16469417838882472.jpg"
    ],
    "size": "22x90",
    "color": "Açık",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Sanctuary Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.</span>",
    "descriptionClean": "Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Sanctuary Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_371",
    "brand": "Duratiles",
    "title": "SARAY Bej 45x45",
    "seriesName": "SARAY",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "371",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7439692597161806.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7439692597161806.jpg"
    ],
    "size": "45x45",
    "color": "Bej",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Geçmişten gelen zarafet anlayışını Saray serisi ile günümüze taşıdık. Seçkin zevklere özel bir tasarım bu ürünümüzde hayat buldu.</span>",
    "descriptionClean": "Geçmişten gelen zarafet anlayışını Saray serisi ile günümüze taşıdık. Seçkin zevklere özel bir tasarım bu ürünümüzde hayat buldu.",
    "source": "duratiles"
  },
  {
    "id": "dura_372",
    "brand": "Duratiles",
    "title": "SCALA Kahve 15x90",
    "seriesName": "SCALA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "372",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3895772657829101.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3895772657829101.jpg"
    ],
    "size": "15x90",
    "color": "Kahve",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Dış Cephe & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Scala Serisi, ahşap dokusuyla natürel tasarımlardan hoşlananların ilk seçeneği olmaya devam ediyor</span>",
    "descriptionClean": "Scala Serisi, ahşap dokusuyla natürel tasarımlardan hoşlananların ilk seçeneği olmaya devam ediyor",
    "source": "duratiles"
  },
  {
    "id": "dura_373",
    "brand": "Duratiles",
    "title": "SCALA Scala 15x90",
    "seriesName": "SCALA",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "373",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.050906755393542835.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.050906755393542835.jpg"
    ],
    "size": "15x90",
    "color": "Scala",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Dış Cephe & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Scala Serisi, ahşap dokusuyla natürel tasarımlardan hoşlananların ilk seçeneği olmaya devam ediyor</span>",
    "descriptionClean": "Scala Serisi, ahşap dokusuyla natürel tasarımlardan hoşlananların ilk seçeneği olmaya devam ediyor",
    "source": "duratiles"
  },
  {
    "id": "dura_375",
    "brand": "Duratiles",
    "title": "SEDİR Ceviz 45x45",
    "seriesName": "SEDİR",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "375",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2189626203323799.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2189626203323799.jpg"
    ],
    "size": "45x45",
    "color": "Ceviz",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sedir ağacının ilham veren dokusu, kendine özgü rengi ve yetiştiği ılıman iklimin rahatlatıcı etkisini barındıran bu seri her açıdan eşsiz bir tasarım. Sedir serisi doğallığın farklı ve özel bir yorumu.</span>",
    "descriptionClean": "Sedir ağacının ilham veren dokusu, kendine özgü rengi ve yetiştiği ılıman iklimin rahatlatıcı etkisini barındıran bu seri her açıdan eşsiz bir tasarım. Sedir serisi doğallığın farklı ve özel bir yorumu.",
    "source": "duratiles"
  },
  {
    "id": "dura_374",
    "brand": "Duratiles",
    "title": "SEDİR Akçaağaç 45x45",
    "seriesName": "SEDİR",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "374",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6393185616929781.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6393185616929781.jpg"
    ],
    "size": "45x45",
    "color": "Akçaağaç",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sedir ağacının ilham veren dokusu, kendine özgü rengi ve yetiştiği ılıman iklimin rahatlatıcı etkisini barındıran bu seri her açıdan eşsiz bir tasarım. Sedir serisi doğallığın farklı ve özel bir yorumu.</span>",
    "descriptionClean": "Sedir ağacının ilham veren dokusu, kendine özgü rengi ve yetiştiği ılıman iklimin rahatlatıcı etkisini barındıran bu seri her açıdan eşsiz bir tasarım. Sedir serisi doğallığın farklı ve özel bir yorumu.",
    "source": "duratiles"
  },
  {
    "id": "dura_378",
    "brand": "Duratiles",
    "title": "SERPEGIANTE Noce 60x120",
    "seriesName": "SERPEGIANTE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "73941",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8656947412188002.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8656947412188002.jpg"
    ],
    "size": "60x120",
    "color": "Noce",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Konutlarda olduğu kadar restoran ve kafe gibi ticari mekanlarda da tercih edilen Serpegiante serisi vizon,noce ve krem renk seçenekleriyle mekanlara farklı bir hava kazandırıyor .</span>",
    "descriptionClean": "Konutlarda olduğu kadar restoran ve kafe gibi ticari mekanlarda da tercih edilen Serpegiante serisi vizon,noce ve krem renk seçenekleriyle mekanlara farklı bir hava kazandırıyor .",
    "source": "duratiles"
  },
  {
    "id": "dura_377",
    "brand": "Duratiles",
    "title": "SERPEGIANTE Vison 60x120",
    "seriesName": "SERPEGIANTE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "65776",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4599347060463731.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4599347060463731.jpg"
    ],
    "size": "60x120",
    "color": "Vison",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Konutlarda olduğu kadar restoran ve kafe gibi ticari mekanlarda da tercih edilen Serpegiante serisi vizon,noce ve krem renk seçenekleriyle mekanlara farklı bir hava kazandırıyor .</span>",
    "descriptionClean": "Konutlarda olduğu kadar restoran ve kafe gibi ticari mekanlarda da tercih edilen Serpegiante serisi vizon,noce ve krem renk seçenekleriyle mekanlara farklı bir hava kazandırıyor .",
    "source": "duratiles"
  },
  {
    "id": "dura_376",
    "brand": "Duratiles",
    "title": "SERPEGIANTE Krem 60x120",
    "seriesName": "SERPEGIANTE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "67409",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4875052840549623.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4875052840549623.jpg"
    ],
    "size": "60x120",
    "color": "Krem",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Konutlarda olduğu kadar restoran ve kafe gibi ticari mekanlarda da tercih edilen Serpegiante serisi vizon,noce ve krem renk seçenekleriyle mekanlara farklı bir hava kazandırıyor .</span>",
    "descriptionClean": "Konutlarda olduğu kadar restoran ve kafe gibi ticari mekanlarda da tercih edilen Serpegiante serisi vizon,noce ve krem renk seçenekleriyle mekanlara farklı bir hava kazandırıyor .",
    "source": "duratiles"
  },
  {
    "id": "dura_380",
    "brand": "Duratiles",
    "title": "SHARPEN Koyu 30x180",
    "seriesName": "SHARPEN",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "380",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.642076425712895.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.642076425712895.jpg"
    ],
    "size": "30x180",
    "color": "Koyu",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Özel renk geçişleri, tasarıma estetik katan ahşabın doğal desenleri Sharpen serisi ile seramikte hayat buldu. Zarafet tasarımın doğasında var. Özel alanlara, özel bir armağan...</span>",
    "descriptionClean": "Özel renk geçişleri, tasarıma estetik katan ahşabın doğal desenleri Sharpen serisi ile seramikte hayat buldu. Zarafet tasarımın doğasında var. Özel alanlara, özel bir armağan...",
    "source": "duratiles"
  },
  {
    "id": "dura_379",
    "brand": "Duratiles",
    "title": "SHARPEN Açık 30x180",
    "seriesName": "SHARPEN",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "379",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4593347151363635.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4593347151363635.jpg"
    ],
    "size": "30x180",
    "color": "Açık",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Özel renk geçişleri, tasarıma estetik katan ahşabın doğal desenleri Sharpen serisi ile seramikte hayat buldu. Zarafet tasarımın doğasında var. Özel alanlara, özel bir armağan...</span>",
    "descriptionClean": "Özel renk geçişleri, tasarıma estetik katan ahşabın doğal desenleri Sharpen serisi ile seramikte hayat buldu. Zarafet tasarımın doğasında var. Özel alanlara, özel bir armağan...",
    "source": "duratiles"
  },
  {
    "id": "dura_389",
    "brand": "Duratiles",
    "title": "SHERWOOD Latte 60x120",
    "seriesName": "SHERWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "389",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5822500093625672.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5822500093625672.jpg"
    ],
    "size": "60x120",
    "color": "Latte",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sherwood porselen karoları sayısız kombinasyonlarla zamansız mekanlar yaratmanız için hayal gücünüzü ve estetik anlayışınızın sınırlarını zorlayacak .</span>",
    "descriptionClean": "Sherwood porselen karoları sayısız kombinasyonlarla zamansız mekanlar yaratmanız için hayal gücünüzü ve estetik anlayışınızın sınırlarını zorlayacak .",
    "source": "duratiles"
  },
  {
    "id": "dura_390",
    "brand": "Duratiles",
    "title": "SHERWOOD Latte Oluklu 60x120",
    "seriesName": "SHERWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "390",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13817495257052348.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13817495257052348.jpg"
    ],
    "size": "60x120",
    "color": "Latte Oluklu",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sherwood porselen karoları sayısız kombinasyonlarla zamansız mekanlar yaratmanız için hayal gücünüzü ve estetik anlayışınızın sınırlarını zorlayacak .</span>",
    "descriptionClean": "Sherwood porselen karoları sayısız kombinasyonlarla zamansız mekanlar yaratmanız için hayal gücünüzü ve estetik anlayışınızın sınırlarını zorlayacak .",
    "source": "duratiles"
  },
  {
    "id": "dura_388",
    "brand": "Duratiles",
    "title": "SHERWOOD Koyu Vizon Oluklu 60x120",
    "seriesName": "SHERWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "388",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20856006223443657.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20856006223443657.jpg"
    ],
    "size": "60x120",
    "color": "Koyu Vizon Oluklu",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sherwood porselen karoları sayısız kombinasyonlarla zamansız mekanlar yaratmanız için hayal gücünüzü ve estetik anlayışınızın sınırlarını zorlayacak .</span>",
    "descriptionClean": "Sherwood porselen karoları sayısız kombinasyonlarla zamansız mekanlar yaratmanız için hayal gücünüzü ve estetik anlayışınızın sınırlarını zorlayacak .",
    "source": "duratiles"
  },
  {
    "id": "dura_387",
    "brand": "Duratiles",
    "title": "SHERWOOD Koyu Vizon 60x120",
    "seriesName": "SHERWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "387",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.712117160710751.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.712117160710751.jpg"
    ],
    "size": "60x120",
    "color": "Koyu Vizon",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sherwood porselen karoları sayısız kombinasyonlarla zamansız mekanlar yaratmanız için hayal gücünüzü ve estetik anlayışınızın sınırlarını zorlayacak .</span>",
    "descriptionClean": "Sherwood porselen karoları sayısız kombinasyonlarla zamansız mekanlar yaratmanız için hayal gücünüzü ve estetik anlayışınızın sınırlarını zorlayacak .",
    "source": "duratiles"
  },
  {
    "id": "dura_386",
    "brand": "Duratiles",
    "title": "SHERWOOD Gri 60x120",
    "seriesName": "SHERWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "386",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09544473299566913.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09544473299566913.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sherwood porselen karoları sayısız kombinasyonlarla zamansız mekanlar yaratmanız için hayal gücünüzü ve estetik anlayışınızın sınırlarını zorlayacak .</span>",
    "descriptionClean": "Sherwood porselen karoları sayısız kombinasyonlarla zamansız mekanlar yaratmanız için hayal gücünüzü ve estetik anlayışınızın sınırlarını zorlayacak .",
    "source": "duratiles"
  },
  {
    "id": "dura_385",
    "brand": "Duratiles",
    "title": "SHERWOOD Koyu Ceviz Oluklu 60x120",
    "seriesName": "SHERWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "385",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09455068082866647.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09455068082866647.jpg"
    ],
    "size": "60x120",
    "color": "Koyu Ceviz Oluklu",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sherwood porselen karoları sayısız kombinasyonlarla zamansız mekanlar yaratmanız için hayal gücünüzü ve estetik anlayışınızın sınırlarını zorlayacak .</span>",
    "descriptionClean": "Sherwood porselen karoları sayısız kombinasyonlarla zamansız mekanlar yaratmanız için hayal gücünüzü ve estetik anlayışınızın sınırlarını zorlayacak .",
    "source": "duratiles"
  },
  {
    "id": "dura_384",
    "brand": "Duratiles",
    "title": "SHERWOOD Açık Ceviz Oluklu 60x120",
    "seriesName": "SHERWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "384",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.45016522465372555.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.45016522465372555.jpg"
    ],
    "size": "60x120",
    "color": "Açık Ceviz Oluklu",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sherwood porselen karoları sayısız kombinasyonlarla zamansız mekanlar yaratmanız için hayal gücünüzü ve estetik anlayışınızın sınırlarını zorlayacak .</span>",
    "descriptionClean": "Sherwood porselen karoları sayısız kombinasyonlarla zamansız mekanlar yaratmanız için hayal gücünüzü ve estetik anlayışınızın sınırlarını zorlayacak .",
    "source": "duratiles"
  },
  {
    "id": "dura_383",
    "brand": "Duratiles",
    "title": "SHERWOOD Ceviz 60x120",
    "seriesName": "SHERWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "383",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.952981872043521.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.952981872043521.jpg"
    ],
    "size": "60x120",
    "color": "Ceviz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sherwood porselen karoları sayısız kombinasyonlarla zamansız mekanlar yaratmanız için hayal gücünüzü ve estetik anlayışınızın sınırlarını zorlayacak .</span>",
    "descriptionClean": "Sherwood porselen karoları sayısız kombinasyonlarla zamansız mekanlar yaratmanız için hayal gücünüzü ve estetik anlayışınızın sınırlarını zorlayacak .",
    "source": "duratiles"
  },
  {
    "id": "dura_382",
    "brand": "Duratiles",
    "title": "SHERWOOD Kül Rengi Oluklu 60x120",
    "seriesName": "SHERWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "382",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1020426809047087.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1020426809047087.jpg"
    ],
    "size": "60x120",
    "color": "Kül Rengi Oluklu",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Endüstriyel Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Endüstriyel Zemin",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sherwood porselen karoları sayısız kombinasyonlarla zamansız mekanlar yaratmanız için hayal gücünüzü ve estetik anlayışınızın sınırlarını zorlayacak .</span>",
    "descriptionClean": "Sherwood porselen karoları sayısız kombinasyonlarla zamansız mekanlar yaratmanız için hayal gücünüzü ve estetik anlayışınızın sınırlarını zorlayacak .",
    "source": "duratiles"
  },
  {
    "id": "dura_381",
    "brand": "Duratiles",
    "title": "SHERWOOD Kül 60x120",
    "seriesName": "SHERWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "381",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6987987419396617.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6987987419396617.jpg"
    ],
    "size": "60x120",
    "color": "Kül",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Endüstriyel Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Endüstriyel Zemin",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sherwood porselen karoları sayısız kombinasyonlarla zamansız mekanlar yaratmanız için hayal gücünüzü ve estetik anlayışınızın sınırlarını zorlayacak .</span>",
    "descriptionClean": "Sherwood porselen karoları sayısız kombinasyonlarla zamansız mekanlar yaratmanız için hayal gücünüzü ve estetik anlayışınızın sınırlarını zorlayacak .",
    "source": "duratiles"
  },
  {
    "id": "dura_392",
    "brand": "Duratiles",
    "title": "SUNDARBAN Gri 22x90",
    "seriesName": "SUNDARBAN",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "392",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8608866714787634.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8608866714787634.jpg"
    ],
    "size": "22x90",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "V3",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı çizgisiyle tercih edildiği mekanları seçkin kılan Sundarban serisi yaşam alanlarının sınırsız bir biçimde tasarlanmasına olanak sağlıyor</span>",
    "descriptionClean": "Farklı çizgisiyle tercih edildiği mekanları seçkin kılan Sundarban serisi yaşam alanlarının sınırsız bir biçimde tasarlanmasına olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_391",
    "brand": "Duratiles",
    "title": "SUNDARBAN Bej 22x90",
    "seriesName": "SUNDARBAN",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "391",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9649358014361767.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9649358014361767.jpg"
    ],
    "size": "22x90",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "V3",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı çizgisiyle tercih edildiği mekanları seçkin kılan Sundarban serisi yaşam alanlarının sınırsız bir biçimde tasarlanmasına olanak sağlıyor</span>",
    "descriptionClean": "Farklı çizgisiyle tercih edildiği mekanları seçkin kılan Sundarban serisi yaşam alanlarının sınırsız bir biçimde tasarlanmasına olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_395",
    "brand": "Duratiles",
    "title": "SUNDARBAN Noce 22x90",
    "seriesName": "SUNDARBAN",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "395",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2414496258815484.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2414496258815484.jpg"
    ],
    "size": "22x90",
    "color": "Noce",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Endüstriyel Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "V3",
      "Endüstriyel Zemin",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı çizgisiyle tercih edildiği mekanları seçkin kılan Sundarban serisi yaşam alanlarının sınırsız bir biçimde tasarlanmasına olanak sağlıyor</span>",
    "descriptionClean": "Farklı çizgisiyle tercih edildiği mekanları seçkin kılan Sundarban serisi yaşam alanlarının sınırsız bir biçimde tasarlanmasına olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_393",
    "brand": "Duratiles",
    "title": "SUNDARBAN Fildişi 22x90",
    "seriesName": "SUNDARBAN",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "393",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20895601720832435.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20895601720832435.jpg"
    ],
    "size": "22x90",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Endüstriyel Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "V3",
      "Endüstriyel Zemin",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı çizgisiyle tercih edildiği mekanları seçkin kılan Sundarban serisi yaşam alanlarının sınırsız bir biçimde tasarlanmasına olanak sağlıyor</span>",
    "descriptionClean": "Farklı çizgisiyle tercih edildiği mekanları seçkin kılan Sundarban serisi yaşam alanlarının sınırsız bir biçimde tasarlanmasına olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_394",
    "brand": "Duratiles",
    "title": "SUNDARBAN Natural 22x90",
    "seriesName": "SUNDARBAN",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "394",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2962156100139193.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2962156100139193.jpg"
    ],
    "size": "22x90",
    "color": "Natural",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Endüstriyel Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "V3",
      "Endüstriyel Zemin",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı çizgisiyle tercih edildiği mekanları seçkin kılan Sundarban serisi yaşam alanlarının sınırsız bir biçimde tasarlanmasına olanak sağlıyor</span>",
    "descriptionClean": "Farklı çizgisiyle tercih edildiği mekanları seçkin kılan Sundarban serisi yaşam alanlarının sınırsız bir biçimde tasarlanmasına olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_396",
    "brand": "Duratiles",
    "title": "TECHWOOD Mocha 15x90",
    "seriesName": "TECHWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "396",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17764652439969308.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17764652439969308.jpg"
    ],
    "size": "15x90",
    "color": "Mocha",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Endüstriyel Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "V3",
      "Endüstriyel Zemin",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Techwood serisi ile natürel kurgular yaratmak, seramiğin konforunu hayatınıza dahil ederek teknolojiyi mekanlarınıza doğal bir görünümle getirmek elinizde.</span>",
    "descriptionClean": "Techwood serisi ile natürel kurgular yaratmak, seramiğin konforunu hayatınıza dahil ederek teknolojiyi mekanlarınıza doğal bir görünümle getirmek elinizde.",
    "source": "duratiles"
  },
  {
    "id": "dura_397",
    "brand": "Duratiles",
    "title": "TECHWOOD Cappucino 15x90",
    "seriesName": "TECHWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "397",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3019778231161149.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3019778231161149.jpg"
    ],
    "size": "15x90",
    "color": "Cappucino",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Endüstriyel Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "V3",
      "Endüstriyel Zemin",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Techwood serisi ile natürel kurgular yaratmak, seramiğin konforunu hayatınıza dahil ederek teknolojiyi mekanlarınıza doğal bir görünümle getirmek elinizde.</span>",
    "descriptionClean": "Techwood serisi ile natürel kurgular yaratmak, seramiğin konforunu hayatınıza dahil ederek teknolojiyi mekanlarınıza doğal bir görünümle getirmek elinizde.",
    "source": "duratiles"
  },
  {
    "id": "dura_398",
    "brand": "Duratiles",
    "title": "TECHWOOD Biondo 15x90",
    "seriesName": "TECHWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "57148",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03720136816146746.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03720136816146746.jpg"
    ],
    "size": "15x90",
    "color": "Biondo",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Techwood serisi ile natürel kurgular yaratmak, seramiğin konforunu hayatınıza dahil ederek teknolojiyi mekanlarınıza doğal bir görünümle getirmek elinizde.</span>",
    "descriptionClean": "Techwood serisi ile natürel kurgular yaratmak, seramiğin konforunu hayatınıza dahil ederek teknolojiyi mekanlarınıza doğal bir görünümle getirmek elinizde.",
    "source": "duratiles"
  },
  {
    "id": "dura_401",
    "brand": "Duratiles",
    "title": "TECHWOOD Gri 15x60",
    "seriesName": "TECHWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "401",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5432522588024369.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5432522588024369.jpg"
    ],
    "size": "15x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Techwood serisi ile natürel kurgular yaratmak, seramiğin konforunu hayatınıza dahil ederek teknolojiyi mekanlarınıza doğal bir görünümle getirmek elinizde.</span>",
    "descriptionClean": "Techwood serisi ile natürel kurgular yaratmak, seramiğin konforunu hayatınıza dahil ederek teknolojiyi mekanlarınıza doğal bir görünümle getirmek elinizde.",
    "source": "duratiles"
  },
  {
    "id": "dura_399",
    "brand": "Duratiles",
    "title": "TECHWOOD Cappucino 15x60",
    "seriesName": "TECHWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "399",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4663818123163017.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4663818123163017.jpg"
    ],
    "size": "15x60",
    "color": "Cappucino",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Techwood serisi ile natürel kurgular yaratmak, seramiğin konforunu hayatınıza dahil ederek teknolojiyi mekanlarınıza doğal bir görünümle getirmek elinizde.</span>",
    "descriptionClean": "Techwood serisi ile natürel kurgular yaratmak, seramiğin konforunu hayatınıza dahil ederek teknolojiyi mekanlarınıza doğal bir görünümle getirmek elinizde.",
    "source": "duratiles"
  },
  {
    "id": "dura_400",
    "brand": "Duratiles",
    "title": "TECHWOOD Mocha 15x60",
    "seriesName": "TECHWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "400",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7615117710385779.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7615117710385779.jpg"
    ],
    "size": "15x60",
    "color": "Mocha",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Techwood serisi ile natürel kurgular yaratmak, seramiğin konforunu hayatınıza dahil ederek teknolojiyi mekanlarınıza doğal bir görünümle getirmek elinizde.</span>",
    "descriptionClean": "Techwood serisi ile natürel kurgular yaratmak, seramiğin konforunu hayatınıza dahil ederek teknolojiyi mekanlarınıza doğal bir görünümle getirmek elinizde.",
    "source": "duratiles"
  },
  {
    "id": "dura_403",
    "brand": "Duratiles",
    "title": "TERK Miele 22x90",
    "seriesName": "TERK",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "403",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7420710247811734.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7420710247811734.jpg"
    ],
    "size": "22x90",
    "color": "Miele",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Terk Porselen Karoları ..</span>",
    "descriptionClean": "Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Terk Porselen Karoları ..",
    "source": "duratiles"
  },
  {
    "id": "dura_402",
    "brand": "Duratiles",
    "title": "TERK Honey 22x90",
    "seriesName": "TERK",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "402",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40892823182060745.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40892823182060745.jpg"
    ],
    "size": "22x90",
    "color": "Honey",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Terk Porselen Karoları ..</span>",
    "descriptionClean": "Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Terk Porselen Karoları ..",
    "source": "duratiles"
  },
  {
    "id": "dura_404",
    "brand": "Duratiles",
    "title": "TIVOLI Tivoli Mix 60x60",
    "seriesName": "TIVOLI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "404",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5553554752685523.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5553554752685523.jpg"
    ],
    "size": "60x60",
    "color": "Tivoli Mix",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Terk Porselen Karoları ..</span>",
    "descriptionClean": "Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Terk Porselen Karoları ..",
    "source": "duratiles"
  },
  {
    "id": "dura_408",
    "brand": "Duratiles",
    "title": "TONGASS Sofia 22x90",
    "seriesName": "TONGASS",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "408",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.399601951670311.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.399601951670311.jpg"
    ],
    "size": "22x90",
    "color": "Sofia",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "V3",
      "Banyo",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tongass gerçek ahşap dokusunu porselen karoya aktararak doğanın huzur veren esintisini evinize taşıyor.</span>",
    "descriptionClean": "Tongass gerçek ahşap dokusunu porselen karoya aktararak doğanın huzur veren esintisini evinize taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_409",
    "brand": "Duratiles",
    "title": "TONGASS Sader 22x90",
    "seriesName": "TONGASS",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "409",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21751161968993382.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21751161968993382.jpg"
    ],
    "size": "22x90",
    "color": "Sader",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "V3",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tongass gerçek ahşap dokusunu porselen karoya aktararak doğanın huzur veren esintisini evinize taşıyor.</span>",
    "descriptionClean": "Tongass gerçek ahşap dokusunu porselen karoya aktararak doğanın huzur veren esintisini evinize taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_410",
    "brand": "Duratiles",
    "title": "TONGASS Belly 22x90",
    "seriesName": "TONGASS",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "410",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8276864895632118.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8276864895632118.jpg"
    ],
    "size": "22x90",
    "color": "Belly",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "V3",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tongass gerçek ahşap dokusunu porselen karoya aktararak doğanın huzur veren esintisini evinize taşıyor.</span>",
    "descriptionClean": "Tongass gerçek ahşap dokusunu porselen karoya aktararak doğanın huzur veren esintisini evinize taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_406",
    "brand": "Duratiles",
    "title": "TRENDWOOD Gri 30x180",
    "seriesName": "TRENDWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "406",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.796869770244244.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.796869770244244.jpg"
    ],
    "size": "30x180",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Güvenli ve dayanıklı zeminlerin vazgeçilmezidir seramik. Ahşabın verdiği keyfi isteyenler ancak seramiğin konforunu düşleyenler için tasarlanan Trendwood ile ahşap görünümünü tüm yaşam alanlarınıza seramik kalitesiyle taşıyabilirsiniz.</span>",
    "descriptionClean": "Güvenli ve dayanıklı zeminlerin vazgeçilmezidir seramik. Ahşabın verdiği keyfi isteyenler ancak seramiğin konforunu düşleyenler için tasarlanan Trendwood ile ahşap görünümünü tüm yaşam alanlarınıza seramik kalitesiyle taşıyabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_405",
    "brand": "Duratiles",
    "title": "TRENDWOOD Krem 30x180",
    "seriesName": "TRENDWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "405",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8191620030873692.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8191620030873692.jpg"
    ],
    "size": "30x180",
    "color": "Krem",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Güvenli ve dayanıklı zeminlerin vazgeçilmezidir seramik. Ahşabın verdiği keyfi isteyenler ancak seramiğin konforunu düşleyenler için tasarlanan Trendwood ile ahşap görünümünü tüm yaşam alanlarınıza seramik kalitesiyle taşıyabilirsiniz.</span>",
    "descriptionClean": "Güvenli ve dayanıklı zeminlerin vazgeçilmezidir seramik. Ahşabın verdiği keyfi isteyenler ancak seramiğin konforunu düşleyenler için tasarlanan Trendwood ile ahşap görünümünü tüm yaşam alanlarınıza seramik kalitesiyle taşıyabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_407",
    "brand": "Duratiles",
    "title": "TRENDWOOD Mocha 30x180",
    "seriesName": "TRENDWOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "407",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17187512779245828.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17187512779245828.jpg"
    ],
    "size": "30x180",
    "color": "Mocha",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Güvenli ve dayanıklı zeminlerin vazgeçilmezidir seramik. Ahşabın verdiği keyfi isteyenler ancak seramiğin konforunu düşleyenler için tasarlanan Trendwood ile ahşap görünümünü tüm yaşam alanlarınıza seramik kalitesiyle taşıyabilirsiniz.</span>",
    "descriptionClean": "Güvenli ve dayanıklı zeminlerin vazgeçilmezidir seramik. Ahşabın verdiği keyfi isteyenler ancak seramiğin konforunu düşleyenler için tasarlanan Trendwood ile ahşap görünümünü tüm yaşam alanlarınıza seramik kalitesiyle taşıyabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_411",
    "brand": "Duratiles",
    "title": "VERCELLI Noce 60x60",
    "seriesName": "VERCELLI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "411",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6772232395949722.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6772232395949722.jpg"
    ],
    "size": "60x60",
    "color": "Noce",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ahşabın doğal sıcaklığını mekânlara yansıtan Vercelli serisi porselen karoları, doğanın özünü derinden hissetmenizi sağlıyor.</span>",
    "descriptionClean": "Ahşabın doğal sıcaklığını mekânlara yansıtan Vercelli serisi porselen karoları, doğanın özünü derinden hissetmenizi sağlıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_412",
    "brand": "Duratiles",
    "title": "VERMONT Bone 60x120",
    "seriesName": "VERMONT",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "412",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4844112224388959.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4844112224388959.jpg"
    ],
    "size": "60x120",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Kaliteyi öne çıkaran ve her zevke hitap eden Vermont porselen karoları geniş ürün yelpazesiyle yaşam alanlarına estetik dokunuşlar katıyor</span>",
    "descriptionClean": "Kaliteyi öne çıkaran ve her zevke hitap eden Vermont porselen karoları geniş ürün yelpazesiyle yaşam alanlarına estetik dokunuşlar katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_413",
    "brand": "Duratiles",
    "title": "VERMONT Kemik Renkli Oluklu 60x120",
    "seriesName": "VERMONT",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "413",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6028011001564944.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6028011001564944.jpg"
    ],
    "size": "60x120",
    "color": "Kemik Renkli Oluklu",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Kaliteyi öne çıkaran ve her zevke hitap eden Vermont porselen karoları geniş ürün yelpazesiyle yaşam alanlarına estetik dokunuşlar katıyor</span>",
    "descriptionClean": "Kaliteyi öne çıkaran ve her zevke hitap eden Vermont porselen karoları geniş ürün yelpazesiyle yaşam alanlarına estetik dokunuşlar katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_414",
    "brand": "Duratiles",
    "title": "VERMONT Gri 60x120",
    "seriesName": "VERMONT",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "414",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5030702615872201.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5030702615872201.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Kaliteyi öne çıkaran ve her zevke hitap eden Vermont porselen karoları geniş ürün yelpazesiyle yaşam alanlarına estetik dokunuşlar katıyor</span>",
    "descriptionClean": "Kaliteyi öne çıkaran ve her zevke hitap eden Vermont porselen karoları geniş ürün yelpazesiyle yaşam alanlarına estetik dokunuşlar katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_415",
    "brand": "Duratiles",
    "title": "VERMONT Vizon 60x120",
    "seriesName": "VERMONT",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "415",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2990112705521706.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2990112705521706.jpg"
    ],
    "size": "60x120",
    "color": "Vizon",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Kaliteyi öne çıkaran ve her zevke hitap eden Vermont porselen karoları geniş ürün yelpazesiyle yaşam alanlarına estetik dokunuşlar katıyor</span>",
    "descriptionClean": "Kaliteyi öne çıkaran ve her zevke hitap eden Vermont porselen karoları geniş ürün yelpazesiyle yaşam alanlarına estetik dokunuşlar katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_416",
    "brand": "Duratiles",
    "title": "VERMONT Vizon Oluklu 60x120",
    "seriesName": "VERMONT",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "416",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2728695318211861.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2728695318211861.jpg"
    ],
    "size": "60x120",
    "color": "Vizon Oluklu",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "Dış Cephe",
      "V3",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Kaliteyi öne çıkaran ve her zevke hitap eden Vermont porselen karoları geniş ürün yelpazesiyle yaşam alanlarına estetik dokunuşlar katıyor</span>",
    "descriptionClean": "Kaliteyi öne çıkaran ve her zevke hitap eden Vermont porselen karoları geniş ürün yelpazesiyle yaşam alanlarına estetik dokunuşlar katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_419",
    "brand": "Duratiles",
    "title": "VICTUS Latte 15x60",
    "seriesName": "VICTUS",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "419",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.280805642056682.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.280805642056682.jpg"
    ],
    "size": "15x60",
    "color": "Latte",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Victus Serisi solmayan renkleri ve aşınmayan yüzeyi ile uzun ömürlü ve hep güzel</span>",
    "descriptionClean": "Victus Serisi solmayan renkleri ve aşınmayan yüzeyi ile uzun ömürlü ve hep güzel",
    "source": "duratiles"
  },
  {
    "id": "dura_418",
    "brand": "Duratiles",
    "title": "VICTUS Gri 15x60",
    "seriesName": "VICTUS",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "64224",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1569538255090982.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1569538255090982.jpg"
    ],
    "size": "15x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Victus Serisi solmayan renkleri ve aşınmayan yüzeyi ile uzun ömürlü ve hep güzel</span>",
    "descriptionClean": "Victus Serisi solmayan renkleri ve aşınmayan yüzeyi ile uzun ömürlü ve hep güzel",
    "source": "duratiles"
  },
  {
    "id": "dura_417",
    "brand": "Duratiles",
    "title": "VICTUS Latte 20x120",
    "seriesName": "VICTUS",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "417",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10684107685519317.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10684107685519317.jpg"
    ],
    "size": "20x120",
    "color": "Latte",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "Dış Cephe",
      "V3",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Victus Serisi solmayan renkleri ve aşınmayan yüzeyi ile uzun ömürlü ve hep güzel</span>",
    "descriptionClean": "Victus Serisi solmayan renkleri ve aşınmayan yüzeyi ile uzun ömürlü ve hep güzel",
    "source": "duratiles"
  },
  {
    "id": "dura_420",
    "brand": "Duratiles",
    "title": "VINTAGE Blue Art 60x60",
    "seriesName": "VINTAGE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "420",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.49138654117897573.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.49138654117897573.jpg"
    ],
    "size": "60x60",
    "color": "Blue Art",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin & Endüstriyel Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Dış Cephe",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ahşaptan gelen sıcak atmosferi yaşam alanlarınıza taşıyan Vintage serisi dekorasyonunuza rustik bir dokunuş katarak, hayat dolu mekânlar yaratmanızı sağlar.</span>",
    "descriptionClean": "Ahşaptan gelen sıcak atmosferi yaşam alanlarınıza taşıyan Vintage serisi dekorasyonunuza rustik bir dokunuş katarak, hayat dolu mekânlar yaratmanızı sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_423",
    "brand": "Duratiles",
    "title": "VIRGIN Virgin 20x120",
    "seriesName": "VIRGIN",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "423",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9051332610111427.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9051332610111427.jpg"
    ],
    "size": "20x120",
    "color": "Virgin",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Özel mekânlara, özel dokunuşlar... Virgin serisi ile özel olmanın ayrıcalığını hissedecek, seramikten yansıyan ışıkla hayat bulacaksınız</span>",
    "descriptionClean": "Özel mekânlara, özel dokunuşlar... Virgin serisi ile özel olmanın ayrıcalığını hissedecek, seramikten yansıyan ışıkla hayat bulacaksınız",
    "source": "duratiles"
  },
  {
    "id": "dura_421",
    "brand": "Duratiles",
    "title": "VIRGIN Siyah 60x120",
    "seriesName": "VIRGIN",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "421",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.018044892329564854.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.018044892329564854.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Özel mekânlara, özel dokunuşlar... Virgin serisi ile özel olmanın ayrıcalığını hissedecek, seramikten yansıyan ışıkla hayat bulacaksınız</span>",
    "descriptionClean": "Özel mekânlara, özel dokunuşlar... Virgin serisi ile özel olmanın ayrıcalığını hissedecek, seramikten yansıyan ışıkla hayat bulacaksınız",
    "source": "duratiles"
  },
  {
    "id": "dura_424",
    "brand": "Duratiles",
    "title": "VOGUE Bruciato 15x90",
    "seriesName": "VOGUE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "424",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1003072841607554.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1003072841607554.jpg"
    ],
    "size": "15x90",
    "color": "Bruciato",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mat yüzeyi ,ahşap dokusu ile Vogue Serisi gri tonların mistik gizemini yaşam alanlarınıza taşıyarak ,stil sahibi modern alanlar yaratıyor</span>",
    "descriptionClean": "Mat yüzeyi ,ahşap dokusu ile Vogue Serisi gri tonların mistik gizemini yaşam alanlarınıza taşıyarak ,stil sahibi modern alanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_425",
    "brand": "Duratiles",
    "title": "VOGUE Sabbia 15x90",
    "seriesName": "VOGUE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "62799",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1352001985747565.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1352001985747565.jpg"
    ],
    "size": "15x90",
    "color": "Sabbia",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mat yüzeyi ,ahşap dokusu ile Vogue Serisi gri tonların mistik gizemini yaşam alanlarınıza taşıyarak ,stil sahibi modern alanlar yaratıyor</span>",
    "descriptionClean": "Mat yüzeyi ,ahşap dokusu ile Vogue Serisi gri tonların mistik gizemini yaşam alanlarınıza taşıyarak ,stil sahibi modern alanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_426",
    "brand": "Duratiles",
    "title": "VOGUE Sabbia 15x60",
    "seriesName": "VOGUE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "426",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11508713842229468.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11508713842229468.jpg"
    ],
    "size": "15x60",
    "color": "Sabbia",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mat yüzeyi ,ahşap dokusu ile Vogue Serisi gri tonların mistik gizemini yaşam alanlarınıza taşıyarak ,stil sahibi modern alanlar yaratıyor</span>",
    "descriptionClean": "Mat yüzeyi ,ahşap dokusu ile Vogue Serisi gri tonların mistik gizemini yaşam alanlarınıza taşıyarak ,stil sahibi modern alanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_427",
    "brand": "Duratiles",
    "title": "VOGUE Bruciato 15x60",
    "seriesName": "VOGUE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "427",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21192705213593033.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21192705213593033.jpg"
    ],
    "size": "15x60",
    "color": "Bruciato",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mat yüzeyi ,ahşap dokusu ile Vogue Serisi gri tonların mistik gizemini yaşam alanlarınıza taşıyarak ,stil sahibi modern alanlar yaratıyor</span>",
    "descriptionClean": "Mat yüzeyi ,ahşap dokusu ile Vogue Serisi gri tonların mistik gizemini yaşam alanlarınıza taşıyarak ,stil sahibi modern alanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_428",
    "brand": "Duratiles",
    "title": "VOGUE Mocha 15x60",
    "seriesName": "VOGUE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "428",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8908823501083711.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8908823501083711.jpg"
    ],
    "size": "15x60",
    "color": "Mocha",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mat yüzeyi ,ahşap dokusu ile Vogue Serisi gri tonların mistik gizemini yaşam alanlarınıza taşıyarak ,stil sahibi modern alanlar yaratıyor</span>",
    "descriptionClean": "Mat yüzeyi ,ahşap dokusu ile Vogue Serisi gri tonların mistik gizemini yaşam alanlarınıza taşıyarak ,stil sahibi modern alanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_429",
    "brand": "Duratiles",
    "title": "VOLDIVIAN Noce 22x90",
    "seriesName": "VOLDIVIAN",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "429",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.39593967594605495.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.39593967594605495.jpg"
    ],
    "size": "22x90",
    "color": "Noce",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Endüstriyel Zemin & Ev içi Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Voldivian Porselen Karoları zamanın ötesinde bir tarz yakalamak isteyenlere hitap ediyor.</span>",
    "descriptionClean": "Voldivian Porselen Karoları zamanın ötesinde bir tarz yakalamak isteyenlere hitap ediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_430",
    "brand": "Duratiles",
    "title": "VOLDIVIAN Bej 22x90",
    "seriesName": "VOLDIVIAN",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "430",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6536347833248372.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6536347833248372.jpg"
    ],
    "size": "22x90",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Voldivian Porselen Karoları zamanın ötesinde bir tarz yakalamak isteyenlere hitap ediyor.</span>",
    "descriptionClean": "Voldivian Porselen Karoları zamanın ötesinde bir tarz yakalamak isteyenlere hitap ediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_431",
    "brand": "Duratiles",
    "title": "VOLDIVIAN Kahve 22x90",
    "seriesName": "VOLDIVIAN",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "431",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6536946768469489.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6536946768469489.jpg"
    ],
    "size": "22x90",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Voldivian Porselen Karoları zamanın ötesinde bir tarz yakalamak isteyenlere hitap ediyor.</span>",
    "descriptionClean": "Voldivian Porselen Karoları zamanın ötesinde bir tarz yakalamak isteyenlere hitap ediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_432",
    "brand": "Duratiles",
    "title": "VOLDIVIAN Gri 22x90",
    "seriesName": "VOLDIVIAN",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "432",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.42043643243536444.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.42043643243536444.jpg"
    ],
    "size": "22x90",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Voldivian Porselen Karoları zamanın ötesinde bir tarz yakalamak isteyenlere hitap ediyor.</span>",
    "descriptionClean": "Voldivian Porselen Karoları zamanın ötesinde bir tarz yakalamak isteyenlere hitap ediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_433",
    "brand": "Duratiles",
    "title": "WILLOW Beyaz 15x60",
    "seriesName": "WILLOW",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "433",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.39628998409905325.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.39628998409905325.jpg"
    ],
    "size": "15x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Willow Serisi yaşam alanlarınıza karakteristik bir görünüm kazandırarak farklı olmanın dekoratif yollarını sunuyor.</span>",
    "descriptionClean": "Willow Serisi yaşam alanlarınıza karakteristik bir görünüm kazandırarak farklı olmanın dekoratif yollarını sunuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_434",
    "brand": "Duratiles",
    "title": "WILLOW Karamel 15x60",
    "seriesName": "WILLOW",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "434",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3599690661055265.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3599690661055265.jpg"
    ],
    "size": "15x60",
    "color": "Karamel",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Willow Serisi yaşam alanlarınıza karakteristik bir görünüm kazandırarak farklı olmanın dekoratif yollarını sunuyor.</span>",
    "descriptionClean": "Willow Serisi yaşam alanlarınıza karakteristik bir görünüm kazandırarak farklı olmanın dekoratif yollarını sunuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_435",
    "brand": "Duratiles",
    "title": "WOOD Cappucino 15x60",
    "seriesName": "WOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "435",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36128668727354873.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36128668727354873.jpg"
    ],
    "size": "15x60",
    "color": "Cappucino",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Özel mekânlara, özel dokunuşlar... Wood serisi ile özel olmanın ayrıcalığını hissedecek, seramikten yansıyan ışıkla hayat bulacaksınız</span>",
    "descriptionClean": "Özel mekânlara, özel dokunuşlar... Wood serisi ile özel olmanın ayrıcalığını hissedecek, seramikten yansıyan ışıkla hayat bulacaksınız",
    "source": "duratiles"
  },
  {
    "id": "dura_436",
    "brand": "Duratiles",
    "title": "WOOD Gri 15x60",
    "seriesName": "WOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "436",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1738034692348579.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1738034692348579.jpg"
    ],
    "size": "15x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "V3",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Özel mekânlara, özel dokunuşlar... Wood serisi ile özel olmanın ayrıcalığını hissedecek, seramikten yansıyan ışıkla hayat bulacaksınız</span>",
    "descriptionClean": "Özel mekânlara, özel dokunuşlar... Wood serisi ile özel olmanın ayrıcalığını hissedecek, seramikten yansıyan ışıkla hayat bulacaksınız",
    "source": "duratiles"
  },
  {
    "id": "dura_437",
    "brand": "Duratiles",
    "title": "WOOD Latte 15x60",
    "seriesName": "WOOD",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "437",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2003062084628916.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2003062084628916.jpg"
    ],
    "size": "15x60",
    "color": "Latte",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "V3",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Özel mekânlara, özel dokunuşlar... Wood serisi ile özel olmanın ayrıcalığını hissedecek, seramikten yansıyan ışıkla hayat bulacaksınız</span>",
    "descriptionClean": "Özel mekânlara, özel dokunuşlar... Wood serisi ile özel olmanın ayrıcalığını hissedecek, seramikten yansıyan ışıkla hayat bulacaksınız",
    "source": "duratiles"
  },
  {
    "id": "dura_438",
    "brand": "Duratiles",
    "title": "WOODLAND Bianco 33x33",
    "seriesName": "WOODLAND",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "438",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.331095039399696.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.331095039399696.jpg"
    ],
    "size": "33x33",
    "color": "Bianco",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Duvar ve Yer Seramiği",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V4"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Woodland Porselen Karoları ,ahşap dokusunun sunduğu natürel atmosfer ile seramiğin avantajlarını bir araya getirerek yaşam alanlarına katma değer katıyor</span>",
    "descriptionClean": "Woodland Porselen Karoları ,ahşap dokusunun sunduğu natürel atmosfer ile seramiğin avantajlarını bir araya getirerek yaşam alanlarına katma değer katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_439",
    "brand": "Duratiles",
    "title": "WOODLAND Nut 33x33",
    "seriesName": "WOODLAND",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "439",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8422449710319194.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8422449710319194.jpg"
    ],
    "size": "33x33",
    "color": "Nut",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Duvar ve Yer Seramiği",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V4"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Woodland Porselen Karoları ,ahşap dokusunun sunduğu natürel atmosfer ile seramiğin avantajlarını bir araya getirerek yaşam alanlarına katma değer katıyor</span>",
    "descriptionClean": "Woodland Porselen Karoları ,ahşap dokusunun sunduğu natürel atmosfer ile seramiğin avantajlarını bir araya getirerek yaşam alanlarına katma değer katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_440",
    "brand": "Duratiles",
    "title": "WOODLAND Gri 33x33",
    "seriesName": "WOODLAND",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "440",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.41806620688561325.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.41806620688561325.jpg"
    ],
    "size": "33x33",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Duvar ve Yer Seramiği",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V4"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Woodland Porselen Karoları ,ahşap dokusunun sunduğu natürel atmosfer ile seramiğin avantajlarını bir araya getirerek yaşam alanlarına katma değer katıyor</span>",
    "descriptionClean": "Woodland Porselen Karoları ,ahşap dokusunun sunduğu natürel atmosfer ile seramiğin avantajlarını bir araya getirerek yaşam alanlarına katma değer katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_119",
    "brand": "Duratiles",
    "title": "AMARO Beyaz 60x60",
    "seriesName": "AMARO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "63476",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5321058657865283.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5321058657865283.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Teknik Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amaro Serisi sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve dayanıklıdır.</span>",
    "descriptionClean": "Amaro Serisi sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve dayanıklıdır.",
    "source": "duratiles"
  },
  {
    "id": "dura_441",
    "brand": "Duratiles",
    "title": "AMARO Bej 60x60",
    "seriesName": "AMARO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "62559",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.620954024024731.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.620954024024731.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Teknik Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amaro Serisi sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve dayanıklıdır.</span>",
    "descriptionClean": "Amaro Serisi sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve dayanıklıdır.",
    "source": "duratiles"
  },
  {
    "id": "dura_442",
    "brand": "Duratiles",
    "title": "AMARO Gri 60x60",
    "seriesName": "AMARO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "62537",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7129465147277746.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7129465147277746.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Teknik Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amaro Serisi sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve dayanıklıdır.</span>",
    "descriptionClean": "Amaro Serisi sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve dayanıklıdır.",
    "source": "duratiles"
  },
  {
    "id": "dura_443",
    "brand": "Duratiles",
    "title": "AMARO Antrasit 60x60",
    "seriesName": "AMARO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "443",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.45560805352545786.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.45560805352545786.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Teknik Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amaro Serisi sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve dayanıklıdır.</span>",
    "descriptionClean": "Amaro Serisi sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve dayanıklıdır.",
    "source": "duratiles"
  },
  {
    "id": "dura_445",
    "brand": "Duratiles",
    "title": "ANTAYLA Gri 60x60",
    "seriesName": "ANTAYLA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "29144",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14634583373779242.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14634583373779242.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Teknik Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Antayla Serisi yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.</span>",
    "descriptionClean": "Antayla Serisi yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_444",
    "brand": "Duratiles",
    "title": "ANTAYLA Kahve 60x60",
    "seriesName": "ANTAYLA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "12001",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4239060913964111.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4239060913964111.jpg"
    ],
    "size": "60x60",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Teknik Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Antayla Serisi yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.</span>",
    "descriptionClean": "Antayla Serisi yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_446",
    "brand": "Duratiles",
    "title": "ANTAYLA Bone 60x60",
    "seriesName": "ANTAYLA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "446",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.854124968830972.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.854124968830972.jpg"
    ],
    "size": "60x60",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Teknik Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Antayla Serisi yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.</span>",
    "descriptionClean": "Antayla Serisi yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_447",
    "brand": "Duratiles",
    "title": "ARDESIA Gri 60x60",
    "seriesName": "ARDESIA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "447",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7105772882540944.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7105772882540944.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar & Banyo",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor</span>",
    "descriptionClean": "Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_465",
    "brand": "Duratiles",
    "title": "ATLANTA Antrasit 40x40",
    "seriesName": "ATLANTA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "465",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.39237970942076483.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.39237970942076483.jpg"
    ],
    "size": "40x40",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor</span>",
    "descriptionClean": "Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_464",
    "brand": "Duratiles",
    "title": "ATLANTA Koyu Gri 40x40",
    "seriesName": "ATLANTA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "464",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7937325891663026.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7937325891663026.jpg"
    ],
    "size": "40x40",
    "color": "Koyu Gri",
    "surface": "Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor</span>",
    "descriptionClean": "Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_461",
    "brand": "Duratiles",
    "title": "ATLANTA Koyu Gri 40x80",
    "seriesName": "ATLANTA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "461",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.49173400325255856.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.49173400325255856.jpg"
    ],
    "size": "40x80",
    "color": "Koyu Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor</span>",
    "descriptionClean": "Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_460",
    "brand": "Duratiles",
    "title": "ATLANTA Antrasit 40x80",
    "seriesName": "ATLANTA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "460",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.34222984282353097.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.34222984282353097.jpg"
    ],
    "size": "40x80",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor</span>",
    "descriptionClean": "Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_449",
    "brand": "Duratiles",
    "title": "ATLANTA Koyu Gri 45x90",
    "seriesName": "ATLANTA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "449",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12758430299382273.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12758430299382273.jpg"
    ],
    "size": "45x90",
    "color": "Koyu Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor</span>",
    "descriptionClean": "Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_448",
    "brand": "Duratiles",
    "title": "ATLANTA Antrasit 45x90",
    "seriesName": "ATLANTA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "448",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07412709350110191.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07412709350110191.jpg"
    ],
    "size": "45x90",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor</span>",
    "descriptionClean": "Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_463",
    "brand": "Duratiles",
    "title": "ATLANTA Koyu Gri 60x60",
    "seriesName": "ATLANTA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "463",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44089522716014684.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44089522716014684.jpg"
    ],
    "size": "60x60",
    "color": "Koyu Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor</span>",
    "descriptionClean": "Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_462",
    "brand": "Duratiles",
    "title": "ATLANTA Antrasit 60x60",
    "seriesName": "ATLANTA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "462",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21853841727022028.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21853841727022028.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor</span>",
    "descriptionClean": "Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_451",
    "brand": "Duratiles",
    "title": "ATLANTA Koyu Gri 60x90",
    "seriesName": "ATLANTA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "451",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9689871473723995.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9689871473723995.jpg"
    ],
    "size": "60x90",
    "color": "Koyu Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor</span>",
    "descriptionClean": "Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_450",
    "brand": "Duratiles",
    "title": "ATLANTA Antrasit 60x90",
    "seriesName": "ATLANTA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "450",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5575595781783949.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5575595781783949.jpg"
    ],
    "size": "60x90",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor</span>",
    "descriptionClean": "Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_459",
    "brand": "Duratiles",
    "title": "ATLANTA Koyu Gri 80x80",
    "seriesName": "ATLANTA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "459",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8802605171125121.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8802605171125121.jpg"
    ],
    "size": "80x80",
    "color": "Koyu Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor</span>",
    "descriptionClean": "Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_458",
    "brand": "Duratiles",
    "title": "ATLANTA Antrasit 80x80",
    "seriesName": "ATLANTA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "458",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28746015444246487.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28746015444246487.jpg"
    ],
    "size": "80x80",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor</span>",
    "descriptionClean": "Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_457",
    "brand": "Duratiles",
    "title": "ATLANTA Koyu Gri 30x120",
    "seriesName": "ATLANTA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "457",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7605715626521818.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7605715626521818.jpg"
    ],
    "size": "30x120",
    "color": "Koyu Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor</span>",
    "descriptionClean": "Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_456",
    "brand": "Duratiles",
    "title": "ATLANTA Antrasit 30x120",
    "seriesName": "ATLANTA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "456",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.024409129294956866.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.024409129294956866.jpg"
    ],
    "size": "30x120",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor</span>",
    "descriptionClean": "Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_455",
    "brand": "Duratiles",
    "title": "ATLANTA Koyu Gri 40x120",
    "seriesName": "ATLANTA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "455",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.45859807062943914.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.45859807062943914.jpg"
    ],
    "size": "40x120",
    "color": "Koyu Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor</span>",
    "descriptionClean": "Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_454",
    "brand": "Duratiles",
    "title": "ATLANTA Antrasit 40x120",
    "seriesName": "ATLANTA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "454",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9271940846314563.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9271940846314563.jpg"
    ],
    "size": "40x120",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor</span>",
    "descriptionClean": "Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_453",
    "brand": "Duratiles",
    "title": "ATLANTA Koyu Gri 60x120",
    "seriesName": "ATLANTA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "453",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9124203483072616.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9124203483072616.jpg"
    ],
    "size": "60x120",
    "color": "Koyu Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor</span>",
    "descriptionClean": "Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_452",
    "brand": "Duratiles",
    "title": "ATLANTA Antrasit 60x120",
    "seriesName": "ATLANTA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "452",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7013616288311881.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7013616288311881.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor</span>",
    "descriptionClean": "Ardesia Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_483",
    "brand": "Duratiles",
    "title": "AUTOMIUM Gri 40x40",
    "seriesName": "AUTOMIUM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "483",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.41781444839934745.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.41781444839934745.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.</span>",
    "descriptionClean": "Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_482",
    "brand": "Duratiles",
    "title": "AUTOMIUM Antrasit 40x40",
    "seriesName": "AUTOMIUM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "482",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9711739458039713.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9711739458039713.jpg"
    ],
    "size": "40x40",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.</span>",
    "descriptionClean": "Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_481",
    "brand": "Duratiles",
    "title": "AUTOMIUM Gri 60x60",
    "seriesName": "AUTOMIUM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "481",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.05369093542972292.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.05369093542972292.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.</span>",
    "descriptionClean": "Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_480",
    "brand": "Duratiles",
    "title": "AUTOMIUM Antrasit 60x60",
    "seriesName": "AUTOMIUM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "480",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4486406167736272.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4486406167736272.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.</span>",
    "descriptionClean": "Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_479",
    "brand": "Duratiles",
    "title": "AUTOMIUM Gri 40x80",
    "seriesName": "AUTOMIUM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "479",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.291094042245279.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.291094042245279.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.</span>",
    "descriptionClean": "Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_478",
    "brand": "Duratiles",
    "title": "AUTOMIUM Antrasit 40x80",
    "seriesName": "AUTOMIUM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "478",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4844778661731449.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4844778661731449.jpg"
    ],
    "size": "40x80",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.</span>",
    "descriptionClean": "Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_477",
    "brand": "Duratiles",
    "title": "AUTOMIUM Gri 80x80",
    "seriesName": "AUTOMIUM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "477",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9736841166242799.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9736841166242799.jpg"
    ],
    "size": "80x80",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.</span>",
    "descriptionClean": "Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_476",
    "brand": "Duratiles",
    "title": "AUTOMIUM Antrasit 80x80",
    "seriesName": "AUTOMIUM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "476",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3834391754552783.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3834391754552783.jpg"
    ],
    "size": "80x80",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.</span>",
    "descriptionClean": "Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_475",
    "brand": "Duratiles",
    "title": "AUTOMIUM Gri 30x120",
    "seriesName": "AUTOMIUM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "475",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7721943758037526.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7721943758037526.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.</span>",
    "descriptionClean": "Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_474",
    "brand": "Duratiles",
    "title": "AUTOMIUM Antrasit 30x120",
    "seriesName": "AUTOMIUM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "474",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28438027302283253.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28438027302283253.jpg"
    ],
    "size": "30x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.</span>",
    "descriptionClean": "Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_473",
    "brand": "Duratiles",
    "title": "AUTOMIUM Gri 40x120",
    "seriesName": "AUTOMIUM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "473",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4003610428633997.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4003610428633997.jpg"
    ],
    "size": "40x120",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.</span>",
    "descriptionClean": "Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_472",
    "brand": "Duratiles",
    "title": "AUTOMIUM Antrasit 40x120",
    "seriesName": "AUTOMIUM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "472",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5491030506365746.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5491030506365746.jpg"
    ],
    "size": "40x120",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.</span>",
    "descriptionClean": "Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_471",
    "brand": "Duratiles",
    "title": "AUTOMIUM Gri 60x120",
    "seriesName": "AUTOMIUM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "471",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1961096555222791.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1961096555222791.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.</span>",
    "descriptionClean": "Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_470",
    "brand": "Duratiles",
    "title": "AUTOMIUM Antrasit 60x120",
    "seriesName": "AUTOMIUM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "470",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.503562633139967.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.503562633139967.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.</span>",
    "descriptionClean": "Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_469",
    "brand": "Duratiles",
    "title": "AUTOMIUM Gri 60x90",
    "seriesName": "AUTOMIUM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "469",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7058056129560977.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7058056129560977.jpg"
    ],
    "size": "60x90",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.</span>",
    "descriptionClean": "Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_468",
    "brand": "Duratiles",
    "title": "AUTOMIUM Antrasit 60x90",
    "seriesName": "AUTOMIUM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "468",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.735101710230512.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.735101710230512.jpg"
    ],
    "size": "60x90",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.</span>",
    "descriptionClean": "Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_467",
    "brand": "Duratiles",
    "title": "AUTOMIUM Gri 45x90",
    "seriesName": "AUTOMIUM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "467",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5819929025608409.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5819929025608409.jpg"
    ],
    "size": "45x90",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.</span>",
    "descriptionClean": "Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_466",
    "brand": "Duratiles",
    "title": "AUTOMIUM Antrasit 45x90",
    "seriesName": "AUTOMIUM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "466",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2442125062600501.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2442125062600501.jpg"
    ],
    "size": "45x90",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.</span>",
    "descriptionClean": "Mükemmel teknik performansının yanı sıra konut ve ticari yerler için çok yönlü ve çağdaş bir tarz sunan Automıum Serisi gri ve antrasit renk alternatifi ile zamansız mekanlar yaratmanıza olanak sağlar. Garajlar, araba yolları , giriş rampaları gibi pek çok yerde gönül rahatlığı içinde kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_488",
    "brand": "Duratiles",
    "title": "AVOLA Koyu Gri 120x120",
    "seriesName": "AVOLA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "488",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7337818396050926.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7337818396050926.jpg"
    ],
    "size": "120x120",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Ticari Alanlar & Banyo & Endüstriyel Zemin",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Banyo",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Endüstriyel görünümüyle mükemmeliyetçi çizgiden ayrılmayanların tercihi olan Avola Serisi dört farklı renk seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "Endüstriyel görünümüyle mükemmeliyetçi çizgiden ayrılmayanların tercihi olan Avola Serisi dört farklı renk seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_485",
    "brand": "Duratiles",
    "title": "AVOLA Koyu Gri 60x120",
    "seriesName": "AVOLA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "485",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4724028586386859.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4724028586386859.jpg"
    ],
    "size": "60x120",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Ticari Alanlar & Banyo",
    "technology": "Granit",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Endüstriyel görünümüyle mükemmeliyetçi çizgiden ayrılmayanların tercihi olan Avola Serisi dört farklı renk seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "Endüstriyel görünümüyle mükemmeliyetçi çizgiden ayrılmayanların tercihi olan Avola Serisi dört farklı renk seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_486",
    "brand": "Duratiles",
    "title": "AVOLA Vison 60x120",
    "seriesName": "AVOLA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "486",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6642740981566057.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6642740981566057.jpg"
    ],
    "size": "60x120",
    "color": "Vison",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Ticari Alanlar & Banyo",
    "technology": "Granit",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Endüstriyel görünümüyle mükemmeliyetçi çizgiden ayrılmayanların tercihi olan Avola Serisi dört farklı renk seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "Endüstriyel görünümüyle mükemmeliyetçi çizgiden ayrılmayanların tercihi olan Avola Serisi dört farklı renk seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_484",
    "brand": "Duratiles",
    "title": "AVOLA Açık Gri 60x120",
    "seriesName": "AVOLA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "484",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4270552734547213.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4270552734547213.jpg"
    ],
    "size": "60x120",
    "color": "Açık Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Ticari Alanlar & Banyo",
    "technology": "Granit",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Endüstriyel görünümüyle mükemmeliyetçi çizgiden ayrılmayanların tercihi olan Avola Serisi dört farklı renk seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "Endüstriyel görünümüyle mükemmeliyetçi çizgiden ayrılmayanların tercihi olan Avola Serisi dört farklı renk seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_487",
    "brand": "Duratiles",
    "title": "AVOLA Koyu Gri 120x120",
    "seriesName": "AVOLA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "487",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9563735029628386.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9563735029628386.jpg"
    ],
    "size": "120x120",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Ticari Alanlar & Banyo & Endüstriyel Zemin",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Banyo",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Endüstriyel görünümüyle mükemmeliyetçi çizgiden ayrılmayanların tercihi olan Avola Serisi dört farklı renk seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "Endüstriyel görünümüyle mükemmeliyetçi çizgiden ayrılmayanların tercihi olan Avola Serisi dört farklı renk seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_492",
    "brand": "Duratiles",
    "title": "AVOLA Vison 100x100",
    "seriesName": "AVOLA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "12271",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8057158890309449.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8057158890309449.jpg"
    ],
    "size": "100x100",
    "color": "Vison",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Banyo",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Endüstriyel görünümüyle mükemmeliyetçi çizgiden ayrılmayanların tercihi olan Avola Serisi dört farklı renk seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "Endüstriyel görünümüyle mükemmeliyetçi çizgiden ayrılmayanların tercihi olan Avola Serisi dört farklı renk seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_491",
    "brand": "Duratiles",
    "title": "AVOLA Açık Gri 100x100",
    "seriesName": "AVOLA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "71857",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6361829778134646.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6361829778134646.jpg"
    ],
    "size": "100x100",
    "color": "Açık Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Endüstriyel görünümüyle mükemmeliyetçi çizgiden ayrılmayanların tercihi olan Avola Serisi dört farklı renk seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "Endüstriyel görünümüyle mükemmeliyetçi çizgiden ayrılmayanların tercihi olan Avola Serisi dört farklı renk seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_490",
    "brand": "Duratiles",
    "title": "AVOLA Koyu Gri 100x100",
    "seriesName": "AVOLA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "490",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.31971756394422757.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.31971756394422757.jpg"
    ],
    "size": "100x100",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin & Banyo & Balkon/Teras",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Banyo",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Endüstriyel görünümüyle mükemmeliyetçi çizgiden ayrılmayanların tercihi olan Avola Serisi dört farklı renk seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "Endüstriyel görünümüyle mükemmeliyetçi çizgiden ayrılmayanların tercihi olan Avola Serisi dört farklı renk seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_489",
    "brand": "Duratiles",
    "title": "AVOLA Vison 120x120",
    "seriesName": "AVOLA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "489",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40938391976786126.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40938391976786126.jpg"
    ],
    "size": "120x120",
    "color": "Vison",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin & Banyo",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Banyo",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Endüstriyel görünümüyle mükemmeliyetçi çizgiden ayrılmayanların tercihi olan Avola Serisi dört farklı renk seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "Endüstriyel görünümüyle mükemmeliyetçi çizgiden ayrılmayanların tercihi olan Avola Serisi dört farklı renk seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_493",
    "brand": "Duratiles",
    "title": "AZZURO Mavi 60x60",
    "seriesName": "AZZURO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "10919",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9932620123654131.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9932620123654131.jpg"
    ],
    "size": "60x60",
    "color": "Mavi",
    "surface": "Color Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Banyo & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Banyo",
      "Havuz",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Uygulandığı alanlarda stil sahibi bir tasarım anlayışının altını çizen Azurro Porselen Karoları kusursuz modern yaşam alanlarının vazgeçilmezi olmaya aday.</span>",
    "descriptionClean": "Uygulandığı alanlarda stil sahibi bir tasarım anlayışının altını çizen Azurro Porselen Karoları kusursuz modern yaşam alanlarının vazgeçilmezi olmaya aday.",
    "source": "duratiles"
  },
  {
    "id": "dura_494",
    "brand": "Duratiles",
    "title": "AZZURO Siyah 60x60",
    "seriesName": "AZZURO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "11605",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09877496896995974.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09877496896995974.jpg"
    ],
    "size": "60x60",
    "color": "Siyah",
    "surface": "Color Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Banyo & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Banyo",
      "Havuz",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Uygulandığı alanlarda stil sahibi bir tasarım anlayışının altını çizen Azurro Porselen Karoları kusursuz modern yaşam alanlarının vazgeçilmezi olmaya aday.</span>",
    "descriptionClean": "Uygulandığı alanlarda stil sahibi bir tasarım anlayışının altını çizen Azurro Porselen Karoları kusursuz modern yaşam alanlarının vazgeçilmezi olmaya aday.",
    "source": "duratiles"
  },
  {
    "id": "dura_506",
    "brand": "Duratiles",
    "title": "BASIC Sand 30x60",
    "seriesName": "BASIC",
    "collection": "Beton",
    "category": "Beton",
    "sku": "506",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19516999492017417.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19516999492017417.jpg"
    ],
    "size": "30x60",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Banyo & Ev içi Zemin & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V3",
      "Banyo",
      "Ev İçi Zemin",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.</span>",
    "descriptionClean": "Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_505",
    "brand": "Duratiles",
    "title": "BASIC Grau 30x60",
    "seriesName": "BASIC",
    "collection": "Beton",
    "category": "Beton",
    "sku": "505",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48235352021944333.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48235352021944333.jpg"
    ],
    "size": "30x60",
    "color": "Grau",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.</span>",
    "descriptionClean": "Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_504",
    "brand": "Duratiles",
    "title": "BASIC Antrasit 30x60",
    "seriesName": "BASIC",
    "collection": "Beton",
    "category": "Beton",
    "sku": "504",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23591104815521202.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23591104815521202.jpg"
    ],
    "size": "30x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V3",
      "Dış Cephe",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.</span>",
    "descriptionClean": "Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_503",
    "brand": "Duratiles",
    "title": "BASIC Sand 60x60",
    "seriesName": "BASIC",
    "collection": "Beton",
    "category": "Beton",
    "sku": "503",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.060463930244530784.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.060463930244530784.jpg"
    ],
    "size": "60x60",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.</span>",
    "descriptionClean": "Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_502",
    "brand": "Duratiles",
    "title": "BASIC Grau 60x60",
    "seriesName": "BASIC",
    "collection": "Beton",
    "category": "Beton",
    "sku": "502",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2785835831068436.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2785835831068436.jpg"
    ],
    "size": "60x60",
    "color": "Grau",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.</span>",
    "descriptionClean": "Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_501",
    "brand": "Duratiles",
    "title": "BASIC Antrasit 60x60",
    "seriesName": "BASIC",
    "collection": "Beton",
    "category": "Beton",
    "sku": "501",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48331851014621163.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48331851014621163.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.</span>",
    "descriptionClean": "Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_500",
    "brand": "Duratiles",
    "title": "BASIC Sand 100x100",
    "seriesName": "BASIC",
    "collection": "Beton",
    "category": "Beton",
    "sku": "500",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.27235603737191605.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.27235603737191605.jpg"
    ],
    "size": "100x100",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.</span>",
    "descriptionClean": "Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_499",
    "brand": "Duratiles",
    "title": "BASIC Grau 100x100",
    "seriesName": "BASIC",
    "collection": "Beton",
    "category": "Beton",
    "sku": "499",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7317359781500216.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7317359781500216.jpg"
    ],
    "size": "100x100",
    "color": "Grau",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.</span>",
    "descriptionClean": "Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_498",
    "brand": "Duratiles",
    "title": "BASIC Antrasit 100x100",
    "seriesName": "BASIC",
    "collection": "Beton",
    "category": "Beton",
    "sku": "498",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9623221996948482.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9623221996948482.jpg"
    ],
    "size": "100x100",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.</span>",
    "descriptionClean": "Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_497",
    "brand": "Duratiles",
    "title": "BASIC Sand 60x120",
    "seriesName": "BASIC",
    "collection": "Beton",
    "category": "Beton",
    "sku": "497",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.04179683793925315.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.04179683793925315.jpg"
    ],
    "size": "60x120",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.</span>",
    "descriptionClean": "Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_496",
    "brand": "Duratiles",
    "title": "BASIC Grau 60x120",
    "seriesName": "BASIC",
    "collection": "Beton",
    "category": "Beton",
    "sku": "496",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.06119129074839569.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.06119129074839569.jpg"
    ],
    "size": "60x120",
    "color": "Grau",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.</span>",
    "descriptionClean": "Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_495",
    "brand": "Duratiles",
    "title": "BASIC Antrasit 60x120",
    "seriesName": "BASIC",
    "collection": "Beton",
    "category": "Beton",
    "sku": "495",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9478452727438788.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9478452727438788.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.</span>",
    "descriptionClean": "Geniş ürün yelpazesi , beton görünümü ve mat yüzeyi ile Basic Serisi sıradanlığa meydan okuyor. Konforu fonksiyonellikle birleştiren Basic Serisi ile göz alıcı mekanlar yaratabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_507",
    "brand": "Duratiles",
    "title": "BATUM Bianco 60x120",
    "seriesName": "BATUM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "507",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.261084083633941.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.261084083633941.jpg"
    ],
    "size": "60x120",
    "color": "Bianco",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Banyo & Ev içi Zemin & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V3",
      "Banyo",
      "Ev İçi Zemin",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Batum Porselen Karoları ...</span>",
    "descriptionClean": "Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Batum Porselen Karoları ...",
    "source": "duratiles"
  },
  {
    "id": "dura_508",
    "brand": "Duratiles",
    "title": "BATUM Noce 60x120",
    "seriesName": "BATUM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "508",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5762501809037521.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5762501809037521.jpg"
    ],
    "size": "60x120",
    "color": "Noce",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "V3",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Batum Porselen Karoları ...</span>",
    "descriptionClean": "Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Batum Porselen Karoları ...",
    "source": "duratiles"
  },
  {
    "id": "dura_509",
    "brand": "Duratiles",
    "title": "BELGİAN BLUE Bianco 45x90",
    "seriesName": "BELGİAN BLUE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "509",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.994084896487353.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.994084896487353.jpg"
    ],
    "size": "45x90",
    "color": "Bianco",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Belgian Blue Serisi yüksek kaliteli görünümü ve teknik özellikleri sayesinde insan trafiği çok olan alanların ilk tercihi. Farklı ebat ve kalınlık alternatifi sunan seri , yaşam alanlarında kendi sade çizgilerini kullanmak isteyenlere dekoratif çözümler sunmakta.</span>",
    "descriptionClean": "Belgian Blue Serisi yüksek kaliteli görünümü ve teknik özellikleri sayesinde insan trafiği çok olan alanların ilk tercihi. Farklı ebat ve kalınlık alternatifi sunan seri , yaşam alanlarında kendi sade çizgilerini kullanmak isteyenlere dekoratif çözümler sunmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_510",
    "brand": "Duratiles",
    "title": "BELGİAN BLUE Koyu Gri 60x90",
    "seriesName": "BELGİAN BLUE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "510",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.902889962906447.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.902889962906447.jpg"
    ],
    "size": "60x90",
    "color": "Koyu Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Belgian Blue Serisi yüksek kaliteli görünümü ve teknik özellikleri sayesinde insan trafiği çok olan alanların ilk tercihi. Farklı ebat ve kalınlık alternatifi sunan seri , yaşam alanlarında kendi sade çizgilerini kullanmak isteyenlere dekoratif çözümler sunmakta.</span>",
    "descriptionClean": "Belgian Blue Serisi yüksek kaliteli görünümü ve teknik özellikleri sayesinde insan trafiği çok olan alanların ilk tercihi. Farklı ebat ve kalınlık alternatifi sunan seri , yaşam alanlarında kendi sade çizgilerini kullanmak isteyenlere dekoratif çözümler sunmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_511",
    "brand": "Duratiles",
    "title": "BELGİAN BLUE Koyu Gri 60x120",
    "seriesName": "BELGİAN BLUE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "511",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09277956159081224.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09277956159081224.jpg"
    ],
    "size": "60x120",
    "color": "Koyu Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Belgian Blue Serisi yüksek kaliteli görünümü ve teknik özellikleri sayesinde insan trafiği çok olan alanların ilk tercihi. Farklı ebat ve kalınlık alternatifi sunan seri , yaşam alanlarında kendi sade çizgilerini kullanmak isteyenlere dekoratif çözümler sunmakta.</span>",
    "descriptionClean": "Belgian Blue Serisi yüksek kaliteli görünümü ve teknik özellikleri sayesinde insan trafiği çok olan alanların ilk tercihi. Farklı ebat ve kalınlık alternatifi sunan seri , yaşam alanlarında kendi sade çizgilerini kullanmak isteyenlere dekoratif çözümler sunmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_2330",
    "brand": "Duratiles",
    "title": "BELGİAN BLUE Koyu Gri 40x120",
    "seriesName": "BELGİAN BLUE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2330",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.42367776207538477.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.42367776207538477.jpg"
    ],
    "size": "40x120",
    "color": "Koyu Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Belgian Blue Serisi yüksek kaliteli görünümü ve teknik özellikleri sayesinde insan trafiği çok olan alanların ilk tercihi. Farklı ebat ve kalınlık alternatifi sunan seri , yaşam alanlarında kendi sade çizgilerini kullanmak isteyenlere dekoratif çözümler sunmakta.</span>",
    "descriptionClean": "Belgian Blue Serisi yüksek kaliteli görünümü ve teknik özellikleri sayesinde insan trafiği çok olan alanların ilk tercihi. Farklı ebat ve kalınlık alternatifi sunan seri , yaşam alanlarında kendi sade çizgilerini kullanmak isteyenlere dekoratif çözümler sunmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_512",
    "brand": "Duratiles",
    "title": "BELGİAN BLUE Koyu Gri 30x120",
    "seriesName": "BELGİAN BLUE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "512",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.42367776207538477.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.42367776207538477.jpg"
    ],
    "size": "30x120",
    "color": "Koyu Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Belgian Blue Serisi yüksek kaliteli görünümü ve teknik özellikleri sayesinde insan trafiği çok olan alanların ilk tercihi. Farklı ebat ve kalınlık alternatifi sunan seri , yaşam alanlarında kendi sade çizgilerini kullanmak isteyenlere dekoratif çözümler sunmakta.</span>",
    "descriptionClean": "Belgian Blue Serisi yüksek kaliteli görünümü ve teknik özellikleri sayesinde insan trafiği çok olan alanların ilk tercihi. Farklı ebat ve kalınlık alternatifi sunan seri , yaşam alanlarında kendi sade çizgilerini kullanmak isteyenlere dekoratif çözümler sunmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_513",
    "brand": "Duratiles",
    "title": "BELGİAN BLUE Koyu Gri 80x80",
    "seriesName": "BELGİAN BLUE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "513",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4493959623364533.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4493959623364533.jpg"
    ],
    "size": "80x80",
    "color": "Koyu Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Dış Cephe & Ev içi Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Dış Cephe",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Belgian Blue Serisi yüksek kaliteli görünümü ve teknik özellikleri sayesinde insan trafiği çok olan alanların ilk tercihi. Farklı ebat ve kalınlık alternatifi sunan seri , yaşam alanlarında kendi sade çizgilerini kullanmak isteyenlere dekoratif çözümler sunmakta.</span>",
    "descriptionClean": "Belgian Blue Serisi yüksek kaliteli görünümü ve teknik özellikleri sayesinde insan trafiği çok olan alanların ilk tercihi. Farklı ebat ve kalınlık alternatifi sunan seri , yaşam alanlarında kendi sade çizgilerini kullanmak isteyenlere dekoratif çözümler sunmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_514",
    "brand": "Duratiles",
    "title": "BELGİAN BLUE Koyu Gri 40x80",
    "seriesName": "BELGİAN BLUE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "514",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2166717238914907.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2166717238914907.jpg"
    ],
    "size": "40x80",
    "color": "Koyu Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Belgian Blue Serisi yüksek kaliteli görünümü ve teknik özellikleri sayesinde insan trafiği çok olan alanların ilk tercihi. Farklı ebat ve kalınlık alternatifi sunan seri , yaşam alanlarında kendi sade çizgilerini kullanmak isteyenlere dekoratif çözümler sunmakta.</span>",
    "descriptionClean": "Belgian Blue Serisi yüksek kaliteli görünümü ve teknik özellikleri sayesinde insan trafiği çok olan alanların ilk tercihi. Farklı ebat ve kalınlık alternatifi sunan seri , yaşam alanlarında kendi sade çizgilerini kullanmak isteyenlere dekoratif çözümler sunmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_515",
    "brand": "Duratiles",
    "title": "BELGİAN BLUE Koyu Gri 60x60",
    "seriesName": "BELGİAN BLUE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "515",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7256338585854161.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7256338585854161.jpg"
    ],
    "size": "60x60",
    "color": "Koyu Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Belgian Blue Serisi yüksek kaliteli görünümü ve teknik özellikleri sayesinde insan trafiği çok olan alanların ilk tercihi. Farklı ebat ve kalınlık alternatifi sunan seri , yaşam alanlarında kendi sade çizgilerini kullanmak isteyenlere dekoratif çözümler sunmakta.</span>",
    "descriptionClean": "Belgian Blue Serisi yüksek kaliteli görünümü ve teknik özellikleri sayesinde insan trafiği çok olan alanların ilk tercihi. Farklı ebat ve kalınlık alternatifi sunan seri , yaşam alanlarında kendi sade çizgilerini kullanmak isteyenlere dekoratif çözümler sunmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_516",
    "brand": "Duratiles",
    "title": "BELGİAN BLUE Koyu Gri 40x40",
    "seriesName": "BELGİAN BLUE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "516",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6568613232170191.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6568613232170191.jpg"
    ],
    "size": "40x40",
    "color": "Koyu Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Belgian Blue Serisi yüksek kaliteli görünümü ve teknik özellikleri sayesinde insan trafiği çok olan alanların ilk tercihi. Farklı ebat ve kalınlık alternatifi sunan seri , yaşam alanlarında kendi sade çizgilerini kullanmak isteyenlere dekoratif çözümler sunmakta.</span>",
    "descriptionClean": "Belgian Blue Serisi yüksek kaliteli görünümü ve teknik özellikleri sayesinde insan trafiği çok olan alanların ilk tercihi. Farklı ebat ve kalınlık alternatifi sunan seri , yaşam alanlarında kendi sade çizgilerini kullanmak isteyenlere dekoratif çözümler sunmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_517",
    "brand": "Duratiles",
    "title": "BENET Grau 60x60",
    "seriesName": "BENET",
    "collection": "Beton",
    "category": "Beton",
    "sku": "74385",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03387297780626208.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03387297780626208.jpg"
    ],
    "size": "60x60",
    "color": "Grau",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Benet Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Benet Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_518",
    "brand": "Duratiles",
    "title": "BENET Taupe 60x60",
    "seriesName": "BENET",
    "collection": "Beton",
    "category": "Beton",
    "sku": "73866",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7314874028399992.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7314874028399992.jpg"
    ],
    "size": "60x60",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Benet Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Benet Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_2229",
    "brand": "Duratiles",
    "title": "BETON Soft Dark 45x90",
    "seriesName": "BETON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2229",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7425378839787368.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7425378839787368.jpg"
    ],
    "size": "45x90",
    "color": "Soft Dark",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_2230",
    "brand": "Duratiles",
    "title": "BETON Soft Mind 45x90",
    "seriesName": "BETON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2230",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.26078081842439116.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.26078081842439116.jpg"
    ],
    "size": "45x90",
    "color": "Soft Mind",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_2231",
    "brand": "Duratiles",
    "title": "BETON Soft Dark 60x90",
    "seriesName": "BETON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2231",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4965356009942431.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4965356009942431.jpg"
    ],
    "size": "60x90",
    "color": "Soft Dark",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_2232",
    "brand": "Duratiles",
    "title": "BETON Soft Mind 60x90",
    "seriesName": "BETON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2232",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.982489916659847.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.982489916659847.jpg"
    ],
    "size": "60x90",
    "color": "Soft Mind",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_2233",
    "brand": "Duratiles",
    "title": "BETON Soft Dark 60x120",
    "seriesName": "BETON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2233",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15004205027964257.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15004205027964257.jpg"
    ],
    "size": "60x120",
    "color": "Soft Dark",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_2234",
    "brand": "Duratiles",
    "title": "BETON Soft Mind 60x120",
    "seriesName": "BETON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2234",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9894579610371335.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9894579610371335.jpg"
    ],
    "size": "60x120",
    "color": "Soft Mind",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_2235",
    "brand": "Duratiles",
    "title": "BETON Soft Dark 40x120",
    "seriesName": "BETON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2235",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9771756550437042.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9771756550437042.jpg"
    ],
    "size": "40x120",
    "color": "Soft Dark",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_2236",
    "brand": "Duratiles",
    "title": "BETON Soft Mind 40x120",
    "seriesName": "BETON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2236",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8190853188509256.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8190853188509256.jpg"
    ],
    "size": "40x120",
    "color": "Soft Mind",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_2237",
    "brand": "Duratiles",
    "title": "BETON Soft Dark 30x120",
    "seriesName": "BETON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2237",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5615156461587169.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5615156461587169.jpg"
    ],
    "size": "30x120",
    "color": "Soft Dark",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_2238",
    "brand": "Duratiles",
    "title": "BETON Soft Mind 30x120",
    "seriesName": "BETON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2238",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5615156461587169.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5615156461587169.jpg"
    ],
    "size": "30x120",
    "color": "Soft Mind",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_2239",
    "brand": "Duratiles",
    "title": "BETON Soft Dark 80x80",
    "seriesName": "BETON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2239",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12231710611545799.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12231710611545799.jpg"
    ],
    "size": "80x80",
    "color": "Soft Dark",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_2240",
    "brand": "Duratiles",
    "title": "BETON Soft Mind 80x80",
    "seriesName": "BETON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2240",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48317026131202867.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48317026131202867.jpg"
    ],
    "size": "80x80",
    "color": "Soft Mind",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_2241",
    "brand": "Duratiles",
    "title": "BETON Soft Dark 40x80",
    "seriesName": "BETON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2241",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.882721247666383.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.882721247666383.jpg"
    ],
    "size": "40x80",
    "color": "Soft Dark",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_2242",
    "brand": "Duratiles",
    "title": "BETON Soft Mind 40x80",
    "seriesName": "BETON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2242",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18290623491647762.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18290623491647762.jpg"
    ],
    "size": "40x80",
    "color": "Soft Mind",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_2243",
    "brand": "Duratiles",
    "title": "BETON Soft Dark 60x60",
    "seriesName": "BETON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2243",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9560976307443776.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9560976307443776.jpg"
    ],
    "size": "60x60",
    "color": "Soft Dark",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_2244",
    "brand": "Duratiles",
    "title": "BETON Gri 60x60",
    "seriesName": "BETON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "74221",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15272033076486347.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15272033076486347.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_2245",
    "brand": "Duratiles",
    "title": "BETON Soft Dark 40x40",
    "seriesName": "BETON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2245",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2058559541636501.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2058559541636501.jpg"
    ],
    "size": "40x40",
    "color": "Soft Dark",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_2246",
    "brand": "Duratiles",
    "title": "BETON Soft Mind 40x40",
    "seriesName": "BETON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2246",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.85327849250854.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.85327849250854.jpg"
    ],
    "size": "40x40",
    "color": "Soft Mind",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Beton Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_528",
    "brand": "Duratiles",
    "title": "BORGHETTO Gri 30x60",
    "seriesName": "BORGHETTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "528",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.453603893280081.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.453603893280081.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal taşın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Borghetto serisi</span>",
    "descriptionClean": "Doğal taşın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Borghetto serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_529",
    "brand": "Duratiles",
    "title": "BORGHETTO Antrasit 30x60",
    "seriesName": "BORGHETTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "529",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8290206357447767.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8290206357447767.jpg"
    ],
    "size": "30x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal taşın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Borghetto serisi</span>",
    "descriptionClean": "Doğal taşın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Borghetto serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_531",
    "brand": "Duratiles",
    "title": "BOTTEGA Night 60x120",
    "seriesName": "BOTTEGA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "531",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.773198898156802.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.773198898156802.jpg"
    ],
    "size": "60x120",
    "color": "Night",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Bottega Porselen Karoları ,konut ve ofis projelerinde şıklığı ve işlevselliği ile hem son kullanıcılar hem de mimarlar için tasarımın önünü açıyor .</span>",
    "descriptionClean": "Bottega Porselen Karoları ,konut ve ofis projelerinde şıklığı ve işlevselliği ile hem son kullanıcılar hem de mimarlar için tasarımın önünü açıyor .",
    "source": "duratiles"
  },
  {
    "id": "dura_530",
    "brand": "Duratiles",
    "title": "BOTTEGA Siyah 60x120",
    "seriesName": "BOTTEGA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "530",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.25652872117737335.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.25652872117737335.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Bottega Porselen Karoları ,konut ve ofis projelerinde şıklığı ve işlevselliği ile hem son kullanıcılar hem de mimarlar için tasarımın önünü açıyor .</span>",
    "descriptionClean": "Bottega Porselen Karoları ,konut ve ofis projelerinde şıklığı ve işlevselliği ile hem son kullanıcılar hem de mimarlar için tasarımın önünü açıyor .",
    "source": "duratiles"
  },
  {
    "id": "dura_533",
    "brand": "Duratiles",
    "title": "BOTTEGA OXIDE Siyah 60x120",
    "seriesName": "BOTTEGA OXIDE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "533",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3079385034343429.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3079385034343429.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "Endüstriyel Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Bottega Porselen Karoları ,konut ve ofis projelerinde şıklığı ve işlevselliği ile hem son kullanıcılar hem de mimarlar için tasarımın önünü açıyor .</span>",
    "descriptionClean": "Bottega Porselen Karoları ,konut ve ofis projelerinde şıklığı ve işlevselliği ile hem son kullanıcılar hem de mimarlar için tasarımın önünü açıyor .",
    "source": "duratiles"
  },
  {
    "id": "dura_532",
    "brand": "Duratiles",
    "title": "BOTTEGA OXIDE Night 60x120",
    "seriesName": "BOTTEGA OXIDE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "532",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9358478094372621.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9358478094372621.jpg"
    ],
    "size": "60x120",
    "color": "Night",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "Endüstriyel Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Bottega Porselen Karoları ,konut ve ofis projelerinde şıklığı ve işlevselliği ile hem son kullanıcılar hem de mimarlar için tasarımın önünü açıyor .</span>",
    "descriptionClean": "Bottega Porselen Karoları ,konut ve ofis projelerinde şıklığı ve işlevselliği ile hem son kullanıcılar hem de mimarlar için tasarımın önünü açıyor .",
    "source": "duratiles"
  },
  {
    "id": "dura_534",
    "brand": "Duratiles",
    "title": "CALVINO CONCRETE Gri 60x120",
    "seriesName": "CALVINO CONCRETE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "534",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7975867173432505.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7975867173432505.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calvino Concrete Porselen Karoları zamanın ötesine geçen tarzıyla stil sahibi mekanlar yaratır.</span>",
    "descriptionClean": "Calvino Concrete Porselen Karoları zamanın ötesine geçen tarzıyla stil sahibi mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_535",
    "brand": "Duratiles",
    "title": "CAMINAR Beyaz 60x60",
    "seriesName": "CAMINAR",
    "collection": "Beton",
    "category": "Beton",
    "sku": "535",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4518965139222838.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4518965139222838.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "V3",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Uygulandığı mekâna zengin ve zarif bir görünüm kazandıran Caminar serisi ile özgün bir tasarımın mimarı olabilirsiniz.</span>",
    "descriptionClean": "Uygulandığı mekâna zengin ve zarif bir görünüm kazandıran Caminar serisi ile özgün bir tasarımın mimarı olabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_536",
    "brand": "Duratiles",
    "title": "CARINE Koyu Gri 45x90",
    "seriesName": "CARINE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "536",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4611775286875066.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4611775286875066.jpg"
    ],
    "size": "45x90",
    "color": "Koyu Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_537",
    "brand": "Duratiles",
    "title": "CARINE Açık Gri 45x90",
    "seriesName": "CARINE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "537",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8406298189852208.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8406298189852208.jpg"
    ],
    "size": "45x90",
    "color": "Açık Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_539",
    "brand": "Duratiles",
    "title": "CARINE Açık Gri 60x90",
    "seriesName": "CARINE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "539",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2810572784746239.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2810572784746239.jpg"
    ],
    "size": "60x90",
    "color": "Açık Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_538",
    "brand": "Duratiles",
    "title": "CARINE Koyu Gri 60x90",
    "seriesName": "CARINE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "538",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8966694257345893.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8966694257345893.jpg"
    ],
    "size": "60x90",
    "color": "Koyu Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_540",
    "brand": "Duratiles",
    "title": "CARINE Açık Gri 60x120",
    "seriesName": "CARINE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "540",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6444233752998303.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6444233752998303.jpg"
    ],
    "size": "60x120",
    "color": "Açık Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_541",
    "brand": "Duratiles",
    "title": "CARINE Koyu Gri 60x120",
    "seriesName": "CARINE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "541",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23044967745586953.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23044967745586953.jpg"
    ],
    "size": "60x120",
    "color": "Koyu Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_551",
    "brand": "Duratiles",
    "title": "CARINE Açık Gri 60x60",
    "seriesName": "CARINE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "551",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.363076059736377.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.363076059736377.jpg"
    ],
    "size": "60x60",
    "color": "Açık Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_550",
    "brand": "Duratiles",
    "title": "CARINE Koyu Gri 60x60",
    "seriesName": "CARINE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "550",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5887473941369697.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5887473941369697.jpg"
    ],
    "size": "60x60",
    "color": "Koyu Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_553",
    "brand": "Duratiles",
    "title": "CARINE Koyu Gri 40x40",
    "seriesName": "CARINE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "553",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4302501920961087.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4302501920961087.jpg"
    ],
    "size": "40x40",
    "color": "Koyu Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_552",
    "brand": "Duratiles",
    "title": "CARINE Açık Gri 40x40",
    "seriesName": "CARINE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "552",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9271109135687994.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9271109135687994.jpg"
    ],
    "size": "40x40",
    "color": "Açık Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_549",
    "brand": "Duratiles",
    "title": "CARINE Açık Gri 40x80",
    "seriesName": "CARINE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "549",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46498519448617714.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46498519448617714.jpg"
    ],
    "size": "40x80",
    "color": "Açık Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_548",
    "brand": "Duratiles",
    "title": "CARINE Koyu Gri 40x80",
    "seriesName": "CARINE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "548",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9688578769397509.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9688578769397509.jpg"
    ],
    "size": "40x80",
    "color": "Koyu Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_547",
    "brand": "Duratiles",
    "title": "CARINE Açık Gri 80x80",
    "seriesName": "CARINE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "547",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.041850326630965884.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.041850326630965884.jpg"
    ],
    "size": "80x80",
    "color": "Açık Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_546",
    "brand": "Duratiles",
    "title": "CARINE Koyu Gri 80x80",
    "seriesName": "CARINE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "546",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11437188796080933.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11437188796080933.jpg"
    ],
    "size": "80x80",
    "color": "Koyu Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_545",
    "brand": "Duratiles",
    "title": "CARINE Açık Gri 30x120",
    "seriesName": "CARINE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "545",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9215668012333221.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9215668012333221.jpg"
    ],
    "size": "30x120",
    "color": "Açık Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_544",
    "brand": "Duratiles",
    "title": "CARINE Koyu Gri 30x120",
    "seriesName": "CARINE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "544",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09965520047215926.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09965520047215926.jpg"
    ],
    "size": "30x120",
    "color": "Koyu Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_543",
    "brand": "Duratiles",
    "title": "CARINE Açık Gri 40x120",
    "seriesName": "CARINE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "543",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.33729207466786326.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.33729207466786326.jpg"
    ],
    "size": "40x120",
    "color": "Açık Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_542",
    "brand": "Duratiles",
    "title": "CARINE Koyu Gri 40x120",
    "seriesName": "CARINE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "542",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1510049786102966.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1510049786102966.jpg"
    ],
    "size": "40x120",
    "color": "Koyu Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Carine Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_554",
    "brand": "Duratiles",
    "title": "CEMENT Gri 60x120",
    "seriesName": "CEMENT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "554",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10975998086249039.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10975998086249039.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo",
    "technology": "Granit",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beton görünümü ile mekânlara net duru bir tarz katan Cement Serisi yaşam alanlarınıza pozitif enerji getirirken farklı olmanın dekoratif yollarını ustalıkla sunmayı ihmal etmiyor.</span>",
    "descriptionClean": "Beton görünümü ile mekânlara net duru bir tarz katan Cement Serisi yaşam alanlarınıza pozitif enerji getirirken farklı olmanın dekoratif yollarını ustalıkla sunmayı ihmal etmiyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_555",
    "brand": "Duratiles",
    "title": "CEMENT Antrasit 60x120",
    "seriesName": "CEMENT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "555",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.603459224274399.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.603459224274399.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo",
    "technology": "Granit",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beton görünümü ile mekânlara net duru bir tarz katan Cement Serisi yaşam alanlarınıza pozitif enerji getirirken farklı olmanın dekoratif yollarını ustalıkla sunmayı ihmal etmiyor.</span>",
    "descriptionClean": "Beton görünümü ile mekânlara net duru bir tarz katan Cement Serisi yaşam alanlarınıza pozitif enerji getirirken farklı olmanın dekoratif yollarını ustalıkla sunmayı ihmal etmiyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_556",
    "brand": "Duratiles",
    "title": "CEMENT Bej 60x60",
    "seriesName": "CEMENT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "556",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9059911911832126.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9059911911832126.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "V2",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beton görünümü ile mekânlara net duru bir tarz katan Cement Serisi yaşam alanlarınıza pozitif enerji getirirken farklı olmanın dekoratif yollarını ustalıkla sunmayı ihmal etmiyor.</span>",
    "descriptionClean": "Beton görünümü ile mekânlara net duru bir tarz katan Cement Serisi yaşam alanlarınıza pozitif enerji getirirken farklı olmanın dekoratif yollarını ustalıkla sunmayı ihmal etmiyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_557",
    "brand": "Duratiles",
    "title": "CEMENT Fildişi 60x60",
    "seriesName": "CEMENT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "557",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8230183940071322.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8230183940071322.jpg"
    ],
    "size": "60x60",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "V2",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beton görünümü ile mekânlara net duru bir tarz katan Cement Serisi yaşam alanlarınıza pozitif enerji getirirken farklı olmanın dekoratif yollarını ustalıkla sunmayı ihmal etmiyor.</span>",
    "descriptionClean": "Beton görünümü ile mekânlara net duru bir tarz katan Cement Serisi yaşam alanlarınıza pozitif enerji getirirken farklı olmanın dekoratif yollarını ustalıkla sunmayı ihmal etmiyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_558",
    "brand": "Duratiles",
    "title": "CEMENT Gri 60x60",
    "seriesName": "CEMENT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "558",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7751721863384464.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7751721863384464.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "V2",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beton görünümü ile mekânlara net duru bir tarz katan Cement Serisi yaşam alanlarınıza pozitif enerji getirirken farklı olmanın dekoratif yollarını ustalıkla sunmayı ihmal etmiyor.</span>",
    "descriptionClean": "Beton görünümü ile mekânlara net duru bir tarz katan Cement Serisi yaşam alanlarınıza pozitif enerji getirirken farklı olmanın dekoratif yollarını ustalıkla sunmayı ihmal etmiyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_559",
    "brand": "Duratiles",
    "title": "CEMENT Antrasit 60x60",
    "seriesName": "CEMENT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "559",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48537006437933894.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48537006437933894.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "V2",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beton görünümü ile mekânlara net duru bir tarz katan Cement Serisi yaşam alanlarınıza pozitif enerji getirirken farklı olmanın dekoratif yollarını ustalıkla sunmayı ihmal etmiyor.</span>",
    "descriptionClean": "Beton görünümü ile mekânlara net duru bir tarz katan Cement Serisi yaşam alanlarınıza pozitif enerji getirirken farklı olmanın dekoratif yollarını ustalıkla sunmayı ihmal etmiyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_560",
    "brand": "Duratiles",
    "title": "CEMENT Antrasit 30x60",
    "seriesName": "CEMENT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "560",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.00687202622538885.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.00687202622538885.jpg"
    ],
    "size": "30x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beton görünümü ile mekânlara net duru bir tarz katan Cement Serisi yaşam alanlarınıza pozitif enerji getirirken farklı olmanın dekoratif yollarını ustalıkla sunmayı ihmal etmiyor.</span>",
    "descriptionClean": "Beton görünümü ile mekânlara net duru bir tarz katan Cement Serisi yaşam alanlarınıza pozitif enerji getirirken farklı olmanın dekoratif yollarını ustalıkla sunmayı ihmal etmiyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_561",
    "brand": "Duratiles",
    "title": "CEMENT Gri 30x60",
    "seriesName": "CEMENT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "561",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03779678986456647.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03779678986456647.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beton görünümü ile mekânlara net duru bir tarz katan Cement Serisi yaşam alanlarınıza pozitif enerji getirirken farklı olmanın dekoratif yollarını ustalıkla sunmayı ihmal etmiyor.</span>",
    "descriptionClean": "Beton görünümü ile mekânlara net duru bir tarz katan Cement Serisi yaşam alanlarınıza pozitif enerji getirirken farklı olmanın dekoratif yollarını ustalıkla sunmayı ihmal etmiyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_562",
    "brand": "Duratiles",
    "title": "CEMENT Fildişi 30x60",
    "seriesName": "CEMENT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "562",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.31698409900590074.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.31698409900590074.jpg"
    ],
    "size": "30x60",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beton görünümü ile mekânlara net duru bir tarz katan Cement Serisi yaşam alanlarınıza pozitif enerji getirirken farklı olmanın dekoratif yollarını ustalıkla sunmayı ihmal etmiyor.</span>",
    "descriptionClean": "Beton görünümü ile mekânlara net duru bir tarz katan Cement Serisi yaşam alanlarınıza pozitif enerji getirirken farklı olmanın dekoratif yollarını ustalıkla sunmayı ihmal etmiyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_563",
    "brand": "Duratiles",
    "title": "CEMENT CEPPO Beyaz 60x120",
    "seriesName": "CEMENT CEPPO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "563",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46953855924808874.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46953855924808874.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "Endüstriyel Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Huzur verici renk paletiyle Cement Ceppo Porselen Karoları sofistike ve rahatlatıcı mekanlar oluşturuyor.</span>",
    "descriptionClean": "Huzur verici renk paletiyle Cement Ceppo Porselen Karoları sofistike ve rahatlatıcı mekanlar oluşturuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_564",
    "brand": "Duratiles",
    "title": "CEMENTINO Graphite 60x60",
    "seriesName": "CEMENTINO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "10923",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5498361231881158.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5498361231881158.jpg"
    ],
    "size": "60x60",
    "color": "Graphite",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo & Endüstriyel Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "Endüstriyel Zemin",
      "V3",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığa vurgu yapan Cementino Porselen Karoları , dingin ruh haliyle yaşam alanlarına her daim zarafet katıyor.</span>",
    "descriptionClean": "Zamansızlığa vurgu yapan Cementino Porselen Karoları , dingin ruh haliyle yaşam alanlarına her daim zarafet katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_565",
    "brand": "Duratiles",
    "title": "CEMENTINO Koyu Gri 60x60",
    "seriesName": "CEMENTINO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "10921",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40049537668619084.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40049537668619084.jpg"
    ],
    "size": "60x60",
    "color": "Koyu Gri",
    "surface": "Mat, Color Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo & Endüstriyel Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "Endüstriyel Zemin",
      "V3",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığa vurgu yapan Cementino Porselen Karoları , dingin ruh haliyle yaşam alanlarına her daim zarafet katıyor.</span>",
    "descriptionClean": "Zamansızlığa vurgu yapan Cementino Porselen Karoları , dingin ruh haliyle yaşam alanlarına her daim zarafet katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_566",
    "brand": "Duratiles",
    "title": "CEMENTINO Gri Bej 60x60",
    "seriesName": "CEMENTINO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "10961",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48234452930260074.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48234452930260074.jpg"
    ],
    "size": "60x60",
    "color": "Gri Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo & Endüstriyel Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "Endüstriyel Zemin",
      "V3",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığa vurgu yapan Cementino Porselen Karoları , dingin ruh haliyle yaşam alanlarına her daim zarafet katıyor.</span>",
    "descriptionClean": "Zamansızlığa vurgu yapan Cementino Porselen Karoları , dingin ruh haliyle yaşam alanlarına her daim zarafet katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_567",
    "brand": "Duratiles",
    "title": "CEMENTINO Açık Gri 60x60",
    "seriesName": "CEMENTINO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "10963",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.37501072867908636.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.37501072867908636.jpg"
    ],
    "size": "60x60",
    "color": "Açık Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Banyo & Endüstriyel Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ev İçi Zemin",
      "Banyo",
      "Endüstriyel Zemin",
      "V3",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığa vurgu yapan Cementino Porselen Karoları , dingin ruh haliyle yaşam alanlarına her daim zarafet katıyor.</span>",
    "descriptionClean": "Zamansızlığa vurgu yapan Cementino Porselen Karoları , dingin ruh haliyle yaşam alanlarına her daim zarafet katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_568",
    "brand": "Duratiles",
    "title": "CEMENTINO Marrone 60x60",
    "seriesName": "CEMENTINO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "10927",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2803968877416877.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2803968877416877.jpg"
    ],
    "size": "60x60",
    "color": "Marrone",
    "surface": "Mat, Color Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Banyo & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ev İçi Zemin",
      "Banyo",
      "Endüstriyel Zemin",
      "V3",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığa vurgu yapan Cementino Porselen Karoları , dingin ruh haliyle yaşam alanlarına her daim zarafet katıyor.</span>",
    "descriptionClean": "Zamansızlığa vurgu yapan Cementino Porselen Karoları , dingin ruh haliyle yaşam alanlarına her daim zarafet katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_569",
    "brand": "Duratiles",
    "title": "CEMENTINO Taupe 60x60",
    "seriesName": "CEMENTINO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "10925",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14429269338309647.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14429269338309647.jpg"
    ],
    "size": "60x60",
    "color": "Taupe",
    "surface": "Mat, Color Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Banyo",
      "Endüstriyel Zemin",
      "V3",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığa vurgu yapan Cementino Porselen Karoları , dingin ruh haliyle yaşam alanlarına her daim zarafet katıyor.</span>",
    "descriptionClean": "Zamansızlığa vurgu yapan Cementino Porselen Karoları , dingin ruh haliyle yaşam alanlarına her daim zarafet katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_570",
    "brand": "Duratiles",
    "title": "CIVIC Bej 60x120",
    "seriesName": "CIVIC",
    "collection": "Beton",
    "category": "Beton",
    "sku": "570",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8897606966459668.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8897606966459668.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Ev içi Zemin & Ticari Alanlar",
    "technology": "Granit",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V2",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Estetik ve şık olmayı simgeleyen Civic Serisi, lüks detayları ile estetiğin mükemmel uyumunu yaşam alanlarına samimi bir dokunuşla vermekte.</span>",
    "descriptionClean": "Estetik ve şık olmayı simgeleyen Civic Serisi, lüks detayları ile estetiğin mükemmel uyumunu yaşam alanlarına samimi bir dokunuşla vermekte.",
    "source": "duratiles"
  },
  {
    "id": "dura_571",
    "brand": "Duratiles",
    "title": "CIVIC Açık Gri 60x120",
    "seriesName": "CIVIC",
    "collection": "Beton",
    "category": "Beton",
    "sku": "571",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2679714202051573.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2679714202051573.jpg"
    ],
    "size": "60x120",
    "color": "Açık Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Granit",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V2",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Estetik ve şık olmayı simgeleyen Civic Serisi, lüks detayları ile estetiğin mükemmel uyumunu yaşam alanlarına samimi bir dokunuşla vermekte.</span>",
    "descriptionClean": "Estetik ve şık olmayı simgeleyen Civic Serisi, lüks detayları ile estetiğin mükemmel uyumunu yaşam alanlarına samimi bir dokunuşla vermekte.",
    "source": "duratiles"
  },
  {
    "id": "dura_572",
    "brand": "Duratiles",
    "title": "CIVIC Koyu Gri 60x120",
    "seriesName": "CIVIC",
    "collection": "Beton",
    "category": "Beton",
    "sku": "572",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4040484280780092.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4040484280780092.jpg"
    ],
    "size": "60x120",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Granit",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V2",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Estetik ve şık olmayı simgeleyen Civic Serisi, lüks detayları ile estetiğin mükemmel uyumunu yaşam alanlarına samimi bir dokunuşla vermekte.</span>",
    "descriptionClean": "Estetik ve şık olmayı simgeleyen Civic Serisi, lüks detayları ile estetiğin mükemmel uyumunu yaşam alanlarına samimi bir dokunuşla vermekte.",
    "source": "duratiles"
  },
  {
    "id": "dura_573",
    "brand": "Duratiles",
    "title": "CIVIC Bej 100x100",
    "seriesName": "CIVIC",
    "collection": "Beton",
    "category": "Beton",
    "sku": "573",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2578951576488927.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2578951576488927.jpg"
    ],
    "size": "100x100",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V2",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Estetik ve şık olmayı simgeleyen Civic Serisi, lüks detayları ile estetiğin mükemmel uyumunu yaşam alanlarına samimi bir dokunuşla vermekte.</span>",
    "descriptionClean": "Estetik ve şık olmayı simgeleyen Civic Serisi, lüks detayları ile estetiğin mükemmel uyumunu yaşam alanlarına samimi bir dokunuşla vermekte.",
    "source": "duratiles"
  },
  {
    "id": "dura_574",
    "brand": "Duratiles",
    "title": "CIVIC Açık Gri 100x100",
    "seriesName": "CIVIC",
    "collection": "Beton",
    "category": "Beton",
    "sku": "574",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4925871321192905.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4925871321192905.jpg"
    ],
    "size": "100x100",
    "color": "Açık Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V2",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Estetik ve şık olmayı simgeleyen Civic Serisi, lüks detayları ile estetiğin mükemmel uyumunu yaşam alanlarına samimi bir dokunuşla vermekte.</span>",
    "descriptionClean": "Estetik ve şık olmayı simgeleyen Civic Serisi, lüks detayları ile estetiğin mükemmel uyumunu yaşam alanlarına samimi bir dokunuşla vermekte.",
    "source": "duratiles"
  },
  {
    "id": "dura_575",
    "brand": "Duratiles",
    "title": "CIVIC Koyu Gri 100x100",
    "seriesName": "CIVIC",
    "collection": "Beton",
    "category": "Beton",
    "sku": "575",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.41591922491882927.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.41591922491882927.jpg"
    ],
    "size": "100x100",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V2",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Estetik ve şık olmayı simgeleyen Civic Serisi, lüks detayları ile estetiğin mükemmel uyumunu yaşam alanlarına samimi bir dokunuşla vermekte.</span>",
    "descriptionClean": "Estetik ve şık olmayı simgeleyen Civic Serisi, lüks detayları ile estetiğin mükemmel uyumunu yaşam alanlarına samimi bir dokunuşla vermekte.",
    "source": "duratiles"
  },
  {
    "id": "dura_576",
    "brand": "Duratiles",
    "title": "COLUMBUS Sand 60x60",
    "seriesName": "COLUMBUS",
    "collection": "Beton",
    "category": "Beton",
    "sku": "576",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4598810943152031.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4598810943152031.jpg"
    ],
    "size": "60x60",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Rafine bir dekorasyon tarzına hayat vermek için en büyük yardımcınız ahşap dokusu ile Columbus Serisi olacaktır. Darbeye ,çizilmeye karşı dirençli olduğu kadar ısı ve ışıktan etkilenmeyen yapısıyla Columbus yeni nesil evlerin ilk tercihi.</span>",
    "descriptionClean": "Rafine bir dekorasyon tarzına hayat vermek için en büyük yardımcınız ahşap dokusu ile Columbus Serisi olacaktır. Darbeye ,çizilmeye karşı dirençli olduğu kadar ısı ve ışıktan etkilenmeyen yapısıyla Columbus yeni nesil evlerin ilk tercihi.",
    "source": "duratiles"
  },
  {
    "id": "dura_577",
    "brand": "Duratiles",
    "title": "COLUMBUS Antrasit 60x60",
    "seriesName": "COLUMBUS",
    "collection": "Beton",
    "category": "Beton",
    "sku": "577",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8847057775433813.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8847057775433813.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Rafine bir dekorasyon tarzına hayat vermek için en büyük yardımcınız ahşap dokusu ile Columbus Serisi olacaktır. Darbeye ,çizilmeye karşı dirençli olduğu kadar ısı ve ışıktan etkilenmeyen yapısıyla Columbus yeni nesil evlerin ilk tercihi.</span>",
    "descriptionClean": "Rafine bir dekorasyon tarzına hayat vermek için en büyük yardımcınız ahşap dokusu ile Columbus Serisi olacaktır. Darbeye ,çizilmeye karşı dirençli olduğu kadar ısı ve ışıktan etkilenmeyen yapısıyla Columbus yeni nesil evlerin ilk tercihi.",
    "source": "duratiles"
  },
  {
    "id": "dura_578",
    "brand": "Duratiles",
    "title": "COLUMBUS Gri 60x60",
    "seriesName": "COLUMBUS",
    "collection": "Beton",
    "category": "Beton",
    "sku": "578",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.32241948370067697.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.32241948370067697.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Rafine bir dekorasyon tarzına hayat vermek için en büyük yardımcınız ahşap dokusu ile Columbus Serisi olacaktır. Darbeye ,çizilmeye karşı dirençli olduğu kadar ısı ve ışıktan etkilenmeyen yapısıyla Columbus yeni nesil evlerin ilk tercihi.</span>",
    "descriptionClean": "Rafine bir dekorasyon tarzına hayat vermek için en büyük yardımcınız ahşap dokusu ile Columbus Serisi olacaktır. Darbeye ,çizilmeye karşı dirençli olduğu kadar ısı ve ışıktan etkilenmeyen yapısıyla Columbus yeni nesil evlerin ilk tercihi.",
    "source": "duratiles"
  },
  {
    "id": "dura_2247",
    "brand": "Duratiles",
    "title": "COTTO Blanco 45x90",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2247",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4215280204123105.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4215280204123105.jpg"
    ],
    "size": "45x90",
    "color": "Blanco",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2249",
    "brand": "Duratiles",
    "title": "COTTO Antrasit 45x90",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2249",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9021902462672349.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9021902462672349.jpg"
    ],
    "size": "45x90",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2250",
    "brand": "Duratiles",
    "title": "COTTO Bej 45x90",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2250",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3205284275689798.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3205284275689798.jpg"
    ],
    "size": "45x90",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2248",
    "brand": "Duratiles",
    "title": "COTTO Gri 45x90",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2248",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8753620173860385.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8753620173860385.jpg"
    ],
    "size": "45x90",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2281",
    "brand": "Duratiles",
    "title": "COTTO Bej 40x40",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2281",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17191090241053608.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17191090241053608.jpg"
    ],
    "size": "40x40",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2280",
    "brand": "Duratiles",
    "title": "COTTO Antrasit 40x40",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2280",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28968375856417716.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28968375856417716.jpg"
    ],
    "size": "40x40",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2279",
    "brand": "Duratiles",
    "title": "COTTO Gri 40x40",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2279",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3046266773527204.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3046266773527204.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2278",
    "brand": "Duratiles",
    "title": "COTTO Blanco 40x40",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2278",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4738651920888657.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4738651920888657.jpg"
    ],
    "size": "40x40",
    "color": "Blanco",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2277",
    "brand": "Duratiles",
    "title": "COTTO Bej 60x60",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2277",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9880285978560684.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9880285978560684.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2276",
    "brand": "Duratiles",
    "title": "COTTO Antrasit 60x60",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2276",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8241938744112958.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8241938744112958.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2275",
    "brand": "Duratiles",
    "title": "COTTO Gri 60x60",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2275",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7176498449527978.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7176498449527978.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2274",
    "brand": "Duratiles",
    "title": "COTTO Blanco 60x60",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2274",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19283341977086055.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19283341977086055.jpg"
    ],
    "size": "60x60",
    "color": "Blanco",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2273",
    "brand": "Duratiles",
    "title": "COTTO Bej 40x80",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2273",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7418933277854771.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7418933277854771.jpg"
    ],
    "size": "40x80",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2272",
    "brand": "Duratiles",
    "title": "COTTO Antrasit 40x80",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2272",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4807083439835649.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4807083439835649.jpg"
    ],
    "size": "40x80",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2271",
    "brand": "Duratiles",
    "title": "COTTO Gri 40x80",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2271",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5433613711866133.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5433613711866133.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2270",
    "brand": "Duratiles",
    "title": "COTTO Blanco 40x80",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2270",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17283945643696796.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17283945643696796.jpg"
    ],
    "size": "40x80",
    "color": "Blanco",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2269",
    "brand": "Duratiles",
    "title": "COTTO Blanco 80x80",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2269",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1746435579864899.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1746435579864899.jpg"
    ],
    "size": "80x80",
    "color": "Blanco",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2268",
    "brand": "Duratiles",
    "title": "COTTO Bej 80x80",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2268",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4488389768394546.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4488389768394546.jpg"
    ],
    "size": "80x80",
    "color": "Bej",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2267",
    "brand": "Duratiles",
    "title": "COTTO Gri 80x80",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2267",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.028617780267756077.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.028617780267756077.jpg"
    ],
    "size": "80x80",
    "color": "Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2266",
    "brand": "Duratiles",
    "title": "COTTO Antrasit 80x80",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2266",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3083084862054982.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3083084862054982.jpg"
    ],
    "size": "80x80",
    "color": "Antrasit",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2265",
    "brand": "Duratiles",
    "title": "COTTO Bej 30x120",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2265",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11945892712600215.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11945892712600215.jpg"
    ],
    "size": "30x120",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2264",
    "brand": "Duratiles",
    "title": "COTTO Gri 30x120",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2264",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.34698164842794543.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.34698164842794543.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2263",
    "brand": "Duratiles",
    "title": "COTTO Blanco 30x120",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2263",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.354908022779865.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.354908022779865.jpg"
    ],
    "size": "30x120",
    "color": "Blanco",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2333",
    "brand": "Duratiles",
    "title": "COTTO Antrasit 30x120",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2333",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16158518617210782.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16158518617210782.jpg"
    ],
    "size": "30x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2262",
    "brand": "Duratiles",
    "title": "COTTO Bej 40x120",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2262",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9740396188627634.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9740396188627634.jpg"
    ],
    "size": "40x120",
    "color": "Bej",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2261",
    "brand": "Duratiles",
    "title": "COTTO Blanco 40x120",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2261",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15179978719017218.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15179978719017218.jpg"
    ],
    "size": "40x120",
    "color": "Blanco",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2260",
    "brand": "Duratiles",
    "title": "COTTO Gri 40x120",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2260",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.908387820694749.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.908387820694749.jpg"
    ],
    "size": "40x120",
    "color": "Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2259",
    "brand": "Duratiles",
    "title": "COTTO Antrasit 40x120",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2259",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15067901675547624.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15067901675547624.jpg"
    ],
    "size": "40x120",
    "color": "Antrasit",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2258",
    "brand": "Duratiles",
    "title": "COTTO Bej 60x120",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2258",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5972499221403194.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5972499221403194.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2257",
    "brand": "Duratiles",
    "title": "COTTO Antrasit 60x120",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2257",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5425406478184225.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5425406478184225.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2256",
    "brand": "Duratiles",
    "title": "COTTO Gri 60x120",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2256",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.42025876304481846.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.42025876304481846.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2255",
    "brand": "Duratiles",
    "title": "COTTO Blanco 60x120",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2255",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19100125520166478.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19100125520166478.jpg"
    ],
    "size": "60x120",
    "color": "Blanco",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2254",
    "brand": "Duratiles",
    "title": "COTTO Gri 60x90",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2254",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3706371124444675.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3706371124444675.jpg"
    ],
    "size": "60x90",
    "color": "Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2253",
    "brand": "Duratiles",
    "title": "COTTO Antrasit 60x90",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2253",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7745999478207142.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7745999478207142.jpg"
    ],
    "size": "60x90",
    "color": "Antrasit",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2252",
    "brand": "Duratiles",
    "title": "COTTO Bej 60x90",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2252",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9179560867734377.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9179560867734377.jpg"
    ],
    "size": "60x90",
    "color": "Bej",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_2251",
    "brand": "Duratiles",
    "title": "COTTO Blanco 60x90",
    "seriesName": "COTTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2251",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48871669634358694.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48871669634358694.jpg"
    ],
    "size": "60x90",
    "color": "Blanco",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Cotto Serisi, ses ve ısı izolasyonuna katkı sağlar ,ayrıca eğimli yüzey sorunları ya da çökme problemleri yaşanılan yerler için ideal bir üründür. Zarafet ve fonksiyonellik bu seride bir arada.",
    "source": "duratiles"
  },
  {
    "id": "dura_617",
    "brand": "Duratiles",
    "title": "COZY Gri 60x60",
    "seriesName": "COZY",
    "collection": "Beton",
    "category": "Beton",
    "sku": "11028",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20022004596844056.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20022004596844056.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz & Banyo",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz",
      "Endüstriyel Zemin",
      "Banyo",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Cozy Porselen Karoları farklı dekorasyon ihtiyaçlarına özel farklı çözümler sunaren zamansız bir şıklağa sahip mekanlar kurgular.</span>",
    "descriptionClean": "Cozy Porselen Karoları farklı dekorasyon ihtiyaçlarına özel farklı çözümler sunaren zamansız bir şıklağa sahip mekanlar kurgular.",
    "source": "duratiles"
  },
  {
    "id": "dura_616",
    "brand": "Duratiles",
    "title": "COZY Bej 60x60",
    "seriesName": "COZY",
    "collection": "Beton",
    "category": "Beton",
    "sku": "11026",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6530453648064481.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6530453648064481.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz & Banyo",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz",
      "Endüstriyel Zemin",
      "Banyo",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Cozy Porselen Karoları farklı dekorasyon ihtiyaçlarına özel farklı çözümler sunaren zamansız bir şıklağa sahip mekanlar kurgular.</span>",
    "descriptionClean": "Cozy Porselen Karoları farklı dekorasyon ihtiyaçlarına özel farklı çözümler sunaren zamansız bir şıklağa sahip mekanlar kurgular.",
    "source": "duratiles"
  },
  {
    "id": "dura_620",
    "brand": "Duratiles",
    "title": "DENVER Gri 60x120",
    "seriesName": "DENVER",
    "collection": "Beton",
    "category": "Beton",
    "sku": "11390",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9793446107649306.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9793446107649306.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz & Banyo",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz",
      "Endüstriyel Zemin",
      "Banyo",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Çağdaş ve şehirli mekan tasarımlarını yeniden yorumlayan Denver Porselen Karoları yaşadığınız mekanlarda farkınızı yansıtacak.</span>",
    "descriptionClean": "Çağdaş ve şehirli mekan tasarımlarını yeniden yorumlayan Denver Porselen Karoları yaşadığınız mekanlarda farkınızı yansıtacak.",
    "source": "duratiles"
  },
  {
    "id": "dura_619",
    "brand": "Duratiles",
    "title": "DENVER Kil 60x120",
    "seriesName": "DENVER",
    "collection": "Beton",
    "category": "Beton",
    "sku": "11388",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23641354310565343.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23641354310565343.jpg"
    ],
    "size": "60x120",
    "color": "Kil",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz & Banyo",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz",
      "Endüstriyel Zemin",
      "Banyo",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Çağdaş ve şehirli mekan tasarımlarını yeniden yorumlayan Denver Porselen Karoları yaşadığınız mekanlarda farkınızı yansıtacak.</span>",
    "descriptionClean": "Çağdaş ve şehirli mekan tasarımlarını yeniden yorumlayan Denver Porselen Karoları yaşadığınız mekanlarda farkınızı yansıtacak.",
    "source": "duratiles"
  },
  {
    "id": "dura_618",
    "brand": "Duratiles",
    "title": "DENVER Weiss 60x120",
    "seriesName": "DENVER",
    "collection": "Beton",
    "category": "Beton",
    "sku": "11392",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5810689954638403.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5810689954638403.jpg"
    ],
    "size": "60x120",
    "color": "Weiss",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz & Banyo",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz",
      "Endüstriyel Zemin",
      "Banyo",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Çağdaş ve şehirli mekan tasarımlarını yeniden yorumlayan Denver Porselen Karoları yaşadığınız mekanlarda farkınızı yansıtacak.</span>",
    "descriptionClean": "Çağdaş ve şehirli mekan tasarımlarını yeniden yorumlayan Denver Porselen Karoları yaşadığınız mekanlarda farkınızı yansıtacak.",
    "source": "duratiles"
  },
  {
    "id": "dura_621",
    "brand": "Duratiles",
    "title": "DURO Gri 90x180",
    "seriesName": "DURO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "621",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08465755380761786.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08465755380761786.jpg"
    ],
    "size": "90x180",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beton görünümü mat yüzeyi ile perçinleyen Duro Serisi geniş ürün yelpazesi ile doğadan aldığı ilhamı yaşam alanlarınıza taşıyor</span>",
    "descriptionClean": "Beton görünümü mat yüzeyi ile perçinleyen Duro Serisi geniş ürün yelpazesi ile doğadan aldığı ilhamı yaşam alanlarınıza taşıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_622",
    "brand": "Duratiles",
    "title": "DURO Beyaz 90x180",
    "seriesName": "DURO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "622",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22881513879602655.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22881513879602655.jpg"
    ],
    "size": "90x180",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beton görünümü mat yüzeyi ile perçinleyen Duro Serisi geniş ürün yelpazesi ile doğadan aldığı ilhamı yaşam alanlarınıza taşıyor</span>",
    "descriptionClean": "Beton görünümü mat yüzeyi ile perçinleyen Duro Serisi geniş ürün yelpazesi ile doğadan aldığı ilhamı yaşam alanlarınıza taşıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_623",
    "brand": "Duratiles",
    "title": "DURO Antrasit 90x180",
    "seriesName": "DURO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "623",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.507627365276212.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.507627365276212.jpg"
    ],
    "size": "90x180",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beton görünümü mat yüzeyi ile perçinleyen Duro Serisi geniş ürün yelpazesi ile doğadan aldığı ilhamı yaşam alanlarınıza taşıyor</span>",
    "descriptionClean": "Beton görünümü mat yüzeyi ile perçinleyen Duro Serisi geniş ürün yelpazesi ile doğadan aldığı ilhamı yaşam alanlarınıza taşıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_625",
    "brand": "Duratiles",
    "title": "DURO Gri 60x120",
    "seriesName": "DURO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "625",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8329463302418856.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8329463302418856.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beton görünümü mat yüzeyi ile perçinleyen Duro Serisi geniş ürün yelpazesi ile doğadan aldığı ilhamı yaşam alanlarınıza taşıyor</span>",
    "descriptionClean": "Beton görünümü mat yüzeyi ile perçinleyen Duro Serisi geniş ürün yelpazesi ile doğadan aldığı ilhamı yaşam alanlarınıza taşıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_626",
    "brand": "Duratiles",
    "title": "DURO Antrasit 60x120",
    "seriesName": "DURO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "626",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8273499528785632.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8273499528785632.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beton görünümü mat yüzeyi ile perçinleyen Duro Serisi geniş ürün yelpazesi ile doğadan aldığı ilhamı yaşam alanlarınıza taşıyor</span>",
    "descriptionClean": "Beton görünümü mat yüzeyi ile perçinleyen Duro Serisi geniş ürün yelpazesi ile doğadan aldığı ilhamı yaşam alanlarınıza taşıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_624",
    "brand": "Duratiles",
    "title": "DURO Beyaz 60x120",
    "seriesName": "DURO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "624",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4182657268707797.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4182657268707797.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beton görünümü mat yüzeyi ile perçinleyen Duro Serisi geniş ürün yelpazesi ile doğadan aldığı ilhamı yaşam alanlarınıza taşıyor</span>",
    "descriptionClean": "Beton görünümü mat yüzeyi ile perçinleyen Duro Serisi geniş ürün yelpazesi ile doğadan aldığı ilhamı yaşam alanlarınıza taşıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_630",
    "brand": "Duratiles",
    "title": "DURO Krem 60x120",
    "seriesName": "DURO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "630",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4050940251200893.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4050940251200893.jpg"
    ],
    "size": "60x120",
    "color": "Krem",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beton görünümü mat yüzeyi ile perçinleyen Duro Serisi geniş ürün yelpazesi ile doğadan aldığı ilhamı yaşam alanlarınıza taşıyor</span>",
    "descriptionClean": "Beton görünümü mat yüzeyi ile perçinleyen Duro Serisi geniş ürün yelpazesi ile doğadan aldığı ilhamı yaşam alanlarınıza taşıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_627",
    "brand": "Duratiles",
    "title": "DURO Beyaz 120x120",
    "seriesName": "DURO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "627",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6645920130270078.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6645920130270078.jpg"
    ],
    "size": "120x120",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beton görünümü mat yüzeyi ile perçinleyen Duro Serisi geniş ürün yelpazesi ile doğadan aldığı ilhamı yaşam alanlarınıza taşıyor</span>",
    "descriptionClean": "Beton görünümü mat yüzeyi ile perçinleyen Duro Serisi geniş ürün yelpazesi ile doğadan aldığı ilhamı yaşam alanlarınıza taşıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_628",
    "brand": "Duratiles",
    "title": "DURO Gri 120x120",
    "seriesName": "DURO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "12275",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9515353172268344.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9515353172268344.jpg"
    ],
    "size": "120x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beton görünümü mat yüzeyi ile perçinleyen Duro Serisi geniş ürün yelpazesi ile doğadan aldığı ilhamı yaşam alanlarınıza taşıyor</span>",
    "descriptionClean": "Beton görünümü mat yüzeyi ile perçinleyen Duro Serisi geniş ürün yelpazesi ile doğadan aldığı ilhamı yaşam alanlarınıza taşıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_629",
    "brand": "Duratiles",
    "title": "DURO Antrasit 120x120",
    "seriesName": "DURO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "12276",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3071332085328785.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3071332085328785.jpg"
    ],
    "size": "120x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beton görünümü mat yüzeyi ile perçinleyen Duro Serisi geniş ürün yelpazesi ile doğadan aldığı ilhamı yaşam alanlarınıza taşıyor</span>",
    "descriptionClean": "Beton görünümü mat yüzeyi ile perçinleyen Duro Serisi geniş ürün yelpazesi ile doğadan aldığı ilhamı yaşam alanlarınıza taşıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_635",
    "brand": "Duratiles",
    "title": "EDEN Beyaz 60x120",
    "seriesName": "EDEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "635",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.33877082765909017.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.33877082765909017.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_634",
    "brand": "Duratiles",
    "title": "EDEN Bej 60x120",
    "seriesName": "EDEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "634",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8665031476936559.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8665031476936559.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_633",
    "brand": "Duratiles",
    "title": "EDEN Grigio 60x120",
    "seriesName": "EDEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "633",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8455406316072483.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8455406316072483.jpg"
    ],
    "size": "60x120",
    "color": "Grigio",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_632",
    "brand": "Duratiles",
    "title": "EDEN Graphite 60x120",
    "seriesName": "EDEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "632",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6550767588418543.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6550767588418543.jpg"
    ],
    "size": "60x120",
    "color": "Graphite",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_636",
    "brand": "Duratiles",
    "title": "EDEN Graphite 100x100",
    "seriesName": "EDEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "636",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2964126768265416.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2964126768265416.jpg"
    ],
    "size": "100x100",
    "color": "Graphite",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_637",
    "brand": "Duratiles",
    "title": "EDEN Grigio 100x100",
    "seriesName": "EDEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "637",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.956426110119167.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.956426110119167.jpg"
    ],
    "size": "100x100",
    "color": "Grigio",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_639",
    "brand": "Duratiles",
    "title": "EDEN Beyaz 100x100",
    "seriesName": "EDEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "639",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16008093176273874.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16008093176273874.jpg"
    ],
    "size": "100x100",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_638",
    "brand": "Duratiles",
    "title": "EDEN Bej 100x100",
    "seriesName": "EDEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "638",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.35596262680663093.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.35596262680663093.jpg"
    ],
    "size": "100x100",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_643",
    "brand": "Duratiles",
    "title": "EDEN Beyaz 60x60",
    "seriesName": "EDEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "643",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3480973552108714.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3480973552108714.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_642",
    "brand": "Duratiles",
    "title": "EDEN Bej 60x60",
    "seriesName": "EDEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "642",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5542038877586487.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5542038877586487.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_641",
    "brand": "Duratiles",
    "title": "EDEN Grigio 60x60",
    "seriesName": "EDEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "641",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5889681053916391.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5889681053916391.jpg"
    ],
    "size": "60x60",
    "color": "Grigio",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_640",
    "brand": "Duratiles",
    "title": "EDEN Graphite 60x60",
    "seriesName": "EDEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "640",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19421616307831513.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19421616307831513.jpg"
    ],
    "size": "60x60",
    "color": "Graphite",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_647",
    "brand": "Duratiles",
    "title": "EDEN Beyaz 30x60",
    "seriesName": "EDEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "647",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.584753196349904.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.584753196349904.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_646",
    "brand": "Duratiles",
    "title": "EDEN Bej 30x60",
    "seriesName": "EDEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "646",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.41178761298421773.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.41178761298421773.jpg"
    ],
    "size": "30x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_645",
    "brand": "Duratiles",
    "title": "EDEN Grigio 30x60",
    "seriesName": "EDEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "645",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6703811298952718.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6703811298952718.jpg"
    ],
    "size": "30x60",
    "color": "Grigio",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_644",
    "brand": "Duratiles",
    "title": "EDEN Graphite 30x60",
    "seriesName": "EDEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "644",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21239082117342467.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21239082117342467.jpg"
    ],
    "size": "30x60",
    "color": "Graphite",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "İlham veren yumuşak renk yelpazesiyle Eden Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Eden farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_648",
    "brand": "Duratiles",
    "title": "ERT Beyaz 60x120",
    "seriesName": "ERT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "648",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9457503953962885.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9457503953962885.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe & Banyo & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe",
      "Banyo",
      "Ev İçi Zemin",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Ert Serisi ile evinize benzersiz bir hava katarken yaşam alanınıza yepyeni çağdaş bir görünüm kazandırabilirsiniz.</span>",
    "descriptionClean": "Ert Serisi ile evinize benzersiz bir hava katarken yaşam alanınıza yepyeni çağdaş bir görünüm kazandırabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_649",
    "brand": "Duratiles",
    "title": "ETNA Siyah 45x90",
    "seriesName": "ETNA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "649",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.583915655085958.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.583915655085958.jpg"
    ],
    "size": "45x90",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_650",
    "brand": "Duratiles",
    "title": "ETNA Gri 45x90",
    "seriesName": "ETNA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "650",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5229194958765452.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5229194958765452.jpg"
    ],
    "size": "45x90",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_651",
    "brand": "Duratiles",
    "title": "ETNA Siyah 60x90",
    "seriesName": "ETNA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "651",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23085095534854627.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23085095534854627.jpg"
    ],
    "size": "60x90",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_652",
    "brand": "Duratiles",
    "title": "ETNA Gri 60x90",
    "seriesName": "ETNA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "652",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9090201752189141.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9090201752189141.jpg"
    ],
    "size": "60x90",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_654",
    "brand": "Duratiles",
    "title": "ETNA Siyah 60x120",
    "seriesName": "ETNA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "654",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6639651130762555.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6639651130762555.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Havuz & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Havuz",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_653",
    "brand": "Duratiles",
    "title": "ETNA Gri 60x120",
    "seriesName": "ETNA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "653",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30615611212360716.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30615611212360716.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Havuz & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Havuz",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_655",
    "brand": "Duratiles",
    "title": "ETNA Siyah 40x120",
    "seriesName": "ETNA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "655",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8026030263549059.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8026030263549059.jpg"
    ],
    "size": "40x120",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Havuz & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Havuz",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_656",
    "brand": "Duratiles",
    "title": "ETNA Gri 40x120",
    "seriesName": "ETNA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "656",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.27116228728150193.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.27116228728150193.jpg"
    ],
    "size": "40x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Havuz & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Havuz",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_657",
    "brand": "Duratiles",
    "title": "ETNA Siyah 30x120",
    "seriesName": "ETNA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "657",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5368728644339458.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5368728644339458.jpg"
    ],
    "size": "30x120",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Havuz & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Havuz",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_658",
    "brand": "Duratiles",
    "title": "ETNA Gri 30x120",
    "seriesName": "ETNA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "658",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03676042214490771.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03676042214490771.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Havuz & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Havuz",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_659",
    "brand": "Duratiles",
    "title": "ETNA Siyah 80x80",
    "seriesName": "ETNA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "659",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.495533227343248.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.495533227343248.jpg"
    ],
    "size": "80x80",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Havuz & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Havuz",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_660",
    "brand": "Duratiles",
    "title": "ETNA Gri 80x80",
    "seriesName": "ETNA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "660",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3766267410697254.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3766267410697254.jpg"
    ],
    "size": "80x80",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Havuz & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Havuz",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_661",
    "brand": "Duratiles",
    "title": "ETNA Siyah 40x80",
    "seriesName": "ETNA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "661",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8621498959244671.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8621498959244671.jpg"
    ],
    "size": "40x80",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Havuz & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Havuz",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_662",
    "brand": "Duratiles",
    "title": "ETNA Gri 40x80",
    "seriesName": "ETNA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "662",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1400878132142298.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1400878132142298.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Havuz & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Havuz",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_663",
    "brand": "Duratiles",
    "title": "ETNA Siyah 60x60",
    "seriesName": "ETNA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "663",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2622824592065047.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2622824592065047.jpg"
    ],
    "size": "60x60",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Havuz & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Havuz",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_664",
    "brand": "Duratiles",
    "title": "ETNA Gri 60x60",
    "seriesName": "ETNA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "664",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09622662903396695.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09622662903396695.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Havuz & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Havuz",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_665",
    "brand": "Duratiles",
    "title": "ETNA Siyah 40x40",
    "seriesName": "ETNA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "665",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15786092911549088.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15786092911549088.jpg"
    ],
    "size": "40x40",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Havuz & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Havuz",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_666",
    "brand": "Duratiles",
    "title": "ETNA Gri 40x40",
    "seriesName": "ETNA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "666",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.34261970570907396.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.34261970570907396.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Havuz & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Havuz",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Etna Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_667",
    "brand": "Duratiles",
    "title": "FADE Altın 60x120",
    "seriesName": "FADE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "667",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19691432571698175.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19691432571698175.jpg"
    ],
    "size": "60x120",
    "color": "Altın",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Fade Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.</span>",
    "descriptionClean": "Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Fade Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_668",
    "brand": "Duratiles",
    "title": "FADE Yosun 60x120",
    "seriesName": "FADE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "668",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9622883431760522.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9622883431760522.jpg"
    ],
    "size": "60x120",
    "color": "Yosun",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Fade Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.</span>",
    "descriptionClean": "Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Fade Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_670",
    "brand": "Duratiles",
    "title": "FADE Okyanus 60x120",
    "seriesName": "FADE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "670",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12169805174133519.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12169805174133519.jpg"
    ],
    "size": "60x120",
    "color": "Okyanus",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Fade Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.</span>",
    "descriptionClean": "Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Fade Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_671",
    "brand": "Duratiles",
    "title": "FADE Beyaz 60x120",
    "seriesName": "FADE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "671",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3023799635331148.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3023799635331148.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Fade Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.</span>",
    "descriptionClean": "Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Fade Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_673",
    "brand": "Duratiles",
    "title": "FAST Smoke 60x120",
    "seriesName": "FAST",
    "collection": "Beton",
    "category": "Beton",
    "sku": "673",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8391003409465787.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8391003409465787.jpg"
    ],
    "size": "60x120",
    "color": "Smoke",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_672",
    "brand": "Duratiles",
    "title": "FAST Taupe 60x120",
    "seriesName": "FAST",
    "collection": "Beton",
    "category": "Beton",
    "sku": "672",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8587553279343448.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8587553279343448.jpg"
    ],
    "size": "60x120",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_674",
    "brand": "Duratiles",
    "title": "FAST Graphite 60x120",
    "seriesName": "FAST",
    "collection": "Beton",
    "category": "Beton",
    "sku": "674",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8122250951053753.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8122250951053753.jpg"
    ],
    "size": "60x120",
    "color": "Graphite",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_675",
    "brand": "Duratiles",
    "title": "FAST Taupe 100x100",
    "seriesName": "FAST",
    "collection": "Beton",
    "category": "Beton",
    "sku": "675",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0027529143904224673.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0027529143904224673.jpg"
    ],
    "size": "100x100",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_676",
    "brand": "Duratiles",
    "title": "FAST Taupe Dekor 100x100",
    "seriesName": "FAST",
    "collection": "Beton",
    "category": "Beton",
    "sku": "676",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6234917814624411.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6234917814624411.jpg"
    ],
    "size": "100x100",
    "color": "Taupe Dekor",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe & Banyo & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_677",
    "brand": "Duratiles",
    "title": "FAST Smoke 100x100",
    "seriesName": "FAST",
    "collection": "Beton",
    "category": "Beton",
    "sku": "677",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.042559610070511567.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.042559610070511567.jpg"
    ],
    "size": "100x100",
    "color": "Smoke",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe & Banyo & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_678",
    "brand": "Duratiles",
    "title": "FAST Smoke Dekor 100x100",
    "seriesName": "FAST",
    "collection": "Beton",
    "category": "Beton",
    "sku": "678",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6736016539096372.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6736016539096372.jpg"
    ],
    "size": "100x100",
    "color": "Smoke Dekor",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe & Banyo & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_679",
    "brand": "Duratiles",
    "title": "FAST Graphite 100x100",
    "seriesName": "FAST",
    "collection": "Beton",
    "category": "Beton",
    "sku": "679",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8284521636108209.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8284521636108209.jpg"
    ],
    "size": "100x100",
    "color": "Graphite",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe & Banyo & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_680",
    "brand": "Duratiles",
    "title": "FAST Graphite Dekor 100x100",
    "seriesName": "FAST",
    "collection": "Beton",
    "category": "Beton",
    "sku": "680",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5111532186830018.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5111532186830018.jpg"
    ],
    "size": "100x100",
    "color": "Graphite Dekor",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe & Banyo & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_681",
    "brand": "Duratiles",
    "title": "FAST Taupe 60x60",
    "seriesName": "FAST",
    "collection": "Beton",
    "category": "Beton",
    "sku": "681",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7945453662703658.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7945453662703658.jpg"
    ],
    "size": "60x60",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_682",
    "brand": "Duratiles",
    "title": "FAST Taupe Dekor 60x60",
    "seriesName": "FAST",
    "collection": "Beton",
    "category": "Beton",
    "sku": "682",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15911619412928868.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15911619412928868.jpg"
    ],
    "size": "60x60",
    "color": "Taupe Dekor",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_683",
    "brand": "Duratiles",
    "title": "FAST Smoke 60x60",
    "seriesName": "FAST",
    "collection": "Beton",
    "category": "Beton",
    "sku": "683",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9002399470970494.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9002399470970494.jpg"
    ],
    "size": "60x60",
    "color": "Smoke",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_684",
    "brand": "Duratiles",
    "title": "FAST Smoke Dekor 60x60",
    "seriesName": "FAST",
    "collection": "Beton",
    "category": "Beton",
    "sku": "684",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.749098472780101.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.749098472780101.jpg"
    ],
    "size": "60x60",
    "color": "Smoke Dekor",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_685",
    "brand": "Duratiles",
    "title": "FAST Graphite 60x60",
    "seriesName": "FAST",
    "collection": "Beton",
    "category": "Beton",
    "sku": "685",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6952717193920946.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6952717193920946.jpg"
    ],
    "size": "60x60",
    "color": "Graphite",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_686",
    "brand": "Duratiles",
    "title": "FAST Graphite Dekor 60x60",
    "seriesName": "FAST",
    "collection": "Beton",
    "category": "Beton",
    "sku": "686",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.545397885318311.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.545397885318311.jpg"
    ],
    "size": "60x60",
    "color": "Graphite Dekor",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_687",
    "brand": "Duratiles",
    "title": "FAST Taupe 30x60",
    "seriesName": "FAST",
    "collection": "Beton",
    "category": "Beton",
    "sku": "687",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.639826418091748.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.639826418091748.jpg"
    ],
    "size": "30x60",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe & Banyo & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_688",
    "brand": "Duratiles",
    "title": "FAST Smoke 30x60",
    "seriesName": "FAST",
    "collection": "Beton",
    "category": "Beton",
    "sku": "688",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15183759412747277.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15183759412747277.jpg"
    ],
    "size": "30x60",
    "color": "Smoke",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_689",
    "brand": "Duratiles",
    "title": "FAST Graphite 30x60",
    "seriesName": "FAST",
    "collection": "Beton",
    "category": "Beton",
    "sku": "689",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5247770563054716.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5247770563054716.jpg"
    ],
    "size": "30x60",
    "color": "Graphite",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile özgün mekanlar tasarlamanıza olanak sağlayan Fast Serisi zarif dekorlarıyla mekanlara hareket katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_692",
    "brand": "Duratiles",
    "title": "FODER Gri 60x120",
    "seriesName": "FODER",
    "collection": "Beton",
    "category": "Beton",
    "sku": "692",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46565731276842814.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46565731276842814.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe & Banyo & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe",
      "Banyo",
      "Ev İçi Zemin",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Foder Serisinin endüstriyel görünümü ile sıradanlığa meydan okuyun</span>",
    "descriptionClean": "Foder Serisinin endüstriyel görünümü ile sıradanlığa meydan okuyun",
    "source": "duratiles"
  },
  {
    "id": "dura_693",
    "brand": "Duratiles",
    "title": "FODER Füme 60x120",
    "seriesName": "FODER",
    "collection": "Beton",
    "category": "Beton",
    "sku": "693",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8397645298147252.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8397645298147252.jpg"
    ],
    "size": "60x120",
    "color": "Füme",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe & Banyo & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe",
      "Banyo",
      "Ev İçi Zemin",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Foder Serisinin endüstriyel görünümü ile sıradanlığa meydan okuyun</span>",
    "descriptionClean": "Foder Serisinin endüstriyel görünümü ile sıradanlığa meydan okuyun",
    "source": "duratiles"
  },
  {
    "id": "dura_694",
    "brand": "Duratiles",
    "title": "FODER Beyaz 60x120",
    "seriesName": "FODER",
    "collection": "Beton",
    "category": "Beton",
    "sku": "694",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8108644876722841.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8108644876722841.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Foder Serisinin endüstriyel görünümü ile sıradanlığa meydan okuyun</span>",
    "descriptionClean": "Foder Serisinin endüstriyel görünümü ile sıradanlığa meydan okuyun",
    "source": "duratiles"
  },
  {
    "id": "dura_695",
    "brand": "Duratiles",
    "title": "FODER Beyaz 120x120",
    "seriesName": "FODER",
    "collection": "Beton",
    "category": "Beton",
    "sku": "695",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16768338694850138.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16768338694850138.jpg"
    ],
    "size": "120x120",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Foder Serisinin endüstriyel görünümü ile sıradanlığa meydan okuyun</span>",
    "descriptionClean": "Foder Serisinin endüstriyel görünümü ile sıradanlığa meydan okuyun",
    "source": "duratiles"
  },
  {
    "id": "dura_696",
    "brand": "Duratiles",
    "title": "FODER Gri 120x120",
    "seriesName": "FODER",
    "collection": "Beton",
    "category": "Beton",
    "sku": "69812",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9272518195676753.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9272518195676753.jpg"
    ],
    "size": "120x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Foder Serisinin endüstriyel görünümü ile sıradanlığa meydan okuyun</span>",
    "descriptionClean": "Foder Serisinin endüstriyel görünümü ile sıradanlığa meydan okuyun",
    "source": "duratiles"
  },
  {
    "id": "dura_697",
    "brand": "Duratiles",
    "title": "FODER Smoke 100x100",
    "seriesName": "FODER",
    "collection": "Beton",
    "category": "Beton",
    "sku": "697",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21923744658623756.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21923744658623756.jpg"
    ],
    "size": "100x100",
    "color": "Smoke",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Foder Serisinin endüstriyel görünümü ile sıradanlığa meydan okuyun</span>",
    "descriptionClean": "Foder Serisinin endüstriyel görünümü ile sıradanlığa meydan okuyun",
    "source": "duratiles"
  },
  {
    "id": "dura_698",
    "brand": "Duratiles",
    "title": "FODER Beyaz 100x100",
    "seriesName": "FODER",
    "collection": "Beton",
    "category": "Beton",
    "sku": "698",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7117254004339884.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7117254004339884.jpg"
    ],
    "size": "100x100",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Foder Serisinin endüstriyel görünümü ile sıradanlığa meydan okuyun</span>",
    "descriptionClean": "Foder Serisinin endüstriyel görünümü ile sıradanlığa meydan okuyun",
    "source": "duratiles"
  },
  {
    "id": "dura_699",
    "brand": "Duratiles",
    "title": "FODER Beyaz 30x60",
    "seriesName": "FODER",
    "collection": "Beton",
    "category": "Beton",
    "sku": "699",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07399029883722519.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07399029883722519.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Foder Serisinin endüstriyel görünümü ile sıradanlığa meydan okuyun</span>",
    "descriptionClean": "Foder Serisinin endüstriyel görünümü ile sıradanlığa meydan okuyun",
    "source": "duratiles"
  },
  {
    "id": "dura_700",
    "brand": "Duratiles",
    "title": "FODER Gri 30x60",
    "seriesName": "FODER",
    "collection": "Beton",
    "category": "Beton",
    "sku": "700",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09158679269749104.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09158679269749104.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Foder Serisinin endüstriyel görünümü ile sıradanlığa meydan okuyun</span>",
    "descriptionClean": "Foder Serisinin endüstriyel görünümü ile sıradanlığa meydan okuyun",
    "source": "duratiles"
  },
  {
    "id": "dura_701",
    "brand": "Duratiles",
    "title": "FODER Smoke 30x60",
    "seriesName": "FODER",
    "collection": "Beton",
    "category": "Beton",
    "sku": "701",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3074379317540522.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3074379317540522.jpg"
    ],
    "size": "30x60",
    "color": "Smoke",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Foder Serisinin endüstriyel görünümü ile sıradanlığa meydan okuyun</span>",
    "descriptionClean": "Foder Serisinin endüstriyel görünümü ile sıradanlığa meydan okuyun",
    "source": "duratiles"
  },
  {
    "id": "dura_702",
    "brand": "Duratiles",
    "title": "FODER MATT Beyaz 60x120",
    "seriesName": "FODER MATT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "702",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2580457791897891.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2580457791897891.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Seramikten gelen saf güzellik Foder serisi iler her alana yansır. Doğanın el değmemiş zarafetini taşır.</span>",
    "descriptionClean": "Seramikten gelen saf güzellik Foder serisi iler her alana yansır. Doğanın el değmemiş zarafetini taşır.",
    "source": "duratiles"
  },
  {
    "id": "dura_703",
    "brand": "Duratiles",
    "title": "FODER MATT Gri 60x120",
    "seriesName": "FODER MATT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "703",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8857113488067403.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8857113488067403.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Seramikten gelen saf güzellik Foder serisi iler her alana yansır. Doğanın el değmemiş zarafetini taşır.</span>",
    "descriptionClean": "Seramikten gelen saf güzellik Foder serisi iler her alana yansır. Doğanın el değmemiş zarafetini taşır.",
    "source": "duratiles"
  },
  {
    "id": "dura_704",
    "brand": "Duratiles",
    "title": "FODER MATT Smoke 60x120",
    "seriesName": "FODER MATT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "704",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8273910370913168.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8273910370913168.jpg"
    ],
    "size": "60x120",
    "color": "Smoke",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Seramikten gelen saf güzellik Foder serisi iler her alana yansır. Doğanın el değmemiş zarafetini taşır.</span>",
    "descriptionClean": "Seramikten gelen saf güzellik Foder serisi iler her alana yansır. Doğanın el değmemiş zarafetini taşır.",
    "source": "duratiles"
  },
  {
    "id": "dura_705",
    "brand": "Duratiles",
    "title": "FODER MATT Beyaz 80x80",
    "seriesName": "FODER MATT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "63088",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.010721588413860506.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.010721588413860506.jpg"
    ],
    "size": "80x80",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Seramikten gelen saf güzellik Foder serisi iler her alana yansır. Doğanın el değmemiş zarafetini taşır.</span>",
    "descriptionClean": "Seramikten gelen saf güzellik Foder serisi iler her alana yansır. Doğanın el değmemiş zarafetini taşır.",
    "source": "duratiles"
  },
  {
    "id": "dura_706",
    "brand": "Duratiles",
    "title": "FODER MATT Gri 80x80",
    "seriesName": "FODER MATT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "59949",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2689498167761557.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2689498167761557.jpg"
    ],
    "size": "80x80",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Seramikten gelen saf güzellik Foder serisi iler her alana yansır. Doğanın el değmemiş zarafetini taşır.</span>",
    "descriptionClean": "Seramikten gelen saf güzellik Foder serisi iler her alana yansır. Doğanın el değmemiş zarafetini taşır.",
    "source": "duratiles"
  },
  {
    "id": "dura_707",
    "brand": "Duratiles",
    "title": "FODER MATT Füme 80x80",
    "seriesName": "FODER MATT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "70611",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16802840558472598.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16802840558472598.jpg"
    ],
    "size": "80x80",
    "color": "Füme",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Seramikten gelen saf güzellik Foder serisi iler her alana yansır. Doğanın el değmemiş zarafetini taşır.</span>",
    "descriptionClean": "Seramikten gelen saf güzellik Foder serisi iler her alana yansır. Doğanın el değmemiş zarafetini taşır.",
    "source": "duratiles"
  },
  {
    "id": "dura_709",
    "brand": "Duratiles",
    "title": "FODER MATT Gri 60x60",
    "seriesName": "FODER MATT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "709",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2924663958735949.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2924663958735949.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Seramikten gelen saf güzellik Foder serisi iler her alana yansır. Doğanın el değmemiş zarafetini taşır.</span>",
    "descriptionClean": "Seramikten gelen saf güzellik Foder serisi iler her alana yansır. Doğanın el değmemiş zarafetini taşır.",
    "source": "duratiles"
  },
  {
    "id": "dura_710",
    "brand": "Duratiles",
    "title": "FODER MATT Smoke 60x60",
    "seriesName": "FODER MATT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "710",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36625975578962655.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36625975578962655.jpg"
    ],
    "size": "60x60",
    "color": "Smoke",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Seramikten gelen saf güzellik Foder serisi iler her alana yansır. Doğanın el değmemiş zarafetini taşır.</span>",
    "descriptionClean": "Seramikten gelen saf güzellik Foder serisi iler her alana yansır. Doğanın el değmemiş zarafetini taşır.",
    "source": "duratiles"
  },
  {
    "id": "dura_708",
    "brand": "Duratiles",
    "title": "FODER MATT Beyaz 60x60",
    "seriesName": "FODER MATT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "708",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5757870658944592.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5757870658944592.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Seramikten gelen saf güzellik Foder serisi iler her alana yansır. Doğanın el değmemiş zarafetini taşır.</span>",
    "descriptionClean": "Seramikten gelen saf güzellik Foder serisi iler her alana yansır. Doğanın el değmemiş zarafetini taşır.",
    "source": "duratiles"
  },
  {
    "id": "dura_711",
    "brand": "Duratiles",
    "title": "FSZ MOON Krem 60x120",
    "seriesName": "FSZ MOON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "711",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9698881068747098.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9698881068747098.jpg"
    ],
    "size": "60x120",
    "color": "Krem",
    "surface": "Mat, Color Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren yumuşak renk yelpazesiyle Fzs Moon Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Fsz Moon farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "İlham veren yumuşak renk yelpazesiyle Fzs Moon Serisi sizi sadeliğin ilham verici dünyasına davet ediyor.Fsz Moon farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_712",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Gümüş 45x90",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "712",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9264963790323846.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9264963790323846.jpg"
    ],
    "size": "45x90",
    "color": "Gümüş",
    "surface": "Mat , Sırlı Body",
    "thickness": "30mm & 20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_713",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Siyah 45x90",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "713",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44335429688008743.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44335429688008743.jpg"
    ],
    "size": "45x90",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "30mm & 20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_714",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Bone 45x90",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "714",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4147598699138.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4147598699138.jpg"
    ],
    "size": "45x90",
    "color": "Bone",
    "surface": "Mat , Sırlı Body",
    "thickness": "30mm & 20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_715",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Taupe 45x90",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "715",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6679802761988607.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6679802761988607.jpg"
    ],
    "size": "45x90",
    "color": "Taupe",
    "surface": "Mat , Sırlı Body",
    "thickness": "30mm & 20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_716",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Gümüş 60x90",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "716",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.31853634894385907.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.31853634894385907.jpg"
    ],
    "size": "60x90",
    "color": "Gümüş",
    "surface": "Mat , Sırlı Body",
    "thickness": "30mm & 20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_717",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Siyah 60x90",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "717",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5706985483746632.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5706985483746632.jpg"
    ],
    "size": "60x90",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_718",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Bone 60x90",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "718",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8705363410004746.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8705363410004746.jpg"
    ],
    "size": "60x90",
    "color": "Bone",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_719",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Taupe 60x90",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "719",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7655519913990192.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7655519913990192.jpg"
    ],
    "size": "60x90",
    "color": "Taupe",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_721",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Gümüş 60x120",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "721",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07800712951219257.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07800712951219257.jpg"
    ],
    "size": "60x120",
    "color": "Gümüş",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_722",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Siyah 60x120",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "722",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7229423829841536.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7229423829841536.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_723",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Bone 60x120",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "723",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4820022366742197.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4820022366742197.jpg"
    ],
    "size": "60x120",
    "color": "Bone",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_720",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Taupe 60x120",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "720",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9181737854035987.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9181737854035987.jpg"
    ],
    "size": "60x120",
    "color": "Taupe",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_724",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Gümüş 40x120",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "724",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13830052365932322.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13830052365932322.jpg"
    ],
    "size": "40x120",
    "color": "Gümüş",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_727",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Siyah 40x120",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "727",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.025202106055677187.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.025202106055677187.jpg"
    ],
    "size": "40x120",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_725",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Bone 40x120",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "725",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08623591720326085.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08623591720326085.jpg"
    ],
    "size": "40x120",
    "color": "Bone",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_726",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Taupe 40x120",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "726",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5264620425624181.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5264620425624181.jpg"
    ],
    "size": "40x120",
    "color": "Taupe",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_731",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Gümüş 30x120",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "731",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.35439374871221796.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.35439374871221796.jpg"
    ],
    "size": "30x120",
    "color": "Gümüş",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_730",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Siyah 30x120",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "730",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9651574615039608.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9651574615039608.jpg"
    ],
    "size": "30x120",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_728",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Bone 30x120",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "728",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9872243982089153.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9872243982089153.jpg"
    ],
    "size": "30x120",
    "color": "Bone",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_729",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Taupe 30x120",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "729",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5702692769487949.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5702692769487949.jpg"
    ],
    "size": "30x120",
    "color": "Taupe",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_732",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Gümüş 80x80",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "732",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5446807327051015.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5446807327051015.jpg"
    ],
    "size": "80x80",
    "color": "Gümüş",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_733",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Siyah 80x80",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "733",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3763590685862792.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3763590685862792.jpg"
    ],
    "size": "80x80",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_735",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Bone 80x80",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "735",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9186896598678554.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9186896598678554.jpg"
    ],
    "size": "80x80",
    "color": "Bone",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_734",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Taupe 80x80",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "734",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7503812514217639.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7503812514217639.jpg"
    ],
    "size": "80x80",
    "color": "Taupe",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_738",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Gümüş 40x80",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "738",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.027311971640097132.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.027311971640097132.jpg"
    ],
    "size": "40x80",
    "color": "Gümüş",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_736",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Siyah 40x80",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "736",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6802564601600075.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6802564601600075.jpg"
    ],
    "size": "40x80",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_737",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Bone 40x80",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "737",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7681496747229692.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7681496747229692.jpg"
    ],
    "size": "40x80",
    "color": "Bone",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_2334",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Taupe 40x80",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2334",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7699655531482616.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7699655531482616.jpg"
    ],
    "size": "40x80",
    "color": "Taupe",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_739",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Gümüş 60x60",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "739",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21009432876646694.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21009432876646694.jpg"
    ],
    "size": "60x60",
    "color": "Gümüş",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_740",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Siyah 60x60",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "740",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6768008016363155.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6768008016363155.jpg"
    ],
    "size": "60x60",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_741",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Bone 60x60",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "741",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15129145895691742.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15129145895691742.jpg"
    ],
    "size": "60x60",
    "color": "Bone",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_742",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Taupe 60x60",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "742",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3354744753309691.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3354744753309691.jpg"
    ],
    "size": "60x60",
    "color": "Taupe",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_743",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Gümüş 40x40",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "743",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3615597709244379.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3615597709244379.jpg"
    ],
    "size": "40x40",
    "color": "Gümüş",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_744",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Siyah 40x40",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "744",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.647178372724668.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.647178372724668.jpg"
    ],
    "size": "40x40",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_745",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Bone 40x40",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "745",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7779792836146253.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7779792836146253.jpg"
    ],
    "size": "40x40",
    "color": "Bone",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_746",
    "brand": "Duratiles",
    "title": "GALERIA 20MM / 30MM Taupe 40x40",
    "seriesName": "GALERIA 20MM / 30MM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "746",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.030688571452348934.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.030688571452348934.jpg"
    ],
    "size": "40x40",
    "color": "Taupe",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Galeria Serisi çatlama ve kırılmaya karşı dayanıklılığı sayesinde ekonomik bir kaplama malzemesi olduğu gibi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_747",
    "brand": "Duratiles",
    "title": "HEMATIT Gri 60x60",
    "seriesName": "HEMATIT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "747",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13584898030161974.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13584898030161974.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mimarinin vazgeçilmeyen klasiği brüt beton görünümü Hematit Serisi sayesinde seramik şıklığıyla buluşuyor.</span>",
    "descriptionClean": "Mimarinin vazgeçilmeyen klasiği brüt beton görünümü Hematit Serisi sayesinde seramik şıklığıyla buluşuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_750",
    "brand": "Duratiles",
    "title": "HMADE Vison 60x60",
    "seriesName": "HMADE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "65385",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3142739902006062.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3142739902006062.jpg"
    ],
    "size": "60x60",
    "color": "Vison",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Balkon/Teras & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Hmade Serisi mükemmel teknik performansının yanı sıra dingin renk skalası ile şehir karmaşışından arınmış ,sade ama etkileyici bir mekana ilham veren ,etkileyici bir tasarıma sahip.</span>",
    "descriptionClean": "Hmade Serisi mükemmel teknik performansının yanı sıra dingin renk skalası ile şehir karmaşışından arınmış ,sade ama etkileyici bir mekana ilham veren ,etkileyici bir tasarıma sahip.",
    "source": "duratiles"
  },
  {
    "id": "dura_749",
    "brand": "Duratiles",
    "title": "HMADE Gri 60x60",
    "seriesName": "HMADE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "749",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5808046861351915.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5808046861351915.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Balkon/Teras & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Hmade Serisi mükemmel teknik performansının yanı sıra dingin renk skalası ile şehir karmaşışından arınmış ,sade ama etkileyici bir mekana ilham veren ,etkileyici bir tasarıma sahip.</span>",
    "descriptionClean": "Hmade Serisi mükemmel teknik performansının yanı sıra dingin renk skalası ile şehir karmaşışından arınmış ,sade ama etkileyici bir mekana ilham veren ,etkileyici bir tasarıma sahip.",
    "source": "duratiles"
  },
  {
    "id": "dura_748",
    "brand": "Duratiles",
    "title": "HMADE Sand 60x60",
    "seriesName": "HMADE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "73808",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9908289036269758.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9908289036269758.jpg"
    ],
    "size": "60x60",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Balkon/Teras",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Hmade Serisi mükemmel teknik performansının yanı sıra dingin renk skalası ile şehir karmaşışından arınmış ,sade ama etkileyici bir mekana ilham veren ,etkileyici bir tasarıma sahip.</span>",
    "descriptionClean": "Hmade Serisi mükemmel teknik performansının yanı sıra dingin renk skalası ile şehir karmaşışından arınmış ,sade ama etkileyici bir mekana ilham veren ,etkileyici bir tasarıma sahip.",
    "source": "duratiles"
  },
  {
    "id": "dura_751",
    "brand": "Duratiles",
    "title": "KEON Beyaz 60x120",
    "seriesName": "KEON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "67860",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8023132405521735.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8023132405521735.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Balkon/Teras & Banyo",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Balkon Teras",
      "V1",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Keon serisi, modern ve çarpıcı mekanlar tasarlar</span>",
    "descriptionClean": "Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Keon serisi, modern ve çarpıcı mekanlar tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_752",
    "brand": "Duratiles",
    "title": "KEON Gri 60x120",
    "seriesName": "KEON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "69335",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10340154852823202.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10340154852823202.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Ev içi Zemin & Balkon/Teras & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Keon serisi, modern ve çarpıcı mekanlar tasarlar</span>",
    "descriptionClean": "Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Keon serisi, modern ve çarpıcı mekanlar tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_753",
    "brand": "Duratiles",
    "title": "KEON Dekor 60x120",
    "seriesName": "KEON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "753",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6490759184623441.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6490759184623441.jpg"
    ],
    "size": "60x120",
    "color": "Dekor",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Balkon Teras",
      "V1",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Keon serisi, modern ve çarpıcı mekanlar tasarlar</span>",
    "descriptionClean": "Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Keon serisi, modern ve çarpıcı mekanlar tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_754",
    "brand": "Duratiles",
    "title": "KEON Carpet Dekor 60x120",
    "seriesName": "KEON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "754",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9301870253142563.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9301870253142563.jpg"
    ],
    "size": "60x120",
    "color": "Carpet Dekor",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Banyo",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Balkon Teras",
      "V1",
      "Endüstriyel Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Keon serisi, modern ve çarpıcı mekanlar tasarlar</span>",
    "descriptionClean": "Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Keon serisi, modern ve çarpıcı mekanlar tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_755",
    "brand": "Duratiles",
    "title": "KEON Beyaz 80x80",
    "seriesName": "KEON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "755",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3456978874581178.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3456978874581178.jpg"
    ],
    "size": "80x80",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Banyo",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Balkon Teras",
      "V1",
      "Endüstriyel Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Keon serisi, modern ve çarpıcı mekanlar tasarlar</span>",
    "descriptionClean": "Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Keon serisi, modern ve çarpıcı mekanlar tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_756",
    "brand": "Duratiles",
    "title": "KEON Gri 80x80",
    "seriesName": "KEON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "756",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36564265739717716.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36564265739717716.jpg"
    ],
    "size": "80x80",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Keon serisi, modern ve çarpıcı mekanlar tasarlar</span>",
    "descriptionClean": "Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Keon serisi, modern ve çarpıcı mekanlar tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_758",
    "brand": "Duratiles",
    "title": "KEON Gri 60x60",
    "seriesName": "KEON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "758",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5665731515349525.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5665731515349525.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Keon serisi, modern ve çarpıcı mekanlar tasarlar</span>",
    "descriptionClean": "Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Keon serisi, modern ve çarpıcı mekanlar tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_757",
    "brand": "Duratiles",
    "title": "KEON Beyaz 60x60",
    "seriesName": "KEON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "757",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.870138151171351.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.870138151171351.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "V1"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Keon serisi, modern ve çarpıcı mekanlar tasarlar</span>",
    "descriptionClean": "Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Keon serisi, modern ve çarpıcı mekanlar tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_760",
    "brand": "Duratiles",
    "title": "KEON Gri 30x60",
    "seriesName": "KEON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "760",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44332222091438167.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44332222091438167.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Ev içi Zemin & Banyo & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Banyo",
      "Endüstriyel Zemin",
      "V1"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Keon serisi, modern ve çarpıcı mekanlar tasarlar</span>",
    "descriptionClean": "Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Keon serisi, modern ve çarpıcı mekanlar tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_759",
    "brand": "Duratiles",
    "title": "KEON Beyaz 30x60",
    "seriesName": "KEON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "759",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7041336277208191.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7041336277208191.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Ev içi Zemin & Banyo & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Banyo",
      "Endüstriyel Zemin",
      "V1",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Keon serisi, modern ve çarpıcı mekanlar tasarlar</span>",
    "descriptionClean": "Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Keon serisi, modern ve çarpıcı mekanlar tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_761",
    "brand": "Duratiles",
    "title": "KOBLENZ Beyaz 60x60",
    "seriesName": "KOBLENZ",
    "collection": "Beton",
    "category": "Beton",
    "sku": "761",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.024626720659591816.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.024626720659591816.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Ev içi Zemin & Banyo",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Banyo",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beton dokusuyla Koblenz Porselen Karoları mekanlara endüstriyel bir şıklık katar.</span>",
    "descriptionClean": "Beton dokusuyla Koblenz Porselen Karoları mekanlara endüstriyel bir şıklık katar.",
    "source": "duratiles"
  },
  {
    "id": "dura_762",
    "brand": "Duratiles",
    "title": "KOBLENZ Antrasit 60x60",
    "seriesName": "KOBLENZ",
    "collection": "Beton",
    "category": "Beton",
    "sku": "762",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5371800805779832.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5371800805779832.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Ev içi Zemin & Banyo",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Banyo",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beton dokusuyla Koblenz Porselen Karoları mekanlara endüstriyel bir şıklık katar.</span>",
    "descriptionClean": "Beton dokusuyla Koblenz Porselen Karoları mekanlara endüstriyel bir şıklık katar.",
    "source": "duratiles"
  },
  {
    "id": "dura_763",
    "brand": "Duratiles",
    "title": "KOBLENZ Smoke 60x60",
    "seriesName": "KOBLENZ",
    "collection": "Beton",
    "category": "Beton",
    "sku": "763",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7519585263386308.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7519585263386308.jpg"
    ],
    "size": "60x60",
    "color": "Smoke",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Ev içi Zemin & Banyo",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Banyo",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beton dokusuyla Koblenz Porselen Karoları mekanlara endüstriyel bir şıklık katar.</span>",
    "descriptionClean": "Beton dokusuyla Koblenz Porselen Karoları mekanlara endüstriyel bir şıklık katar.",
    "source": "duratiles"
  },
  {
    "id": "dura_764",
    "brand": "Duratiles",
    "title": "KOBLENZ Vizon 60x60",
    "seriesName": "KOBLENZ",
    "collection": "Beton",
    "category": "Beton",
    "sku": "764",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9149294659656372.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9149294659656372.jpg"
    ],
    "size": "60x60",
    "color": "Vizon",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Ev içi Zemin & Banyo",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Banyo",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beton dokusuyla Koblenz Porselen Karoları mekanlara endüstriyel bir şıklık katar.</span>",
    "descriptionClean": "Beton dokusuyla Koblenz Porselen Karoları mekanlara endüstriyel bir şıklık katar.",
    "source": "duratiles"
  },
  {
    "id": "dura_765",
    "brand": "Duratiles",
    "title": "LIBAD AQUA Aqua 60x120",
    "seriesName": "LIBAD AQUA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "765",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7251870421349011.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7251870421349011.jpg"
    ],
    "size": "60x120",
    "color": "Aqua",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Ev içi Zemin & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Banyo",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Libada Aqua Porselen Karoları benzersiz tasarımlarıyla mekanlara dinamizm katıyor</span>",
    "descriptionClean": "Libada Aqua Porselen Karoları benzersiz tasarımlarıyla mekanlara dinamizm katıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_766",
    "brand": "Duratiles",
    "title": "LIGHTNING Gri 30x60",
    "seriesName": "LIGHTNING",
    "collection": "Beton",
    "category": "Beton",
    "sku": "766",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46999175148979955.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46999175148979955.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Işığı yansıtan özel dokusu ve yarı parlak yüzeyiyle mekânlara derinlik ve zarafet kazandırır. Modern tasarımlar için şık, sade ve etkileyici bir zemin alternatifi sunar.</span>",
    "descriptionClean": "Işığı yansıtan özel dokusu ve yarı parlak yüzeyiyle mekânlara derinlik ve zarafet kazandırır. Modern tasarımlar için şık, sade ve etkileyici bir zemin alternatifi sunar.",
    "source": "duratiles"
  },
  {
    "id": "dura_769",
    "brand": "Duratiles",
    "title": "LOFT Bone 60x120",
    "seriesName": "LOFT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "67218",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6360493464919745.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6360493464919745.jpg"
    ],
    "size": "60x120",
    "color": "Bone",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "V3",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.</span>",
    "descriptionClean": "Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.",
    "source": "duratiles"
  },
  {
    "id": "dura_770",
    "brand": "Duratiles",
    "title": "LOFT Gri 60x120",
    "seriesName": "LOFT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "67216",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13792163039223004.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13792163039223004.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "V3",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.</span>",
    "descriptionClean": "Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.",
    "source": "duratiles"
  },
  {
    "id": "dura_771",
    "brand": "Duratiles",
    "title": "LOFT Cement 60x120",
    "seriesName": "LOFT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "771",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.05397958135869185.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.05397958135869185.jpg"
    ],
    "size": "60x120",
    "color": "Cement",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.</span>",
    "descriptionClean": "Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.",
    "source": "duratiles"
  },
  {
    "id": "dura_772",
    "brand": "Duratiles",
    "title": "LOFT Antrasit 60x120",
    "seriesName": "LOFT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "67222",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1455099637960069.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1455099637960069.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.</span>",
    "descriptionClean": "Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.",
    "source": "duratiles"
  },
  {
    "id": "dura_773",
    "brand": "Duratiles",
    "title": "LOFT Bone 80x80",
    "seriesName": "LOFT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "773",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4629506310780438.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4629506310780438.jpg"
    ],
    "size": "80x80",
    "color": "Bone",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.</span>",
    "descriptionClean": "Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.",
    "source": "duratiles"
  },
  {
    "id": "dura_774",
    "brand": "Duratiles",
    "title": "LOFT Cement 80x80",
    "seriesName": "LOFT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "774",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3116141688189019.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3116141688189019.jpg"
    ],
    "size": "80x80",
    "color": "Cement",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.</span>",
    "descriptionClean": "Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.",
    "source": "duratiles"
  },
  {
    "id": "dura_775",
    "brand": "Duratiles",
    "title": "LOFT Gri 80x80",
    "seriesName": "LOFT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "775",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8328347115069045.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8328347115069045.jpg"
    ],
    "size": "80x80",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.</span>",
    "descriptionClean": "Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.",
    "source": "duratiles"
  },
  {
    "id": "dura_776",
    "brand": "Duratiles",
    "title": "LOFT Antrasit 80x80",
    "seriesName": "LOFT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "776",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.33234892035722785.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.33234892035722785.jpg"
    ],
    "size": "80x80",
    "color": "Antrasit",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.</span>",
    "descriptionClean": "Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.",
    "source": "duratiles"
  },
  {
    "id": "dura_777",
    "brand": "Duratiles",
    "title": "LOFT Bone 60x60",
    "seriesName": "LOFT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "777",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5998889327500225.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5998889327500225.jpg"
    ],
    "size": "60x60",
    "color": "Bone",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.</span>",
    "descriptionClean": "Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.",
    "source": "duratiles"
  },
  {
    "id": "dura_778",
    "brand": "Duratiles",
    "title": "LOFT Bej 60x60",
    "seriesName": "LOFT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "778",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.616007842684364.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.616007842684364.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.</span>",
    "descriptionClean": "Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.",
    "source": "duratiles"
  },
  {
    "id": "dura_779",
    "brand": "Duratiles",
    "title": "LOFT Gri 60x60",
    "seriesName": "LOFT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "779",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5769507773544751.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5769507773544751.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.</span>",
    "descriptionClean": "Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.",
    "source": "duratiles"
  },
  {
    "id": "dura_780",
    "brand": "Duratiles",
    "title": "LOFT Antrasit 60x60",
    "seriesName": "LOFT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "780",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08130716182490216.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08130716182490216.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.</span>",
    "descriptionClean": "Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.",
    "source": "duratiles"
  },
  {
    "id": "dura_781",
    "brand": "Duratiles",
    "title": "LOFT Dekor 60x60",
    "seriesName": "LOFT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "781",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4097837132946325.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4097837132946325.jpg"
    ],
    "size": "60x60",
    "color": "Dekor",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.</span>",
    "descriptionClean": "Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.",
    "source": "duratiles"
  },
  {
    "id": "dura_782",
    "brand": "Duratiles",
    "title": "MAPS Beyaz 60x120",
    "seriesName": "MAPS",
    "collection": "Beton",
    "category": "Beton",
    "sku": "782",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.630256636736474.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.630256636736474.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.</span>",
    "descriptionClean": "Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.",
    "source": "duratiles"
  },
  {
    "id": "dura_783",
    "brand": "Duratiles",
    "title": "MAPS Beyaz 30x120",
    "seriesName": "MAPS",
    "collection": "Beton",
    "category": "Beton",
    "sku": "783",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8597705465042702.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8597705465042702.jpg"
    ],
    "size": "30x120",
    "color": "Beyaz",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.</span>",
    "descriptionClean": "Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.",
    "source": "duratiles"
  },
  {
    "id": "dura_784",
    "brand": "Duratiles",
    "title": "MAPS Beyaz 40x80",
    "seriesName": "MAPS",
    "collection": "Beton",
    "category": "Beton",
    "sku": "784",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4463756154364169.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4463756154364169.jpg"
    ],
    "size": "40x80",
    "color": "Beyaz",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.</span>",
    "descriptionClean": "Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.",
    "source": "duratiles"
  },
  {
    "id": "dura_785",
    "brand": "Duratiles",
    "title": "MAPS Beyaz 60x60",
    "seriesName": "MAPS",
    "collection": "Beton",
    "category": "Beton",
    "sku": "785",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7781792177899535.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7781792177899535.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.</span>",
    "descriptionClean": "Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.",
    "source": "duratiles"
  },
  {
    "id": "dura_786",
    "brand": "Duratiles",
    "title": "MAPS Beyaz 40x40",
    "seriesName": "MAPS",
    "collection": "Beton",
    "category": "Beton",
    "sku": "786",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.42914829807637.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.42914829807637.jpg"
    ],
    "size": "40x40",
    "color": "Beyaz",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.</span>",
    "descriptionClean": "Değişimi güvenle, zarafetle buluşturduk. Yeni bir tasarım, yeni bir kimlik... Yaşamın enerjisini yansıtan bir seri... Loft serisi hayatla uyum içinde.",
    "source": "duratiles"
  },
  {
    "id": "dura_787",
    "brand": "Duratiles",
    "title": "MARMOSTONE Antrasit 60x120",
    "seriesName": "MARMOSTONE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "787",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6076567705543672.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6076567705543672.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Banyo & Ev içi Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Özel mekânlara karakter katan bir seri... Marmostone serisi ile yaşam alanlarınıza seramikten gelen güzelli��i dâhil edin.</span>",
    "descriptionClean": "Özel mekânlara karakter katan bir seri... Marmostone serisi ile yaşam alanlarınıza seramikten gelen güzelli��i dâhil edin.",
    "source": "duratiles"
  },
  {
    "id": "dura_797",
    "brand": "Duratiles",
    "title": "MAROON Antrasit 120x120",
    "seriesName": "MAROON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "797",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6901047951480134.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6901047951480134.jpg"
    ],
    "size": "120x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.</span>",
    "descriptionClean": "Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.",
    "source": "duratiles"
  },
  {
    "id": "dura_796",
    "brand": "Duratiles",
    "title": "MAROON Gri 120x120",
    "seriesName": "MAROON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "796",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6263323934874456.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6263323934874456.jpg"
    ],
    "size": "120x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.</span>",
    "descriptionClean": "Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.",
    "source": "duratiles"
  },
  {
    "id": "dura_795",
    "brand": "Duratiles",
    "title": "MAROON Bej 120x120",
    "seriesName": "MAROON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "795",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5390840998893741.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5390840998893741.jpg"
    ],
    "size": "120x120",
    "color": "Bej",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.</span>",
    "descriptionClean": "Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.",
    "source": "duratiles"
  },
  {
    "id": "dura_794",
    "brand": "Duratiles",
    "title": "MAROON Antrasit 60x120",
    "seriesName": "MAROON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "794",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.778991771178901.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.778991771178901.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.</span>",
    "descriptionClean": "Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.",
    "source": "duratiles"
  },
  {
    "id": "dura_793",
    "brand": "Duratiles",
    "title": "MAROON Gri 60x120",
    "seriesName": "MAROON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "793",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4844659323571848.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4844659323571848.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.</span>",
    "descriptionClean": "Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.",
    "source": "duratiles"
  },
  {
    "id": "dura_792",
    "brand": "Duratiles",
    "title": "MAROON Bej 60x120",
    "seriesName": "MAROON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "792",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13234476159461783.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13234476159461783.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Dış Cephe & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Dış Cephe",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.</span>",
    "descriptionClean": "Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.",
    "source": "duratiles"
  },
  {
    "id": "dura_791",
    "brand": "Duratiles",
    "title": "MAROON Fildişi 90x180",
    "seriesName": "MAROON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "791",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5865019985028466.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5865019985028466.jpg"
    ],
    "size": "90x180",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.</span>",
    "descriptionClean": "Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.",
    "source": "duratiles"
  },
  {
    "id": "dura_790",
    "brand": "Duratiles",
    "title": "MAROON Antrasit 90x180",
    "seriesName": "MAROON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "790",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8932168642007207.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8932168642007207.jpg"
    ],
    "size": "90x180",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.</span>",
    "descriptionClean": "Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.",
    "source": "duratiles"
  },
  {
    "id": "dura_789",
    "brand": "Duratiles",
    "title": "MAROON Gri 90x180",
    "seriesName": "MAROON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "789",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1630951465600763.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1630951465600763.jpg"
    ],
    "size": "90x180",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.</span>",
    "descriptionClean": "Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.",
    "source": "duratiles"
  },
  {
    "id": "dura_788",
    "brand": "Duratiles",
    "title": "MAROON Bej 90x180",
    "seriesName": "MAROON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "788",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9241335326834466.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9241335326834466.jpg"
    ],
    "size": "90x180",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.</span>",
    "descriptionClean": "Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.",
    "source": "duratiles"
  },
  {
    "id": "dura_815",
    "brand": "Duratiles",
    "title": "MAXXI Antrasit 30x60",
    "seriesName": "MAXXI",
    "collection": "Beton",
    "category": "Beton",
    "sku": "815",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.019922613027183234.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.019922613027183234.jpg"
    ],
    "size": "30x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bol dekor alternatifi ile mekanlara hareket katmayı amaçlayan Maxxi Serisi ile kendinizi daha çok yansıtabileceğiniz özgür mekanlar tasarlamak hiç zor değil</span>",
    "descriptionClean": "Bol dekor alternatifi ile mekanlara hareket katmayı amaçlayan Maxxi Serisi ile kendinizi daha çok yansıtabileceğiniz özgür mekanlar tasarlamak hiç zor değil",
    "source": "duratiles"
  },
  {
    "id": "dura_814",
    "brand": "Duratiles",
    "title": "MAXXI Gri 30x60",
    "seriesName": "MAXXI",
    "collection": "Beton",
    "category": "Beton",
    "sku": "814",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23627112766623615.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23627112766623615.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bol dekor alternatifi ile mekanlara hareket katmayı amaçlayan Maxxi Serisi ile kendinizi daha çok yansıtabileceğiniz özgür mekanlar tasarlamak hiç zor değil</span>",
    "descriptionClean": "Bol dekor alternatifi ile mekanlara hareket katmayı amaçlayan Maxxi Serisi ile kendinizi daha çok yansıtabileceğiniz özgür mekanlar tasarlamak hiç zor değil",
    "source": "duratiles"
  },
  {
    "id": "dura_813",
    "brand": "Duratiles",
    "title": "MAXXI Antrasit Dekor 60x60",
    "seriesName": "MAXXI",
    "collection": "Beton",
    "category": "Beton",
    "sku": "813",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7688915114079524.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7688915114079524.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit Dekor",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bol dekor alternatifi ile mekanlara hareket katmayı amaçlayan Maxxi Serisi ile kendinizi daha çok yansıtabileceğiniz özgür mekanlar tasarlamak hiç zor değil</span>",
    "descriptionClean": "Bol dekor alternatifi ile mekanlara hareket katmayı amaçlayan Maxxi Serisi ile kendinizi daha çok yansıtabileceğiniz özgür mekanlar tasarlamak hiç zor değil",
    "source": "duratiles"
  },
  {
    "id": "dura_812",
    "brand": "Duratiles",
    "title": "MAXXI Gri Dekor 60x60",
    "seriesName": "MAXXI",
    "collection": "Beton",
    "category": "Beton",
    "sku": "812",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15433144236909468.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15433144236909468.jpg"
    ],
    "size": "60x60",
    "color": "Gri Dekor",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bol dekor alternatifi ile mekanlara hareket katmayı amaçlayan Maxxi Serisi ile kendinizi daha çok yansıtabileceğiniz özgür mekanlar tasarlamak hiç zor değil</span>",
    "descriptionClean": "Bol dekor alternatifi ile mekanlara hareket katmayı amaçlayan Maxxi Serisi ile kendinizi daha çok yansıtabileceğiniz özgür mekanlar tasarlamak hiç zor değil",
    "source": "duratiles"
  },
  {
    "id": "dura_811",
    "brand": "Duratiles",
    "title": "MAXXI Antrasit Dekor 100x100",
    "seriesName": "MAXXI",
    "collection": "Beton",
    "category": "Beton",
    "sku": "811",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5957285050719998.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5957285050719998.jpg"
    ],
    "size": "100x100",
    "color": "Antrasit Dekor",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bol dekor alternatifi ile mekanlara hareket katmayı amaçlayan Maxxi Serisi ile kendinizi daha çok yansıtabileceğiniz özgür mekanlar tasarlamak hiç zor değil</span>",
    "descriptionClean": "Bol dekor alternatifi ile mekanlara hareket katmayı amaçlayan Maxxi Serisi ile kendinizi daha çok yansıtabileceğiniz özgür mekanlar tasarlamak hiç zor değil",
    "source": "duratiles"
  },
  {
    "id": "dura_810",
    "brand": "Duratiles",
    "title": "MAXXI Antrasit 100x100",
    "seriesName": "MAXXI",
    "collection": "Beton",
    "category": "Beton",
    "sku": "810",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2807562813711082.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2807562813711082.jpg"
    ],
    "size": "100x100",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bol dekor alternatifi ile mekanlara hareket katmayı amaçlayan Maxxi Serisi ile kendinizi daha çok yansıtabileceğiniz özgür mekanlar tasarlamak hiç zor değil</span>",
    "descriptionClean": "Bol dekor alternatifi ile mekanlara hareket katmayı amaçlayan Maxxi Serisi ile kendinizi daha çok yansıtabileceğiniz özgür mekanlar tasarlamak hiç zor değil",
    "source": "duratiles"
  },
  {
    "id": "dura_809",
    "brand": "Duratiles",
    "title": "MAXXI Gri Dekor 100x100",
    "seriesName": "MAXXI",
    "collection": "Beton",
    "category": "Beton",
    "sku": "809",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.219056216885419.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.219056216885419.jpg"
    ],
    "size": "100x100",
    "color": "Gri Dekor",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bol dekor alternatifi ile mekanlara hareket katmayı amaçlayan Maxxi Serisi ile kendinizi daha çok yansıtabileceğiniz özgür mekanlar tasarlamak hiç zor değil</span>",
    "descriptionClean": "Bol dekor alternatifi ile mekanlara hareket katmayı amaçlayan Maxxi Serisi ile kendinizi daha çok yansıtabileceğiniz özgür mekanlar tasarlamak hiç zor değil",
    "source": "duratiles"
  },
  {
    "id": "dura_808",
    "brand": "Duratiles",
    "title": "MAXXI Gri 100x100",
    "seriesName": "MAXXI",
    "collection": "Beton",
    "category": "Beton",
    "sku": "808",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.05827446412432158.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.05827446412432158.jpg"
    ],
    "size": "100x100",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bol dekor alternatifi ile mekanlara hareket katmayı amaçlayan Maxxi Serisi ile kendinizi daha çok yansıtabileceğiniz özgür mekanlar tasarlamak hiç zor değil</span>",
    "descriptionClean": "Bol dekor alternatifi ile mekanlara hareket katmayı amaçlayan Maxxi Serisi ile kendinizi daha çok yansıtabileceğiniz özgür mekanlar tasarlamak hiç zor değil",
    "source": "duratiles"
  },
  {
    "id": "dura_807",
    "brand": "Duratiles",
    "title": "MAXXI Antrasit 60x120",
    "seriesName": "MAXXI",
    "collection": "Beton",
    "category": "Beton",
    "sku": "807",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.906808745458936.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.906808745458936.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bol dekor alternatifi ile mekanlara hareket katmayı amaçlayan Maxxi Serisi ile kendinizi daha çok yansıtabileceğiniz özgür mekanlar tasarlamak hiç zor değil</span>",
    "descriptionClean": "Bol dekor alternatifi ile mekanlara hareket katmayı amaçlayan Maxxi Serisi ile kendinizi daha çok yansıtabileceğiniz özgür mekanlar tasarlamak hiç zor değil",
    "source": "duratiles"
  },
  {
    "id": "dura_806",
    "brand": "Duratiles",
    "title": "MAXXI Gri 60x120",
    "seriesName": "MAXXI",
    "collection": "Beton",
    "category": "Beton",
    "sku": "806",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2656606987009966.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2656606987009966.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bol dekor alternatifi ile mekanlara hareket katmayı amaçlayan Maxxi Serisi ile kendinizi daha çok yansıtabileceğiniz özgür mekanlar tasarlamak hiç zor değil</span>",
    "descriptionClean": "Bol dekor alternatifi ile mekanlara hareket katmayı amaçlayan Maxxi Serisi ile kendinizi daha çok yansıtabileceğiniz özgür mekanlar tasarlamak hiç zor değil",
    "source": "duratiles"
  },
  {
    "id": "dura_816",
    "brand": "Duratiles",
    "title": "METALLIC CORTEN Kahve 100x100",
    "seriesName": "METALLIC CORTEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "816",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28210503867669223.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28210503867669223.jpg"
    ],
    "size": "100x100",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Mekanlara yeni bir hareket ve derinlik getiren Metallic Corten Porselen Karoları, maximum konforu hedefliyor.</span>",
    "descriptionClean": "Mekanlara yeni bir hareket ve derinlik getiren Metallic Corten Porselen Karoları, maximum konforu hedefliyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_817",
    "brand": "Duratiles",
    "title": "METALLIC IRON Siyah 100x100",
    "seriesName": "METALLIC IRON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "817",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13165157492284407.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13165157492284407.jpg"
    ],
    "size": "100x100",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Endüstriyel Zemin & Ev içi Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Özel mekânlara karakter katan bir seri... Metallic Iron serisi ile yaşam alanlarınıza seramikten gelen güzelliği dâhil edin.</span>",
    "descriptionClean": "Özel mekânlara karakter katan bir seri... Metallic Iron serisi ile yaşam alanlarınıza seramikten gelen güzelliği dâhil edin.",
    "source": "duratiles"
  },
  {
    "id": "dura_819",
    "brand": "Duratiles",
    "title": "MIRAVA Gri 60x120",
    "seriesName": "MIRAVA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "819",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9959617960572575.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9959617960572575.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Mirava Porselen Karoları ...</span>",
    "descriptionClean": "Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Mirava Porselen Karoları ...",
    "source": "duratiles"
  },
  {
    "id": "dura_818",
    "brand": "Duratiles",
    "title": "MIRAVA Siyah 60x120",
    "seriesName": "MIRAVA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "818",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43131801873886944.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43131801873886944.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Mirava Porselen Karoları ...</span>",
    "descriptionClean": "Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Mirava Porselen Karoları ...",
    "source": "duratiles"
  },
  {
    "id": "dura_820",
    "brand": "Duratiles",
    "title": "MISCHEN Koyu 45x90",
    "seriesName": "MISCHEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "820",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.943463714898064.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.943463714898064.jpg"
    ],
    "size": "45x90",
    "color": "Koyu",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_821",
    "brand": "Duratiles",
    "title": "MISCHEN Açık 45x90",
    "seriesName": "MISCHEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "821",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07628365543666404.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07628365543666404.jpg"
    ],
    "size": "45x90",
    "color": "Açık",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_822",
    "brand": "Duratiles",
    "title": "MISCHEN Koyu 60x120",
    "seriesName": "MISCHEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "822",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.49175505188848456.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.49175505188848456.jpg"
    ],
    "size": "60x120",
    "color": "Koyu",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_823",
    "brand": "Duratiles",
    "title": "MISCHEN Açık 60x120",
    "seriesName": "MISCHEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "823",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19840437059924787.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19840437059924787.jpg"
    ],
    "size": "60x120",
    "color": "Açık",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_824",
    "brand": "Duratiles",
    "title": "MISCHEN Koyu 100x100",
    "seriesName": "MISCHEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "824",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7260862545988843.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7260862545988843.jpg"
    ],
    "size": "100x100",
    "color": "Koyu",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_825",
    "brand": "Duratiles",
    "title": "MISCHEN Açık 100x100",
    "seriesName": "MISCHEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "825",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.060497345560958427.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.060497345560958427.jpg"
    ],
    "size": "100x100",
    "color": "Açık",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_826",
    "brand": "Duratiles",
    "title": "MISCHEN Koyu 80x80",
    "seriesName": "MISCHEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "826",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6342722274202508.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6342722274202508.jpg"
    ],
    "size": "80x80",
    "color": "Koyu",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_827",
    "brand": "Duratiles",
    "title": "MISCHEN Açık 80x80",
    "seriesName": "MISCHEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "827",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8351017799760101.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8351017799760101.jpg"
    ],
    "size": "80x80",
    "color": "Açık",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_828",
    "brand": "Duratiles",
    "title": "MISCHEN Koyu 40x80",
    "seriesName": "MISCHEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "828",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9430233868757807.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9430233868757807.jpg"
    ],
    "size": "40x80",
    "color": "Koyu",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_829",
    "brand": "Duratiles",
    "title": "MISCHEN Açık 40x80",
    "seriesName": "MISCHEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "829",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9938716715233521.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9938716715233521.jpg"
    ],
    "size": "40x80",
    "color": "Açık",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_830",
    "brand": "Duratiles",
    "title": "MISCHEN Koyu 60x60",
    "seriesName": "MISCHEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "830",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9549630859398159.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9549630859398159.jpg"
    ],
    "size": "60x60",
    "color": "Koyu",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_831",
    "brand": "Duratiles",
    "title": "MISCHEN Açık 60x60",
    "seriesName": "MISCHEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "831",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16026534282907212.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16026534282907212.jpg"
    ],
    "size": "60x60",
    "color": "Açık",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_833",
    "brand": "Duratiles",
    "title": "MISCHEN Koyu 40x40",
    "seriesName": "MISCHEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "833",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8276736884651721.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8276736884651721.jpg"
    ],
    "size": "40x40",
    "color": "Koyu",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_832",
    "brand": "Duratiles",
    "title": "MISCHEN Açık 40x40",
    "seriesName": "MISCHEN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "832",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.715646254478769.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.715646254478769.jpg"
    ],
    "size": "40x40",
    "color": "Açık",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Mischen Serisi dark ve light renk seçenekleri ile yaşanılası mekanlar yaratmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_834",
    "brand": "Duratiles",
    "title": "MODUS Gri 100x100",
    "seriesName": "MODUS",
    "collection": "Beton",
    "category": "Beton",
    "sku": "834",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5683047723334926.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5683047723334926.jpg"
    ],
    "size": "100x100",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın şıklığı ile dingin mekanlar tasarlayan Modus porselen karoları zamansız yaşam alanları kurgular.</span>",
    "descriptionClean": "Yalın şıklığı ile dingin mekanlar tasarlayan Modus porselen karoları zamansız yaşam alanları kurgular.",
    "source": "duratiles"
  },
  {
    "id": "dura_836",
    "brand": "Duratiles",
    "title": "MODUS Antrasit 100x100",
    "seriesName": "MODUS",
    "collection": "Beton",
    "category": "Beton",
    "sku": "836",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5212710971752641.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5212710971752641.jpg"
    ],
    "size": "100x100",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın şıklığı ile dingin mekanlar tasarlayan Modus porselen karoları zamansız yaşam alanları kurgular.</span>",
    "descriptionClean": "Yalın şıklığı ile dingin mekanlar tasarlayan Modus porselen karoları zamansız yaşam alanları kurgular.",
    "source": "duratiles"
  },
  {
    "id": "dura_838",
    "brand": "Duratiles",
    "title": "MOOR Sand 60x120",
    "seriesName": "MOOR",
    "collection": "Beton",
    "category": "Beton",
    "sku": "838",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6807994315330559.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6807994315330559.jpg"
    ],
    "size": "60x120",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Konfora estetik kattık, doğal taştan ilham aldık ve Moor serisini tasarladık. Doğanın ruhunu tüm alanlarınıza taşıyın. Her adımda seramiğin karakteristik duygusunu hissedeceksiniz.</span>",
    "descriptionClean": "Konfora estetik kattık, doğal taştan ilham aldık ve Moor serisini tasarladık. Doğanın ruhunu tüm alanlarınıza taşıyın. Her adımda seramiğin karakteristik duygusunu hissedeceksiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_837",
    "brand": "Duratiles",
    "title": "MOOR Designo 60x120",
    "seriesName": "MOOR",
    "collection": "Beton",
    "category": "Beton",
    "sku": "837",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.779727969174678.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.779727969174678.jpg"
    ],
    "size": "60x120",
    "color": "Designo",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Konfora estetik kattık, doğal taştan ilham aldık ve Moor serisini tasarladık. Doğanın ruhunu tüm alanlarınıza taşıyın. Her adımda seramiğin karakteristik duygusunu hissedeceksiniz.</span>",
    "descriptionClean": "Konfora estetik kattık, doğal taştan ilham aldık ve Moor serisini tasarladık. Doğanın ruhunu tüm alanlarınıza taşıyın. Her adımda seramiğin karakteristik duygusunu hissedeceksiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_839",
    "brand": "Duratiles",
    "title": "NANTES Taupe 60x120",
    "seriesName": "NANTES",
    "collection": "Beton",
    "category": "Beton",
    "sku": "839",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5551915157175772.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5551915157175772.jpg"
    ],
    "size": "60x120",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Dış Cephe & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Dış Cephe",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor</span>",
    "descriptionClean": "Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_840",
    "brand": "Duratiles",
    "title": "NANTES Gri 60x120",
    "seriesName": "NANTES",
    "collection": "Beton",
    "category": "Beton",
    "sku": "840",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4799585125837712.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4799585125837712.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Dış Cephe & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Dış Cephe",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor</span>",
    "descriptionClean": "Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_841",
    "brand": "Duratiles",
    "title": "NANTES Bej 60x120",
    "seriesName": "NANTES",
    "collection": "Beton",
    "category": "Beton",
    "sku": "841",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44521383401786174.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44521383401786174.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Dış Cephe & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Dış Cephe",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor</span>",
    "descriptionClean": "Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_842",
    "brand": "Duratiles",
    "title": "NANTES Antrasit 60x120",
    "seriesName": "NANTES",
    "collection": "Beton",
    "category": "Beton",
    "sku": "842",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12239898203285315.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12239898203285315.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Dış Cephe & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Dış Cephe",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor</span>",
    "descriptionClean": "Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_843",
    "brand": "Duratiles",
    "title": "NANTES Taupe 100x100",
    "seriesName": "NANTES",
    "collection": "Beton",
    "category": "Beton",
    "sku": "843",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6734251690970888.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6734251690970888.jpg"
    ],
    "size": "100x100",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Dış Cephe & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Dış Cephe",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor</span>",
    "descriptionClean": "Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_844",
    "brand": "Duratiles",
    "title": "NANTES Gri 100x100",
    "seriesName": "NANTES",
    "collection": "Beton",
    "category": "Beton",
    "sku": "844",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4424454879269859.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4424454879269859.jpg"
    ],
    "size": "100x100",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Dış Cephe & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Dış Cephe",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor</span>",
    "descriptionClean": "Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_845",
    "brand": "Duratiles",
    "title": "NANTES Bej 100x100",
    "seriesName": "NANTES",
    "collection": "Beton",
    "category": "Beton",
    "sku": "845",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.498313860357696.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.498313860357696.jpg"
    ],
    "size": "100x100",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Dış Cephe & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Dış Cephe",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor</span>",
    "descriptionClean": "Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_846",
    "brand": "Duratiles",
    "title": "NANTES Antrasit 100x100",
    "seriesName": "NANTES",
    "collection": "Beton",
    "category": "Beton",
    "sku": "846",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5718214049547935.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5718214049547935.jpg"
    ],
    "size": "100x100",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Dış Cephe & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Dış Cephe",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor</span>",
    "descriptionClean": "Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_847",
    "brand": "Duratiles",
    "title": "NANTES Taupe 60x60",
    "seriesName": "NANTES",
    "collection": "Beton",
    "category": "Beton",
    "sku": "847",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0006449138048301162.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0006449138048301162.jpg"
    ],
    "size": "60x60",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Dış Cephe & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Dış Cephe",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor</span>",
    "descriptionClean": "Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_848",
    "brand": "Duratiles",
    "title": "NANTES Gri 60x60",
    "seriesName": "NANTES",
    "collection": "Beton",
    "category": "Beton",
    "sku": "848",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.38804971479078276.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.38804971479078276.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Dış Cephe & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Dış Cephe",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor</span>",
    "descriptionClean": "Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_849",
    "brand": "Duratiles",
    "title": "NANTES Bej 60x60",
    "seriesName": "NANTES",
    "collection": "Beton",
    "category": "Beton",
    "sku": "849",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3831816918199821.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3831816918199821.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Dış Cephe & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Dış Cephe",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor</span>",
    "descriptionClean": "Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_850",
    "brand": "Duratiles",
    "title": "NANTES Antrasit 60x60",
    "seriesName": "NANTES",
    "collection": "Beton",
    "category": "Beton",
    "sku": "850",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6741211031844047.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6741211031844047.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Dış Cephe & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Dış Cephe",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor</span>",
    "descriptionClean": "Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_851",
    "brand": "Duratiles",
    "title": "NANTES Taupe 30x60",
    "seriesName": "NANTES",
    "collection": "Beton",
    "category": "Beton",
    "sku": "851",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11805145558741759.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11805145558741759.jpg"
    ],
    "size": "30x60",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Dış Cephe & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Dış Cephe",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor</span>",
    "descriptionClean": "Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_852",
    "brand": "Duratiles",
    "title": "NANTES Gri 30x60",
    "seriesName": "NANTES",
    "collection": "Beton",
    "category": "Beton",
    "sku": "852",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.028616999157777157.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.028616999157777157.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Dış Cephe & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Dış Cephe",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor</span>",
    "descriptionClean": "Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_853",
    "brand": "Duratiles",
    "title": "NANTES Bej 30x60",
    "seriesName": "NANTES",
    "collection": "Beton",
    "category": "Beton",
    "sku": "853",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3219975582424969.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3219975582424969.jpg"
    ],
    "size": "30x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Dış Cephe & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Dış Cephe",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor</span>",
    "descriptionClean": "Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_854",
    "brand": "Duratiles",
    "title": "NANTES Antrasit 30x60",
    "seriesName": "NANTES",
    "collection": "Beton",
    "category": "Beton",
    "sku": "854",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.136670287585555.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.136670287585555.jpg"
    ],
    "size": "30x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Balkon/Teras & Dış Cephe & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Dış Cephe",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor</span>",
    "descriptionClean": "Nantes Serisinin net yalın tarzı beton görünümü ve mat yüzeyi zamanının ötesine geçen bir güzelliği mekanlarınıza taşımanıza olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_855",
    "brand": "Duratiles",
    "title": "NEW FOSSIL Gri 60x120",
    "seriesName": "NEW FOSSIL",
    "collection": "Beton",
    "category": "Beton",
    "sku": "855",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48063405678543014.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48063405678543014.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Mat mermer dokusuyla güncel dekorasyon trendlerine cevap veren New Fossil Porselen Karoları yalın şıklığını yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Mat mermer dokusuyla güncel dekorasyon trendlerine cevap veren New Fossil Porselen Karoları yalın şıklığını yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_856",
    "brand": "Duratiles",
    "title": "NEW FOSSIL Fildişi 60x120",
    "seriesName": "NEW FOSSIL",
    "collection": "Beton",
    "category": "Beton",
    "sku": "856",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5143551624213566.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5143551624213566.jpg"
    ],
    "size": "60x120",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Havuz & Endüstriyel Zemin",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Mat mermer dokusuyla güncel dekorasyon trendlerine cevap veren New Fossil Porselen Karoları yalın şıklığını yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Mat mermer dokusuyla güncel dekorasyon trendlerine cevap veren New Fossil Porselen Karoları yalın şıklığını yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_860",
    "brand": "Duratiles",
    "title": "NEW PIETRA MODA Antrasit 60x60",
    "seriesName": "NEW PIETRA MODA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "860",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8666987596114434.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8666987596114434.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Endüstriyel Zemin & Banyo & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Özel mekânlara karakter katan bir seri... New Pietra Moda serisi ile yaşam alanlarınıza seramikten gelen güzelliği dâhil edin.</span>",
    "descriptionClean": "Özel mekânlara karakter katan bir seri... New Pietra Moda serisi ile yaşam alanlarınıza seramikten gelen güzelliği dâhil edin.",
    "source": "duratiles"
  },
  {
    "id": "dura_859",
    "brand": "Duratiles",
    "title": "NEW PIETRA MODA Gri 60x60",
    "seriesName": "NEW PIETRA MODA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "859",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.050002527667524554.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.050002527667524554.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Endüstriyel Zemin & Banyo & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Özel mekânlara karakter katan bir seri... New Pietra Moda serisi ile yaşam alanlarınıza seramikten gelen güzelliği dâhil edin.</span>",
    "descriptionClean": "Özel mekânlara karakter katan bir seri... New Pietra Moda serisi ile yaşam alanlarınıza seramikten gelen güzelliği dâhil edin.",
    "source": "duratiles"
  },
  {
    "id": "dura_858",
    "brand": "Duratiles",
    "title": "NEW PIETRA MODA Bej 60x60",
    "seriesName": "NEW PIETRA MODA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "858",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9651275975163274.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9651275975163274.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Endüstriyel Zemin & Banyo & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Özel mekânlara karakter katan bir seri... New Pietra Moda serisi ile yaşam alanlarınıza seramikten gelen güzelliği dâhil edin.</span>",
    "descriptionClean": "Özel mekânlara karakter katan bir seri... New Pietra Moda serisi ile yaşam alanlarınıza seramikten gelen güzelliği dâhil edin.",
    "source": "duratiles"
  },
  {
    "id": "dura_857",
    "brand": "Duratiles",
    "title": "NEW PIETRA MODA Beyaz 60x60",
    "seriesName": "NEW PIETRA MODA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "857",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3802561284939652.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3802561284939652.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin & Banyo & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Banyo",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Özel mekânlara karakter katan bir seri... New Pietra Moda serisi ile yaşam alanlarınıza seramikten gelen güzelliği dâhil edin.</span>",
    "descriptionClean": "Özel mekânlara karakter katan bir seri... New Pietra Moda serisi ile yaşam alanlarınıza seramikten gelen güzelliği dâhil edin.",
    "source": "duratiles"
  },
  {
    "id": "dura_864",
    "brand": "Duratiles",
    "title": "NOBLE Siyah 60x120",
    "seriesName": "NOBLE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "864",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.45966189154990944.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.45966189154990944.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Banyo & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır</span>",
    "descriptionClean": "Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır",
    "source": "duratiles"
  },
  {
    "id": "dura_863",
    "brand": "Duratiles",
    "title": "NOBLE Antrasit 60x120",
    "seriesName": "NOBLE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "863",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.468284624606508.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.468284624606508.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Banyo & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır</span>",
    "descriptionClean": "Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır",
    "source": "duratiles"
  },
  {
    "id": "dura_862",
    "brand": "Duratiles",
    "title": "NOBLE Fildişi 60x120",
    "seriesName": "NOBLE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "862",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4139972263270042.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4139972263270042.jpg"
    ],
    "size": "60x120",
    "color": "Fildişi",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Banyo & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır</span>",
    "descriptionClean": "Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır",
    "source": "duratiles"
  },
  {
    "id": "dura_861",
    "brand": "Duratiles",
    "title": "NOBLE Gri 60x120",
    "seriesName": "NOBLE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "861",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2340369326367302.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2340369326367302.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Banyo & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır</span>",
    "descriptionClean": "Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır",
    "source": "duratiles"
  },
  {
    "id": "dura_868",
    "brand": "Duratiles",
    "title": "NOBLE Fildişi 100x100",
    "seriesName": "NOBLE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "868",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8339812745821973.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8339812745821973.jpg"
    ],
    "size": "100x100",
    "color": "Fildişi",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Banyo & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır</span>",
    "descriptionClean": "Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır",
    "source": "duratiles"
  },
  {
    "id": "dura_867",
    "brand": "Duratiles",
    "title": "NOBLE Siyah 100x100",
    "seriesName": "NOBLE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "867",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5573304420504582.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5573304420504582.jpg"
    ],
    "size": "100x100",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Banyo & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır</span>",
    "descriptionClean": "Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır",
    "source": "duratiles"
  },
  {
    "id": "dura_865",
    "brand": "Duratiles",
    "title": "NOBLE Gri 100x100",
    "seriesName": "NOBLE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "865",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6965121157686931.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6965121157686931.jpg"
    ],
    "size": "100x100",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Banyo & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır</span>",
    "descriptionClean": "Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır",
    "source": "duratiles"
  },
  {
    "id": "dura_866",
    "brand": "Duratiles",
    "title": "NOBLE Antrasit 100x100",
    "seriesName": "NOBLE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "866",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6492559446200354.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6492559446200354.jpg"
    ],
    "size": "100x100",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Banyo & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır</span>",
    "descriptionClean": "Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır",
    "source": "duratiles"
  },
  {
    "id": "dura_870",
    "brand": "Duratiles",
    "title": "NOBLE Fildişi 60x60",
    "seriesName": "NOBLE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "870",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9074041553755718.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9074041553755718.jpg"
    ],
    "size": "60x60",
    "color": "Fildişi",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Banyo & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır</span>",
    "descriptionClean": "Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır",
    "source": "duratiles"
  },
  {
    "id": "dura_871",
    "brand": "Duratiles",
    "title": "NOBLE Antrasit 60x60",
    "seriesName": "NOBLE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "871",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.04629875693024532.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.04629875693024532.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Banyo & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır</span>",
    "descriptionClean": "Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır",
    "source": "duratiles"
  },
  {
    "id": "dura_872",
    "brand": "Duratiles",
    "title": "NOBLE Siyah 60x60",
    "seriesName": "NOBLE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "872",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.37340721302907587.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.37340721302907587.jpg"
    ],
    "size": "60x60",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Banyo & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır</span>",
    "descriptionClean": "Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır",
    "source": "duratiles"
  },
  {
    "id": "dura_869",
    "brand": "Duratiles",
    "title": "NOBLE Gri 60x60",
    "seriesName": "NOBLE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "869",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9882758442208112.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9882758442208112.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Banyo & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır</span>",
    "descriptionClean": "Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır",
    "source": "duratiles"
  },
  {
    "id": "dura_874",
    "brand": "Duratiles",
    "title": "NOBLE Fildişi 30x60",
    "seriesName": "NOBLE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "874",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5590964372834274.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5590964372834274.jpg"
    ],
    "size": "30x60",
    "color": "Fildişi",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Banyo & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır</span>",
    "descriptionClean": "Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır",
    "source": "duratiles"
  },
  {
    "id": "dura_876",
    "brand": "Duratiles",
    "title": "NOBLE Siyah 30x60",
    "seriesName": "NOBLE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "876",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5726997060178942.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5726997060178942.jpg"
    ],
    "size": "30x60",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ticari Alanlar & Balkon/Teras",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır</span>",
    "descriptionClean": "Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır",
    "source": "duratiles"
  },
  {
    "id": "dura_875",
    "brand": "Duratiles",
    "title": "NOBLE Antrasit 30x60",
    "seriesName": "NOBLE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "875",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2827096951386716.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2827096951386716.jpg"
    ],
    "size": "30x60",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Banyo & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır</span>",
    "descriptionClean": "Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır",
    "source": "duratiles"
  },
  {
    "id": "dura_873",
    "brand": "Duratiles",
    "title": "NOBLE Gri 30x60",
    "seriesName": "NOBLE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "873",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.031492633865907727.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.031492633865907727.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Banyo & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır</span>",
    "descriptionClean": "Farklı dekorasyon ihtiyaçlarına farklı çözümler sunan Noble Serisi geniş ürün gamıyla seramiğin dingin enerjisini yaşam alanlarınıza taşır",
    "source": "duratiles"
  },
  {
    "id": "dura_877",
    "brand": "Duratiles",
    "title": "NUVOLA Gri 60x60",
    "seriesName": "NUVOLA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "70252",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20376295408796286.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20376295408796286.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Banyo & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ticari Alanlar",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Uygulandığı yaşam alanlarında çağdaş ve güçlü bir etki yaratan Nuvola Porselen Karoları mekanlara yalın ve modern bir hava katar.</span>",
    "descriptionClean": "Uygulandığı yaşam alanlarında çağdaş ve güçlü bir etki yaratan Nuvola Porselen Karoları mekanlara yalın ve modern bir hava katar.",
    "source": "duratiles"
  },
  {
    "id": "dura_879",
    "brand": "Duratiles",
    "title": "NUVOLA Taupe 60x60",
    "seriesName": "NUVOLA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "73901",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10125036205394822.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10125036205394822.jpg"
    ],
    "size": "60x60",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Banyo & Endüstriyel Zemin & Ev içi Zemin & Balkon/Teras",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ticari Alanlar",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Uygulandığı yaşam alanlarında çağdaş ve güçlü bir etki yaratan Nuvola Porselen Karoları mekanlara yalın ve modern bir hava katar.</span>",
    "descriptionClean": "Uygulandığı yaşam alanlarında çağdaş ve güçlü bir etki yaratan Nuvola Porselen Karoları mekanlara yalın ve modern bir hava katar.",
    "source": "duratiles"
  },
  {
    "id": "dura_878",
    "brand": "Duratiles",
    "title": "NUVOLA Antrasit 60x60",
    "seriesName": "NUVOLA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "73951",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9373204188487634.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9373204188487634.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Banyo & Endüstriyel Zemin & Ev içi Zemin & Balkon/Teras",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ticari Alanlar",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Uygulandığı yaşam alanlarında çağdaş ve güçlü bir etki yaratan Nuvola Porselen Karoları mekanlara yalın ve modern bir hava katar.</span>",
    "descriptionClean": "Uygulandığı yaşam alanlarında çağdaş ve güçlü bir etki yaratan Nuvola Porselen Karoları mekanlara yalın ve modern bir hava katar.",
    "source": "duratiles"
  },
  {
    "id": "dura_880",
    "brand": "Duratiles",
    "title": "NUVOLA 20mm Antrasit 60x120",
    "seriesName": "NUVOLA 20mm",
    "collection": "Beton",
    "category": "Beton",
    "sku": "880",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4005681336967084.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4005681336967084.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<font color=\"#707070\" face=\"DIN[T] Light\">Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.</font>",
    "descriptionClean": "Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_882",
    "brand": "Duratiles",
    "title": "NUVOLA 20mm Taupe 60x120",
    "seriesName": "NUVOLA 20mm",
    "collection": "Beton",
    "category": "Beton",
    "sku": "882",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.49979827875949023.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.49979827875949023.jpg"
    ],
    "size": "60x120",
    "color": "Taupe",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<font color=\"#707070\" face=\"DIN[T] Light\">Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.</font>",
    "descriptionClean": "Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_881",
    "brand": "Duratiles",
    "title": "NUVOLA 20mm Gri 60x120",
    "seriesName": "NUVOLA 20mm",
    "collection": "Beton",
    "category": "Beton",
    "sku": "881",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8108835050293008.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8108835050293008.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<font color=\"#707070\" face=\"DIN[T] Light\">Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.</font>",
    "descriptionClean": "Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_885",
    "brand": "Duratiles",
    "title": "NUVOLA 20mm Taupe 30x120",
    "seriesName": "NUVOLA 20mm",
    "collection": "Beton",
    "category": "Beton",
    "sku": "885",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.00832074840925734.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.00832074840925734.jpg"
    ],
    "size": "30x120",
    "color": "Taupe",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<font color=\"#707070\" face=\"DIN[T] Light\">Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.</font>",
    "descriptionClean": "Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_883",
    "brand": "Duratiles",
    "title": "NUVOLA 20mm Antrasit 30x120",
    "seriesName": "NUVOLA 20mm",
    "collection": "Beton",
    "category": "Beton",
    "sku": "883",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22615856374812282.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22615856374812282.jpg"
    ],
    "size": "30x120",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<font color=\"#707070\" face=\"DIN[T] Light\">Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.</font>",
    "descriptionClean": "Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_884",
    "brand": "Duratiles",
    "title": "NUVOLA 20mm Gri 30x120",
    "seriesName": "NUVOLA 20mm",
    "collection": "Beton",
    "category": "Beton",
    "sku": "884",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.26905942101160274.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.26905942101160274.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<font color=\"#707070\" face=\"DIN[T] Light\">Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.</font>",
    "descriptionClean": "Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_892",
    "brand": "Duratiles",
    "title": "NUVOLA 20mm Antrasit 40x40",
    "seriesName": "NUVOLA 20mm",
    "collection": "Beton",
    "category": "Beton",
    "sku": "892",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.47503120515396613.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.47503120515396613.jpg"
    ],
    "size": "40x40",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<font color=\"#707070\" face=\"DIN[T] Light\">Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.</font>",
    "descriptionClean": "Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_893",
    "brand": "Duratiles",
    "title": "NUVOLA 20mm Gri 40x40",
    "seriesName": "NUVOLA 20mm",
    "collection": "Beton",
    "category": "Beton",
    "sku": "893",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.04346498846630453.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.04346498846630453.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<font color=\"#707070\" face=\"DIN[T] Light\">Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.</font>",
    "descriptionClean": "Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_894",
    "brand": "Duratiles",
    "title": "NUVOLA 20mm Taupe 40x40",
    "seriesName": "NUVOLA 20mm",
    "collection": "Beton",
    "category": "Beton",
    "sku": "894",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7292896248575329.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7292896248575329.jpg"
    ],
    "size": "40x40",
    "color": "Taupe",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<font color=\"#707070\" face=\"DIN[T] Light\">Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.</font>",
    "descriptionClean": "Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_887",
    "brand": "Duratiles",
    "title": "NUVOLA 20mm Gri 40x80",
    "seriesName": "NUVOLA 20mm",
    "collection": "Beton",
    "category": "Beton",
    "sku": "887",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6528820699315365.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6528820699315365.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<font color=\"#707070\" face=\"DIN[T] Light\">Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.</font>",
    "descriptionClean": "Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_886",
    "brand": "Duratiles",
    "title": "NUVOLA 20mm Antrasit 40x80",
    "seriesName": "NUVOLA 20mm",
    "collection": "Beton",
    "category": "Beton",
    "sku": "886",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.39163412270565245.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.39163412270565245.jpg"
    ],
    "size": "40x80",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<font color=\"#707070\" face=\"DIN[T] Light\">Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.</font>",
    "descriptionClean": "Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_888",
    "brand": "Duratiles",
    "title": "NUVOLA 20mm Taupe 40x80",
    "seriesName": "NUVOLA 20mm",
    "collection": "Beton",
    "category": "Beton",
    "sku": "888",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.665324736946307.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.665324736946307.jpg"
    ],
    "size": "40x80",
    "color": "Taupe",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<font color=\"#707070\" face=\"DIN[T] Light\">Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.</font>",
    "descriptionClean": "Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_890",
    "brand": "Duratiles",
    "title": "NUVOLA 20mm Gri 60x60",
    "seriesName": "NUVOLA 20mm",
    "collection": "Beton",
    "category": "Beton",
    "sku": "70252",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14658903413592783.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14658903413592783.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<font color=\"#707070\" face=\"DIN[T] Light\">Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.</font>",
    "descriptionClean": "Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_891",
    "brand": "Duratiles",
    "title": "NUVOLA 20mm Taupe 60x60",
    "seriesName": "NUVOLA 20mm",
    "collection": "Beton",
    "category": "Beton",
    "sku": "73901",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8018583761806605.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8018583761806605.jpg"
    ],
    "size": "60x60",
    "color": "Taupe",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<font color=\"#707070\" face=\"DIN[T] Light\">Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.</font>",
    "descriptionClean": "Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_889",
    "brand": "Duratiles",
    "title": "NUVOLA 20mm Antrasit 60x60",
    "seriesName": "NUVOLA 20mm",
    "collection": "Beton",
    "category": "Beton",
    "sku": "73951",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4926220716106623.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4926220716106623.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<font color=\"#707070\" face=\"DIN[T] Light\">Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.</font>",
    "descriptionClean": "Nuvola Serisi, yaşam alanlarında doğal yapılar oluşturmak isteyenler için tasarlanmıştır. Bu seri ile çağdaş ve özgün mekanlar yaratabilirsiniz. Nuvola Serisi, yük ve yaya trafiğinin yoğun olduğu tüm iç ve dış mekanlarda kullanılabilir ve yüksek teknik performansı sayesinde eğimli yüzeylerde de kolaylıkla uygulanabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_895",
    "brand": "Duratiles",
    "title": "ONTARIO Antrasit 60x120",
    "seriesName": "ONTARIO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "895",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7099984753878644.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7099984753878644.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_896",
    "brand": "Duratiles",
    "title": "ONTARIO Blanco 60x120",
    "seriesName": "ONTARIO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "896",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4993463910205682.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4993463910205682.jpg"
    ],
    "size": "60x120",
    "color": "Blanco",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_897",
    "brand": "Duratiles",
    "title": "ONTARIO Koyu Gri 60x120",
    "seriesName": "ONTARIO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "897",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7930819993204538.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7930819993204538.jpg"
    ],
    "size": "60x120",
    "color": "Koyu Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_898",
    "brand": "Duratiles",
    "title": "ONTARIO Antrasit 30x120",
    "seriesName": "ONTARIO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "898",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4637974213864141.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4637974213864141.jpg"
    ],
    "size": "30x120",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_899",
    "brand": "Duratiles",
    "title": "ONTARIO Blanco 30x120",
    "seriesName": "ONTARIO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "899",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.908516208249892.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.908516208249892.jpg"
    ],
    "size": "30x120",
    "color": "Blanco",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_2335",
    "brand": "Duratiles",
    "title": "ONTARIO Koyu Gri 30x120",
    "seriesName": "ONTARIO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2335",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.39222248435395857.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.39222248435395857.jpg"
    ],
    "size": "30x120",
    "color": "Koyu Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_900",
    "brand": "Duratiles",
    "title": "ONTARIO Antrasit 40x80",
    "seriesName": "ONTARIO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "900",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5154817243332717.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5154817243332717.jpg"
    ],
    "size": "40x80",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_901",
    "brand": "Duratiles",
    "title": "ONTARIO Blanco 40x80",
    "seriesName": "ONTARIO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "901",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.758592565225984.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.758592565225984.jpg"
    ],
    "size": "40x80",
    "color": "Blanco",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_902",
    "brand": "Duratiles",
    "title": "ONTARIO Koyu Gri 40x80",
    "seriesName": "ONTARIO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "902",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2104286496087675.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2104286496087675.jpg"
    ],
    "size": "40x80",
    "color": "Koyu Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_903",
    "brand": "Duratiles",
    "title": "ONTARIO Antrasit 60x60",
    "seriesName": "ONTARIO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "903",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09905921607824275.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09905921607824275.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "30mm & 20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_904",
    "brand": "Duratiles",
    "title": "ONTARIO Blanco 60x60",
    "seriesName": "ONTARIO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "904",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8575795847265554.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8575795847265554.jpg"
    ],
    "size": "60x60",
    "color": "Blanco",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_905",
    "brand": "Duratiles",
    "title": "ONTARIO Koyu Gri 60x60",
    "seriesName": "ONTARIO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "905",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.02018663658821307.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.02018663658821307.jpg"
    ],
    "size": "60x60",
    "color": "Koyu Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_906",
    "brand": "Duratiles",
    "title": "ONTARIO Antrasit 40x40",
    "seriesName": "ONTARIO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "906",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.345393720452991.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.345393720452991.jpg"
    ],
    "size": "40x40",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_907",
    "brand": "Duratiles",
    "title": "ONTARIO Blanco 40x40",
    "seriesName": "ONTARIO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "907",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12929302283780542.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12929302283780542.jpg"
    ],
    "size": "40x40",
    "color": "Blanco",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_908",
    "brand": "Duratiles",
    "title": "ONTARIO Koyu Gri 40x40",
    "seriesName": "ONTARIO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "908",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6783320702779102.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6783320702779102.jpg"
    ],
    "size": "40x40",
    "color": "Koyu Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Ontario Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta. Güçlü rafine çizgilere sahip olan Ontario 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_912",
    "brand": "Duratiles",
    "title": "OREGON Siyah 45x90",
    "seriesName": "OREGON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "912",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.015611398159775858.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.015611398159775858.jpg"
    ],
    "size": "45x90",
    "color": "Siyah",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor</span>",
    "descriptionClean": "20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_910",
    "brand": "Duratiles",
    "title": "OREGON Gri 45x90",
    "seriesName": "OREGON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "910",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8286740765926435.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8286740765926435.jpg"
    ],
    "size": "45x90",
    "color": "Gri",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "30mm & 20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor</span>",
    "descriptionClean": "20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_911",
    "brand": "Duratiles",
    "title": "OREGON Sand 45x90",
    "seriesName": "OREGON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "911",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19375343536953815.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19375343536953815.jpg"
    ],
    "size": "45x90",
    "color": "Sand",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "30mm & 20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor</span>",
    "descriptionClean": "20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_914",
    "brand": "Duratiles",
    "title": "OREGON Gri 60x120",
    "seriesName": "OREGON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "914",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9656741090518819.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9656741090518819.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor</span>",
    "descriptionClean": "20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_915",
    "brand": "Duratiles",
    "title": "OREGON Sand 60x120",
    "seriesName": "OREGON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "915",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44906711553094103.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44906711553094103.jpg"
    ],
    "size": "60x120",
    "color": "Sand",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor</span>",
    "descriptionClean": "20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_913",
    "brand": "Duratiles",
    "title": "OREGON Siyah 60x120",
    "seriesName": "OREGON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "913",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4793271165472057.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4793271165472057.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor</span>",
    "descriptionClean": "20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_918",
    "brand": "Duratiles",
    "title": "OREGON Gri 100x100",
    "seriesName": "OREGON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "918",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.06395972687884366.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.06395972687884366.jpg"
    ],
    "size": "100x100",
    "color": "Gri",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor</span>",
    "descriptionClean": "20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_917",
    "brand": "Duratiles",
    "title": "OREGON Sand 100x100",
    "seriesName": "OREGON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "917",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6093435814609932.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6093435814609932.jpg"
    ],
    "size": "100x100",
    "color": "Sand",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor</span>",
    "descriptionClean": "20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_916",
    "brand": "Duratiles",
    "title": "OREGON Siyah 100x100",
    "seriesName": "OREGON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "916",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5946053406080988.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5946053406080988.jpg"
    ],
    "size": "100x100",
    "color": "Siyah",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor</span>",
    "descriptionClean": "20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_921",
    "brand": "Duratiles",
    "title": "OREGON Sand 80x80",
    "seriesName": "OREGON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "921",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.02249093997962648.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.02249093997962648.jpg"
    ],
    "size": "80x80",
    "color": "Sand",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor</span>",
    "descriptionClean": "20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_920",
    "brand": "Duratiles",
    "title": "OREGON Gri 80x80",
    "seriesName": "OREGON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "920",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6833119058494014.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6833119058494014.jpg"
    ],
    "size": "80x80",
    "color": "Gri",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor</span>",
    "descriptionClean": "20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_919",
    "brand": "Duratiles",
    "title": "OREGON Siyah 80x80",
    "seriesName": "OREGON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "919",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.02724832918397646.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.02724832918397646.jpg"
    ],
    "size": "80x80",
    "color": "Siyah",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor</span>",
    "descriptionClean": "20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_924",
    "brand": "Duratiles",
    "title": "OREGON Sand 40x80",
    "seriesName": "OREGON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "924",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7112353159799999.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7112353159799999.jpg"
    ],
    "size": "40x80",
    "color": "Sand",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor</span>",
    "descriptionClean": "20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_923",
    "brand": "Duratiles",
    "title": "OREGON Gri 40x80",
    "seriesName": "OREGON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "923",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4701758553859776.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4701758553859776.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor</span>",
    "descriptionClean": "20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_922",
    "brand": "Duratiles",
    "title": "OREGON Siyah 40x80",
    "seriesName": "OREGON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "922",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5497583335105953.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5497583335105953.jpg"
    ],
    "size": "40x80",
    "color": "Siyah",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor</span>",
    "descriptionClean": "20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_925",
    "brand": "Duratiles",
    "title": "OREGON Siyah 60x60",
    "seriesName": "OREGON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "925",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5433380926672761.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5433380926672761.jpg"
    ],
    "size": "60x60",
    "color": "Siyah",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "30mm & 20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor</span>",
    "descriptionClean": "20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_926",
    "brand": "Duratiles",
    "title": "OREGON Gri 60x60",
    "seriesName": "OREGON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "926",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9776247475787382.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9776247475787382.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "30mm & 20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor</span>",
    "descriptionClean": "20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_927",
    "brand": "Duratiles",
    "title": "OREGON Sand 60x60",
    "seriesName": "OREGON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "927",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.05494040218220708.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.05494040218220708.jpg"
    ],
    "size": "60x60",
    "color": "Sand",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "30mm & 20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor</span>",
    "descriptionClean": "20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_930",
    "brand": "Duratiles",
    "title": "OREGON Gri 40x40",
    "seriesName": "OREGON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "930",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.71075836673077.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.71075836673077.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor</span>",
    "descriptionClean": "20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_929",
    "brand": "Duratiles",
    "title": "OREGON Sand 40x40",
    "seriesName": "OREGON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "929",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5699686901049871.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5699686901049871.jpg"
    ],
    "size": "40x40",
    "color": "Sand",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor</span>",
    "descriptionClean": "20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_928",
    "brand": "Duratiles",
    "title": "OREGON Siyah 40x40",
    "seriesName": "OREGON",
    "collection": "Beton",
    "category": "Beton",
    "sku": "928",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46152502412579366.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46152502412579366.jpg"
    ],
    "size": "40x40",
    "color": "Siyah",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras & Duvar & Yer & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor</span>",
    "descriptionClean": "20mm ve 30mm kalınlığında ki Oregon Sırlı Porselen Karoları , konforu ve lüksü bir araya getirerek üst düzey standartları yeniden belirliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_931",
    "brand": "Duratiles",
    "title": "PASSEO Bej 60x120",
    "seriesName": "PASSEO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "931",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4504178485107402.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4504178485107402.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Dış Cephe",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar</span>",
    "descriptionClean": "Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_932",
    "brand": "Duratiles",
    "title": "PASSEO Açık Gri 60x120",
    "seriesName": "PASSEO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "932",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7725692427176234.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7725692427176234.jpg"
    ],
    "size": "60x120",
    "color": "Açık Gri",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Dış Cephe",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar</span>",
    "descriptionClean": "Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_933",
    "brand": "Duratiles",
    "title": "PASSEO Koyu Gri 60x120",
    "seriesName": "PASSEO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "933",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4827861718707007.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4827861718707007.jpg"
    ],
    "size": "60x120",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Dış Cephe",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar</span>",
    "descriptionClean": "Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_934",
    "brand": "Duratiles",
    "title": "PASSEO Antrasit 60x120",
    "seriesName": "PASSEO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "934",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7365163521667235.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7365163521667235.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Dış Cephe",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar</span>",
    "descriptionClean": "Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_935",
    "brand": "Duratiles",
    "title": "PASSEO Bej 100x100",
    "seriesName": "PASSEO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "935",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.053376066527934696.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.053376066527934696.jpg"
    ],
    "size": "100x100",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Dış Cephe",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar</span>",
    "descriptionClean": "Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_936",
    "brand": "Duratiles",
    "title": "PASSEO Açık Gri 100x100",
    "seriesName": "PASSEO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "936",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9174062407323293.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9174062407323293.jpg"
    ],
    "size": "100x100",
    "color": "Açık Gri",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Dış Cephe",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar</span>",
    "descriptionClean": "Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_937",
    "brand": "Duratiles",
    "title": "PASSEO Koyu Gri 100x100",
    "seriesName": "PASSEO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "937",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1393504975727402.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1393504975727402.jpg"
    ],
    "size": "100x100",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Dış Cephe",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar</span>",
    "descriptionClean": "Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_938",
    "brand": "Duratiles",
    "title": "PASSEO Antrasit 100x100",
    "seriesName": "PASSEO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "938",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9565215397918153.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9565215397918153.jpg"
    ],
    "size": "100x100",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Dış Cephe",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar</span>",
    "descriptionClean": "Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_939",
    "brand": "Duratiles",
    "title": "PASSEO Bej 60x60",
    "seriesName": "PASSEO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "939",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6026509167675016.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6026509167675016.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Dış Cephe",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar</span>",
    "descriptionClean": "Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_942",
    "brand": "Duratiles",
    "title": "PASSEO Antrasit 60x60",
    "seriesName": "PASSEO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "942",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.798380662287108.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.798380662287108.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Dış Cephe",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar</span>",
    "descriptionClean": "Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_940",
    "brand": "Duratiles",
    "title": "PASSEO Açık Gri 60x60",
    "seriesName": "PASSEO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "940",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.039856599960225836.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.039856599960225836.jpg"
    ],
    "size": "60x60",
    "color": "Açık Gri",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Dış Cephe",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar</span>",
    "descriptionClean": "Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_941",
    "brand": "Duratiles",
    "title": "PASSEO Koyu Gri 60x60",
    "seriesName": "PASSEO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "941",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6853467519430586.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6853467519430586.jpg"
    ],
    "size": "60x60",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Dış Cephe",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar</span>",
    "descriptionClean": "Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_943",
    "brand": "Duratiles",
    "title": "PASSEO Bej 30x60",
    "seriesName": "PASSEO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "943",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7101448582769956.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7101448582769956.jpg"
    ],
    "size": "30x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Dış Cephe & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar</span>",
    "descriptionClean": "Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_944",
    "brand": "Duratiles",
    "title": "PASSEO Açık Gri 30x60",
    "seriesName": "PASSEO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "944",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9514213252091719.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9514213252091719.jpg"
    ],
    "size": "30x60",
    "color": "Açık Gri",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Dış Cephe & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar</span>",
    "descriptionClean": "Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_945",
    "brand": "Duratiles",
    "title": "PASSEO Koyu Gri 30x60",
    "seriesName": "PASSEO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "945",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4548549885750489.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4548549885750489.jpg"
    ],
    "size": "30x60",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Dış Cephe & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar</span>",
    "descriptionClean": "Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_946",
    "brand": "Duratiles",
    "title": "PASSEO Antrasit 30x60",
    "seriesName": "PASSEO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "946",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8155767131408438.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8155767131408438.jpg"
    ],
    "size": "30x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Dış Cephe & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar</span>",
    "descriptionClean": "Passeo Serisi modern tasarım anlayışını estetik ve konforla buluşturarak çarpıcı yaşam alanları tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_948",
    "brand": "Duratiles",
    "title": "PİETRA Antrasit 60x120",
    "seriesName": "PİETRA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "11502",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7598686614589578.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7598686614589578.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.</span>",
    "descriptionClean": "İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_949",
    "brand": "Duratiles",
    "title": "PİETRA Siyah 60x120",
    "seriesName": "PİETRA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "949",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19718963992331173.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19718963992331173.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.</span>",
    "descriptionClean": "İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_950",
    "brand": "Duratiles",
    "title": "PİETRA Gri 60x120",
    "seriesName": "PİETRA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "950",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8157220036638769.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8157220036638769.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.</span>",
    "descriptionClean": "İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_951",
    "brand": "Duratiles",
    "title": "PİETRA Antrasit 30x120",
    "seriesName": "PİETRA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "951",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3288000479885893.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3288000479885893.jpg"
    ],
    "size": "30x120",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.</span>",
    "descriptionClean": "İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_952",
    "brand": "Duratiles",
    "title": "PİETRA Siyah 30x120",
    "seriesName": "PİETRA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "952",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3975938415240031.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3975938415240031.jpg"
    ],
    "size": "30x120",
    "color": "Siyah",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.</span>",
    "descriptionClean": "İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_953",
    "brand": "Duratiles",
    "title": "PİETRA Gri 30x120",
    "seriesName": "PİETRA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "953",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21651196784253757.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21651196784253757.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.</span>",
    "descriptionClean": "İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_954",
    "brand": "Duratiles",
    "title": "PİETRA Antrasit 40x80",
    "seriesName": "PİETRA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "954",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20442776705141597.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20442776705141597.jpg"
    ],
    "size": "40x80",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.</span>",
    "descriptionClean": "İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_955",
    "brand": "Duratiles",
    "title": "PİETRA Siyah 40x80",
    "seriesName": "PİETRA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "955",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5734234535845277.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5734234535845277.jpg"
    ],
    "size": "40x80",
    "color": "Siyah",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.</span>",
    "descriptionClean": "İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_956",
    "brand": "Duratiles",
    "title": "PİETRA Gri 40x80",
    "seriesName": "PİETRA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "956",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3524506076444246.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3524506076444246.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.</span>",
    "descriptionClean": "İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_957",
    "brand": "Duratiles",
    "title": "PİETRA Antrasit 60x60",
    "seriesName": "PİETRA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "957",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7076478590495178.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7076478590495178.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.</span>",
    "descriptionClean": "İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_958",
    "brand": "Duratiles",
    "title": "PİETRA Siyah 60x60",
    "seriesName": "PİETRA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "958",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.49540276161971175.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.49540276161971175.jpg"
    ],
    "size": "60x60",
    "color": "Siyah",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.</span>",
    "descriptionClean": "İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_959",
    "brand": "Duratiles",
    "title": "PİETRA Gri 60x60",
    "seriesName": "PİETRA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "959",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10546729761220486.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10546729761220486.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.</span>",
    "descriptionClean": "İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_960",
    "brand": "Duratiles",
    "title": "PİETRA Antrasit 40x40",
    "seriesName": "PİETRA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "960",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4085042536005299.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4085042536005299.jpg"
    ],
    "size": "40x40",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.</span>",
    "descriptionClean": "İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_961",
    "brand": "Duratiles",
    "title": "PİETRA Siyah 40x40",
    "seriesName": "PİETRA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "961",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6095306791363646.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6095306791363646.jpg"
    ],
    "size": "40x40",
    "color": "Siyah",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "Class A",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.</span>",
    "descriptionClean": "İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_962",
    "brand": "Duratiles",
    "title": "PİETRA Gri 40x40",
    "seriesName": "PİETRA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "962",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21463534348664948.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21463534348664948.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Ticari Alanlar & Balkon/Teras & Duvar & Yer & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.</span>",
    "descriptionClean": "İçi pozitif enerji dolu mekanlar yaratmanıza imkan sağlayan Pietra Serisiyle sıradanlığa meydan okuyun. İddiası sadeliğinde olan Pietra Serisi antrasit ,siyah ve gri renk alternatifleriyle size özgü yaşam alanları tasarlamanıza olanak sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_963",
    "brand": "Duratiles",
    "title": "POINT Özel Renk 60x60",
    "seriesName": "POINT",
    "collection": "Beton",
    "category": "Beton",
    "sku": "963",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8424692304406481.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8424692304406481.jpg"
    ],
    "size": "60x60",
    "color": "Özel Renk",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İşaretlemek mekan tasarımının doğal bir refleksidir.Mekandaki ögelere aidiyet ve olması gerektikleri yerde oldukları duygusunu verir.Rafine ve zamansız bir tasarım yaklaşımıyla sağlamayı hedefleyen Point Serisi kullanıcısına sınırsız bir kişiselleştirme imkanı sunar.</span>",
    "descriptionClean": "İşaretlemek mekan tasarımının doğal bir refleksidir.Mekandaki ögelere aidiyet ve olması gerektikleri yerde oldukları duygusunu verir.Rafine ve zamansız bir tasarım yaklaşımıyla sağlamayı hedefleyen Point Serisi kullanıcısına sınırsız bir kişiselleştirme imkanı sunar.",
    "source": "duratiles"
  },
  {
    "id": "dura_964",
    "brand": "Duratiles",
    "title": "PORTO Taupe 60x120",
    "seriesName": "PORTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "964",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.25877874516711663.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.25877874516711663.jpg"
    ],
    "size": "60x120",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi</span>",
    "descriptionClean": "Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi",
    "source": "duratiles"
  },
  {
    "id": "dura_965",
    "brand": "Duratiles",
    "title": "PORTO Antrasit 60x120",
    "seriesName": "PORTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "965",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9960319992240534.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9960319992240534.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi</span>",
    "descriptionClean": "Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi",
    "source": "duratiles"
  },
  {
    "id": "dura_966",
    "brand": "Duratiles",
    "title": "PORTO Blanco 60x120",
    "seriesName": "PORTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "966",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6324612038079457.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6324612038079457.jpg"
    ],
    "size": "60x120",
    "color": "Blanco",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi</span>",
    "descriptionClean": "Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi",
    "source": "duratiles"
  },
  {
    "id": "dura_967",
    "brand": "Duratiles",
    "title": "PORTO Gri 60x120",
    "seriesName": "PORTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "967",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7842813997219924.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7842813997219924.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi</span>",
    "descriptionClean": "Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi",
    "source": "duratiles"
  },
  {
    "id": "dura_968",
    "brand": "Duratiles",
    "title": "PORTO Taupe 30x120",
    "seriesName": "PORTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "968",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3859992539077183.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3859992539077183.jpg"
    ],
    "size": "30x120",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi</span>",
    "descriptionClean": "Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi",
    "source": "duratiles"
  },
  {
    "id": "dura_969",
    "brand": "Duratiles",
    "title": "PORTO Antrasit 30x120",
    "seriesName": "PORTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "969",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8998185751491201.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8998185751491201.jpg"
    ],
    "size": "30x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi</span>",
    "descriptionClean": "Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi",
    "source": "duratiles"
  },
  {
    "id": "dura_970",
    "brand": "Duratiles",
    "title": "PORTO Blanco 30x120",
    "seriesName": "PORTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "970",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.748066929655183.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.748066929655183.jpg"
    ],
    "size": "30x120",
    "color": "Blanco",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi</span>",
    "descriptionClean": "Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi",
    "source": "duratiles"
  },
  {
    "id": "dura_971",
    "brand": "Duratiles",
    "title": "PORTO Gri 30x120",
    "seriesName": "PORTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "971",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4341041105700203.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4341041105700203.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi</span>",
    "descriptionClean": "Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi",
    "source": "duratiles"
  },
  {
    "id": "dura_972",
    "brand": "Duratiles",
    "title": "PORTO Taupe 40x80",
    "seriesName": "PORTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "972",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.85924840501683.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.85924840501683.jpg"
    ],
    "size": "40x80",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi</span>",
    "descriptionClean": "Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi",
    "source": "duratiles"
  },
  {
    "id": "dura_973",
    "brand": "Duratiles",
    "title": "PORTO Antrasit 40x80",
    "seriesName": "PORTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "973",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21889979246643942.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21889979246643942.jpg"
    ],
    "size": "40x80",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi</span>",
    "descriptionClean": "Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi",
    "source": "duratiles"
  },
  {
    "id": "dura_974",
    "brand": "Duratiles",
    "title": "PORTO Blanco 40x80",
    "seriesName": "PORTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "974",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9482365926991666.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9482365926991666.jpg"
    ],
    "size": "40x80",
    "color": "Blanco",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi</span>",
    "descriptionClean": "Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi",
    "source": "duratiles"
  },
  {
    "id": "dura_975",
    "brand": "Duratiles",
    "title": "PORTO Gri 40x80",
    "seriesName": "PORTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "975",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6409043588871022.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6409043588871022.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi</span>",
    "descriptionClean": "Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi",
    "source": "duratiles"
  },
  {
    "id": "dura_976",
    "brand": "Duratiles",
    "title": "PORTO Taupe 60x60",
    "seriesName": "PORTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "976",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3138885530475445.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3138885530475445.jpg"
    ],
    "size": "60x60",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi</span>",
    "descriptionClean": "Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi",
    "source": "duratiles"
  },
  {
    "id": "dura_977",
    "brand": "Duratiles",
    "title": "PORTO Antrasit 60x60",
    "seriesName": "PORTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "977",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.030192607991061604.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.030192607991061604.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi</span>",
    "descriptionClean": "Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi",
    "source": "duratiles"
  },
  {
    "id": "dura_978",
    "brand": "Duratiles",
    "title": "PORTO Blanco 60x60",
    "seriesName": "PORTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "978",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.26574755642207204.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.26574755642207204.jpg"
    ],
    "size": "60x60",
    "color": "Blanco",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi</span>",
    "descriptionClean": "Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi",
    "source": "duratiles"
  },
  {
    "id": "dura_979",
    "brand": "Duratiles",
    "title": "PORTO Gri 60x60",
    "seriesName": "PORTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "979",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3400544024758867.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3400544024758867.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi</span>",
    "descriptionClean": "Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi",
    "source": "duratiles"
  },
  {
    "id": "dura_980",
    "brand": "Duratiles",
    "title": "PORTO Taupe 40x40",
    "seriesName": "PORTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "980",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.009995707097656625.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.009995707097656625.jpg"
    ],
    "size": "40x40",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi</span>",
    "descriptionClean": "Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi",
    "source": "duratiles"
  },
  {
    "id": "dura_981",
    "brand": "Duratiles",
    "title": "PORTO Antrasit 40x40",
    "seriesName": "PORTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "981",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7878522408179829.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7878522408179829.jpg"
    ],
    "size": "40x40",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi</span>",
    "descriptionClean": "Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi",
    "source": "duratiles"
  },
  {
    "id": "dura_982",
    "brand": "Duratiles",
    "title": "PORTO Blanco 40x40",
    "seriesName": "PORTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "982",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5983258868004389.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5983258868004389.jpg"
    ],
    "size": "40x40",
    "color": "Blanco",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi</span>",
    "descriptionClean": "Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi",
    "source": "duratiles"
  },
  {
    "id": "dura_983",
    "brand": "Duratiles",
    "title": "PORTO Gri 40x40",
    "seriesName": "PORTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "983",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5277714540850578.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5277714540850578.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi</span>",
    "descriptionClean": "Betonun dayanıklılığı ve zamansız güzelliğinden etkilenerek tasarlanan Porto Serisi, dört renk seçeneği ve mat yüzeyi ile seçkim mekanların ilk tercihi",
    "source": "duratiles"
  },
  {
    "id": "dura_984",
    "brand": "Duratiles",
    "title": "REVESTO Gri 100x100",
    "seriesName": "REVESTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "75584",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6875123143932995.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6875123143932995.jpg"
    ],
    "size": "100x100",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren estetiği ile göz dolduran Revesto Porselen Karoları fonksiyonel yapısıyla yaşam alışkanlıklarınıza uygun olarak bütün beklentinizi karşılamayı hedefliyor</span>",
    "descriptionClean": "İlham veren estetiği ile göz dolduran Revesto Porselen Karoları fonksiyonel yapısıyla yaşam alışkanlıklarınıza uygun olarak bütün beklentinizi karşılamayı hedefliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_985",
    "brand": "Duratiles",
    "title": "REVESTO Antrasit 100x100",
    "seriesName": "REVESTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "75582",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.035231919460145256.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.035231919460145256.jpg"
    ],
    "size": "100x100",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren estetiği ile göz dolduran Revesto Porselen Karoları fonksiyonel yapısıyla yaşam alışkanlıklarınıza uygun olarak bütün beklentinizi karşılamayı hedefliyor</span>",
    "descriptionClean": "İlham veren estetiği ile göz dolduran Revesto Porselen Karoları fonksiyonel yapısıyla yaşam alışkanlıklarınıza uygun olarak bütün beklentinizi karşılamayı hedefliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_986",
    "brand": "Duratiles",
    "title": "REVESTO Gri 80x80",
    "seriesName": "REVESTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "986",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4228396216554998.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4228396216554998.jpg"
    ],
    "size": "80x80",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren estetiği ile göz dolduran Revesto Porselen Karoları fonksiyonel yapısıyla yaşam alışkanlıklarınıza uygun olarak bütün beklentinizi karşılamayı hedefliyor</span>",
    "descriptionClean": "İlham veren estetiği ile göz dolduran Revesto Porselen Karoları fonksiyonel yapısıyla yaşam alışkanlıklarınıza uygun olarak bütün beklentinizi karşılamayı hedefliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_987",
    "brand": "Duratiles",
    "title": "REVESTO Antrasit 60x60",
    "seriesName": "REVESTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "987",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4881559730497045.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4881559730497045.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren estetiği ile göz dolduran Revesto Porselen Karoları fonksiyonel yapısıyla yaşam alışkanlıklarınıza uygun olarak bütün beklentinizi karşılamayı hedefliyor</span>",
    "descriptionClean": "İlham veren estetiği ile göz dolduran Revesto Porselen Karoları fonksiyonel yapısıyla yaşam alışkanlıklarınıza uygun olarak bütün beklentinizi karşılamayı hedefliyor",
    "source": "duratiles"
  },
  {
    "id": "dura_988",
    "brand": "Duratiles",
    "title": "RIVESTIMENTO Gri 60x120",
    "seriesName": "RIVESTIMENTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "988",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8587547225393223.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8587547225393223.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bir mekânda aradığınız modernlik, dinlik ve güç ise aradığınızın Rivestimento Serisi olduğunu gönül rahatlığıyla söyleyebiliriz. Rivestimento Serisi beyaz , gri ve antrasit renkleri, fonksiyonel ve üstün teknik performansı ile mekanlarınızı hayallerinizde ki görünüme kavuşturuyor.</span>",
    "descriptionClean": "Bir mekânda aradığınız modernlik, dinlik ve güç ise aradığınızın Rivestimento Serisi olduğunu gönül rahatlığıyla söyleyebiliriz. Rivestimento Serisi beyaz , gri ve antrasit renkleri, fonksiyonel ve üstün teknik performansı ile mekanlarınızı hayallerinizde ki görünüme kavuşturuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_989",
    "brand": "Duratiles",
    "title": "RIVESTIMENTO Antrasit 60x120",
    "seriesName": "RIVESTIMENTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "989",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8267644014993881.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8267644014993881.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bir mekânda aradığınız modernlik, dinlik ve güç ise aradığınızın Rivestimento Serisi olduğunu gönül rahatlığıyla söyleyebiliriz. Rivestimento Serisi beyaz , gri ve antrasit renkleri, fonksiyonel ve üstün teknik performansı ile mekanlarınızı hayallerinizde ki görünüme kavuşturuyor.</span>",
    "descriptionClean": "Bir mekânda aradığınız modernlik, dinlik ve güç ise aradığınızın Rivestimento Serisi olduğunu gönül rahatlığıyla söyleyebiliriz. Rivestimento Serisi beyaz , gri ve antrasit renkleri, fonksiyonel ve üstün teknik performansı ile mekanlarınızı hayallerinizde ki görünüme kavuşturuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_991",
    "brand": "Duratiles",
    "title": "RIVESTIMENTO Antrasit 30x120",
    "seriesName": "RIVESTIMENTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "991",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7742285366382823.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7742285366382823.jpg"
    ],
    "size": "30x120",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bir mekânda aradığınız modernlik, dinlik ve güç ise aradığınızın Rivestimento Serisi olduğunu gönül rahatlığıyla söyleyebiliriz. Rivestimento Serisi beyaz , gri ve antrasit renkleri, fonksiyonel ve üstün teknik performansı ile mekanlarınızı hayallerinizde ki görünüme kavuşturuyor.</span>",
    "descriptionClean": "Bir mekânda aradığınız modernlik, dinlik ve güç ise aradığınızın Rivestimento Serisi olduğunu gönül rahatlığıyla söyleyebiliriz. Rivestimento Serisi beyaz , gri ve antrasit renkleri, fonksiyonel ve üstün teknik performansı ile mekanlarınızı hayallerinizde ki görünüme kavuşturuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_990",
    "brand": "Duratiles",
    "title": "RIVESTIMENTO Gri 30x120",
    "seriesName": "RIVESTIMENTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "990",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6549661978394059.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6549661978394059.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bir mekânda aradığınız modernlik, dinlik ve güç ise aradığınızın Rivestimento Serisi olduğunu gönül rahatlığıyla söyleyebiliriz. Rivestimento Serisi beyaz , gri ve antrasit renkleri, fonksiyonel ve üstün teknik performansı ile mekanlarınızı hayallerinizde ki görünüme kavuşturuyor.</span>",
    "descriptionClean": "Bir mekânda aradığınız modernlik, dinlik ve güç ise aradığınızın Rivestimento Serisi olduğunu gönül rahatlığıyla söyleyebiliriz. Rivestimento Serisi beyaz , gri ve antrasit renkleri, fonksiyonel ve üstün teknik performansı ile mekanlarınızı hayallerinizde ki görünüme kavuşturuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_997",
    "brand": "Duratiles",
    "title": "RIVESTIMENTO Antrasit 40x40",
    "seriesName": "RIVESTIMENTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "997",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30419644678005975.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30419644678005975.jpg"
    ],
    "size": "40x40",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bir mekânda aradığınız modernlik, dinlik ve güç ise aradığınızın Rivestimento Serisi olduğunu gönül rahatlığıyla söyleyebiliriz. Rivestimento Serisi beyaz , gri ve antrasit renkleri, fonksiyonel ve üstün teknik performansı ile mekanlarınızı hayallerinizde ki görünüme kavuşturuyor.</span>",
    "descriptionClean": "Bir mekânda aradığınız modernlik, dinlik ve güç ise aradığınızın Rivestimento Serisi olduğunu gönül rahatlığıyla söyleyebiliriz. Rivestimento Serisi beyaz , gri ve antrasit renkleri, fonksiyonel ve üstün teknik performansı ile mekanlarınızı hayallerinizde ki görünüme kavuşturuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_996",
    "brand": "Duratiles",
    "title": "RIVESTIMENTO Gri 40x40",
    "seriesName": "RIVESTIMENTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "996",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18225649104982977.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18225649104982977.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bir mekânda aradığınız modernlik, dinlik ve güç ise aradığınızın Rivestimento Serisi olduğunu gönül rahatlığıyla söyleyebiliriz. Rivestimento Serisi beyaz , gri ve antrasit renkleri, fonksiyonel ve üstün teknik performansı ile mekanlarınızı hayallerinizde ki görünüme kavuşturuyor.</span>",
    "descriptionClean": "Bir mekânda aradığınız modernlik, dinlik ve güç ise aradığınızın Rivestimento Serisi olduğunu gönül rahatlığıyla söyleyebiliriz. Rivestimento Serisi beyaz , gri ve antrasit renkleri, fonksiyonel ve üstün teknik performansı ile mekanlarınızı hayallerinizde ki görünüme kavuşturuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_993",
    "brand": "Duratiles",
    "title": "RIVESTIMENTO Antrasit 40x80",
    "seriesName": "RIVESTIMENTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "993",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9029484396506063.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9029484396506063.jpg"
    ],
    "size": "40x80",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bir mekânda aradığınız modernlik, dinlik ve güç ise aradığınızın Rivestimento Serisi olduğunu gönül rahatlığıyla söyleyebiliriz. Rivestimento Serisi beyaz , gri ve antrasit renkleri, fonksiyonel ve üstün teknik performansı ile mekanlarınızı hayallerinizde ki görünüme kavuşturuyor.</span>",
    "descriptionClean": "Bir mekânda aradığınız modernlik, dinlik ve güç ise aradığınızın Rivestimento Serisi olduğunu gönül rahatlığıyla söyleyebiliriz. Rivestimento Serisi beyaz , gri ve antrasit renkleri, fonksiyonel ve üstün teknik performansı ile mekanlarınızı hayallerinizde ki görünüme kavuşturuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_992",
    "brand": "Duratiles",
    "title": "RIVESTIMENTO Gri 40x80",
    "seriesName": "RIVESTIMENTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "992",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6258431382875306.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6258431382875306.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bir mekânda aradığınız modernlik, dinlik ve güç ise aradığınızın Rivestimento Serisi olduğunu gönül rahatlığıyla söyleyebiliriz. Rivestimento Serisi beyaz , gri ve antrasit renkleri, fonksiyonel ve üstün teknik performansı ile mekanlarınızı hayallerinizde ki görünüme kavuşturuyor.</span>",
    "descriptionClean": "Bir mekânda aradığınız modernlik, dinlik ve güç ise aradığınızın Rivestimento Serisi olduğunu gönül rahatlığıyla söyleyebiliriz. Rivestimento Serisi beyaz , gri ve antrasit renkleri, fonksiyonel ve üstün teknik performansı ile mekanlarınızı hayallerinizde ki görünüme kavuşturuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_995",
    "brand": "Duratiles",
    "title": "RIVESTIMENTO Antrasit 60x60",
    "seriesName": "RIVESTIMENTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "69577",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7797414337832131.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7797414337832131.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bir mekânda aradığınız modernlik, dinlik ve güç ise aradığınızın Rivestimento Serisi olduğunu gönül rahatlığıyla söyleyebiliriz. Rivestimento Serisi beyaz , gri ve antrasit renkleri, fonksiyonel ve üstün teknik performansı ile mekanlarınızı hayallerinizde ki görünüme kavuşturuyor.</span>",
    "descriptionClean": "Bir mekânda aradığınız modernlik, dinlik ve güç ise aradığınızın Rivestimento Serisi olduğunu gönül rahatlığıyla söyleyebiliriz. Rivestimento Serisi beyaz , gri ve antrasit renkleri, fonksiyonel ve üstün teknik performansı ile mekanlarınızı hayallerinizde ki görünüme kavuşturuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_994",
    "brand": "Duratiles",
    "title": "RIVESTIMENTO Gri 60x60",
    "seriesName": "RIVESTIMENTO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "69581",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11088590112154517.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11088590112154517.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bir mekânda aradığınız modernlik, dinlik ve güç ise aradığınızın Rivestimento Serisi olduğunu gönül rahatlığıyla söyleyebiliriz. Rivestimento Serisi beyaz , gri ve antrasit renkleri, fonksiyonel ve üstün teknik performansı ile mekanlarınızı hayallerinizde ki görünüme kavuşturuyor.</span>",
    "descriptionClean": "Bir mekânda aradığınız modernlik, dinlik ve güç ise aradığınızın Rivestimento Serisi olduğunu gönül rahatlığıyla söyleyebiliriz. Rivestimento Serisi beyaz , gri ve antrasit renkleri, fonksiyonel ve üstün teknik performansı ile mekanlarınızı hayallerinizde ki görünüme kavuşturuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_999",
    "brand": "Duratiles",
    "title": "SEVEN EVO Graphite 30x60",
    "seriesName": "SEVEN EVO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "999",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14129271788146947.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14129271788146947.jpg"
    ],
    "size": "30x60",
    "color": "Graphite",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Mimarinin vazgeçilmeyen klasiği brüt beton görünümü, Seven Evo Serisi sayesinde seramik şıklığıyla buluşuyor.</span>",
    "descriptionClean": "Mimarinin vazgeçilmeyen klasiği brüt beton görünümü, Seven Evo Serisi sayesinde seramik şıklığıyla buluşuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_998",
    "brand": "Duratiles",
    "title": "SEVEN EVO Taupe 60x60",
    "seriesName": "SEVEN EVO",
    "collection": "Beton",
    "category": "Beton",
    "sku": "998",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3156625273277186.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3156625273277186.jpg"
    ],
    "size": "60x60",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Mimarinin vazgeçilmeyen klasiği brüt beton görünümü, Seven Evo Serisi sayesinde seramik şıklığıyla buluşuyor.</span>",
    "descriptionClean": "Mimarinin vazgeçilmeyen klasiği brüt beton görünümü, Seven Evo Serisi sayesinde seramik şıklığıyla buluşuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1000",
    "brand": "Duratiles",
    "title": "SEVEN TREND Antrasit 60x120",
    "seriesName": "SEVEN TREND",
    "collection": "Beton",
    "category": "Beton",
    "sku": "1000",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3122477806387145.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3122477806387145.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Çok geniş bir kullanım alanı olan Seven Trend cesur bir dekorasyon tarzını benimseyenlerin favorisi.</span>",
    "descriptionClean": "Çok geniş bir kullanım alanı olan Seven Trend cesur bir dekorasyon tarzını benimseyenlerin favorisi.",
    "source": "duratiles"
  },
  {
    "id": "dura_1001",
    "brand": "Duratiles",
    "title": "SEVEN TREND Siyah 60x60",
    "seriesName": "SEVEN TREND",
    "collection": "Beton",
    "category": "Beton",
    "sku": "1001",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3527107469559466.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3527107469559466.jpg"
    ],
    "size": "60x60",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Çok geniş bir kullanım alanı olan Seven Trend cesur bir dekorasyon tarzını benimseyenlerin favorisi.</span>",
    "descriptionClean": "Çok geniş bir kullanım alanı olan Seven Trend cesur bir dekorasyon tarzını benimseyenlerin favorisi.",
    "source": "duratiles"
  },
  {
    "id": "dura_1002",
    "brand": "Duratiles",
    "title": "SEVEN TREND Grau 30x60",
    "seriesName": "SEVEN TREND",
    "collection": "Beton",
    "category": "Beton",
    "sku": "1002",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.548380088887952.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.548380088887952.jpg"
    ],
    "size": "30x60",
    "color": "Grau",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Çok geniş bir kullanım alanı olan Seven Trend cesur bir dekorasyon tarzını benimseyenlerin favorisi.</span>",
    "descriptionClean": "Çok geniş bir kullanım alanı olan Seven Trend cesur bir dekorasyon tarzını benimseyenlerin favorisi.",
    "source": "duratiles"
  },
  {
    "id": "dura_1003",
    "brand": "Duratiles",
    "title": "SKY GREY Koyu 60x60",
    "seriesName": "SKY GREY",
    "collection": "Beton",
    "category": "Beton",
    "sku": "10204",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7687400941401471.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7687400941401471.jpg"
    ],
    "size": "60x60",
    "color": "Koyu",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mimarinin vazgeçilmeyen klasiği brüt beton görünümü, Sky Grey Serisi sayesinde seramik şıklığıyla buluşuyor.</span>",
    "descriptionClean": "Mimarinin vazgeçilmeyen klasiği brüt beton görünümü, Sky Grey Serisi sayesinde seramik şıklığıyla buluşuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1004",
    "brand": "Duratiles",
    "title": "SKY GREY Mild 60x60",
    "seriesName": "SKY GREY",
    "collection": "Beton",
    "category": "Beton",
    "sku": "10202",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.02038783808267819.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.02038783808267819.jpg"
    ],
    "size": "60x60",
    "color": "Mild",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mimarinin vazgeçilmeyen klasiği brüt beton görünümü, Sky Grey Serisi sayesinde seramik şıklığıyla buluşuyor.</span>",
    "descriptionClean": "Mimarinin vazgeçilmeyen klasiği brüt beton görünümü, Sky Grey Serisi sayesinde seramik şıklığıyla buluşuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1005",
    "brand": "Duratiles",
    "title": "TAPA Gri 60x120",
    "seriesName": "TAPA",
    "collection": "Beton",
    "category": "Beton",
    "sku": "1005",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.054256914208978824.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.054256914208978824.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Tapa serisi ile size özel mekanlar tasarlayabilir , yaşam alanlarınıza stilizi yansıtabilirsiniz.</span>",
    "descriptionClean": "Tapa serisi ile size özel mekanlar tasarlayabilir , yaşam alanlarınıza stilizi yansıtabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1006",
    "brand": "Duratiles",
    "title": "TURNE Bianco 22x90",
    "seriesName": "TURNE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "1006",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2969781927691939.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2969781927691939.jpg"
    ],
    "size": "22x90",
    "color": "Bianco",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Doğanın kusursuz uyumunu yansıtan Turne Porselen Karosu dingin ve yalın iç mekan kurguları yaratır.</span>",
    "descriptionClean": "Doğanın kusursuz uyumunu yansıtan Turne Porselen Karosu dingin ve yalın iç mekan kurguları yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1008",
    "brand": "Duratiles",
    "title": "TURNE Wenge 22x90",
    "seriesName": "TURNE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "1008",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6425363681966132.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6425363681966132.jpg"
    ],
    "size": "22x90",
    "color": "Wenge",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Doğanın kusursuz uyumunu yansıtan Turne Porselen Karosu dingin ve yalın iç mekan kurguları yaratır.</span>",
    "descriptionClean": "Doğanın kusursuz uyumunu yansıtan Turne Porselen Karosu dingin ve yalın iç mekan kurguları yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1007",
    "brand": "Duratiles",
    "title": "TURNE Siyah 22x90",
    "seriesName": "TURNE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "1007",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.37318566015687316.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.37318566015687316.jpg"
    ],
    "size": "22x90",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Doğanın kusursuz uyumunu yansıtan Turne Porselen Karosu dingin ve yalın iç mekan kurguları yaratır.</span>",
    "descriptionClean": "Doğanın kusursuz uyumunu yansıtan Turne Porselen Karosu dingin ve yalın iç mekan kurguları yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1029",
    "brand": "Duratiles",
    "title": "ZAIRE Krem 60x120",
    "seriesName": "ZAIRE",
    "collection": "Beton",
    "category": "Beton",
    "sku": "1029",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9592597389830533.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9592597389830533.jpg"
    ],
    "size": "60x120",
    "color": "Krem",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Zaire porselen karoları hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor .</span>",
    "descriptionClean": "Zaire porselen karoları hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor .",
    "source": "duratiles"
  },
  {
    "id": "dura_1028",
    "brand": "Duratiles",
    "title": "URBAN Cenere 60x60",
    "seriesName": "URBAN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "1028",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1262677786248223.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1262677786248223.jpg"
    ],
    "size": "60x60",
    "color": "Cenere",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1027",
    "brand": "Duratiles",
    "title": "URBAN Taupe 60x60",
    "seriesName": "URBAN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "1027",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7236370258501174.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7236370258501174.jpg"
    ],
    "size": "60x60",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1026",
    "brand": "Duratiles",
    "title": "URBAN Gri 60x60",
    "seriesName": "URBAN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "69477",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4875265067994349.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4875265067994349.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1025",
    "brand": "Duratiles",
    "title": "URBAN Cool Grey 60x60",
    "seriesName": "URBAN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "1025",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12513248822469814.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12513248822469814.jpg"
    ],
    "size": "60x60",
    "color": "Cool Grey",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1024",
    "brand": "Duratiles",
    "title": "URBAN Fildişi 60x60",
    "seriesName": "URBAN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "1024",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9629439015829153.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9629439015829153.jpg"
    ],
    "size": "60x60",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1023",
    "brand": "Duratiles",
    "title": "URBAN Taupe 80x80",
    "seriesName": "URBAN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "1023",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6982458638345407.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6982458638345407.jpg"
    ],
    "size": "80x80",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1022",
    "brand": "Duratiles",
    "title": "URBAN Cenere 80x80",
    "seriesName": "URBAN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "1022",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6829298708201064.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6829298708201064.jpg"
    ],
    "size": "80x80",
    "color": "Cenere",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1021",
    "brand": "Duratiles",
    "title": "URBAN Gri 80x80",
    "seriesName": "URBAN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "1021",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7921483445109636.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7921483445109636.jpg"
    ],
    "size": "80x80",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1020",
    "brand": "Duratiles",
    "title": "URBAN Cool Grey 80x80",
    "seriesName": "URBAN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "1020",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6183975944944127.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6183975944944127.jpg"
    ],
    "size": "80x80",
    "color": "Cool Grey",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1019",
    "brand": "Duratiles",
    "title": "URBAN Cool Grey 100x100",
    "seriesName": "URBAN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "65413",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6412010749674547.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6412010749674547.jpg"
    ],
    "size": "100x100",
    "color": "Cool Grey",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1018",
    "brand": "Duratiles",
    "title": "URBAN Cenere 100x100",
    "seriesName": "URBAN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "1018",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21987013323921423.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21987013323921423.jpg"
    ],
    "size": "100x100",
    "color": "Cenere",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1017",
    "brand": "Duratiles",
    "title": "URBAN Gri 100x100",
    "seriesName": "URBAN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "67799",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9218496365659379.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9218496365659379.jpg"
    ],
    "size": "100x100",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1016",
    "brand": "Duratiles",
    "title": "URBAN Cenere 120x120",
    "seriesName": "URBAN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "1016",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.532830800240493.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.532830800240493.jpg"
    ],
    "size": "120x120",
    "color": "Cenere",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1015",
    "brand": "Duratiles",
    "title": "URBAN Cool Grey 120x120",
    "seriesName": "URBAN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "1015",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.374649940412462.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.374649940412462.jpg"
    ],
    "size": "120x120",
    "color": "Cool Grey",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1014",
    "brand": "Duratiles",
    "title": "URBAN Fildişi 120x120",
    "seriesName": "URBAN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "1014",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3794597747812537.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3794597747812537.jpg"
    ],
    "size": "120x120",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_2319",
    "brand": "Duratiles",
    "title": "URBAN Antrasit 100x100",
    "seriesName": "URBAN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "65409",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18940845149675856.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18940845149675856.jpg"
    ],
    "size": "100x100",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1013",
    "brand": "Duratiles",
    "title": "URBAN Gri 60x120",
    "seriesName": "URBAN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "71911",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2580539492538495.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2580539492538495.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1012",
    "brand": "Duratiles",
    "title": "URBAN Fildişi 60x120",
    "seriesName": "URBAN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "1012",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4306813711280697.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4306813711280697.jpg"
    ],
    "size": "60x120",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1009",
    "brand": "Duratiles",
    "title": "URBAN Gri 90x180",
    "seriesName": "URBAN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "12273",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12247552881898316.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12247552881898316.jpg"
    ],
    "size": "90x180",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1010",
    "brand": "Duratiles",
    "title": "URBAN Cenere 60x120",
    "seriesName": "URBAN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "1010",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12356682239576977.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12356682239576977.jpg"
    ],
    "size": "60x120",
    "color": "Cenere",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1011",
    "brand": "Duratiles",
    "title": "URBAN Cool Grey 60x120",
    "seriesName": "URBAN",
    "collection": "Beton",
    "category": "Beton",
    "sku": "1011",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.250457257925805.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.250457257925805.jpg"
    ],
    "size": "60x120",
    "color": "Cool Grey",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır</span>",
    "descriptionClean": "Geniş ürün yelpazesi ile her mekana ve tarza göre çözümler sunan Urba Serisi ilham veren mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1033",
    "brand": "Duratiles",
    "title": "AFEL Gri 60x120",
    "seriesName": "AFEL",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1033",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36433626795236784.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36433626795236784.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Lüks algısını yediden yorumlayan Afel Porselen Karoları renk alternatifi ile yaratıcılığınızı özgürleştiriyor</span>",
    "descriptionClean": "Lüks algısını yediden yorumlayan Afel Porselen Karoları renk alternatifi ile yaratıcılığınızı özgürleştiriyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1032",
    "brand": "Duratiles",
    "title": "AFEL Night 60x120",
    "seriesName": "AFEL",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1032",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5678989165702305.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5678989165702305.jpg"
    ],
    "size": "60x120",
    "color": "Night",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Dış Cephe",
      "V3",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Lüks algısını yediden yorumlayan Afel Porselen Karoları renk alternatifi ile yaratıcılığınızı özgürleştiriyor</span>",
    "descriptionClean": "Lüks algısını yediden yorumlayan Afel Porselen Karoları renk alternatifi ile yaratıcılığınızı özgürleştiriyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1036",
    "brand": "Duratiles",
    "title": "ALBEDO Kahve 60x120",
    "seriesName": "ALBEDO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1036",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7614307285816585.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7614307285816585.jpg"
    ],
    "size": "60x120",
    "color": "Kahve",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Dış Cephe",
      "V3",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Mekanlara yeni bir hareket ve derinlik getiren Albedo Porselen Karoları, maximum konforu hedefliyor.</span>",
    "descriptionClean": "Mekanlara yeni bir hareket ve derinlik getiren Albedo Porselen Karoları, maximum konforu hedefliyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1034",
    "brand": "Duratiles",
    "title": "ALBEDO Mavi 60x120",
    "seriesName": "ALBEDO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1034",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2606951662318946.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2606951662318946.jpg"
    ],
    "size": "60x120",
    "color": "Mavi",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Dış Cephe",
      "V3",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Mekanlara yeni bir hareket ve derinlik getiren Albedo Porselen Karoları, maximum konforu hedefliyor.</span>",
    "descriptionClean": "Mekanlara yeni bir hareket ve derinlik getiren Albedo Porselen Karoları, maximum konforu hedefliyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1035",
    "brand": "Duratiles",
    "title": "ALBEDO Antrasit 60x120",
    "seriesName": "ALBEDO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1035",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.401967581882845.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.401967581882845.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Dış Cephe",
      "V3",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Mekanlara yeni bir hareket ve derinlik getiren Albedo Porselen Karoları, maximum konforu hedefliyor.</span>",
    "descriptionClean": "Mekanlara yeni bir hareket ve derinlik getiren Albedo Porselen Karoları, maximum konforu hedefliyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1038",
    "brand": "Duratiles",
    "title": "ALPIN NATURA Beyaz 60x60",
    "seriesName": "ALPIN NATURA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1038",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9737490185453721.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9737490185453721.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer deseninin kattığı dinamizm ve full lappato yüzey özelliğinin verdiği ışıltıyla Alpin Natura Porselen Karoları yaşam alanlarına ferahlık ve hareket katar.</span>",
    "descriptionClean": "Mermer deseninin kattığı dinamizm ve full lappato yüzey özelliğinin verdiği ışıltıyla Alpin Natura Porselen Karoları yaşam alanlarına ferahlık ve hareket katar.",
    "source": "duratiles"
  },
  {
    "id": "dura_1037",
    "brand": "Duratiles",
    "title": "ALPIN NATURA Beyaz 60x120",
    "seriesName": "ALPIN NATURA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1037",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6553932786556859.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6553932786556859.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer deseninin kattığı dinamizm ve full lappato yüzey özelliğinin verdiği ışıltıyla Alpin Natura Porselen Karoları yaşam alanlarına ferahlık ve hareket katar.</span>",
    "descriptionClean": "Mermer deseninin kattığı dinamizm ve full lappato yüzey özelliğinin verdiği ışıltıyla Alpin Natura Porselen Karoları yaşam alanlarına ferahlık ve hareket katar.",
    "source": "duratiles"
  },
  {
    "id": "dura_1041",
    "brand": "Duratiles",
    "title": "ANUBIS Taupe 60x120",
    "seriesName": "ANUBIS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1041",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7830142590108272.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7830142590108272.jpg"
    ],
    "size": "60x120",
    "color": "Taupe",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümünü full lappato özelliği ile taçlandıran Anubis Porselen Karoları üç ayrı renk seçeneği ile yaşam alanlarına rafine bir şıklık getiriyor.</span>",
    "descriptionClean": "Mermer görünümünü full lappato özelliği ile taçlandıran Anubis Porselen Karoları üç ayrı renk seçeneği ile yaşam alanlarına rafine bir şıklık getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1040",
    "brand": "Duratiles",
    "title": "ANUBIS Bej 60x120",
    "seriesName": "ANUBIS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "77309",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09919277930019943.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09919277930019943.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Crowning its marble look with full lappato feature, Anubis Porcelain Tiles add a refined elegance to your living spaces with three different color options.</span>",
    "descriptionClean": "Crowning its marble look with full lappato feature, Anubis Porcelain Tiles add a refined elegance to your living spaces with three different color options.",
    "source": "duratiles"
  },
  {
    "id": "dura_1039",
    "brand": "Duratiles",
    "title": "ANUBIS Siyah 60x120",
    "seriesName": "ANUBIS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "77307",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48619791476917684.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48619791476917684.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümünü full lappato özelliği ile taçlandıran Anubis Porselen Karoları üç ayrı renk seçeneği ile yaşam alanlarına rafine bir şıklık getiriyor.</span>",
    "descriptionClean": "Mermer görünümünü full lappato özelliği ile taçlandıran Anubis Porselen Karoları üç ayrı renk seçeneği ile yaşam alanlarına rafine bir şıklık getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1042",
    "brand": "Duratiles",
    "title": "ANUBIS Taupe 60x60",
    "seriesName": "ANUBIS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1042",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23960804019900606.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23960804019900606.jpg"
    ],
    "size": "60x60",
    "color": "Taupe",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümünü full lappato özelliği ile taçlandıran Anubis Porselen Karoları üç ayrı renk seçeneği ile yaşam alanlarına rafine bir şıklık getiriyor.</span>",
    "descriptionClean": "Mermer görünümünü full lappato özelliği ile taçlandıran Anubis Porselen Karoları üç ayrı renk seçeneği ile yaşam alanlarına rafine bir şıklık getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1043",
    "brand": "Duratiles",
    "title": "ANUBIS Bej 60x60",
    "seriesName": "ANUBIS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1043",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4536905889399855.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4536905889399855.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümünü full lappato özelliği ile taçlandıran Anubis Porselen Karoları üç ayrı renk seçeneği ile yaşam alanlarına rafine bir şıklık getiriyor.</span>",
    "descriptionClean": "Mermer görünümünü full lappato özelliği ile taçlandıran Anubis Porselen Karoları üç ayrı renk seçeneği ile yaşam alanlarına rafine bir şıklık getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1044",
    "brand": "Duratiles",
    "title": "ANUBIS Siyah 60x60",
    "seriesName": "ANUBIS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1044",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43749679929905616.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43749679929905616.jpg"
    ],
    "size": "60x60",
    "color": "Siyah",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümünü full lappato özelliği ile taçlandıran Anubis Porselen Karoları üç ayrı renk seçeneği ile yaşam alanlarına rafine bir şıklık getiriyor.</span>",
    "descriptionClean": "Mermer görünümünü full lappato özelliği ile taçlandıran Anubis Porselen Karoları üç ayrı renk seçeneği ile yaşam alanlarına rafine bir şıklık getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1046",
    "brand": "Duratiles",
    "title": "ARAS Antrasit 60x120",
    "seriesName": "ARAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1046",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2678617234210663.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2678617234210663.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Granit",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermerin göz alıcı görünümünü parlak yüzeyi ile daha da ön plana çıkaran Aras Serisinin kahve ve antrasit renk alternatifleriyle çekici, davetkar mekanlar yaratmanız çok kolay.</span>",
    "descriptionClean": "Mermerin göz alıcı görünümünü parlak yüzeyi ile daha da ön plana çıkaran Aras Serisinin kahve ve antrasit renk alternatifleriyle çekici, davetkar mekanlar yaratmanız çok kolay.",
    "source": "duratiles"
  },
  {
    "id": "dura_1045",
    "brand": "Duratiles",
    "title": "ARAS Kahve 60x120",
    "seriesName": "ARAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "67338",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17092530078949253.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17092530078949253.jpg"
    ],
    "size": "60x120",
    "color": "Kahve",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermerin göz alıcı görünümünü parlak yüzeyi ile daha da ön plana çıkaran Aras Serisinin kahve ve antrasit renk alternatifleriyle çekici, davetkar mekanlar yaratmanız çok kolay.</span>",
    "descriptionClean": "Mermerin göz alıcı görünümünü parlak yüzeyi ile daha da ön plana çıkaran Aras Serisinin kahve ve antrasit renk alternatifleriyle çekici, davetkar mekanlar yaratmanız çok kolay.",
    "source": "duratiles"
  },
  {
    "id": "dura_1047",
    "brand": "Duratiles",
    "title": "ARGENTO Travertino 40x80",
    "seriesName": "ARGENTO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "64921",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09020144343816383.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09020144343816383.jpg"
    ],
    "size": "40x80",
    "color": "Travertino",
    "surface": "Mat, Color Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Teknik Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Argento Sırlı Porselen Karoları sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.</span>",
    "descriptionClean": "Argento Sırlı Porselen Karoları sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1049",
    "brand": "Duratiles",
    "title": "ARIANA  River 40x120",
    "seriesName": "ARIANA ",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1049",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12330538336746633.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12330538336746633.jpg"
    ],
    "size": "40x120",
    "color": "River",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Banyo",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Evinize estetik bir dokunuş katacak olan Ariana Serisi ile seramiğin doğallığı her mekânda sizinle. Tarzınızı tamamlayan detayların bütünü bu seride saklı.</span>",
    "descriptionClean": "Evinize estetik bir dokunuş katacak olan Ariana Serisi ile seramiğin doğallığı her mekânda sizinle. Tarzınızı tamamlayan detayların bütünü bu seride saklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1048",
    "brand": "Duratiles",
    "title": "ARIANA Krema 40x120",
    "seriesName": "ARIANA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1048",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.570256683134136.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.570256683134136.jpg"
    ],
    "size": "40x120",
    "color": "Krema",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Banyo",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Evinize estetik bir dokunuş katacak olan Ariana Serisi ile seramiğin doğallığı her mekânda sizinle. Tarzınızı tamamlayan detayların bütünü bu seride saklı.</span>",
    "descriptionClean": "Evinize estetik bir dokunuş katacak olan Ariana Serisi ile seramiğin doğallığı her mekânda sizinle. Tarzınızı tamamlayan detayların bütünü bu seride saklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1052",
    "brand": "Duratiles",
    "title": "ARIANA Krem 60x60",
    "seriesName": "ARIANA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1052",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7549998655325186.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7549998655325186.jpg"
    ],
    "size": "60x60",
    "color": "Krem",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Evinize estetik bir dokunuş katacak olan Ariana Serisi ile seramiğin doğallığı her mekânda sizinle. Tarzınızı tamamlayan detayların bütünü bu seride saklı.</span>",
    "descriptionClean": "Evinize estetik bir dokunuş katacak olan Ariana Serisi ile seramiğin doğallığı her mekânda sizinle. Tarzınızı tamamlayan detayların bütünü bu seride saklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1051",
    "brand": "Duratiles",
    "title": "ARIANA Krema 60x60",
    "seriesName": "ARIANA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1051",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5790308933433788.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5790308933433788.jpg"
    ],
    "size": "60x60",
    "color": "Krema",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Evinize estetik bir dokunuş katacak olan Ariana Serisi ile seramiğin doğallığı her mekânda sizinle. Tarzınızı tamamlayan detayların bütünü bu seride saklı.</span>",
    "descriptionClean": "Evinize estetik bir dokunuş katacak olan Ariana Serisi ile seramiğin doğallığı her mekânda sizinle. Tarzınızı tamamlayan detayların bütünü bu seride saklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1050",
    "brand": "Duratiles",
    "title": "ARIANA Maze Dekofon 40x120",
    "seriesName": "ARIANA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1050",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7344632581798385.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7344632581798385.jpg"
    ],
    "size": "40x120",
    "color": "Maze Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Banyo",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Evinize estetik bir dokunuş katacak olan Ariana Serisi ile seramiğin doğallığı her mekânda sizinle. Tarzınızı tamamlayan detayların bütünü bu seride saklı.</span>",
    "descriptionClean": "Evinize estetik bir dokunuş katacak olan Ariana Serisi ile seramiğin doğallığı her mekânda sizinle. Tarzınızı tamamlayan detayların bütünü bu seride saklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1053",
    "brand": "Duratiles",
    "title": "ARMANI Siyah 60x120",
    "seriesName": "ARMANI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "69412",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2152388324175808.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2152388324175808.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Evinize estetik bir dokunuş katacak olan Armani Serisi ile seramiğin doğallığı her mekânda sizinle. Tarzınızı tamamlayan detayların bütünü bu seride saklı.</span>",
    "descriptionClean": "Evinize estetik bir dokunuş katacak olan Armani Serisi ile seramiğin doğallığı her mekânda sizinle. Tarzınızı tamamlayan detayların bütünü bu seride saklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1054",
    "brand": "Duratiles",
    "title": "ARMONIA Armonia 60x60",
    "seriesName": "ARMONIA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1054",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28477307812355057.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28477307812355057.jpg"
    ],
    "size": "60x60",
    "color": "Armonia",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Armonia Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.</span>",
    "descriptionClean": "Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Armonia Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1057",
    "brand": "Duratiles",
    "title": "ASTANA Koyu Gri 60x120",
    "seriesName": "ASTANA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1057",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2915614556535858.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2915614556535858.jpg"
    ],
    "size": "60x120",
    "color": "Koyu Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Astana porselen karoları hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor .</span>",
    "descriptionClean": "Astana porselen karoları hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor .",
    "source": "duratiles"
  },
  {
    "id": "dura_1056",
    "brand": "Duratiles",
    "title": "ASTANA Gri 60x120",
    "seriesName": "ASTANA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1056",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7186730858611807.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7186730858611807.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Astana porselen karoları hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor .</span>",
    "descriptionClean": "Astana porselen karoları hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor .",
    "source": "duratiles"
  },
  {
    "id": "dura_1055",
    "brand": "Duratiles",
    "title": "ASTANA Açık Gri 60x120",
    "seriesName": "ASTANA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1055",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20009092091288772.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20009092091288772.jpg"
    ],
    "size": "60x120",
    "color": "Açık Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Astana porselen karoları hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor .</span>",
    "descriptionClean": "Astana porselen karoları hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor .",
    "source": "duratiles"
  },
  {
    "id": "dura_1058",
    "brand": "Duratiles",
    "title": "ASTECA Aria 60x120",
    "seriesName": "ASTECA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12282",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4535817442994021.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4535817442994021.jpg"
    ],
    "size": "60x120",
    "color": "Aria",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V1"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Konutlar dışında otel ve restoran gibi ticari yapılarda da tercih edilen Asteca Serisi iç ve dış mekan tasarımlarının yer ve duvar uygulamalarında kullanılarak alanları sanat eserlerine dönüştürüyor.</span>",
    "descriptionClean": "Konutlar dışında otel ve restoran gibi ticari yapılarda da tercih edilen Asteca Serisi iç ve dış mekan tasarımlarının yer ve duvar uygulamalarında kullanılarak alanları sanat eserlerine dönüştürüyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1060",
    "brand": "Duratiles",
    "title": "ASTRA Gri 60x60",
    "seriesName": "ASTRA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1060",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.49548079237841147.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.49548079237841147.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Yumuşak ve dingin renk kartelasını altın ışıltılarla canlandırılan Astra Serisi, mermer dokusunu parlak yüzeyi ile daha göz alıcı hale getirerek yaşam alanlarınıza dingin, romantik bir hava esmesini sağlıyor.</span>",
    "descriptionClean": "Yumuşak ve dingin renk kartelasını altın ışıltılarla canlandırılan Astra Serisi, mermer dokusunu parlak yüzeyi ile daha göz alıcı hale getirerek yaşam alanlarınıza dingin, romantik bir hava esmesini sağlıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1059",
    "brand": "Duratiles",
    "title": "ASTRA Bone 60x60",
    "seriesName": "ASTRA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1059",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17342908049766526.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17342908049766526.jpg"
    ],
    "size": "60x60",
    "color": "Bone",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Yumuşak ve dingin renk kartelasını altın ışıltılarla canlandırılan Astra Serisi, mermer dokusunu parlak yüzeyi ile daha göz alıcı hale getirerek yaşam alanlarınıza dingin, romantik bir hava esmesini sağlıyor.</span>",
    "descriptionClean": "Yumuşak ve dingin renk kartelasını altın ışıltılarla canlandırılan Astra Serisi, mermer dokusunu parlak yüzeyi ile daha göz alıcı hale getirerek yaşam alanlarınıza dingin, romantik bir hava esmesini sağlıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1061",
    "brand": "Duratiles",
    "title": "AURA Beyaz 60x120",
    "seriesName": "AURA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1061",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4566137394651456.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4566137394651456.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Aura Serisi göz alıcı mermer görünümüyle mekanlara yeni bir soluk ve derinlik getiriyor.</span>",
    "descriptionClean": "Aura Serisi göz alıcı mermer görünümüyle mekanlara yeni bir soluk ve derinlik getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1062",
    "brand": "Duratiles",
    "title": "AURA Beyaz 80x80",
    "seriesName": "AURA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1062",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14548359082356155.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14548359082356155.jpg"
    ],
    "size": "80x80",
    "color": "Beyaz",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Aura Serisi göz alıcı mermer görünümüyle mekanlara yeni bir soluk ve derinlik getiriyor.</span>",
    "descriptionClean": "Aura Serisi göz alıcı mermer görünümüyle mekanlara yeni bir soluk ve derinlik getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1063",
    "brand": "Duratiles",
    "title": "AURA Beyaz 30x60",
    "seriesName": "AURA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1063",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5777778337721712.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5777778337721712.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Aura Serisi göz alıcı mermer görünümüyle mekanlara yeni bir soluk ve derinlik getiriyor.</span>",
    "descriptionClean": "Aura Serisi göz alıcı mermer görünümüyle mekanlara yeni bir soluk ve derinlik getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1064",
    "brand": "Duratiles",
    "title": "AUSTRALE BOOKMATCH Beyaz 30x60",
    "seriesName": "AUSTRALE BOOKMATCH",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1064",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07859646017687849.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07859646017687849.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Aura Serisi göz alıcı mermer görünümüyle mekanlara yeni bir soluk ve derinlik getiriyor.</span>",
    "descriptionClean": "Aura Serisi göz alıcı mermer görünümüyle mekanlara yeni bir soluk ve derinlik getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1065",
    "brand": "Duratiles",
    "title": "BALTIC Kahverengi 60x120",
    "seriesName": "BALTIC",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1065",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23243874225289385.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23243874225289385.jpg"
    ],
    "size": "60x120",
    "color": "Kahverengi",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dikkat çekici ve gösterişli iç mekan kurguları için ideal bir seçenek olan Baltic Porselen Karolarının full lappato özelliği sayesinde yaşam alanlarınız daha parlak daha ışıltılı.</span>",
    "descriptionClean": "Dikkat çekici ve gösterişli iç mekan kurguları için ideal bir seçenek olan Baltic Porselen Karolarının full lappato özelliği sayesinde yaşam alanlarınız daha parlak daha ışıltılı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1066",
    "brand": "Duratiles",
    "title": "BALTIC Koyu Gri 60x120",
    "seriesName": "BALTIC",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1066",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43394935372620336.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43394935372620336.jpg"
    ],
    "size": "60x120",
    "color": "Koyu Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dikkat çekici ve gösterişli iç mekan kurguları için ideal bir seçenek olan Baltic Porselen Karolarının full lappato özelliği sayesinde yaşam alanlarınız daha parlak daha ışıltılı.</span>",
    "descriptionClean": "Dikkat çekici ve gösterişli iç mekan kurguları için ideal bir seçenek olan Baltic Porselen Karolarının full lappato özelliği sayesinde yaşam alanlarınız daha parlak daha ışıltılı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1067",
    "brand": "Duratiles",
    "title": "BALTIC Gri 60x120",
    "seriesName": "BALTIC",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1067",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1911584606745892.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1911584606745892.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dikkat çekici ve gösterişli iç mekan kurguları için ideal bir seçenek olan Baltic Porselen Karolarının full lappato özelliği sayesinde yaşam alanlarınız daha parlak daha ışıltılı.</span>",
    "descriptionClean": "Dikkat çekici ve gösterişli iç mekan kurguları için ideal bir seçenek olan Baltic Porselen Karolarının full lappato özelliği sayesinde yaşam alanlarınız daha parlak daha ışıltılı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1068",
    "brand": "Duratiles",
    "title": "BALTIC Gri 60x60",
    "seriesName": "BALTIC",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1068",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3154907297514681.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3154907297514681.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dikkat çekici ve gösterişli iç mekan kurguları için ideal bir seçenek olan Baltic Porselen Karolarının full lappato özelliği sayesinde yaşam alanlarınız daha parlak daha ışıltılı.</span>",
    "descriptionClean": "Dikkat çekici ve gösterişli iç mekan kurguları için ideal bir seçenek olan Baltic Porselen Karolarının full lappato özelliği sayesinde yaşam alanlarınız daha parlak daha ışıltılı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1069",
    "brand": "Duratiles",
    "title": "BALTIC Koyu Gri 60x60",
    "seriesName": "BALTIC",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1069",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2635092899993947.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2635092899993947.jpg"
    ],
    "size": "60x60",
    "color": "Koyu Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dikkat çekici ve gösterişli iç mekan kurguları için ideal bir seçenek olan Baltic Porselen Karolarının full lappato özelliği sayesinde yaşam alanlarınız daha parlak daha ışıltılı.</span>",
    "descriptionClean": "Dikkat çekici ve gösterişli iç mekan kurguları için ideal bir seçenek olan Baltic Porselen Karolarının full lappato özelliği sayesinde yaşam alanlarınız daha parlak daha ışıltılı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1070",
    "brand": "Duratiles",
    "title": "BALTIC Kahverengi 60x60",
    "seriesName": "BALTIC",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1070",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5901426694522811.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5901426694522811.jpg"
    ],
    "size": "60x60",
    "color": "Kahverengi",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dikkat çekici ve gösterişli iç mekan kurguları için ideal bir seçenek olan Baltic Porselen Karolarının full lappato özelliği sayesinde yaşam alanlarınız daha parlak daha ışıltılı.</span>",
    "descriptionClean": "Dikkat çekici ve gösterişli iç mekan kurguları için ideal bir seçenek olan Baltic Porselen Karolarının full lappato özelliği sayesinde yaşam alanlarınız daha parlak daha ışıltılı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1071",
    "brand": "Duratiles",
    "title": "BELLINI Krem 60x60",
    "seriesName": "BELLINI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1071",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9355850634226577.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9355850634226577.jpg"
    ],
    "size": "60x60",
    "color": "Krem",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tarz sahibi mekânlara yumuşak bir dokunuş yapmak için özenle tasarlanan bir seri... Bellini serisi zarafete açılan huzur dolu bir pencere. İzin verin seramiğin havası evinizi sarsın.</span>",
    "descriptionClean": "Tarz sahibi mekânlara yumuşak bir dokunuş yapmak için özenle tasarlanan bir seri... Bellini serisi zarafete açılan huzur dolu bir pencere. İzin verin seramiğin havası evinizi sarsın.",
    "source": "duratiles"
  },
  {
    "id": "dura_1072",
    "brand": "Duratiles",
    "title": "BETA Bone 60x120",
    "seriesName": "BETA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1072",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4065194902966819.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4065194902966819.jpg"
    ],
    "size": "60x120",
    "color": "Bone",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Şık ve modern dokunuşun mekânlardaki yansıması Beta Serisi geniş ürün yelpazesi ile özgün tasarımlara imza atıyor.</span>",
    "descriptionClean": "Şık ve modern dokunuşun mekânlardaki yansıması Beta Serisi geniş ürün yelpazesi ile özgün tasarımlara imza atıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1073",
    "brand": "Duratiles",
    "title": "BETA Siyah 60x120",
    "seriesName": "BETA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1073",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6720823252671584.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6720823252671584.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Şık ve modern dokunuşun mekânlardaki yansıması Beta Serisi geniş ürün yelpazesi ile özgün tasarımlara imza atıyor.</span>",
    "descriptionClean": "Şık ve modern dokunuşun mekânlardaki yansıması Beta Serisi geniş ürün yelpazesi ile özgün tasarımlara imza atıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1074",
    "brand": "Duratiles",
    "title": "BETA Bone 40x120",
    "seriesName": "BETA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1074",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.32151026573070896.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.32151026573070896.jpg"
    ],
    "size": "40x120",
    "color": "Bone",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Şık ve modern dokunuşun mekânlardaki yansıması Beta Serisi geniş ürün yelpazesi ile özgün tasarımlara imza atıyor.</span>",
    "descriptionClean": "Şık ve modern dokunuşun mekânlardaki yansıması Beta Serisi geniş ürün yelpazesi ile özgün tasarımlara imza atıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1075",
    "brand": "Duratiles",
    "title": "BETA Siyah 40x120",
    "seriesName": "BETA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1075",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7806217938582608.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7806217938582608.jpg"
    ],
    "size": "40x120",
    "color": "Siyah",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Şık ve modern dokunuşun mekânlardaki yansıması Beta Serisi geniş ürün yelpazesi ile özgün tasarımlara imza atıyor.</span>",
    "descriptionClean": "Şık ve modern dokunuşun mekânlardaki yansıması Beta Serisi geniş ürün yelpazesi ile özgün tasarımlara imza atıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1076",
    "brand": "Duratiles",
    "title": "BETA Dekofon 40x120",
    "seriesName": "BETA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1076",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3338272277857337.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3338272277857337.jpg"
    ],
    "size": "40x120",
    "color": "Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Şık ve modern dokunuşun mekânlardaki yansıması Beta Serisi geniş ürün yelpazesi ile özgün tasarımlara imza atıyor.</span>",
    "descriptionClean": "Şık ve modern dokunuşun mekânlardaki yansıması Beta Serisi geniş ürün yelpazesi ile özgün tasarımlara imza atıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1077",
    "brand": "Duratiles",
    "title": "BETA Bone 60x60",
    "seriesName": "BETA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1077",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22650369041193041.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22650369041193041.jpg"
    ],
    "size": "60x60",
    "color": "Bone",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "Teknik Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Şık ve modern dokunuşun mekânlardaki yansıması Beta Serisi geniş ürün yelpazesi ile özgün tasarımlara imza atıyor.</span>",
    "descriptionClean": "Şık ve modern dokunuşun mekânlardaki yansıması Beta Serisi geniş ürün yelpazesi ile özgün tasarımlara imza atıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1078",
    "brand": "Duratiles",
    "title": "BETA Siyah 60x60",
    "seriesName": "BETA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1078",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.186822564970911.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.186822564970911.jpg"
    ],
    "size": "60x60",
    "color": "Siyah",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "Teknik Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Şık ve modern dokunuşun mekânlardaki yansıması Beta Serisi geniş ürün yelpazesi ile özgün tasarımlara imza atıyor.</span>",
    "descriptionClean": "Şık ve modern dokunuşun mekânlardaki yansıması Beta Serisi geniş ürün yelpazesi ile özgün tasarımlara imza atıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1079",
    "brand": "Duratiles",
    "title": "BETA Dekor 60x60",
    "seriesName": "BETA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1079",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.62974580707795.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.62974580707795.jpg"
    ],
    "size": "60x60",
    "color": "Dekor",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "Teknik Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Şık ve modern dokunuşun mekânlardaki yansıması Beta Serisi geniş ürün yelpazesi ile özgün tasarımlara imza atıyor.</span>",
    "descriptionClean": "Şık ve modern dokunuşun mekânlardaki yansıması Beta Serisi geniş ürün yelpazesi ile özgün tasarımlara imza atıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1080",
    "brand": "Duratiles",
    "title": "BLACK JACK Siyah 60x120",
    "seriesName": "BLACK JACK",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1080",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4813476524196275.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4813476524196275.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Siyahın cazibesini mermerin ihtişamı ile daha da ön plana çıkaran Black Jack Serisi desenindeki hareketliliği mekanlara taşıyarak canlı, dinamik bir tasarım ortaya koyuyor.</span>",
    "descriptionClean": "Siyahın cazibesini mermerin ihtişamı ile daha da ön plana çıkaran Black Jack Serisi desenindeki hareketliliği mekanlara taşıyarak canlı, dinamik bir tasarım ortaya koyuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1081",
    "brand": "Duratiles",
    "title": "BOSCOSTONE Bej 60x120",
    "seriesName": "BOSCOSTONE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1081",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7613810011611767.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7613810011611767.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Granit",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğanın zenginliğinden ilham alarak tasarlanan Boscostone Porselen Karoları yaşam alanlarına tazeleyici bir etki getiriyor.</span>",
    "descriptionClean": "Doğanın zenginliğinden ilham alarak tasarlanan Boscostone Porselen Karoları yaşam alanlarına tazeleyici bir etki getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1082",
    "brand": "Duratiles",
    "title": "BOTTICINO Beyaz 60x120",
    "seriesName": "BOTTICINO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "69854",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4058556920119645.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4058556920119645.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Botticino serisi porselen karoları ile mekânlara sıra dışı bir görünüm kazandırın. Ayrıntıların keyfini çıkarın. Botticino serisi ile doğal ve zarif mekânlar yaratın. Estetiğin keyfini çıkarın.</span>",
    "descriptionClean": "Botticino serisi porselen karoları ile mekânlara sıra dışı bir görünüm kazandırın. Ayrıntıların keyfini çıkarın. Botticino serisi ile doğal ve zarif mekânlar yaratın. Estetiğin keyfini çıkarın.",
    "source": "duratiles"
  },
  {
    "id": "dura_1083",
    "brand": "Duratiles",
    "title": "BOTTICINO Gri 60x120",
    "seriesName": "BOTTICINO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1083",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.034894885517682606.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.034894885517682606.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Granit",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Botticino serisi porselen karoları ile mekânlara sıra dışı bir görünüm kazandırın. Ayrıntıların keyfini çıkarın. Botticino serisi ile doğal ve zarif mekânlar yaratın. Estetiğin keyfini çıkarın.</span>",
    "descriptionClean": "Botticino serisi porselen karoları ile mekânlara sıra dışı bir görünüm kazandırın. Ayrıntıların keyfini çıkarın. Botticino serisi ile doğal ve zarif mekânlar yaratın. Estetiğin keyfini çıkarın.",
    "source": "duratiles"
  },
  {
    "id": "dura_1084",
    "brand": "Duratiles",
    "title": "BOTTICINO Taupe 60x120",
    "seriesName": "BOTTICINO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "72186",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7953767350792258.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7953767350792258.jpg"
    ],
    "size": "60x120",
    "color": "Taupe",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Botticino serisi porselen karoları ile mekânlara sıra dışı bir görünüm kazandırın. Ayrıntıların keyfini çıkarın. Botticino serisi ile doğal ve zarif mekânlar yaratın. Estetiğin keyfini çıkarın.</span>",
    "descriptionClean": "Botticino serisi porselen karoları ile mekânlara sıra dışı bir görünüm kazandırın. Ayrıntıların keyfini çıkarın. Botticino serisi ile doğal ve zarif mekânlar yaratın. Estetiğin keyfini çıkarın.",
    "source": "duratiles"
  },
  {
    "id": "dura_1085",
    "brand": "Duratiles",
    "title": "BOTTICINO Beyaz 60x60",
    "seriesName": "BOTTICINO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1085",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6144519291115774.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6144519291115774.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Botticino serisi porselen karoları ile mekânlara sıra dışı bir görünüm kazandırın. Ayrıntıların keyfini çıkarın. Botticino serisi ile doğal ve zarif mekânlar yaratın. Estetiğin keyfini çıkarın.</span>",
    "descriptionClean": "Botticino serisi porselen karoları ile mekânlara sıra dışı bir görünüm kazandırın. Ayrıntıların keyfini çıkarın. Botticino serisi ile doğal ve zarif mekânlar yaratın. Estetiğin keyfini çıkarın.",
    "source": "duratiles"
  },
  {
    "id": "dura_1086",
    "brand": "Duratiles",
    "title": "BOTTICINO Gri 60x60",
    "seriesName": "BOTTICINO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1086",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7653181055698011.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7653181055698011.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Botticino serisi porselen karoları ile mekânlara sıra dışı bir görünüm kazandırın. Ayrıntıların keyfini çıkarın. Botticino serisi ile doğal ve zarif mekânlar yaratın. Estetiğin keyfini çıkarın.</span>",
    "descriptionClean": "Botticino serisi porselen karoları ile mekânlara sıra dışı bir görünüm kazandırın. Ayrıntıların keyfini çıkarın. Botticino serisi ile doğal ve zarif mekânlar yaratın. Estetiğin keyfini çıkarın.",
    "source": "duratiles"
  },
  {
    "id": "dura_1087",
    "brand": "Duratiles",
    "title": "BOTTICINO Taupe 60x60",
    "seriesName": "BOTTICINO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1087",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7990610088021968.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7990610088021968.jpg"
    ],
    "size": "60x60",
    "color": "Taupe",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Botticino serisi porselen karoları ile mekânlara sıra dışı bir görünüm kazandırın. Ayrıntıların keyfini çıkarın. Botticino serisi ile doğal ve zarif mekânlar yaratın. Estetiğin keyfini çıkarın.</span>",
    "descriptionClean": "Botticino serisi porselen karoları ile mekânlara sıra dışı bir görünüm kazandırın. Ayrıntıların keyfini çıkarın. Botticino serisi ile doğal ve zarif mekânlar yaratın. Estetiğin keyfini çıkarın.",
    "source": "duratiles"
  },
  {
    "id": "dura_1088",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Gri 45x90",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1088",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19055393323017666.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19055393323017666.jpg"
    ],
    "size": "45x90",
    "color": "Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1089",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Taupe 45x90",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1089",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5296815018485681.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5296815018485681.jpg"
    ],
    "size": "45x90",
    "color": "Taupe",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1093",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Natural 45x90",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1093",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3528856940917483.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3528856940917483.jpg"
    ],
    "size": "45x90",
    "color": "Natural",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1090",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Gri 60x90",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "67099",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4595949365635229.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4595949365635229.jpg"
    ],
    "size": "60x90",
    "color": "Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1091",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Taupe 60x90",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "67095",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5097421930681248.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5097421930681248.jpg"
    ],
    "size": "60x90",
    "color": "Taupe",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1092",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Natural 60x90",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "67097",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09967588555143037.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09967588555143037.jpg"
    ],
    "size": "60x90",
    "color": "Natural",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1114",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Taupe 40x40",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1114",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.855081574134997.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.855081574134997.jpg"
    ],
    "size": "40x40",
    "color": "Taupe",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Ticari Alanlar & Balkon/Teras",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1113",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Natural 40x40",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1113",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10775890636273311.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10775890636273311.jpg"
    ],
    "size": "40x40",
    "color": "Natural",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Ticari Alanlar & Balkon/Teras",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1112",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Gri 40x40",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1112",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8880919205720313.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8880919205720313.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Ticari Alanlar & Balkon/Teras",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1111",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Natural 60x60",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "67097",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7562386308853688.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7562386308853688.jpg"
    ],
    "size": "60x60",
    "color": "Natural",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Ticari Alanlar & Balkon/Teras & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Balkon Teras",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1110",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Gri 60x60",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "67099",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8734173302681045.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8734173302681045.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Ticari Alanlar & Balkon/Teras & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Balkon Teras",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1109",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Taupe 60x60",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1109",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.45237953830803646.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.45237953830803646.jpg"
    ],
    "size": "60x60",
    "color": "Taupe",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Ticari Alanlar & Balkon/Teras & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Balkon Teras",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1108",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Taupe 40x80",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1108",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21469387508257276.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21469387508257276.jpg"
    ],
    "size": "40x80",
    "color": "Taupe",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Ticari Alanlar & Balkon/Teras",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1107",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Natural 40x80",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1107",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8439588693103219.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8439588693103219.jpg"
    ],
    "size": "40x80",
    "color": "Natural",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Ticari Alanlar & Balkon/Teras",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1106",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Gri 40x80",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1106",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17546356673820318.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17546356673820318.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Ticari Alanlar & Balkon/Teras",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1105",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Natural 80x80",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1105",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9200942867197427.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9200942867197427.jpg"
    ],
    "size": "80x80",
    "color": "Natural",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Ticari Alanlar & Balkon/Teras",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1104",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Taupe 80x80",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1104",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8242743575342081.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8242743575342081.jpg"
    ],
    "size": "80x80",
    "color": "Taupe",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1103",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Gri 80x80",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1103",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4524225980949549.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4524225980949549.jpg"
    ],
    "size": "80x80",
    "color": "Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1102",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Natural 30x120",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1102",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8460577126720553.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8460577126720553.jpg"
    ],
    "size": "30x120",
    "color": "Natural",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1101",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Gri 30x120",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1101",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46929316223723705.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46929316223723705.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1100",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Taupe 30x120",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1100",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6146202923397345.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6146202923397345.jpg"
    ],
    "size": "30x120",
    "color": "Taupe",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1099",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Taupe 40x120",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1099",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8899731377449159.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8899731377449159.jpg"
    ],
    "size": "40x120",
    "color": "Taupe",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1098",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Natural 40x120",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1098",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8008707784865471.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8008707784865471.jpg"
    ],
    "size": "40x120",
    "color": "Natural",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1097",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Gri 40x120",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1097",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9009994075322492.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9009994075322492.jpg"
    ],
    "size": "40x120",
    "color": "Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1096",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Taupe 60x120",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1096",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18493101056404782.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18493101056404782.jpg"
    ],
    "size": "60x120",
    "color": "Taupe",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1095",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Natural 60x120",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1095",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12292679594419609.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12292679594419609.jpg"
    ],
    "size": "60x120",
    "color": "Natural",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1094",
    "brand": "Duratiles",
    "title": "BOTTİCİNO 20 MM Gri 60x120",
    "seriesName": "BOTTİCİNO 20 MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1094",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9418669579554032.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9418669579554032.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .</span>",
    "descriptionClean": "Modern tasarım anlayışını estetik ve konforla buluşturan Botticino Serisi, ses ve ısı izolasyonuna katkı sağlar .",
    "source": "duratiles"
  },
  {
    "id": "dura_1115",
    "brand": "Duratiles",
    "title": "BRUNO Perla 60x120",
    "seriesName": "BRUNO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1115",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.38779500256886146.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.38779500256886146.jpg"
    ],
    "size": "60x120",
    "color": "Perla",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Granit",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermere kazılan zarafeti, ayrıntılarında saklanan asaleti Bruno Serisi'nde keşfetmenin tam zamanı</span>",
    "descriptionClean": "Mermere kazılan zarafeti, ayrıntılarında saklanan asaleti Bruno Serisi'nde keşfetmenin tam zamanı",
    "source": "duratiles"
  },
  {
    "id": "dura_1116",
    "brand": "Duratiles",
    "title": "BURGAU Burgau 60x120",
    "seriesName": "BURGAU",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "10112",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.128089091131121.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.128089091131121.jpg"
    ],
    "size": "60x120",
    "color": "Burgau",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V1"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermere kazılan zarafeti, ayrıntılarında saklanan asaleti Bruno Serisi'nde keşfetmenin tam zamanı</span>",
    "descriptionClean": "Mermere kazılan zarafeti, ayrıntılarında saklanan asaleti Bruno Serisi'nde keşfetmenin tam zamanı",
    "source": "duratiles"
  },
  {
    "id": "dura_1117",
    "brand": "Duratiles",
    "title": "CALACAPOL Burgau 60x120",
    "seriesName": "CALACAPOL",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1117",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3057586297360404.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3057586297360404.jpg"
    ],
    "size": "60x120",
    "color": "Burgau",
    "surface": "Parlak, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Calacapol Porselen Karoları zamanın ötesinde bir tarz yakalamak isteyenlere hitap ediyor.</span>",
    "descriptionClean": "Calacapol Porselen Karoları zamanın ötesinde bir tarz yakalamak isteyenlere hitap ediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1118",
    "brand": "Duratiles",
    "title": "CALACATTA Dekofon 30x75",
    "seriesName": "CALACATTA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1118",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5728018824694673.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5728018824694673.jpg"
    ],
    "size": "30x75",
    "color": "Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo",
    "technology": "Dekofon",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.</span>",
    "descriptionClean": "Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1119",
    "brand": "Duratiles",
    "title": "CALACATTA Beyaz 30x75",
    "seriesName": "CALACATTA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1119",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15244657389699623.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15244657389699623.jpg"
    ],
    "size": "30x75",
    "color": "Beyaz",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo",
    "technology": "Duvar Karosu",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.</span>",
    "descriptionClean": "Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1120",
    "brand": "Duratiles",
    "title": "CALACATTA Beyaz Rölyef 30x75",
    "seriesName": "CALACATTA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1120",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1489032768274.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1489032768274.jpg"
    ],
    "size": "30x75",
    "color": "Beyaz Rölyef",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo",
    "technology": "Dekofon",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.</span>",
    "descriptionClean": "Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1121",
    "brand": "Duratiles",
    "title": "CALACATTA Beyaz 60x120",
    "seriesName": "CALACATTA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "67200",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1673035825594107.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1673035825594107.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.</span>",
    "descriptionClean": "Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1122",
    "brand": "Duratiles",
    "title": "CALACATTA Fraves Dekor 60x120",
    "seriesName": "CALACATTA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1122",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.31090465344751406.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.31090465344751406.jpg"
    ],
    "size": "60x120",
    "color": "Fraves Dekor",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.</span>",
    "descriptionClean": "Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1123",
    "brand": "Duratiles",
    "title": "CALACATTA Beyaz 80x80",
    "seriesName": "CALACATTA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1123",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.672322724652076.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.672322724652076.jpg"
    ],
    "size": "80x80",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.</span>",
    "descriptionClean": "Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1124",
    "brand": "Duratiles",
    "title": "CALACATTA Beyaz 60x60",
    "seriesName": "CALACATTA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1124",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43967959955229396.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43967959955229396.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.</span>",
    "descriptionClean": "Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1125",
    "brand": "Duratiles",
    "title": "CALACATTA Gri 60x60",
    "seriesName": "CALACATTA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1125",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2924163335134091.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2924163335134091.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.</span>",
    "descriptionClean": "Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1126",
    "brand": "Duratiles",
    "title": "CALACATTA Bej 60x60",
    "seriesName": "CALACATTA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1126",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.24024616036293678.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.24024616036293678.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.</span>",
    "descriptionClean": "Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1127",
    "brand": "Duratiles",
    "title": "CALACATTA Dekor 60x60",
    "seriesName": "CALACATTA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1127",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.01720910670136533.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.01720910670136533.jpg"
    ],
    "size": "60x60",
    "color": "Dekor",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.</span>",
    "descriptionClean": "Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1128",
    "brand": "Duratiles",
    "title": "CALACATTA Gri 45x45",
    "seriesName": "CALACATTA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1128",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.251719889041392.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.251719889041392.jpg"
    ],
    "size": "45x45",
    "color": "Gri",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.</span>",
    "descriptionClean": "Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1129",
    "brand": "Duratiles",
    "title": "CALACATTA Select 30x60",
    "seriesName": "CALACATTA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12203",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8682639125360028.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8682639125360028.jpg"
    ],
    "size": "30x60",
    "color": "Select",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V1",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.</span>",
    "descriptionClean": "Mermer görünümlü Calacatta serisi porselen karoları, mekanlara net ve sade bir görüntü getirirken dekor seçenekleri ile yaşam alanlarına canlılık katıp hareketlendiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1130",
    "brand": "Duratiles",
    "title": "CAPITOLINA Fildişi 60x120",
    "seriesName": "CAPITOLINA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1130",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7494586238578668.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7494586238578668.jpg"
    ],
    "size": "60x120",
    "color": "Fildişi",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Capitolina Porselen Karoları full lappato özelliği ile hiç solmayan ve asla eskimeyen bir görüntüyü garantiliyor.</span>",
    "descriptionClean": "Capitolina Porselen Karoları full lappato özelliği ile hiç solmayan ve asla eskimeyen bir görüntüyü garantiliyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1131",
    "brand": "Duratiles",
    "title": "CAPITOLINA Latte 60x120",
    "seriesName": "CAPITOLINA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "75788",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22570276216439766.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22570276216439766.jpg"
    ],
    "size": "60x120",
    "color": "Latte",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Capitolina Porselen Karoları full lappato özelliği ile hiç solmayan ve asla eskimeyen bir görüntüyü garantiliyor.</span>",
    "descriptionClean": "Capitolina Porselen Karoları full lappato özelliği ile hiç solmayan ve asla eskimeyen bir görüntüyü garantiliyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1132",
    "brand": "Duratiles",
    "title": "CAPITOLINA Taupe 60x120",
    "seriesName": "CAPITOLINA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "77305",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6952103636616559.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6952103636616559.jpg"
    ],
    "size": "60x120",
    "color": "Taupe",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Capitolina Porselen Karoları full lappato özelliği ile hiç solmayan ve asla eskimeyen bir görüntüyü garantiliyor.</span>",
    "descriptionClean": "Capitolina Porselen Karoları full lappato özelliği ile hiç solmayan ve asla eskimeyen bir görüntüyü garantiliyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1133",
    "brand": "Duratiles",
    "title": "CAPRI Altın 60x60",
    "seriesName": "CAPRI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "77305",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9998980575823713.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9998980575823713.jpg"
    ],
    "size": "60x60",
    "color": "Altın",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Capri Serisinin zamansız güzelliği ile mekanlarınıza ferah ve dingin bir soluk getirebilirsiniz</span>",
    "descriptionClean": "Capri Serisinin zamansız güzelliği ile mekanlarınıza ferah ve dingin bir soluk getirebilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_1134",
    "brand": "Duratiles",
    "title": "CARAMEL Multi 100x100",
    "seriesName": "CARAMEL",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1134",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0717844678684526.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0717844678684526.jpg"
    ],
    "size": "100x100",
    "color": "Multi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "V4",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İnce detayları özenle seramiğe işledik ve Caramel serisini tasarladık. Yenilenmenin verdiği hissi yaşam alanlarınıza taşıyın. Zamanın yıpratıcı etkilerine maruz kalmadan yaşam alanlarınızın güzelliğini her zaman koruyun.</span>",
    "descriptionClean": "İnce detayları özenle seramiğe işledik ve Caramel serisini tasarladık. Yenilenmenin verdiği hissi yaşam alanlarınıza taşıyın. Zamanın yıpratıcı etkilerine maruz kalmadan yaşam alanlarınızın güzelliğini her zaman koruyun.",
    "source": "duratiles"
  },
  {
    "id": "dura_1135",
    "brand": "Duratiles",
    "title": "CARRARA Beyaz 60x120",
    "seriesName": "CARRARA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "67202",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9899923507963372.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9899923507963372.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Göz alıcı detayların özenli yorumunu keşfedin. Carrara serisinde ince detayları özenle seramiğe işledik. Modern yaşamın tamamlayıcı detayları özünde saklı.</span>",
    "descriptionClean": "Göz alıcı detayların özenli yorumunu keşfedin. Carrara serisinde ince detayları özenle seramiğe işledik. Modern yaşamın tamamlayıcı detayları özünde saklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1136",
    "brand": "Duratiles",
    "title": "CARRARA Spectrum Dekor 60x120",
    "seriesName": "CARRARA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1136",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3775072245530926.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3775072245530926.jpg"
    ],
    "size": "60x120",
    "color": "Spectrum Dekor",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Göz alıcı detayların özenli yorumunu keşfedin. Carrara serisinde ince detayları özenle seramiğe işledik. Modern yaşamın tamamlayıcı detayları özünde saklı.</span>",
    "descriptionClean": "Göz alıcı detayların özenli yorumunu keşfedin. Carrara serisinde ince detayları özenle seramiğe işledik. Modern yaşamın tamamlayıcı detayları özünde saklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1137",
    "brand": "Duratiles",
    "title": "CARRARA Beyaz 60x60",
    "seriesName": "CARRARA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1137",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5678065856227545.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5678065856227545.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Göz alıcı detayların özenli yorumunu keşfedin. Carrara serisinde ince detayları özenle seramiğe işledik. Modern yaşamın tamamlayıcı detayları özünde saklı.</span>",
    "descriptionClean": "Göz alıcı detayların özenli yorumunu keşfedin. Carrara serisinde ince detayları özenle seramiğe işledik. Modern yaşamın tamamlayıcı detayları özünde saklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1138",
    "brand": "Duratiles",
    "title": "CARRARA Ahşap Dekor 60x60",
    "seriesName": "CARRARA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1138",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3632211345073346.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3632211345073346.jpg"
    ],
    "size": "60x60",
    "color": "Ahşap Dekor",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Göz alıcı detayların özenli yorumunu keşfedin. Carrara serisinde ince detayları özenle seramiğe işledik. Modern yaşamın tamamlayıcı detayları özünde saklı.</span>",
    "descriptionClean": "Göz alıcı detayların özenli yorumunu keşfedin. Carrara serisinde ince detayları özenle seramiğe işledik. Modern yaşamın tamamlayıcı detayları özünde saklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1141",
    "brand": "Duratiles",
    "title": "CLASSICO Notte 30x60",
    "seriesName": "CLASSICO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1141",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9014942627086446.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9014942627086446.jpg"
    ],
    "size": "30x60",
    "color": "Notte",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Klasik çizgilerden vazgeçmeyenlerin tercihi olan Classico Serisi çabasız şıklığı yalın tarzı ile yaşam alanlarınıza taşıyor</span>",
    "descriptionClean": "Klasik çizgilerden vazgeçmeyenlerin tercihi olan Classico Serisi çabasız şıklığı yalın tarzı ile yaşam alanlarınıza taşıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1140",
    "brand": "Duratiles",
    "title": "CLASSICO Villa 30x60",
    "seriesName": "CLASSICO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1140",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5582028036066391.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5582028036066391.jpg"
    ],
    "size": "30x60",
    "color": "Villa",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Klasik çizgilerden vazgeçmeyenlerin tercihi olan Classico Serisi çabasız şıklığı yalın tarzı ile yaşam alanlarınıza taşıyor</span>",
    "descriptionClean": "Klasik çizgilerden vazgeçmeyenlerin tercihi olan Classico Serisi çabasız şıklığı yalın tarzı ile yaşam alanlarınıza taşıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1139",
    "brand": "Duratiles",
    "title": "CLASSICO Blanco 30x60",
    "seriesName": "CLASSICO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1139",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5771634965665067.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5771634965665067.jpg"
    ],
    "size": "30x60",
    "color": "Blanco",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Klasik çizgilerden vazgeçmeyenlerin tercihi olan Classico Serisi çabasız şıklığı yalın tarzı ile yaşam alanlarınıza taşıyor</span>",
    "descriptionClean": "Klasik çizgilerden vazgeçmeyenlerin tercihi olan Classico Serisi çabasız şıklığı yalın tarzı ile yaşam alanlarınıza taşıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1142",
    "brand": "Duratiles",
    "title": "CORDIAL Cordial 60x120",
    "seriesName": "CORDIAL",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1142",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3068417490633847.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3068417490633847.jpg"
    ],
    "size": "60x120",
    "color": "Cordial",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Evinize estetik bir dokunuş katacak olan Cordial Serisi ile seramiğin doğallığı her mekânda sizinle. Tarzınızı tamamlayan detayların bütünü bu seride saklı.</span>",
    "descriptionClean": "Evinize estetik bir dokunuş katacak olan Cordial Serisi ile seramiğin doğallığı her mekânda sizinle. Tarzınızı tamamlayan detayların bütünü bu seride saklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1143",
    "brand": "Duratiles",
    "title": "COROLLA Fildişi 60x120",
    "seriesName": "COROLLA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1143",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8089075422899175.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8089075422899175.jpg"
    ],
    "size": "60x120",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Corolla, ince damar dokusuyla her mekâna sofistike bir zarafet katar.</span>",
    "descriptionClean": "Corolla, ince damar dokusuyla her mekâna sofistike bir zarafet katar.",
    "source": "duratiles"
  },
  {
    "id": "dura_1144",
    "brand": "Duratiles",
    "title": "CREMA Krem 60x60",
    "seriesName": "CREMA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1144",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1640001758234635.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1640001758234635.jpg"
    ],
    "size": "60x60",
    "color": "Krem",
    "surface": "Full Lappato, Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermerden alınan ilhamın en yumuşak renk ve dokusuyla seramikte hayat bulması Crema Serisinde gerçekleşti. Parlak yüzeyi ile mermer görünümünü pekiştiren seri 60x60cm ebadı ile hem duvarda hem yerde kullanabilme özgürlüğünü kullanıcılarına sunmakta.</span>",
    "descriptionClean": "Mermerden alınan ilhamın en yumuşak renk ve dokusuyla seramikte hayat bulması Crema Serisinde gerçekleşti. Parlak yüzeyi ile mermer görünümünü pekiştiren seri 60x60cm ebadı ile hem duvarda hem yerde kullanabilme özgürlüğünü kullanıcılarına sunmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1148",
    "brand": "Duratiles",
    "title": "DAHLIA Bej 30x60",
    "seriesName": "DAHLIA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1148",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7619004481700127.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7619004481700127.jpg"
    ],
    "size": "30x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo",
    "technology": "Duvar Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Banyo",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dahlia Porselen Karoları natürel doku ve renk yelpazesiyle mekanlarınıza karakteristik bir görünüm kazandırır.</span>",
    "descriptionClean": "Dahlia Porselen Karoları natürel doku ve renk yelpazesiyle mekanlarınıza karakteristik bir görünüm kazandırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1147",
    "brand": "Duratiles",
    "title": "DAHLIA Gri 30x60",
    "seriesName": "DAHLIA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1147",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7764013755260483.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7764013755260483.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo",
    "technology": "Duvar Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Banyo",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dahlia Porselen Karoları natürel doku ve renk yelpazesiyle mekanlarınıza karakteristik bir görünüm kazandırır.</span>",
    "descriptionClean": "Dahlia Porselen Karoları natürel doku ve renk yelpazesiyle mekanlarınıza karakteristik bir görünüm kazandırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1146",
    "brand": "Duratiles",
    "title": "DAHLIA Bej 45x45",
    "seriesName": "DAHLIA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1146",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20338409861558715.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20338409861558715.jpg"
    ],
    "size": "45x45",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dahlia Porselen Karoları natürel doku ve renk yelpazesiyle mekanlarınıza karakteristik bir görünüm kazandırır.</span>",
    "descriptionClean": "Dahlia Porselen Karoları natürel doku ve renk yelpazesiyle mekanlarınıza karakteristik bir görünüm kazandırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1145",
    "brand": "Duratiles",
    "title": "DAHLIA Gri 45x45",
    "seriesName": "DAHLIA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1145",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46463413082388605.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46463413082388605.jpg"
    ],
    "size": "45x45",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dahlia Porselen Karoları natürel doku ve renk yelpazesiyle mekanlarınıza karakteristik bir görünüm kazandırır.</span>",
    "descriptionClean": "Dahlia Porselen Karoları natürel doku ve renk yelpazesiyle mekanlarınıza karakteristik bir görünüm kazandırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1149",
    "brand": "Duratiles",
    "title": "DAKOTA ESPEJO Dakota Espejo 60x120",
    "seriesName": "DAKOTA ESPEJO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "79860",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6767483544366999.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6767483544366999.jpg"
    ],
    "size": "60x120",
    "color": "Dakota Espejo",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Balkon/Teras & Ev içi Zemin & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Çok geniş bir kullanım alanı olan Dakota Espejo cesur bir dekorasyon tarzını benimseyenlerin favorisi.</span>",
    "descriptionClean": "Çok geniş bir kullanım alanı olan Dakota Espejo cesur bir dekorasyon tarzını benimseyenlerin favorisi.",
    "source": "duratiles"
  },
  {
    "id": "dura_1150",
    "brand": "Duratiles",
    "title": "DHARA SUNLIGHT BOOKMATCH Sunlight 60x120",
    "seriesName": "DHARA SUNLIGHT BOOKMATCH",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "79860",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3894741943651585.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3894741943651585.jpg"
    ],
    "size": "60x120",
    "color": "Sunlight",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Balkon/Teras & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Çok geniş bir kullanım alanı olan Dakota Espejo cesur bir dekorasyon tarzını benimseyenlerin favorisi.</span>",
    "descriptionClean": "Çok geniş bir kullanım alanı olan Dakota Espejo cesur bir dekorasyon tarzını benimseyenlerin favorisi.",
    "source": "duratiles"
  },
  {
    "id": "dura_1151",
    "brand": "Duratiles",
    "title": "DOLCE Altın 60x120",
    "seriesName": "DOLCE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "67312",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1830867693298438.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1830867693298438.jpg"
    ],
    "size": "60x120",
    "color": "Altın",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Balkon/Teras & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Gösterişli mermer görünümünü göz alıcı iki renk ile çeşitlendiren Dolce Serisi zamansız yaşam alanları yaratırken farklı tarzlara özel tasarımlar ve işlevsel çözümler sunmakta.</span>",
    "descriptionClean": "Gösterişli mermer görünümünü göz alıcı iki renk ile çeşitlendiren Dolce Serisi zamansız yaşam alanları yaratırken farklı tarzlara özel tasarımlar ve işlevsel çözümler sunmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1152",
    "brand": "Duratiles",
    "title": "DOLCE Dolce 60x120",
    "seriesName": "DOLCE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1152",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3290001127303511.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3290001127303511.jpg"
    ],
    "size": "60x120",
    "color": "Dolce",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Gösterişli mermer görünümünü göz alıcı iki renk ile çeşitlendiren Dolce Serisi zamansız yaşam alanları yaratırken farklı tarzlara özel tasarımlar ve işlevsel çözümler sunmakta.</span>",
    "descriptionClean": "Gösterişli mermer görünümünü göz alıcı iki renk ile çeşitlendiren Dolce Serisi zamansız yaşam alanları yaratırken farklı tarzlara özel tasarımlar ve işlevsel çözümler sunmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1153",
    "brand": "Duratiles",
    "title": "DUDEN Bej 60x90",
    "seriesName": "DUDEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1153",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09299995153824137.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09299995153824137.jpg"
    ],
    "size": "60x90",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_1154",
    "brand": "Duratiles",
    "title": "DUDEN Bone 60x90",
    "seriesName": "DUDEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1154",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9656262994890472.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9656262994890472.jpg"
    ],
    "size": "60x90",
    "color": "Bone",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_1155",
    "brand": "Duratiles",
    "title": "DUDEN Bej 45x90",
    "seriesName": "DUDEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1155",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8676448161133512.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8676448161133512.jpg"
    ],
    "size": "45x90",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_1156",
    "brand": "Duratiles",
    "title": "DUDEN Bone 45x90",
    "seriesName": "DUDEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1156",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4397005260663279.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4397005260663279.jpg"
    ],
    "size": "45x90",
    "color": "Bone",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_1157",
    "brand": "Duratiles",
    "title": "DUDEN Bej 60x120",
    "seriesName": "DUDEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1157",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5559377823308994.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5559377823308994.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_1158",
    "brand": "Duratiles",
    "title": "DUDEN Bone 60x120",
    "seriesName": "DUDEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1158",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30589398022613645.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30589398022613645.jpg"
    ],
    "size": "60x120",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_1159",
    "brand": "Duratiles",
    "title": "DUDEN Bej 40x120",
    "seriesName": "DUDEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1159",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.26687127552426804.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.26687127552426804.jpg"
    ],
    "size": "40x120",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_1160",
    "brand": "Duratiles",
    "title": "DUDEN Bone 40x120",
    "seriesName": "DUDEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1160",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3503440580462479.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3503440580462479.jpg"
    ],
    "size": "40x120",
    "color": "Bone",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_1161",
    "brand": "Duratiles",
    "title": "DUDEN Bej 30x120",
    "seriesName": "DUDEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1161",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20374614357772425.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20374614357772425.jpg"
    ],
    "size": "30x120",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_1162",
    "brand": "Duratiles",
    "title": "DUDEN Bone 30x120",
    "seriesName": "DUDEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1162",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4576672430576427.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4576672430576427.jpg"
    ],
    "size": "30x120",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_1163",
    "brand": "Duratiles",
    "title": "DUDEN Bej 80x80",
    "seriesName": "DUDEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1163",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48620906354524496.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48620906354524496.jpg"
    ],
    "size": "80x80",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_1164",
    "brand": "Duratiles",
    "title": "DUDEN Bone 80x80",
    "seriesName": "DUDEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1164",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23626520725241973.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23626520725241973.jpg"
    ],
    "size": "80x80",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_1165",
    "brand": "Duratiles",
    "title": "DUDEN Bej 40x80",
    "seriesName": "DUDEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1165",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14894442545990794.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14894442545990794.jpg"
    ],
    "size": "40x80",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_1166",
    "brand": "Duratiles",
    "title": "DUDEN Bone 40x80",
    "seriesName": "DUDEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1166",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1702137225255873.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1702137225255873.jpg"
    ],
    "size": "40x80",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_1167",
    "brand": "Duratiles",
    "title": "DUDEN Bej 60x60",
    "seriesName": "DUDEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1167",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1702667652362222.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1702667652362222.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_1168",
    "brand": "Duratiles",
    "title": "DUDEN Bone 60x60",
    "seriesName": "DUDEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1168",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6403895187925981.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6403895187925981.jpg"
    ],
    "size": "60x60",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_1169",
    "brand": "Duratiles",
    "title": "DUDEN Bej 40x40",
    "seriesName": "DUDEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1169",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6992906608556481.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6992906608556481.jpg"
    ],
    "size": "40x40",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_1170",
    "brand": "Duratiles",
    "title": "DUDEN Bone 40x40",
    "seriesName": "DUDEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1170",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21913446901656075.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21913446901656075.jpg"
    ],
    "size": "40x40",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.</span>",
    "descriptionClean": "Modern tasarım dilini yaşam alanlarınıza taşıyan Duden Serisi küf,yosun ve böcek ilaçlarına karşı dayanıklıdır diğer kaplama malzemelerine göre çok daha hijyeniktir. Üstelik bu özellik sayısız kullanım kolaylıklarından sadece biri.",
    "source": "duratiles"
  },
  {
    "id": "dura_1171",
    "brand": "Duratiles",
    "title": "EARTHSTONE Natural 60x60",
    "seriesName": "EARTHSTONE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1171",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9075449085004091.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9075449085004091.jpg"
    ],
    "size": "60x60",
    "color": "Natural",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğadan ilham alan doğal dokusuyla mekânlara dinginlik ve denge katıyor. Zarif mat yüzeyiyle sade ama güçlü bir atmosfer yaratırken, mermerin zamansız etkisini modern yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Doğadan ilham alan doğal dokusuyla mekânlara dinginlik ve denge katıyor. Zarif mat yüzeyiyle sade ama güçlü bir atmosfer yaratırken, mermerin zamansız etkisini modern yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1172",
    "brand": "Duratiles",
    "title": "EMPEDAS Koyu 60x120",
    "seriesName": "EMPEDAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1172",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4606800797634677.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4606800797634677.jpg"
    ],
    "size": "60x120",
    "color": "Koyu",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Empedas Porselen Karoları bulunduğu alanda stil sahibi bir tasarım anlayışının altını çiziyor</span>",
    "descriptionClean": "Empedas Porselen Karoları bulunduğu alanda stil sahibi bir tasarım anlayışının altını çiziyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1173",
    "brand": "Duratiles",
    "title": "EMPIRE Beyaz 30x60",
    "seriesName": "EMPIRE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12207",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.708197057357248.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.708197057357248.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Empire Serisi ile evinize benzersiz bir hava katarken yaşam alanınıza yepyeni çağdaş bir görünüm kazandırabilirsiniz.</span>",
    "descriptionClean": "Empire Serisi ile evinize benzersiz bir hava katarken yaşam alanınıza yepyeni çağdaş bir görünüm kazandırabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1174",
    "brand": "Duratiles",
    "title": "EMPIRE Fildişi 30x60",
    "seriesName": "EMPIRE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12206",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6637679712081145.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6637679712081145.jpg"
    ],
    "size": "30x60",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Empire Serisi ile evinize benzersiz bir hava katarken yaşam alanınıza yepyeni çağdaş bir görünüm kazandırabilirsiniz.</span>",
    "descriptionClean": "Empire Serisi ile evinize benzersiz bir hava katarken yaşam alanınıza yepyeni çağdaş bir görünüm kazandırabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1175",
    "brand": "Duratiles",
    "title": "EMPIRE Gri 30x60",
    "seriesName": "EMPIRE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12205",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8830177777811637.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8830177777811637.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Empire Serisi ile evinize benzersiz bir hava katarken yaşam alanınıza yepyeni çağdaş bir görünüm kazandırabilirsiniz.</span>",
    "descriptionClean": "Empire Serisi ile evinize benzersiz bir hava katarken yaşam alanınıza yepyeni çağdaş bir görünüm kazandırabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1176",
    "brand": "Duratiles",
    "title": "EMPIRE Antrasit 30x60",
    "seriesName": "EMPIRE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12204",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36093200348829213.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36093200348829213.jpg"
    ],
    "size": "30x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Empire Serisi ile evinize benzersiz bir hava katarken yaşam alanınıza yepyeni çağdaş bir görünüm kazandırabilirsiniz.</span>",
    "descriptionClean": "Empire Serisi ile evinize benzersiz bir hava katarken yaşam alanınıza yepyeni çağdaş bir görünüm kazandırabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1177",
    "brand": "Duratiles",
    "title": "EMPRADOR Bone 60x60",
    "seriesName": "EMPRADOR",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1177",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17936816823148638.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17936816823148638.jpg"
    ],
    "size": "60x60",
    "color": "Bone",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Seramikten gelen güzelliği hayatınıza dâhil edin. Yaşam alanlarınız özel bir dokunuşla daha da güzelleşsin.</span>",
    "descriptionClean": "Seramikten gelen güzelliği hayatınıza dâhil edin. Yaşam alanlarınız özel bir dokunuşla daha da güzelleşsin.",
    "source": "duratiles"
  },
  {
    "id": "dura_1178",
    "brand": "Duratiles",
    "title": "EMPRADOR Kahve 60x60",
    "seriesName": "EMPRADOR",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1178",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7282260238216974.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7282260238216974.jpg"
    ],
    "size": "60x60",
    "color": "Kahve",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Seramikten gelen güzelliği hayatınıza dâhil edin. Yaşam alanlarınız özel bir dokunuşla daha da güzelleşsin.</span>",
    "descriptionClean": "Seramikten gelen güzelliği hayatınıza dâhil edin. Yaşam alanlarınız özel bir dokunuşla daha da güzelleşsin.",
    "source": "duratiles"
  },
  {
    "id": "dura_1179",
    "brand": "Duratiles",
    "title": "EMPRADOR EMPEDAS Koyu 60x120",
    "seriesName": "EMPRADOR EMPEDAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1179",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.535741689523764.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.535741689523764.jpg"
    ],
    "size": "60x120",
    "color": "Koyu",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermerin göz alıcı görünümünü parlak yüzeyi ile daha da ön plana çıkaran Emprador Empedas Serisinin kahve ve antrasit renk alternatifleriyle çekici, davetkar mekanlar yaratmanız çok kolay.</span>",
    "descriptionClean": "Mermerin göz alıcı görünümünü parlak yüzeyi ile daha da ön plana çıkaran Emprador Empedas Serisinin kahve ve antrasit renk alternatifleriyle çekici, davetkar mekanlar yaratmanız çok kolay.",
    "source": "duratiles"
  },
  {
    "id": "dura_1180",
    "brand": "Duratiles",
    "title": "EMPRADOR MARMI Bej 60x120",
    "seriesName": "EMPRADOR MARMI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1180",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.290859302596304.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.290859302596304.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Emprador Marmi Porselen Karoları , iddialı tasarımları ile göz alıcı mekanlar yaratmanıza olanak sağlıyor.</span>",
    "descriptionClean": "Emprador Marmi Porselen Karoları , iddialı tasarımları ile göz alıcı mekanlar yaratmanıza olanak sağlıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1181",
    "brand": "Duratiles",
    "title": "EMPRADOR MARMI Bone 60x120",
    "seriesName": "EMPRADOR MARMI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1181",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40209534080210674.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40209534080210674.jpg"
    ],
    "size": "60x120",
    "color": "Bone",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Emprador Marmi Porselen Karoları , iddialı tasarımları ile göz alıcı mekanlar yaratmanıza olanak sağlıyor.</span>",
    "descriptionClean": "Emprador Marmi Porselen Karoları , iddialı tasarımları ile göz alıcı mekanlar yaratmanıza olanak sağlıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1182",
    "brand": "Duratiles",
    "title": "EMPRADOR MARMI Koyu 60x120",
    "seriesName": "EMPRADOR MARMI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "77441",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8323482245007953.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8323482245007953.jpg"
    ],
    "size": "60x120",
    "color": "Koyu",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Emprador Marmi Porselen Karoları , iddialı tasarımları ile göz alıcı mekanlar yaratmanıza olanak sağlıyor.</span>",
    "descriptionClean": "Emprador Marmi Porselen Karoları , iddialı tasarımları ile göz alıcı mekanlar yaratmanıza olanak sağlıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1183",
    "brand": "Duratiles",
    "title": "EMPRADOR MARMI Gri 60x120",
    "seriesName": "EMPRADOR MARMI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "77447",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7153890155470344.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7153890155470344.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Emprador Marmi Porselen Karoları , iddialı tasarımları ile göz alıcı mekanlar yaratmanıza olanak sağlıyor.</span>",
    "descriptionClean": "Emprador Marmi Porselen Karoları , iddialı tasarımları ile göz alıcı mekanlar yaratmanıza olanak sağlıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1184",
    "brand": "Duratiles",
    "title": "EMPRADOR PIONEER Beyaz 60x120",
    "seriesName": "EMPRADOR PIONEER",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1184",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8920254006170792.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8920254006170792.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Emprador Pioneer Porselen Karoları hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltir .</span>",
    "descriptionClean": "Emprador Pioneer Porselen Karoları hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1185",
    "brand": "Duratiles",
    "title": "EMPRADOR PIONEER Gri 60x120",
    "seriesName": "EMPRADOR PIONEER",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1185",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8293497609535294.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8293497609535294.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Emprador Pioneer Porselen Karoları hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltir .</span>",
    "descriptionClean": "Emprador Pioneer Porselen Karoları hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1186",
    "brand": "Duratiles",
    "title": "EMPRADOR PIONEER Wenge 60x120",
    "seriesName": "EMPRADOR PIONEER",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "77450",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.005764821421726185.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.005764821421726185.jpg"
    ],
    "size": "60x120",
    "color": "Wenge",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Emprador Pioneer Porselen Karoları hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltir .</span>",
    "descriptionClean": "Emprador Pioneer Porselen Karoları hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1187",
    "brand": "Duratiles",
    "title": "EMPRADOR PIONEER Siyah 60x120",
    "seriesName": "EMPRADOR PIONEER",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1187",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3469579663334095.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3469579663334095.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Emprador Pioneer Porselen Karoları hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltir .</span>",
    "descriptionClean": "Emprador Pioneer Porselen Karoları hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1188",
    "brand": "Duratiles",
    "title": "EMPRADOR SHAE Açık 60x120",
    "seriesName": "EMPRADOR SHAE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1188",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23167412117825215.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23167412117825215.jpg"
    ],
    "size": "60x120",
    "color": "Açık",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Emprador Shae Porselen Karoları ilham veren ,sıradanlığa meydan okuyan mekanlar yaratır.</span>",
    "descriptionClean": "Emprador Shae Porselen Karoları ilham veren ,sıradanlığa meydan okuyan mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1189",
    "brand": "Duratiles",
    "title": "EMPRADOR SHAE Koyu 60x120",
    "seriesName": "EMPRADOR SHAE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "77454",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4279164866199958.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4279164866199958.jpg"
    ],
    "size": "60x120",
    "color": "Koyu",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Emprador Shae Porselen Karoları ilham veren ,sıradanlığa meydan okuyan mekanlar yaratır.</span>",
    "descriptionClean": "Emprador Shae Porselen Karoları ilham veren ,sıradanlığa meydan okuyan mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1190",
    "brand": "Duratiles",
    "title": "EMPRADOR SHAE Kahverengi 60x120",
    "seriesName": "EMPRADOR SHAE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1190",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6790230568212753.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6790230568212753.jpg"
    ],
    "size": "60x120",
    "color": "Kahverengi",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Emprador Shae Porselen Karoları ilham veren ,sıradanlığa meydan okuyan mekanlar yaratır.</span>",
    "descriptionClean": "Emprador Shae Porselen Karoları ilham veren ,sıradanlığa meydan okuyan mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1227",
    "brand": "Duratiles",
    "title": "ERA Antrasit 45x90",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1227",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.031298829551148155.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.031298829551148155.jpg"
    ],
    "size": "45x90",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Havuz & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1228",
    "brand": "Duratiles",
    "title": "ERA Gri 45x90",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1228",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9225498513197228.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9225498513197228.jpg"
    ],
    "size": "45x90",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Havuz & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1229",
    "brand": "Duratiles",
    "title": "ERA Beyaz 45x90",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1229",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8359836707753251.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8359836707753251.jpg"
    ],
    "size": "45x90",
    "color": "Beyaz",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1230",
    "brand": "Duratiles",
    "title": "ERA Camel 45x90",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1230",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7094542457233111.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7094542457233111.jpg"
    ],
    "size": "45x90",
    "color": "Camel",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Havuz & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1231",
    "brand": "Duratiles",
    "title": "ERA Sand 45x90",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1231",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6632823128734495.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6632823128734495.jpg"
    ],
    "size": "45x90",
    "color": "Sand",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Havuz & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1232",
    "brand": "Duratiles",
    "title": "ERA Antrasit 60x90",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1232",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6669887937516197.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6669887937516197.jpg"
    ],
    "size": "60x90",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Havuz & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1233",
    "brand": "Duratiles",
    "title": "ERA Beyaz 60x90",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1233",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.29995266590921743.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.29995266590921743.jpg"
    ],
    "size": "60x90",
    "color": "Beyaz",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Havuz & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1234",
    "brand": "Duratiles",
    "title": "ERA Camel 60x90",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1234",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8068566550633739.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8068566550633739.jpg"
    ],
    "size": "60x90",
    "color": "Camel",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Havuz & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1235",
    "brand": "Duratiles",
    "title": "ERA Gri 60x90",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1235",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8489792771023262.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8489792771023262.jpg"
    ],
    "size": "60x90",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Havuz & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1236",
    "brand": "Duratiles",
    "title": "ERA Sand 60x90",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1236",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5827024592789061.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5827024592789061.jpg"
    ],
    "size": "60x90",
    "color": "Sand",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Havuz & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1237",
    "brand": "Duratiles",
    "title": "ERA Beyaz 60x120",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1237",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9920386902728124.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9920386902728124.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1238",
    "brand": "Duratiles",
    "title": "ERA Antrasit 60x120",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1238",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.04672663061445048.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.04672663061445048.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1239",
    "brand": "Duratiles",
    "title": "ERA Camel 60x120",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1239",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13715384393527363.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13715384393527363.jpg"
    ],
    "size": "60x120",
    "color": "Camel",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1240",
    "brand": "Duratiles",
    "title": "ERA Gri 60x120",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1240",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36233835861075625.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36233835861075625.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1241",
    "brand": "Duratiles",
    "title": "ERA Sand 60x120",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1241",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3353960709683642.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3353960709683642.jpg"
    ],
    "size": "60x120",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1242",
    "brand": "Duratiles",
    "title": "ERA Beyaz 40x120",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1242",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10831476125929385.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10831476125929385.jpg"
    ],
    "size": "40x120",
    "color": "Beyaz",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1243",
    "brand": "Duratiles",
    "title": "ERA Antrasit 40x120",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1243",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5669874427426622.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5669874427426622.jpg"
    ],
    "size": "40x120",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1244",
    "brand": "Duratiles",
    "title": "ERA Camel 40x120",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1244",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2718079932672143.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2718079932672143.jpg"
    ],
    "size": "40x120",
    "color": "Camel",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1245",
    "brand": "Duratiles",
    "title": "ERA Gri 40x120",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1245",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6722708310312064.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6722708310312064.jpg"
    ],
    "size": "40x120",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1246",
    "brand": "Duratiles",
    "title": "ERA Sand 40x120",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1246",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7220045706962696.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7220045706962696.jpg"
    ],
    "size": "40x120",
    "color": "Sand",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1247",
    "brand": "Duratiles",
    "title": "ERA Beyaz 30x120",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1247",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6412065852976914.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6412065852976914.jpg"
    ],
    "size": "30x120",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1248",
    "brand": "Duratiles",
    "title": "ERA Antrasit 30x120",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1248",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17943050764087287.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17943050764087287.jpg"
    ],
    "size": "30x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1249",
    "brand": "Duratiles",
    "title": "ERA Camel 30x120",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1249",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5887468469605608.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5887468469605608.jpg"
    ],
    "size": "30x120",
    "color": "Camel",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1250",
    "brand": "Duratiles",
    "title": "ERA Gri 30x120",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1250",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6320884295695776.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6320884295695776.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1251",
    "brand": "Duratiles",
    "title": "ERA Sand 30x120",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1251",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7615778397853988.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7615778397853988.jpg"
    ],
    "size": "30x120",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1252",
    "brand": "Duratiles",
    "title": "ERA Beyaz 80x80",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1252",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5540895382849949.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5540895382849949.jpg"
    ],
    "size": "80x80",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1253",
    "brand": "Duratiles",
    "title": "ERA Antrasit 80x80",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1253",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.32982124167211924.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.32982124167211924.jpg"
    ],
    "size": "80x80",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1254",
    "brand": "Duratiles",
    "title": "ERA Camel 80x80",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1254",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2585156688466843.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2585156688466843.jpg"
    ],
    "size": "80x80",
    "color": "Camel",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1255",
    "brand": "Duratiles",
    "title": "ERA Gri 80x80",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1255",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7292351335892377.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7292351335892377.jpg"
    ],
    "size": "80x80",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1256",
    "brand": "Duratiles",
    "title": "ERA Sand 80x80",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1256",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17334590334425326.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17334590334425326.jpg"
    ],
    "size": "80x80",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1257",
    "brand": "Duratiles",
    "title": "ERA Beyaz 40x80",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1257",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9488541354204708.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9488541354204708.jpg"
    ],
    "size": "40x80",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1258",
    "brand": "Duratiles",
    "title": "ERA Antrasit 40x80",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1258",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15494048275694117.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15494048275694117.jpg"
    ],
    "size": "40x80",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1259",
    "brand": "Duratiles",
    "title": "ERA Camel 40x80",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1259",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6978221596042723.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6978221596042723.jpg"
    ],
    "size": "40x80",
    "color": "Camel",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1260",
    "brand": "Duratiles",
    "title": "ERA Gri 40x80",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1260",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2646553563818791.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2646553563818791.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1261",
    "brand": "Duratiles",
    "title": "ERA Sand 40x80",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1261",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.455300155057505.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.455300155057505.jpg"
    ],
    "size": "40x80",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1262",
    "brand": "Duratiles",
    "title": "ERA Beyaz 60x60",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1262",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6826464652823004.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6826464652823004.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1263",
    "brand": "Duratiles",
    "title": "ERA Antrasit 60x60",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1263",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9607664568971004.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9607664568971004.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1264",
    "brand": "Duratiles",
    "title": "ERA Camel 60x60",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1264",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5935697316911281.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5935697316911281.jpg"
    ],
    "size": "60x60",
    "color": "Camel",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1265",
    "brand": "Duratiles",
    "title": "ERA Gri 60x60",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1265",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6042907203993697.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6042907203993697.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1266",
    "brand": "Duratiles",
    "title": "ERA Sand 60x60",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1266",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.26443461280563296.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.26443461280563296.jpg"
    ],
    "size": "60x60",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1267",
    "brand": "Duratiles",
    "title": "ERA Beyaz 40x40",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1267",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8989502485542396.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8989502485542396.jpg"
    ],
    "size": "40x40",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1268",
    "brand": "Duratiles",
    "title": "ERA Antrasit 40x40",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1268",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7109277324914856.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7109277324914856.jpg"
    ],
    "size": "40x40",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1269",
    "brand": "Duratiles",
    "title": "ERA Camel 40x40",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1269",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08311906764291921.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08311906764291921.jpg"
    ],
    "size": "40x40",
    "color": "Camel",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1270",
    "brand": "Duratiles",
    "title": "ERA Gri 40x40",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1270",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43898198793130894.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43898198793130894.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1271",
    "brand": "Duratiles",
    "title": "ERA Sand 40x40",
    "seriesName": "ERA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1271",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10112482158950331.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10112482158950331.jpg"
    ],
    "size": "40x40",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span>",
    "descriptionClean": "Beş farklı renk seçeneği ile dilediğiniz alanı zamansız yaşam alanlarına dönüştüren Era Serisini uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir, tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1272",
    "brand": "Duratiles",
    "title": "ETIENNE Gri 80x80",
    "seriesName": "ETIENNE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1272",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3866079743057489.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3866079743057489.jpg"
    ],
    "size": "80x80",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Rengini doğadan alan, desenleriyle ortama yumuşak ve doğal bir görünüm kazandıran Etienne serisi porselen karoları mekânlara ihtişamlı bir hava katıyor.</span>",
    "descriptionClean": "Rengini doğadan alan, desenleriyle ortama yumuşak ve doğal bir görünüm kazandıran Etienne serisi porselen karoları mekânlara ihtişamlı bir hava katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1273",
    "brand": "Duratiles",
    "title": "ETIENNE Kahve 80x80",
    "seriesName": "ETIENNE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1273",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28882589135112124.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28882589135112124.jpg"
    ],
    "size": "80x80",
    "color": "Kahve",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Rengini doğadan alan, desenleriyle ortama yumuşak ve doğal bir görünüm kazandıran Etienne serisi porselen karoları mekânlara ihtişamlı bir hava katıyor.</span>",
    "descriptionClean": "Rengini doğadan alan, desenleriyle ortama yumuşak ve doğal bir görünüm kazandıran Etienne serisi porselen karoları mekânlara ihtişamlı bir hava katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1274",
    "brand": "Duratiles",
    "title": "ETIENNE Gri 60x60",
    "seriesName": "ETIENNE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1274",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8316966294710773.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8316966294710773.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Rengini doğadan alan, desenleriyle ortama yumuşak ve doğal bir görünüm kazandıran Etienne serisi porselen karoları mekânlara ihtişamlı bir hava katıyor.</span>",
    "descriptionClean": "Rengini doğadan alan, desenleriyle ortama yumuşak ve doğal bir görünüm kazandıran Etienne serisi porselen karoları mekânlara ihtişamlı bir hava katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1275",
    "brand": "Duratiles",
    "title": "ETIENNE Kahve 60x60",
    "seriesName": "ETIENNE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1275",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18939276663543758.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18939276663543758.jpg"
    ],
    "size": "60x60",
    "color": "Kahve",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Rengini doğadan alan, desenleriyle ortama yumuşak ve doğal bir görünüm kazandıran Etienne serisi porselen karoları mekânlara ihtişamlı bir hava katıyor.</span>",
    "descriptionClean": "Rengini doğadan alan, desenleriyle ortama yumuşak ve doğal bir görünüm kazandıran Etienne serisi porselen karoları mekânlara ihtişamlı bir hava katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1276",
    "brand": "Duratiles",
    "title": "EVEREST Bej 60x120",
    "seriesName": "EVEREST",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "73408",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10572979338943078.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10572979338943078.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Everest Serisi yaşam alanlarına kolayca uyum sağlayabilen fonksiyonelliği ve dinamik renkleri ile konforundan taviz vermeyenlerin yeni gözdesi</span>",
    "descriptionClean": "Everest Serisi yaşam alanlarına kolayca uyum sağlayabilen fonksiyonelliği ve dinamik renkleri ile konforundan taviz vermeyenlerin yeni gözdesi",
    "source": "duratiles"
  },
  {
    "id": "dura_1277",
    "brand": "Duratiles",
    "title": "EVEREST Gri 60x120",
    "seriesName": "EVEREST",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "73347",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16154942815472284.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16154942815472284.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Everest Serisi yaşam alanlarına kolayca uyum sağlayabilen fonksiyonelliği ve dinamik renkleri ile konforundan taviz vermeyenlerin yeni gözdesi</span>",
    "descriptionClean": "Everest Serisi yaşam alanlarına kolayca uyum sağlayabilen fonksiyonelliği ve dinamik renkleri ile konforundan taviz vermeyenlerin yeni gözdesi",
    "source": "duratiles"
  },
  {
    "id": "dura_1278",
    "brand": "Duratiles",
    "title": "EVEREST Antrasit 60x120",
    "seriesName": "EVEREST",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1278",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4820663077461912.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4820663077461912.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Everest Serisi yaşam alanlarına kolayca uyum sağlayabilen fonksiyonelliği ve dinamik renkleri ile konforundan taviz vermeyenlerin yeni gözdesi</span>",
    "descriptionClean": "Everest Serisi yaşam alanlarına kolayca uyum sağlayabilen fonksiyonelliği ve dinamik renkleri ile konforundan taviz vermeyenlerin yeni gözdesi",
    "source": "duratiles"
  },
  {
    "id": "dura_1279",
    "brand": "Duratiles",
    "title": "EVEREST Mocha 60x120",
    "seriesName": "EVEREST",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1279",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.26079405142934364.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.26079405142934364.jpg"
    ],
    "size": "60x120",
    "color": "Mocha",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Everest Serisi yaşam alanlarına kolayca uyum sağlayabilen fonksiyonelliği ve dinamik renkleri ile konforundan taviz vermeyenlerin yeni gözdesi</span>",
    "descriptionClean": "Everest Serisi yaşam alanlarına kolayca uyum sağlayabilen fonksiyonelliği ve dinamik renkleri ile konforundan taviz vermeyenlerin yeni gözdesi",
    "source": "duratiles"
  },
  {
    "id": "dura_1280",
    "brand": "Duratiles",
    "title": "FABULA Yeşil 60x120",
    "seriesName": "FABULA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1280",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43938377956644736.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43938377956644736.jpg"
    ],
    "size": "60x120",
    "color": "Yeşil",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Mekanlara farklı bir soluk ve dinamizm getiren Fabula Porselen Karoları etkileyici yaşam alanları tasarlar.</span>",
    "descriptionClean": "Mekanlara farklı bir soluk ve dinamizm getiren Fabula Porselen Karoları etkileyici yaşam alanları tasarlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_1281",
    "brand": "Duratiles",
    "title": "FABULA Latte 60x120",
    "seriesName": "FABULA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1281",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6968396310041878.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6968396310041878.jpg"
    ],
    "size": "60x120",
    "color": "Latte",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Mekanlara farklı bir soluk ve dinamizm getiren Fabula Porselen Karoları etkileyici yaşam alanları tasarlar.</span>",
    "descriptionClean": "Mekanlara farklı bir soluk ve dinamizm getiren Fabula Porselen Karoları etkileyici yaşam alanları tasarlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_1282",
    "brand": "Duratiles",
    "title": "FABULA Koyu Kahve 60x120",
    "seriesName": "FABULA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1282",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8823020624723551.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8823020624723551.jpg"
    ],
    "size": "60x120",
    "color": "Koyu Kahve",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Mekanlara farklı bir soluk ve dinamizm getiren Fabula Porselen Karoları etkileyici yaşam alanları tasarlar.</span>",
    "descriptionClean": "Mekanlara farklı bir soluk ve dinamizm getiren Fabula Porselen Karoları etkileyici yaşam alanları tasarlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_1283",
    "brand": "Duratiles",
    "title": "FABULA Kahve 60x120",
    "seriesName": "FABULA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1283",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6499345255300233.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6499345255300233.jpg"
    ],
    "size": "60x120",
    "color": "Kahve",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Mekanlara farklı bir soluk ve dinamizm getiren Fabula Porselen Karoları etkileyici yaşam alanları tasarlar.</span>",
    "descriptionClean": "Mekanlara farklı bir soluk ve dinamizm getiren Fabula Porselen Karoları etkileyici yaşam alanları tasarlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_1031",
    "brand": "Duratiles",
    "title": "FIRAT Beyaz 45x45",
    "seriesName": "FIRAT",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1031",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9293495943931335.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9293495943931335.jpg"
    ],
    "size": "45x45",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Dış Cephe & Endüstriyel Zemin",
    "technology": "Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Fırat Serisi hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor</span>",
    "descriptionClean": "Fırat Serisi hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1030",
    "brand": "Duratiles",
    "title": "FIRAT Gri 45x45",
    "seriesName": "FIRAT",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1030",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09969115661305172.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09969115661305172.jpg"
    ],
    "size": "45x45",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Dış Cephe & Endüstriyel Zemin",
    "technology": "Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Dış Cephe",
      "V2",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Fırat Serisi hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor</span>",
    "descriptionClean": "Fırat Serisi hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1284",
    "brand": "Duratiles",
    "title": "GALAXY Gri 60x120",
    "seriesName": "GALAXY",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1284",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30580492217870425.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30580492217870425.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlhamını gökyüzünün sonsuz derinliğinden alan Galaxy serisi yıldızların ışıltısını size getiriyor. Renk ve ebat seçeneğine ürün yelpazesine eklediği dekor ile dinamizm katan seri, şıklığı ile göz dolduruyor</span>",
    "descriptionClean": "İlhamını gökyüzünün sonsuz derinliğinden alan Galaxy serisi yıldızların ışıltısını size getiriyor. Renk ve ebat seçeneğine ürün yelpazesine eklediği dekor ile dinamizm katan seri, şıklığı ile göz dolduruyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1285",
    "brand": "Duratiles",
    "title": "GALAXY Siyah 60x120",
    "seriesName": "GALAXY",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1285",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4158267163634135.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4158267163634135.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlhamını gökyüzünün sonsuz derinliğinden alan Galaxy serisi yıldızların ışıltısını size getiriyor. Renk ve ebat seçeneğine ürün yelpazesine eklediği dekor ile dinamizm katan seri, şıklığı ile göz dolduruyor</span>",
    "descriptionClean": "İlhamını gökyüzünün sonsuz derinliğinden alan Galaxy serisi yıldızların ışıltısını size getiriyor. Renk ve ebat seçeneğine ürün yelpazesine eklediği dekor ile dinamizm katan seri, şıklığı ile göz dolduruyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1286",
    "brand": "Duratiles",
    "title": "GALAXY Gri 60x60",
    "seriesName": "GALAXY",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1286",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3314334679787797.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3314334679787797.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlhamını gökyüzünün sonsuz derinliğinden alan Galaxy serisi yıldızların ışıltısını size getiriyor. Renk ve ebat seçeneğine ürün yelpazesine eklediği dekor ile dinamizm katan seri, şıklığı ile göz dolduruyor</span>",
    "descriptionClean": "İlhamını gökyüzünün sonsuz derinliğinden alan Galaxy serisi yıldızların ışıltısını size getiriyor. Renk ve ebat seçeneğine ürün yelpazesine eklediği dekor ile dinamizm katan seri, şıklığı ile göz dolduruyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1287",
    "brand": "Duratiles",
    "title": "GALAXY Siyah 60x60",
    "seriesName": "GALAXY",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1287",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.433045543947185.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.433045543947185.jpg"
    ],
    "size": "60x60",
    "color": "Siyah",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlhamını gökyüzünün sonsuz derinliğinden alan Galaxy serisi yıldızların ışıltısını size getiriyor. Renk ve ebat seçeneğine ürün yelpazesine eklediği dekor ile dinamizm katan seri, şıklığı ile göz dolduruyor</span>",
    "descriptionClean": "İlhamını gökyüzünün sonsuz derinliğinden alan Galaxy serisi yıldızların ışıltısını size getiriyor. Renk ve ebat seçeneğine ürün yelpazesine eklediği dekor ile dinamizm katan seri, şıklığı ile göz dolduruyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1288",
    "brand": "Duratiles",
    "title": "GALAXY Dekor 60x60",
    "seriesName": "GALAXY",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1288",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7971142484083252.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7971142484083252.jpg"
    ],
    "size": "60x60",
    "color": "Dekor",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlhamını gökyüzünün sonsuz derinliğinden alan Galaxy serisi yıldızların ışıltısını size getiriyor. Renk ve ebat seçeneğine ürün yelpazesine eklediği dekor ile dinamizm katan seri, şıklığı ile göz dolduruyor</span>",
    "descriptionClean": "İlhamını gökyüzünün sonsuz derinliğinden alan Galaxy serisi yıldızların ışıltısını size getiriyor. Renk ve ebat seçeneğine ürün yelpazesine eklediği dekor ile dinamizm katan seri, şıklığı ile göz dolduruyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1289",
    "brand": "Duratiles",
    "title": "GAMPER Gamper 60x120",
    "seriesName": "GAMPER",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1289",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8889052953581288.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8889052953581288.jpg"
    ],
    "size": "60x120",
    "color": "Gamper",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yenilenmenin verdiği hissi her alana taşıyın Gamper serisi ile sıradanlığa meydan okuyun</span>",
    "descriptionClean": "Yenilenmenin verdiği hissi her alana taşıyın Gamper serisi ile sıradanlığa meydan okuyun",
    "source": "duratiles"
  },
  {
    "id": "dura_1290",
    "brand": "Duratiles",
    "title": "GENESI Genesi 60x60",
    "seriesName": "GENESI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1290",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3497824109546961.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3497824109546961.jpg"
    ],
    "size": "60x60",
    "color": "Genesi",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Mermer görünüme sahip Genesi serisi porselen karoları, yapılara canlı bir görünüm kazandırırken, pozitif bir etkinin de mimarı oluyor.</span>",
    "descriptionClean": "Mermer görünüme sahip Genesi serisi porselen karoları, yapılara canlı bir görünüm kazandırırken, pozitif bir etkinin de mimarı oluyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1291",
    "brand": "Duratiles",
    "title": "GIALLO Beyaz 30x60",
    "seriesName": "GIALLO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12199",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4212219138168921.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4212219138168921.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Giallo Porselen Karoları güçlü ve doğal tonlarıyla mekanlarınıza karakteristik bir görünüm kazandıracak!</span>",
    "descriptionClean": "Giallo Porselen Karoları güçlü ve doğal tonlarıyla mekanlarınıza karakteristik bir görünüm kazandıracak!",
    "source": "duratiles"
  },
  {
    "id": "dura_1292",
    "brand": "Duratiles",
    "title": "GIALLO Fildişi 30x60",
    "seriesName": "GIALLO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12197",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5790071830474752.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5790071830474752.jpg"
    ],
    "size": "30x60",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Giallo Porselen Karoları güçlü ve doğal tonlarıyla mekanlarınıza karakteristik bir görünüm kazandıracak!</span>",
    "descriptionClean": "Giallo Porselen Karoları güçlü ve doğal tonlarıyla mekanlarınıza karakteristik bir görünüm kazandıracak!",
    "source": "duratiles"
  },
  {
    "id": "dura_1293",
    "brand": "Duratiles",
    "title": "GIALLO Krem 30x60",
    "seriesName": "GIALLO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12195",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5781657006268021.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5781657006268021.jpg"
    ],
    "size": "30x60",
    "color": "Krem",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Giallo Porselen Karoları güçlü ve doğal tonlarıyla mekanlarınıza karakteristik bir görünüm kazandıracak!</span>",
    "descriptionClean": "Giallo Porselen Karoları güçlü ve doğal tonlarıyla mekanlarınıza karakteristik bir görünüm kazandıracak!",
    "source": "duratiles"
  },
  {
    "id": "dura_1294",
    "brand": "Duratiles",
    "title": "GIALLO Gri 30x60",
    "seriesName": "GIALLO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12196",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20017389599892021.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20017389599892021.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Giallo Porselen Karoları güçlü ve doğal tonlarıyla mekanlarınıza karakteristik bir görünüm kazandıracak!</span>",
    "descriptionClean": "Giallo Porselen Karoları güçlü ve doğal tonlarıyla mekanlarınıza karakteristik bir görünüm kazandıracak!",
    "source": "duratiles"
  },
  {
    "id": "dura_1295",
    "brand": "Duratiles",
    "title": "GIALLO Noce 30x60",
    "seriesName": "GIALLO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12198",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8471854839428032.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8471854839428032.jpg"
    ],
    "size": "30x60",
    "color": "Noce",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Giallo Porselen Karoları güçlü ve doğal tonlarıyla mekanlarınıza karakteristik bir görünüm kazandıracak!</span>",
    "descriptionClean": "Giallo Porselen Karoları güçlü ve doğal tonlarıyla mekanlarınıza karakteristik bir görünüm kazandıracak!",
    "source": "duratiles"
  },
  {
    "id": "dura_1296",
    "brand": "Duratiles",
    "title": "GIALLO Antrasit 30x60",
    "seriesName": "GIALLO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12194",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3930067491089607.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3930067491089607.jpg"
    ],
    "size": "30x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Giallo Porselen Karoları güçlü ve doğal tonlarıyla mekanlarınıza karakteristik bir görünüm kazandıracak!</span>",
    "descriptionClean": "Giallo Porselen Karoları güçlü ve doğal tonlarıyla mekanlarınıza karakteristik bir görünüm kazandıracak!",
    "source": "duratiles"
  },
  {
    "id": "dura_1297",
    "brand": "Duratiles",
    "title": "GLEN Snow 60x120",
    "seriesName": "GLEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1297",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7103859231114522.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7103859231114522.jpg"
    ],
    "size": "60x120",
    "color": "Snow",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Hayatın dinamik akışından ilham alan Glen porselen karoları konfordan ödün vermeyen tasarımlarıyla evinizin enerjisini yükseltiyor.</span>",
    "descriptionClean": "Hayatın dinamik akışından ilham alan Glen porselen karoları konfordan ödün vermeyen tasarımlarıyla evinizin enerjisini yükseltiyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1298",
    "brand": "Duratiles",
    "title": "GLEN Natura 60x120",
    "seriesName": "GLEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1298",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44901414388222893.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44901414388222893.jpg"
    ],
    "size": "60x120",
    "color": "Natura",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Hayatın dinamik akışından ilham alan Glen porselen karoları konfordan ödün vermeyen tasarımlarıyla evinizin enerjisini yükseltiyor.</span>",
    "descriptionClean": "Hayatın dinamik akışından ilham alan Glen porselen karoları konfordan ödün vermeyen tasarımlarıyla evinizin enerjisini yükseltiyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1299",
    "brand": "Duratiles",
    "title": "GLEN Warm 60x120",
    "seriesName": "GLEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1299",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.27528470815765516.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.27528470815765516.jpg"
    ],
    "size": "60x120",
    "color": "Warm",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Hayatın dinamik akışından ilham alan Glen porselen karoları konfordan ödün vermeyen tasarımlarıyla evinizin enerjisini yükseltiyor.</span>",
    "descriptionClean": "Hayatın dinamik akışından ilham alan Glen porselen karoları konfordan ödün vermeyen tasarımlarıyla evinizin enerjisini yükseltiyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1300",
    "brand": "Duratiles",
    "title": "GLORIA Beyaz 60x120",
    "seriesName": "GLORIA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1300",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8577953495329831.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8577953495329831.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İddialı mekanların tercihi olan Gloria Serisi özgün tasarımlar yaratır</span>",
    "descriptionClean": "İddialı mekanların tercihi olan Gloria Serisi özgün tasarımlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1301",
    "brand": "Duratiles",
    "title": "GLORIA Siyah 60x120",
    "seriesName": "GLORIA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1301",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7261715018775678.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7261715018775678.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İddialı mekanların tercihi olan Gloria Serisi özgün tasarımlar yaratır</span>",
    "descriptionClean": "İddialı mekanların tercihi olan Gloria Serisi özgün tasarımlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1302",
    "brand": "Duratiles",
    "title": "GRABEN Beyaz 30x60",
    "seriesName": "GRABEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "51077",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5534358120779217.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5534358120779217.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaratıcı mekanların mimarı</span>",
    "descriptionClean": "Yaratıcı mekanların mimarı",
    "source": "duratiles"
  },
  {
    "id": "dura_1303",
    "brand": "Duratiles",
    "title": "GRABEN Bone 30x60",
    "seriesName": "GRABEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "51446",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9447150661599762.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9447150661599762.jpg"
    ],
    "size": "30x60",
    "color": "Bone",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "V2",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaratıcı mekanların mimarı</span>",
    "descriptionClean": "Yaratıcı mekanların mimarı",
    "source": "duratiles"
  },
  {
    "id": "dura_1304",
    "brand": "Duratiles",
    "title": "GRABEN Gri 30x60",
    "seriesName": "GRABEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "32045",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7118390062785603.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7118390062785603.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "V2",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaratıcı mekanların mimarı</span>",
    "descriptionClean": "Yaratıcı mekanların mimarı",
    "source": "duratiles"
  },
  {
    "id": "dura_1305",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Beyaz 45x90",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1305",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20688985473163835.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20688985473163835.jpg"
    ],
    "size": "45x90",
    "color": "Beyaz",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1306",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Bone 45x90",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1306",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46839200464877884.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46839200464877884.jpg"
    ],
    "size": "45x90",
    "color": "Bone",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1307",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Gri 45x90",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1307",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5642372162252097.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5642372162252097.jpg"
    ],
    "size": "45x90",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1308",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Gri 60x90",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1308",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9914611700392418.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9914611700392418.jpg"
    ],
    "size": "60x90",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1309",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Beyaz 60x90",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1309",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7936719239507695.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7936719239507695.jpg"
    ],
    "size": "60x90",
    "color": "Beyaz",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1310",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Bone 60x90",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1310",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.04211187013019879.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.04211187013019879.jpg"
    ],
    "size": "60x90",
    "color": "Bone",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1311",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Beyaz 60x120",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1311",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11693528126664499.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11693528126664499.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1312",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Bone 60x120",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1312",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4847724785670915.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4847724785670915.jpg"
    ],
    "size": "60x120",
    "color": "Bone",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1313",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Gri 60x120",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1313",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8181242572715306.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8181242572715306.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1314",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Bone 60x120",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1314",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9223149446297652.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9223149446297652.jpg"
    ],
    "size": "60x120",
    "color": "Bone",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1315",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Gri 60x120",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1315",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2644994366577683.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2644994366577683.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1316",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Beyaz 40x120",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1316",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9238808467813043.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9238808467813043.jpg"
    ],
    "size": "40x120",
    "color": "Beyaz",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1317",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Bone 40x120",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1317",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46969631906295106.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46969631906295106.jpg"
    ],
    "size": "40x120",
    "color": "Bone",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1318",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Gri 40x120",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1318",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0948630238370427.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0948630238370427.jpg"
    ],
    "size": "40x120",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1319",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Beyaz 30x120",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1319",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7578030384786741.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7578030384786741.jpg"
    ],
    "size": "30x120",
    "color": "Beyaz",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1320",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Bone 30x120",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1320",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40176269385500263.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40176269385500263.jpg"
    ],
    "size": "30x120",
    "color": "Bone",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1321",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Gri 30x120",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1321",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6927677497731366.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6927677497731366.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1322",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Beyaz 80x80",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1322",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9449924409486594.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9449924409486594.jpg"
    ],
    "size": "80x80",
    "color": "Beyaz",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1323",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Bone 80x80",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1323",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22589319637017236.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22589319637017236.jpg"
    ],
    "size": "80x80",
    "color": "Bone",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1324",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Gri 80x80",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1324",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.29504662925215297.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.29504662925215297.jpg"
    ],
    "size": "80x80",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1325",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Beyaz 40x80",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1325",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.25937380652320496.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.25937380652320496.jpg"
    ],
    "size": "40x80",
    "color": "Beyaz",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1326",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Bone 40x80",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1326",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.47157435926672076.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.47157435926672076.jpg"
    ],
    "size": "40x80",
    "color": "Bone",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1327",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Gri 40x80",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1327",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7625055284822224.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7625055284822224.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1328",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Beyaz 60x60",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1328",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11059148971517385.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11059148971517385.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1329",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Bone 60x60",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1329",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6928179776893859.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6928179776893859.jpg"
    ],
    "size": "60x60",
    "color": "Bone",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1330",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Gri 60x60",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1330",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5303282937110465.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5303282937110465.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1331",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Beyaz 40x40",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1331",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9344389260084279.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9344389260084279.jpg"
    ],
    "size": "40x40",
    "color": "Beyaz",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1332",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Bone 40x40",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1332",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9401415103817682.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9401415103817682.jpg"
    ],
    "size": "40x40",
    "color": "Bone",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1333",
    "brand": "Duratiles",
    "title": "GRABEN 20mm Gri 40x40",
    "seriesName": "GRABEN 20mm",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1333",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.29075578877480157.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.29075578877480157.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Graben serisi seramiğin dingin enerjisini mermer görünümüyle yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1334",
    "brand": "Duratiles",
    "title": "GRAPHITE Graphite 60x120",
    "seriesName": "GRAPHITE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1334",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.271506760506502.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.271506760506502.jpg"
    ],
    "size": "60x120",
    "color": "Graphite",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Yalın şıklığı ile dingin mekanlar tasarlayan Graphite porselen karoları zamansız yaşam alanları kurgular.</span>",
    "descriptionClean": "Yalın şıklığı ile dingin mekanlar tasarlayan Graphite porselen karoları zamansız yaşam alanları kurgular.",
    "source": "duratiles"
  },
  {
    "id": "dura_1335",
    "brand": "Duratiles",
    "title": "GRAPHITE Graphite 60x60",
    "seriesName": "GRAPHITE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1335",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6741979652558503.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6741979652558503.jpg"
    ],
    "size": "60x60",
    "color": "Graphite",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Yalın şıklığı ile dingin mekanlar tasarlayan Graphite porselen karoları zamansız yaşam alanları kurgular.</span>",
    "descriptionClean": "Yalın şıklığı ile dingin mekanlar tasarlayan Graphite porselen karoları zamansız yaşam alanları kurgular.",
    "source": "duratiles"
  },
  {
    "id": "dura_1336",
    "brand": "Duratiles",
    "title": "HALONG BOOKMATCH Dekor 60x120",
    "seriesName": "HALONG BOOKMATCH",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1336",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5743429441442013.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5743429441442013.jpg"
    ],
    "size": "60x120",
    "color": "Dekor",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Uygulandığı alanlarda stil sahibi bir tasarım anlayışının altını çizen Halong Porselen Karoları kusursuz modern yaşam alanlarının vazgeçilmezi olmaya aday.</span>",
    "descriptionClean": "Uygulandığı alanlarda stil sahibi bir tasarım anlayışının altını çizen Halong Porselen Karoları kusursuz modern yaşam alanlarının vazgeçilmezi olmaya aday.",
    "source": "duratiles"
  },
  {
    "id": "dura_1337",
    "brand": "Duratiles",
    "title": "HERAKLES Beyaz 45x45",
    "seriesName": "HERAKLES",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1337",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21119261374388987.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21119261374388987.jpg"
    ],
    "size": "45x45",
    "color": "Beyaz",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">İnce detaylar şıklığı tamamlar. Herakles serisi ile şıklığa yeni bir soluk getirdik. Seramiğe atılan şık bir imza misali zarafeti yansıtır.</span>",
    "descriptionClean": "İnce detaylar şıklığı tamamlar. Herakles serisi ile şıklığa yeni bir soluk getirdik. Seramiğe atılan şık bir imza misali zarafeti yansıtır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1338",
    "brand": "Duratiles",
    "title": "HERAKLES Latte 45x45",
    "seriesName": "HERAKLES",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1338",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6938396906497009.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6938396906497009.jpg"
    ],
    "size": "45x45",
    "color": "Latte",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">İnce detaylar şıklığı tamamlar. Herakles serisi ile şıklığa yeni bir soluk getirdik. Seramiğe atılan şık bir imza misali zarafeti yansıtır.</span>",
    "descriptionClean": "İnce detaylar şıklığı tamamlar. Herakles serisi ile şıklığa yeni bir soluk getirdik. Seramiğe atılan şık bir imza misali zarafeti yansıtır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1339",
    "brand": "Duratiles",
    "title": "HERAKLES Beyaz 30x60",
    "seriesName": "HERAKLES",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1339",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23563242086722713.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23563242086722713.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">İnce detaylar şıklığı tamamlar. Herakles serisi ile şıklığa yeni bir soluk getirdik. Seramiğe atılan şık bir imza misali zarafeti yansıtır.</span>",
    "descriptionClean": "İnce detaylar şıklığı tamamlar. Herakles serisi ile şıklığa yeni bir soluk getirdik. Seramiğe atılan şık bir imza misali zarafeti yansıtır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1340",
    "brand": "Duratiles",
    "title": "HERAKLES Gri 30x60",
    "seriesName": "HERAKLES",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1340",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13360709763114598.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13360709763114598.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">İnce detaylar şıklığı tamamlar. Herakles serisi ile şıklığa yeni bir soluk getirdik. Seramiğe atılan şık bir imza misali zarafeti yansıtır.</span>",
    "descriptionClean": "İnce detaylar şıklığı tamamlar. Herakles serisi ile şıklığa yeni bir soluk getirdik. Seramiğe atılan şık bir imza misali zarafeti yansıtır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1341",
    "brand": "Duratiles",
    "title": "HERAKLES Latte 30x60",
    "seriesName": "HERAKLES",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1341",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.39166825736568645.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.39166825736568645.jpg"
    ],
    "size": "30x60",
    "color": "Latte",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">İnce detaylar şıklığı tamamlar. Herakles serisi ile şıklığa yeni bir soluk getirdik. Seramiğe atılan şık bir imza misali zarafeti yansıtır.</span>",
    "descriptionClean": "İnce detaylar şıklığı tamamlar. Herakles serisi ile şıklığa yeni bir soluk getirdik. Seramiğe atılan şık bir imza misali zarafeti yansıtır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1342",
    "brand": "Duratiles",
    "title": "HERAKLES Mocha 30x60",
    "seriesName": "HERAKLES",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1342",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10688201951586718.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10688201951586718.jpg"
    ],
    "size": "30x60",
    "color": "Mocha",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">İnce detaylar şıklığı tamamlar. Herakles serisi ile şıklığa yeni bir soluk getirdik. Seramiğe atılan şık bir imza misali zarafeti yansıtır.</span>",
    "descriptionClean": "İnce detaylar şıklığı tamamlar. Herakles serisi ile şıklığa yeni bir soluk getirdik. Seramiğe atılan şık bir imza misali zarafeti yansıtır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1343",
    "brand": "Duratiles",
    "title": "HERAKLES Dekofon 30x60",
    "seriesName": "HERAKLES",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1343",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6989407306340948.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6989407306340948.jpg"
    ],
    "size": "30x60",
    "color": "Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">İnce detaylar şıklığı tamamlar. Herakles serisi ile şıklığa yeni bir soluk getirdik. Seramiğe atılan şık bir imza misali zarafeti yansıtır.</span>",
    "descriptionClean": "İnce detaylar şıklığı tamamlar. Herakles serisi ile şıklığa yeni bir soluk getirdik. Seramiğe atılan şık bir imza misali zarafeti yansıtır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1344",
    "brand": "Duratiles",
    "title": "INTEGRA Krema 45x45",
    "seriesName": "INTEGRA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1344",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7678432409525751.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7678432409525751.jpg"
    ],
    "size": "45x45",
    "color": "Krema",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Balkon/Teras & Dış Cephe & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo",
      "Balkon Teras",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Integra serisi ile mekanlarınıza hareket katıp ,tarzınızı yansıtabilirsiniz</span>",
    "descriptionClean": "Integra serisi ile mekanlarınıza hareket katıp ,tarzınızı yansıtabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_1345",
    "brand": "Duratiles",
    "title": "INTEGRA Okyanus 30x60",
    "seriesName": "INTEGRA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1345",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9365297150832087.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9365297150832087.jpg"
    ],
    "size": "30x60",
    "color": "Okyanus",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Integra serisi ile mekanlarınıza hareket katıp ,tarzınızı yansıtabilirsiniz</span>",
    "descriptionClean": "Integra serisi ile mekanlarınıza hareket katıp ,tarzınızı yansıtabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_1346",
    "brand": "Duratiles",
    "title": "INTEGRA Chocolate 30x60",
    "seriesName": "INTEGRA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1346",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9950705570769465.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9950705570769465.jpg"
    ],
    "size": "30x60",
    "color": "Chocolate",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Integra serisi ile mekanlarınıza hareket katıp ,tarzınızı yansıtabilirsiniz</span>",
    "descriptionClean": "Integra serisi ile mekanlarınıza hareket katıp ,tarzınızı yansıtabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_1347",
    "brand": "Duratiles",
    "title": "INTEGRA Chocolate Dekofon 30x60",
    "seriesName": "INTEGRA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1347",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8426503307052744.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8426503307052744.jpg"
    ],
    "size": "30x60",
    "color": "Chocolate Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Integra serisi ile mekanlarınıza hareket katıp ,tarzınızı yansıtabilirsiniz</span>",
    "descriptionClean": "Integra serisi ile mekanlarınıza hareket katıp ,tarzınızı yansıtabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_1348",
    "brand": "Duratiles",
    "title": "INTEGRA Ocean Dekofon 30x60",
    "seriesName": "INTEGRA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1348",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7566923562883964.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7566923562883964.jpg"
    ],
    "size": "30x60",
    "color": "Ocean Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Integra serisi ile mekanlarınıza hareket katıp ,tarzınızı yansıtabilirsiniz</span>",
    "descriptionClean": "Integra serisi ile mekanlarınıza hareket katıp ,tarzınızı yansıtabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_1349",
    "brand": "Duratiles",
    "title": "INTEGRA Krema 30x60",
    "seriesName": "INTEGRA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1349",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3749001370597834.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3749001370597834.jpg"
    ],
    "size": "30x60",
    "color": "Krema",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Integra serisi ile mekanlarınıza hareket katıp ,tarzınızı yansıtabilirsiniz</span>",
    "descriptionClean": "Integra serisi ile mekanlarınıza hareket katıp ,tarzınızı yansıtabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_1350",
    "brand": "Duratiles",
    "title": "INTENSE Gümüş 60x120",
    "seriesName": "INTENSE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1350",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12291386611173216.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12291386611173216.jpg"
    ],
    "size": "60x120",
    "color": "Gümüş",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Balkon/Teras & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Intense Porselen Karoları mermer dokusunun ışıltılı cazibesini zamansızlığa vurgu yaparcasına gözler önüne seriyor.</span>",
    "descriptionClean": "Intense Porselen Karoları mermer dokusunun ışıltılı cazibesini zamansızlığa vurgu yaparcasına gözler önüne seriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1351",
    "brand": "Duratiles",
    "title": "INTENSE Gümüş 80x80",
    "seriesName": "INTENSE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1351",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5173988221705148.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5173988221705148.jpg"
    ],
    "size": "80x80",
    "color": "Gümüş",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Balkon/Teras & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Intense Porselen Karoları mermer dokusunun ışıltılı cazibesini zamansızlığa vurgu yaparcasına gözler önüne seriyor.</span>",
    "descriptionClean": "Intense Porselen Karoları mermer dokusunun ışıltılı cazibesini zamansızlığa vurgu yaparcasına gözler önüne seriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1352",
    "brand": "Duratiles",
    "title": "INTENSE Gümüş 30x60",
    "seriesName": "INTENSE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1352",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1230251213958774.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1230251213958774.jpg"
    ],
    "size": "30x60",
    "color": "Gümüş",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Balkon/Teras & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Intense Porselen Karoları mermer dokusunun ışıltılı cazibesini zamansızlığa vurgu yaparcasına gözler önüne seriyor.</span>",
    "descriptionClean": "Intense Porselen Karoları mermer dokusunun ışıltılı cazibesini zamansızlığa vurgu yaparcasına gözler önüne seriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1353",
    "brand": "Duratiles",
    "title": "IRANDASH BOOKMATCH Dekor 60x120",
    "seriesName": "IRANDASH BOOKMATCH",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1353",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7997603727781735.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7997603727781735.jpg"
    ],
    "size": "60x120",
    "color": "Dekor",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansızlığı ve yalınlığı beraberinde getiren Bookmatch Koleksiyonundan Irandash Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta .</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Bookmatch Koleksiyonundan Irandash Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta .",
    "source": "duratiles"
  },
  {
    "id": "dura_1354",
    "brand": "Duratiles",
    "title": "IVERNESS Fildişi 60x90",
    "seriesName": "IVERNESS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1354",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9986382264515848.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9986382264515848.jpg"
    ],
    "size": "60x90",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümlü mat yüzeyiyle estetik ve dayanıklılığı bir araya getiren 20 mm kalınlığındaki Durastone, dış mekanlar için ideal bir çözümdür.</span>",
    "descriptionClean": "Mermer görünümlü mat yüzeyiyle estetik ve dayanıklılığı bir araya getiren 20 mm kalınlığındaki Durastone, dış mekanlar için ideal bir çözümdür.",
    "source": "duratiles"
  },
  {
    "id": "dura_1355",
    "brand": "Duratiles",
    "title": "LAND Beyaz 60x120",
    "seriesName": "LAND",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "75461",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9606853182503747.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9606853182503747.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Banyo",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren mekanların mucidi Land Serisi , geniş renk kartelası ile her beğeniye hitap ediyor .Göz alıcı doğallığını taçlandıran yumuşak renkleri ile Land Serisi hayalinizdeki yaşam alanlarını yaratırken en büyük yardımcınız.</span>",
    "descriptionClean": "İlham veren mekanların mucidi Land Serisi , geniş renk kartelası ile her beğeniye hitap ediyor .Göz alıcı doğallığını taçlandıran yumuşak renkleri ile Land Serisi hayalinizdeki yaşam alanlarını yaratırken en büyük yardımcınız.",
    "source": "duratiles"
  },
  {
    "id": "dura_1356",
    "brand": "Duratiles",
    "title": "LAND Sand 60x120",
    "seriesName": "LAND",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "75462",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.020884685768651767.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.020884685768651767.jpg"
    ],
    "size": "60x120",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Banyo",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren mekanların mucidi Land Serisi , geniş renk kartelası ile her beğeniye hitap ediyor .Göz alıcı doğallığını taçlandıran yumuşak renkleri ile Land Serisi hayalinizdeki yaşam alanlarını yaratırken en büyük yardımcınız.</span>",
    "descriptionClean": "İlham veren mekanların mucidi Land Serisi , geniş renk kartelası ile her beğeniye hitap ediyor .Göz alıcı doğallığını taçlandıran yumuşak renkleri ile Land Serisi hayalinizdeki yaşam alanlarını yaratırken en büyük yardımcınız.",
    "source": "duratiles"
  },
  {
    "id": "dura_1357",
    "brand": "Duratiles",
    "title": "LAND İce 100x100",
    "seriesName": "LAND",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1357",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5901599412955774.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5901599412955774.jpg"
    ],
    "size": "100x100",
    "color": "İce",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Banyo",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren mekanların mucidi Land Serisi , geniş renk kartelası ile her beğeniye hitap ediyor .Göz alıcı doğallığını taçlandıran yumuşak renkleri ile Land Serisi hayalinizdeki yaşam alanlarını yaratırken en büyük yardımcınız.</span>",
    "descriptionClean": "İlham veren mekanların mucidi Land Serisi , geniş renk kartelası ile her beğeniye hitap ediyor .Göz alıcı doğallığını taçlandıran yumuşak renkleri ile Land Serisi hayalinizdeki yaşam alanlarını yaratırken en büyük yardımcınız.",
    "source": "duratiles"
  },
  {
    "id": "dura_1358",
    "brand": "Duratiles",
    "title": "LAND Beyaz 100x100",
    "seriesName": "LAND",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1358",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.809835358110132.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.809835358110132.jpg"
    ],
    "size": "100x100",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Banyo",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren mekanların mucidi Land Serisi , geniş renk kartelası ile her beğeniye hitap ediyor .Göz alıcı doğallığını taçlandıran yumuşak renkleri ile Land Serisi hayalinizdeki yaşam alanlarını yaratırken en büyük yardımcınız.</span>",
    "descriptionClean": "İlham veren mekanların mucidi Land Serisi , geniş renk kartelası ile her beğeniye hitap ediyor .Göz alıcı doğallığını taçlandıran yumuşak renkleri ile Land Serisi hayalinizdeki yaşam alanlarını yaratırken en büyük yardımcınız.",
    "source": "duratiles"
  },
  {
    "id": "dura_1359",
    "brand": "Duratiles",
    "title": "LAND Gri 100x100",
    "seriesName": "LAND",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1359",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44558229033353447.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44558229033353447.jpg"
    ],
    "size": "100x100",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Banyo",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren mekanların mucidi Land Serisi , geniş renk kartelası ile her beğeniye hitap ediyor .Göz alıcı doğallığını taçlandıran yumuşak renkleri ile Land Serisi hayalinizdeki yaşam alanlarını yaratırken en büyük yardımcınız.</span>",
    "descriptionClean": "İlham veren mekanların mucidi Land Serisi , geniş renk kartelası ile her beğeniye hitap ediyor .Göz alıcı doğallığını taçlandıran yumuşak renkleri ile Land Serisi hayalinizdeki yaşam alanlarını yaratırken en büyük yardımcınız.",
    "source": "duratiles"
  },
  {
    "id": "dura_1360",
    "brand": "Duratiles",
    "title": "LAND Bej 100x100",
    "seriesName": "LAND",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1360",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2416098885136152.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2416098885136152.jpg"
    ],
    "size": "100x100",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren mekanların mucidi Land Serisi , geniş renk kartelası ile her beğeniye hitap ediyor .Göz alıcı doğallığını taçlandıran yumuşak renkleri ile Land Serisi hayalinizdeki yaşam alanlarını yaratırken en büyük yardımcınız.</span>",
    "descriptionClean": "İlham veren mekanların mucidi Land Serisi , geniş renk kartelası ile her beğeniye hitap ediyor .Göz alıcı doğallığını taçlandıran yumuşak renkleri ile Land Serisi hayalinizdeki yaşam alanlarını yaratırken en büyük yardımcınız.",
    "source": "duratiles"
  },
  {
    "id": "dura_1361",
    "brand": "Duratiles",
    "title": "LAND Sand 100x100",
    "seriesName": "LAND",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1361",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09674391805774796.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09674391805774796.jpg"
    ],
    "size": "100x100",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Banyo",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren mekanların mucidi Land Serisi , geniş renk kartelası ile her beğeniye hitap ediyor .Göz alıcı doğallığını taçlandıran yumuşak renkleri ile Land Serisi hayalinizdeki yaşam alanlarını yaratırken en büyük yardımcınız.</span>",
    "descriptionClean": "İlham veren mekanların mucidi Land Serisi , geniş renk kartelası ile her beğeniye hitap ediyor .Göz alıcı doğallığını taçlandıran yumuşak renkleri ile Land Serisi hayalinizdeki yaşam alanlarını yaratırken en büyük yardımcınız.",
    "source": "duratiles"
  },
  {
    "id": "dura_1362",
    "brand": "Duratiles",
    "title": "LAND Kül 100x100",
    "seriesName": "LAND",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1362",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8029432187680466.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8029432187680466.jpg"
    ],
    "size": "100x100",
    "color": "Kül",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Banyo",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren mekanların mucidi Land Serisi , geniş renk kartelası ile her beğeniye hitap ediyor .Göz alıcı doğallığını taçlandıran yumuşak renkleri ile Land Serisi hayalinizdeki yaşam alanlarını yaratırken en büyük yardımcınız.</span>",
    "descriptionClean": "İlham veren mekanların mucidi Land Serisi , geniş renk kartelası ile her beğeniye hitap ediyor .Göz alıcı doğallığını taçlandıran yumuşak renkleri ile Land Serisi hayalinizdeki yaşam alanlarını yaratırken en büyük yardımcınız.",
    "source": "duratiles"
  },
  {
    "id": "dura_1363",
    "brand": "Duratiles",
    "title": "LAVASTONE Stone 60x60",
    "seriesName": "LAVASTONE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1363",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.02976758242297728.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.02976758242297728.jpg"
    ],
    "size": "60x60",
    "color": "Stone",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Lavastone Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.</span>",
    "descriptionClean": "Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Lavastone Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1364",
    "brand": "Duratiles",
    "title": "LAVASTONE Gri 30x60",
    "seriesName": "LAVASTONE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1364",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.602844448599436.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.602844448599436.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart & 20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Banyo",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Lavastone Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.</span>",
    "descriptionClean": "Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Lavastone Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1365",
    "brand": "Duratiles",
    "title": "LAVASTONE Beyaz 30x60",
    "seriesName": "LAVASTONE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1365",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7297672215364779.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7297672215364779.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Lavastone Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.</span>",
    "descriptionClean": "Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Lavastone Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1366",
    "brand": "Duratiles",
    "title": "LIEN Kahve 60x120",
    "seriesName": "LIEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1366",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7491957691042799.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7491957691042799.jpg"
    ],
    "size": "60x120",
    "color": "Kahve",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Banyo & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Banyo",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Lien Porselen Karoları estetik ve fonksiyonel çizgileriyle sıra dışı konseptler yaratıyor</span>",
    "descriptionClean": "Lien Porselen Karoları estetik ve fonksiyonel çizgileriyle sıra dışı konseptler yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1367",
    "brand": "Duratiles",
    "title": "LIEN Siyah 60x120",
    "seriesName": "LIEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1367",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4876765579703113.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4876765579703113.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Banyo & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Banyo",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Lien Porselen Karoları estetik ve fonksiyonel çizgileriyle sıra dışı konseptler yaratıyor</span>",
    "descriptionClean": "Lien Porselen Karoları estetik ve fonksiyonel çizgileriyle sıra dışı konseptler yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1368",
    "brand": "Duratiles",
    "title": "LINE CALACATTA Gri 45x45",
    "seriesName": "LINE CALACATTA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1368",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6812538418268055.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6812538418268055.jpg"
    ],
    "size": "45x45",
    "color": "Gri",
    "surface": "Parlak, Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Banyo & Dış Cephe",
    "technology": "Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Banyo",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Duru şıklığı ve modern tarzı ile Zen Serisi yaşam alanlarınızda stilinizi oluştururken size ilham verecek</span>",
    "descriptionClean": "Duru şıklığı ve modern tarzı ile Zen Serisi yaşam alanlarınızda stilinizi oluştururken size ilham verecek",
    "source": "duratiles"
  },
  {
    "id": "dura_1369",
    "brand": "Duratiles",
    "title": "LIZA Beyaz 60x120",
    "seriesName": "LIZA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1369",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4623652272330224.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4623652272330224.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Liza Porselen Karoları full lappato özelliği ile hiç solmayan ve asla eskimeyen bir görüntüyü garantiliyor.</span>",
    "descriptionClean": "Liza Porselen Karoları full lappato özelliği ile hiç solmayan ve asla eskimeyen bir görüntüyü garantiliyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1370",
    "brand": "Duratiles",
    "title": "LIZA Siyah 60x120",
    "seriesName": "LIZA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1370",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17696189389610928.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17696189389610928.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Liza Porselen Karoları full lappato özelliği ile hiç solmayan ve asla eskimeyen bir görüntüyü garantiliyor.</span>",
    "descriptionClean": "Liza Porselen Karoları full lappato özelliği ile hiç solmayan ve asla eskimeyen bir görüntüyü garantiliyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1371",
    "brand": "Duratiles",
    "title": "LOOKITA Beyaz 60x120",
    "seriesName": "LOOKITA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1371",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.009296697305498203.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.009296697305498203.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Lookita Porselen Karoları modern tasarım dilini yaşam alanlarınıza taşıyor.</span>",
    "descriptionClean": "Lookita Porselen Karoları modern tasarım dilini yaşam alanlarınıza taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1372",
    "brand": "Duratiles",
    "title": "LUXOR Gri 45x45",
    "seriesName": "LUXOR",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1372",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9330427257626646.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9330427257626646.jpg"
    ],
    "size": "45x45",
    "color": "Gri",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Lüksün en doğal hali... Sade tasarımlar doğal çizgilerle bütünleşti ve Luxor serisini oluşturdu. Sadeliği hayat tarzı haline getirenlere özel bir tasarım. Gücün ve lüksün en yalın halini temsil eder.</span>",
    "descriptionClean": "Lüksün en doğal hali... Sade tasarımlar doğal çizgilerle bütünleşti ve Luxor serisini oluşturdu. Sadeliği hayat tarzı haline getirenlere özel bir tasarım. Gücün ve lüksün en yalın halini temsil eder.",
    "source": "duratiles"
  },
  {
    "id": "dura_1373",
    "brand": "Duratiles",
    "title": "LUXOR Gray Scan Dekofon 30x60",
    "seriesName": "LUXOR",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1373",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.31279740880201323.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.31279740880201323.jpg"
    ],
    "size": "30x60",
    "color": "Gray Scan Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Lüksün en doğal hali... Sade tasarımlar doğal çizgilerle bütünleşti ve Luxor serisini oluşturdu. Sadeliği hayat tarzı haline getirenlere özel bir tasarım. Gücün ve lüksün en yalın halini temsil eder.</span>",
    "descriptionClean": "Lüksün en doğal hali... Sade tasarımlar doğal çizgilerle bütünleşti ve Luxor serisini oluşturdu. Sadeliği hayat tarzı haline getirenlere özel bir tasarım. Gücün ve lüksün en yalın halini temsil eder.",
    "source": "duratiles"
  },
  {
    "id": "dura_1374",
    "brand": "Duratiles",
    "title": "LUXOR Gri 30x60",
    "seriesName": "LUXOR",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1374",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8355772994121174.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8355772994121174.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Lüksün en doğal hali... Sade tasarımlar doğal çizgilerle bütünleşti ve Luxor serisini oluşturdu. Sadeliği hayat tarzı haline getirenlere özel bir tasarım. Gücün ve lüksün en yalın halini temsil eder.</span>",
    "descriptionClean": "Lüksün en doğal hali... Sade tasarımlar doğal çizgilerle bütünleşti ve Luxor serisini oluşturdu. Sadeliği hayat tarzı haline getirenlere özel bir tasarım. Gücün ve lüksün en yalın halini temsil eder.",
    "source": "duratiles"
  },
  {
    "id": "dura_1375",
    "brand": "Duratiles",
    "title": "LUXOR Sütun Dekofon 30x60",
    "seriesName": "LUXOR",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1375",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2786767197176243.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2786767197176243.jpg"
    ],
    "size": "30x60",
    "color": "Sütun Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Lüksün en doğal hali... Sade tasarımlar doğal çizgilerle bütünleşti ve Luxor serisini oluşturdu. Sadeliği hayat tarzı haline getirenlere özel bir tasarım. Gücün ve lüksün en yalın halini temsil eder.</span>",
    "descriptionClean": "Lüksün en doğal hali... Sade tasarımlar doğal çizgilerle bütünleşti ve Luxor serisini oluşturdu. Sadeliği hayat tarzı haline getirenlere özel bir tasarım. Gücün ve lüksün en yalın halini temsil eder.",
    "source": "duratiles"
  },
  {
    "id": "dura_1376",
    "brand": "Duratiles",
    "title": "LUXURY Luxury 90x180",
    "seriesName": "LUXURY",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1376",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.023199376891167578.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.023199376891167578.jpg"
    ],
    "size": "90x180",
    "color": "Luxury",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Üstün tasarım, mimari bir bakış açısı... Hikâyenize doğal bir ayrıntı katın. Özel desenlerin, özellikle buluşmasına tanık olun. Evinizin havasını Luxury serisi ile değiştirin.</span>",
    "descriptionClean": "Üstün tasarım, mimari bir bakış açısı... Hikâyenize doğal bir ayrıntı katın. Özel desenlerin, özellikle buluşmasına tanık olun. Evinizin havasını Luxury serisi ile değiştirin.",
    "source": "duratiles"
  },
  {
    "id": "dura_1377",
    "brand": "Duratiles",
    "title": "LUXURY Luxury 60x120",
    "seriesName": "LUXURY",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "67336",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22708184850776536.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22708184850776536.jpg"
    ],
    "size": "60x120",
    "color": "Luxury",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Üstün tasarım, mimari bir bakış açısı... Hikâyenize doğal bir ayrıntı katın. Özel desenlerin, özellikle buluşmasına tanık olun. Evinizin havasını Luxury serisi ile değiştirin.</span>",
    "descriptionClean": "Üstün tasarım, mimari bir bakış açısı... Hikâyenize doğal bir ayrıntı katın. Özel desenlerin, özellikle buluşmasına tanık olun. Evinizin havasını Luxury serisi ile değiştirin.",
    "source": "duratiles"
  },
  {
    "id": "dura_1378",
    "brand": "Duratiles",
    "title": "MADRA Siyah 60x120",
    "seriesName": "MADRA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1378",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03510571005493546.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03510571005493546.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Madra Porselen Karoları ...</span>",
    "descriptionClean": "Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Madra Porselen Karoları ...",
    "source": "duratiles"
  },
  {
    "id": "dura_1379",
    "brand": "Duratiles",
    "title": "MARGARITA Beyaz 60x120",
    "seriesName": "MARGARITA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1379",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7981121353166697.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7981121353166697.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Margarita serisi , beyaz rengin ortamlara yaydığı ferahlığı porselen karo konfouyla bir araya getirerek rafine bir tasarım dili oluşturur.</span>",
    "descriptionClean": "Margarita serisi , beyaz rengin ortamlara yaydığı ferahlığı porselen karo konfouyla bir araya getirerek rafine bir tasarım dili oluşturur.",
    "source": "duratiles"
  },
  {
    "id": "dura_1380",
    "brand": "Duratiles",
    "title": "MARGARITA Beyaz 60x60",
    "seriesName": "MARGARITA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1380",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7480452186834727.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7480452186834727.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Margarita serisi , beyaz rengin ortamlara yaydığı ferahlığı porselen karo konfouyla bir araya getirerek rafine bir tasarım dili oluşturur.</span>",
    "descriptionClean": "Margarita serisi , beyaz rengin ortamlara yaydığı ferahlığı porselen karo konfouyla bir araya getirerek rafine bir tasarım dili oluşturur.",
    "source": "duratiles"
  },
  {
    "id": "dura_1381",
    "brand": "Duratiles",
    "title": "MARMI Bianco 60x60",
    "seriesName": "MARMI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1381",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20173085094143528.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20173085094143528.jpg"
    ],
    "size": "60x60",
    "color": "Bianco",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yeni bir tarzla fark yaratan tasarım... Marmi serisi doğanın özündeki güzelliği ortaya çıkartıyor. . Her zaman şık, her zaman ferah mekanlar için yeni nesil seramik.</span>",
    "descriptionClean": "Yeni bir tarzla fark yaratan tasarım... Marmi serisi doğanın özündeki güzelliği ortaya çıkartıyor. . Her zaman şık, her zaman ferah mekanlar için yeni nesil seramik.",
    "source": "duratiles"
  },
  {
    "id": "dura_1382",
    "brand": "Duratiles",
    "title": "MARMIS Bianco 90x180",
    "seriesName": "MARMIS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12283",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8589112233332291.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8589112233332291.jpg"
    ],
    "size": "90x180",
    "color": "Bianco",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Maxımum konforu hedefleyen bir tasarım anlayışına sahip olan Marmis Porselen Karoları rafine bir dekorasyon tarzına hayat verir .</span>",
    "descriptionClean": "Maxımum konforu hedefleyen bir tasarım anlayışına sahip olan Marmis Porselen Karoları rafine bir dekorasyon tarzına hayat verir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1383",
    "brand": "Duratiles",
    "title": "MARMOL Bone 60x120",
    "seriesName": "MARMOL",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "58057",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.35190589586934284.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.35190589586934284.jpg"
    ],
    "size": "60x120",
    "color": "Bone",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermeri aşkla konuşturan Marmol serisi ile tanışın. Beyaz damarlı yapısı,soft renk tonları ve zengin ebat seçeneğiyle tasarımda çığır açıyor.</span>",
    "descriptionClean": "Mermeri aşkla konuşturan Marmol serisi ile tanışın. Beyaz damarlı yapısı,soft renk tonları ve zengin ebat seçeneğiyle tasarımda çığır açıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1384",
    "brand": "Duratiles",
    "title": "MARMOL Smoke 60x120",
    "seriesName": "MARMOL",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "58354",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8049979847676244.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8049979847676244.jpg"
    ],
    "size": "60x120",
    "color": "Smoke",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermeri aşkla konuşturan Marmol serisi ile tanışın. Beyaz damarlı yapısı,soft renk tonları ve zengin ebat seçeneğiyle tasarımda çığır açıyor.</span>",
    "descriptionClean": "Mermeri aşkla konuşturan Marmol serisi ile tanışın. Beyaz damarlı yapısı,soft renk tonları ve zengin ebat seçeneğiyle tasarımda çığır açıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1385",
    "brand": "Duratiles",
    "title": "MARMOL Antrasit 60x120",
    "seriesName": "MARMOL",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "57980",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8475729568440815.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8475729568440815.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermeri aşkla konuşturan Marmol serisi ile tanışın. Beyaz damarlı yapısı,soft renk tonları ve zengin ebat seçeneğiyle tasarımda çığır açıyor.</span>",
    "descriptionClean": "Mermeri aşkla konuşturan Marmol serisi ile tanışın. Beyaz damarlı yapısı,soft renk tonları ve zengin ebat seçeneğiyle tasarımda çığır açıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1386",
    "brand": "Duratiles",
    "title": "MARMOL Bone 80x80",
    "seriesName": "MARMOL",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1386",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.02915447958684758.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.02915447958684758.jpg"
    ],
    "size": "80x80",
    "color": "Bone",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermeri aşkla konuşturan Marmol serisi ile tanışın. Beyaz damarlı yapısı,soft renk tonları ve zengin ebat seçeneğiyle tasarımda çığır açıyor.</span>",
    "descriptionClean": "Mermeri aşkla konuşturan Marmol serisi ile tanışın. Beyaz damarlı yapısı,soft renk tonları ve zengin ebat seçeneğiyle tasarımda çığır açıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1387",
    "brand": "Duratiles",
    "title": "MARMOL Smoke 80x80",
    "seriesName": "MARMOL",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1387",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.25584359418048597.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.25584359418048597.jpg"
    ],
    "size": "80x80",
    "color": "Smoke",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermeri aşkla konuşturan Marmol serisi ile tanışın. Beyaz damarlı yapısı,soft renk tonları ve zengin ebat seçeneğiyle tasarımda çığır açıyor.</span>",
    "descriptionClean": "Mermeri aşkla konuşturan Marmol serisi ile tanışın. Beyaz damarlı yapısı,soft renk tonları ve zengin ebat seçeneğiyle tasarımda çığır açıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1388",
    "brand": "Duratiles",
    "title": "MARMOL Antrasit 80x80",
    "seriesName": "MARMOL",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1388",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8810337369851765.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8810337369851765.jpg"
    ],
    "size": "80x80",
    "color": "Antrasit",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermeri aşkla konuşturan Marmol serisi ile tanışın. Beyaz damarlı yapısı,soft renk tonları ve zengin ebat seçeneğiyle tasarımda çığır açıyor.</span>",
    "descriptionClean": "Mermeri aşkla konuşturan Marmol serisi ile tanışın. Beyaz damarlı yapısı,soft renk tonları ve zengin ebat seçeneğiyle tasarımda çığır açıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1389",
    "brand": "Duratiles",
    "title": "MARMOL Bone 60x60",
    "seriesName": "MARMOL",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1389",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9048500393137909.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9048500393137909.jpg"
    ],
    "size": "60x60",
    "color": "Bone",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermeri aşkla konuşturan Marmol serisi ile tanışın. Beyaz damarlı yapısı,soft renk tonları ve zengin ebat seçeneğiyle tasarımda çığır açıyor.</span>",
    "descriptionClean": "Mermeri aşkla konuşturan Marmol serisi ile tanışın. Beyaz damarlı yapısı,soft renk tonları ve zengin ebat seçeneğiyle tasarımda çığır açıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1390",
    "brand": "Duratiles",
    "title": "MARMOL Smoke 60x60",
    "seriesName": "MARMOL",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1390",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9308704027838192.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9308704027838192.jpg"
    ],
    "size": "60x60",
    "color": "Smoke",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermeri aşkla konuşturan Marmol serisi ile tanışın. Beyaz damarlı yapısı,soft renk tonları ve zengin ebat seçeneğiyle tasarımda çığır açıyor.</span>",
    "descriptionClean": "Mermeri aşkla konuşturan Marmol serisi ile tanışın. Beyaz damarlı yapısı,soft renk tonları ve zengin ebat seçeneğiyle tasarımda çığır açıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1391",
    "brand": "Duratiles",
    "title": "MARMOL Antrasit 60x60",
    "seriesName": "MARMOL",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1391",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.49314814426035614.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.49314814426035614.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermeri aşkla konuşturan Marmol serisi ile tanışın. Beyaz damarlı yapısı,soft renk tonları ve zengin ebat seçeneğiyle tasarımda çığır açıyor.</span>",
    "descriptionClean": "Mermeri aşkla konuşturan Marmol serisi ile tanışın. Beyaz damarlı yapısı,soft renk tonları ve zengin ebat seçeneğiyle tasarımda çığır açıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1392",
    "brand": "Duratiles",
    "title": "MARMOL Dekor 60x60",
    "seriesName": "MARMOL",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1392",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3668021920994313.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3668021920994313.jpg"
    ],
    "size": "60x60",
    "color": "Dekor",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermeri aşkla konuşturan Marmol serisi ile tanışın. Beyaz damarlı yapısı,soft renk tonları ve zengin ebat seçeneğiyle tasarımda çığır açıyor.</span>",
    "descriptionClean": "Mermeri aşkla konuşturan Marmol serisi ile tanışın. Beyaz damarlı yapısı,soft renk tonları ve zengin ebat seçeneğiyle tasarımda çığır açıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1393",
    "brand": "Duratiles",
    "title": "MASSA Fildişi 60x120",
    "seriesName": "MASSA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "75017",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4637876454142983.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4637876454142983.jpg"
    ],
    "size": "60x120",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal taş görünümlü dokusuyla Massa Karoları özgür ruhlu mekanlara yepyeni bir soluk getiriyor.</span>",
    "descriptionClean": "Doğal taş görünümlü dokusuyla Massa Karoları özgür ruhlu mekanlara yepyeni bir soluk getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1394",
    "brand": "Duratiles",
    "title": "MASSA Grigio 60x120",
    "seriesName": "MASSA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "75019",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2507758130383194.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2507758130383194.jpg"
    ],
    "size": "60x120",
    "color": "Grigio",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal taş görünümlü dokusuyla Massa Karoları özgür ruhlu mekanlara yepyeni bir soluk getiriyor.</span>",
    "descriptionClean": "Doğal taş görünümlü dokusuyla Massa Karoları özgür ruhlu mekanlara yepyeni bir soluk getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1395",
    "brand": "Duratiles",
    "title": "MASSA Antrasit 60x120",
    "seriesName": "MASSA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "75021",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3586431110109002.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3586431110109002.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal taş görünümlü dokusuyla Massa Karoları özgür ruhlu mekanlara yepyeni bir soluk getiriyor.</span>",
    "descriptionClean": "Doğal taş görünümlü dokusuyla Massa Karoları özgür ruhlu mekanlara yepyeni bir soluk getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1396",
    "brand": "Duratiles",
    "title": "MASSA Fildişi 60x60",
    "seriesName": "MASSA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "75017",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.441461561785507.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.441461561785507.jpg"
    ],
    "size": "60x60",
    "color": "Fildişi",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal taş görünümlü dokusuyla Massa Karoları özgür ruhlu mekanlara yepyeni bir soluk getiriyor.</span>",
    "descriptionClean": "Doğal taş görünümlü dokusuyla Massa Karoları özgür ruhlu mekanlara yepyeni bir soluk getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1397",
    "brand": "Duratiles",
    "title": "MASSA Grigio 60x60",
    "seriesName": "MASSA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "75019",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7395679095037886.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7395679095037886.jpg"
    ],
    "size": "60x60",
    "color": "Grigio",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal taş görünümlü dokusuyla Massa Karoları özgür ruhlu mekanlara yepyeni bir soluk getiriyor.</span>",
    "descriptionClean": "Doğal taş görünümlü dokusuyla Massa Karoları özgür ruhlu mekanlara yepyeni bir soluk getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1398",
    "brand": "Duratiles",
    "title": "MASSA Antrasit 60x60",
    "seriesName": "MASSA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "75019",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7879426407377076.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7879426407377076.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal taş görünümlü dokusuyla Massa Karoları özgür ruhlu mekanlara yepyeni bir soluk getiriyor.</span>",
    "descriptionClean": "Doğal taş görünümlü dokusuyla Massa Karoları özgür ruhlu mekanlara yepyeni bir soluk getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1399",
    "brand": "Duratiles",
    "title": "MASSA Taupe 60x60",
    "seriesName": "MASSA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1399",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.013466771489205054.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.013466771489205054.jpg"
    ],
    "size": "60x60",
    "color": "Taupe",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal taş görünümlü dokusuyla Massa Karoları özgür ruhlu mekanlara yepyeni bir soluk getiriyor.</span>",
    "descriptionClean": "Doğal taş görünümlü dokusuyla Massa Karoları özgür ruhlu mekanlara yepyeni bir soluk getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1400",
    "brand": "Duratiles",
    "title": "MASSA Siyah 60x60",
    "seriesName": "MASSA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1400",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6420110979209332.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6420110979209332.jpg"
    ],
    "size": "60x60",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal taş görünümlü dokusuyla Massa Karoları özgür ruhlu mekanlara yepyeni bir soluk getiriyor.</span>",
    "descriptionClean": "Doğal taş görünümlü dokusuyla Massa Karoları özgür ruhlu mekanlara yepyeni bir soluk getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1401",
    "brand": "Duratiles",
    "title": "MAYA Bone 45x45",
    "seriesName": "MAYA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1401",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.35541403192543763.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.35541403192543763.jpg"
    ],
    "size": "45x45",
    "color": "Bone",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sanatı mimari ile buluşturan özel bir tasarım. Maya serisinde klasik güzellik anlayışına estetik bir dokunuş yaptık. Modern yaşamın vazgeçilmezi seramik, yaşam alanlarınıza hayat verecek.</span>",
    "descriptionClean": "Sanatı mimari ile buluşturan özel bir tasarım. Maya serisinde klasik güzellik anlayışına estetik bir dokunuş yaptık. Modern yaşamın vazgeçilmezi seramik, yaşam alanlarınıza hayat verecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1402",
    "brand": "Duratiles",
    "title": "MAYA Bone 30x60",
    "seriesName": "MAYA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1402",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3565836725462159.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3565836725462159.jpg"
    ],
    "size": "30x60",
    "color": "Bone",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sanatı mimari ile buluşturan özel bir tasarım. Maya serisinde klasik güzellik anlayışına estetik bir dokunuş yaptık. Modern yaşamın vazgeçilmezi seramik, yaşam alanlarınıza hayat verecek.</span>",
    "descriptionClean": "Sanatı mimari ile buluşturan özel bir tasarım. Maya serisinde klasik güzellik anlayışına estetik bir dokunuş yaptık. Modern yaşamın vazgeçilmezi seramik, yaşam alanlarınıza hayat verecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1403",
    "brand": "Duratiles",
    "title": "MAYA Kahve 30x60",
    "seriesName": "MAYA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1403",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.02438676708571874.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.02438676708571874.jpg"
    ],
    "size": "30x60",
    "color": "Kahve",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sanatı mimari ile buluşturan özel bir tasarım. Maya serisinde klasik güzellik anlayışına estetik bir dokunuş yaptık. Modern yaşamın vazgeçilmezi seramik, yaşam alanlarınıza hayat verecek.</span>",
    "descriptionClean": "Sanatı mimari ile buluşturan özel bir tasarım. Maya serisinde klasik güzellik anlayışına estetik bir dokunuş yaptık. Modern yaşamın vazgeçilmezi seramik, yaşam alanlarınıza hayat verecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1404",
    "brand": "Duratiles",
    "title": "MAYA Dekofon 30x60",
    "seriesName": "MAYA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1404",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.71636485032768.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.71636485032768.jpg"
    ],
    "size": "30x60",
    "color": "Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sanatı mimari ile buluşturan özel bir tasarım. Maya serisinde klasik güzellik anlayışına estetik bir dokunuş yaptık. Modern yaşamın vazgeçilmezi seramik, yaşam alanlarınıza hayat verecek.</span>",
    "descriptionClean": "Sanatı mimari ile buluşturan özel bir tasarım. Maya serisinde klasik güzellik anlayışına estetik bir dokunuş yaptık. Modern yaşamın vazgeçilmezi seramik, yaşam alanlarınıza hayat verecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1405",
    "brand": "Duratiles",
    "title": "MIRAGE Antrasit 30x75",
    "seriesName": "MIRAGE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1405",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4351896334213957.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4351896334213957.jpg"
    ],
    "size": "30x75",
    "color": "Antrasit",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo",
    "technology": "Duvar Karosu",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Rafine bir hayat tarzını oluşturmak ve seramiğin dingin enerjisini mekanlara taşımak için tasarlanan Mirage Serisi, mermer dokusunu ön plana çıkaran parlak yüzeyi ile zamansız güzellikte yaşam alanları yaratır.</span>",
    "descriptionClean": "Rafine bir hayat tarzını oluşturmak ve seramiğin dingin enerjisini mekanlara taşımak için tasarlanan Mirage Serisi, mermer dokusunu ön plana çıkaran parlak yüzeyi ile zamansız güzellikte yaşam alanları yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1406",
    "brand": "Duratiles",
    "title": "MIRAGE Gri Dekofon 30x75",
    "seriesName": "MIRAGE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1406",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7656685245437088.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7656685245437088.jpg"
    ],
    "size": "30x75",
    "color": "Gri Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo",
    "technology": "Duvar Karosu",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Rafine bir hayat tarzını oluşturmak ve seramiğin dingin enerjisini mekanlara taşımak için tasarlanan Mirage Serisi, mermer dokusunu ön plana çıkaran parlak yüzeyi ile zamansız güzellikte yaşam alanları yaratır.</span>",
    "descriptionClean": "Rafine bir hayat tarzını oluşturmak ve seramiğin dingin enerjisini mekanlara taşımak için tasarlanan Mirage Serisi, mermer dokusunu ön plana çıkaran parlak yüzeyi ile zamansız güzellikte yaşam alanları yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1407",
    "brand": "Duratiles",
    "title": "MIRAGE Gri 30x75",
    "seriesName": "MIRAGE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1407",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1538497861632412.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1538497861632412.jpg"
    ],
    "size": "30x75",
    "color": "Gri",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo",
    "technology": "Duvar Karosu",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Rafine bir hayat tarzını oluşturmak ve seramiğin dingin enerjisini mekanlara taşımak için tasarlanan Mirage Serisi, mermer dokusunu ön plana çıkaran parlak yüzeyi ile zamansız güzellikte yaşam alanları yaratır.</span>",
    "descriptionClean": "Rafine bir hayat tarzını oluşturmak ve seramiğin dingin enerjisini mekanlara taşımak için tasarlanan Mirage Serisi, mermer dokusunu ön plana çıkaran parlak yüzeyi ile zamansız güzellikte yaşam alanları yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1408",
    "brand": "Duratiles",
    "title": "MIX STONE Mix Stone 30x75",
    "seriesName": "MIX STONE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1408",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4548063981604408.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4548063981604408.jpg"
    ],
    "size": "30x75",
    "color": "Mix Stone",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Mix Stone porselen karoları estetik ve fonksiyonel çizgileriyle sıra dışı konseptler yaratıyor</span>",
    "descriptionClean": "Mix Stone porselen karoları estetik ve fonksiyonel çizgileriyle sıra dışı konseptler yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1409",
    "brand": "Duratiles",
    "title": "MODENA Koyu 30x60",
    "seriesName": "MODENA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1409",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13001697855730843.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13001697855730843.jpg"
    ],
    "size": "30x60",
    "color": "Koyu",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Konfora estetik kattık, doğal taştan ilham aldık ve Modena serisini tasarladık. Doğanın ruhunu tüm alanlarınıza taşıyın. Her adımda seramiğin karakteristik duygusunu hissedeceksiniz.</span>",
    "descriptionClean": "Konfora estetik kattık, doğal taştan ilham aldık ve Modena serisini tasarladık. Doğanın ruhunu tüm alanlarınıza taşıyın. Her adımda seramiğin karakteristik duygusunu hissedeceksiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1410",
    "brand": "Duratiles",
    "title": "MODENA Açık 30x60",
    "seriesName": "MODENA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1410",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3519648671428629.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3519648671428629.jpg"
    ],
    "size": "30x60",
    "color": "Açık",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Konfora estetik kattık, doğal taştan ilham aldık ve Modena serisini tasarladık. Doğanın ruhunu tüm alanlarınıza taşıyın. Her adımda seramiğin karakteristik duygusunu hissedeceksiniz.</span>",
    "descriptionClean": "Konfora estetik kattık, doğal taştan ilham aldık ve Modena serisini tasarladık. Doğanın ruhunu tüm alanlarınıza taşıyın. Her adımda seramiğin karakteristik duygusunu hissedeceksiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1411",
    "brand": "Duratiles",
    "title": "MODENA Cube Dekofon 30x60",
    "seriesName": "MODENA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1411",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9332506161793708.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9332506161793708.jpg"
    ],
    "size": "30x60",
    "color": "Cube Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Konfora estetik kattık, doğal taştan ilham aldık ve Modena serisini tasarladık. Doğanın ruhunu tüm alanlarınıza taşıyın. Her adımda seramiğin karakteristik duygusunu hissedeceksiniz.</span>",
    "descriptionClean": "Konfora estetik kattık, doğal taştan ilham aldık ve Modena serisini tasarladık. Doğanın ruhunu tüm alanlarınıza taşıyın. Her adımda seramiğin karakteristik duygusunu hissedeceksiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1412",
    "brand": "Duratiles",
    "title": "MODENA Wave Dekofon 30x60",
    "seriesName": "MODENA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1412",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44755138198564137.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44755138198564137.jpg"
    ],
    "size": "30x60",
    "color": "Wave Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Konfora estetik kattık, doğal taştan ilham aldık ve Modena serisini tasarladık. Doğanın ruhunu tüm alanlarınıza taşıyın. Her adımda seramiğin karakteristik duygusunu hissedeceksiniz.</span>",
    "descriptionClean": "Konfora estetik kattık, doğal taştan ilham aldık ve Modena serisini tasarladık. Doğanın ruhunu tüm alanlarınıza taşıyın. Her adımda seramiğin karakteristik duygusunu hissedeceksiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1413",
    "brand": "Duratiles",
    "title": "MONTA Beyaz 60x120",
    "seriesName": "MONTA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1413",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7233979302474141.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7233979302474141.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Dış Cephe",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansız tasarımıyla mekânlara kusursuz bir bütünlük kazandıran Monta, doğallığın en rafine hâlini yansıtır.</span>",
    "descriptionClean": "Zamansız tasarımıyla mekânlara kusursuz bir bütünlük kazandıran Monta, doğallığın en rafine hâlini yansıtır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1414",
    "brand": "Duratiles",
    "title": "MOVE Gri 60x120",
    "seriesName": "MOVE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "63982",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9059684208180079.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9059684208180079.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Detayları ince ince seramiğe işledik ve Move serisini tasarladık. Doğal mermer görünümü bu eşsiz üründe. Ayrıca farklı renk seçenekleri eşliğinde sizlerle...</span>",
    "descriptionClean": "Detayları ince ince seramiğe işledik ve Move serisini tasarladık. Doğal mermer görünümü bu eşsiz üründe. Ayrıca farklı renk seçenekleri eşliğinde sizlerle...",
    "source": "duratiles"
  },
  {
    "id": "dura_1415",
    "brand": "Duratiles",
    "title": "NAPOLI Bej 80x80",
    "seriesName": "NAPOLI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1415",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8906558727107565.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8906558727107565.jpg"
    ],
    "size": "80x80",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Özgün ve dinamik mekanlar yaratmanız için tasarlanan Napoli Porselen Karolarının iddiası doğallığında saklı.</span>",
    "descriptionClean": "Özgün ve dinamik mekanlar yaratmanız için tasarlanan Napoli Porselen Karolarının iddiası doğallığında saklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1416",
    "brand": "Duratiles",
    "title": "NAPOLI Bej Dekofon 80x80",
    "seriesName": "NAPOLI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1416",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9580211527817208.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9580211527817208.jpg"
    ],
    "size": "80x80",
    "color": "Bej Dekofon",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Özgün ve dinamik mekanlar yaratmanız için tasarlanan Napoli Porselen Karolarının iddiası doğallığında saklı.</span>",
    "descriptionClean": "Özgün ve dinamik mekanlar yaratmanız için tasarlanan Napoli Porselen Karolarının iddiası doğallığında saklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1417",
    "brand": "Duratiles",
    "title": "NAPOLI Kahve 80x80",
    "seriesName": "NAPOLI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1417",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.490328958616149.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.490328958616149.jpg"
    ],
    "size": "80x80",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Özgün ve dinamik mekanlar yaratmanız için tasarlanan Napoli Porselen Karolarının iddiası doğallığında saklı.</span>",
    "descriptionClean": "Özgün ve dinamik mekanlar yaratmanız için tasarlanan Napoli Porselen Karolarının iddiası doğallığında saklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1418",
    "brand": "Duratiles",
    "title": "NAPOLI Kahve Dekofon 80x80",
    "seriesName": "NAPOLI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1418",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2135160856093139.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2135160856093139.jpg"
    ],
    "size": "80x80",
    "color": "Kahve Dekofon",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Özgün ve dinamik mekanlar yaratmanız için tasarlanan Napoli Porselen Karolarının iddiası doğallığında saklı.</span>",
    "descriptionClean": "Özgün ve dinamik mekanlar yaratmanız için tasarlanan Napoli Porselen Karolarının iddiası doğallığında saklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1419",
    "brand": "Duratiles",
    "title": "NAPOLI Siyah 80x80",
    "seriesName": "NAPOLI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "75529",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2759293380907205.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2759293380907205.jpg"
    ],
    "size": "80x80",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Özgün ve dinamik mekanlar yaratmanız için tasarlanan Napoli Porselen Karolarının iddiası doğallığında saklı.</span>",
    "descriptionClean": "Özgün ve dinamik mekanlar yaratmanız için tasarlanan Napoli Porselen Karolarının iddiası doğallığında saklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1420",
    "brand": "Duratiles",
    "title": "NAPOLI Gri 80x80",
    "seriesName": "NAPOLI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "74293",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2961396257237895.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2961396257237895.jpg"
    ],
    "size": "80x80",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Özgün ve dinamik mekanlar yaratmanız için tasarlanan Napoli Porselen Karolarının iddiası doğallığında saklı.</span>",
    "descriptionClean": "Özgün ve dinamik mekanlar yaratmanız için tasarlanan Napoli Porselen Karolarının iddiası doğallığında saklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1421",
    "brand": "Duratiles",
    "title": "NAPOLI Koyu Gri 80x80",
    "seriesName": "NAPOLI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "75527",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10239673748249978.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10239673748249978.jpg"
    ],
    "size": "80x80",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Özgün ve dinamik mekanlar yaratmanız için tasarlanan Napoli Porselen Karolarının iddiası doğallığında saklı.</span>",
    "descriptionClean": "Özgün ve dinamik mekanlar yaratmanız için tasarlanan Napoli Porselen Karolarının iddiası doğallığında saklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1422",
    "brand": "Duratiles",
    "title": "NATURA Krem 60x120",
    "seriesName": "NATURA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1422",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3223654152645543.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3223654152645543.jpg"
    ],
    "size": "60x120",
    "color": "Krem",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğanın dilinden konuşan Natura serisi porselen karoları, damarlı mermer görünümü ile sizlerle. Kahve ve krem tonlarında iki farklı renk üç farklı boyut alternatifi ile kendinizi doğanın kalbinde fantastik bir yolculuğun içinde bulacaksınız.</span>",
    "descriptionClean": "Doğanın dilinden konuşan Natura serisi porselen karoları, damarlı mermer görünümü ile sizlerle. Kahve ve krem tonlarında iki farklı renk üç farklı boyut alternatifi ile kendinizi doğanın kalbinde fantastik bir yolculuğun içinde bulacaksınız.",
    "source": "duratiles"
  },
  {
    "id": "dura_1423",
    "brand": "Duratiles",
    "title": "NATURA Kahve 60x120",
    "seriesName": "NATURA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1423",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.022277477407284474.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.022277477407284474.jpg"
    ],
    "size": "60x120",
    "color": "Kahve",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğanın dilinden konuşan Natura serisi porselen karoları, damarlı mermer görünümü ile sizlerle. Kahve ve krem tonlarında iki farklı renk üç farklı boyut alternatifi ile kendinizi doğanın kalbinde fantastik bir yolculuğun içinde bulacaksınız.</span>",
    "descriptionClean": "Doğanın dilinden konuşan Natura serisi porselen karoları, damarlı mermer görünümü ile sizlerle. Kahve ve krem tonlarında iki farklı renk üç farklı boyut alternatifi ile kendinizi doğanın kalbinde fantastik bir yolculuğun içinde bulacaksınız.",
    "source": "duratiles"
  },
  {
    "id": "dura_1424",
    "brand": "Duratiles",
    "title": "NATURA Krem 60x60",
    "seriesName": "NATURA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1424",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5066871449878649.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5066871449878649.jpg"
    ],
    "size": "60x60",
    "color": "Krem",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğanın dilinden konuşan Natura serisi porselen karoları, damarlı mermer görünümü ile sizlerle. Kahve ve krem tonlarında iki farklı renk üç farklı boyut alternatifi ile kendinizi doğanın kalbinde fantastik bir yolculuğun içinde bulacaksınız.</span>",
    "descriptionClean": "Doğanın dilinden konuşan Natura serisi porselen karoları, damarlı mermer görünümü ile sizlerle. Kahve ve krem tonlarında iki farklı renk üç farklı boyut alternatifi ile kendinizi doğanın kalbinde fantastik bir yolculuğun içinde bulacaksınız.",
    "source": "duratiles"
  },
  {
    "id": "dura_1425",
    "brand": "Duratiles",
    "title": "NATURA Kahve 60x60",
    "seriesName": "NATURA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1425",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2151020407134957.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2151020407134957.jpg"
    ],
    "size": "60x60",
    "color": "Kahve",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğanın dilinden konuşan Natura serisi porselen karoları, damarlı mermer görünümü ile sizlerle. Kahve ve krem tonlarında iki farklı renk üç farklı boyut alternatifi ile kendinizi doğanın kalbinde fantastik bir yolculuğun içinde bulacaksınız.</span>",
    "descriptionClean": "Doğanın dilinden konuşan Natura serisi porselen karoları, damarlı mermer görünümü ile sizlerle. Kahve ve krem tonlarında iki farklı renk üç farklı boyut alternatifi ile kendinizi doğanın kalbinde fantastik bir yolculuğun içinde bulacaksınız.",
    "source": "duratiles"
  },
  {
    "id": "dura_1426",
    "brand": "Duratiles",
    "title": "NATURAL STONE Kahve 60x120",
    "seriesName": "NATURAL STONE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1426",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4135017243637986.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4135017243637986.jpg"
    ],
    "size": "60x120",
    "color": "Kahve",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Dış Cephe & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Naturel stone doğallığı ön plana çıkararak ferah yaşam alanları tasarlıyor.</span>",
    "descriptionClean": "Naturel stone doğallığı ön plana çıkararak ferah yaşam alanları tasarlıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1427",
    "brand": "Duratiles",
    "title": "NAVAS Açık Gri 90x180",
    "seriesName": "NAVAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1427",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2584279558333039.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2584279558333039.jpg"
    ],
    "size": "90x180",
    "color": "Açık Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.</span>",
    "descriptionClean": "Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1428",
    "brand": "Duratiles",
    "title": "NAVAS Koyu Gri 90x180",
    "seriesName": "NAVAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1428",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1436899436038993.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1436899436038993.jpg"
    ],
    "size": "90x180",
    "color": "Koyu Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.</span>",
    "descriptionClean": "Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1429",
    "brand": "Duratiles",
    "title": "NAVAS Taupe 90x180",
    "seriesName": "NAVAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1429",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5205030310300184.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5205030310300184.jpg"
    ],
    "size": "90x180",
    "color": "Taupe",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.</span>",
    "descriptionClean": "Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1430",
    "brand": "Duratiles",
    "title": "NAVAS Siyah 90x180",
    "seriesName": "NAVAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1430",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13316637458060487.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13316637458060487.jpg"
    ],
    "size": "90x180",
    "color": "Siyah",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.</span>",
    "descriptionClean": "Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1431",
    "brand": "Duratiles",
    "title": "NAVAS Açık Gri 60x120",
    "seriesName": "NAVAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "75979",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03848238985158048.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03848238985158048.jpg"
    ],
    "size": "60x120",
    "color": "Açık Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.</span>",
    "descriptionClean": "Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1432",
    "brand": "Duratiles",
    "title": "NAVAS Koyu Gri 60x120",
    "seriesName": "NAVAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1432",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3500839951958944.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3500839951958944.jpg"
    ],
    "size": "60x120",
    "color": "Koyu Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.</span>",
    "descriptionClean": "Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1433",
    "brand": "Duratiles",
    "title": "NAVAS Taupe 60x120",
    "seriesName": "NAVAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1433",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7548354491466601.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7548354491466601.jpg"
    ],
    "size": "60x120",
    "color": "Taupe",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.</span>",
    "descriptionClean": "Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_2318",
    "brand": "Duratiles",
    "title": "NAVAS Antrasit 60x120",
    "seriesName": "NAVAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "73364",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7064057115939076.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7064057115939076.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.</span>",
    "descriptionClean": "Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1434",
    "brand": "Duratiles",
    "title": "NAVAS Siyah 60x120",
    "seriesName": "NAVAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "66242",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13875803125499797.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13875803125499797.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.</span>",
    "descriptionClean": "Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1435",
    "brand": "Duratiles",
    "title": "NAVAS Bej 60x120",
    "seriesName": "NAVAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "67380",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6208905560408732.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6208905560408732.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.</span>",
    "descriptionClean": "Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1436",
    "brand": "Duratiles",
    "title": "NAVAS Beyaz 60x120",
    "seriesName": "NAVAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1436",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.014138072223150444.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.014138072223150444.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.</span>",
    "descriptionClean": "Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1437",
    "brand": "Duratiles",
    "title": "NAVAS Bej 60x60",
    "seriesName": "NAVAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "73978",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8630984479106326.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8630984479106326.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.</span>",
    "descriptionClean": "Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1438",
    "brand": "Duratiles",
    "title": "NAVAS İce 60x60",
    "seriesName": "NAVAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "70189",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48842381923010214.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48842381923010214.jpg"
    ],
    "size": "60x60",
    "color": "İce",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.</span>",
    "descriptionClean": "Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1439",
    "brand": "Duratiles",
    "title": "NAVAS Antrasit 60x60",
    "seriesName": "NAVAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1439",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8004624159477257.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8004624159477257.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.</span>",
    "descriptionClean": "Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1440",
    "brand": "Duratiles",
    "title": "NAVAS Açık Gri 60x60",
    "seriesName": "NAVAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1440",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6472967873501482.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6472967873501482.jpg"
    ],
    "size": "60x60",
    "color": "Açık Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.</span>",
    "descriptionClean": "Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1441",
    "brand": "Duratiles",
    "title": "NAVAS Koyu Gri 60x60",
    "seriesName": "NAVAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1441",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.544089732988824.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.544089732988824.jpg"
    ],
    "size": "60x60",
    "color": "Koyu Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.</span>",
    "descriptionClean": "Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1442",
    "brand": "Duratiles",
    "title": "NAVAS Taupe 60x60",
    "seriesName": "NAVAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1442",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7572081204528824.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7572081204528824.jpg"
    ],
    "size": "60x60",
    "color": "Taupe",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.</span>",
    "descriptionClean": "Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1443",
    "brand": "Duratiles",
    "title": "NAVAS Siyah 60x60",
    "seriesName": "NAVAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1443",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.41308368890700786.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.41308368890700786.jpg"
    ],
    "size": "60x60",
    "color": "Siyah",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.</span>",
    "descriptionClean": "Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1444",
    "brand": "Duratiles",
    "title": "NAVAS Açık Gri 30x60",
    "seriesName": "NAVAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1444",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11449179594571546.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11449179594571546.jpg"
    ],
    "size": "30x60",
    "color": "Açık Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.</span>",
    "descriptionClean": "Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1445",
    "brand": "Duratiles",
    "title": "NAVAS Koyu Gri 30x60",
    "seriesName": "NAVAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1445",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.014202908384617685.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.014202908384617685.jpg"
    ],
    "size": "30x60",
    "color": "Koyu Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.</span>",
    "descriptionClean": "Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1446",
    "brand": "Duratiles",
    "title": "NAVAS Taupe 30x60",
    "seriesName": "NAVAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1446",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9460952192873469.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9460952192873469.jpg"
    ],
    "size": "30x60",
    "color": "Taupe",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.</span>",
    "descriptionClean": "Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1447",
    "brand": "Duratiles",
    "title": "NAVAS Siyah 30x60",
    "seriesName": "NAVAS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1447",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4120082375168391.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4120082375168391.jpg"
    ],
    "size": "30x60",
    "color": "Siyah",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.</span>",
    "descriptionClean": "Mermer görünüme sahip Navas serisi porselen karoları ferah, modern ve şık görünümü, birçok farklı renk seçeneği ve boyut opsiyonu ile mekânlara hareket getirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1448",
    "brand": "Duratiles",
    "title": "NEO CALACATTA Gümüş 90x180",
    "seriesName": "NEO CALACATTA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1448",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.24603687495014337.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.24603687495014337.jpg"
    ],
    "size": "90x180",
    "color": "Gümüş",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Sadeliği zarafetle buluşturan Neo Calacatta serisi ile her alana sadeliğin izlerini taşıyabilir ,doğal bir ruh katabilirsiniz.</span>",
    "descriptionClean": "Sadeliği zarafetle buluşturan Neo Calacatta serisi ile her alana sadeliğin izlerini taşıyabilir ,doğal bir ruh katabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1449",
    "brand": "Duratiles",
    "title": "NEO CALACATTA Gümüş 60x120",
    "seriesName": "NEO CALACATTA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "67300",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2618340029081617.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2618340029081617.jpg"
    ],
    "size": "60x120",
    "color": "Gümüş",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Sadeliği zarafetle buluşturan Neo Calacatta serisi ile her alana sadeliğin izlerini taşıyabilir ,doğal bir ruh katabilirsiniz.</span>",
    "descriptionClean": "Sadeliği zarafetle buluşturan Neo Calacatta serisi ile her alana sadeliğin izlerini taşıyabilir ,doğal bir ruh katabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1450",
    "brand": "Duratiles",
    "title": "NEO CALACATTA Altın 60x120",
    "seriesName": "NEO CALACATTA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "67704",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40444279948569706.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40444279948569706.jpg"
    ],
    "size": "60x120",
    "color": "Altın",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Sadeliği zarafetle buluşturan Neo Calacatta serisi ile her alana sadeliğin izlerini taşıyabilir ,doğal bir ruh katabilirsiniz.</span>",
    "descriptionClean": "Sadeliği zarafetle buluşturan Neo Calacatta serisi ile her alana sadeliğin izlerini taşıyabilir ,doğal bir ruh katabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1451",
    "brand": "Duratiles",
    "title": "NEO CALACATTA Gümüş 120x120",
    "seriesName": "NEO CALACATTA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1451",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2620717557551635.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2620717557551635.jpg"
    ],
    "size": "120x120",
    "color": "Gümüş",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Sadeliği zarafetle buluşturan Neo Calacatta serisi ile her alana sadeliğin izlerini taşıyabilir ,doğal bir ruh katabilirsiniz.</span>",
    "descriptionClean": "Sadeliği zarafetle buluşturan Neo Calacatta serisi ile her alana sadeliğin izlerini taşıyabilir ,doğal bir ruh katabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1452",
    "brand": "Duratiles",
    "title": "NEO CALACATTA Altın 60x60",
    "seriesName": "NEO CALACATTA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "75314",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2597425477932154.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2597425477932154.jpg"
    ],
    "size": "60x60",
    "color": "Altın",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Sadeliği zarafetle buluşturan Neo Calacatta serisi ile her alana sadeliğin izlerini taşıyabilir ,doğal bir ruh katabilirsiniz.</span>",
    "descriptionClean": "Sadeliği zarafetle buluşturan Neo Calacatta serisi ile her alana sadeliğin izlerini taşıyabilir ,doğal bir ruh katabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1453",
    "brand": "Duratiles",
    "title": "NEO CALACATTA Gümüş 60x60",
    "seriesName": "NEO CALACATTA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "74492",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6316293858094999.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6316293858094999.jpg"
    ],
    "size": "60x60",
    "color": "Gümüş",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Sadeliği zarafetle buluşturan Neo Calacatta serisi ile her alana sadeliğin izlerini taşıyabilir ,doğal bir ruh katabilirsiniz.</span>",
    "descriptionClean": "Sadeliği zarafetle buluşturan Neo Calacatta serisi ile her alana sadeliğin izlerini taşıyabilir ,doğal bir ruh katabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1454",
    "brand": "Duratiles",
    "title": "NEO DOLCE Dolce 60x120",
    "seriesName": "NEO DOLCE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1454",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7789097821949716.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7789097821949716.jpg"
    ],
    "size": "60x120",
    "color": "Dolce",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Uygulandığı alanlarda stil sahibi bir tasarım anlayışının altını çizen Neo Dolce Porselen Karoları kusursuz modern yaşam alanlarının vazgeçilmezi olmaya aday.</span>",
    "descriptionClean": "Uygulandığı alanlarda stil sahibi bir tasarım anlayışının altını çizen Neo Dolce Porselen Karoları kusursuz modern yaşam alanlarının vazgeçilmezi olmaya aday.",
    "source": "duratiles"
  },
  {
    "id": "dura_1455",
    "brand": "Duratiles",
    "title": "NEO MARMO Crea 90x180",
    "seriesName": "NEO MARMO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1455",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2979468866340216.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2979468866340216.jpg"
    ],
    "size": "90x180",
    "color": "Crea",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Neo Marmo Serisi mavinin dinginliğini evlerinize mermer dokusunun çarpıcı görünümü ile getirmekte.</span>",
    "descriptionClean": "Neo Marmo Serisi mavinin dinginliğini evlerinize mermer dokusunun çarpıcı görünümü ile getirmekte.",
    "source": "duratiles"
  },
  {
    "id": "dura_1456",
    "brand": "Duratiles",
    "title": "NEO MARMO Crea 60x120",
    "seriesName": "NEO MARMO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "67342",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8493567393406103.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8493567393406103.jpg"
    ],
    "size": "60x120",
    "color": "Crea",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Neo Marmo Serisi mavinin dinginliğini evlerinize mermer dokusunun çarpıcı görünümü ile getirmekte.</span>",
    "descriptionClean": "Neo Marmo Serisi mavinin dinginliğini evlerinize mermer dokusunun çarpıcı görünümü ile getirmekte.",
    "source": "duratiles"
  },
  {
    "id": "dura_1457",
    "brand": "Duratiles",
    "title": "NEO MARMOL Neo Marmol 60x120",
    "seriesName": "NEO MARMOL",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1457",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5266908287024754.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5266908287024754.jpg"
    ],
    "size": "60x120",
    "color": "Neo Marmol",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüyle Neo Marmol çarpıcı olduğu kadar modern yaşam alanları tasarlamanızı sağlar</span>",
    "descriptionClean": "Mermer görünümüyle Neo Marmol çarpıcı olduğu kadar modern yaşam alanları tasarlamanızı sağlar",
    "source": "duratiles"
  },
  {
    "id": "dura_1458",
    "brand": "Duratiles",
    "title": "NEO ONIX Beyaz 90x180",
    "seriesName": "NEO ONIX",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1458",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1706633065239146.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1706633065239146.jpg"
    ],
    "size": "90x180",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Neo Onix yumuşak rengi ve mermer dokusuyla mekanlara romantik bir hava getiriyor</span>",
    "descriptionClean": "Neo Onix yumuşak rengi ve mermer dokusuyla mekanlara romantik bir hava getiriyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1459",
    "brand": "Duratiles",
    "title": "NEO ONIX Beyaz 60x120",
    "seriesName": "NEO ONIX",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "67314",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4924117833307845.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4924117833307845.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Neo Onix yumuşak rengi ve mermer dokusuyla mekanlara romantik bir hava getiriyor</span>",
    "descriptionClean": "Neo Onix yumuşak rengi ve mermer dokusuyla mekanlara romantik bir hava getiriyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1460",
    "brand": "Duratiles",
    "title": "NEO ONIX Beyaz 120x120",
    "seriesName": "NEO ONIX",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1460",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09009197479153175.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09009197479153175.jpg"
    ],
    "size": "120x120",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Neo Onix yumuşak rengi ve mermer dokusuyla mekanlara romantik bir hava getiriyor</span>",
    "descriptionClean": "Neo Onix yumuşak rengi ve mermer dokusuyla mekanlara romantik bir hava getiriyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1461",
    "brand": "Duratiles",
    "title": "NEO PULPIS Açık 60x120",
    "seriesName": "NEO PULPIS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "67320",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9700196123064191.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9700196123064191.jpg"
    ],
    "size": "60x120",
    "color": "Açık",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & İç Mekan & Balkon/Teras & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Neo Pulpis serisi geniş renk kartelası ile her mekana uygun çözümler sunmakta</span>",
    "descriptionClean": "Neo Pulpis serisi geniş renk kartelası ile her mekana uygun çözümler sunmakta",
    "source": "duratiles"
  },
  {
    "id": "dura_1462",
    "brand": "Duratiles",
    "title": "NEO PULPIS Gri 60x120",
    "seriesName": "NEO PULPIS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "67377",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.012837209912576641.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.012837209912576641.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & İç Mekan & Balkon/Teras & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Neo Pulpis serisi geniş renk kartelası ile her mekana uygun çözümler sunmakta</span>",
    "descriptionClean": "Neo Pulpis serisi geniş renk kartelası ile her mekana uygun çözümler sunmakta",
    "source": "duratiles"
  },
  {
    "id": "dura_1463",
    "brand": "Duratiles",
    "title": "NEO PULPIS Nero 60x120",
    "seriesName": "NEO PULPIS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "67318",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.037923449038062884.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.037923449038062884.jpg"
    ],
    "size": "60x120",
    "color": "Nero",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Neo Pulpis serisi geniş renk kartelası ile her mekana uygun çözümler sunmakta</span>",
    "descriptionClean": "Neo Pulpis serisi geniş renk kartelası ile her mekana uygun çözümler sunmakta",
    "source": "duratiles"
  },
  {
    "id": "dura_1464",
    "brand": "Duratiles",
    "title": "NEW HAZAR Beyaz 45x45",
    "seriesName": "NEW HAZAR",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1464",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.05763828951866545.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.05763828951866545.jpg"
    ],
    "size": "45x45",
    "color": "Beyaz",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Uygulandığı mekâna zengin ve zarif bir görünüm kazandıran New Hazar serisi ile özgün bir tasarımın mimarı olabilirsiniz.</span>",
    "descriptionClean": "Uygulandığı mekâna zengin ve zarif bir görünüm kazandıran New Hazar serisi ile özgün bir tasarımın mimarı olabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1465",
    "brand": "Duratiles",
    "title": "NEW MERMER Gri 60x60",
    "seriesName": "NEW MERMER",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1465",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6562375577834066.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6562375577834066.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Desenlerin uyumunu Bella Serisi ile evinize taşıyın. Bu uyumu hayatınızın her anına dâhil ederek sanatsal dokunuşların tarzınıza kattığı farkı hemen hissedeceksiniz.</span>",
    "descriptionClean": "Desenlerin uyumunu Bella Serisi ile evinize taşıyın. Bu uyumu hayatınızın her anına dâhil ederek sanatsal dokunuşların tarzınıza kattığı farkı hemen hissedeceksiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1466",
    "brand": "Duratiles",
    "title": "NILE Fildişi 30x60",
    "seriesName": "NILE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12208",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6562375577834066.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6562375577834066.jpg"
    ],
    "size": "30x60",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Nile Porselen Karoları hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor .</span>",
    "descriptionClean": "Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Nile Porselen Karoları hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor .",
    "source": "duratiles"
  },
  {
    "id": "dura_1467",
    "brand": "Duratiles",
    "title": "NILE Açık Gri 30x60",
    "seriesName": "NILE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12209",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20084441288998112.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20084441288998112.jpg"
    ],
    "size": "30x60",
    "color": "Açık Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Nile Porselen Karoları hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor .</span>",
    "descriptionClean": "Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Nile Porselen Karoları hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor .",
    "source": "duratiles"
  },
  {
    "id": "dura_1468",
    "brand": "Duratiles",
    "title": "NIVAL Nival 30x60",
    "seriesName": "NIVAL",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1468",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6671263280175026.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6671263280175026.jpg"
    ],
    "size": "30x60",
    "color": "Nival",
    "surface": "Mat, Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Şık tasarımı ve rengiyle Nival Porselen Karoları yaşam alanlarınıza zamansız bir şıklık getiriyor.</span>",
    "descriptionClean": "Şık tasarımı ve rengiyle Nival Porselen Karoları yaşam alanlarınıza zamansız bir şıklık getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1469",
    "brand": "Duratiles",
    "title": "NOLITA Nolita 60x120",
    "seriesName": "NOLITA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1469",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4737490270737341.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4737490270737341.jpg"
    ],
    "size": "60x120",
    "color": "Nolita",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Mekanlara farklı bir soluk ve dinamizm taşıyan Nolita Serisi etkileyici yaşam alanları tasarlerken stilinizi ortaya çıkarmanızı da sağlayacaktır.</span>",
    "descriptionClean": "Mekanlara farklı bir soluk ve dinamizm taşıyan Nolita Serisi etkileyici yaşam alanları tasarlerken stilinizi ortaya çıkarmanızı da sağlayacaktır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1470",
    "brand": "Duratiles",
    "title": "OROBICO Orobico 60x120",
    "seriesName": "OROBICO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1470",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7176605929701361.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7176605929701361.jpg"
    ],
    "size": "60x120",
    "color": "Orobico",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Orobico porselen karoları modern tasarım dilini yaşam alanlarınıza taşıyor</span>",
    "descriptionClean": "Orobico porselen karoları modern tasarım dilini yaşam alanlarınıza taşıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1471",
    "brand": "Duratiles",
    "title": "OXIDE Antrasit 90x180",
    "seriesName": "OXIDE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1471",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15697042186504961.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15697042186504961.jpg"
    ],
    "size": "90x180",
    "color": "Antrasit",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "V4"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaşam alanlarında kendi stillerini yaratmak isteyenler için Oxide serisi iddialı ürünleriyle farklı olmanın dekoratif yollarını sunuyor.</span>",
    "descriptionClean": "Yaşam alanlarında kendi stillerini yaratmak isteyenler için Oxide serisi iddialı ürünleriyle farklı olmanın dekoratif yollarını sunuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1472",
    "brand": "Duratiles",
    "title": "OXIDE Mavi 90x180",
    "seriesName": "OXIDE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1472",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3992630874891846.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3992630874891846.jpg"
    ],
    "size": "90x180",
    "color": "Mavi",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "V4"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaşam alanlarında kendi stillerini yaratmak isteyenler için Oxide serisi iddialı ürünleriyle farklı olmanın dekoratif yollarını sunuyor.</span>",
    "descriptionClean": "Yaşam alanlarında kendi stillerini yaratmak isteyenler için Oxide serisi iddialı ürünleriyle farklı olmanın dekoratif yollarını sunuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1473",
    "brand": "Duratiles",
    "title": "OXIDE Mavi 60x120",
    "seriesName": "OXIDE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "69404",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48852791778541027.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48852791778541027.jpg"
    ],
    "size": "60x120",
    "color": "Mavi",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "V4"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaşam alanlarında kendi stillerini yaratmak isteyenler için Oxide serisi iddialı ürünleriyle farklı olmanın dekoratif yollarını sunuyor.</span>",
    "descriptionClean": "Yaşam alanlarında kendi stillerini yaratmak isteyenler için Oxide serisi iddialı ürünleriyle farklı olmanın dekoratif yollarını sunuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1474",
    "brand": "Duratiles",
    "title": "OXIDE Antrasit 60x120",
    "seriesName": "OXIDE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "69406",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6896427477082745.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6896427477082745.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "V4"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaşam alanlarında kendi stillerini yaratmak isteyenler için Oxide serisi iddialı ürünleriyle farklı olmanın dekoratif yollarını sunuyor.</span>",
    "descriptionClean": "Yaşam alanlarında kendi stillerini yaratmak isteyenler için Oxide serisi iddialı ürünleriyle farklı olmanın dekoratif yollarını sunuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1475",
    "brand": "Duratiles",
    "title": "PASSION Fildişi 60x60",
    "seriesName": "PASSION",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1475",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3906857940927485.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3906857940927485.jpg"
    ],
    "size": "60x60",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Özel mekânlara karakter katan bir seri... Passion serisi ile yaşam alanlarınıza seramikten gelen güzelliği dâhil edin.</span>",
    "descriptionClean": "Özel mekânlara karakter katan bir seri... Passion serisi ile yaşam alanlarınıza seramikten gelen güzelliği dâhil edin.",
    "source": "duratiles"
  },
  {
    "id": "dura_1476",
    "brand": "Duratiles",
    "title": "PASSION Fildişi 30x60",
    "seriesName": "PASSION",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "70130",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7732563685455485.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7732563685455485.jpg"
    ],
    "size": "30x60",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Özel mekânlara karakter katan bir seri... Passion serisi ile yaşam alanlarınıza seramikten gelen güzelliği dâhil edin.</span>",
    "descriptionClean": "Özel mekânlara karakter katan bir seri... Passion serisi ile yaşam alanlarınıza seramikten gelen güzelliği dâhil edin.",
    "source": "duratiles"
  },
  {
    "id": "dura_1477",
    "brand": "Duratiles",
    "title": "PASSION Açık Gri 30x60",
    "seriesName": "PASSION",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "70131",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6527576478777787.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6527576478777787.jpg"
    ],
    "size": "30x60",
    "color": "Açık Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Özel mekânlara karakter katan bir seri... Passion serisi ile yaşam alanlarınıza seramikten gelen güzelliği dâhil edin.</span>",
    "descriptionClean": "Özel mekânlara karakter katan bir seri... Passion serisi ile yaşam alanlarınıza seramikten gelen güzelliği dâhil edin.",
    "source": "duratiles"
  },
  {
    "id": "dura_1478",
    "brand": "Duratiles",
    "title": "PATAGONIA Gri 60x120",
    "seriesName": "PATAGONIA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1478",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7564449263787653.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7564449263787653.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bookmatch serisinden Patagonia Porselen Karoları şık mermer görünümü ile sıradanlığa meydan okuyan tasarımlar yaratır.</span>",
    "descriptionClean": "Bookmatch serisinden Patagonia Porselen Karoları şık mermer görünümü ile sıradanlığa meydan okuyan tasarımlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1479",
    "brand": "Duratiles",
    "title": "PETRA Gri 60x120",
    "seriesName": "PETRA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1479",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7999165347501881.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7999165347501881.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Petra Serisi incelikli tasarım anlayışı ile ilham dolu ambiyanslar yaratmanıza olanak sağlar.</span>",
    "descriptionClean": "Petra Serisi incelikli tasarım anlayışı ile ilham dolu ambiyanslar yaratmanıza olanak sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_1480",
    "brand": "Duratiles",
    "title": "PHASELIS Phaselis 30x60",
    "seriesName": "PHASELIS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12210",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.948761501508839.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.948761501508839.jpg"
    ],
    "size": "30x60",
    "color": "Phaselis",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "V1"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer dokunun yarattığı buyuleyıcı bır etkı ile Phaselis Porselen Karoları mekanlara kaliteli bir görünüm ve katma değer katıyor .</span>",
    "descriptionClean": "Mermer dokunun yarattığı buyuleyıcı bır etkı ile Phaselis Porselen Karoları mekanlara kaliteli bir görünüm ve katma değer katıyor .",
    "source": "duratiles"
  },
  {
    "id": "dura_1481",
    "brand": "Duratiles",
    "title": "PIEDMONT Beyaz 100x100",
    "seriesName": "PIEDMONT",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12202",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09274644087218953.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09274644087218953.jpg"
    ],
    "size": "100x100",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Detayların fark yaratan harmonisini Piedmont serisi ile keşfedin.</span>",
    "descriptionClean": "Detayların fark yaratan harmonisini Piedmont serisi ile keşfedin.",
    "source": "duratiles"
  },
  {
    "id": "dura_1482",
    "brand": "Duratiles",
    "title": "POMPEI Geo Dekofon 40x120",
    "seriesName": "POMPEI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1482",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8063542372926165.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8063542372926165.jpg"
    ],
    "size": "40x120",
    "color": "Geo Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Hayatın dinamik akışından ilham alan tasarımıyla Pompei Serisi renkleri ve desenleriyle evinizin enerjisini yükseltiyor</span>",
    "descriptionClean": "Hayatın dinamik akışından ilham alan tasarımıyla Pompei Serisi renkleri ve desenleriyle evinizin enerjisini yükseltiyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1483",
    "brand": "Duratiles",
    "title": "POMPEI Bone 40x120",
    "seriesName": "POMPEI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1483",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3943204816227971.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3943204816227971.jpg"
    ],
    "size": "40x120",
    "color": "Bone",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Hayatın dinamik akışından ilham alan tasarımıyla Pompei Serisi renkleri ve desenleriyle evinizin enerjisini yükseltiyor</span>",
    "descriptionClean": "Hayatın dinamik akışından ilham alan tasarımıyla Pompei Serisi renkleri ve desenleriyle evinizin enerjisini yükseltiyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1484",
    "brand": "Duratiles",
    "title": "POMPEI Kahve 40x120",
    "seriesName": "POMPEI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1484",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2842873196792386.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2842873196792386.jpg"
    ],
    "size": "40x120",
    "color": "Kahve",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Hayatın dinamik akışından ilham alan tasarımıyla Pompei Serisi renkleri ve desenleriyle evinizin enerjisini yükseltiyor</span>",
    "descriptionClean": "Hayatın dinamik akışından ilham alan tasarımıyla Pompei Serisi renkleri ve desenleriyle evinizin enerjisini yükseltiyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1485",
    "brand": "Duratiles",
    "title": "POMPEI Bone 60x60",
    "seriesName": "POMPEI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1485",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.057554976343172526.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.057554976343172526.jpg"
    ],
    "size": "60x60",
    "color": "Bone",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Hayatın dinamik akışından ilham alan tasarımıyla Pompei Serisi renkleri ve desenleriyle evinizin enerjisini yükseltiyor</span>",
    "descriptionClean": "Hayatın dinamik akışından ilham alan tasarımıyla Pompei Serisi renkleri ve desenleriyle evinizin enerjisini yükseltiyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1486",
    "brand": "Duratiles",
    "title": "POMPEI Kahve 60x60",
    "seriesName": "POMPEI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1486",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.27655053170888333.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.27655053170888333.jpg"
    ],
    "size": "60x60",
    "color": "Kahve",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Hayatın dinamik akışından ilham alan tasarımıyla Pompei Serisi renkleri ve desenleriyle evinizin enerjisini yükseltiyor</span>",
    "descriptionClean": "Hayatın dinamik akışından ilham alan tasarımıyla Pompei Serisi renkleri ve desenleriyle evinizin enerjisini yükseltiyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1488",
    "brand": "Duratiles",
    "title": "PORTOFINO Night 60x120",
    "seriesName": "PORTOFINO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1488",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2507133400099564.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2507133400099564.jpg"
    ],
    "size": "60x120",
    "color": "Night",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Estetik tarzı ile mekanlara dinamizm katan Portofino Serisi dikkat çekici yaşam alanları tasarlar.</span>",
    "descriptionClean": "Estetik tarzı ile mekanlara dinamizm katan Portofino Serisi dikkat çekici yaşam alanları tasarlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_1487",
    "brand": "Duratiles",
    "title": "PORTOFINO Cloud 60x120",
    "seriesName": "PORTOFINO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1487",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2349072587153822.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2349072587153822.jpg"
    ],
    "size": "60x120",
    "color": "Cloud",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Estetik tarzı ile mekanlara dinamizm katan Portofino Serisi dikkat çekici yaşam alanları tasarlar.</span>",
    "descriptionClean": "Estetik tarzı ile mekanlara dinamizm katan Portofino Serisi dikkat çekici yaşam alanları tasarlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_1489",
    "brand": "Duratiles",
    "title": "PORTORO Siyah 60x120",
    "seriesName": "PORTORO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1489",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5142167028097311.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5142167028097311.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Portoro serisi siyah fon üzerinde sofistike detayları ile asil ve elegant bir tarzın mimarı oluyor.</span>",
    "descriptionClean": "Portoro serisi siyah fon üzerinde sofistike detayları ile asil ve elegant bir tarzın mimarı oluyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1490",
    "brand": "Duratiles",
    "title": "PORTORO Siyah 60x60",
    "seriesName": "PORTORO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "67242",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1872579718692703.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1872579718692703.jpg"
    ],
    "size": "60x60",
    "color": "Siyah",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Portoro serisi siyah fon üzerinde sofistike detayları ile asil ve elegant bir tarzın mimarı oluyor.</span>",
    "descriptionClean": "Portoro serisi siyah fon üzerinde sofistike detayları ile asil ve elegant bir tarzın mimarı oluyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1491",
    "brand": "Duratiles",
    "title": "PRAIA Carrara 60x120",
    "seriesName": "PRAIA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "63931",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5143932826948915.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5143932826948915.jpg"
    ],
    "size": "60x120",
    "color": "Carrara",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın şıklığı ile dingin mekanlar tasarlayan Praia porselen karoları zamansız yaşam alanları kurgular.</span>",
    "descriptionClean": "Yalın şıklığı ile dingin mekanlar tasarlayan Praia porselen karoları zamansız yaşam alanları kurgular.",
    "source": "duratiles"
  },
  {
    "id": "dura_1492",
    "brand": "Duratiles",
    "title": "PRAIA Beyaz 60x120",
    "seriesName": "PRAIA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "11743",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8558458468604171.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8558458468604171.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın şıklığı ile dingin mekanlar tasarlayan Praia porselen karoları zamansız yaşam alanları kurgular.</span>",
    "descriptionClean": "Yalın şıklığı ile dingin mekanlar tasarlayan Praia porselen karoları zamansız yaşam alanları kurgular.",
    "source": "duratiles"
  },
  {
    "id": "dura_1493",
    "brand": "Duratiles",
    "title": "PRAIA Krem 60x120",
    "seriesName": "PRAIA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "64919",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7825814609809686.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7825814609809686.jpg"
    ],
    "size": "60x120",
    "color": "Krem",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın şıklığı ile dingin mekanlar tasarlayan Praia porselen karoları zamansız yaşam alanları kurgular.</span>",
    "descriptionClean": "Yalın şıklığı ile dingin mekanlar tasarlayan Praia porselen karoları zamansız yaşam alanları kurgular.",
    "source": "duratiles"
  },
  {
    "id": "dura_1494",
    "brand": "Duratiles",
    "title": "PRAIA Gri 60x120",
    "seriesName": "PRAIA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "64917",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.26676539658593634.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.26676539658593634.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın şıklığı ile dingin mekanlar tasarlayan Praia porselen karoları zamansız yaşam alanları kurgular.</span>",
    "descriptionClean": "Yalın şıklığı ile dingin mekanlar tasarlayan Praia porselen karoları zamansız yaşam alanları kurgular.",
    "source": "duratiles"
  },
  {
    "id": "dura_1495",
    "brand": "Duratiles",
    "title": "PRAIA 20MM Krema 40x80",
    "seriesName": "PRAIA 20MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1495",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21900700087142444.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21900700087142444.jpg"
    ],
    "size": "40x80",
    "color": "Krema",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mat mermer dokusuna sahip olan Praia Porselen Karoları yaşam alanlarına modern bir dokunuş katıyor.</span>",
    "descriptionClean": "Mat mermer dokusuna sahip olan Praia Porselen Karoları yaşam alanlarına modern bir dokunuş katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1496",
    "brand": "Duratiles",
    "title": "PRAIA 20MM Carrara 60x60",
    "seriesName": "PRAIA 20MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "69916",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.42149372053998824.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.42149372053998824.jpg"
    ],
    "size": "60x60",
    "color": "Carrara",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mat mermer dokusuna sahip olan Praia Porselen Karoları yaşam alanlarına modern bir dokunuş katıyor.</span>",
    "descriptionClean": "Mat mermer dokusuna sahip olan Praia Porselen Karoları yaşam alanlarına modern bir dokunuş katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1497",
    "brand": "Duratiles",
    "title": "PRAIA 20MM Krema 60x60",
    "seriesName": "PRAIA 20MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "73382",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17367559648481234.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17367559648481234.jpg"
    ],
    "size": "60x60",
    "color": "Krema",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mat mermer dokusuna sahip olan Praia Porselen Karoları yaşam alanlarına modern bir dokunuş katıyor.</span>",
    "descriptionClean": "Mat mermer dokusuna sahip olan Praia Porselen Karoları yaşam alanlarına modern bir dokunuş katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1498",
    "brand": "Duratiles",
    "title": "PRAIA 20MM Gri 60x60",
    "seriesName": "PRAIA 20MM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "66074",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2021519487336355.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2021519487336355.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mat mermer dokusuna sahip olan Praia Porselen Karoları yaşam alanlarına modern bir dokunuş katıyor.</span>",
    "descriptionClean": "Mat mermer dokusuna sahip olan Praia Porselen Karoları yaşam alanlarına modern bir dokunuş katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1499",
    "brand": "Duratiles",
    "title": "PREMIUM MARBLE VISAGE Koyu Gri 60x120",
    "seriesName": "PREMIUM MARBLE VISAGE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "74400",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8670430628968117.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8670430628968117.jpg"
    ],
    "size": "60x120",
    "color": "Koyu Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Hayatın dinamik akışından ilham alan Premium Marble Visage porselen karoları konfordan ödün vermeyen tasarımlarıyla evinizin enerjisini yükseltir.</span>",
    "descriptionClean": "Hayatın dinamik akışından ilham alan Premium Marble Visage porselen karoları konfordan ödün vermeyen tasarımlarıyla evinizin enerjisini yükseltir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1500",
    "brand": "Duratiles",
    "title": "PREMIUM MARBLE VISAGE Altın 60x120",
    "seriesName": "PREMIUM MARBLE VISAGE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "74128",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8677636170260831.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8677636170260831.jpg"
    ],
    "size": "60x120",
    "color": "Altın",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Endüstriyel Zemin & Ticari Alanlar & Havuz & Balkon/Teras",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Hayatın dinamik akışından ilham alan Premium Marble Visage porselen karoları konfordan ödün vermeyen tasarımlarıyla evinizin enerjisini yükseltir.</span>",
    "descriptionClean": "Hayatın dinamik akışından ilham alan Premium Marble Visage porselen karoları konfordan ödün vermeyen tasarımlarıyla evinizin enerjisini yükseltir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1501",
    "brand": "Duratiles",
    "title": "PREMIUM MARBLE VISAGE Weiss 60x120",
    "seriesName": "PREMIUM MARBLE VISAGE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "74131",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.00911843847801741.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.00911843847801741.jpg"
    ],
    "size": "60x120",
    "color": "Weiss",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Endüstriyel Zemin & Ticari Alanlar & Balkon/Teras & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Balkon Teras",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Hayatın dinamik akışından ilham alan Premium Marble Visage porselen karoları konfordan ödün vermeyen tasarımlarıyla evinizin enerjisini yükseltir.</span>",
    "descriptionClean": "Hayatın dinamik akışından ilham alan Premium Marble Visage porselen karoları konfordan ödün vermeyen tasarımlarıyla evinizin enerjisini yükseltir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1502",
    "brand": "Duratiles",
    "title": "PULPIS Beyaz Dekofon 40x120",
    "seriesName": "PULPIS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1502",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3248904493904591.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3248904493904591.jpg"
    ],
    "size": "40x120",
    "color": "Beyaz Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tekdüze mekanlardan sıkılıyorsanız Pulpis Serisinin dinamik desen ve renkleri ile yaşam alanlarınızı canlandırabilirsiniz. Mermerin göz alıcı dokusunu desenlerine işleyen Pulpis Serisi , farklı ebat ve renk seçeneği ile her zevke ve mekana hitap etmekte</span>",
    "descriptionClean": "Tekdüze mekanlardan sıkılıyorsanız Pulpis Serisinin dinamik desen ve renkleri ile yaşam alanlarınızı canlandırabilirsiniz. Mermerin göz alıcı dokusunu desenlerine işleyen Pulpis Serisi , farklı ebat ve renk seçeneği ile her zevke ve mekana hitap etmekte",
    "source": "duratiles"
  },
  {
    "id": "dura_1503",
    "brand": "Duratiles",
    "title": "PULPIS Smoke Dekofon 40x120",
    "seriesName": "PULPIS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1503",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5520402269652019.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5520402269652019.jpg"
    ],
    "size": "40x120",
    "color": "Smoke Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tekdüze mekanlardan sıkılıyorsanız Pulpis Serisinin dinamik desen ve renkleri ile yaşam alanlarınızı canlandırabilirsiniz. Mermerin göz alıcı dokusunu desenlerine işleyen Pulpis Serisi , farklı ebat ve renk seçeneği ile her zevke ve mekana hitap etmekte</span>",
    "descriptionClean": "Tekdüze mekanlardan sıkılıyorsanız Pulpis Serisinin dinamik desen ve renkleri ile yaşam alanlarınızı canlandırabilirsiniz. Mermerin göz alıcı dokusunu desenlerine işleyen Pulpis Serisi , farklı ebat ve renk seçeneği ile her zevke ve mekana hitap etmekte",
    "source": "duratiles"
  },
  {
    "id": "dura_1504",
    "brand": "Duratiles",
    "title": "PULPIS Bej Patchwork Dekofon 40x120",
    "seriesName": "PULPIS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1504",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8926203525555568.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8926203525555568.jpg"
    ],
    "size": "40x120",
    "color": "Bej Patchwork Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tekdüze mekanlardan sıkılıyorsanız Pulpis Serisinin dinamik desen ve renkleri ile yaşam alanlarınızı canlandırabilirsiniz. Mermerin göz alıcı dokusunu desenlerine işleyen Pulpis Serisi , farklı ebat ve renk seçeneği ile her zevke ve mekana hitap etmekte</span>",
    "descriptionClean": "Tekdüze mekanlardan sıkılıyorsanız Pulpis Serisinin dinamik desen ve renkleri ile yaşam alanlarınızı canlandırabilirsiniz. Mermerin göz alıcı dokusunu desenlerine işleyen Pulpis Serisi , farklı ebat ve renk seçeneği ile her zevke ve mekana hitap etmekte",
    "source": "duratiles"
  },
  {
    "id": "dura_1505",
    "brand": "Duratiles",
    "title": "PULPIS Gri Patchwork Dekofon 40x120",
    "seriesName": "PULPIS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1505",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03487853763680182.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03487853763680182.jpg"
    ],
    "size": "40x120",
    "color": "Gri Patchwork Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tekdüze mekanlardan sıkılıyorsanız Pulpis Serisinin dinamik desen ve renkleri ile yaşam alanlarınızı canlandırabilirsiniz. Mermerin göz alıcı dokusunu desenlerine işleyen Pulpis Serisi , farklı ebat ve renk seçeneği ile her zevke ve mekana hitap etmekte</span>",
    "descriptionClean": "Tekdüze mekanlardan sıkılıyorsanız Pulpis Serisinin dinamik desen ve renkleri ile yaşam alanlarınızı canlandırabilirsiniz. Mermerin göz alıcı dokusunu desenlerine işleyen Pulpis Serisi , farklı ebat ve renk seçeneği ile her zevke ve mekana hitap etmekte",
    "source": "duratiles"
  },
  {
    "id": "dura_1506",
    "brand": "Duratiles",
    "title": "PULPIS Beyaz 40x120",
    "seriesName": "PULPIS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1506",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2245744266889116.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2245744266889116.jpg"
    ],
    "size": "40x120",
    "color": "Beyaz",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tekdüze mekanlardan sıkılıyorsanız Pulpis Serisinin dinamik desen ve renkleri ile yaşam alanlarınızı canlandırabilirsiniz. Mermerin göz alıcı dokusunu desenlerine işleyen Pulpis Serisi , farklı ebat ve renk seçeneği ile her zevke ve mekana hitap etmekte</span>",
    "descriptionClean": "Tekdüze mekanlardan sıkılıyorsanız Pulpis Serisinin dinamik desen ve renkleri ile yaşam alanlarınızı canlandırabilirsiniz. Mermerin göz alıcı dokusunu desenlerine işleyen Pulpis Serisi , farklı ebat ve renk seçeneği ile her zevke ve mekana hitap etmekte",
    "source": "duratiles"
  },
  {
    "id": "dura_1507",
    "brand": "Duratiles",
    "title": "PULPIS Smoke 40x120",
    "seriesName": "PULPIS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1507",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8014913782224676.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8014913782224676.jpg"
    ],
    "size": "40x120",
    "color": "Smoke",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tekdüze mekanlardan sıkılıyorsanız Pulpis Serisinin dinamik desen ve renkleri ile yaşam alanlarınızı canlandırabilirsiniz. Mermerin göz alıcı dokusunu desenlerine işleyen Pulpis Serisi , farklı ebat ve renk seçeneği ile her zevke ve mekana hitap etmekte</span>",
    "descriptionClean": "Tekdüze mekanlardan sıkılıyorsanız Pulpis Serisinin dinamik desen ve renkleri ile yaşam alanlarınızı canlandırabilirsiniz. Mermerin göz alıcı dokusunu desenlerine işleyen Pulpis Serisi , farklı ebat ve renk seçeneği ile her zevke ve mekana hitap etmekte",
    "source": "duratiles"
  },
  {
    "id": "dura_1508",
    "brand": "Duratiles",
    "title": "PULPIS Beyaz Dekofon 60x60",
    "seriesName": "PULPIS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1508",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7761825560021419.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7761825560021419.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tekdüze mekanlardan sıkılıyorsanız Pulpis Serisinin dinamik desen ve renkleri ile yaşam alanlarınızı canlandırabilirsiniz. Mermerin göz alıcı dokusunu desenlerine işleyen Pulpis Serisi , farklı ebat ve renk seçeneği ile her zevke ve mekana hitap etmekte</span>",
    "descriptionClean": "Tekdüze mekanlardan sıkılıyorsanız Pulpis Serisinin dinamik desen ve renkleri ile yaşam alanlarınızı canlandırabilirsiniz. Mermerin göz alıcı dokusunu desenlerine işleyen Pulpis Serisi , farklı ebat ve renk seçeneği ile her zevke ve mekana hitap etmekte",
    "source": "duratiles"
  },
  {
    "id": "dura_1509",
    "brand": "Duratiles",
    "title": "PULPIS Beyaz 60x60",
    "seriesName": "PULPIS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1509",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08261527061981411.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08261527061981411.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tekdüze mekanlardan sıkılıyorsanız Pulpis Serisinin dinamik desen ve renkleri ile yaşam alanlarınızı canlandırabilirsiniz. Mermerin göz alıcı dokusunu desenlerine işleyen Pulpis Serisi , farklı ebat ve renk seçeneği ile her zevke ve mekana hitap etmekte</span>",
    "descriptionClean": "Tekdüze mekanlardan sıkılıyorsanız Pulpis Serisinin dinamik desen ve renkleri ile yaşam alanlarınızı canlandırabilirsiniz. Mermerin göz alıcı dokusunu desenlerine işleyen Pulpis Serisi , farklı ebat ve renk seçeneği ile her zevke ve mekana hitap etmekte",
    "source": "duratiles"
  },
  {
    "id": "dura_1510",
    "brand": "Duratiles",
    "title": "PULPIS Smoke 60x60",
    "seriesName": "PULPIS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1510",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6321816976476486.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6321816976476486.jpg"
    ],
    "size": "60x60",
    "color": "Smoke",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tekdüze mekanlardan sıkılıyorsanız Pulpis Serisinin dinamik desen ve renkleri ile yaşam alanlarınızı canlandırabilirsiniz. Mermerin göz alıcı dokusunu desenlerine işleyen Pulpis Serisi , farklı ebat ve renk seçeneği ile her zevke ve mekana hitap etmekte</span>",
    "descriptionClean": "Tekdüze mekanlardan sıkılıyorsanız Pulpis Serisinin dinamik desen ve renkleri ile yaşam alanlarınızı canlandırabilirsiniz. Mermerin göz alıcı dokusunu desenlerine işleyen Pulpis Serisi , farklı ebat ve renk seçeneği ile her zevke ve mekana hitap etmekte",
    "source": "duratiles"
  },
  {
    "id": "dura_1511",
    "brand": "Duratiles",
    "title": "RAFAEL Bone 60x120",
    "seriesName": "RAFAEL",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1511",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8910370477804859.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8910370477804859.jpg"
    ],
    "size": "60x120",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal mermerin zarif dokusunu modern tasarımla buluşturan Rafael, yaşam alanlarına sofistike ve zamansız bir şıklık kazandırır.</span>",
    "descriptionClean": "Doğal mermerin zarif dokusunu modern tasarımla buluşturan Rafael, yaşam alanlarına sofistike ve zamansız bir şıklık kazandırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1512",
    "brand": "Duratiles",
    "title": "RAFAEL Gri 60x120",
    "seriesName": "RAFAEL",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1512",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4166347047786175.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4166347047786175.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal mermerin zarif dokusunu modern tasarımla buluşturan Rafael, yaşam alanlarına sofistike ve zamansız bir şıklık kazandırır.</span>",
    "descriptionClean": "Doğal mermerin zarif dokusunu modern tasarımla buluşturan Rafael, yaşam alanlarına sofistike ve zamansız bir şıklık kazandırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1513",
    "brand": "Duratiles",
    "title": "RAFAEL Antrasit 60x60",
    "seriesName": "RAFAEL",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1513",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6707291775514675.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6707291775514675.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal mermerin zarif dokusunu modern tasarımla buluşturan Rafael, yaşam alanlarına sofistike ve zamansız bir şıklık kazandırır.</span>",
    "descriptionClean": "Doğal mermerin zarif dokusunu modern tasarımla buluşturan Rafael, yaşam alanlarına sofistike ve zamansız bir şıklık kazandırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1514",
    "brand": "Duratiles",
    "title": "RAFAEL Bone 60x60",
    "seriesName": "RAFAEL",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1514",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6718965894557147.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6718965894557147.jpg"
    ],
    "size": "60x60",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal mermerin zarif dokusunu modern tasarımla buluşturan Rafael, yaşam alanlarına sofistike ve zamansız bir şıklık kazandırır.</span>",
    "descriptionClean": "Doğal mermerin zarif dokusunu modern tasarımla buluşturan Rafael, yaşam alanlarına sofistike ve zamansız bir şıklık kazandırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1515",
    "brand": "Duratiles",
    "title": "RAFAEL Gri 60x60",
    "seriesName": "RAFAEL",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1515",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8468660602667425.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8468660602667425.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal mermerin zarif dokusunu modern tasarımla buluşturan Rafael, yaşam alanlarına sofistike ve zamansız bir şıklık kazandırır.</span>",
    "descriptionClean": "Doğal mermerin zarif dokusunu modern tasarımla buluşturan Rafael, yaşam alanlarına sofistike ve zamansız bir şıklık kazandırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1516",
    "brand": "Duratiles",
    "title": "RAFAEL Beyaz 60x60",
    "seriesName": "RAFAEL",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1516",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22971824464131996.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22971824464131996.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal mermerin zarif dokusunu modern tasarımla buluşturan Rafael, yaşam alanlarına sofistike ve zamansız bir şıklık kazandırır.</span>",
    "descriptionClean": "Doğal mermerin zarif dokusunu modern tasarımla buluşturan Rafael, yaşam alanlarına sofistike ve zamansız bir şıklık kazandırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1517",
    "brand": "Duratiles",
    "title": "RAGUSA Oro 45x45",
    "seriesName": "RAGUSA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1517",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16773647617463427.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16773647617463427.jpg"
    ],
    "size": "45x45",
    "color": "Oro",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zarafetin en yalın tanımı Ragusa ... Sadeliği hayatının bir parçası haline getirenlere özel bir tasarım. Modern yaşamın yalın güzelliğini ortaya çıkarabilirsiniz</span>",
    "descriptionClean": "Zarafetin en yalın tanımı Ragusa ... Sadeliği hayatının bir parçası haline getirenlere özel bir tasarım. Modern yaşamın yalın güzelliğini ortaya çıkarabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_1518",
    "brand": "Duratiles",
    "title": "RAGUSA Oro 30x60",
    "seriesName": "RAGUSA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1518",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5062394940919808.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5062394940919808.jpg"
    ],
    "size": "30x60",
    "color": "Oro",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zarafetin en yalın tanımı Ragusa ... Sadeliği hayatının bir parçası haline getirenlere özel bir tasarım. Modern yaşamın yalın güzelliğini ortaya çıkarabilirsiniz</span>",
    "descriptionClean": "Zarafetin en yalın tanımı Ragusa ... Sadeliği hayatının bir parçası haline getirenlere özel bir tasarım. Modern yaşamın yalın güzelliğini ortaya çıkarabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_1519",
    "brand": "Duratiles",
    "title": "RAGUSA Ahşap Dekofon 30x60",
    "seriesName": "RAGUSA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1519",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8864056335644438.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8864056335644438.jpg"
    ],
    "size": "30x60",
    "color": "Ahşap Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zarafetin en yalın tanımı Ragusa ... Sadeliği hayatının bir parçası haline getirenlere özel bir tasarım. Modern yaşamın yalın güzelliğini ortaya çıkarabilirsiniz</span>",
    "descriptionClean": "Zarafetin en yalın tanımı Ragusa ... Sadeliği hayatının bir parçası haline getirenlere özel bir tasarım. Modern yaşamın yalın güzelliğini ortaya çıkarabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_1520",
    "brand": "Duratiles",
    "title": "RAUSA İce 30x60",
    "seriesName": "RAUSA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12211",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4546573575369258.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4546573575369258.jpg"
    ],
    "size": "30x60",
    "color": "İce",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2",
      "Banyo",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mat mermer dokusuyla güncel dekorasyon trendlerine cevap veren Rausa Porselen Karoları yalın şıklığını yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Mat mermer dokusuyla güncel dekorasyon trendlerine cevap veren Rausa Porselen Karoları yalın şıklığını yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1521",
    "brand": "Duratiles",
    "title": "RAUSA Krem 30x60",
    "seriesName": "RAUSA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12213",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.38533447336265647.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.38533447336265647.jpg"
    ],
    "size": "30x60",
    "color": "Krem",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Balkon/Teras & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2",
      "Banyo",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mat mermer dokusuyla güncel dekorasyon trendlerine cevap veren Rausa Porselen Karoları yalın şıklığını yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Mat mermer dokusuyla güncel dekorasyon trendlerine cevap veren Rausa Porselen Karoları yalın şıklığını yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1522",
    "brand": "Duratiles",
    "title": "RAUSA Taupe 30x60",
    "seriesName": "RAUSA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12212",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2919559909432845.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2919559909432845.jpg"
    ],
    "size": "30x60",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2",
      "Banyo",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mat mermer dokusuyla güncel dekorasyon trendlerine cevap veren Rausa Porselen Karoları yalın şıklığını yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Mat mermer dokusuyla güncel dekorasyon trendlerine cevap veren Rausa Porselen Karoları yalın şıklığını yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1523",
    "brand": "Duratiles",
    "title": "RAUSA Gri 30x60",
    "seriesName": "RAUSA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12214",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5291035992188873.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5291035992188873.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2",
      "Banyo",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mat mermer dokusuyla güncel dekorasyon trendlerine cevap veren Rausa Porselen Karoları yalın şıklığını yaşam alanlarına taşıyor.</span>",
    "descriptionClean": "Mat mermer dokusuyla güncel dekorasyon trendlerine cevap veren Rausa Porselen Karoları yalın şıklığını yaşam alanlarına taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1524",
    "brand": "Duratiles",
    "title": "RIMINI Grigio 60x60",
    "seriesName": "RIMINI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12214",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10771534179337783.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10771534179337783.jpg"
    ],
    "size": "60x60",
    "color": "Grigio",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naif deseni ve rengi ile romantik bir ambiyans ortaya koyan Rimini Serisi mermerin cazibesini yaşam alanlarınıza getiriyor.</span>",
    "descriptionClean": "Naif deseni ve rengi ile romantik bir ambiyans ortaya koyan Rimini Serisi mermerin cazibesini yaşam alanlarınıza getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1525",
    "brand": "Duratiles",
    "title": "RIVOLI Gri 60x60",
    "seriesName": "RIVOLI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1525",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6022168500897271.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6022168500897271.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tasarımda fark yaratan çizgileri ahenkle buluşturduk. Rivoli serisini sizler için özenle tasarladık. Sanatın kökenini oluşturan çizgisel yaklaşımın vücut bulmuş hali bu seride.</span>",
    "descriptionClean": "Tasarımda fark yaratan çizgileri ahenkle buluşturduk. Rivoli serisini sizler için özenle tasarladık. Sanatın kökenini oluşturan çizgisel yaklaşımın vücut bulmuş hali bu seride.",
    "source": "duratiles"
  },
  {
    "id": "dura_1526",
    "brand": "Duratiles",
    "title": "ROMA Vizon 60x120",
    "seriesName": "ROMA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1526",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.05781431834239037.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.05781431834239037.jpg"
    ],
    "size": "60x120",
    "color": "Vizon",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Dış Cephe & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Roma serisi kullanıcıları geniş ürün yelpazesi ile buluşturuyor</span>",
    "descriptionClean": "Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Roma serisi kullanıcıları geniş ürün yelpazesi ile buluşturuyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1527",
    "brand": "Duratiles",
    "title": "ROMA Siyah 60x120",
    "seriesName": "ROMA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1527",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6530975238739272.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6530975238739272.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Dış Cephe & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Roma serisi kullanıcıları geniş ürün yelpazesi ile buluşturuyor</span>",
    "descriptionClean": "Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Roma serisi kullanıcıları geniş ürün yelpazesi ile buluşturuyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1528",
    "brand": "Duratiles",
    "title": "ROMA Kahve 60x120",
    "seriesName": "ROMA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1528",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5769054727478565.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5769054727478565.jpg"
    ],
    "size": "60x120",
    "color": "Kahve",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Dış Cephe & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Roma serisi kullanıcıları geniş ürün yelpazesi ile buluşturuyor</span>",
    "descriptionClean": "Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Roma serisi kullanıcıları geniş ürün yelpazesi ile buluşturuyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1529",
    "brand": "Duratiles",
    "title": "ROMA Bone 60x120",
    "seriesName": "ROMA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1529",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.06539453347094748.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.06539453347094748.jpg"
    ],
    "size": "60x120",
    "color": "Bone",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Dış Cephe & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Roma serisi kullanıcıları geniş ürün yelpazesi ile buluşturuyor</span>",
    "descriptionClean": "Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Roma serisi kullanıcıları geniş ürün yelpazesi ile buluşturuyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1530",
    "brand": "Duratiles",
    "title": "ROMA Gri 60x120",
    "seriesName": "ROMA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1530",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28302070523292877.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28302070523292877.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Dış Cephe & Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Dış Cephe",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Roma serisi kullanıcıları geniş ürün yelpazesi ile buluşturuyor</span>",
    "descriptionClean": "Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Roma serisi kullanıcıları geniş ürün yelpazesi ile buluşturuyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1531",
    "brand": "Duratiles",
    "title": "ROMA Bej 60x120",
    "seriesName": "ROMA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1531",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8919714375254608.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8919714375254608.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Dış Cephe & Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Dış Cephe",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Roma serisi kullanıcıları geniş ürün yelpazesi ile buluşturuyor</span>",
    "descriptionClean": "Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Roma serisi kullanıcıları geniş ürün yelpazesi ile buluşturuyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1532",
    "brand": "Duratiles",
    "title": "ROUD Beyaz 60x120",
    "seriesName": "ROUD",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "75441",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16145961320301205.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16145961320301205.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Ticari Alanlar & Balkon/Teras",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo",
      "Ticari Alanlar",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Roud Porselen Karoları özgün ve çarpıcı mekanlara imza atmanıza olanak sağlar.</span>",
    "descriptionClean": "Roud Porselen Karoları özgün ve çarpıcı mekanlara imza atmanıza olanak sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_1533",
    "brand": "Duratiles",
    "title": "ROUD Siyah 60x120",
    "seriesName": "ROUD",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1533",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.41117989862746207.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.41117989862746207.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Ticari Alanlar & Balkon/Teras",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo",
      "Ticari Alanlar",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Roud Porselen Karoları özgün ve çarpıcı mekanlara imza atmanıza olanak sağlar.</span>",
    "descriptionClean": "Roud Porselen Karoları özgün ve çarpıcı mekanlara imza atmanıza olanak sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_1534",
    "brand": "Duratiles",
    "title": "SAHARA Beyaz 60x120",
    "seriesName": "SAHARA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1534",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2231494606096972.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2231494606096972.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermerin en doğal halini seramikle buluşturan Sahara serisi ile mekanlarınıza aydınlık ve modern bir hava katabilirsiniz.</span>",
    "descriptionClean": "Mermerin en doğal halini seramikle buluşturan Sahara serisi ile mekanlarınıza aydınlık ve modern bir hava katabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1536",
    "brand": "Duratiles",
    "title": "SAND DUNE Kahverengi 60x120",
    "seriesName": "SAND DUNE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1536",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.060923138622852036.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.060923138622852036.jpg"
    ],
    "size": "60x120",
    "color": "Kahverengi",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Balkon/Teras & Dış Cephe & Ev içi Zemin & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">10 mm kalınlığıyla sağlamlığını hissettiren Sand Dune, mermerin doğal dokusunu modern yüzeylere taşır.</span>",
    "descriptionClean": "10 mm kalınlığıyla sağlamlığını hissettiren Sand Dune, mermerin doğal dokusunu modern yüzeylere taşır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1535",
    "brand": "Duratiles",
    "title": "SAND DUNE Orjinal 60x120",
    "seriesName": "SAND DUNE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1535",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5225565905031136.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5225565905031136.jpg"
    ],
    "size": "60x120",
    "color": "Orjinal",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Balkon/Teras & Dış Cephe & Ev içi Zemin & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">10 mm kalınlığıyla sağlamlığını hissettiren Sand Dune, mermerin doğal dokusunu modern yüzeylere taşır.</span>",
    "descriptionClean": "10 mm kalınlığıyla sağlamlığını hissettiren Sand Dune, mermerin doğal dokusunu modern yüzeylere taşır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1537",
    "brand": "Duratiles",
    "title": "SANDY Bej 60x60",
    "seriesName": "SANDY",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1537",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6284795006406588.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6284795006406588.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Dayanıklı yapısı sayesinde zamanın yıpratamadığı Sand Serisi ile mekanlar hep göz alıcı ve şık</span>",
    "descriptionClean": "Dayanıklı yapısı sayesinde zamanın yıpratamadığı Sand Serisi ile mekanlar hep göz alıcı ve şık",
    "source": "duratiles"
  },
  {
    "id": "dura_1538",
    "brand": "Duratiles",
    "title": "SANDY Vizon 60x60",
    "seriesName": "SANDY",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1538",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3656459985760314.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3656459985760314.jpg"
    ],
    "size": "60x60",
    "color": "Vizon",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Dayanıklı yapısı sayesinde zamanın yıpratamadığı Sand Serisi ile mekanlar hep göz alıcı ve şık</span>",
    "descriptionClean": "Dayanıklı yapısı sayesinde zamanın yıpratamadığı Sand Serisi ile mekanlar hep göz alıcı ve şık",
    "source": "duratiles"
  },
  {
    "id": "dura_1539",
    "brand": "Duratiles",
    "title": "SANDY Taupe 60x60",
    "seriesName": "SANDY",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1539",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21385917615036865.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21385917615036865.jpg"
    ],
    "size": "60x60",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Dayanıklı yapısı sayesinde zamanın yıpratamadığı Sand Serisi ile mekanlar hep göz alıcı ve şık</span>",
    "descriptionClean": "Dayanıklı yapısı sayesinde zamanın yıpratamadığı Sand Serisi ile mekanlar hep göz alıcı ve şık",
    "source": "duratiles"
  },
  {
    "id": "dura_1540",
    "brand": "Duratiles",
    "title": "SANDY Bej 30x60",
    "seriesName": "SANDY",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1540",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22403367397177743.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22403367397177743.jpg"
    ],
    "size": "30x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Dayanıklı yapısı sayesinde zamanın yıpratamadığı Sand Serisi ile mekanlar hep göz alıcı ve şık</span>",
    "descriptionClean": "Dayanıklı yapısı sayesinde zamanın yıpratamadığı Sand Serisi ile mekanlar hep göz alıcı ve şık",
    "source": "duratiles"
  },
  {
    "id": "dura_1541",
    "brand": "Duratiles",
    "title": "SANDY Vizon 30x60",
    "seriesName": "SANDY",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1541",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5917064001291706.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5917064001291706.jpg"
    ],
    "size": "30x60",
    "color": "Vizon",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Dayanıklı yapısı sayesinde zamanın yıpratamadığı Sand Serisi ile mekanlar hep göz alıcı ve şık</span>",
    "descriptionClean": "Dayanıklı yapısı sayesinde zamanın yıpratamadığı Sand Serisi ile mekanlar hep göz alıcı ve şık",
    "source": "duratiles"
  },
  {
    "id": "dura_1542",
    "brand": "Duratiles",
    "title": "SANTORINI Gri 60x120",
    "seriesName": "SANTORINI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "67247",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3653167037562487.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3653167037562487.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer dokusunun tüm ihtişamını seramik konforuyla harmanlayan Santorini Serisi mekanlarınıza kaliteyi konfor ve estetikle beraber getiriyor.</span>",
    "descriptionClean": "Mermer dokusunun tüm ihtişamını seramik konforuyla harmanlayan Santorini Serisi mekanlarınıza kaliteyi konfor ve estetikle beraber getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1543",
    "brand": "Duratiles",
    "title": "SANTORINI Bone 60x120",
    "seriesName": "SANTORINI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1543",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8352130488539661.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8352130488539661.jpg"
    ],
    "size": "60x120",
    "color": "Bone",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer dokusunun tüm ihtişamını seramik konforuyla harmanlayan Santorini Serisi mekanlarınıza kaliteyi konfor ve estetikle beraber getiriyor.</span>",
    "descriptionClean": "Mermer dokusunun tüm ihtişamını seramik konforuyla harmanlayan Santorini Serisi mekanlarınıza kaliteyi konfor ve estetikle beraber getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1544",
    "brand": "Duratiles",
    "title": "SANTORINI Blanco 60x120",
    "seriesName": "SANTORINI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1544",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6623630680933619.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6623630680933619.jpg"
    ],
    "size": "60x120",
    "color": "Blanco",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer dokusunun tüm ihtişamını seramik konforuyla harmanlayan Santorini Serisi mekanlarınıza kaliteyi konfor ve estetikle beraber getiriyor.</span>",
    "descriptionClean": "Mermer dokusunun tüm ihtişamını seramik konforuyla harmanlayan Santorini Serisi mekanlarınıza kaliteyi konfor ve estetikle beraber getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1547",
    "brand": "Duratiles",
    "title": "SANTORINI Gri 60x60",
    "seriesName": "SANTORINI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1547",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4471549784868093.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4471549784868093.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer dokusunun tüm ihtişamını seramik konforuyla harmanlayan Santorini Serisi mekanlarınıza kaliteyi konfor ve estetikle beraber getiriyor.</span>",
    "descriptionClean": "Mermer dokusunun tüm ihtişamını seramik konforuyla harmanlayan Santorini Serisi mekanlarınıza kaliteyi konfor ve estetikle beraber getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1545",
    "brand": "Duratiles",
    "title": "SANTORINI Bone 60x60",
    "seriesName": "SANTORINI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1545",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08984952198894647.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08984952198894647.jpg"
    ],
    "size": "60x60",
    "color": "Bone",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer dokusunun tüm ihtişamını seramik konforuyla harmanlayan Santorini Serisi mekanlarınıza kaliteyi konfor ve estetikle beraber getiriyor.</span>",
    "descriptionClean": "Mermer dokusunun tüm ihtişamını seramik konforuyla harmanlayan Santorini Serisi mekanlarınıza kaliteyi konfor ve estetikle beraber getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1546",
    "brand": "Duratiles",
    "title": "SANTORINI Bianco 60x60",
    "seriesName": "SANTORINI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1546",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6917206121216123.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6917206121216123.jpg"
    ],
    "size": "60x60",
    "color": "Bianco",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer dokusunun tüm ihtişamını seramik konforuyla harmanlayan Santorini Serisi mekanlarınıza kaliteyi konfor ve estetikle beraber getiriyor.</span>",
    "descriptionClean": "Mermer dokusunun tüm ihtişamını seramik konforuyla harmanlayan Santorini Serisi mekanlarınıza kaliteyi konfor ve estetikle beraber getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1548",
    "brand": "Duratiles",
    "title": "SARDA Krem 45x45",
    "seriesName": "SARDA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1548",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.35426373494058205.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.35426373494058205.jpg"
    ],
    "size": "45x45",
    "color": "Krem",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sarda Serisinin üç farklı deseni ile mekanlara dinamizm katıp evlerinizin enerjisini yükseltebilirsiniz.</span>",
    "descriptionClean": "Sarda Serisinin üç farklı deseni ile mekanlara dinamizm katıp evlerinizin enerjisini yükseltebilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1549",
    "brand": "Duratiles",
    "title": "SARDA Krem 30x60",
    "seriesName": "SARDA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1549",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7212888674981726.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7212888674981726.jpg"
    ],
    "size": "30x60",
    "color": "Krem",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sarda Serisinin üç farklı deseni ile mekanlara dinamizm katıp evlerinizin enerjisini yükseltebilirsiniz.</span>",
    "descriptionClean": "Sarda Serisinin üç farklı deseni ile mekanlara dinamizm katıp evlerinizin enerjisini yükseltebilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1550",
    "brand": "Duratiles",
    "title": "SARDA Chocolate 30x60",
    "seriesName": "SARDA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1550",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8757681856610389.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8757681856610389.jpg"
    ],
    "size": "30x60",
    "color": "Chocolate",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sarda Serisinin üç farklı deseni ile mekanlara dinamizm katıp evlerinizin enerjisini yükseltebilirsiniz.</span>",
    "descriptionClean": "Sarda Serisinin üç farklı deseni ile mekanlara dinamizm katıp evlerinizin enerjisini yükseltebilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1551",
    "brand": "Duratiles",
    "title": "SARDA Krem Line Dekofon 30x60",
    "seriesName": "SARDA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1551",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8612563037010855.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8612563037010855.jpg"
    ],
    "size": "30x60",
    "color": "Krem Line Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sarda Serisinin üç farklı deseni ile mekanlara dinamizm katıp evlerinizin enerjisini yükseltebilirsiniz.</span>",
    "descriptionClean": "Sarda Serisinin üç farklı deseni ile mekanlara dinamizm katıp evlerinizin enerjisini yükseltebilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1552",
    "brand": "Duratiles",
    "title": "SARDA Chocolate Line Dekofon 30x60",
    "seriesName": "SARDA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1552",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12425847313597471.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12425847313597471.jpg"
    ],
    "size": "30x60",
    "color": "Chocolate Line Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sarda Serisinin üç farklı deseni ile mekanlara dinamizm katıp evlerinizin enerjisini yükseltebilirsiniz.</span>",
    "descriptionClean": "Sarda Serisinin üç farklı deseni ile mekanlara dinamizm katıp evlerinizin enerjisini yükseltebilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1553",
    "brand": "Duratiles",
    "title": "SARDA Krem Swing Dekofon 30x60",
    "seriesName": "SARDA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1553",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.25995998855453495.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.25995998855453495.jpg"
    ],
    "size": "30x60",
    "color": "Krem Swing Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sarda Serisinin üç farklı deseni ile mekanlara dinamizm katıp evlerinizin enerjisini yükseltebilirsiniz.</span>",
    "descriptionClean": "Sarda Serisinin üç farklı deseni ile mekanlara dinamizm katıp evlerinizin enerjisini yükseltebilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1559",
    "brand": "Duratiles",
    "title": "SARDES Açık Mavi 45x45",
    "seriesName": "SARDES",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1559",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.91998272536561.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.91998272536561.jpg"
    ],
    "size": "45x45",
    "color": "Açık Mavi",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V4"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dekorasyonunuzu tamamlayan, dokusu ile fark yaratan Sardes serisi maximum konforu hedefleyen evler tasarlar</span>",
    "descriptionClean": "Dekorasyonunuzu tamamlayan, dokusu ile fark yaratan Sardes serisi maximum konforu hedefleyen evler tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_1558",
    "brand": "Duratiles",
    "title": "SARDES Mix Dekofon 30x75",
    "seriesName": "SARDES",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1558",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8632463029606724.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8632463029606724.jpg"
    ],
    "size": "30x75",
    "color": "Mix Dekofon",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo",
    "technology": "Dekofon",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dekorasyonunuzu tamamlayan, dokusu ile fark yaratan Sardes serisi maximum konforu hedefleyen evler tasarlar</span>",
    "descriptionClean": "Dekorasyonunuzu tamamlayan, dokusu ile fark yaratan Sardes serisi maximum konforu hedefleyen evler tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_1557",
    "brand": "Duratiles",
    "title": "SARDES Antrasit 30x75",
    "seriesName": "SARDES",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1557",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2669105751699916.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2669105751699916.jpg"
    ],
    "size": "30x75",
    "color": "Antrasit",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo",
    "technology": "Duvar Karosu",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dekorasyonunuzu tamamlayan, dokusu ile fark yaratan Sardes serisi maximum konforu hedefleyen evler tasarlar</span>",
    "descriptionClean": "Dekorasyonunuzu tamamlayan, dokusu ile fark yaratan Sardes serisi maximum konforu hedefleyen evler tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_1556",
    "brand": "Duratiles",
    "title": "SARDES Gri 30x75",
    "seriesName": "SARDES",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1556",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.31011986359284116.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.31011986359284116.jpg"
    ],
    "size": "30x75",
    "color": "Gri",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo",
    "technology": "Duvar Karosu",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dekorasyonunuzu tamamlayan, dokusu ile fark yaratan Sardes serisi maximum konforu hedefleyen evler tasarlar</span>",
    "descriptionClean": "Dekorasyonunuzu tamamlayan, dokusu ile fark yaratan Sardes serisi maximum konforu hedefleyen evler tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_1555",
    "brand": "Duratiles",
    "title": "SARDES Koyu Mavi 30x75",
    "seriesName": "SARDES",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1555",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.142937824555734.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.142937824555734.jpg"
    ],
    "size": "30x75",
    "color": "Koyu Mavi",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo",
    "technology": "Duvar Karosu",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dekorasyonunuzu tamamlayan, dokusu ile fark yaratan Sardes serisi maximum konforu hedefleyen evler tasarlar</span>",
    "descriptionClean": "Dekorasyonunuzu tamamlayan, dokusu ile fark yaratan Sardes serisi maximum konforu hedefleyen evler tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_1554",
    "brand": "Duratiles",
    "title": "SARDES Açık Mavi 30x75",
    "seriesName": "SARDES",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1554",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6096131833933638.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6096131833933638.jpg"
    ],
    "size": "30x75",
    "color": "Açık Mavi",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo",
    "technology": "Duvar Karosu",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dekorasyonunuzu tamamlayan, dokusu ile fark yaratan Sardes serisi maximum konforu hedefleyen evler tasarlar</span>",
    "descriptionClean": "Dekorasyonunuzu tamamlayan, dokusu ile fark yaratan Sardes serisi maximum konforu hedefleyen evler tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_1560",
    "brand": "Duratiles",
    "title": "SERENDRA Luna 80x80",
    "seriesName": "SERENDRA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "11724",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9531925037105864.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9531925037105864.jpg"
    ],
    "size": "80x80",
    "color": "Luna",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermerin çekiciliğini bütün görkemiyle yaşatan Serendra serisi Luna,Mila ve Zara seçenekleriyle yaşam alanlarında fark yaratır.</span>",
    "descriptionClean": "Mermerin çekiciliğini bütün görkemiyle yaşatan Serendra serisi Luna,Mila ve Zara seçenekleriyle yaşam alanlarında fark yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1561",
    "brand": "Duratiles",
    "title": "SERENDRA Zara 80x80",
    "seriesName": "SERENDRA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "11729",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8299296368811702.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8299296368811702.jpg"
    ],
    "size": "80x80",
    "color": "Zara",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermerin çekiciliğini bütün görkemiyle yaşatan Serendra serisi Luna,Mila ve Zara seçenekleriyle yaşam alanlarında fark yaratır.</span>",
    "descriptionClean": "Mermerin çekiciliğini bütün görkemiyle yaşatan Serendra serisi Luna,Mila ve Zara seçenekleriyle yaşam alanlarında fark yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1562",
    "brand": "Duratiles",
    "title": "SERENDRA Mila 80x80",
    "seriesName": "SERENDRA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "11727",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.026217241241303757.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.026217241241303757.jpg"
    ],
    "size": "80x80",
    "color": "Mila",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermerin çekiciliğini bütün görkemiyle yaşatan Serendra serisi Luna,Mila ve Zara seçenekleriyle yaşam alanlarında fark yaratır.</span>",
    "descriptionClean": "Mermerin çekiciliğini bütün görkemiyle yaşatan Serendra serisi Luna,Mila ve Zara seçenekleriyle yaşam alanlarında fark yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1563",
    "brand": "Duratiles",
    "title": "SHADE PLUS Shadow 60x90",
    "seriesName": "SHADE PLUS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1563",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15939867219702852.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15939867219702852.jpg"
    ],
    "size": "60x90",
    "color": "Shadow",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Shade Plus Porselen Karoları ...</span>",
    "descriptionClean": "Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Shade Plus Porselen Karoları ...",
    "source": "duratiles"
  },
  {
    "id": "dura_1564",
    "brand": "Duratiles",
    "title": "SHADE PLUS Gri 60x90",
    "seriesName": "SHADE PLUS",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1564",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8840307948261528.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8840307948261528.jpg"
    ],
    "size": "60x90",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Shade Plus Porselen Karoları ...</span>",
    "descriptionClean": "Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Shade Plus Porselen Karoları ...",
    "source": "duratiles"
  },
  {
    "id": "dura_1565",
    "brand": "Duratiles",
    "title": "SIENA Beyaz 30x75",
    "seriesName": "SIENA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1565",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.935308720785915.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.935308720785915.jpg"
    ],
    "size": "30x75",
    "color": "Beyaz",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo",
    "technology": "Duvar Karosu",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Siena serisinin modern tarzı ile mekanlara tarz katabilir şık dekofon seçeneği sayesinde yaşam alanlarınızın enerjisini yükseltebilirsiniz.</span>",
    "descriptionClean": "Siena serisinin modern tarzı ile mekanlara tarz katabilir şık dekofon seçeneği sayesinde yaşam alanlarınızın enerjisini yükseltebilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1566",
    "brand": "Duratiles",
    "title": "SIENA Beyaz Dekofon 30x75",
    "seriesName": "SIENA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1566",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13482275824570522.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13482275824570522.jpg"
    ],
    "size": "30x75",
    "color": "Beyaz Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo",
    "technology": "Duvar Karosu",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Siena serisinin modern tarzı ile mekanlara tarz katabilir şık dekofon seçeneği sayesinde yaşam alanlarınızın enerjisini yükseltebilirsiniz.</span>",
    "descriptionClean": "Siena serisinin modern tarzı ile mekanlara tarz katabilir şık dekofon seçeneği sayesinde yaşam alanlarınızın enerjisini yükseltebilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1567",
    "brand": "Duratiles",
    "title": "SILVER Gri 60x120",
    "seriesName": "SILVER",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1567",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5647000499856294.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5647000499856294.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Balkon/Teras & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">İddialı ve göz alıcı mekanlar için tasarlanan Silver Serisi dayanıklı ve bir o kadar fonksiyonel.</span>",
    "descriptionClean": "İddialı ve göz alıcı mekanlar için tasarlanan Silver Serisi dayanıklı ve bir o kadar fonksiyonel.",
    "source": "duratiles"
  },
  {
    "id": "dura_1568",
    "brand": "Duratiles",
    "title": "SILVER Gri 60x60",
    "seriesName": "SILVER",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1568",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8406767467586278.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8406767467586278.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Balkon/Teras & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">İddialı ve göz alıcı mekanlar için tasarlanan Silver Serisi dayanıklı ve bir o kadar fonksiyonel.</span>",
    "descriptionClean": "İddialı ve göz alıcı mekanlar için tasarlanan Silver Serisi dayanıklı ve bir o kadar fonksiyonel.",
    "source": "duratiles"
  },
  {
    "id": "dura_1569",
    "brand": "Duratiles",
    "title": "SMART Fildişi 60x120",
    "seriesName": "SMART",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1569",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.41340811784225373.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.41340811784225373.jpg"
    ],
    "size": "60x120",
    "color": "Fildişi",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Smart Serisi yalın güzelliği ile yaşam alanlarınıza kolayca uyum sağlarken şıklığı ve estetiği beraberinde getiriyor.</span>",
    "descriptionClean": "Smart Serisi yalın güzelliği ile yaşam alanlarınıza kolayca uyum sağlarken şıklığı ve estetiği beraberinde getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1570",
    "brand": "Duratiles",
    "title": "SMART Gri 60x120",
    "seriesName": "SMART",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1570",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17634002884940292.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17634002884940292.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Smart Serisi yalın güzelliği ile yaşam alanlarınıza kolayca uyum sağlarken şıklığı ve estetiği beraberinde getiriyor.</span>",
    "descriptionClean": "Smart Serisi yalın güzelliği ile yaşam alanlarınıza kolayca uyum sağlarken şıklığı ve estetiği beraberinde getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1571",
    "brand": "Duratiles",
    "title": "SOCHI Açık Gri 60x120",
    "seriesName": "SOCHI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1571",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8640313864462483.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8640313864462483.jpg"
    ],
    "size": "60x120",
    "color": "Açık Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Smart Serisi yalın güzelliği ile yaşam alanlarınıza kolayca uyum sağlarken şıklığı ve estetiği beraberinde getiriyor.</span>",
    "descriptionClean": "Smart Serisi yalın güzelliği ile yaşam alanlarınıza kolayca uyum sağlarken şıklığı ve estetiği beraberinde getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1572",
    "brand": "Duratiles",
    "title": "SOCHI Gri 60x120",
    "seriesName": "SOCHI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1572",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.745742000168756.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.745742000168756.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Smart Serisi yalın güzelliği ile yaşam alanlarınıza kolayca uyum sağlarken şıklığı ve estetiği beraberinde getiriyor.</span>",
    "descriptionClean": "Smart Serisi yalın güzelliği ile yaşam alanlarınıza kolayca uyum sağlarken şıklığı ve estetiği beraberinde getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1573",
    "brand": "Duratiles",
    "title": "SOCHI Bej 60x120",
    "seriesName": "SOCHI",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1573",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08960121365442231.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08960121365442231.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Smart Serisi yalın güzelliği ile yaşam alanlarınıza kolayca uyum sağlarken şıklığı ve estetiği beraberinde getiriyor.</span>",
    "descriptionClean": "Smart Serisi yalın güzelliği ile yaşam alanlarınıza kolayca uyum sağlarken şıklığı ve estetiği beraberinde getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1574",
    "brand": "Duratiles",
    "title": "STATUARIO Statuario 60x120",
    "seriesName": "STATUARIO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "67260",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6169758521801945.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6169758521801945.jpg"
    ],
    "size": "60x120",
    "color": "Statuario",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermerin klasik güzelliğini Statuario serisi ile yaşam alanlarınıza taşıyabilir ,sofistike bir dizayn oluşturabilirsiniz</span>",
    "descriptionClean": "Mermerin klasik güzelliğini Statuario serisi ile yaşam alanlarınıza taşıyabilir ,sofistike bir dizayn oluşturabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_1575",
    "brand": "Duratiles",
    "title": "STATUARIO Beyaz 40x120",
    "seriesName": "STATUARIO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1575",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8453629460954862.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8453629460954862.jpg"
    ],
    "size": "40x120",
    "color": "Beyaz",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermerin klasik güzelliğini Statuario serisi ile yaşam alanlarınıza taşıyabilir ,sofistike bir dizayn oluşturabilirsiniz</span>",
    "descriptionClean": "Mermerin klasik güzelliğini Statuario serisi ile yaşam alanlarınıza taşıyabilir ,sofistike bir dizayn oluşturabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_1576",
    "brand": "Duratiles",
    "title": "STATUARIO Beyaz Dekofon 40x120",
    "seriesName": "STATUARIO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1576",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5987198189214159.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5987198189214159.jpg"
    ],
    "size": "40x120",
    "color": "Beyaz Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermerin klasik güzelliğini Statuario serisi ile yaşam alanlarınıza taşıyabilir ,sofistike bir dizayn oluşturabilirsiniz</span>",
    "descriptionClean": "Mermerin klasik güzelliğini Statuario serisi ile yaşam alanlarınıza taşıyabilir ,sofistike bir dizayn oluşturabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_1577",
    "brand": "Duratiles",
    "title": "STATUARIO Beyaz 60x60",
    "seriesName": "STATUARIO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1577",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5193102089063205.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5193102089063205.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermerin klasik güzelliğini Statuario serisi ile yaşam alanlarınıza taşıyabilir ,sofistike bir dizayn oluşturabilirsiniz</span>",
    "descriptionClean": "Mermerin klasik güzelliğini Statuario serisi ile yaşam alanlarınıza taşıyabilir ,sofistike bir dizayn oluşturabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_1578",
    "brand": "Duratiles",
    "title": "STELLA Siyah 30x75",
    "seriesName": "STELLA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1578",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.662998345458774.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.662998345458774.jpg"
    ],
    "size": "30x75",
    "color": "Siyah",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo",
    "technology": "Duvar Karosu",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tasarımında ki farklı yaklaşım ile canlı renklerin ve desenlerin buluştuğu Stella serisi yaşam alanlarında değişime öncülük ediyor.</span>",
    "descriptionClean": "Tasarımında ki farklı yaklaşım ile canlı renklerin ve desenlerin buluştuğu Stella serisi yaşam alanlarında değişime öncülük ediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1579",
    "brand": "Duratiles",
    "title": "STELLA Açık Gri 30x75",
    "seriesName": "STELLA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1579",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48868581672470723.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48868581672470723.jpg"
    ],
    "size": "30x75",
    "color": "Açık Gri",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo",
    "technology": "Duvar Karosu",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tasarımında ki farklı yaklaşım ile canlı renklerin ve desenlerin buluştuğu Stella serisi yaşam alanlarında değişime öncülük ediyor.</span>",
    "descriptionClean": "Tasarımında ki farklı yaklaşım ile canlı renklerin ve desenlerin buluştuğu Stella serisi yaşam alanlarında değişime öncülük ediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1580",
    "brand": "Duratiles",
    "title": "STELLA Siyah Dekofon 30x75",
    "seriesName": "STELLA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1580",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9162332109097644.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9162332109097644.jpg"
    ],
    "size": "30x75",
    "color": "Siyah Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo",
    "technology": "Duvar Karosu",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tasarımında ki farklı yaklaşım ile canlı renklerin ve desenlerin buluştuğu Stella serisi yaşam alanlarında değişime öncülük ediyor.</span>",
    "descriptionClean": "Tasarımında ki farklı yaklaşım ile canlı renklerin ve desenlerin buluştuğu Stella serisi yaşam alanlarında değişime öncülük ediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1581",
    "brand": "Duratiles",
    "title": "STELLA Mix Dekor 30x75",
    "seriesName": "STELLA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1581",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.383791680368872.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.383791680368872.jpg"
    ],
    "size": "30x75",
    "color": "Mix Dekor",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo",
    "technology": "Duvar Karosu",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tasarımında ki farklı yaklaşım ile canlı renklerin ve desenlerin buluştuğu Stella serisi yaşam alanlarında değişime öncülük ediyor.</span>",
    "descriptionClean": "Tasarımında ki farklı yaklaşım ile canlı renklerin ve desenlerin buluştuğu Stella serisi yaşam alanlarında değişime öncülük ediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1582",
    "brand": "Duratiles",
    "title": "STELLA Açık Gri 45x45",
    "seriesName": "STELLA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1582",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8736588169817258.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8736588169817258.jpg"
    ],
    "size": "45x45",
    "color": "Açık Gri",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Balkon/Teras & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Balkon Teras",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tasarımında ki farklı yaklaşım ile canlı renklerin ve desenlerin buluştuğu Stella serisi yaşam alanlarında değişime öncülük ediyor.</span>",
    "descriptionClean": "Tasarımında ki farklı yaklaşım ile canlı renklerin ve desenlerin buluştuğu Stella serisi yaşam alanlarında değişime öncülük ediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1583",
    "brand": "Duratiles",
    "title": "STELLA Hermes Dekofon 30x60",
    "seriesName": "STELLA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1583",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3281075871031216.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3281075871031216.jpg"
    ],
    "size": "30x60",
    "color": "Hermes Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "Duvar Karosu",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tasarımında ki farklı yaklaşım ile canlı renklerin ve desenlerin buluştuğu Stella serisi yaşam alanlarında değişime öncülük ediyor.</span>",
    "descriptionClean": "Tasarımında ki farklı yaklaşım ile canlı renklerin ve desenlerin buluştuğu Stella serisi yaşam alanlarında değişime öncülük ediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1584",
    "brand": "Duratiles",
    "title": "STELLA Açık Gri 30x60",
    "seriesName": "STELLA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1584",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6974761778752394.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6974761778752394.jpg"
    ],
    "size": "30x60",
    "color": "Açık Gri",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "Duvar Karosu",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tasarımında ki farklı yaklaşım ile canlı renklerin ve desenlerin buluştuğu Stella serisi yaşam alanlarında değişime öncülük ediyor.</span>",
    "descriptionClean": "Tasarımında ki farklı yaklaşım ile canlı renklerin ve desenlerin buluştuğu Stella serisi yaşam alanlarında değişime öncülük ediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1585",
    "brand": "Duratiles",
    "title": "STELLA Siyah 30x60",
    "seriesName": "STELLA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1585",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.596442040876438.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.596442040876438.jpg"
    ],
    "size": "30x60",
    "color": "Siyah",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "Duvar Karosu",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tasarımında ki farklı yaklaşım ile canlı renklerin ve desenlerin buluştuğu Stella serisi yaşam alanlarında değişime öncülük ediyor.</span>",
    "descriptionClean": "Tasarımında ki farklı yaklaşım ile canlı renklerin ve desenlerin buluştuğu Stella serisi yaşam alanlarında değişime öncülük ediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1586",
    "brand": "Duratiles",
    "title": "STELLA Geo Dekofon 30x60",
    "seriesName": "STELLA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1586",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6147092242611112.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6147092242611112.jpg"
    ],
    "size": "30x60",
    "color": "Geo Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "Duvar Karosu",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tasarımında ki farklı yaklaşım ile canlı renklerin ve desenlerin buluştuğu Stella serisi yaşam alanlarında değişime öncülük ediyor.</span>",
    "descriptionClean": "Tasarımında ki farklı yaklaşım ile canlı renklerin ve desenlerin buluştuğu Stella serisi yaşam alanlarında değişime öncülük ediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1587",
    "brand": "Duratiles",
    "title": "STREAM Stream 60x120",
    "seriesName": "STREAM",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1587",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9038191896639385.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9038191896639385.jpg"
    ],
    "size": "60x120",
    "color": "Stream",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Banyo",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Mermerin göz alıcı görünümünü parlak yüzeyi ile daha da ön plana çıkaran Stream Serisinin kahve ve antrasit renk alternatifleriyle çekici, davetkar mekanlar yaratmanız çok kolay.</span>",
    "descriptionClean": "Mermerin göz alıcı görünümünü parlak yüzeyi ile daha da ön plana çıkaran Stream Serisinin kahve ve antrasit renk alternatifleriyle çekici, davetkar mekanlar yaratmanız çok kolay.",
    "source": "duratiles"
  },
  {
    "id": "dura_1588",
    "brand": "Duratiles",
    "title": "TELLUGA Beyaz 30x60",
    "seriesName": "TELLUGA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12201",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5196053364494644.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5196053364494644.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "V1"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mat mermer dokusuna sahip olan Telluga Porselen Karoları white ve grey renk seçenekleriyle yaşam alanlarına modern bir dokunuş katıyor.</span>",
    "descriptionClean": "Mat mermer dokusuna sahip olan Telluga Porselen Karoları white ve grey renk seçenekleriyle yaşam alanlarına modern bir dokunuş katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1589",
    "brand": "Duratiles",
    "title": "TELLUGA Gri 30x60",
    "seriesName": "TELLUGA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12200",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8019601485531263.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8019601485531263.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "V1"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mat mermer dokusuna sahip olan Telluga Porselen Karoları white ve grey renk seçenekleriyle yaşam alanlarına modern bir dokunuş katıyor.</span>",
    "descriptionClean": "Mat mermer dokusuna sahip olan Telluga Porselen Karoları white ve grey renk seçenekleriyle yaşam alanlarına modern bir dokunuş katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1590",
    "brand": "Duratiles",
    "title": "TRAVERTEN Bone 30x60",
    "seriesName": "TRAVERTEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1590",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.039417133425276085.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.039417133425276085.jpg"
    ],
    "size": "30x60",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "DURASTONE",
    "features": [
      "Banyo",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Traverten Serisi doğal tonlardan oluşan ürün yelpazesi ile natürellikten yana bir tasarımdan hoşlananların favorisi</span>",
    "descriptionClean": "Traverten Serisi doğal tonlardan oluşan ürün yelpazesi ile natürellikten yana bir tasarımdan hoşlananların favorisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1591",
    "brand": "Duratiles",
    "title": "TRAVERTEN Bej 30x60",
    "seriesName": "TRAVERTEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1591",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5772773925918735.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5772773925918735.jpg"
    ],
    "size": "30x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "DURASTONE",
    "features": [
      "Banyo",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Traverten Serisi doğal tonlardan oluşan ürün yelpazesi ile natürellikten yana bir tasarımdan hoşlananların favorisi</span>",
    "descriptionClean": "Traverten Serisi doğal tonlardan oluşan ürün yelpazesi ile natürellikten yana bir tasarımdan hoşlananların favorisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1592",
    "brand": "Duratiles",
    "title": "TRAVERTEN Vizon 30x60",
    "seriesName": "TRAVERTEN",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1592",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6005110776888805.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6005110776888805.jpg"
    ],
    "size": "30x60",
    "color": "Vizon",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "DURASTONE",
    "features": [
      "Banyo",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Traverten Serisi doğal tonlardan oluşan ürün yelpazesi ile natürellikten yana bir tasarımdan hoşlananların favorisi</span>",
    "descriptionClean": "Traverten Serisi doğal tonlardan oluşan ürün yelpazesi ile natürellikten yana bir tasarımdan hoşlananların favorisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1593",
    "brand": "Duratiles",
    "title": "TRAVERTINO Bone 60x120",
    "seriesName": "TRAVERTINO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1593",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20872331053155302.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20872331053155302.jpg"
    ],
    "size": "60x120",
    "color": "Bone",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Banyo",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal taş efektinin sade güzelliğini barındıran Travertino serisi, mekanlara ferahlığı, tazeliği ve şıklığı getirecek</span>",
    "descriptionClean": "Doğal taş efektinin sade güzelliğini barındıran Travertino serisi, mekanlara ferahlığı, tazeliği ve şıklığı getirecek",
    "source": "duratiles"
  },
  {
    "id": "dura_1594",
    "brand": "Duratiles",
    "title": "TRAVERTINO Natural 60x120",
    "seriesName": "TRAVERTINO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1594",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5422492154052456.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5422492154052456.jpg"
    ],
    "size": "60x120",
    "color": "Natural",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal taş efektinin sade güzelliğini barındıran Travertino serisi, mekanlara ferahlığı, tazeliği ve şıklığı getirecek</span>",
    "descriptionClean": "Doğal taş efektinin sade güzelliğini barındıran Travertino serisi, mekanlara ferahlığı, tazeliği ve şıklığı getirecek",
    "source": "duratiles"
  },
  {
    "id": "dura_1595",
    "brand": "Duratiles",
    "title": "TRAVERTINO Noce 60x120",
    "seriesName": "TRAVERTINO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1595",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5020728405683857.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5020728405683857.jpg"
    ],
    "size": "60x120",
    "color": "Noce",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal taş efektinin sade güzelliğini barındıran Travertino serisi, mekanlara ferahlığı, tazeliği ve şıklığı getirecek</span>",
    "descriptionClean": "Doğal taş efektinin sade güzelliğini barındıran Travertino serisi, mekanlara ferahlığı, tazeliği ve şıklığı getirecek",
    "source": "duratiles"
  },
  {
    "id": "dura_1596",
    "brand": "Duratiles",
    "title": "TRAVERTINO Natura 60x120",
    "seriesName": "TRAVERTINO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1596",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.29665616231555525.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.29665616231555525.jpg"
    ],
    "size": "60x120",
    "color": "Natura",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal taş efektinin sade güzelliğini barındıran Travertino serisi, mekanlara ferahlığı, tazeliği ve şıklığı getirecek</span>",
    "descriptionClean": "Doğal taş efektinin sade güzelliğini barındıran Travertino serisi, mekanlara ferahlığı, tazeliği ve şıklığı getirecek",
    "source": "duratiles"
  },
  {
    "id": "dura_1597",
    "brand": "Duratiles",
    "title": "TRAVERTINO Gri 30x60",
    "seriesName": "TRAVERTINO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1597",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7251146661816567.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7251146661816567.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal taş efektinin sade güzelliğini barındıran Travertino serisi, mekanlara ferahlığı, tazeliği ve şıklığı getirecek</span>",
    "descriptionClean": "Doğal taş efektinin sade güzelliğini barındıran Travertino serisi, mekanlara ferahlığı, tazeliği ve şıklığı getirecek",
    "source": "duratiles"
  },
  {
    "id": "dura_1598",
    "brand": "Duratiles",
    "title": "TRAVERTINO Bej 30x60",
    "seriesName": "TRAVERTINO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1598",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5655439401643833.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5655439401643833.jpg"
    ],
    "size": "30x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal taş efektinin sade güzelliğini barındıran Travertino serisi, mekanlara ferahlığı, tazeliği ve şıklığı getirecek</span>",
    "descriptionClean": "Doğal taş efektinin sade güzelliğini barındıran Travertino serisi, mekanlara ferahlığı, tazeliği ve şıklığı getirecek",
    "source": "duratiles"
  },
  {
    "id": "dura_1599",
    "brand": "Duratiles",
    "title": "TRAVERTINO Beyaz 30x60",
    "seriesName": "TRAVERTINO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1599",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9731597678156341.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9731597678156341.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal taş efektinin sade güzelliğini barındıran Travertino serisi, mekanlara ferahlığı, tazeliği ve şıklığı getirecek</span>",
    "descriptionClean": "Doğal taş efektinin sade güzelliğini barındıran Travertino serisi, mekanlara ferahlığı, tazeliği ve şıklığı getirecek",
    "source": "duratiles"
  },
  {
    "id": "dura_1600",
    "brand": "Duratiles",
    "title": "TRAVERTINO Noce 30x60",
    "seriesName": "TRAVERTINO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1600",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8497154341917283.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8497154341917283.jpg"
    ],
    "size": "30x60",
    "color": "Noce",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal taş efektinin sade güzelliğini barındıran Travertino serisi, mekanlara ferahlığı, tazeliği ve şıklığı getirecek</span>",
    "descriptionClean": "Doğal taş efektinin sade güzelliğini barındıran Travertino serisi, mekanlara ferahlığı, tazeliği ve şıklığı getirecek",
    "source": "duratiles"
  },
  {
    "id": "dura_1601",
    "brand": "Duratiles",
    "title": "TUNDRA Geo Dekofon 40x120",
    "seriesName": "TUNDRA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1601",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8386224223007234.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8386224223007234.jpg"
    ],
    "size": "40x120",
    "color": "Geo Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tundra Serisi doğanın en cesur tonlarını yaşam alanlarınıza seramik konforuyla harmanlayarak taşıyor</span>",
    "descriptionClean": "Tundra Serisi doğanın en cesur tonlarını yaşam alanlarınıza seramik konforuyla harmanlayarak taşıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1602",
    "brand": "Duratiles",
    "title": "TUNDRA Kahve 40x120",
    "seriesName": "TUNDRA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1602",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4645509039229635.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4645509039229635.jpg"
    ],
    "size": "40x120",
    "color": "Kahve",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tundra Serisi doğanın en cesur tonlarını yaşam alanlarınıza seramik konforuyla harmanlayarak taşıyor</span>",
    "descriptionClean": "Tundra Serisi doğanın en cesur tonlarını yaşam alanlarınıza seramik konforuyla harmanlayarak taşıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1603",
    "brand": "Duratiles",
    "title": "TUNDRA Bej 40x120",
    "seriesName": "TUNDRA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1603",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7006044476761081.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7006044476761081.jpg"
    ],
    "size": "40x120",
    "color": "Bej",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tundra Serisi doğanın en cesur tonlarını yaşam alanlarınıza seramik konforuyla harmanlayarak taşıyor</span>",
    "descriptionClean": "Tundra Serisi doğanın en cesur tonlarını yaşam alanlarınıza seramik konforuyla harmanlayarak taşıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1604",
    "brand": "Duratiles",
    "title": "TUNDRA Kahve 60x60",
    "seriesName": "TUNDRA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1604",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7201812853667273.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7201812853667273.jpg"
    ],
    "size": "60x60",
    "color": "Kahve",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tundra Serisi doğanın en cesur tonlarını yaşam alanlarınıza seramik konforuyla harmanlayarak taşıyor</span>",
    "descriptionClean": "Tundra Serisi doğanın en cesur tonlarını yaşam alanlarınıza seramik konforuyla harmanlayarak taşıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1605",
    "brand": "Duratiles",
    "title": "TUNDRA Bej 60x60",
    "seriesName": "TUNDRA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1605",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6634859605058964.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6634859605058964.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tundra Serisi doğanın en cesur tonlarını yaşam alanlarınıza seramik konforuyla harmanlayarak taşıyor</span>",
    "descriptionClean": "Tundra Serisi doğanın en cesur tonlarını yaşam alanlarınıza seramik konforuyla harmanlayarak taşıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1606",
    "brand": "Duratiles",
    "title": "UNIQUE Luna 60x120",
    "seriesName": "UNIQUE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1606",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30439885911505704.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30439885911505704.jpg"
    ],
    "size": "60x120",
    "color": "Luna",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer dokusunun ihtişamlı güzelliğini alternatif mimari çözümlerle yaşam alanlarınıza taşıyan Unique Porselen Karoları dikkat çekici tasarımıyla mekanlara katma değer katar.</span>",
    "descriptionClean": "Mermer dokusunun ihtişamlı güzelliğini alternatif mimari çözümlerle yaşam alanlarınıza taşıyan Unique Porselen Karoları dikkat çekici tasarımıyla mekanlara katma değer katar.",
    "source": "duratiles"
  },
  {
    "id": "dura_1607",
    "brand": "Duratiles",
    "title": "UNIQUE Luna 80x80",
    "seriesName": "UNIQUE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1607",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11218845892522555.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11218845892522555.jpg"
    ],
    "size": "80x80",
    "color": "Luna",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer dokusunun ihtişamlı güzelliğini alternatif mimari çözümlerle yaşam alanlarınıza taşıyan Unique Porselen Karoları dikkat çekici tasarımıyla mekanlara katma değer katar.</span>",
    "descriptionClean": "Mermer dokusunun ihtişamlı güzelliğini alternatif mimari çözümlerle yaşam alanlarınıza taşıyan Unique Porselen Karoları dikkat çekici tasarımıyla mekanlara katma değer katar.",
    "source": "duratiles"
  },
  {
    "id": "dura_1608",
    "brand": "Duratiles",
    "title": "UNIQUE Luna 30x60",
    "seriesName": "UNIQUE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1608",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8431132466123101.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8431132466123101.jpg"
    ],
    "size": "30x60",
    "color": "Luna",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer dokusunun ihtişamlı güzelliğini alternatif mimari çözümlerle yaşam alanlarınıza taşıyan Unique Porselen Karoları dikkat çekici tasarımıyla mekanlara katma değer katar.</span>",
    "descriptionClean": "Mermer dokusunun ihtişamlı güzelliğini alternatif mimari çözümlerle yaşam alanlarınıza taşıyan Unique Porselen Karoları dikkat çekici tasarımıyla mekanlara katma değer katar.",
    "source": "duratiles"
  },
  {
    "id": "dura_1609",
    "brand": "Duratiles",
    "title": "VARANA Beyaz 60x120",
    "seriesName": "VARANA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1609",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3757068669554884.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3757068669554884.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "V4"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pozitif enerjinin ve mutluluğun hakim olduğu mekanlar yaratan Varana Serisi özgün mekanlar yaratmanız için biçilmiş kaftan</span>",
    "descriptionClean": "Pozitif enerjinin ve mutluluğun hakim olduğu mekanlar yaratan Varana Serisi özgün mekanlar yaratmanız için biçilmiş kaftan",
    "source": "duratiles"
  },
  {
    "id": "dura_1610",
    "brand": "Duratiles",
    "title": "VARANA Antrasit 60x120",
    "seriesName": "VARANA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1610",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5995744126954903.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5995744126954903.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "V4"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pozitif enerjinin ve mutluluğun hakim olduğu mekanlar yaratan Varana Serisi özgün mekanlar yaratmanız için biçilmiş kaftan</span>",
    "descriptionClean": "Pozitif enerjinin ve mutluluğun hakim olduğu mekanlar yaratan Varana Serisi özgün mekanlar yaratmanız için biçilmiş kaftan",
    "source": "duratiles"
  },
  {
    "id": "dura_1611",
    "brand": "Duratiles",
    "title": "VERDE ONIX Onix 60x120",
    "seriesName": "VERDE ONIX",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1611",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28547348222120683.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28547348222120683.jpg"
    ],
    "size": "60x120",
    "color": "Onix",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bookmatch serisinden Verde Porselen Karoları fonksiyonel çözümler sunan yapısı , şıklık katan ayrıntıları ile yaşam alanlarına eşsiz bir atmosfer katar.</span>",
    "descriptionClean": "Bookmatch serisinden Verde Porselen Karoları fonksiyonel çözümler sunan yapısı , şıklık katan ayrıntıları ile yaşam alanlarına eşsiz bir atmosfer katar.",
    "source": "duratiles"
  },
  {
    "id": "dura_1612",
    "brand": "Duratiles",
    "title": "VERANA Beyaz 30x60",
    "seriesName": "VERANA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "64997",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12474656702384002.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12474656702384002.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Verena Porselen Karoları zamanın ötesinde bir tarz yakalamak isteyenlere hitap ediyor.</span>",
    "descriptionClean": "Verena Porselen Karoları zamanın ötesinde bir tarz yakalamak isteyenlere hitap ediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1613",
    "brand": "Duratiles",
    "title": "VERANA Bone 30x60",
    "seriesName": "VERANA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "64994",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.47431571995359356.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.47431571995359356.jpg"
    ],
    "size": "30x60",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Verena Porselen Karoları zamanın ötesinde bir tarz yakalamak isteyenlere hitap ediyor.</span>",
    "descriptionClean": "Verena Porselen Karoları zamanın ötesinde bir tarz yakalamak isteyenlere hitap ediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1614",
    "brand": "Duratiles",
    "title": "VERANA Gri 30x60",
    "seriesName": "VERANA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "64999",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.05642061352047889.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.05642061352047889.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Verena Porselen Karoları zamanın ötesinde bir tarz yakalamak isteyenlere hitap ediyor.</span>",
    "descriptionClean": "Verena Porselen Karoları zamanın ötesinde bir tarz yakalamak isteyenlere hitap ediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1615",
    "brand": "Duratiles",
    "title": "VERONA Gri 45x45",
    "seriesName": "VERONA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1615",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8961511829504374.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8961511829504374.jpg"
    ],
    "size": "45x45",
    "color": "Gri",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Verona Serisi sade tarzı ile mekanların modern bir duruş yakalamasına olanak verirken güçlü teknik yapısıyla da zamansız bir güzellik sunmakta.</span>",
    "descriptionClean": "Verona Serisi sade tarzı ile mekanların modern bir duruş yakalamasına olanak verirken güçlü teknik yapısıyla da zamansız bir güzellik sunmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1616",
    "brand": "Duratiles",
    "title": "VERONA Bej 45x45",
    "seriesName": "VERONA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1616",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8532959444090099.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8532959444090099.jpg"
    ],
    "size": "45x45",
    "color": "Bej",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Verona Serisi sade tarzı ile mekanların modern bir duruş yakalamasına olanak verirken güçlü teknik yapısıyla da zamansız bir güzellik sunmakta.</span>",
    "descriptionClean": "Verona Serisi sade tarzı ile mekanların modern bir duruş yakalamasına olanak verirken güçlü teknik yapısıyla da zamansız bir güzellik sunmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1617",
    "brand": "Duratiles",
    "title": "VERONA Gri 30x60",
    "seriesName": "VERONA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1617",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.39511303335448134.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.39511303335448134.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Verona Serisi sade tarzı ile mekanların modern bir duruş yakalamasına olanak verirken güçlü teknik yapısıyla da zamansız bir güzellik sunmakta.</span>",
    "descriptionClean": "Verona Serisi sade tarzı ile mekanların modern bir duruş yakalamasına olanak verirken güçlü teknik yapısıyla da zamansız bir güzellik sunmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1618",
    "brand": "Duratiles",
    "title": "VERONA Bej 30x60",
    "seriesName": "VERONA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1618",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6255204824082724.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6255204824082724.jpg"
    ],
    "size": "30x60",
    "color": "Bej",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Verona Serisi sade tarzı ile mekanların modern bir duruş yakalamasına olanak verirken güçlü teknik yapısıyla da zamansız bir güzellik sunmakta.</span>",
    "descriptionClean": "Verona Serisi sade tarzı ile mekanların modern bir duruş yakalamasına olanak verirken güçlü teknik yapısıyla da zamansız bir güzellik sunmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1619",
    "brand": "Duratiles",
    "title": "VERONA Gray Scan Dekofon 30x60",
    "seriesName": "VERONA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1619",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8763141805875307.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8763141805875307.jpg"
    ],
    "size": "30x60",
    "color": "Gray Scan Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Verona Serisi sade tarzı ile mekanların modern bir duruş yakalamasına olanak verirken güçlü teknik yapısıyla da zamansız bir güzellik sunmakta.</span>",
    "descriptionClean": "Verona Serisi sade tarzı ile mekanların modern bir duruş yakalamasına olanak verirken güçlü teknik yapısıyla da zamansız bir güzellik sunmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1620",
    "brand": "Duratiles",
    "title": "VERONA Bej Scan Dekofon 30x60",
    "seriesName": "VERONA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1620",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20303743498219662.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20303743498219662.jpg"
    ],
    "size": "30x60",
    "color": "Bej Scan Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Verona Serisi sade tarzı ile mekanların modern bir duruş yakalamasına olanak verirken güçlü teknik yapısıyla da zamansız bir güzellik sunmakta.</span>",
    "descriptionClean": "Verona Serisi sade tarzı ile mekanların modern bir duruş yakalamasına olanak verirken güçlü teknik yapısıyla da zamansız bir güzellik sunmakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1621",
    "brand": "Duratiles",
    "title": "VIOLA Viola 60x120",
    "seriesName": "VIOLA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1621",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8271025419543708.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8271025419543708.jpg"
    ],
    "size": "60x120",
    "color": "Viola",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Banyo",
      "Balkon Teras",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">İncelikli tasarım anlayışı ile Viola porselen karoları yaşam alanlarına rafine bir dekorasyon tarzı getiriyor.</span>",
    "descriptionClean": "İncelikli tasarım anlayışı ile Viola porselen karoları yaşam alanlarına rafine bir dekorasyon tarzı getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1622",
    "brand": "Duratiles",
    "title": "WHITE LEAF Beyaz 30x60",
    "seriesName": "WHITE LEAF",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12215",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5739499166870451.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5739499166870451.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Banyo",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Klasik mermer görünümünden ilham alan White Leaf serisi iç ve dış mekanlarda rahatça uygulanabilir olması ısıya,ışığa ve suy akarşı dayanıklı yapısıyla uzun ömürlüdür.</span>",
    "descriptionClean": "Klasik mermer görünümünden ilham alan White Leaf serisi iç ve dış mekanlarda rahatça uygulanabilir olması ısıya,ışığa ve suy akarşı dayanıklı yapısıyla uzun ömürlüdür.",
    "source": "duratiles"
  },
  {
    "id": "dura_1623",
    "brand": "Duratiles",
    "title": "YENİ GLORIA Beyaz 45x45",
    "seriesName": "YENİ GLORIA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1623",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9081029776108174.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9081029776108174.jpg"
    ],
    "size": "45x45",
    "color": "Beyaz",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ender bir mermer türünden ilham alınarak tasarlanan Yeni Gloria porselen karoları beyaz damarlı yapısıyla her zaman şık bir tasarımın mimarı oluyor</span>",
    "descriptionClean": "Ender bir mermer türünden ilham alınarak tasarlanan Yeni Gloria porselen karoları beyaz damarlı yapısıyla her zaman şık bir tasarımın mimarı oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1624",
    "brand": "Duratiles",
    "title": "YENİ GLORIA Beyaz 30x60",
    "seriesName": "YENİ GLORIA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1624",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.463511353474339.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.463511353474339.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ender bir mermer türünden ilham alınarak tasarlanan Yeni Gloria porselen karoları beyaz damarlı yapısıyla her zaman şık bir tasarımın mimarı oluyor</span>",
    "descriptionClean": "Ender bir mermer türünden ilham alınarak tasarlanan Yeni Gloria porselen karoları beyaz damarlı yapısıyla her zaman şık bir tasarımın mimarı oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1625",
    "brand": "Duratiles",
    "title": "YENİ GLORIA Siyah 30x60",
    "seriesName": "YENİ GLORIA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1625",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2880384733096907.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2880384733096907.jpg"
    ],
    "size": "30x60",
    "color": "Siyah",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ender bir mermer türünden ilham alınarak tasarlanan Yeni Gloria porselen karoları beyaz damarlı yapısıyla her zaman şık bir tasarımın mimarı oluyor</span>",
    "descriptionClean": "Ender bir mermer türünden ilham alınarak tasarlanan Yeni Gloria porselen karoları beyaz damarlı yapısıyla her zaman şık bir tasarımın mimarı oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1626",
    "brand": "Duratiles",
    "title": "YENİ GLORIA Beyaz Dekofon 30x60",
    "seriesName": "YENİ GLORIA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1626",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.33559124394436013.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.33559124394436013.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ender bir mermer türünden ilham alınarak tasarlanan Yeni Gloria porselen karoları beyaz damarlı yapısıyla her zaman şık bir tasarımın mimarı oluyor</span>",
    "descriptionClean": "Ender bir mermer türünden ilham alınarak tasarlanan Yeni Gloria porselen karoları beyaz damarlı yapısıyla her zaman şık bir tasarımın mimarı oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1627",
    "brand": "Duratiles",
    "title": "YENİ GLORIA Siyah Dekofon 30x60",
    "seriesName": "YENİ GLORIA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1627",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9255486752440164.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9255486752440164.jpg"
    ],
    "size": "30x60",
    "color": "Siyah Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ender bir mermer türünden ilham alınarak tasarlanan Yeni Gloria porselen karoları beyaz damarlı yapısıyla her zaman şık bir tasarımın mimarı oluyor</span>",
    "descriptionClean": "Ender bir mermer türünden ilham alınarak tasarlanan Yeni Gloria porselen karoları beyaz damarlı yapısıyla her zaman şık bir tasarımın mimarı oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1628",
    "brand": "Duratiles",
    "title": "ZAFIRE Beyaz 60x120",
    "seriesName": "ZAFIRE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1628",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.859424895723053.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.859424895723053.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Balkon/Teras & Dış Cephe & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo",
      "Balkon Teras",
      "Dış Cephe",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zafire Porselen Karoları keyif dozu yüksek yaşanılası mekanlar yaratır.</span>",
    "descriptionClean": "Zafire Porselen Karoları keyif dozu yüksek yaşanılası mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1629",
    "brand": "Duratiles",
    "title": "ZAFIRE Siyah 60x120",
    "seriesName": "ZAFIRE",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "1629",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3164144995671886.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3164144995671886.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3",
      "Banyo",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zafire Porselen Karoları keyif dozu yüksek yaşanılası mekanlar yaratır.</span>",
    "descriptionClean": "Zafire Porselen Karoları keyif dozu yüksek yaşanılası mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1630",
    "brand": "Duratiles",
    "title": "ZEBRANO Beyaz 30x60",
    "seriesName": "ZEBRANO",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "12216",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6530425400006908.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6530425400006908.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Balkon/Teras & Endüstriyel Zemin",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Banyo",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümünü net belirgin damarlarıyla veren Zebrano Porselen Karoları soft rengiyle dingin mekanlar yaratır&nbsp;</span>",
    "descriptionClean": "Mermer görünümünü net belirgin damarlarıyla veren Zebrano Porselen Karoları soft rengiyle dingin mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1631",
    "brand": "Duratiles",
    "title": "ALICANTE Dekor 30x60",
    "seriesName": "ALICANTE",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "12216",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6696266059112076.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6696266059112076.jpg"
    ],
    "size": "30x60",
    "color": "Dekor",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Banyo",
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Zamansızlığı ve yalınlığı beraberinde getiren Alicante PorselEn karoları benzersiz tasarımı ile seçkin bir deneyim sunmakta .</span>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Alicante PorselEn karoları benzersiz tasarımı ile seçkin bir deneyim sunmakta .",
    "source": "duratiles"
  },
  {
    "id": "dura_1632",
    "brand": "Duratiles",
    "title": "ARNEDO Cotto 30x60",
    "seriesName": "ARNEDO",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1632",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.94647359757343.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.94647359757343.jpg"
    ],
    "size": "30x60",
    "color": "Cotto",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Banyo",
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Arnedo Porselen Karoları ...</span>",
    "descriptionClean": "Yaratıcılığını cesur tercihlerle yaşadığı mekanlara yansıtmak isteyenlerin tercihi Arnedo Porselen Karoları ...",
    "source": "duratiles"
  },
  {
    "id": "dura_1633",
    "brand": "Duratiles",
    "title": "ARVEN Siyah 15x60",
    "seriesName": "ARVEN",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1633",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8620525626202589.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8620525626202589.jpg"
    ],
    "size": "15x60",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Ticari Alanlar",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Detayların fark yaratan harmonisini Arven serisi ile keşfedin.</span>",
    "descriptionClean": "Detayların fark yaratan harmonisini Arven serisi ile keşfedin.",
    "source": "duratiles"
  },
  {
    "id": "dura_1634",
    "brand": "Duratiles",
    "title": "ARVEN Beyaz 15x60",
    "seriesName": "ARVEN",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1634",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03978951762476601.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03978951762476601.jpg"
    ],
    "size": "15x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Dış Cephe",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Detayların fark yaratan harmonisini Arven serisi ile keşfedin.</span>",
    "descriptionClean": "Detayların fark yaratan harmonisini Arven serisi ile keşfedin.",
    "source": "duratiles"
  },
  {
    "id": "dura_1635",
    "brand": "Duratiles",
    "title": "CRACKLE Beyaz 60x120",
    "seriesName": "CRACKLE",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1635",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.29579754139656766.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.29579754139656766.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Granit",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V1"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Crackle serisi yaşam alanlarınıza aydınlık ,ferah ve dingin bir ambiyans yaratmak için ideal çözümler sunuyor</span>",
    "descriptionClean": "Crackle serisi yaşam alanlarınıza aydınlık ,ferah ve dingin bir ambiyans yaratmak için ideal çözümler sunuyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1636",
    "brand": "Duratiles",
    "title": "CRACKLE Gri 60x120",
    "seriesName": "CRACKLE",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1636",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.29814181906120085.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.29814181906120085.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Granit",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V1"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Crackle serisi yaşam alanlarınıza aydınlık ,ferah ve dingin bir ambiyans yaratmak için ideal çözümler sunuyor</span>",
    "descriptionClean": "Crackle serisi yaşam alanlarınıza aydınlık ,ferah ve dingin bir ambiyans yaratmak için ideal çözümler sunuyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1637",
    "brand": "Duratiles",
    "title": "CRACKLE Koyu Gri 60x120",
    "seriesName": "CRACKLE",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1637",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7112826937754593.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7112826937754593.jpg"
    ],
    "size": "60x120",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Granit",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V1"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Crackle serisi yaşam alanlarınıza aydınlık ,ferah ve dingin bir ambiyans yaratmak için ideal çözümler sunuyor</span>",
    "descriptionClean": "Crackle serisi yaşam alanlarınıza aydınlık ,ferah ve dingin bir ambiyans yaratmak için ideal çözümler sunuyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1638",
    "brand": "Duratiles",
    "title": "CROCODILE Vizon 60x120",
    "seriesName": "CROCODILE",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1638",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.778036386476367.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.778036386476367.jpg"
    ],
    "size": "60x120",
    "color": "Vizon",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Crocodile porselen karoları estetik ve fonksiyonel çizgileriyle sıra dışı konseptler yaratıyor</span>",
    "descriptionClean": "Crocodile porselen karoları estetik ve fonksiyonel çizgileriyle sıra dışı konseptler yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1639",
    "brand": "Duratiles",
    "title": "CROCODILE Kahve 60x120",
    "seriesName": "CROCODILE",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1639",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9215681685537392.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9215681685537392.jpg"
    ],
    "size": "60x120",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Crocodile porselen karoları estetik ve fonksiyonel çizgileriyle sıra dışı konseptler yaratıyor</span>",
    "descriptionClean": "Crocodile porselen karoları estetik ve fonksiyonel çizgileriyle sıra dışı konseptler yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1640",
    "brand": "Duratiles",
    "title": "CROCODILE Mavi 60x120",
    "seriesName": "CROCODILE",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1640",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6662455230426184.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6662455230426184.jpg"
    ],
    "size": "60x120",
    "color": "Mavi",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Crocodile porselen karoları estetik ve fonksiyonel çizgileriyle sıra dışı konseptler yaratıyor</span>",
    "descriptionClean": "Crocodile porselen karoları estetik ve fonksiyonel çizgileriyle sıra dışı konseptler yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1641",
    "brand": "Duratiles",
    "title": "CROCODILE Siyah 60x60",
    "seriesName": "CROCODILE",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1641",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5578243507357441.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5578243507357441.jpg"
    ],
    "size": "60x60",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Crocodile porselen karoları estetik ve fonksiyonel çizgileriyle sıra dışı konseptler yaratıyor</span>",
    "descriptionClean": "Crocodile porselen karoları estetik ve fonksiyonel çizgileriyle sıra dışı konseptler yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1642",
    "brand": "Duratiles",
    "title": "CROMIE Bej 60x60",
    "seriesName": "CROMIE",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1642",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13846220883010374.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13846220883010374.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Size özel kişisel mekanlar oluşturabilmeniz için tasarlanan Cromie Serisi ile farklı olmanın dekoratif yollarını görebilirsiniz</span>",
    "descriptionClean": "Size özel kişisel mekanlar oluşturabilmeniz için tasarlanan Cromie Serisi ile farklı olmanın dekoratif yollarını görebilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_1643",
    "brand": "Duratiles",
    "title": "CROMIE Gri 60x60",
    "seriesName": "CROMIE",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1643",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15359015426740463.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15359015426740463.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Size özel kişisel mekanlar oluşturabilmeniz için tasarlanan Cromie Serisi ile farklı olmanın dekoratif yollarını görebilirsiniz</span>",
    "descriptionClean": "Size özel kişisel mekanlar oluşturabilmeniz için tasarlanan Cromie Serisi ile farklı olmanın dekoratif yollarını görebilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_1644",
    "brand": "Duratiles",
    "title": "CRONO Kahve 30x60",
    "seriesName": "CRONO",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1644",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11974920077055262.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11974920077055262.jpg"
    ],
    "size": "30x60",
    "color": "Kahve",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "V2",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Üç farklı renk alternatifi sunan Crono Serisi mozaik deseni ile mekânlara hareketlilik katıyor. Tekdüze sıradan geçişleri Crono Serisi ile kırabilir yaşam alanlarınıza dinamizm katabilirsiniz.</span>",
    "descriptionClean": "Üç farklı renk alternatifi sunan Crono Serisi mozaik deseni ile mekânlara hareketlilik katıyor. Tekdüze sıradan geçişleri Crono Serisi ile kırabilir yaşam alanlarınıza dinamizm katabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1645",
    "brand": "Duratiles",
    "title": "CRONO Bej 30x60",
    "seriesName": "CRONO",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1645",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.017541253667842316.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.017541253667842316.jpg"
    ],
    "size": "30x60",
    "color": "Bej",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "V2",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Üç farklı renk alternatifi sunan Crono Serisi mozaik deseni ile mekânlara hareketlilik katıyor. Tekdüze sıradan geçişleri Crono Serisi ile kırabilir yaşam alanlarınıza dinamizm katabilirsiniz.</span>",
    "descriptionClean": "Üç farklı renk alternatifi sunan Crono Serisi mozaik deseni ile mekânlara hareketlilik katıyor. Tekdüze sıradan geçişleri Crono Serisi ile kırabilir yaşam alanlarınıza dinamizm katabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1646",
    "brand": "Duratiles",
    "title": "CRONO Gri 30x60",
    "seriesName": "CRONO",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1646",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5872085032858636.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5872085032858636.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "V2",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Üç farklı renk alternatifi sunan Crono Serisi mozaik deseni ile mekânlara hareketlilik katıyor. Tekdüze sıradan geçişleri Crono Serisi ile kırabilir yaşam alanlarınıza dinamizm katabilirsiniz.</span>",
    "descriptionClean": "Üç farklı renk alternatifi sunan Crono Serisi mozaik deseni ile mekânlara hareketlilik katıyor. Tekdüze sıradan geçişleri Crono Serisi ile kırabilir yaşam alanlarınıza dinamizm katabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1647",
    "brand": "Duratiles",
    "title": "EXTREME Extreme 20x120",
    "seriesName": "EXTREME",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1647",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9643532937439934.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9643532937439934.jpg"
    ],
    "size": "20x120",
    "color": "Extreme",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Extreme Porselen Karoları güçlü ve doğal tonlarıyla mekanlarınıza karakteristik bir görünüm kazandıracak!</span>",
    "descriptionClean": "Extreme Porselen Karoları güçlü ve doğal tonlarıyla mekanlarınıza karakteristik bir görünüm kazandıracak!",
    "source": "duratiles"
  },
  {
    "id": "dura_1649",
    "brand": "Duratiles",
    "title": "GOBI Gri 33x33",
    "seriesName": "GOBI",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1649",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1548531308164971.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1548531308164971.jpg"
    ],
    "size": "33x33",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "V3",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaşadığınız mekanlarda farkınızı yansıtacak olan Gobi Porselen Karoları solmayan güzelliği ile stilinizi yansıtır.</span>",
    "descriptionClean": "Yaşadığınız mekanlarda farkınızı yansıtacak olan Gobi Porselen Karoları solmayan güzelliği ile stilinizi yansıtır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1650",
    "brand": "Duratiles",
    "title": "HEDERA Bone 30x60",
    "seriesName": "HEDERA",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1650",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7740565355341971.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7740565355341971.jpg"
    ],
    "size": "30x60",
    "color": "Bone",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Banyo",
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ayrıntıların ahengini her alanda hissedin. Hedera serisi ile hayatınıza özgünlük katın</span>",
    "descriptionClean": "Ayrıntıların ahengini her alanda hissedin. Hedera serisi ile hayatınıza özgünlük katın",
    "source": "duratiles"
  },
  {
    "id": "dura_1651",
    "brand": "Duratiles",
    "title": "İZNİK Dekor 60x60",
    "seriesName": "İZNİK",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1651",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30572700731832536.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30572700731832536.jpg"
    ],
    "size": "60x60",
    "color": "Dekor",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İznik çinilerinden ilham alınarak tasarlanan İznik serisi ile siz de İznik Çiniler'inin o gizemli ve mistik enerjisini yaşam alanlarınıza katabilirsiniz.</span>",
    "descriptionClean": "İznik çinilerinden ilham alınarak tasarlanan İznik serisi ile siz de İznik Çiniler'inin o gizemli ve mistik enerjisini yaşam alanlarınıza katabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1652",
    "brand": "Duratiles",
    "title": "KÜBİK Siyah 60x120",
    "seriesName": "KÜBİK",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1652",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10813043706262782.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10813043706262782.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Banyo",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">İncelikli tasarım anlayışı ile Kübik porselen karoları yaşam alanlarına rafine bir dekorasyon tarzı getiriyor.</span>",
    "descriptionClean": "İncelikli tasarım anlayışı ile Kübik porselen karoları yaşam alanlarına rafine bir dekorasyon tarzı getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1653",
    "brand": "Duratiles",
    "title": "KÜBİK Parlement 60x120",
    "seriesName": "KÜBİK",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1653",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07273868073643375.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07273868073643375.jpg"
    ],
    "size": "60x120",
    "color": "Parlement",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Dış Cephe & Balkon/Teras",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Banyo",
      "Dış Cephe",
      "Balkon Teras",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">İncelikli tasarım anlayışı ile Kübik porselen karoları yaşam alanlarına rafine bir dekorasyon tarzı getiriyor.</span>",
    "descriptionClean": "İncelikli tasarım anlayışı ile Kübik porselen karoları yaşam alanlarına rafine bir dekorasyon tarzı getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1654",
    "brand": "Duratiles",
    "title": "KÜBİK Parlement Beyaz 60x120",
    "seriesName": "KÜBİK",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1654",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2464127792727865.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2464127792727865.jpg"
    ],
    "size": "60x120",
    "color": "Parlement Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Balkon/Teras & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Banyo",
      "Balkon Teras",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">İncelikli tasarım anlayışı ile Kübik porselen karoları yaşam alanlarına rafine bir dekorasyon tarzı getiriyor.</span>",
    "descriptionClean": "İncelikli tasarım anlayışı ile Kübik porselen karoları yaşam alanlarına rafine bir dekorasyon tarzı getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1655",
    "brand": "Duratiles",
    "title": "LABRANDA Dekor 60x60",
    "seriesName": "LABRANDA",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1655",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03744359304308886.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03744359304308886.jpg"
    ],
    "size": "60x60",
    "color": "Dekor",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Özel mekânlar için özel bir seçim. Labranda serisi ayrıcalığın simgesi. Dayanıklı, şık ve özel mekânların anahtarı. Modern yaşamın vazgeçilmezi.</span>",
    "descriptionClean": "Özel mekânlar için özel bir seçim. Labranda serisi ayrıcalığın simgesi. Dayanıklı, şık ve özel mekânların anahtarı. Modern yaşamın vazgeçilmezi.",
    "source": "duratiles"
  },
  {
    "id": "dura_1656",
    "brand": "Duratiles",
    "title": "LABRANDA Dekor 60x60",
    "seriesName": "LABRANDA",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1656",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5169320276637568.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5169320276637568.jpg"
    ],
    "size": "60x60",
    "color": "Dekor",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Özel mekânlar için özel bir seçim. Labranda serisi ayrıcalığın simgesi. Dayanıklı, şık ve özel mekânların anahtarı. Modern yaşamın vazgeçilmezi.</span>",
    "descriptionClean": "Özel mekânlar için özel bir seçim. Labranda serisi ayrıcalığın simgesi. Dayanıklı, şık ve özel mekânların anahtarı. Modern yaşamın vazgeçilmezi.",
    "source": "duratiles"
  },
  {
    "id": "dura_1657",
    "brand": "Duratiles",
    "title": "LABRANDA Mix Dekor 60x60",
    "seriesName": "LABRANDA",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1657",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5235945041245289.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5235945041245289.jpg"
    ],
    "size": "60x60",
    "color": "Mix Dekor",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Özel mekânlar için özel bir seçim. Labranda serisi ayrıcalığın simgesi. Dayanıklı, şık ve özel mekânların anahtarı. Modern yaşamın vazgeçilmezi.</span>",
    "descriptionClean": "Özel mekânlar için özel bir seçim. Labranda serisi ayrıcalığın simgesi. Dayanıklı, şık ve özel mekânların anahtarı. Modern yaşamın vazgeçilmezi.",
    "source": "duratiles"
  },
  {
    "id": "dura_1658",
    "brand": "Duratiles",
    "title": "LABRANDA Mix Dekor 60x60",
    "seriesName": "LABRANDA",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1658",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7986324793542877.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7986324793542877.jpg"
    ],
    "size": "60x60",
    "color": "Mix Dekor",
    "surface": "Full Lappato, Mat",
    "thickness": "30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Özel mekânlar için özel bir seçim. Labranda serisi ayrıcalığın simgesi. Dayanıklı, şık ve özel mekânların anahtarı. Modern yaşamın vazgeçilmezi.</span>",
    "descriptionClean": "Özel mekânlar için özel bir seçim. Labranda serisi ayrıcalığın simgesi. Dayanıklı, şık ve özel mekânların anahtarı. Modern yaşamın vazgeçilmezi.",
    "source": "duratiles"
  },
  {
    "id": "dura_1659",
    "brand": "Duratiles",
    "title": "LACE Lace 60x60",
    "seriesName": "LACE",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1659",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.33279226778805115.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.33279226778805115.jpg"
    ],
    "size": "60x60",
    "color": "Lace",
    "surface": "Parlak",
    "thickness": "30mm",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Banyo",
      "Ev İçi Zemin",
      "V1"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Büyüleyici detaylar, özgün tasarımla buluştu. Lace serisi ile yaşam alanlarınıza sanatsal bir dokunuş yapın.</span>",
    "descriptionClean": "Büyüleyici detaylar, özgün tasarımla buluştu. Lace serisi ile yaşam alanlarınıza sanatsal bir dokunuş yapın.",
    "source": "duratiles"
  },
  {
    "id": "dura_1660",
    "brand": "Duratiles",
    "title": "LUTTER RUST Lutter Rust 45x90",
    "seriesName": "LUTTER RUST",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1660",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18177235209763798.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18177235209763798.jpg"
    ],
    "size": "45x90",
    "color": "Lutter Rust",
    "surface": "Mat , Sırlı Body",
    "thickness": "30mm & 20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Lutter Rust Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Lutter Rust Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1661",
    "brand": "Duratiles",
    "title": "LUTTER RUST Lutter Rust 60x90",
    "seriesName": "LUTTER RUST",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1661",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6319978945253546.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6319978945253546.jpg"
    ],
    "size": "60x90",
    "color": "Lutter Rust",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Lutter Rust Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Lutter Rust Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1662",
    "brand": "Duratiles",
    "title": "LUTTER RUST Lutter Rust 60x120",
    "seriesName": "LUTTER RUST",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1662",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.371597863914652.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.371597863914652.jpg"
    ],
    "size": "60x120",
    "color": "Lutter Rust",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Havuz & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Lutter Rust Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Lutter Rust Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1663",
    "brand": "Duratiles",
    "title": "LUTTER RUST Lutter Rust 40x120",
    "seriesName": "LUTTER RUST",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1663",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7425660197389266.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7425660197389266.jpg"
    ],
    "size": "40x120",
    "color": "Lutter Rust",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Havuz & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Lutter Rust Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Lutter Rust Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1664",
    "brand": "Duratiles",
    "title": "LUTTER RUST Lutter Rust 30x120",
    "seriesName": "LUTTER RUST",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1664",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7312068166391522.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7312068166391522.jpg"
    ],
    "size": "30x120",
    "color": "Lutter Rust",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Havuz & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Lutter Rust Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Lutter Rust Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1665",
    "brand": "Duratiles",
    "title": "LUTTER RUST Lutter Rust 80x80",
    "seriesName": "LUTTER RUST",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1665",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4272684344503287.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4272684344503287.jpg"
    ],
    "size": "80x80",
    "color": "Lutter Rust",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Havuz & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Lutter Rust Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Lutter Rust Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1666",
    "brand": "Duratiles",
    "title": "LUTTER RUST Lutter Rust 40x80",
    "seriesName": "LUTTER RUST",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1666",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2622063855209723.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2622063855209723.jpg"
    ],
    "size": "40x80",
    "color": "Lutter Rust",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Havuz & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Lutter Rust Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Lutter Rust Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1667",
    "brand": "Duratiles",
    "title": "LUTTER RUST Lutter Rust 60x60",
    "seriesName": "LUTTER RUST",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1667",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7166031119665625.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7166031119665625.jpg"
    ],
    "size": "60x60",
    "color": "Lutter Rust",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Havuz & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Lutter Rust Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Lutter Rust Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1668",
    "brand": "Duratiles",
    "title": "LUTTER RUST Lutter Rust 40x40",
    "seriesName": "LUTTER RUST",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1668",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09927401610722286.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09927401610722286.jpg"
    ],
    "size": "40x40",
    "color": "Lutter Rust",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Havuz & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Lutter Rust Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Lutter Rust Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1669",
    "brand": "Duratiles",
    "title": "LYRIC Lyric 20x120",
    "seriesName": "LYRIC",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1669",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.37704979605240774.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.37704979605240774.jpg"
    ],
    "size": "20x120",
    "color": "Lyric",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Yaşadığınız mekanlarda farkınızı yansıtacak olan Lyric Porselen Karoları solmayan güzelliği ile stilinizi yansıtır.</span>",
    "descriptionClean": "Yaşadığınız mekanlarda farkınızı yansıtacak olan Lyric Porselen Karoları solmayan güzelliği ile stilinizi yansıtır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1670",
    "brand": "Duratiles",
    "title": "MAHOPANY Koyu Gri 33x33",
    "seriesName": "MAHOPANY",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1670",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.538318659007288.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.538318659007288.jpg"
    ],
    "size": "33x33",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İlham veren yumuşak renk yelpazesiyle Mahopany Serisi sizi sadeliğin ilham verici dünyasına davet ediyor. Mahopany farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır</span>",
    "descriptionClean": "İlham veren yumuşak renk yelpazesiyle Mahopany Serisi sizi sadeliğin ilham verici dünyasına davet ediyor. Mahopany farklı renk ve ebat seçeneği ile tarz sahibi mekanlar yaratır",
    "source": "duratiles"
  },
  {
    "id": "dura_1671",
    "brand": "Duratiles",
    "title": "MAROON Bej 90x180",
    "seriesName": "MAROON",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1671",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36758719132304774.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36758719132304774.jpg"
    ],
    "size": "90x180",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Banyo & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Endüstriyel Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.</span>",
    "descriptionClean": "Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.",
    "source": "duratiles"
  },
  {
    "id": "dura_1672",
    "brand": "Duratiles",
    "title": "MAROON Gri 90x180",
    "seriesName": "MAROON",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1672",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07258750930050772.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07258750930050772.jpg"
    ],
    "size": "90x180",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.</span>",
    "descriptionClean": "Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.",
    "source": "duratiles"
  },
  {
    "id": "dura_1673",
    "brand": "Duratiles",
    "title": "MAROON Antrasit 90x180",
    "seriesName": "MAROON",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1673",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9603242289890841.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9603242289890841.jpg"
    ],
    "size": "90x180",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.</span>",
    "descriptionClean": "Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.",
    "source": "duratiles"
  },
  {
    "id": "dura_1674",
    "brand": "Duratiles",
    "title": "MAROON Fildişi 90x180",
    "seriesName": "MAROON",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1674",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4448302929711121.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4448302929711121.jpg"
    ],
    "size": "90x180",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.</span>",
    "descriptionClean": "Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.",
    "source": "duratiles"
  },
  {
    "id": "dura_1675",
    "brand": "Duratiles",
    "title": "MAROON Bej 60x120",
    "seriesName": "MAROON",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1675",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6787886230027119.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6787886230027119.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.</span>",
    "descriptionClean": "Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.",
    "source": "duratiles"
  },
  {
    "id": "dura_1676",
    "brand": "Duratiles",
    "title": "MAROON Gri 60x120",
    "seriesName": "MAROON",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1676",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9574665023130453.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9574665023130453.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.</span>",
    "descriptionClean": "Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.",
    "source": "duratiles"
  },
  {
    "id": "dura_1677",
    "brand": "Duratiles",
    "title": "MAROON Antrasit 60x120",
    "seriesName": "MAROON",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1677",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18952779861383484.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18952779861383484.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.</span>",
    "descriptionClean": "Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.",
    "source": "duratiles"
  },
  {
    "id": "dura_1678",
    "brand": "Duratiles",
    "title": "MAROON Bej 120x120",
    "seriesName": "MAROON",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "12278",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3625535486650011.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3625535486650011.jpg"
    ],
    "size": "120x120",
    "color": "Bej",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.</span>",
    "descriptionClean": "Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.",
    "source": "duratiles"
  },
  {
    "id": "dura_1679",
    "brand": "Duratiles",
    "title": "MAROON Gri 120x120",
    "seriesName": "MAROON",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "12277",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9023926906950861.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9023926906950861.jpg"
    ],
    "size": "120x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.</span>",
    "descriptionClean": "Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.",
    "source": "duratiles"
  },
  {
    "id": "dura_1680",
    "brand": "Duratiles",
    "title": "MAROON Antrasit 120x120",
    "seriesName": "MAROON",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "12279",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2571313353264202.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2571313353264202.jpg"
    ],
    "size": "120x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.</span>",
    "descriptionClean": "Doğal fonlar farklı desenlerle buluştu ve Maroon serisini oluşturdu. Farklı seçenekleri başınızı döndürse de tarzınıza uygun bir seçim yapmak elinizde. Tasarımda sınır tanımayanlara fark yaratan bir sunum.",
    "source": "duratiles"
  },
  {
    "id": "dura_1681",
    "brand": "Duratiles",
    "title": "MATTONE Cotto 15x60",
    "seriesName": "MATTONE",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1681",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.908407486213669.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.908407486213669.jpg"
    ],
    "size": "15x60",
    "color": "Cotto",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Modern tarzı ile mekanlara rafine bir şıklık getiren Mattone Porselen Karoları yaşam alanlarınıza rakipsiz bir davetkarlık yaratır.</span>",
    "descriptionClean": "Modern tarzı ile mekanlara rafine bir şıklık getiren Mattone Porselen Karoları yaşam alanlarınıza rakipsiz bir davetkarlık yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1682",
    "brand": "Duratiles",
    "title": "MENSA Bej 45x45",
    "seriesName": "MENSA",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1682",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1657588380434335.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1657588380434335.jpg"
    ],
    "size": "45x45",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ticari Alanlar & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern tarzı ile mekanlara rafine bir şıklık getiren Mensa Porselen Karoları yaşam alanlarınıza rakipsiz bir davetkarlık yaratır.</span>",
    "descriptionClean": "Modern tarzı ile mekanlara rafine bir şıklık getiren Mensa Porselen Karoları yaşam alanlarınıza rakipsiz bir davetkarlık yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1683",
    "brand": "Duratiles",
    "title": "METRO Gri 30x60",
    "seriesName": "METRO",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1683",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08674445628260241.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08674445628260241.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ticari Alanlar & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Metro Serisi hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor</span>",
    "descriptionClean": "Metro Serisi hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1684",
    "brand": "Duratiles",
    "title": "METRO Charcoal 30x60",
    "seriesName": "METRO",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1684",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2866186342926743.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2866186342926743.jpg"
    ],
    "size": "30x60",
    "color": "Charcoal",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ticari Alanlar & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Metro Serisi hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor</span>",
    "descriptionClean": "Metro Serisi hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1685",
    "brand": "Duratiles",
    "title": "METRO Glacier 30x60",
    "seriesName": "METRO",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1685",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6340737307823955.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6340737307823955.jpg"
    ],
    "size": "30x60",
    "color": "Glacier",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ticari Alanlar & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Metro Serisi hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor</span>",
    "descriptionClean": "Metro Serisi hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1686",
    "brand": "Duratiles",
    "title": "METRO Blanco 30x60",
    "seriesName": "METRO",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1686",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9865113858411922.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9865113858411922.jpg"
    ],
    "size": "30x60",
    "color": "Blanco",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ticari Alanlar & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Metro Serisi hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor</span>",
    "descriptionClean": "Metro Serisi hayatın dinamik akışından ilham alan tasarımıyla evinizin enerjisini yükseltiyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1687",
    "brand": "Duratiles",
    "title": "NEWCASTLE Bej 33x33",
    "seriesName": "NEWCASTLE",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1687",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.38868848012434.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.38868848012434.jpg"
    ],
    "size": "33x33",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tasarımında ki farklı yaklaşım ile canlı renklerin ve desenlerin buluştuğu Newcastle serisi yaşam alanlarında değişime öncülük ediyor.</span>",
    "descriptionClean": "Tasarımında ki farklı yaklaşım ile canlı renklerin ve desenlerin buluştuğu Newcastle serisi yaşam alanlarında değişime öncülük ediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1688",
    "brand": "Duratiles",
    "title": "NEWCASTLE Gri 33x33",
    "seriesName": "NEWCASTLE",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1688",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7802553698588257.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7802553698588257.jpg"
    ],
    "size": "33x33",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tasarımında ki farklı yaklaşım ile canlı renklerin ve desenlerin buluştuğu Newcastle serisi yaşam alanlarında değişime öncülük ediyor.</span>",
    "descriptionClean": "Tasarımında ki farklı yaklaşım ile canlı renklerin ve desenlerin buluştuğu Newcastle serisi yaşam alanlarında değişime öncülük ediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1689",
    "brand": "Duratiles",
    "title": "OXFORD Bej 33x33",
    "seriesName": "OXFORD",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1689",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46583066459680844.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46583066459680844.jpg"
    ],
    "size": "33x33",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Oxford Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor</span>",
    "descriptionClean": "Oxford Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1690",
    "brand": "Duratiles",
    "title": "OXFORD Gri 33x33",
    "seriesName": "OXFORD",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1690",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36051801452600807.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36051801452600807.jpg"
    ],
    "size": "33x33",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "V3",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Oxford Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor</span>",
    "descriptionClean": "Oxford Porselen Karoları özgün bir tarz arayanlar için iddialı mekanlar yaratıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1691",
    "brand": "Duratiles",
    "title": "SPANISH Bej 45x45",
    "seriesName": "SPANISH",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1691",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.056090177109257455.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.056090177109257455.jpg"
    ],
    "size": "45x45",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Spanish Serisi mekanlara tarz katan duru güzelliği ile aydınlık ve ferah ambiyanslar yaratır.</span>",
    "descriptionClean": "Spanish Serisi mekanlara tarz katan duru güzelliği ile aydınlık ve ferah ambiyanslar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1692",
    "brand": "Duratiles",
    "title": "SPIL Beyaz 60x60",
    "seriesName": "SPIL",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1692",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4852062113346671.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4852062113346671.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Spil serisinin yumuşak renk tonları ile mekanlara sade olduğu kadar iddialı ve modern bir dokunuş katabilirsiniz.</span>",
    "descriptionClean": "Spil serisinin yumuşak renk tonları ile mekanlara sade olduğu kadar iddialı ve modern bir dokunuş katabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1693",
    "brand": "Duratiles",
    "title": "SPIL Bone 60x60",
    "seriesName": "SPIL",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1693",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16613272992618955.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16613272992618955.jpg"
    ],
    "size": "60x60",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Spil serisinin yumuşak renk tonları ile mekanlara sade olduğu kadar iddialı ve modern bir dokunuş katabilirsiniz.</span>",
    "descriptionClean": "Spil serisinin yumuşak renk tonları ile mekanlara sade olduğu kadar iddialı ve modern bir dokunuş katabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1694",
    "brand": "Duratiles",
    "title": "SPIL Bej 60x60",
    "seriesName": "SPIL",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1694",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7261909168853103.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7261909168853103.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Spil serisinin yumuşak renk tonları ile mekanlara sade olduğu kadar iddialı ve modern bir dokunuş katabilirsiniz.</span>",
    "descriptionClean": "Spil serisinin yumuşak renk tonları ile mekanlara sade olduğu kadar iddialı ve modern bir dokunuş katabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1695",
    "brand": "Duratiles",
    "title": "SPIL Gri 60x60",
    "seriesName": "SPIL",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1695",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7599765443839197.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7599765443839197.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Spil serisinin yumuşak renk tonları ile mekanlara sade olduğu kadar iddialı ve modern bir dokunuş katabilirsiniz.</span>",
    "descriptionClean": "Spil serisinin yumuşak renk tonları ile mekanlara sade olduğu kadar iddialı ve modern bir dokunuş katabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1696",
    "brand": "Duratiles",
    "title": "STRADA Bej 60x120",
    "seriesName": "STRADA",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1696",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6225908909153874.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6225908909153874.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "V2",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaşam alanlarınıza Strada serisinin renkli ,dinamik desenleri ile sıradanlığa meydan okuyan tasarımlara imzanızı atabilirsiniz.</span>",
    "descriptionClean": "Yaşam alanlarınıza Strada serisinin renkli ,dinamik desenleri ile sıradanlığa meydan okuyan tasarımlara imzanızı atabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1697",
    "brand": "Duratiles",
    "title": "STRADA Bej Dekofon 60x120",
    "seriesName": "STRADA",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1697",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7835205680371486.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7835205680371486.jpg"
    ],
    "size": "60x120",
    "color": "Bej Dekofon",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "V2",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaşam alanlarınıza Strada serisinin renkli ,dinamik desenleri ile sıradanlığa meydan okuyan tasarımlara imzanızı atabilirsiniz.</span>",
    "descriptionClean": "Yaşam alanlarınıza Strada serisinin renkli ,dinamik desenleri ile sıradanlığa meydan okuyan tasarımlara imzanızı atabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1698",
    "brand": "Duratiles",
    "title": "TAPPETO Mix Dekor 30x60",
    "seriesName": "TAPPETO",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1698",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.42647560176792043.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.42647560176792043.jpg"
    ],
    "size": "30x60",
    "color": "Mix Dekor",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "DURASTONE",
    "features": [
      "V2",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Desenlerin melodik şarkısını dinleyin. Dekorasyonunuzu desenlerin sunduğu görsel şölen ile zenginleştirin. Tappeto serisinde, farklı renklerin ve desenlerin uyumlu birlikteliği hayat buluyor. Değişimin başlangıç noktası bu seride.</span>",
    "descriptionClean": "Desenlerin melodik şarkısını dinleyin. Dekorasyonunuzu desenlerin sunduğu görsel şölen ile zenginleştirin. Tappeto serisinde, farklı renklerin ve desenlerin uyumlu birlikteliği hayat buluyor. Değişimin başlangıç noktası bu seride.",
    "source": "duratiles"
  },
  {
    "id": "dura_1699",
    "brand": "Duratiles",
    "title": "TOLEDO Bone 30x60",
    "seriesName": "TOLEDO",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1699",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36890301875033626.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36890301875033626.jpg"
    ],
    "size": "30x60",
    "color": "Bone",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "DURASTONE",
    "features": [
      "V2",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı renklerin ve desenlerin küçük karelerde hayat bulmasından doğan Toledo ile mekânların durağan havasını değiştirebilirsiniz.</span>",
    "descriptionClean": "Farklı renklerin ve desenlerin küçük karelerde hayat bulmasından doğan Toledo ile mekânların durağan havasını değiştirebilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1700",
    "brand": "Duratiles",
    "title": "TOLEDO Kahve 30x60",
    "seriesName": "TOLEDO",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1700",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8906245672346011.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8906245672346011.jpg"
    ],
    "size": "30x60",
    "color": "Kahve",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "DURASTONE",
    "features": [
      "V2",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı renklerin ve desenlerin küçük karelerde hayat bulmasından doğan Toledo ile mekânların durağan havasını değiştirebilirsiniz.</span>",
    "descriptionClean": "Farklı renklerin ve desenlerin küçük karelerde hayat bulmasından doğan Toledo ile mekânların durağan havasını değiştirebilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_1701",
    "brand": "Duratiles",
    "title": "TOSCANA Mix Dekor 60x60",
    "seriesName": "TOSCANA",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1701",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6708705528615709.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6708705528615709.jpg"
    ],
    "size": "60x60",
    "color": "Mix Dekor",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Toscana Serisi zarif deseni ile yaşam alanlarınıza hareket katarak canlılık getirmeye devam ediyor</span>",
    "descriptionClean": "Toscana Serisi zarif deseni ile yaşam alanlarınıza hareket katarak canlılık getirmeye devam ediyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1702",
    "brand": "Duratiles",
    "title": "VENTURA Siyah 60x120",
    "seriesName": "VENTURA",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1702",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1285847274506452.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1285847274506452.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Gece ile gündüzün, siyah ile beyazın uyumunu seramiğe yansıttık. Tasarımda zıtlıklardan ilham aldık. Zıt kutupların çekimi ile hayat bulan Ventura serisi zarafete keskin bir dokunuşun simgesi.</span>",
    "descriptionClean": "Gece ile gündüzün, siyah ile beyazın uyumunu seramiğe yansıttık. Tasarımda zıtlıklardan ilham aldık. Zıt kutupların çekimi ile hayat bulan Ventura serisi zarafete keskin bir dokunuşun simgesi.",
    "source": "duratiles"
  },
  {
    "id": "dura_1703",
    "brand": "Duratiles",
    "title": "VENTURA Beyaz 60x120",
    "seriesName": "VENTURA",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1703",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6969065029540601.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6969065029540601.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Gece ile gündüzün, siyah ile beyazın uyumunu seramiğe yansıttık. Tasarımda zıtlıklardan ilham aldık. Zıt kutupların çekimi ile hayat bulan Ventura serisi zarafete keskin bir dokunuşun simgesi.</span>",
    "descriptionClean": "Gece ile gündüzün, siyah ile beyazın uyumunu seramiğe yansıttık. Tasarımda zıtlıklardan ilham aldık. Zıt kutupların çekimi ile hayat bulan Ventura serisi zarafete keskin bir dokunuşun simgesi.",
    "source": "duratiles"
  },
  {
    "id": "dura_1704",
    "brand": "Duratiles",
    "title": "VIETRI Multi 60x60",
    "seriesName": "VIETRI",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1704",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7342436052878445.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7342436052878445.jpg"
    ],
    "size": "60x60",
    "color": "Multi",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğayla uyumun ışığında şekillenen Vietri serisi porselen karoları,iİnce detayları ve özenli tasarımı ile mekanların stillerini yeniden tasarlıyor</span>",
    "descriptionClean": "Doğayla uyumun ışığında şekillenen Vietri serisi porselen karoları,iİnce detayları ve özenli tasarımı ile mekanların stillerini yeniden tasarlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1705",
    "brand": "Duratiles",
    "title": "VIETRI Mono 60x60",
    "seriesName": "VIETRI",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1705",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6219215269072286.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6219215269072286.jpg"
    ],
    "size": "60x60",
    "color": "Mono",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "DURASTONE",
    "features": [
      "V2",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğayla uyumun ışığında şekillenen Vietri serisi porselen karoları,iİnce detayları ve özenli tasarımı ile mekanların stillerini yeniden tasarlıyor</span>",
    "descriptionClean": "Doğayla uyumun ışığında şekillenen Vietri serisi porselen karoları,iİnce detayları ve özenli tasarımı ile mekanların stillerini yeniden tasarlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1706",
    "brand": "Duratiles",
    "title": "ZEN Beyaz 30x60",
    "seriesName": "ZEN",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1706",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5891649360179192.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5891649360179192.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "DURASTONE",
    "features": [
      "Banyo",
      "Ev İçi Zemin",
      "V1"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Duru şıklığı ve modern tarzı ile Zen Serisi yaşam alanlarınızda stilinizi oluştururken size ilham verecek</span>",
    "descriptionClean": "Duru şıklığı ve modern tarzı ile Zen Serisi yaşam alanlarınızda stilinizi oluştururken size ilham verecek",
    "source": "duratiles"
  },
  {
    "id": "dura_1707",
    "brand": "Duratiles",
    "title": "ZEN Siyah 30x60",
    "seriesName": "ZEN",
    "collection": "Özgün",
    "category": "Özgün",
    "sku": "1707",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4481889583862152.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4481889583862152.jpg"
    ],
    "size": "30x60",
    "color": "Siyah",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "DURASTONE",
    "features": [
      "Banyo",
      "Ev İçi Zemin",
      "V1"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Duru şıklığı ve modern tarzı ile Zen Serisi yaşam alanlarınızda stilinizi oluştururken size ilham verecek</span>",
    "descriptionClean": "Duru şıklığı ve modern tarzı ile Zen Serisi yaşam alanlarınızda stilinizi oluştururken size ilham verecek",
    "source": "duratiles"
  },
  {
    "id": "dura_134",
    "brand": "Duratiles",
    "title": "AFFIKS Kahve 15x60",
    "seriesName": "AFFIKS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "134",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9446033945355311.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9446033945355311.jpg"
    ],
    "size": "15x60",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Dış Cephe & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Dış Cephe",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş dokusu ile natürel mekanlara ilham olan Affiks Serisi, modern tarzı ile mekanlara prestij katar.</span>",
    "descriptionClean": "Taş dokusu ile natürel mekanlara ilham olan Affiks Serisi, modern tarzı ile mekanlara prestij katar.",
    "source": "duratiles"
  },
  {
    "id": "dura_135",
    "brand": "Duratiles",
    "title": "AFFIKS Koyu 15x60",
    "seriesName": "AFFIKS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "135",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7049134055369265.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7049134055369265.jpg"
    ],
    "size": "15x60",
    "color": "Koyu",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Dış Cephe & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Dış Cephe",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş dokusu ile natürel mekanlara ilham olan Affiks Serisi, modern tarzı ile mekanlara prestij katar.</span>",
    "descriptionClean": "Taş dokusu ile natürel mekanlara ilham olan Affiks Serisi, modern tarzı ile mekanlara prestij katar.",
    "source": "duratiles"
  },
  {
    "id": "dura_136",
    "brand": "Duratiles",
    "title": "AFFIKS Açık 15x60",
    "seriesName": "AFFIKS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "136",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43337941788011214.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43337941788011214.jpg"
    ],
    "size": "15x60",
    "color": "Açık",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Dış Cephe & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Dış Cephe",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş dokusu ile natürel mekanlara ilham olan Affiks Serisi, modern tarzı ile mekanlara prestij katar.</span>",
    "descriptionClean": "Taş dokusu ile natürel mekanlara ilham olan Affiks Serisi, modern tarzı ile mekanlara prestij katar.",
    "source": "duratiles"
  },
  {
    "id": "dura_147",
    "brand": "Duratiles",
    "title": "AGELESS Beyaz 90x180",
    "seriesName": "AGELESS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "147",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.29173022780301683.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.29173022780301683.jpg"
    ],
    "size": "90x180",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">90x180 cm, 120x120 cm, ve 60x120 cm ebat seçenekleri ile iddialı mekanların mimarı Ageless Serisi beyaz ve gri renk alternatifleri, parlak yüzeyi ve taş dokusuyla ilham veren yaşam alanları yaratır.</span>",
    "descriptionClean": "90x180 cm, 120x120 cm, ve 60x120 cm ebat seçenekleri ile iddialı mekanların mimarı Ageless Serisi beyaz ve gri renk alternatifleri, parlak yüzeyi ve taş dokusuyla ilham veren yaşam alanları yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_148",
    "brand": "Duratiles",
    "title": "AGELESS Beyaz 60x120",
    "seriesName": "AGELESS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "148",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6319570140111678.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6319570140111678.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">90x180 cm, 120x120 cm, ve 60x120 cm ebat seçenekleri ile iddialı mekanların mimarı Ageless Serisi beyaz ve gri renk alternatifleri, parlak yüzeyi ve taş dokusuyla ilham veren yaşam alanları yaratır.</span>",
    "descriptionClean": "90x180 cm, 120x120 cm, ve 60x120 cm ebat seçenekleri ile iddialı mekanların mimarı Ageless Serisi beyaz ve gri renk alternatifleri, parlak yüzeyi ve taş dokusuyla ilham veren yaşam alanları yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_149",
    "brand": "Duratiles",
    "title": "AGELESS Gri 60x120",
    "seriesName": "AGELESS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "149",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.449078109895203.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.449078109895203.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">90x180 cm, 120x120 cm, ve 60x120 cm ebat seçenekleri ile iddialı mekanların mimarı Ageless Serisi beyaz ve gri renk alternatifleri, parlak yüzeyi ve taş dokusuyla ilham veren yaşam alanları yaratır.</span>",
    "descriptionClean": "90x180 cm, 120x120 cm, ve 60x120 cm ebat seçenekleri ile iddialı mekanların mimarı Ageless Serisi beyaz ve gri renk alternatifleri, parlak yüzeyi ve taş dokusuyla ilham veren yaşam alanları yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_151",
    "brand": "Duratiles",
    "title": "AGELESS Beyaz 120x120",
    "seriesName": "AGELESS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "69928",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8035749168132963.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8035749168132963.jpg"
    ],
    "size": "120x120",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">90x180 cm, 120x120 cm, ve 60x120 cm ebat seçenekleri ile iddialı mekanların mimarı Ageless Serisi beyaz ve gri renk alternatifleri, parlak yüzeyi ve taş dokusuyla ilham veren yaşam alanları yaratır.</span>",
    "descriptionClean": "90x180 cm, 120x120 cm, ve 60x120 cm ebat seçenekleri ile iddialı mekanların mimarı Ageless Serisi beyaz ve gri renk alternatifleri, parlak yüzeyi ve taş dokusuyla ilham veren yaşam alanları yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_150",
    "brand": "Duratiles",
    "title": "AGELESS Gri 120x120",
    "seriesName": "AGELESS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "75374",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2755953874570348.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2755953874570348.jpg"
    ],
    "size": "120x120",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">90x180 cm, 120x120 cm, ve 60x120 cm ebat seçenekleri ile iddialı mekanların mimarı Ageless Serisi beyaz ve gri renk alternatifleri, parlak yüzeyi ve taş dokusuyla ilham veren yaşam alanları yaratır.</span>",
    "descriptionClean": "90x180 cm, 120x120 cm, ve 60x120 cm ebat seçenekleri ile iddialı mekanların mimarı Ageless Serisi beyaz ve gri renk alternatifleri, parlak yüzeyi ve taş dokusuyla ilham veren yaşam alanları yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_152",
    "brand": "Duratiles",
    "title": "ALFA Siyah 45x90",
    "seriesName": "ALFA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "152",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8369987446343979.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8369987446343979.jpg"
    ],
    "size": "45x90",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "30mm & 20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.</span>",
    "descriptionClean": "Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.",
    "source": "duratiles"
  },
  {
    "id": "dura_153",
    "brand": "Duratiles",
    "title": "ALFA Gri 45x90",
    "seriesName": "ALFA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "153",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28081525179000855.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28081525179000855.jpg"
    ],
    "size": "45x90",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "30mm & 20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.</span>",
    "descriptionClean": "Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.",
    "source": "duratiles"
  },
  {
    "id": "dura_154",
    "brand": "Duratiles",
    "title": "ALFA Siyah 60x90",
    "seriesName": "ALFA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "154",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.848417057728303.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.848417057728303.jpg"
    ],
    "size": "60x90",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.</span>",
    "descriptionClean": "Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.",
    "source": "duratiles"
  },
  {
    "id": "dura_155",
    "brand": "Duratiles",
    "title": "ALFA Gri 60x90",
    "seriesName": "ALFA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "155",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9783841840207084.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9783841840207084.jpg"
    ],
    "size": "60x90",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.</span>",
    "descriptionClean": "Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.",
    "source": "duratiles"
  },
  {
    "id": "dura_156",
    "brand": "Duratiles",
    "title": "ALFA Siyah 60x120",
    "seriesName": "ALFA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "156",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2468228472451366.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2468228472451366.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.</span>",
    "descriptionClean": "Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.",
    "source": "duratiles"
  },
  {
    "id": "dura_157",
    "brand": "Duratiles",
    "title": "ALFA Gri 60x120",
    "seriesName": "ALFA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "157",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2707167268189985.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2707167268189985.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.</span>",
    "descriptionClean": "Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.",
    "source": "duratiles"
  },
  {
    "id": "dura_159",
    "brand": "Duratiles",
    "title": "ALFA Siyah 40x120",
    "seriesName": "ALFA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "159",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9048353232816101.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9048353232816101.jpg"
    ],
    "size": "40x120",
    "color": "Siyah",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.</span>",
    "descriptionClean": "Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.",
    "source": "duratiles"
  },
  {
    "id": "dura_158",
    "brand": "Duratiles",
    "title": "ALFA Gri 40x120",
    "seriesName": "ALFA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "158",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4611765204134457.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4611765204134457.jpg"
    ],
    "size": "40x120",
    "color": "Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.</span>",
    "descriptionClean": "Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.",
    "source": "duratiles"
  },
  {
    "id": "dura_160",
    "brand": "Duratiles",
    "title": "ALFA Siyah 30x120",
    "seriesName": "ALFA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "160",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9612684732876144.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9612684732876144.jpg"
    ],
    "size": "30x120",
    "color": "Siyah",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.</span>",
    "descriptionClean": "Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.",
    "source": "duratiles"
  },
  {
    "id": "dura_161",
    "brand": "Duratiles",
    "title": "ALFA Gri 30x120",
    "seriesName": "ALFA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "161",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6053080015181435.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6053080015181435.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Mat, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.</span>",
    "descriptionClean": "Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.",
    "source": "duratiles"
  },
  {
    "id": "dura_162",
    "brand": "Duratiles",
    "title": "ALFA Siyah 80x80",
    "seriesName": "ALFA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "162",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.49531213738966484.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.49531213738966484.jpg"
    ],
    "size": "80x80",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.</span>",
    "descriptionClean": "Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.",
    "source": "duratiles"
  },
  {
    "id": "dura_163",
    "brand": "Duratiles",
    "title": "ALFA Gri 80x80",
    "seriesName": "ALFA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "163",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5295662017740677.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5295662017740677.jpg"
    ],
    "size": "80x80",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.</span>",
    "descriptionClean": "Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.",
    "source": "duratiles"
  },
  {
    "id": "dura_164",
    "brand": "Duratiles",
    "title": "ALFA Siyah 40x80",
    "seriesName": "ALFA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "164",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6443580825175136.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6443580825175136.jpg"
    ],
    "size": "40x80",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.</span>",
    "descriptionClean": "Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.",
    "source": "duratiles"
  },
  {
    "id": "dura_165",
    "brand": "Duratiles",
    "title": "ALFA Gri 40x80",
    "seriesName": "ALFA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "165",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6265175952692392.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6265175952692392.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.</span>",
    "descriptionClean": "Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.",
    "source": "duratiles"
  },
  {
    "id": "dura_166",
    "brand": "Duratiles",
    "title": "ALFA Siyah 60x60",
    "seriesName": "ALFA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "166",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23650875320168774.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23650875320168774.jpg"
    ],
    "size": "60x60",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.</span>",
    "descriptionClean": "Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.",
    "source": "duratiles"
  },
  {
    "id": "dura_167",
    "brand": "Duratiles",
    "title": "ALFA Gri 60x60",
    "seriesName": "ALFA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "167",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3267321359823723.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3267321359823723.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.</span>",
    "descriptionClean": "Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.",
    "source": "duratiles"
  },
  {
    "id": "dura_168",
    "brand": "Duratiles",
    "title": "ALFA Siyah 40x40",
    "seriesName": "ALFA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "168",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.011051586820149617.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.011051586820149617.jpg"
    ],
    "size": "40x40",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.</span>",
    "descriptionClean": "Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.",
    "source": "duratiles"
  },
  {
    "id": "dura_169",
    "brand": "Duratiles",
    "title": "ALFA Gri 40x40",
    "seriesName": "ALFA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "169",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.39863803586557056.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.39863803586557056.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.</span>",
    "descriptionClean": "Taş görünümüyle sağlamlığın ve doğallığın altını çizen Alfa Serisi kuru uygulamalarda uzman gerektirmeyen pratik kurulumu ve sağlıklı yapısıyla göz doldurmakta. Alfa Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1708",
    "brand": "Duratiles",
    "title": "AMATA Antrasit 45x90",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1708",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.020837111813363784.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.020837111813363784.jpg"
    ],
    "size": "45x90",
    "color": "Antrasit",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1709",
    "brand": "Duratiles",
    "title": "AMATA Bej 45x90",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1709",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4852624414476262.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4852624414476262.jpg"
    ],
    "size": "45x90",
    "color": "Bej",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1710",
    "brand": "Duratiles",
    "title": "AMATA Kahve 45x90",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1710",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5883124992035748.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5883124992035748.jpg"
    ],
    "size": "45x90",
    "color": "Kahve",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1711",
    "brand": "Duratiles",
    "title": "AMATA Bej 60x90",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1711",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.524663975901779.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.524663975901779.jpg"
    ],
    "size": "60x90",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1712",
    "brand": "Duratiles",
    "title": "AMATA Kahve 60x90",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1712",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17796209327412682.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17796209327412682.jpg"
    ],
    "size": "60x90",
    "color": "Kahve",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1713",
    "brand": "Duratiles",
    "title": "AMATA Antrasit 60x120",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1713",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8873050552660248.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8873050552660248.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1714",
    "brand": "Duratiles",
    "title": "AMATA Bej 60x120",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1714",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2941150096666586.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2941150096666586.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1715",
    "brand": "Duratiles",
    "title": "AMATA Kahve 60x120",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1715",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8918785211844887.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8918785211844887.jpg"
    ],
    "size": "60x120",
    "color": "Kahve",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1716",
    "brand": "Duratiles",
    "title": "AMATA Antrasit 40x120",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1716",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7650315075888229.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7650315075888229.jpg"
    ],
    "size": "40x120",
    "color": "Antrasit",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1717",
    "brand": "Duratiles",
    "title": "AMATA Bej 40x120",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1717",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18548322140301565.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18548322140301565.jpg"
    ],
    "size": "40x120",
    "color": "Bej",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1718",
    "brand": "Duratiles",
    "title": "AMATA Kahve 40x120",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1718",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0851312845071659.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0851312845071659.jpg"
    ],
    "size": "40x120",
    "color": "Kahve",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1719",
    "brand": "Duratiles",
    "title": "AMATA Antrasit 30x120",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1719",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8035334951574907.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8035334951574907.jpg"
    ],
    "size": "30x120",
    "color": "Antrasit",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1720",
    "brand": "Duratiles",
    "title": "AMATA Bej 30x120",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1720",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0429088468269847.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0429088468269847.jpg"
    ],
    "size": "30x120",
    "color": "Bej",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1721",
    "brand": "Duratiles",
    "title": "AMATA Kahve 30x120",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1721",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9506905321765813.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9506905321765813.jpg"
    ],
    "size": "30x120",
    "color": "Kahve",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1722",
    "brand": "Duratiles",
    "title": "AMATA Antrasit 80x80",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1722",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8435522534110775.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8435522534110775.jpg"
    ],
    "size": "80x80",
    "color": "Antrasit",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1723",
    "brand": "Duratiles",
    "title": "AMATA Kahve 80x80",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1723",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7211278211484102.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7211278211484102.jpg"
    ],
    "size": "80x80",
    "color": "Kahve",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1724",
    "brand": "Duratiles",
    "title": "AMATA Bej 80x80",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1724",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20973233638855704.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20973233638855704.jpg"
    ],
    "size": "80x80",
    "color": "Bej",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1725",
    "brand": "Duratiles",
    "title": "AMATA Antrasit 40x80",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1725",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3823647409593661.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3823647409593661.jpg"
    ],
    "size": "40x80",
    "color": "Antrasit",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1726",
    "brand": "Duratiles",
    "title": "AMATA Bej 40x80",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1726",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4665388032965374.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4665388032965374.jpg"
    ],
    "size": "40x80",
    "color": "Bej",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1727",
    "brand": "Duratiles",
    "title": "AMATA Kahve 40x80",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1727",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4008030221279749.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4008030221279749.jpg"
    ],
    "size": "40x80",
    "color": "Kahve",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1728",
    "brand": "Duratiles",
    "title": "AMATA Bej 60x60",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1728",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5524519191703581.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5524519191703581.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1729",
    "brand": "Duratiles",
    "title": "AMATA Antrasit 60x60",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1729",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2038001735021474.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2038001735021474.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1730",
    "brand": "Duratiles",
    "title": "AMATA Kahve 60x60",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1730",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7635277473058916.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7635277473058916.jpg"
    ],
    "size": "60x60",
    "color": "Kahve",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1731",
    "brand": "Duratiles",
    "title": "AMATA Antrasit 40x40",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1731",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8160699740538644.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8160699740538644.jpg"
    ],
    "size": "40x40",
    "color": "Antrasit",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1732",
    "brand": "Duratiles",
    "title": "AMATA Bej 40x40",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1732",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2494765726200996.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2494765726200996.jpg"
    ],
    "size": "40x40",
    "color": "Bej",
    "surface": "Mat, Color Body, Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1733",
    "brand": "Duratiles",
    "title": "AMATA Kahve 40x40",
    "seriesName": "AMATA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1733",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8443175810698562.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8443175810698562.jpg"
    ],
    "size": "40x40",
    "color": "Kahve",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.</span>",
    "descriptionClean": "Amata Serisi yüksek teknik yeterliliği sayesinde özel ve halka açık mekanlar için idealdir. Yoğun insan trafiğinin olduğu ya da mukavemetin ön planda olduğu alanlarda güvenle kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1734",
    "brand": "Duratiles",
    "title": "ANDRAX Basalto 45x45",
    "seriesName": "ANDRAX",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1734",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8709813417998084.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8709813417998084.jpg"
    ],
    "size": "45x45",
    "color": "Basalto",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş görünümü ve mat yüzeyi ile dikkat çeken Andrax Serisi renk ve desen harmonisini mekanlarınıza taşıyarak yaşam alanlarınıza dinamizm katıyor.</span>",
    "descriptionClean": "Taş görünümü ve mat yüzeyi ile dikkat çeken Andrax Serisi renk ve desen harmonisini mekanlarınıza taşıyarak yaşam alanlarınıza dinamizm katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1735",
    "brand": "Duratiles",
    "title": "ANDRAX Piedra 45x45",
    "seriesName": "ANDRAX",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1735",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3620130496700682.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3620130496700682.jpg"
    ],
    "size": "45x45",
    "color": "Piedra",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş görünümü ve mat yüzeyi ile dikkat çeken Andrax Serisi renk ve desen harmonisini mekanlarınıza taşıyarak yaşam alanlarınıza dinamizm katıyor.</span>",
    "descriptionClean": "Taş görünümü ve mat yüzeyi ile dikkat çeken Andrax Serisi renk ve desen harmonisini mekanlarınıza taşıyarak yaşam alanlarınıza dinamizm katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1736",
    "brand": "Duratiles",
    "title": "ANDRAX Gri 45x45",
    "seriesName": "ANDRAX",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1736",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18363591227948628.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18363591227948628.jpg"
    ],
    "size": "45x45",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş görünümü ve mat yüzeyi ile dikkat çeken Andrax Serisi renk ve desen harmonisini mekanlarınıza taşıyarak yaşam alanlarınıza dinamizm katıyor.</span>",
    "descriptionClean": "Taş görünümü ve mat yüzeyi ile dikkat çeken Andrax Serisi renk ve desen harmonisini mekanlarınıza taşıyarak yaşam alanlarınıza dinamizm katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1737",
    "brand": "Duratiles",
    "title": "ARENA Siyah 45x90",
    "seriesName": "ARENA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1737",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5596958566033161.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5596958566033161.jpg"
    ],
    "size": "45x90",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1738",
    "brand": "Duratiles",
    "title": "ARENA Gri 45x90",
    "seriesName": "ARENA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1738",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07052725994487363.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07052725994487363.jpg"
    ],
    "size": "45x90",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1739",
    "brand": "Duratiles",
    "title": "ARENA Siyah 60x90",
    "seriesName": "ARENA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1739",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3646805712115262.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3646805712115262.jpg"
    ],
    "size": "60x90",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1740",
    "brand": "Duratiles",
    "title": "ARENA Gri 60x90",
    "seriesName": "ARENA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1740",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09009842214652974.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09009842214652974.jpg"
    ],
    "size": "60x90",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1741",
    "brand": "Duratiles",
    "title": "ARENA Siyah 60x120",
    "seriesName": "ARENA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1741",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.013336573322076384.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.013336573322076384.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1742",
    "brand": "Duratiles",
    "title": "ARENA Gri 60x120",
    "seriesName": "ARENA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1742",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08527636606243127.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08527636606243127.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1743",
    "brand": "Duratiles",
    "title": "ARENA Siyah 40x120",
    "seriesName": "ARENA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1743",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5012083756474858.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5012083756474858.jpg"
    ],
    "size": "40x120",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1744",
    "brand": "Duratiles",
    "title": "ARENA Gri 40x120",
    "seriesName": "ARENA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1744",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.45080195692587244.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.45080195692587244.jpg"
    ],
    "size": "40x120",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1745",
    "brand": "Duratiles",
    "title": "ARENA Siyah 30x120",
    "seriesName": "ARENA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1745",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.24729809742419873.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.24729809742419873.jpg"
    ],
    "size": "30x120",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1746",
    "brand": "Duratiles",
    "title": "ARENA Gri 30x120",
    "seriesName": "ARENA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1746",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0063661697936142625.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0063661697936142625.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1747",
    "brand": "Duratiles",
    "title": "ARENA Siyah 40x80",
    "seriesName": "ARENA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1747",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5654954185377341.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5654954185377341.jpg"
    ],
    "size": "40x80",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1748",
    "brand": "Duratiles",
    "title": "ARENA Gri 40x80",
    "seriesName": "ARENA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1748",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15666653260686214.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15666653260686214.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1749",
    "brand": "Duratiles",
    "title": "ARENA Siyah 60x60",
    "seriesName": "ARENA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1749",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5065872645984535.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5065872645984535.jpg"
    ],
    "size": "60x60",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1750",
    "brand": "Duratiles",
    "title": "ARENA Gri 60x60",
    "seriesName": "ARENA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1750",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.05794597052791106.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.05794597052791106.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1751",
    "brand": "Duratiles",
    "title": "ARENA Siyah 40x40",
    "seriesName": "ARENA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1751",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08604784287642009.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08604784287642009.jpg"
    ],
    "size": "40x40",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1752",
    "brand": "Duratiles",
    "title": "ARENA Gri 40x40",
    "seriesName": "ARENA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1752",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8142664174692471.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8142664174692471.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.</span>",
    "descriptionClean": "Yalın ve duru bir güzellik arayanların beğenisine sunulan Arena Serisi gri ve siyah renk seçenekleri ile yaşanılası mekanlar yaratmakta. Arena sökülebilir , yenilenebilir ve yeniden kullanılabilir yapısıyla pratik ve çok yaratıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1753",
    "brand": "Duratiles",
    "title": "ARION Taupe 60x120",
    "seriesName": "ARION",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1753",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6426140756569027.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6426140756569027.jpg"
    ],
    "size": "60x120",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "DURASTONE",
    "features": [
      "V2",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yunan mitolojisinden esinlenerek tasarlanan Arion Serisinin farklı renk ve ebat seçeneklerinden oluşan geniş ürün yelpazesinden yararlanarak size özgü mekanlar yaratabilirsiniz. Serinin geniş ürün gamı içinde yer alan dekofon ile yaşam alanlarınızı hareketlendirmek, dinamizm katmak elinizde.</span>",
    "descriptionClean": "Yunan mitolojisinden esinlenerek tasarlanan Arion Serisinin farklı renk ve ebat seçeneklerinden oluşan geniş ürün yelpazesinden yararlanarak size özgü mekanlar yaratabilirsiniz. Serinin geniş ürün gamı içinde yer alan dekofon ile yaşam alanlarınızı hareketlendirmek, dinamizm katmak elinizde.",
    "source": "duratiles"
  },
  {
    "id": "dura_1754",
    "brand": "Duratiles",
    "title": "ARION Taupe 40x120",
    "seriesName": "ARION",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1754",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4244001133558908.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4244001133558908.jpg"
    ],
    "size": "40x120",
    "color": "Taupe",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "DURASTONE",
    "features": [
      "V2",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yunan mitolojisinden esinlenerek tasarlanan Arion Serisinin farklı renk ve ebat seçeneklerinden oluşan geniş ürün yelpazesinden yararlanarak size özgü mekanlar yaratabilirsiniz. Serinin geniş ürün gamı içinde yer alan dekofon ile yaşam alanlarınızı hareketlendirmek, dinamizm katmak elinizde.</span>",
    "descriptionClean": "Yunan mitolojisinden esinlenerek tasarlanan Arion Serisinin farklı renk ve ebat seçeneklerinden oluşan geniş ürün yelpazesinden yararlanarak size özgü mekanlar yaratabilirsiniz. Serinin geniş ürün gamı içinde yer alan dekofon ile yaşam alanlarınızı hareketlendirmek, dinamizm katmak elinizde.",
    "source": "duratiles"
  },
  {
    "id": "dura_1755",
    "brand": "Duratiles",
    "title": "ARION Dekofon 40x120",
    "seriesName": "ARION",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1755",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2614968469537643.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2614968469537643.jpg"
    ],
    "size": "40x120",
    "color": "Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "DURASTONE",
    "features": [
      "V2",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yunan mitolojisinden esinlenerek tasarlanan Arion Serisinin farklı renk ve ebat seçeneklerinden oluşan geniş ürün yelpazesinden yararlanarak size özgü mekanlar yaratabilirsiniz. Serinin geniş ürün gamı içinde yer alan dekofon ile yaşam alanlarınızı hareketlendirmek, dinamizm katmak elinizde.</span>",
    "descriptionClean": "Yunan mitolojisinden esinlenerek tasarlanan Arion Serisinin farklı renk ve ebat seçeneklerinden oluşan geniş ürün yelpazesinden yararlanarak size özgü mekanlar yaratabilirsiniz. Serinin geniş ürün gamı içinde yer alan dekofon ile yaşam alanlarınızı hareketlendirmek, dinamizm katmak elinizde.",
    "source": "duratiles"
  },
  {
    "id": "dura_1756",
    "brand": "Duratiles",
    "title": "ARION Almond 40x120",
    "seriesName": "ARION",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1756",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21263087924106294.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21263087924106294.jpg"
    ],
    "size": "40x120",
    "color": "Almond",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "DURASTONE",
    "features": [
      "V2",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yunan mitolojisinden esinlenerek tasarlanan Arion Serisinin farklı renk ve ebat seçeneklerinden oluşan geniş ürün yelpazesinden yararlanarak size özgü mekanlar yaratabilirsiniz. Serinin geniş ürün gamı içinde yer alan dekofon ile yaşam alanlarınızı hareketlendirmek, dinamizm katmak elinizde.</span>",
    "descriptionClean": "Yunan mitolojisinden esinlenerek tasarlanan Arion Serisinin farklı renk ve ebat seçeneklerinden oluşan geniş ürün yelpazesinden yararlanarak size özgü mekanlar yaratabilirsiniz. Serinin geniş ürün gamı içinde yer alan dekofon ile yaşam alanlarınızı hareketlendirmek, dinamizm katmak elinizde.",
    "source": "duratiles"
  },
  {
    "id": "dura_1757",
    "brand": "Duratiles",
    "title": "ARION Taupe 60x60",
    "seriesName": "ARION",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1757",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.34876282641602896.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.34876282641602896.jpg"
    ],
    "size": "60x60",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "DURASTONE",
    "features": [
      "V2",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yunan mitolojisinden esinlenerek tasarlanan Arion Serisinin farklı renk ve ebat seçeneklerinden oluşan geniş ürün yelpazesinden yararlanarak size özgü mekanlar yaratabilirsiniz. Serinin geniş ürün gamı içinde yer alan dekofon ile yaşam alanlarınızı hareketlendirmek, dinamizm katmak elinizde.</span>",
    "descriptionClean": "Yunan mitolojisinden esinlenerek tasarlanan Arion Serisinin farklı renk ve ebat seçeneklerinden oluşan geniş ürün yelpazesinden yararlanarak size özgü mekanlar yaratabilirsiniz. Serinin geniş ürün gamı içinde yer alan dekofon ile yaşam alanlarınızı hareketlendirmek, dinamizm katmak elinizde.",
    "source": "duratiles"
  },
  {
    "id": "dura_1758",
    "brand": "Duratiles",
    "title": "ARION Taupe 60x60",
    "seriesName": "ARION",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1758",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.897386382435966.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.897386382435966.jpg"
    ],
    "size": "60x60",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "DURASTONE",
    "features": [
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yunan mitolojisinden esinlenerek tasarlanan Arion Serisinin farklı renk ve ebat seçeneklerinden oluşan geniş ürün yelpazesinden yararlanarak size özgü mekanlar yaratabilirsiniz. Serinin geniş ürün gamı içinde yer alan dekofon ile yaşam alanlarınızı hareketlendirmek, dinamizm katmak elinizde.</span>",
    "descriptionClean": "Yunan mitolojisinden esinlenerek tasarlanan Arion Serisinin farklı renk ve ebat seçeneklerinden oluşan geniş ürün yelpazesinden yararlanarak size özgü mekanlar yaratabilirsiniz. Serinin geniş ürün gamı içinde yer alan dekofon ile yaşam alanlarınızı hareketlendirmek, dinamizm katmak elinizde.",
    "source": "duratiles"
  },
  {
    "id": "dura_1759",
    "brand": "Duratiles",
    "title": "ARIZONA Gri 60x60",
    "seriesName": "ARIZONA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1759",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8759400600929101.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8759400600929101.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe & Ev içi Zemin & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern ve minimal çizgileriyle Arizona Porselen Karoları şık tasarımıyla yaşam alanlarınızın atmosferini değiştirecek.</span>",
    "descriptionClean": "Modern ve minimal çizgileriyle Arizona Porselen Karoları şık tasarımıyla yaşam alanlarınızın atmosferini değiştirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1760",
    "brand": "Duratiles",
    "title": "ARIZONA Bej 60x60",
    "seriesName": "ARIZONA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1760",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8753720289351266.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8753720289351266.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Modern ve minimal çizgileriyle Arizona Porselen Karoları şık tasarımıyla yaşam alanlarınızın atmosferini değiştirecek.</span>",
    "descriptionClean": "Modern ve minimal çizgileriyle Arizona Porselen Karoları şık tasarımıyla yaşam alanlarınızın atmosferini değiştirecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1761",
    "brand": "Duratiles",
    "title": "ASTORIA Luna 60x120",
    "seriesName": "ASTORIA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1761",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6328602138868326.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6328602138868326.jpg"
    ],
    "size": "60x120",
    "color": "Luna",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Güzelliğini taş dokusunun doğal yalınlığından alan Astoria Porselen Karoları yaşam alanlarına yeni nesil bir şıklık anlayışı getiriyor.</span>",
    "descriptionClean": "Güzelliğini taş dokusunun doğal yalınlığından alan Astoria Porselen Karoları yaşam alanlarına yeni nesil bir şıklık anlayışı getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1762",
    "brand": "Duratiles",
    "title": "ASTORIA Terra 60x120",
    "seriesName": "ASTORIA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1762",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3380536988122398.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3380536988122398.jpg"
    ],
    "size": "60x120",
    "color": "Terra",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Güzelliğini taş dokusunun doğal yalınlığından alan Astoria Porselen Karoları yaşam alanlarına yeni nesil bir şıklık anlayışı getiriyor.</span>",
    "descriptionClean": "Güzelliğini taş dokusunun doğal yalınlığından alan Astoria Porselen Karoları yaşam alanlarına yeni nesil bir şıklık anlayışı getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1763",
    "brand": "Duratiles",
    "title": "AZUMA Beyaz 100x100",
    "seriesName": "AZUMA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1763",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.37523216373059864.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.37523216373059864.jpg"
    ],
    "size": "100x100",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş dokusunu mat yüzeyi ile daha da belirginleştiren Azuma Serisi dört renk seçeneği ile ilham veren mekanlar yaratmak için tasarlandı.</span>",
    "descriptionClean": "Taş dokusunu mat yüzeyi ile daha da belirginleştiren Azuma Serisi dört renk seçeneği ile ilham veren mekanlar yaratmak için tasarlandı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1764",
    "brand": "Duratiles",
    "title": "AZUMA Gri 100x100",
    "seriesName": "AZUMA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1764",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08539840789800279.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08539840789800279.jpg"
    ],
    "size": "100x100",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş dokusunu mat yüzeyi ile daha da belirginleştiren Azuma Serisi dört renk seçeneği ile ilham veren mekanlar yaratmak için tasarlandı.</span>",
    "descriptionClean": "Taş dokusunu mat yüzeyi ile daha da belirginleştiren Azuma Serisi dört renk seçeneği ile ilham veren mekanlar yaratmak için tasarlandı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1765",
    "brand": "Duratiles",
    "title": "AZUMA Sand 100x100",
    "seriesName": "AZUMA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1765",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19076863165094604.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19076863165094604.jpg"
    ],
    "size": "100x100",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş dokusunu mat yüzeyi ile daha da belirginleştiren Azuma Serisi dört renk seçeneği ile ilham veren mekanlar yaratmak için tasarlandı.</span>",
    "descriptionClean": "Taş dokusunu mat yüzeyi ile daha da belirginleştiren Azuma Serisi dört renk seçeneği ile ilham veren mekanlar yaratmak için tasarlandı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1766",
    "brand": "Duratiles",
    "title": "AZUMA Antrasit 100x100",
    "seriesName": "AZUMA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1766",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9145059357824726.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9145059357824726.jpg"
    ],
    "size": "100x100",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş dokusunu mat yüzeyi ile daha da belirginleştiren Azuma Serisi dört renk seçeneği ile ilham veren mekanlar yaratmak için tasarlandı.</span>",
    "descriptionClean": "Taş dokusunu mat yüzeyi ile daha da belirginleştiren Azuma Serisi dört renk seçeneği ile ilham veren mekanlar yaratmak için tasarlandı.",
    "source": "duratiles"
  },
  {
    "id": "dura_1767",
    "brand": "Duratiles",
    "title": "BELENCO Gri 45x90",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1767",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3144619803426687.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3144619803426687.jpg"
    ],
    "size": "45x90",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "30mm & 20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1768",
    "brand": "Duratiles",
    "title": "BELENCO İce 45x90",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1768",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9626000038840694.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9626000038840694.jpg"
    ],
    "size": "45x90",
    "color": "İce",
    "surface": "Mat , Sırlı Body",
    "thickness": "30mm & 20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1769",
    "brand": "Duratiles",
    "title": "BELENCO Sand 45x90",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1769",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3353042798752184.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3353042798752184.jpg"
    ],
    "size": "45x90",
    "color": "Sand",
    "surface": "Mat , Sırlı Body",
    "thickness": "30mm & 20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1770",
    "brand": "Duratiles",
    "title": "BELENCO Gri 60x90",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1770",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4328169587373776.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4328169587373776.jpg"
    ],
    "size": "60x90",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1771",
    "brand": "Duratiles",
    "title": "BELENCO İce 60x90",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1771",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.47269645430998863.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.47269645430998863.jpg"
    ],
    "size": "60x90",
    "color": "İce",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1772",
    "brand": "Duratiles",
    "title": "BELENCO Sand 60x90",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1772",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8697324737030915.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8697324737030915.jpg"
    ],
    "size": "60x90",
    "color": "Sand",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1773",
    "brand": "Duratiles",
    "title": "BELENCO Gri 60x120",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1773",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9734231674055586.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9734231674055586.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1774",
    "brand": "Duratiles",
    "title": "BELENCO İce 60x120",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1774",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9058652656478737.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9058652656478737.jpg"
    ],
    "size": "60x120",
    "color": "İce",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1775",
    "brand": "Duratiles",
    "title": "BELENCO Sand 60x120",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1775",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3598976698165247.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3598976698165247.jpg"
    ],
    "size": "60x120",
    "color": "Sand",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1776",
    "brand": "Duratiles",
    "title": "BELENCO Gri 40x120",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1776",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8111865080875446.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8111865080875446.jpg"
    ],
    "size": "40x120",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1777",
    "brand": "Duratiles",
    "title": "BELENCO İce 40x120",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1777",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5005379308020682.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5005379308020682.jpg"
    ],
    "size": "40x120",
    "color": "İce",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1778",
    "brand": "Duratiles",
    "title": "BELENCO Sand 40x120",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1778",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2466809082197211.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2466809082197211.jpg"
    ],
    "size": "40x120",
    "color": "Sand",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1779",
    "brand": "Duratiles",
    "title": "BELENCO Gri 30x120",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1779",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.37875472006899824.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.37875472006899824.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1780",
    "brand": "Duratiles",
    "title": "BELENCO İce 30x120",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1780",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7682597092549102.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7682597092549102.jpg"
    ],
    "size": "30x120",
    "color": "İce",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1781",
    "brand": "Duratiles",
    "title": "BELENCO Sand 30x120",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1781",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1612438147327776.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1612438147327776.jpg"
    ],
    "size": "30x120",
    "color": "Sand",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1782",
    "brand": "Duratiles",
    "title": "BELENCO Gri 80x80",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1782",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43683904968679743.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43683904968679743.jpg"
    ],
    "size": "80x80",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1783",
    "brand": "Duratiles",
    "title": "BELENCO İce 80x80",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1783",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28488422114951173.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28488422114951173.jpg"
    ],
    "size": "80x80",
    "color": "İce",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1784",
    "brand": "Duratiles",
    "title": "BELENCO Sand 80x80",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1784",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.771868811286604.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.771868811286604.jpg"
    ],
    "size": "80x80",
    "color": "Sand",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1785",
    "brand": "Duratiles",
    "title": "BELENCO Gri 40x80",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1785",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9887303637409963.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9887303637409963.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1786",
    "brand": "Duratiles",
    "title": "BELENCO İce 40x80",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1786",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5824419795451071.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5824419795451071.jpg"
    ],
    "size": "40x80",
    "color": "İce",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1787",
    "brand": "Duratiles",
    "title": "BELENCO Sand 40x80",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1787",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6854370970082256.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6854370970082256.jpg"
    ],
    "size": "40x80",
    "color": "Sand",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1788",
    "brand": "Duratiles",
    "title": "BELENCO Gri 60x60",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1788",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8545165445350994.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8545165445350994.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1789",
    "brand": "Duratiles",
    "title": "BELENCO İce 60x60",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1789",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8517139776095146.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8517139776095146.jpg"
    ],
    "size": "60x60",
    "color": "İce",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1790",
    "brand": "Duratiles",
    "title": "BELENCO Sand 60x60",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1790",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4277728112846364.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4277728112846364.jpg"
    ],
    "size": "60x60",
    "color": "Sand",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1791",
    "brand": "Duratiles",
    "title": "BELENCO Gri 40x40",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1791",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.32500787272019516.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.32500787272019516.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1792",
    "brand": "Duratiles",
    "title": "BELENCO İce 40x40",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1792",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5479405450309057.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5479405450309057.jpg"
    ],
    "size": "40x40",
    "color": "İce",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1793",
    "brand": "Duratiles",
    "title": "BELENCO Sand 40x40",
    "seriesName": "BELENCO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1793",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14215393564343426.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14215393564343426.jpg"
    ],
    "size": "40x40",
    "color": "Sand",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Belenco Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz .Otel ve kurumsal firmalarda, ağır malzemelerin bulunduğu ve düşme ihtimali olduğu mekanlarda ,çatlamaya ve kırılmaya karşı dayanıklı yapısıyla güvenle kullanılır ve ekonomik bir seçimdir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1794",
    "brand": "Duratiles",
    "title": "BLUE STONE Siyah 60x90",
    "seriesName": "BLUE STONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1794",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6927036230992087.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6927036230992087.jpg"
    ],
    "size": "60x90",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Siyahın cazibesini beraberinde getiren Blue Stone yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır. Kuru döşeme alternatifine sahip olan Blue Stone Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Siyahın cazibesini beraberinde getiren Blue Stone yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır. Kuru döşeme alternatifine sahip olan Blue Stone Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1795",
    "brand": "Duratiles",
    "title": "BLUE STONE Siyah 45x90",
    "seriesName": "BLUE STONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1795",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.278605961549942.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.278605961549942.jpg"
    ],
    "size": "45x90",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Siyahın cazibesini beraberinde getiren Blue Stone yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır. Kuru döşeme alternatifine sahip olan Blue Stone Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Siyahın cazibesini beraberinde getiren Blue Stone yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır. Kuru döşeme alternatifine sahip olan Blue Stone Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1796",
    "brand": "Duratiles",
    "title": "BLUE STONE Siyah 60x120",
    "seriesName": "BLUE STONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1796",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.25210537281430634.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.25210537281430634.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Siyahın cazibesini beraberinde getiren Blue Stone yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır. Kuru döşeme alternatifine sahip olan Blue Stone Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Siyahın cazibesini beraberinde getiren Blue Stone yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır. Kuru döşeme alternatifine sahip olan Blue Stone Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1797",
    "brand": "Duratiles",
    "title": "BLUE STONE Siyah 40x120",
    "seriesName": "BLUE STONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1797",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.062034657694612916.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.062034657694612916.jpg"
    ],
    "size": "40x120",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Siyahın cazibesini beraberinde getiren Blue Stone yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır. Kuru döşeme alternatifine sahip olan Blue Stone Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Siyahın cazibesini beraberinde getiren Blue Stone yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır. Kuru döşeme alternatifine sahip olan Blue Stone Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1798",
    "brand": "Duratiles",
    "title": "BLUE STONE Siyah 30x120",
    "seriesName": "BLUE STONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1798",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6353626166515126.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6353626166515126.jpg"
    ],
    "size": "30x120",
    "color": "Siyah",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Siyahın cazibesini beraberinde getiren Blue Stone yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır. Kuru döşeme alternatifine sahip olan Blue Stone Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Siyahın cazibesini beraberinde getiren Blue Stone yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır. Kuru döşeme alternatifine sahip olan Blue Stone Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1799",
    "brand": "Duratiles",
    "title": "BLUE STONE Siyah 80x80",
    "seriesName": "BLUE STONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1799",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5531711731353666.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5531711731353666.jpg"
    ],
    "size": "80x80",
    "color": "Siyah",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Siyahın cazibesini beraberinde getiren Blue Stone yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır. Kuru döşeme alternatifine sahip olan Blue Stone Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Siyahın cazibesini beraberinde getiren Blue Stone yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır. Kuru döşeme alternatifine sahip olan Blue Stone Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1800",
    "brand": "Duratiles",
    "title": "BLUE STONE Siyah 40x80",
    "seriesName": "BLUE STONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1800",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1920069596325653.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1920069596325653.jpg"
    ],
    "size": "40x80",
    "color": "Siyah",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Siyahın cazibesini beraberinde getiren Blue Stone yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır. Kuru döşeme alternatifine sahip olan Blue Stone Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Siyahın cazibesini beraberinde getiren Blue Stone yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır. Kuru döşeme alternatifine sahip olan Blue Stone Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1801",
    "brand": "Duratiles",
    "title": "BLUE STONE Siyah 60x60",
    "seriesName": "BLUE STONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1801",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.133977844830945.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.133977844830945.jpg"
    ],
    "size": "60x60",
    "color": "Siyah",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Siyahın cazibesini beraberinde getiren Blue Stone yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır. Kuru döşeme alternatifine sahip olan Blue Stone Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Siyahın cazibesini beraberinde getiren Blue Stone yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır. Kuru döşeme alternatifine sahip olan Blue Stone Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1802",
    "brand": "Duratiles",
    "title": "BLUE STONE Siyah 40x40",
    "seriesName": "BLUE STONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1802",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6340926518767976.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6340926518767976.jpg"
    ],
    "size": "40x40",
    "color": "Siyah",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Siyahın cazibesini beraberinde getiren Blue Stone yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır. Kuru döşeme alternatifine sahip olan Blue Stone Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.</span>",
    "descriptionClean": "Siyahın cazibesini beraberinde getiren Blue Stone yüksek teknik yeterliliğinin yanı sıra estetik görünümü ve fonksiyonel yapısıyla çağdaş ve özgün mekanlar yaratır. Kuru döşeme alternatifine sahip olan Blue Stone Serisi kimseye ihtiyaç duymadan pratik olarak döşeme yapabilmenize imkân tanır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1803",
    "brand": "Duratiles",
    "title": "BOSTON Fildişi 45x45",
    "seriesName": "BOSTON",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1803",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.209976317608762.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.209976317608762.jpg"
    ],
    "size": "45x45",
    "color": "Fildişi",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Banyo & Dış Cephe & Ev içi Zemin",
    "technology": "Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zarafetin çizgilerini doğanın rengiyle çizdik. Doğanın ruhuna uygun tasarımlarımızla, ayrıntılara düşkün anlayışımızla işte karşınızda Boston Serisi porselen karoları.</span>",
    "descriptionClean": "Zarafetin çizgilerini doğanın rengiyle çizdik. Doğanın ruhuna uygun tasarımlarımızla, ayrıntılara düşkün anlayışımızla işte karşınızda Boston Serisi porselen karoları.",
    "source": "duratiles"
  },
  {
    "id": "dura_1804",
    "brand": "Duratiles",
    "title": "BOSTON Gri 45x45",
    "seriesName": "BOSTON",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1804",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7471219999772029.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7471219999772029.jpg"
    ],
    "size": "45x45",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Ev içi Zemin",
    "technology": "Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zarafetin çizgilerini doğanın rengiyle çizdik. Doğanın ruhuna uygun tasarımlarımızla, ayrıntılara düşkün anlayışımızla işte karşınızda Boston Serisi porselen karoları.</span>",
    "descriptionClean": "Zarafetin çizgilerini doğanın rengiyle çizdik. Doğanın ruhuna uygun tasarımlarımızla, ayrıntılara düşkün anlayışımızla işte karşınızda Boston Serisi porselen karoları.",
    "source": "duratiles"
  },
  {
    "id": "dura_1805",
    "brand": "Duratiles",
    "title": "BOSTON Kahve 45x45",
    "seriesName": "BOSTON",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1805",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.958674948040249.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.958674948040249.jpg"
    ],
    "size": "45x45",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "V3",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zarafetin çizgilerini doğanın rengiyle çizdik. Doğanın ruhuna uygun tasarımlarımızla, ayrıntılara düşkün anlayışımızla işte karşınızda Boston Serisi porselen karoları.</span>",
    "descriptionClean": "Zarafetin çizgilerini doğanın rengiyle çizdik. Doğanın ruhuna uygun tasarımlarımızla, ayrıntılara düşkün anlayışımızla işte karşınızda Boston Serisi porselen karoları.",
    "source": "duratiles"
  },
  {
    "id": "dura_1807",
    "brand": "Duratiles",
    "title": "BRETANA Gri 30x60",
    "seriesName": "BRETANA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1807",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15424390791059195.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15424390791059195.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Bretana Porselen Karoları ile yaşadığınız mekanlarda farkınızı yansıtabilir , çarpıcı dokusu ve rengiyle evinize rafine bir şıklık katabilirsiniz .</span>",
    "descriptionClean": "Bretana Porselen Karoları ile yaşadığınız mekanlarda farkınızı yansıtabilir , çarpıcı dokusu ve rengiyle evinize rafine bir şıklık katabilirsiniz .",
    "source": "duratiles"
  },
  {
    "id": "dura_1806",
    "brand": "Duratiles",
    "title": "BRETANA Bej 30x60",
    "seriesName": "BRETANA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1806",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48483064314702606.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.48483064314702606.jpg"
    ],
    "size": "30x60",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Bretana Porselen Karoları ile yaşadığınız mekanlarda farkınızı yansıtabilir , çarpıcı dokusu ve rengiyle evinize rafine bir şıklık katabilirsiniz .</span>",
    "descriptionClean": "Bretana Porselen Karoları ile yaşadığınız mekanlarda farkınızı yansıtabilir , çarpıcı dokusu ve rengiyle evinize rafine bir şıklık katabilirsiniz .",
    "source": "duratiles"
  },
  {
    "id": "dura_1808",
    "brand": "Duratiles",
    "title": "BRICK Bej 30x60",
    "seriesName": "BRICK",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1808",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07212740315799215.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07212740315799215.jpg"
    ],
    "size": "30x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Brick Serisi yaşam alanlarınıza karakteristik bir görünüm kazandırarak farklı olmanın dekoratif yollarını sunuyor.</span>",
    "descriptionClean": "Brick Serisi yaşam alanlarınıza karakteristik bir görünüm kazandırarak farklı olmanın dekoratif yollarını sunuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1809",
    "brand": "Duratiles",
    "title": "BRICK Gri 30x60",
    "seriesName": "BRICK",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1809",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5571512184239137.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5571512184239137.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Brick Serisi yaşam alanlarınıza karakteristik bir görünüm kazandırarak farklı olmanın dekoratif yollarını sunuyor.</span>",
    "descriptionClean": "Brick Serisi yaşam alanlarınıza karakteristik bir görünüm kazandırarak farklı olmanın dekoratif yollarını sunuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1810",
    "brand": "Duratiles",
    "title": "BRICK Kahve 30x60",
    "seriesName": "BRICK",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1810",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8498274410840421.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8498274410840421.jpg"
    ],
    "size": "30x60",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Brick Serisi yaşam alanlarınıza karakteristik bir görünüm kazandırarak farklı olmanın dekoratif yollarını sunuyor.</span>",
    "descriptionClean": "Brick Serisi yaşam alanlarınıza karakteristik bir görünüm kazandırarak farklı olmanın dekoratif yollarını sunuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1811",
    "brand": "Duratiles",
    "title": "CALMENTE Bej 45x90",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1811",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6266811336479895.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6266811336479895.jpg"
    ],
    "size": "45x90",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1812",
    "brand": "Duratiles",
    "title": "CALMENTE Grau 45x90",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1812",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6488612113817328.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6488612113817328.jpg"
    ],
    "size": "45x90",
    "color": "Grau",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1813",
    "brand": "Duratiles",
    "title": "CALMENTE Schwarz 45x90",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1813",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5713098381526392.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5713098381526392.jpg"
    ],
    "size": "45x90",
    "color": "Schwarz",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1814",
    "brand": "Duratiles",
    "title": "CALMENTE Bej 60x90",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1814",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7294799754848864.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7294799754848864.jpg"
    ],
    "size": "60x90",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1815",
    "brand": "Duratiles",
    "title": "CALMENTE Schwarz 60x90",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1815",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5083131393743413.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5083131393743413.jpg"
    ],
    "size": "60x90",
    "color": "Schwarz",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1816",
    "brand": "Duratiles",
    "title": "CALMENTE Grau 60x90",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1816",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8758996541820748.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8758996541820748.jpg"
    ],
    "size": "60x90",
    "color": "Grau",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1817",
    "brand": "Duratiles",
    "title": "CALMENTE Bej 60x120",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1817",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43355560903645896.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43355560903645896.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1819",
    "brand": "Duratiles",
    "title": "CALMENTE Schwarz 60x120",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1819",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8638226313228969.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8638226313228969.jpg"
    ],
    "size": "60x120",
    "color": "Schwarz",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1818",
    "brand": "Duratiles",
    "title": "CALMENTE Grau 60x120",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1818",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8607087519782969.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8607087519782969.jpg"
    ],
    "size": "60x120",
    "color": "Grau",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1820",
    "brand": "Duratiles",
    "title": "CALMENTE Bej 40x120",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1820",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5135164866256043.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5135164866256043.jpg"
    ],
    "size": "40x120",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Havuz & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1821",
    "brand": "Duratiles",
    "title": "CALMENTE Schwarz 40x120",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1821",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30786908442319527.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30786908442319527.jpg"
    ],
    "size": "40x120",
    "color": "Schwarz",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1822",
    "brand": "Duratiles",
    "title": "CALMENTE Grau 40x120",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1822",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09752426544295856.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09752426544295856.jpg"
    ],
    "size": "40x120",
    "color": "Grau",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ev İçi Zemin",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1824",
    "brand": "Duratiles",
    "title": "CALMENTE Bej 30x120",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1824",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21804575795378855.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21804575795378855.jpg"
    ],
    "size": "30x120",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1825",
    "brand": "Duratiles",
    "title": "CALMENTE Schwarz 30x120",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1825",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19002539344158398.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19002539344158398.jpg"
    ],
    "size": "30x120",
    "color": "Schwarz",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1823",
    "brand": "Duratiles",
    "title": "CALMENTE Grau 30x120",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1823",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8516177923394551.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8516177923394551.jpg"
    ],
    "size": "30x120",
    "color": "Grau",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1826",
    "brand": "Duratiles",
    "title": "CALMENTE Bej 80x80",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1826",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4653794096507262.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4653794096507262.jpg"
    ],
    "size": "80x80",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1827",
    "brand": "Duratiles",
    "title": "CALMENTE Schwarz 80x80",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1827",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9763534955945183.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9763534955945183.jpg"
    ],
    "size": "80x80",
    "color": "Schwarz",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1828",
    "brand": "Duratiles",
    "title": "CALMENTE Grau 80x80",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1828",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5144327941248918.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5144327941248918.jpg"
    ],
    "size": "80x80",
    "color": "Grau",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1829",
    "brand": "Duratiles",
    "title": "CALMENTE Bej 40x80",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1829",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5402598306788599.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5402598306788599.jpg"
    ],
    "size": "40x80",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1830",
    "brand": "Duratiles",
    "title": "CALMENTE Schwarz 40x80",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1830",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7359770189929143.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7359770189929143.jpg"
    ],
    "size": "40x80",
    "color": "Schwarz",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1831",
    "brand": "Duratiles",
    "title": "CALMENTE Grau 40x80",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1831",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1954027433593789.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1954027433593789.jpg"
    ],
    "size": "40x80",
    "color": "Grau",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1832",
    "brand": "Duratiles",
    "title": "CALMENTE Bej 60x60",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1832",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.826687856483665.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.826687856483665.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Havuz & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1833",
    "brand": "Duratiles",
    "title": "CALMENTE Schwarz 60x60",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1833",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7978075955058163.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7978075955058163.jpg"
    ],
    "size": "60x60",
    "color": "Schwarz",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Havuz & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1834",
    "brand": "Duratiles",
    "title": "CALMENTE Grau 60x60",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1834",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7275076683748717.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7275076683748717.jpg"
    ],
    "size": "60x60",
    "color": "Grau",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Havuz & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1835",
    "brand": "Duratiles",
    "title": "CALMENTE Bej 40x40",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1835",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5120888897665014.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5120888897665014.jpg"
    ],
    "size": "40x40",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Havuz & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1836",
    "brand": "Duratiles",
    "title": "CALMENTE Schwarz 40x40",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1836",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.512878743192526.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.512878743192526.jpg"
    ],
    "size": "40x40",
    "color": "Schwarz",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Havuz & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1837",
    "brand": "Duratiles",
    "title": "CALMENTE Grau 40x40",
    "seriesName": "CALMENTE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1837",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7772959203732135.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7772959203732135.jpg"
    ],
    "size": "40x40",
    "color": "Grau",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Havuz & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Havuz",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .</span>",
    "descriptionClean": "Calmente Serisi ,yapıştırıcı tekniği uygulanan uygulamalarda özel kalınlığı sayesinde kırılma ve çatlamalara karşı üstün dayanıklılık gösterir .",
    "source": "duratiles"
  },
  {
    "id": "dura_1838",
    "brand": "Duratiles",
    "title": "CAMARQUE Krem 60x120",
    "seriesName": "CAMARQUE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1838",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9891751078354402.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9891751078354402.jpg"
    ],
    "size": "60x120",
    "color": "Krem",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Camarque, özgün dokusundan aldığı ilhamla doğal taşın zarafetini modern çizgilerle yeniden yorumlar.</span>",
    "descriptionClean": "Camarque, özgün dokusundan aldığı ilhamla doğal taşın zarafetini modern çizgilerle yeniden yorumlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_1839",
    "brand": "Duratiles",
    "title": "CAMARQUE Gris 60x120",
    "seriesName": "CAMARQUE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1839",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5483661425495187.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5483661425495187.jpg"
    ],
    "size": "60x120",
    "color": "Gris",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Camarque, özgün dokusundan aldığı ilhamla doğal taşın zarafetini modern çizgilerle yeniden yorumlar.</span>",
    "descriptionClean": "Camarque, özgün dokusundan aldığı ilhamla doğal taşın zarafetini modern çizgilerle yeniden yorumlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_1840",
    "brand": "Duratiles",
    "title": "CAMARQUE Marrone 60x120",
    "seriesName": "CAMARQUE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1840",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3138150130639269.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3138150130639269.jpg"
    ],
    "size": "60x120",
    "color": "Marrone",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Camarque, özgün dokusundan aldığı ilhamla doğal taşın zarafetini modern çizgilerle yeniden yorumlar.</span>",
    "descriptionClean": "Camarque, özgün dokusundan aldığı ilhamla doğal taşın zarafetini modern çizgilerle yeniden yorumlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_1841",
    "brand": "Duratiles",
    "title": "CAMARQUE Krem 60x60",
    "seriesName": "CAMARQUE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1841",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4456132269193358.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4456132269193358.jpg"
    ],
    "size": "60x60",
    "color": "Krem",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Camarque, özgün dokusundan aldığı ilhamla doğal taşın zarafetini modern çizgilerle yeniden yorumlar.</span>",
    "descriptionClean": "Camarque, özgün dokusundan aldığı ilhamla doğal taşın zarafetini modern çizgilerle yeniden yorumlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_1842",
    "brand": "Duratiles",
    "title": "CAMARQUE Gris 60x60",
    "seriesName": "CAMARQUE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1842",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6968767122071498.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6968767122071498.jpg"
    ],
    "size": "60x60",
    "color": "Gris",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Camarque, özgün dokusundan aldığı ilhamla doğal taşın zarafetini modern çizgilerle yeniden yorumlar.</span>",
    "descriptionClean": "Camarque, özgün dokusundan aldığı ilhamla doğal taşın zarafetini modern çizgilerle yeniden yorumlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_1843",
    "brand": "Duratiles",
    "title": "CAMARQUE Marrone 60x60",
    "seriesName": "CAMARQUE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1843",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07871017806439617.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07871017806439617.jpg"
    ],
    "size": "60x60",
    "color": "Marrone",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Banyo",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Camarque, özgün dokusundan aldığı ilhamla doğal taşın zarafetini modern çizgilerle yeniden yorumlar.</span>",
    "descriptionClean": "Camarque, özgün dokusundan aldığı ilhamla doğal taşın zarafetini modern çizgilerle yeniden yorumlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_1844",
    "brand": "Duratiles",
    "title": "COMO Gri 60x90",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1844",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5205849220568216.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5205849220568216.jpg"
    ],
    "size": "60x90",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1845",
    "brand": "Duratiles",
    "title": "COMO Sand 60x90",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1845",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18146616016139983.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18146616016139983.jpg"
    ],
    "size": "60x90",
    "color": "Sand",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1846",
    "brand": "Duratiles",
    "title": "COMO Bej 60x90",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1846",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5304857701924175.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5304857701924175.jpg"
    ],
    "size": "60x90",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1847",
    "brand": "Duratiles",
    "title": "COMO Kül 60x90",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1847",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4255934663408715.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4255934663408715.jpg"
    ],
    "size": "60x90",
    "color": "Kül",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1848",
    "brand": "Duratiles",
    "title": "COMO Gri 45x90",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1848",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6090543297426909.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6090543297426909.jpg"
    ],
    "size": "45x90",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1851",
    "brand": "Duratiles",
    "title": "COMO Sand 45x90",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1851",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6102787771374782.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6102787771374782.jpg"
    ],
    "size": "45x90",
    "color": "Sand",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1849",
    "brand": "Duratiles",
    "title": "COMO Bej 45x90",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1849",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.05423860475442266.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.05423860475442266.jpg"
    ],
    "size": "45x90",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1850",
    "brand": "Duratiles",
    "title": "COMO Kül 45x90",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1850",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9971637024104686.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9971637024104686.jpg"
    ],
    "size": "45x90",
    "color": "Kül",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1852",
    "brand": "Duratiles",
    "title": "COMO Kül 60x120",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1852",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6225950699871875.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6225950699871875.jpg"
    ],
    "size": "60x120",
    "color": "Kül",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1853",
    "brand": "Duratiles",
    "title": "COMO Bej 60x120",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1853",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4290179857740699.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4290179857740699.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2332",
    "brand": "Duratiles",
    "title": "COMO Gri 60x120",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2332",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1279978500725556.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1279978500725556.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2331",
    "brand": "Duratiles",
    "title": "COMO Sand 60x120",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2331",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2418676041924136.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2418676041924136.jpg"
    ],
    "size": "60x120",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1857",
    "brand": "Duratiles",
    "title": "COMO Gri 40x120",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1857",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4584603396496366.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4584603396496366.jpg"
    ],
    "size": "40x120",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1854",
    "brand": "Duratiles",
    "title": "COMO Sand 40x120",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1854",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9457201773138693.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9457201773138693.jpg"
    ],
    "size": "40x120",
    "color": "Sand",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1856",
    "brand": "Duratiles",
    "title": "COMO Bej 40x120",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1856",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6864158613030125.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6864158613030125.jpg"
    ],
    "size": "40x120",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1855",
    "brand": "Duratiles",
    "title": "COMO Kül 40x120",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1855",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7822587897771575.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7822587897771575.jpg"
    ],
    "size": "40x120",
    "color": "Kül",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1861",
    "brand": "Duratiles",
    "title": "COMO Gri 30x120",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1861",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1427919811259255.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1427919811259255.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1860",
    "brand": "Duratiles",
    "title": "COMO Sand 30x120",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1860",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.515891462008859.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.515891462008859.jpg"
    ],
    "size": "30x120",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1859",
    "brand": "Duratiles",
    "title": "COMO Bej 30x120",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1859",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.328484393427531.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.328484393427531.jpg"
    ],
    "size": "30x120",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1858",
    "brand": "Duratiles",
    "title": "COMO Kül 30x120",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1858",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9327417855040212.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9327417855040212.jpg"
    ],
    "size": "30x120",
    "color": "Kül",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1865",
    "brand": "Duratiles",
    "title": "COMO Gri 80x80",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1865",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9692672472727691.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9692672472727691.jpg"
    ],
    "size": "80x80",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1864",
    "brand": "Duratiles",
    "title": "COMO Sand 80x80",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1864",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6737157306512217.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6737157306512217.jpg"
    ],
    "size": "80x80",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1863",
    "brand": "Duratiles",
    "title": "COMO Bej 80x80",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1863",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.854555324679617.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.854555324679617.jpg"
    ],
    "size": "80x80",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1862",
    "brand": "Duratiles",
    "title": "COMO Kül 80x80",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1862",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36043631883995997.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36043631883995997.jpg"
    ],
    "size": "80x80",
    "color": "Kül",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1869",
    "brand": "Duratiles",
    "title": "COMO Gri 40x80",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1869",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.38717290322666686.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.38717290322666686.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1868",
    "brand": "Duratiles",
    "title": "COMO Sand 40x80",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1868",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9621678620731519.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9621678620731519.jpg"
    ],
    "size": "40x80",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1867",
    "brand": "Duratiles",
    "title": "COMO Bej 40x80",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1867",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1403471269291936.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1403471269291936.jpg"
    ],
    "size": "40x80",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1866",
    "brand": "Duratiles",
    "title": "COMO Kül 40x80",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1866",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.827453078534882.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.827453078534882.jpg"
    ],
    "size": "40x80",
    "color": "Kül",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1873",
    "brand": "Duratiles",
    "title": "COMO Gri 60x60",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1873",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6610139350091341.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6610139350091341.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1872",
    "brand": "Duratiles",
    "title": "COMO Sand 60x60",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1872",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0005708464715017403.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0005708464715017403.jpg"
    ],
    "size": "60x60",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1871",
    "brand": "Duratiles",
    "title": "COMO Bej 60x60",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1871",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3811825478007944.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3811825478007944.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1870",
    "brand": "Duratiles",
    "title": "COMO Kül 60x60",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1870",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.979591540780639.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.979591540780639.jpg"
    ],
    "size": "60x60",
    "color": "Kül",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1877",
    "brand": "Duratiles",
    "title": "COMO Gri 40x40",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1877",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.019021205887015724.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.019021205887015724.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1876",
    "brand": "Duratiles",
    "title": "COMO Sand 40x40",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1876",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7768033672795961.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7768033672795961.jpg"
    ],
    "size": "40x40",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1875",
    "brand": "Duratiles",
    "title": "COMO Bej 40x40",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1875",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6976576592225432.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6976576592225432.jpg"
    ],
    "size": "40x40",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1874",
    "brand": "Duratiles",
    "title": "COMO Kül 40x40",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1874",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5183794711075247.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5183794711075247.jpg"
    ],
    "size": "40x40",
    "color": "Kül",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1879",
    "brand": "Duratiles",
    "title": "COMO Krem 30x60",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1879",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3105107519507573.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3105107519507573.jpg"
    ],
    "size": "30x60",
    "color": "Krem",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1878",
    "brand": "Duratiles",
    "title": "COMO Beyaz 30x60",
    "seriesName": "COMO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1878",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5429201954773215.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5429201954773215.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.</span>",
    "descriptionClean": "Como Serisi ,estetik duru görünümünü güçlü sağlam yapısıyla birleştirerek ,yaşam alanlarınıza uzun ömürlü konforu getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1880",
    "brand": "Duratiles",
    "title": "CORAL Beyaz 30x60",
    "seriesName": "CORAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1880",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43065663228947715.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43065663228947715.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Grinin kusursuz uyumunu yansıtan Coral Porselen Karoları ile dingin ve yalın iç mekan kurguları yaratabilirsiniz .</span>",
    "descriptionClean": "Grinin kusursuz uyumunu yansıtan Coral Porselen Karoları ile dingin ve yalın iç mekan kurguları yaratabilirsiniz .",
    "source": "duratiles"
  },
  {
    "id": "dura_1881",
    "brand": "Duratiles",
    "title": "CROSS Koyu Gri 60x60",
    "seriesName": "CROSS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1881",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9351812704808693.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9351812704808693.jpg"
    ],
    "size": "60x60",
    "color": "Koyu Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Yaşadığınız mekanlarda farkınızı yansıtacak olan Cross Porselen Karoları solmayan güzelliği ile stilinizi yansıtır.</span>",
    "descriptionClean": "Yaşadığınız mekanlarda farkınızı yansıtacak olan Cross Porselen Karoları solmayan güzelliği ile stilinizi yansıtır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1882",
    "brand": "Duratiles",
    "title": "CROSS Gri 60x60",
    "seriesName": "CROSS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1882",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8318111426014144.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8318111426014144.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Yaşadığınız mekanlarda farkınızı yansıtacak olan Cross Porselen Karoları solmayan güzelliği ile stilinizi yansıtır.</span>",
    "descriptionClean": "Yaşadığınız mekanlarda farkınızı yansıtacak olan Cross Porselen Karoları solmayan güzelliği ile stilinizi yansıtır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1883",
    "brand": "Duratiles",
    "title": "CROSS Fildişi 60x60",
    "seriesName": "CROSS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1883",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4211117119261657.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4211117119261657.jpg"
    ],
    "size": "60x60",
    "color": "Fildişi",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Yaşadığınız mekanlarda farkınızı yansıtacak olan Cross Porselen Karoları solmayan güzelliği ile stilinizi yansıtır.</span>",
    "descriptionClean": "Yaşadığınız mekanlarda farkınızı yansıtacak olan Cross Porselen Karoları solmayan güzelliği ile stilinizi yansıtır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1884",
    "brand": "Duratiles",
    "title": "DEEP Siyah 45x90",
    "seriesName": "DEEP",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1884",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30237146160446005.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30237146160446005.jpg"
    ],
    "size": "45x90",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Deep Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Deep Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz",
    "source": "duratiles"
  },
  {
    "id": "dura_1885",
    "brand": "Duratiles",
    "title": "DEEP Siyah 60x90",
    "seriesName": "DEEP",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1885",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0654206062178263.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0654206062178263.jpg"
    ],
    "size": "60x90",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Deep Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Deep Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz",
    "source": "duratiles"
  },
  {
    "id": "dura_1886",
    "brand": "Duratiles",
    "title": "DEEP Siyah 60x120",
    "seriesName": "DEEP",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1886",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4608627744826512.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4608627744826512.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Deep Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Deep Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz",
    "source": "duratiles"
  },
  {
    "id": "dura_1887",
    "brand": "Duratiles",
    "title": "DEEP Siyah 40x120",
    "seriesName": "DEEP",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1887",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7990651921350469.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7990651921350469.jpg"
    ],
    "size": "40x120",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Deep Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Deep Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz",
    "source": "duratiles"
  },
  {
    "id": "dura_1888",
    "brand": "Duratiles",
    "title": "DEEP Siyah 30x120",
    "seriesName": "DEEP",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1888",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5649680094019363.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5649680094019363.jpg"
    ],
    "size": "30x120",
    "color": "Siyah",
    "surface": "Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Deep Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Deep Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz",
    "source": "duratiles"
  },
  {
    "id": "dura_1889",
    "brand": "Duratiles",
    "title": "DEEP Siyah 80x80",
    "seriesName": "DEEP",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1889",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6383184191196051.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6383184191196051.jpg"
    ],
    "size": "80x80",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Deep Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Deep Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz",
    "source": "duratiles"
  },
  {
    "id": "dura_1890",
    "brand": "Duratiles",
    "title": "DEEP Siyah 40x80",
    "seriesName": "DEEP",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1890",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9935081962612455.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9935081962612455.jpg"
    ],
    "size": "40x80",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Deep Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Deep Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz",
    "source": "duratiles"
  },
  {
    "id": "dura_1891",
    "brand": "Duratiles",
    "title": "DEEP Siyah 60x60",
    "seriesName": "DEEP",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1891",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8686659947826723.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8686659947826723.jpg"
    ],
    "size": "60x60",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Deep Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Deep Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz",
    "source": "duratiles"
  },
  {
    "id": "dura_1892",
    "brand": "Duratiles",
    "title": "DEEP Siyah 40x40",
    "seriesName": "DEEP",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1892",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.06623675709599874.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.06623675709599874.jpg"
    ],
    "size": "40x40",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Pratik ve çevre dostu olan Deep Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz</span>",
    "descriptionClean": "Pratik ve çevre dostu olan Deep Serisi mükemmel teknik performansı sayesinde diğer seramikler gibi kolay kırılmaz",
    "source": "duratiles"
  },
  {
    "id": "dura_1893",
    "brand": "Duratiles",
    "title": "DELTA Bej 60x60",
    "seriesName": "DELTA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1893",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20044708147925272.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20044708147925272.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Banyo & Ev içi Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Geometrik çizgileriyle mekânlara farklı bir tarz katan Delta Serisi, özgür ve yaratıcı fikirlerinizi yaşama alışkanlıklarınızla birleştirerek uygulayabilmenize fırsat tanıyacak kadar fonksiyonel ve cesur.</span>",
    "descriptionClean": "Geometrik çizgileriyle mekânlara farklı bir tarz katan Delta Serisi, özgür ve yaratıcı fikirlerinizi yaşama alışkanlıklarınızla birleştirerek uygulayabilmenize fırsat tanıyacak kadar fonksiyonel ve cesur.",
    "source": "duratiles"
  },
  {
    "id": "dura_1894",
    "brand": "Duratiles",
    "title": "DELTA Gri 60x60",
    "seriesName": "DELTA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1894",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9252024663121279.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9252024663121279.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Banyo & Ev içi Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Geometrik çizgileriyle mekânlara farklı bir tarz katan Delta Serisi, özgür ve yaratıcı fikirlerinizi yaşama alışkanlıklarınızla birleştirerek uygulayabilmenize fırsat tanıyacak kadar fonksiyonel ve cesur.</span>",
    "descriptionClean": "Geometrik çizgileriyle mekânlara farklı bir tarz katan Delta Serisi, özgür ve yaratıcı fikirlerinizi yaşama alışkanlıklarınızla birleştirerek uygulayabilmenize fırsat tanıyacak kadar fonksiyonel ve cesur.",
    "source": "duratiles"
  },
  {
    "id": "dura_1895",
    "brand": "Duratiles",
    "title": "DICLE Gri 45x45",
    "seriesName": "DICLE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1895",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4053101205652674.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4053101205652674.jpg"
    ],
    "size": "45x45",
    "color": "Gri",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Banyo & Ev içi Zemin & Dış Cephe",
    "technology": "Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Dicle Serisi yalın güzelliği ile yaşam alanlarınıza kolayca uyum sağlarken şıklığı ve estetiği beraberinde getiriyor.</span>",
    "descriptionClean": "Dicle Serisi yalın güzelliği ile yaşam alanlarınıza kolayca uyum sağlarken şıklığı ve estetiği beraberinde getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1896",
    "brand": "Duratiles",
    "title": "DURBAN Antrasit 60x120",
    "seriesName": "DURBAN",
    "collection": "Taş",
    "category": "Taş",
    "sku": "70667",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2286970563441163.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2286970563441163.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğanın renklerini ve dokusunu yaşam alanlarınıza taşıyan Durban Porselen Karoları farklı dekorasyon ihtiyaçlarına yönelik sunduğu çözümlerle hayatınızı kolaylaştırır.</span>",
    "descriptionClean": "Doğanın renklerini ve dokusunu yaşam alanlarınıza taşıyan Durban Porselen Karoları farklı dekorasyon ihtiyaçlarına yönelik sunduğu çözümlerle hayatınızı kolaylaştırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1897",
    "brand": "Duratiles",
    "title": "DURBAN Beyaz 60x120",
    "seriesName": "DURBAN",
    "collection": "Taş",
    "category": "Taş",
    "sku": "70663",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.34745331506125143.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.34745331506125143.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğanın renklerini ve dokusunu yaşam alanlarınıza taşıyan Durban Porselen Karoları farklı dekorasyon ihtiyaçlarına yönelik sunduğu çözümlerle hayatınızı kolaylaştırır.</span>",
    "descriptionClean": "Doğanın renklerini ve dokusunu yaşam alanlarınıza taşıyan Durban Porselen Karoları farklı dekorasyon ihtiyaçlarına yönelik sunduğu çözümlerle hayatınızı kolaylaştırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1898",
    "brand": "Duratiles",
    "title": "DURBAN Gri 60x120",
    "seriesName": "DURBAN",
    "collection": "Taş",
    "category": "Taş",
    "sku": "70665",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12353209463131365.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12353209463131365.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğanın renklerini ve dokusunu yaşam alanlarınıza taşıyan Durban Porselen Karoları farklı dekorasyon ihtiyaçlarına yönelik sunduğu çözümlerle hayatınızı kolaylaştırır.</span>",
    "descriptionClean": "Doğanın renklerini ve dokusunu yaşam alanlarınıza taşıyan Durban Porselen Karoları farklı dekorasyon ihtiyaçlarına yönelik sunduğu çözümlerle hayatınızı kolaylaştırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1899",
    "brand": "Duratiles",
    "title": "DURBAN Beyaz 30x60",
    "seriesName": "DURBAN",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1899",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4507285598950699.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4507285598950699.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğanın renklerini ve dokusunu yaşam alanlarınıza taşıyan Durban Porselen Karoları farklı dekorasyon ihtiyaçlarına yönelik sunduğu çözümlerle hayatınızı kolaylaştırır.</span>",
    "descriptionClean": "Doğanın renklerini ve dokusunu yaşam alanlarınıza taşıyan Durban Porselen Karoları farklı dekorasyon ihtiyaçlarına yönelik sunduğu çözümlerle hayatınızı kolaylaştırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1900",
    "brand": "Duratiles",
    "title": "DURBAN Antrasit 30x60",
    "seriesName": "DURBAN",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1900",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9074440620375528.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9074440620375528.jpg"
    ],
    "size": "30x60",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğanın renklerini ve dokusunu yaşam alanlarınıza taşıyan Durban Porselen Karoları farklı dekorasyon ihtiyaçlarına yönelik sunduğu çözümlerle hayatınızı kolaylaştırır.</span>",
    "descriptionClean": "Doğanın renklerini ve dokusunu yaşam alanlarınıza taşıyan Durban Porselen Karoları farklı dekorasyon ihtiyaçlarına yönelik sunduğu çözümlerle hayatınızı kolaylaştırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1901",
    "brand": "Duratiles",
    "title": "DURBAN Gri 30x60",
    "seriesName": "DURBAN",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1901",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5396634419659913.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5396634419659913.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğanın renklerini ve dokusunu yaşam alanlarınıza taşıyan Durban Porselen Karoları farklı dekorasyon ihtiyaçlarına yönelik sunduğu çözümlerle hayatınızı kolaylaştırır.</span>",
    "descriptionClean": "Doğanın renklerini ve dokusunu yaşam alanlarınıza taşıyan Durban Porselen Karoları farklı dekorasyon ihtiyaçlarına yönelik sunduğu çözümlerle hayatınızı kolaylaştırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1902",
    "brand": "Duratiles",
    "title": "EDESSA Bej 45x45",
    "seriesName": "EDESSA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1902",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.054586149828445785.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.054586149828445785.jpg"
    ],
    "size": "45x45",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı bir dizayn, fark yaratan sonuçlar. Seçkin zevklerinizi Edessa serisi ile yansıtın. Sıradan olmak istemeyenlere özel... Her zaman gözde her zaman şık...</span>",
    "descriptionClean": "Farklı bir dizayn, fark yaratan sonuçlar. Seçkin zevklerinizi Edessa serisi ile yansıtın. Sıradan olmak istemeyenlere özel... Her zaman gözde her zaman şık...",
    "source": "duratiles"
  },
  {
    "id": "dura_1903",
    "brand": "Duratiles",
    "title": "EDESSA Kahve 45x45",
    "seriesName": "EDESSA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1903",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7883042785117447.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7883042785117447.jpg"
    ],
    "size": "45x45",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı bir dizayn, fark yaratan sonuçlar. Seçkin zevklerinizi Edessa serisi ile yansıtın. Sıradan olmak istemeyenlere özel... Her zaman gözde her zaman şık...</span>",
    "descriptionClean": "Farklı bir dizayn, fark yaratan sonuçlar. Seçkin zevklerinizi Edessa serisi ile yansıtın. Sıradan olmak istemeyenlere özel... Her zaman gözde her zaman şık...",
    "source": "duratiles"
  },
  {
    "id": "dura_1904",
    "brand": "Duratiles",
    "title": "EDESSA Gri 45x45",
    "seriesName": "EDESSA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1904",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8596989028779704.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8596989028779704.jpg"
    ],
    "size": "45x45",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Farklı bir dizayn, fark yaratan sonuçlar. Seçkin zevklerinizi Edessa serisi ile yansıtın. Sıradan olmak istemeyenlere özel... Her zaman gözde her zaman şık...</span>",
    "descriptionClean": "Farklı bir dizayn, fark yaratan sonuçlar. Seçkin zevklerinizi Edessa serisi ile yansıtın. Sıradan olmak istemeyenlere özel... Her zaman gözde her zaman şık...",
    "source": "duratiles"
  },
  {
    "id": "dura_1905",
    "brand": "Duratiles",
    "title": "ELEGANCE Antrasit 45x90",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1905",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.592241280550962.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.592241280550962.jpg"
    ],
    "size": "45x90",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "30mm & 20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1906",
    "brand": "Duratiles",
    "title": "ELEGANCE Bej 45x90",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1906",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8257679431731012.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8257679431731012.jpg"
    ],
    "size": "45x90",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "30mm & 20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Havuz & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1907",
    "brand": "Duratiles",
    "title": "ELEGANCE Gri 45x90",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1907",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7009716890431971.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7009716890431971.jpg"
    ],
    "size": "45x90",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Ev içi Zemin & Havuz & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1908",
    "brand": "Duratiles",
    "title": "ELEGANCE Bej 60x90",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1908",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40196215693275616.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40196215693275616.jpg"
    ],
    "size": "60x90",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Ev içi Zemin & Havuz & Endüstriyel Zemin & Balkon/Teras",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1909",
    "brand": "Duratiles",
    "title": "ELEGANCE Gri 60x90",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1909",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6968204570264712.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6968204570264712.jpg"
    ],
    "size": "60x90",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Ev içi Zemin & Havuz & Endüstriyel Zemin & Balkon/Teras",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1910",
    "brand": "Duratiles",
    "title": "ELEGANCE Antrasit 60x90",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1910",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.38279849809488653.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.38279849809488653.jpg"
    ],
    "size": "60x90",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Ev içi Zemin & Havuz & Endüstriyel Zemin & Balkon/Teras",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1911",
    "brand": "Duratiles",
    "title": "ELEGANCE Antrasit 60x120",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1911",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07102968331123005.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07102968331123005.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1912",
    "brand": "Duratiles",
    "title": "ELEGANCE Bej 60x120",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1912",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7588137023007121.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7588137023007121.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1913",
    "brand": "Duratiles",
    "title": "ELEGANCE Gri 60x120",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1913",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.29100437186154704.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.29100437186154704.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Endüstriyel Zemin & Balkon/Teras",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1914",
    "brand": "Duratiles",
    "title": "ELEGANCE Antrasit 40x120",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1914",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15922375069289596.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15922375069289596.jpg"
    ],
    "size": "40x120",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1915",
    "brand": "Duratiles",
    "title": "ELEGANCE Bej 40x120",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1915",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4249807663547588.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4249807663547588.jpg"
    ],
    "size": "40x120",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Ev içi Zemin & Havuz & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1916",
    "brand": "Duratiles",
    "title": "ELEGANCE Gri 40x120",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1916",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.02936223314648434.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.02936223314648434.jpg"
    ],
    "size": "40x120",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Ev içi Zemin & Havuz & Endüstriyel Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1917",
    "brand": "Duratiles",
    "title": "ELEGANCE Antrasit 30x120",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1917",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7361551333367413.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7361551333367413.jpg"
    ],
    "size": "30x120",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1918",
    "brand": "Duratiles",
    "title": "ELEGANCE Bej 30x120",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1918",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.986258559372033.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.986258559372033.jpg"
    ],
    "size": "30x120",
    "color": "Bej",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1919",
    "brand": "Duratiles",
    "title": "ELEGANCE Gri 30x120",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1919",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5863677685177836.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5863677685177836.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1920",
    "brand": "Duratiles",
    "title": "ELEGANCE Antrasit 80x80",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1920",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1649071277646339.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1649071277646339.jpg"
    ],
    "size": "80x80",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1921",
    "brand": "Duratiles",
    "title": "ELEGANCE Bej 80x80",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1921",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1853535861453327.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1853535861453327.jpg"
    ],
    "size": "80x80",
    "color": "Bej",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1922",
    "brand": "Duratiles",
    "title": "ELEGANCE Gri 80x80",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1922",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30733362394931585.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30733362394931585.jpg"
    ],
    "size": "80x80",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1923",
    "brand": "Duratiles",
    "title": "ELEGANCE Antrasit 40x80",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1923",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.29533023793412316.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.29533023793412316.jpg"
    ],
    "size": "40x80",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1924",
    "brand": "Duratiles",
    "title": "ELEGANCE Bej 40x80",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1924",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5002020998388409.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5002020998388409.jpg"
    ],
    "size": "40x80",
    "color": "Bej",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1925",
    "brand": "Duratiles",
    "title": "ELEGANCE Gri 40x80",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1925",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1967374325620943.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1967374325620943.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1926",
    "brand": "Duratiles",
    "title": "ELEGANCE Antrasit 60x60",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1926",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.01358731840351024.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.01358731840351024.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1927",
    "brand": "Duratiles",
    "title": "ELEGANCE Bej 60x60",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1927",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.49784795117370373.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.49784795117370373.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1928",
    "brand": "Duratiles",
    "title": "ELEGANCE Gri 60x60",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1928",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5898147723467289.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5898147723467289.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1929",
    "brand": "Duratiles",
    "title": "ELEGANCE Antrasit 40x40",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1929",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4177007094894284.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4177007094894284.jpg"
    ],
    "size": "40x40",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1930",
    "brand": "Duratiles",
    "title": "ELEGANCE Bej 40x40",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1930",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0666679055451389.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0666679055451389.jpg"
    ],
    "size": "40x40",
    "color": "Bej",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1931",
    "brand": "Duratiles",
    "title": "ELEGANCE Gri 40x40",
    "seriesName": "ELEGANCE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1931",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5360758242954144.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5360758242954144.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Elegance Serisi ,antrasit ,bej ve gri renkleri mat dokusuyla birleştirerek mekanlarda çağdaş şıklığı yakalamanıza yardım etmekte. Yüksek teknik performansa sahip olan seri , teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1191",
    "brand": "Duratiles",
    "title": "ENSTONE Sabbia 45x90",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1191",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2954692443230147.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2954692443230147.jpg"
    ],
    "size": "45x90",
    "color": "Sabbia",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1192",
    "brand": "Duratiles",
    "title": "ENSTONE Antrasit 45x90",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1192",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.05256236098224587.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.05256236098224587.jpg"
    ],
    "size": "45x90",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1193",
    "brand": "Duratiles",
    "title": "ENSTONE Gri 45x90",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1193",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7168955476663063.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7168955476663063.jpg"
    ],
    "size": "45x90",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "30mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1194",
    "brand": "Duratiles",
    "title": "ENSTONE Fildişi 45x90",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1194",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5206260977817031.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5206260977817031.jpg"
    ],
    "size": "45x90",
    "color": "Fildişi",
    "surface": "Full Lappato, Mat",
    "thickness": "30mm & 20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1195",
    "brand": "Duratiles",
    "title": "ENSTONE Sabbia 60x90",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1195",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18877291799209872.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18877291799209872.jpg"
    ],
    "size": "60x90",
    "color": "Sabbia",
    "surface": "Mat , Sırlı Body",
    "thickness": "30mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1196",
    "brand": "Duratiles",
    "title": "ENSTONE Fildişi 60x90",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1196",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5545381572496847.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5545381572496847.jpg"
    ],
    "size": "60x90",
    "color": "Fildişi",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1197",
    "brand": "Duratiles",
    "title": "ENSTONE Gri 60x90",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1197",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.34848605309415814.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.34848605309415814.jpg"
    ],
    "size": "60x90",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1198",
    "brand": "Duratiles",
    "title": "ENSTONE Antrasit 60x90",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1198",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10111854092038419.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10111854092038419.jpg"
    ],
    "size": "60x90",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1199",
    "brand": "Duratiles",
    "title": "ENSTONE Sabbia 60x120",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1199",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2643095271149336.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2643095271149336.jpg"
    ],
    "size": "60x120",
    "color": "Sabbia",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1200",
    "brand": "Duratiles",
    "title": "ENSTONE Antrasit 60x120",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1200",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6358131135632827.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6358131135632827.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1201",
    "brand": "Duratiles",
    "title": "ENSTONE Gri 60x120",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1201",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.50507502263923.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.50507502263923.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1202",
    "brand": "Duratiles",
    "title": "ENSTONE Fildişi 60x120",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1202",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11927273729910348.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11927273729910348.jpg"
    ],
    "size": "60x120",
    "color": "Fildişi",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1203",
    "brand": "Duratiles",
    "title": "ENSTONE Antrasit 40x120",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1203",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8095091958521293.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8095091958521293.jpg"
    ],
    "size": "40x120",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1204",
    "brand": "Duratiles",
    "title": "ENSTONE Gri 40x120",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1204",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7425962014421467.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7425962014421467.jpg"
    ],
    "size": "40x120",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1205",
    "brand": "Duratiles",
    "title": "ENSTONE Sabbia 40x120",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1205",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1320085902304866.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1320085902304866.jpg"
    ],
    "size": "40x120",
    "color": "Sabbia",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1206",
    "brand": "Duratiles",
    "title": "ENSTONE Fildişi 40x120",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1206",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8682891435926557.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8682891435926557.jpg"
    ],
    "size": "40x120",
    "color": "Fildişi",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1208",
    "brand": "Duratiles",
    "title": "ENSTONE Antrasit 30x120",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1208",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5810171770282064.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5810171770282064.jpg"
    ],
    "size": "30x120",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1209",
    "brand": "Duratiles",
    "title": "ENSTONE Gri 30x120",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1209",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7484193105200593.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7484193105200593.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1207",
    "brand": "Duratiles",
    "title": "ENSTONE Sabbia 30x120",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1207",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10970817673438704.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10970817673438704.jpg"
    ],
    "size": "30x120",
    "color": "Sabbia",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1210",
    "brand": "Duratiles",
    "title": "ENSTONE Fildişi 30x120",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1210",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12472310139887866.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12472310139887866.jpg"
    ],
    "size": "30x120",
    "color": "Fildişi",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1211",
    "brand": "Duratiles",
    "title": "ENSTONE Antrasit 80x80",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1211",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.45913753937915347.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.45913753937915347.jpg"
    ],
    "size": "80x80",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1212",
    "brand": "Duratiles",
    "title": "ENSTONE Gri 80x80",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1212",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3534561619671631.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3534561619671631.jpg"
    ],
    "size": "80x80",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1214",
    "brand": "Duratiles",
    "title": "ENSTONE Sabbia 80x80",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1214",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.25537860913068955.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.25537860913068955.jpg"
    ],
    "size": "80x80",
    "color": "Sabbia",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1213",
    "brand": "Duratiles",
    "title": "ENSTONE Fildişi 80x80",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1213",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8696113756902674.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8696113756902674.jpg"
    ],
    "size": "80x80",
    "color": "Fildişi",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1216",
    "brand": "Duratiles",
    "title": "ENSTONE Antrasit 40x80",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1216",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6802990509993911.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6802990509993911.jpg"
    ],
    "size": "40x80",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1217",
    "brand": "Duratiles",
    "title": "ENSTONE Gri 40x80",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1217",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12692754662428019.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12692754662428019.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1215",
    "brand": "Duratiles",
    "title": "ENSTONE Sabbia 40x80",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1215",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8771570490345195.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8771570490345195.jpg"
    ],
    "size": "40x80",
    "color": "Sabbia",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1218",
    "brand": "Duratiles",
    "title": "ENSTONE Fildişi 40x80",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1218",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7862267825115156.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7862267825115156.jpg"
    ],
    "size": "40x80",
    "color": "Fildişi",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1219",
    "brand": "Duratiles",
    "title": "ENSTONE Sabbia 60x60",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "41397",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43223768827590403.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.43223768827590403.jpg"
    ],
    "size": "60x60",
    "color": "Sabbia",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1220",
    "brand": "Duratiles",
    "title": "ENSTONE Antrasit 60x60",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "41395",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5615140387639614.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5615140387639614.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1221",
    "brand": "Duratiles",
    "title": "ENSTONE Gri 60x60",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "41396",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8379547854929655.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8379547854929655.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1222",
    "brand": "Duratiles",
    "title": "ENSTONE Fildişi 60x60",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1222",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46079482734396604.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.46079482734396604.jpg"
    ],
    "size": "60x60",
    "color": "Fildişi",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1223",
    "brand": "Duratiles",
    "title": "ENSTONE Sabbia 40x40",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1223",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9410653503644767.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9410653503644767.jpg"
    ],
    "size": "40x40",
    "color": "Sabbia",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1224",
    "brand": "Duratiles",
    "title": "ENSTONE Antrasit 40x40",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1224",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4456423479329148.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4456423479329148.jpg"
    ],
    "size": "40x40",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1225",
    "brand": "Duratiles",
    "title": "ENSTONE Gri 40x40",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1225",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4414858762052333.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4414858762052333.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1226",
    "brand": "Duratiles",
    "title": "ENSTONE Fildişi 40x40",
    "seriesName": "ENSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1226",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22765686797916318.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22765686797916318.jpg"
    ],
    "size": "40x40",
    "color": "Fildişi",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.</span>",
    "descriptionClean": "Mermer görünümüne sahip Enstone Serisi dört farklı renk alternatifi ile doğal mermerin büyüsünü yaşam alanlarınıza taşıyor. Bulunduğu her ortama benzersiz bir hava katan seri ekolojik ve sürdürülebilir bir ürün olma özelliğini taşımakta.",
    "source": "duratiles"
  },
  {
    "id": "dura_1932",
    "brand": "Duratiles",
    "title": "ERCİYES Bone 60x60",
    "seriesName": "ERCİYES",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1932",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.06099013360505945.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.06099013360505945.jpg"
    ],
    "size": "60x60",
    "color": "Bone",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sadelikten gelen şıklık Erciyes serisi ile hayat buldu. Ferah mekânların tamamlayıcısı olmak için vazgeçilmeziniz haline gelecek.</span>",
    "descriptionClean": "Sadelikten gelen şıklık Erciyes serisi ile hayat buldu. Ferah mekânların tamamlayıcısı olmak için vazgeçilmeziniz haline gelecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1933",
    "brand": "Duratiles",
    "title": "ERCİYES Gri 60x60",
    "seriesName": "ERCİYES",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1933",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6273941384727485.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6273941384727485.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sadelikten gelen şıklık Erciyes serisi ile hayat buldu. Ferah mekânların tamamlayıcısı olmak için vazgeçilmeziniz haline gelecek.</span>",
    "descriptionClean": "Sadelikten gelen şıklık Erciyes serisi ile hayat buldu. Ferah mekânların tamamlayıcısı olmak için vazgeçilmeziniz haline gelecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1934",
    "brand": "Duratiles",
    "title": "ERCİYES Bone 45x45",
    "seriesName": "ERCİYES",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1934",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.987194125642518.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.987194125642518.jpg"
    ],
    "size": "45x45",
    "color": "Bone",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sadelikten gelen şıklık Erciyes serisi ile hayat buldu. Ferah mekânların tamamlayıcısı olmak için vazgeçilmeziniz haline gelecek.</span>",
    "descriptionClean": "Sadelikten gelen şıklık Erciyes serisi ile hayat buldu. Ferah mekânların tamamlayıcısı olmak için vazgeçilmeziniz haline gelecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1935",
    "brand": "Duratiles",
    "title": "ERCİYES Gri 45x45",
    "seriesName": "ERCİYES",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1935",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4844633490461341.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4844633490461341.jpg"
    ],
    "size": "45x45",
    "color": "Gri",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Sadelikten gelen şıklık Erciyes serisi ile hayat buldu. Ferah mekânların tamamlayıcısı olmak için vazgeçilmeziniz haline gelecek.</span>",
    "descriptionClean": "Sadelikten gelen şıklık Erciyes serisi ile hayat buldu. Ferah mekânların tamamlayıcısı olmak için vazgeçilmeziniz haline gelecek.",
    "source": "duratiles"
  },
  {
    "id": "dura_1938",
    "brand": "Duratiles",
    "title": "EXTREME POOL Pool Blue 60x60",
    "seriesName": "EXTREME POOL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1938",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8477525103535202.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8477525103535202.jpg"
    ],
    "size": "60x60",
    "color": "Pool Blue",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Durastone koleksiyonun havuz kenarı için tasarladığı Extreme serisinin Pool Blue rengi havuzlara mavi rengin canlandırıcı ve tazeleyici hissini veriyor. Havuz kenarları için Natura White ve White isimli iki ayrı renk seçeneği sunan serinin mat dokusu, kaymazlık özelliği dikkat çekmekte. Extreme serisi farklı ebat seçenekleri ile zengin ve fonksiyonel.</span>",
    "descriptionClean": "Durastone koleksiyonun havuz kenarı için tasarladığı Extreme serisinin Pool Blue rengi havuzlara mavi rengin canlandırıcı ve tazeleyici hissini veriyor. Havuz kenarları için Natura White ve White isimli iki ayrı renk seçeneği sunan serinin mat dokusu, kaymazlık özelliği dikkat çekmekte. Extreme serisi farklı ebat seçenekleri ile zengin ve fonksiyonel.",
    "source": "duratiles"
  },
  {
    "id": "dura_1936",
    "brand": "Duratiles",
    "title": "EXTREME POOL Natura White 60x60",
    "seriesName": "EXTREME POOL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1936",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.49927161085570415.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.49927161085570415.jpg"
    ],
    "size": "60x60",
    "color": "Natura White",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Durastone koleksiyonun havuz kenarı için tasarladığı Extreme serisinin Pool Blue rengi havuzlara mavi rengin canlandırıcı ve tazeleyici hissini veriyor. Havuz kenarları için Natura White ve White isimli iki ayrı renk seçeneği sunan serinin mat dokusu, kaymazlık özelliği dikkat çekmekte. Extreme serisi farklı ebat seçenekleri ile zengin ve fonksiyonel.</span>",
    "descriptionClean": "Durastone koleksiyonun havuz kenarı için tasarladığı Extreme serisinin Pool Blue rengi havuzlara mavi rengin canlandırıcı ve tazeleyici hissini veriyor. Havuz kenarları için Natura White ve White isimli iki ayrı renk seçeneği sunan serinin mat dokusu, kaymazlık özelliği dikkat çekmekte. Extreme serisi farklı ebat seçenekleri ile zengin ve fonksiyonel.",
    "source": "duratiles"
  },
  {
    "id": "dura_1937",
    "brand": "Duratiles",
    "title": "EXTREME POOL Beyaz 60x60",
    "seriesName": "EXTREME POOL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1937",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7562991210118993.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7562991210118993.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Durastone koleksiyonun havuz kenarı için tasarladığı Extreme serisinin Pool Blue rengi havuzlara mavi rengin canlandırıcı ve tazeleyici hissini veriyor. Havuz kenarları için Natura White ve White isimli iki ayrı renk seçeneği sunan serinin mat dokusu, kaymazlık özelliği dikkat çekmekte. Extreme serisi farklı ebat seçenekleri ile zengin ve fonksiyonel.</span>",
    "descriptionClean": "Durastone koleksiyonun havuz kenarı için tasarladığı Extreme serisinin Pool Blue rengi havuzlara mavi rengin canlandırıcı ve tazeleyici hissini veriyor. Havuz kenarları için Natura White ve White isimli iki ayrı renk seçeneği sunan serinin mat dokusu, kaymazlık özelliği dikkat çekmekte. Extreme serisi farklı ebat seçenekleri ile zengin ve fonksiyonel.",
    "source": "duratiles"
  },
  {
    "id": "dura_1939",
    "brand": "Duratiles",
    "title": "FLAGSTONE Bej 45x90",
    "seriesName": "FLAGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1939",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8774119251424939.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8774119251424939.jpg"
    ],
    "size": "45x90",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1940",
    "brand": "Duratiles",
    "title": "FLAGSTONE Gri 45x90",
    "seriesName": "FLAGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1940",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8919694912187666.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8919694912187666.jpg"
    ],
    "size": "45x90",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1941",
    "brand": "Duratiles",
    "title": "FLAGSTONE Bej 60x90",
    "seriesName": "FLAGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1941",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.63866510189596.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.63866510189596.jpg"
    ],
    "size": "60x90",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1942",
    "brand": "Duratiles",
    "title": "FLAGSTONE Gri 60x90",
    "seriesName": "FLAGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1942",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.824964353857326.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.824964353857326.jpg"
    ],
    "size": "60x90",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1943",
    "brand": "Duratiles",
    "title": "FLAGSTONE Bej 60x120",
    "seriesName": "FLAGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1943",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1756177819256033.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1756177819256033.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1944",
    "brand": "Duratiles",
    "title": "FLAGSTONE Gri 60x120",
    "seriesName": "FLAGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1944",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.143019950642848.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.143019950642848.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1945",
    "brand": "Duratiles",
    "title": "FLAGSTONE Bej 40x120",
    "seriesName": "FLAGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1945",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8515437625310116.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8515437625310116.jpg"
    ],
    "size": "40x120",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1946",
    "brand": "Duratiles",
    "title": "FLAGSTONE Gri 40x120",
    "seriesName": "FLAGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1946",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18101344406871145.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18101344406871145.jpg"
    ],
    "size": "40x120",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1947",
    "brand": "Duratiles",
    "title": "FLAGSTONE Bej 30x120",
    "seriesName": "FLAGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1947",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17115638985839876.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17115638985839876.jpg"
    ],
    "size": "30x120",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1948",
    "brand": "Duratiles",
    "title": "FLAGSTONE Gri 30x120",
    "seriesName": "FLAGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1948",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.771236390300596.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.771236390300596.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1949",
    "brand": "Duratiles",
    "title": "FLAGSTONE Bej 80x80",
    "seriesName": "FLAGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1949",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8545769697423199.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8545769697423199.jpg"
    ],
    "size": "80x80",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1950",
    "brand": "Duratiles",
    "title": "FLAGSTONE Gri 80x80",
    "seriesName": "FLAGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1950",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6004650025027801.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6004650025027801.jpg"
    ],
    "size": "80x80",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1951",
    "brand": "Duratiles",
    "title": "FLAGSTONE Bej 40x80",
    "seriesName": "FLAGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1951",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3757427208769303.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3757427208769303.jpg"
    ],
    "size": "40x80",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1952",
    "brand": "Duratiles",
    "title": "FLAGSTONE Gri 40x80",
    "seriesName": "FLAGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1952",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.32546576024087825.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.32546576024087825.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1953",
    "brand": "Duratiles",
    "title": "FLAGSTONE Bej 60x60",
    "seriesName": "FLAGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1953",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8585759292667339.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8585759292667339.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1954",
    "brand": "Duratiles",
    "title": "FLAGSTONE Gri 60x60",
    "seriesName": "FLAGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1954",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.511808281588876.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.511808281588876.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1955",
    "brand": "Duratiles",
    "title": "FLAGSTONE Bej 40x40",
    "seriesName": "FLAGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1955",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7872490367289275.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7872490367289275.jpg"
    ],
    "size": "40x40",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1956",
    "brand": "Duratiles",
    "title": "FLAGSTONE Gri 40x40",
    "seriesName": "FLAGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1956",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.056867511946640414.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.056867511946640414.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.</span>",
    "descriptionClean": "Yüksek teknik performansa sahip olan Flagstone Serisi teraslardan plajlara ,araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar bir çok yerde rahatlıkla kullanılabilir.",
    "source": "duratiles"
  },
  {
    "id": "dura_1957",
    "brand": "Duratiles",
    "title": "GRANIT Gri 45x90",
    "seriesName": "GRANIT",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1957",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7963857159336548.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7963857159336548.jpg"
    ],
    "size": "45x90",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bulunduğu her ortama benzersiz bir hava katan Granit Serisi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Bulunduğu her ortama benzersiz bir hava katan Granit Serisi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_1958",
    "brand": "Duratiles",
    "title": "GRANIT Gri 60x90",
    "seriesName": "GRANIT",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1958",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7132523276066683.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7132523276066683.jpg"
    ],
    "size": "60x90",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bulunduğu her ortama benzersiz bir hava katan Granit Serisi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Bulunduğu her ortama benzersiz bir hava katan Granit Serisi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_1959",
    "brand": "Duratiles",
    "title": "GRANIT Gri 60x120",
    "seriesName": "GRANIT",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1959",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8664572986749641.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8664572986749641.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bulunduğu her ortama benzersiz bir hava katan Granit Serisi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Bulunduğu her ortama benzersiz bir hava katan Granit Serisi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_1960",
    "brand": "Duratiles",
    "title": "GRANIT Gri 40x120",
    "seriesName": "GRANIT",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1960",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8664572986749641.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8664572986749641.jpg"
    ],
    "size": "40x120",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bulunduğu her ortama benzersiz bir hava katan Granit Serisi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Bulunduğu her ortama benzersiz bir hava katan Granit Serisi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_1961",
    "brand": "Duratiles",
    "title": "GRANIT Gri 30x120",
    "seriesName": "GRANIT",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1961",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.022657922722461366.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.022657922722461366.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bulunduğu her ortama benzersiz bir hava katan Granit Serisi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Bulunduğu her ortama benzersiz bir hava katan Granit Serisi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_1962",
    "brand": "Duratiles",
    "title": "GRANIT Gri 80x80",
    "seriesName": "GRANIT",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1962",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5413563635865245.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5413563635865245.jpg"
    ],
    "size": "80x80",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bulunduğu her ortama benzersiz bir hava katan Granit Serisi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Bulunduğu her ortama benzersiz bir hava katan Granit Serisi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_1963",
    "brand": "Duratiles",
    "title": "GRANIT Gri 40x80",
    "seriesName": "GRANIT",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1963",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4556192140909019.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4556192140909019.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bulunduğu her ortama benzersiz bir hava katan Granit Serisi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Bulunduğu her ortama benzersiz bir hava katan Granit Serisi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_1964",
    "brand": "Duratiles",
    "title": "GRANIT Gri 60x60",
    "seriesName": "GRANIT",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1964",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7374095036420898.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7374095036420898.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ticari Alanlar & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bulunduğu her ortama benzersiz bir hava katan Granit Serisi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Bulunduğu her ortama benzersiz bir hava katan Granit Serisi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_1965",
    "brand": "Duratiles",
    "title": "GRANIT Gri 40x40",
    "seriesName": "GRANIT",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1965",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03048715725127904.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03048715725127904.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Havuz & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Endüstriyel Zemin",
      "Havuz",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bulunduğu her ortama benzersiz bir hava katan Granit Serisi ekolojik ve sürdürülebilir bir üründür.</span>",
    "descriptionClean": "Bulunduğu her ortama benzersiz bir hava katan Granit Serisi ekolojik ve sürdürülebilir bir üründür.",
    "source": "duratiles"
  },
  {
    "id": "dura_1966",
    "brand": "Duratiles",
    "title": "HURLEY Multi 60x120",
    "seriesName": "HURLEY",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1966",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44192164196398287.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44192164196398287.jpg"
    ],
    "size": "60x120",
    "color": "Multi",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "V4"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Hayatı hep en uçlarda yaşayanları yansıtan bir seri. Hurley ile hislerinizi ortaya çıkarın. Hayatı sıra dışı yaşayanlara, sıra dışı bir tasarım. Heyecanlı, genç ve dinamik bir tasarımın hikâyesi.</span>",
    "descriptionClean": "Hayatı hep en uçlarda yaşayanları yansıtan bir seri. Hurley ile hislerinizi ortaya çıkarın. Hayatı sıra dışı yaşayanlara, sıra dışı bir tasarım. Heyecanlı, genç ve dinamik bir tasarımın hikâyesi.",
    "source": "duratiles"
  },
  {
    "id": "dura_1967",
    "brand": "Duratiles",
    "title": "JERICO Bianco 45x45",
    "seriesName": "JERICO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1967",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5327421298703872.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5327421298703872.jpg"
    ],
    "size": "45x45",
    "color": "Bianco",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Doğanın kusursuz uyumunu yansıtan Jerico Porselen Karosu dingin ve yalın iç mekan kurguları yaratır.</span>",
    "descriptionClean": "Doğanın kusursuz uyumunu yansıtan Jerico Porselen Karosu dingin ve yalın iç mekan kurguları yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1968",
    "brand": "Duratiles",
    "title": "JERICO Bone 45x45",
    "seriesName": "JERICO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1968",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5979556293822083.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5979556293822083.jpg"
    ],
    "size": "45x45",
    "color": "Bone",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Doğanın kusursuz uyumunu yansıtan Jerico Porselen Karosu dingin ve yalın iç mekan kurguları yaratır.</span>",
    "descriptionClean": "Doğanın kusursuz uyumunu yansıtan Jerico Porselen Karosu dingin ve yalın iç mekan kurguları yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_1969",
    "brand": "Duratiles",
    "title": "KALAHARI Soft 60x120",
    "seriesName": "KALAHARI",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1969",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7128960424139524.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7128960424139524.jpg"
    ],
    "size": "60x120",
    "color": "Soft",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamanın ruhunu, nostaljik dokunuşlarla resmeden Astoria Porselen Karoları, üst düzey lüks tanımını değiştiriyor.</span>",
    "descriptionClean": "Zamanın ruhunu, nostaljik dokunuşlarla resmeden Astoria Porselen Karoları, üst düzey lüks tanımını değiştiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1970",
    "brand": "Duratiles",
    "title": "KALAHARI Cold 60x120",
    "seriesName": "KALAHARI",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1970",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5080740949133322.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5080740949133322.jpg"
    ],
    "size": "60x120",
    "color": "Cold",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamanın ruhunu, nostaljik dokunuşlarla resmeden Astoria Porselen Karoları, üst düzey lüks tanımını değiştiriyor.</span>",
    "descriptionClean": "Zamanın ruhunu, nostaljik dokunuşlarla resmeden Astoria Porselen Karoları, üst düzey lüks tanımını değiştiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_1971",
    "brand": "Duratiles",
    "title": "KATUNGA Antrasit 60x60",
    "seriesName": "KATUNGA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1971",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.47052258713171.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.47052258713171.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Ticari Alanlar & Endüstriyel Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Endüstriyel Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">İddialı ve göz alıcı mekanlar için tasarlanan Katunga Serisi dayanıklı ve bir o kadar fonksiyonel.</span>",
    "descriptionClean": "İddialı ve göz alıcı mekanlar için tasarlanan Katunga Serisi dayanıklı ve bir o kadar fonksiyonel.",
    "source": "duratiles"
  },
  {
    "id": "dura_1972",
    "brand": "Duratiles",
    "title": "KAYRAK Kahve 45x45",
    "seriesName": "KAYRAK",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1972",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2622113115199576.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2622113115199576.jpg"
    ],
    "size": "45x45",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taşın doğal estetiği ve renk uyumu Kayrak ile mekanlara taşınıyor</span>",
    "descriptionClean": "Taşın doğal estetiği ve renk uyumu Kayrak ile mekanlara taşınıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1973",
    "brand": "Duratiles",
    "title": "KAYRAK Yeşil 45x45",
    "seriesName": "KAYRAK",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1973",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5212254649167531.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5212254649167531.jpg"
    ],
    "size": "45x45",
    "color": "Yeşil",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taşın doğal estetiği ve renk uyumu Kayrak ile mekanlara taşınıyor</span>",
    "descriptionClean": "Taşın doğal estetiği ve renk uyumu Kayrak ile mekanlara taşınıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_1974",
    "brand": "Duratiles",
    "title": "LADRILLO Gri 15x60",
    "seriesName": "LADRILLO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1974",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8142041735387798.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8142041735387798.jpg"
    ],
    "size": "15x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Dış Cephe",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1975",
    "brand": "Duratiles",
    "title": "LADRILLO Natura 15x60",
    "seriesName": "LADRILLO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1975",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5533833112776037.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5533833112776037.jpg"
    ],
    "size": "15x60",
    "color": "Natura",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Dış Cephe",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_2336",
    "brand": "Duratiles",
    "title": "LADRILLO Beyaz 15x60",
    "seriesName": "LADRILLO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2336",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9890591828301488.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9890591828301488.jpg"
    ],
    "size": "15x60",
    "color": "Beyaz",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Dış Cephe",
      "V2",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1976",
    "brand": "Duratiles",
    "title": "LEO Siyah 45x90",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1976",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9590634169773955.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9590634169773955.jpg"
    ],
    "size": "45x90",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1977",
    "brand": "Duratiles",
    "title": "LEO Gri 45x90",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1977",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.641640073038044.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.641640073038044.jpg"
    ],
    "size": "45x90",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1978",
    "brand": "Duratiles",
    "title": "LEO Gri 60x90",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1978",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44579941563052006.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.44579941563052006.jpg"
    ],
    "size": "60x90",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1979",
    "brand": "Duratiles",
    "title": "LEO Siyah 60x90",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1979",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09133681712567732.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09133681712567732.jpg"
    ],
    "size": "60x90",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1980",
    "brand": "Duratiles",
    "title": "LEO Sand 60x90",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1980",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8582181626883121.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8582181626883121.jpg"
    ],
    "size": "60x90",
    "color": "Sand",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1981",
    "brand": "Duratiles",
    "title": "LEO Siyah 60x120",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1981",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3969047857938075.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3969047857938075.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1982",
    "brand": "Duratiles",
    "title": "LEO Gri 60x120",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1982",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5962937057652867.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5962937057652867.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1983",
    "brand": "Duratiles",
    "title": "LEO Sand 60x120",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1983",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7661121157628644.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7661121157628644.jpg"
    ],
    "size": "60x120",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1984",
    "brand": "Duratiles",
    "title": "LEO Siyah 40x120",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1984",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7008665724761979.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7008665724761979.jpg"
    ],
    "size": "40x120",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1985",
    "brand": "Duratiles",
    "title": "LEO Sand 40x120",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1985",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9957615777931406.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9957615777931406.jpg"
    ],
    "size": "40x120",
    "color": "Sand",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1986",
    "brand": "Duratiles",
    "title": "LEO Gri 40x120",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1986",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8027563691149537.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8027563691149537.jpg"
    ],
    "size": "40x120",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1987",
    "brand": "Duratiles",
    "title": "LEO Siyah 30x120",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1987",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3550315394678255.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3550315394678255.jpg"
    ],
    "size": "30x120",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Ticari Alanlar & Balkon/Teras",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1988",
    "brand": "Duratiles",
    "title": "LEO Gri 30x120",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1988",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6959596372327735.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6959596372327735.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Ticari Alanlar & Balkon/Teras",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1989",
    "brand": "Duratiles",
    "title": "LEO Sand 30x120",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1989",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09208415068486075.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09208415068486075.jpg"
    ],
    "size": "30x120",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Ticari Alanlar & Balkon/Teras",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1990",
    "brand": "Duratiles",
    "title": "LEO Gri 80x80",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1990",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8222091755681382.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8222091755681382.jpg"
    ],
    "size": "80x80",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Ticari Alanlar & Balkon/Teras & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1991",
    "brand": "Duratiles",
    "title": "LEO Siyah 80x80",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1991",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5221405328593178.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5221405328593178.jpg"
    ],
    "size": "80x80",
    "color": "Siyah",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Ticari Alanlar & Balkon/Teras & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1992",
    "brand": "Duratiles",
    "title": "LEO Sand 80x80",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1992",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9359659814728106.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9359659814728106.jpg"
    ],
    "size": "80x80",
    "color": "Sand",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Ticari Alanlar & Balkon/Teras & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1993",
    "brand": "Duratiles",
    "title": "LEO Siyah 40x80",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1993",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8959305954267037.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8959305954267037.jpg"
    ],
    "size": "40x80",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Ticari Alanlar & Balkon/Teras",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1994",
    "brand": "Duratiles",
    "title": "LEO Gri 40x80",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1994",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6402566028538984.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6402566028538984.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Ticari Alanlar & Balkon/Teras",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1995",
    "brand": "Duratiles",
    "title": "LEO Sand 40x80",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1995",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9471408970632518.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9471408970632518.jpg"
    ],
    "size": "40x80",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Ticari Alanlar & Balkon/Teras",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1996",
    "brand": "Duratiles",
    "title": "LEO Sand 60x60",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1996",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9424349818496832.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9424349818496832.jpg"
    ],
    "size": "60x60",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Ticari Alanlar & Balkon/Teras & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1997",
    "brand": "Duratiles",
    "title": "LEO Siyah 60x60",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1997",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.34800927068064325.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.34800927068064325.jpg"
    ],
    "size": "60x60",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Ticari Alanlar & Balkon/Teras & Havuz & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1998",
    "brand": "Duratiles",
    "title": "LEO Gri 60x60",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1998",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.034436896684884255.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.034436896684884255.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Ticari Alanlar & Balkon/Teras & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_1999",
    "brand": "Duratiles",
    "title": "LEO Siyah 40x40",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "1999",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14334600673012676.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14334600673012676.jpg"
    ],
    "size": "40x40",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Ticari Alanlar & Balkon/Teras",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_2000",
    "brand": "Duratiles",
    "title": "LEO Gri 40x40",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2000",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.001391669840215437.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.001391669840215437.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Ticari Alanlar & Balkon/Teras",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_2001",
    "brand": "Duratiles",
    "title": "LEO Sand 40x40",
    "seriesName": "LEO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2001",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8678901171215272.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8678901171215272.jpg"
    ],
    "size": "40x40",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Endüstriyel Zemin & Ticari Alanlar & Balkon/Teras",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi</span>",
    "descriptionClean": "Doğal tuğlanın pozitif enerjisinin cesaretle baştan tasarlandığı anların adıdır Ladrillo serisi",
    "source": "duratiles"
  },
  {
    "id": "dura_767",
    "brand": "Duratiles",
    "title": "LIMONE Fildişi 60x60",
    "seriesName": "LIMONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "11466",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3011529872250396.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3011529872250396.jpg"
    ],
    "size": "60x60",
    "color": "Fildişi",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Banyo & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "V3",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaşam alanlarında natürel kurgular yaratmak isteyenler için tasarlanan Limone Serisi ile çağdaş özgün mekanlar yaratabilirsiniz</span>",
    "descriptionClean": "Yaşam alanlarında natürel kurgular yaratmak isteyenler için tasarlanan Limone Serisi ile çağdaş özgün mekanlar yaratabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_768",
    "brand": "Duratiles",
    "title": "LIMONE Açık Gri 60x60",
    "seriesName": "LIMONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "10971",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9858141986544413.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9858141986544413.jpg"
    ],
    "size": "60x60",
    "color": "Açık Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Banyo & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "V3",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yaşam alanlarında natürel kurgular yaratmak isteyenler için tasarlanan Limone Serisi ile çağdaş özgün mekanlar yaratabilirsiniz</span>",
    "descriptionClean": "Yaşam alanlarında natürel kurgular yaratmak isteyenler için tasarlanan Limone Serisi ile çağdaş özgün mekanlar yaratabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_2002",
    "brand": "Duratiles",
    "title": "LION Bej 45x45",
    "seriesName": "LION",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2002",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8678901171215272.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8678901171215272.jpg"
    ],
    "size": "45x45",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Banyo & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Taş dokusu ile Lion Porselen Karoları dayanıklı ve hijyenik yapısıyla göz alıcı mekanlar yaratır.</span>",
    "descriptionClean": "Taş dokusu ile Lion Porselen Karoları dayanıklı ve hijyenik yapısıyla göz alıcı mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2003",
    "brand": "Duratiles",
    "title": "LIVINGSTONE Antrasit 60x120",
    "seriesName": "LIVINGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2003",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6386840312828966.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6386840312828966.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Banyo & Ev içi Zemin & Dış Cephe & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "V2",
      "Dış Cephe",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.</span>",
    "descriptionClean": "Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.",
    "source": "duratiles"
  },
  {
    "id": "dura_2004",
    "brand": "Duratiles",
    "title": "LIVINGSTONE Açık Gri 60x120",
    "seriesName": "LIVINGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2004",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2636810449230105.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2636810449230105.jpg"
    ],
    "size": "60x120",
    "color": "Açık Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Banyo & Ev içi Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "V2",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.</span>",
    "descriptionClean": "Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.",
    "source": "duratiles"
  },
  {
    "id": "dura_2005",
    "brand": "Duratiles",
    "title": "LIVINGSTONE Koyu Gri 60x120",
    "seriesName": "LIVINGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2005",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.06074058243498748.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.06074058243498748.jpg"
    ],
    "size": "60x120",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.</span>",
    "descriptionClean": "Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.",
    "source": "duratiles"
  },
  {
    "id": "dura_2006",
    "brand": "Duratiles",
    "title": "LIVINGSTONE Sand 60x120",
    "seriesName": "LIVINGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2006",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.593871573008028.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.593871573008028.jpg"
    ],
    "size": "60x120",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.</span>",
    "descriptionClean": "Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.",
    "source": "duratiles"
  },
  {
    "id": "dura_2007",
    "brand": "Duratiles",
    "title": "LIVINGSTONE Beyaz 60x120",
    "seriesName": "LIVINGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "11482",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5386773946112008.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5386773946112008.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Banyo & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.</span>",
    "descriptionClean": "Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.",
    "source": "duratiles"
  },
  {
    "id": "dura_2008",
    "brand": "Duratiles",
    "title": "LIVINGSTONE Vison 60x120",
    "seriesName": "LIVINGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "11484",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.47615544572751256.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.47615544572751256.jpg"
    ],
    "size": "60x120",
    "color": "Vison",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Banyo & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.</span>",
    "descriptionClean": "Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.",
    "source": "duratiles"
  },
  {
    "id": "dura_2009",
    "brand": "Duratiles",
    "title": "LIVINGSTONE Sand 120x120",
    "seriesName": "LIVINGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2009",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4603400853724283.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4603400853724283.jpg"
    ],
    "size": "120x120",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.</span>",
    "descriptionClean": "Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.",
    "source": "duratiles"
  },
  {
    "id": "dura_2010",
    "brand": "Duratiles",
    "title": "LIVINGSTONE Açık Gri 120x120",
    "seriesName": "LIVINGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2010",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6159508906193374.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6159508906193374.jpg"
    ],
    "size": "120x120",
    "color": "Açık Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.</span>",
    "descriptionClean": "Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.",
    "source": "duratiles"
  },
  {
    "id": "dura_2011",
    "brand": "Duratiles",
    "title": "LIVINGSTONE Koyu Gri 120x120",
    "seriesName": "LIVINGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2011",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14546225093974152.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14546225093974152.jpg"
    ],
    "size": "120x120",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.</span>",
    "descriptionClean": "Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.",
    "source": "duratiles"
  },
  {
    "id": "dura_2012",
    "brand": "Duratiles",
    "title": "LIVINGSTONE Antrasit 120x120",
    "seriesName": "LIVINGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2012",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4835715011449614.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4835715011449614.jpg"
    ],
    "size": "120x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.</span>",
    "descriptionClean": "Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.",
    "source": "duratiles"
  },
  {
    "id": "dura_2013",
    "brand": "Duratiles",
    "title": "LIVINGSTONE Sand 100x100",
    "seriesName": "LIVINGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2013",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8105607710141551.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8105607710141551.jpg"
    ],
    "size": "100x100",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.</span>",
    "descriptionClean": "Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.",
    "source": "duratiles"
  },
  {
    "id": "dura_2014",
    "brand": "Duratiles",
    "title": "LIVINGSTONE Açık Gri 100x100",
    "seriesName": "LIVINGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2014",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6439625101945592.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6439625101945592.jpg"
    ],
    "size": "100x100",
    "color": "Açık Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.</span>",
    "descriptionClean": "Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.",
    "source": "duratiles"
  },
  {
    "id": "dura_2015",
    "brand": "Duratiles",
    "title": "LIVINGSTONE Koyu Gri 100x100",
    "seriesName": "LIVINGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2015",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09312993127464952.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09312993127464952.jpg"
    ],
    "size": "100x100",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.</span>",
    "descriptionClean": "Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.",
    "source": "duratiles"
  },
  {
    "id": "dura_2016",
    "brand": "Duratiles",
    "title": "LIVINGSTONE Antrasit 100x100",
    "seriesName": "LIVINGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2016",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7719292000703725.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7719292000703725.jpg"
    ],
    "size": "100x100",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.</span>",
    "descriptionClean": "Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.",
    "source": "duratiles"
  },
  {
    "id": "dura_2017",
    "brand": "Duratiles",
    "title": "LIVINGSTONE Sand 80x80",
    "seriesName": "LIVINGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2017",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8220646382410948.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8220646382410948.jpg"
    ],
    "size": "80x80",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.</span>",
    "descriptionClean": "Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.",
    "source": "duratiles"
  },
  {
    "id": "dura_2018",
    "brand": "Duratiles",
    "title": "LIVINGSTONE Açık Gri 80x80",
    "seriesName": "LIVINGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2018",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36683217158008374.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36683217158008374.jpg"
    ],
    "size": "80x80",
    "color": "Açık Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.</span>",
    "descriptionClean": "Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.",
    "source": "duratiles"
  },
  {
    "id": "dura_2019",
    "brand": "Duratiles",
    "title": "LIVINGSTONE Koyu Gri 80x80",
    "seriesName": "LIVINGSTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2019",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8679109000173492.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8679109000173492.jpg"
    ],
    "size": "80x80",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.</span>",
    "descriptionClean": "Dokusuyla ve desenleriyle baş döndüren bir tasarım. Livingstone serisinde zarafeti seramikle bütünleştirdik. Her zaman şık, her zaman değerli bir armağan.",
    "source": "duratiles"
  },
  {
    "id": "dura_2020",
    "brand": "Duratiles",
    "title": "LIVINGSTONE SLIM TILES Sand 60x120",
    "seriesName": "LIVINGSTONE SLIM TILES",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2020",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6523725757942284.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6523725757942284.jpg"
    ],
    "size": "60x120",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz</span>",
    "descriptionClean": "Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_2021",
    "brand": "Duratiles",
    "title": "LIVINGSTONE SLIM TILES Açık Gri 60x120",
    "seriesName": "LIVINGSTONE SLIM TILES",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2021",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23815633924723933.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23815633924723933.jpg"
    ],
    "size": "60x120",
    "color": "Açık Gri",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz</span>",
    "descriptionClean": "Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_2022",
    "brand": "Duratiles",
    "title": "LIVINGSTONE SLIM TILES Koyu Gri 60x120",
    "seriesName": "LIVINGSTONE SLIM TILES",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2022",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5191352512055264.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5191352512055264.jpg"
    ],
    "size": "60x120",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz</span>",
    "descriptionClean": "Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_2023",
    "brand": "Duratiles",
    "title": "LIVINGSTONE SLIM TILES Antrasit 60x120",
    "seriesName": "LIVINGSTONE SLIM TILES",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2023",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.37114833624596244.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.37114833624596244.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz</span>",
    "descriptionClean": "Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_2024",
    "brand": "Duratiles",
    "title": "LIVINGSTONE SLIM TILES Sand 100x100",
    "seriesName": "LIVINGSTONE SLIM TILES",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2024",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5516493724955376.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5516493724955376.jpg"
    ],
    "size": "100x100",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz</span>",
    "descriptionClean": "Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_2025",
    "brand": "Duratiles",
    "title": "LIVINGSTONE SLIM TILES Açık Gri 100x100",
    "seriesName": "LIVINGSTONE SLIM TILES",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2025",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5044374852910705.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5044374852910705.jpg"
    ],
    "size": "100x100",
    "color": "Açık Gri",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz</span>",
    "descriptionClean": "Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_2026",
    "brand": "Duratiles",
    "title": "LIVINGSTONE SLIM TILES Koyu Gri 100x100",
    "seriesName": "LIVINGSTONE SLIM TILES",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2026",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9370456803445384.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9370456803445384.jpg"
    ],
    "size": "100x100",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz</span>",
    "descriptionClean": "Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_2027",
    "brand": "Duratiles",
    "title": "LIVINGSTONE SLIM TILES Antrasit 100x100",
    "seriesName": "LIVINGSTONE SLIM TILES",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2027",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15705219235005574.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15705219235005574.jpg"
    ],
    "size": "100x100",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz</span>",
    "descriptionClean": "Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_2028",
    "brand": "Duratiles",
    "title": "LIVINGSTONE SLIM TILES Sand 60x60",
    "seriesName": "LIVINGSTONE SLIM TILES",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2028",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4991030358141859.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4991030358141859.jpg"
    ],
    "size": "60x60",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz</span>",
    "descriptionClean": "Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_2029",
    "brand": "Duratiles",
    "title": "LIVINGSTONE SLIM TILES Açık Gri 60x60",
    "seriesName": "LIVINGSTONE SLIM TILES",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2029",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7690256327320187.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7690256327320187.jpg"
    ],
    "size": "60x60",
    "color": "Açık Gri",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz</span>",
    "descriptionClean": "Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_2030",
    "brand": "Duratiles",
    "title": "LIVINGSTONE SLIM TILES Koyu Gri 60x60",
    "seriesName": "LIVINGSTONE SLIM TILES",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2030",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7399822503590335.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7399822503590335.jpg"
    ],
    "size": "60x60",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz</span>",
    "descriptionClean": "Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_2031",
    "brand": "Duratiles",
    "title": "LIVINGSTONE SLIM TILES Antrasit 60x60",
    "seriesName": "LIVINGSTONE SLIM TILES",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2031",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9946840438388365.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9946840438388365.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz</span>",
    "descriptionClean": "Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_2032",
    "brand": "Duratiles",
    "title": "LIVINGSTONE SLIM TILES Sand 30x60",
    "seriesName": "LIVINGSTONE SLIM TILES",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2032",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.018841299748702967.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.018841299748702967.jpg"
    ],
    "size": "30x60",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V2",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz</span>",
    "descriptionClean": "Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_2033",
    "brand": "Duratiles",
    "title": "LIVINGSTONE SLIM TILES Açık Gri 30x60",
    "seriesName": "LIVINGSTONE SLIM TILES",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2033",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.352765515563078.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.352765515563078.jpg"
    ],
    "size": "30x60",
    "color": "Açık Gri",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V2",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz</span>",
    "descriptionClean": "Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_2034",
    "brand": "Duratiles",
    "title": "LIVINGSTONE SLIM TILES Koyu Gri 30x60",
    "seriesName": "LIVINGSTONE SLIM TILES",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2034",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4316863045656799.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4316863045656799.jpg"
    ],
    "size": "30x60",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V2",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz</span>",
    "descriptionClean": "Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_2035",
    "brand": "Duratiles",
    "title": "LIVINGSTONE SLIM TILES Antrasit 30x60",
    "seriesName": "LIVINGSTONE SLIM TILES",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2035",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.26863544436032594.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.26863544436032594.jpg"
    ],
    "size": "30x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Slim Tiles",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Dış Cephe & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Dış Cephe",
      "V2",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz</span>",
    "descriptionClean": "Naif bir kurgu yaratırken ,güçlü taş dokusunu mekanlarınıza taşımak isterseniz Livingstone Serisi en doğru seçim olacaktır.Farklı renk ve ebat seçeneğine sahip seri ile nefes kesen yaşam alanlarına kavuşabilirsiniz",
    "source": "duratiles"
  },
  {
    "id": "dura_2036",
    "brand": "Duratiles",
    "title": "MABEL Bej 15x60",
    "seriesName": "MABEL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2036",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4715353981607694.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4715353981607694.jpg"
    ],
    "size": "15x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Banyo & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2",
      "Banyo",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Özel mekânlara, özel dokunuşlar... Mabel serisi ile özel olmanın ayrıcalığını hissedecek, seramikten yansıyan ışıkla hayat bulacaksınız</span>",
    "descriptionClean": "Özel mekânlara, özel dokunuşlar... Mabel serisi ile özel olmanın ayrıcalığını hissedecek, seramikten yansıyan ışıkla hayat bulacaksınız",
    "source": "duratiles"
  },
  {
    "id": "dura_2037",
    "brand": "Duratiles",
    "title": "MABEL Gri 15x60",
    "seriesName": "MABEL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2037",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.35958498985649956.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.35958498985649956.jpg"
    ],
    "size": "15x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Banyo",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Özel mekânlara, özel dokunuşlar... Mabel serisi ile özel olmanın ayrıcalığını hissedecek, seramikten yansıyan ışıkla hayat bulacaksınız</span>",
    "descriptionClean": "Özel mekânlara, özel dokunuşlar... Mabel serisi ile özel olmanın ayrıcalığını hissedecek, seramikten yansıyan ışıkla hayat bulacaksınız",
    "source": "duratiles"
  },
  {
    "id": "dura_2038",
    "brand": "Duratiles",
    "title": "MANGAN Siyah 45x90",
    "seriesName": "MANGAN",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2038",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5349030981836974.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5349030981836974.jpg"
    ],
    "size": "45x90",
    "color": "Siyah",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mangan Serisi endüstriyel görünümü ile mekânlarınızı hayal ettiğiniz modern görünüme kavuşturuyor. Yalın bir zarifliğe sahip tasarımının yanı sıra yük ve yaya trafiğinin yoğun olduğu bütün iç ve dış mekanlarda kullanılabilme özelliği ile Mangan Serisi güçlü , dinamik ve dayanıklı.</span>",
    "descriptionClean": "Mangan Serisi endüstriyel görünümü ile mekânlarınızı hayal ettiğiniz modern görünüme kavuşturuyor. Yalın bir zarifliğe sahip tasarımının yanı sıra yük ve yaya trafiğinin yoğun olduğu bütün iç ve dış mekanlarda kullanılabilme özelliği ile Mangan Serisi güçlü , dinamik ve dayanıklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_2039",
    "brand": "Duratiles",
    "title": "MANGAN Siyah 60x120",
    "seriesName": "MANGAN",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2039",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.998803590950147.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.998803590950147.jpg"
    ],
    "size": "60x120",
    "color": "Siyah",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mangan Serisi endüstriyel görünümü ile mekânlarınızı hayal ettiğiniz modern görünüme kavuşturuyor. Yalın bir zarifliğe sahip tasarımının yanı sıra yük ve yaya trafiğinin yoğun olduğu bütün iç ve dış mekanlarda kullanılabilme özelliği ile Mangan Serisi güçlü , dinamik ve dayanıklı.</span>",
    "descriptionClean": "Mangan Serisi endüstriyel görünümü ile mekânlarınızı hayal ettiğiniz modern görünüme kavuşturuyor. Yalın bir zarifliğe sahip tasarımının yanı sıra yük ve yaya trafiğinin yoğun olduğu bütün iç ve dış mekanlarda kullanılabilme özelliği ile Mangan Serisi güçlü , dinamik ve dayanıklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_2040",
    "brand": "Duratiles",
    "title": "MANGAN Gri 60x120",
    "seriesName": "MANGAN",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2040",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9209707512536193.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9209707512536193.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mangan Serisi endüstriyel görünümü ile mekânlarınızı hayal ettiğiniz modern görünüme kavuşturuyor. Yalın bir zarifliğe sahip tasarımının yanı sıra yük ve yaya trafiğinin yoğun olduğu bütün iç ve dış mekanlarda kullanılabilme özelliği ile Mangan Serisi güçlü , dinamik ve dayanıklı.</span>",
    "descriptionClean": "Mangan Serisi endüstriyel görünümü ile mekânlarınızı hayal ettiğiniz modern görünüme kavuşturuyor. Yalın bir zarifliğe sahip tasarımının yanı sıra yük ve yaya trafiğinin yoğun olduğu bütün iç ve dış mekanlarda kullanılabilme özelliği ile Mangan Serisi güçlü , dinamik ve dayanıklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_2041",
    "brand": "Duratiles",
    "title": "MANGAN Siyah 30x120",
    "seriesName": "MANGAN",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2041",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5458552389319178.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5458552389319178.jpg"
    ],
    "size": "30x120",
    "color": "Siyah",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mangan Serisi endüstriyel görünümü ile mekânlarınızı hayal ettiğiniz modern görünüme kavuşturuyor. Yalın bir zarifliğe sahip tasarımının yanı sıra yük ve yaya trafiğinin yoğun olduğu bütün iç ve dış mekanlarda kullanılabilme özelliği ile Mangan Serisi güçlü , dinamik ve dayanıklı.</span>",
    "descriptionClean": "Mangan Serisi endüstriyel görünümü ile mekânlarınızı hayal ettiğiniz modern görünüme kavuşturuyor. Yalın bir zarifliğe sahip tasarımının yanı sıra yük ve yaya trafiğinin yoğun olduğu bütün iç ve dış mekanlarda kullanılabilme özelliği ile Mangan Serisi güçlü , dinamik ve dayanıklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_2042",
    "brand": "Duratiles",
    "title": "MANGAN Gri 30x120",
    "seriesName": "MANGAN",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2042",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9530367346079717.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9530367346079717.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mangan Serisi endüstriyel görünümü ile mekânlarınızı hayal ettiğiniz modern görünüme kavuşturuyor. Yalın bir zarifliğe sahip tasarımının yanı sıra yük ve yaya trafiğinin yoğun olduğu bütün iç ve dış mekanlarda kullanılabilme özelliği ile Mangan Serisi güçlü , dinamik ve dayanıklı.</span>",
    "descriptionClean": "Mangan Serisi endüstriyel görünümü ile mekânlarınızı hayal ettiğiniz modern görünüme kavuşturuyor. Yalın bir zarifliğe sahip tasarımının yanı sıra yük ve yaya trafiğinin yoğun olduğu bütün iç ve dış mekanlarda kullanılabilme özelliği ile Mangan Serisi güçlü , dinamik ve dayanıklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_2043",
    "brand": "Duratiles",
    "title": "MANGAN Siyah 40x80",
    "seriesName": "MANGAN",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2043",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9784713188813862.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9784713188813862.jpg"
    ],
    "size": "40x80",
    "color": "Siyah",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mangan Serisi endüstriyel görünümü ile mekânlarınızı hayal ettiğiniz modern görünüme kavuşturuyor. Yalın bir zarifliğe sahip tasarımının yanı sıra yük ve yaya trafiğinin yoğun olduğu bütün iç ve dış mekanlarda kullanılabilme özelliği ile Mangan Serisi güçlü , dinamik ve dayanıklı.</span>",
    "descriptionClean": "Mangan Serisi endüstriyel görünümü ile mekânlarınızı hayal ettiğiniz modern görünüme kavuşturuyor. Yalın bir zarifliğe sahip tasarımının yanı sıra yük ve yaya trafiğinin yoğun olduğu bütün iç ve dış mekanlarda kullanılabilme özelliği ile Mangan Serisi güçlü , dinamik ve dayanıklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_2044",
    "brand": "Duratiles",
    "title": "MANGAN Gri 40x80",
    "seriesName": "MANGAN",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2044",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2192544241769182.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2192544241769182.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mangan Serisi endüstriyel görünümü ile mekânlarınızı hayal ettiğiniz modern görünüme kavuşturuyor. Yalın bir zarifliğe sahip tasarımının yanı sıra yük ve yaya trafiğinin yoğun olduğu bütün iç ve dış mekanlarda kullanılabilme özelliği ile Mangan Serisi güçlü , dinamik ve dayanıklı.</span>",
    "descriptionClean": "Mangan Serisi endüstriyel görünümü ile mekânlarınızı hayal ettiğiniz modern görünüme kavuşturuyor. Yalın bir zarifliğe sahip tasarımının yanı sıra yük ve yaya trafiğinin yoğun olduğu bütün iç ve dış mekanlarda kullanılabilme özelliği ile Mangan Serisi güçlü , dinamik ve dayanıklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_2045",
    "brand": "Duratiles",
    "title": "MANGAN Siyah 60x60",
    "seriesName": "MANGAN",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2045",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8956469875277067.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8956469875277067.jpg"
    ],
    "size": "60x60",
    "color": "Siyah",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mangan Serisi endüstriyel görünümü ile mekânlarınızı hayal ettiğiniz modern görünüme kavuşturuyor. Yalın bir zarifliğe sahip tasarımının yanı sıra yük ve yaya trafiğinin yoğun olduğu bütün iç ve dış mekanlarda kullanılabilme özelliği ile Mangan Serisi güçlü , dinamik ve dayanıklı.</span>",
    "descriptionClean": "Mangan Serisi endüstriyel görünümü ile mekânlarınızı hayal ettiğiniz modern görünüme kavuşturuyor. Yalın bir zarifliğe sahip tasarımının yanı sıra yük ve yaya trafiğinin yoğun olduğu bütün iç ve dış mekanlarda kullanılabilme özelliği ile Mangan Serisi güçlü , dinamik ve dayanıklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_2046",
    "brand": "Duratiles",
    "title": "MANGAN Siyah 40x40",
    "seriesName": "MANGAN",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2046",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18358028642288626.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18358028642288626.jpg"
    ],
    "size": "40x40",
    "color": "Siyah",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mangan Serisi endüstriyel görünümü ile mekânlarınızı hayal ettiğiniz modern görünüme kavuşturuyor. Yalın bir zarifliğe sahip tasarımının yanı sıra yük ve yaya trafiğinin yoğun olduğu bütün iç ve dış mekanlarda kullanılabilme özelliği ile Mangan Serisi güçlü , dinamik ve dayanıklı.</span>",
    "descriptionClean": "Mangan Serisi endüstriyel görünümü ile mekânlarınızı hayal ettiğiniz modern görünüme kavuşturuyor. Yalın bir zarifliğe sahip tasarımının yanı sıra yük ve yaya trafiğinin yoğun olduğu bütün iç ve dış mekanlarda kullanılabilme özelliği ile Mangan Serisi güçlü , dinamik ve dayanıklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_2047",
    "brand": "Duratiles",
    "title": "MANGAN Gri 40x40",
    "seriesName": "MANGAN",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2047",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5072003913436495.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5072003913436495.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mangan Serisi endüstriyel görünümü ile mekânlarınızı hayal ettiğiniz modern görünüme kavuşturuyor. Yalın bir zarifliğe sahip tasarımının yanı sıra yük ve yaya trafiğinin yoğun olduğu bütün iç ve dış mekanlarda kullanılabilme özelliği ile Mangan Serisi güçlü , dinamik ve dayanıklı.</span>",
    "descriptionClean": "Mangan Serisi endüstriyel görünümü ile mekânlarınızı hayal ettiğiniz modern görünüme kavuşturuyor. Yalın bir zarifliğe sahip tasarımının yanı sıra yük ve yaya trafiğinin yoğun olduğu bütün iç ve dış mekanlarda kullanılabilme özelliği ile Mangan Serisi güçlü , dinamik ve dayanıklı.",
    "source": "duratiles"
  },
  {
    "id": "dura_2048",
    "brand": "Duratiles",
    "title": "MARFA Antrasit 15x60",
    "seriesName": "MARFA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2048",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8562156143634782.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8562156143634782.jpg"
    ],
    "size": "15x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Banyo & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mekanlara yeni bir hareket ve derinlik getiren Marfa Porselen Karoları, maximum konforu hedefliyor.</span>",
    "descriptionClean": "Mekanlara yeni bir hareket ve derinlik getiren Marfa Porselen Karoları, maximum konforu hedefliyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2049",
    "brand": "Duratiles",
    "title": "MARFA Cotto 15x60",
    "seriesName": "MARFA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2049",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9181943193284661.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9181943193284661.jpg"
    ],
    "size": "15x60",
    "color": "Cotto",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Banyo & Dış Cephe & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "V2",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mekanlara yeni bir hareket ve derinlik getiren Marfa Porselen Karoları, maximum konforu hedefliyor.</span>",
    "descriptionClean": "Mekanlara yeni bir hareket ve derinlik getiren Marfa Porselen Karoları, maximum konforu hedefliyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2050",
    "brand": "Duratiles",
    "title": "MARS Bone 30x60",
    "seriesName": "MARS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2050",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7921681823148943.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7921681823148943.jpg"
    ],
    "size": "30x60",
    "color": "Bone",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Banyo & Dış Cephe & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "V2",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal taşın sıcaklığını ve karakterini yansıtan yüzeyiyle her alanda estetik bir bütünlük oluşturur. Dayanıklılığı ve zarif görünümüyle Mars, mekânlarda dengeli ve sofistike bir atmosfer yaratır.</span>",
    "descriptionClean": "Doğal taşın sıcaklığını ve karakterini yansıtan yüzeyiyle her alanda estetik bir bütünlük oluşturur. Dayanıklılığı ve zarif görünümüyle Mars, mekânlarda dengeli ve sofistike bir atmosfer yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2051",
    "brand": "Duratiles",
    "title": "MARS Gümüş 30x60",
    "seriesName": "MARS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2051",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17595548926510907.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17595548926510907.jpg"
    ],
    "size": "30x60",
    "color": "Gümüş",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Banyo & Dış Cephe & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "Banyo",
      "Dış Cephe",
      "V2",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğal taşın sıcaklığını ve karakterini yansıtan yüzeyiyle her alanda estetik bir bütünlük oluşturur. Dayanıklılığı ve zarif görünümüyle Mars, mekânlarda dengeli ve sofistike bir atmosfer yaratır.</span>",
    "descriptionClean": "Doğal taşın sıcaklığını ve karakterini yansıtan yüzeyiyle her alanda estetik bir bütünlük oluşturur. Dayanıklılığı ve zarif görünümüyle Mars, mekânlarda dengeli ve sofistike bir atmosfer yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2052",
    "brand": "Duratiles",
    "title": "MILESTONE Antrasit 60x60",
    "seriesName": "MILESTONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2052",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9353460722879375.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9353460722879375.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Güçlü taş dokusunu modern tasarımla buluşturarak mekânlara karakter katar. Mat yüzeyinin sofistike duruşu, zamansız ve etkileyici bir atmosfer yaratır.</span>",
    "descriptionClean": "Güçlü taş dokusunu modern tasarımla buluşturarak mekânlara karakter katar. Mat yüzeyinin sofistike duruşu, zamansız ve etkileyici bir atmosfer yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2339",
    "brand": "Duratiles",
    "title": "MINESOTA Mocha 60x120",
    "seriesName": "MINESOTA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2339",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5066301564224428.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5066301564224428.jpg"
    ],
    "size": "60x120",
    "color": "Mocha",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar & Yer & Duvar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Minesota Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.</span>",
    "descriptionClean": "Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Minesota Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2338",
    "brand": "Duratiles",
    "title": "MINESOTA Antrasit 60x120",
    "seriesName": "MINESOTA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2338",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09687005929162518.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09687005929162518.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar & Yer & Duvar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Minesota Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.</span>",
    "descriptionClean": "Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Minesota Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2337",
    "brand": "Duratiles",
    "title": "MINESOTA Sand 60x120",
    "seriesName": "MINESOTA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2337",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.320295775946412.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.320295775946412.jpg"
    ],
    "size": "60x120",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar & Yer & Duvar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "< 0.5%",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Minesota Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.</span>",
    "descriptionClean": "Bulunduğu alanda stil sahibi bir tasarım anlayışının altını çizen Minesota Porselen Karoları kusursuz tasarım dilini yaşam alanlarınıza taşıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2056",
    "brand": "Duratiles",
    "title": "MYSTIQUE Multi Color 60x120",
    "seriesName": "MYSTIQUE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2056",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4537571516681991.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4537571516681991.jpg"
    ],
    "size": "60x120",
    "color": "Multi Color",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mystique Serisi dokusu , rengi ve tarzıyla özgün ve çarpıcı mekanların ilk tercihi olan seri klasik harçlı uygulamalarda 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.</span>",
    "descriptionClean": "Mystique Serisi dokusu , rengi ve tarzıyla özgün ve çarpıcı mekanların ilk tercihi olan seri klasik harçlı uygulamalarda 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_2057",
    "brand": "Duratiles",
    "title": "MYSTIQUE Multi Color 30x120",
    "seriesName": "MYSTIQUE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2057",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20758833159099654.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20758833159099654.jpg"
    ],
    "size": "30x120",
    "color": "Multi Color",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mystique Serisi dokusu , rengi ve tarzıyla özgün ve çarpıcı mekanların ilk tercihi olan seri klasik harçlı uygulamalarda 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.</span>",
    "descriptionClean": "Mystique Serisi dokusu , rengi ve tarzıyla özgün ve çarpıcı mekanların ilk tercihi olan seri klasik harçlı uygulamalarda 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_2058",
    "brand": "Duratiles",
    "title": "MYSTIQUE Multi Color 40x80",
    "seriesName": "MYSTIQUE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2058",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7213489335914242.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7213489335914242.jpg"
    ],
    "size": "40x80",
    "color": "Multi Color",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mystique Serisi dokusu , rengi ve tarzıyla özgün ve çarpıcı mekanların ilk tercihi olan seri klasik harçlı uygulamalarda 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.</span>",
    "descriptionClean": "Mystique Serisi dokusu , rengi ve tarzıyla özgün ve çarpıcı mekanların ilk tercihi olan seri klasik harçlı uygulamalarda 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_2059",
    "brand": "Duratiles",
    "title": "MYSTIQUE Multi Color 60x60",
    "seriesName": "MYSTIQUE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2059",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8010291162038992.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8010291162038992.jpg"
    ],
    "size": "60x60",
    "color": "Multi Color",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mystique Serisi dokusu , rengi ve tarzıyla özgün ve çarpıcı mekanların ilk tercihi olan seri klasik harçlı uygulamalarda 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.</span>",
    "descriptionClean": "Mystique Serisi dokusu , rengi ve tarzıyla özgün ve çarpıcı mekanların ilk tercihi olan seri klasik harçlı uygulamalarda 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_2060",
    "brand": "Duratiles",
    "title": "MYSTIQUE Multi Color 60x60",
    "seriesName": "MYSTIQUE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2060",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14286986792518563.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.14286986792518563.jpg"
    ],
    "size": "60x60",
    "color": "Multi Color",
    "surface": "Full Lappato, Mat",
    "thickness": "30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mystique Serisi dokusu , rengi ve tarzıyla özgün ve çarpıcı mekanların ilk tercihi olan seri klasik harçlı uygulamalarda 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.</span>",
    "descriptionClean": "Mystique Serisi dokusu , rengi ve tarzıyla özgün ve çarpıcı mekanların ilk tercihi olan seri klasik harçlı uygulamalarda 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_2061",
    "brand": "Duratiles",
    "title": "MYSTIQUE Multi Color 40x40",
    "seriesName": "MYSTIQUE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2061",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4816578118165594.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4816578118165594.jpg"
    ],
    "size": "40x40",
    "color": "Multi Color",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mystique Serisi dokusu , rengi ve tarzıyla özgün ve çarpıcı mekanların ilk tercihi olan seri klasik harçlı uygulamalarda 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.</span>",
    "descriptionClean": "Mystique Serisi dokusu , rengi ve tarzıyla özgün ve çarpıcı mekanların ilk tercihi olan seri klasik harçlı uygulamalarda 30mm ve 20mm kalınlıklarının avantajıyla çatlamalara ve kırılmalara karşı üstün bir dayanıklılık sağlar.",
    "source": "duratiles"
  },
  {
    "id": "dura_2062",
    "brand": "Duratiles",
    "title": "NEO ASSOS Gri 60x120",
    "seriesName": "NEO ASSOS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "70503",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9785619034425947.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9785619034425947.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Son zamanlarda popüler hale gelen beton görünümlü karolar, uygulandığı mekânlara sıra dışı bir görünüm kazandırırken, Neo Assos serisi size farklı ve modern bir tarzın kapılarını aralıyor.</span></ul>",
    "descriptionClean": "Son zamanlarda popüler hale gelen beton görünümlü karolar, uygulandığı mekânlara sıra dışı bir görünüm kazandırırken, Neo Assos serisi size farklı ve modern bir tarzın kapılarını aralıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2063",
    "brand": "Duratiles",
    "title": "NEO ASSOS Nero 60x120",
    "seriesName": "NEO ASSOS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "70344",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6473945875097351.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6473945875097351.jpg"
    ],
    "size": "60x120",
    "color": "Nero",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Son zamanlarda popüler hale gelen beton görünümlü karolar, uygulandığı mekânlara sıra dışı bir görünüm kazandırırken, Neo Assos serisi size farklı ve modern bir tarzın kapılarını aralıyor.</span></ul>",
    "descriptionClean": "Son zamanlarda popüler hale gelen beton görünümlü karolar, uygulandığı mekânlara sıra dışı bir görünüm kazandırırken, Neo Assos serisi size farklı ve modern bir tarzın kapılarını aralıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2064",
    "brand": "Duratiles",
    "title": "NEO ASSOS Gri 120x120",
    "seriesName": "NEO ASSOS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2064",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5518082471964423.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5518082471964423.jpg"
    ],
    "size": "120x120",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Son zamanlarda popüler hale gelen beton görünümlü karolar, uygulandığı mekânlara sıra dışı bir görünüm kazandırırken, Neo Assos serisi size farklı ve modern bir tarzın kapılarını aralıyor.</span></ul>",
    "descriptionClean": "Son zamanlarda popüler hale gelen beton görünümlü karolar, uygulandığı mekânlara sıra dışı bir görünüm kazandırırken, Neo Assos serisi size farklı ve modern bir tarzın kapılarını aralıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2065",
    "brand": "Duratiles",
    "title": "NEO ASSOS Nero 120x120",
    "seriesName": "NEO ASSOS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2065",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1722657205786997.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1722657205786997.jpg"
    ],
    "size": "120x120",
    "color": "Nero",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Son zamanlarda popüler hale gelen beton görünümlü karolar, uygulandığı mekânlara sıra dışı bir görünüm kazandırırken, Neo Assos serisi size farklı ve modern bir tarzın kapılarını aralıyor.</span></ul>",
    "descriptionClean": "Son zamanlarda popüler hale gelen beton görünümlü karolar, uygulandığı mekânlara sıra dışı bir görünüm kazandırırken, Neo Assos serisi size farklı ve modern bir tarzın kapılarını aralıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2066",
    "brand": "Duratiles",
    "title": "NEO SONORA SHADOW Cool 60x120",
    "seriesName": "NEO SONORA SHADOW",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2066",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6877089819594714.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6877089819594714.jpg"
    ],
    "size": "60x120",
    "color": "Cool",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Balkon/Teras & Banyo & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112); text-align: center;\">İncelikli tasarım anlayışı ile Neo Sonora Shadow porselen karoları ile yaşam alanlarınız zamansız bir görünüm kazandırır</span></ul>",
    "descriptionClean": "İncelikli tasarım anlayışı ile Neo Sonora Shadow porselen karoları ile yaşam alanlarınız zamansız bir görünüm kazandırır",
    "source": "duratiles"
  },
  {
    "id": "dura_2067",
    "brand": "Duratiles",
    "title": "NEXUS Mica 60x120",
    "seriesName": "NEXUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2067",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22880268790353908.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22880268790353908.jpg"
    ],
    "size": "60x120",
    "color": "Mica",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor</span></ul>",
    "descriptionClean": "Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2068",
    "brand": "Duratiles",
    "title": "NEXUS Kil 60x120",
    "seriesName": "NEXUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2068",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4599501841413538.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4599501841413538.jpg"
    ],
    "size": "60x120",
    "color": "Kil",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor</span></ul>",
    "descriptionClean": "Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2069",
    "brand": "Duratiles",
    "title": "NEXUS Graphite 60x120",
    "seriesName": "NEXUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2069",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5260797485254156.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5260797485254156.jpg"
    ],
    "size": "60x120",
    "color": "Graphite",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor</span></ul>",
    "descriptionClean": "Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2070",
    "brand": "Duratiles",
    "title": "NEXUS İce 60x120",
    "seriesName": "NEXUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2070",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7066393233622756.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7066393233622756.jpg"
    ],
    "size": "60x120",
    "color": "İce",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor</span></ul>",
    "descriptionClean": "Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2071",
    "brand": "Duratiles",
    "title": "NEXUS Mica 30x120",
    "seriesName": "NEXUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2071",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2346346885552587.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2346346885552587.jpg"
    ],
    "size": "30x120",
    "color": "Mica",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor</span></ul>",
    "descriptionClean": "Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2072",
    "brand": "Duratiles",
    "title": "NEXUS Kil 30x120",
    "seriesName": "NEXUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2072",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8393322298459465.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8393322298459465.jpg"
    ],
    "size": "30x120",
    "color": "Kil",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor</span></ul>",
    "descriptionClean": "Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2073",
    "brand": "Duratiles",
    "title": "NEXUS Graphite 30x120",
    "seriesName": "NEXUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2073",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15432069325200393.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15432069325200393.jpg"
    ],
    "size": "30x120",
    "color": "Graphite",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor</span></ul>",
    "descriptionClean": "Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2074",
    "brand": "Duratiles",
    "title": "NEXUS İce 30x120",
    "seriesName": "NEXUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2074",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.051202057053379546.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.051202057053379546.jpg"
    ],
    "size": "30x120",
    "color": "İce",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor</span></ul>",
    "descriptionClean": "Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2075",
    "brand": "Duratiles",
    "title": "NEXUS Mica 40x80",
    "seriesName": "NEXUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2075",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.38846841915917973.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.38846841915917973.jpg"
    ],
    "size": "40x80",
    "color": "Mica",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor</span></ul>",
    "descriptionClean": "Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2076",
    "brand": "Duratiles",
    "title": "NEXUS Kil 40x80",
    "seriesName": "NEXUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2076",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7168688596825202.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7168688596825202.jpg"
    ],
    "size": "40x80",
    "color": "Kil",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor</span></ul>",
    "descriptionClean": "Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2077",
    "brand": "Duratiles",
    "title": "NEXUS Graphite 40x80",
    "seriesName": "NEXUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2077",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9183372556841578.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9183372556841578.jpg"
    ],
    "size": "40x80",
    "color": "Graphite",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor</span></ul>",
    "descriptionClean": "Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2078",
    "brand": "Duratiles",
    "title": "NEXUS İce 40x80",
    "seriesName": "NEXUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2078",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5391272113638627.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5391272113638627.jpg"
    ],
    "size": "40x80",
    "color": "İce",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor</span></ul>",
    "descriptionClean": "Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2079",
    "brand": "Duratiles",
    "title": "NEXUS Mica 60x60",
    "seriesName": "NEXUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2079",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2714977434894422.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2714977434894422.jpg"
    ],
    "size": "60x60",
    "color": "Mica",
    "surface": "Full Lappato, Mat",
    "thickness": "30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor</span></ul>",
    "descriptionClean": "Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2080",
    "brand": "Duratiles",
    "title": "NEXUS Kil 60x60",
    "seriesName": "NEXUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2080",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6535054933203305.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6535054933203305.jpg"
    ],
    "size": "60x60",
    "color": "Kil",
    "surface": "Full Lappato, Mat",
    "thickness": "30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor</span></ul>",
    "descriptionClean": "Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2081",
    "brand": "Duratiles",
    "title": "NEXUS Graphite 60x60",
    "seriesName": "NEXUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2081",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16012678025187377.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16012678025187377.jpg"
    ],
    "size": "60x60",
    "color": "Graphite",
    "surface": "Full Lappato, Mat",
    "thickness": "30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor</span></ul>",
    "descriptionClean": "Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2082",
    "brand": "Duratiles",
    "title": "NEXUS İce 60x60",
    "seriesName": "NEXUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2082",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.31754170310180396.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.31754170310180396.jpg"
    ],
    "size": "60x60",
    "color": "İce",
    "surface": "Full Lappato, Mat",
    "thickness": "30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor</span></ul>",
    "descriptionClean": "Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2083",
    "brand": "Duratiles",
    "title": "NEXUS Mica 40x40",
    "seriesName": "NEXUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2083",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8477792296258403.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8477792296258403.jpg"
    ],
    "size": "40x40",
    "color": "Mica",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor</span></ul>",
    "descriptionClean": "Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2084",
    "brand": "Duratiles",
    "title": "NEXUS Kil 40x40",
    "seriesName": "NEXUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2084",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20332810110890565.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.20332810110890565.jpg"
    ],
    "size": "40x40",
    "color": "Kil",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor</span></ul>",
    "descriptionClean": "Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2085",
    "brand": "Duratiles",
    "title": "NEXUS Graphite 40x40",
    "seriesName": "NEXUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2085",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5804341405498851.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5804341405498851.jpg"
    ],
    "size": "40x40",
    "color": "Graphite",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor</span></ul>",
    "descriptionClean": "Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2086",
    "brand": "Duratiles",
    "title": "NEXUS İce 40x40",
    "seriesName": "NEXUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2086",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5087522429673587.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5087522429673587.jpg"
    ],
    "size": "40x40",
    "color": "İce",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor</span></ul>",
    "descriptionClean": "Güzelliğin tanımı Nexus Serisi ile tekrar yazılıyor. Tarz sahibi mekânlar Nexus ile karakteristik detaylara sahip oluyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2087",
    "brand": "Duratiles",
    "title": "NOGUCHI Beyaz 30x60",
    "seriesName": "NOGUCHI",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2087",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4341826438576235.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4341826438576235.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Doğal taşlardan ilham alınarak tasarlanan Noguchi Serisi uygulandığı her mekana uyum sağlama becerisi ile göz dolduruyor. Hem duvarda hem de zeminde kullanabileceğiniz Noguchi Serisi güçlü teknik alt yapısını zarif tasarımı ile harmanlayarak stil sahibi alanlar yaratıyor .</span></ul>",
    "descriptionClean": "Doğal taşlardan ilham alınarak tasarlanan Noguchi Serisi uygulandığı her mekana uyum sağlama becerisi ile göz dolduruyor. Hem duvarda hem de zeminde kullanabileceğiniz Noguchi Serisi güçlü teknik alt yapısını zarif tasarımı ile harmanlayarak stil sahibi alanlar yaratıyor .",
    "source": "duratiles"
  },
  {
    "id": "dura_2088",
    "brand": "Duratiles",
    "title": "NOGUCHI Antrasit 30x60",
    "seriesName": "NOGUCHI",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2088",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09749309958229302.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09749309958229302.jpg"
    ],
    "size": "30x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Doğal taşlardan ilham alınarak tasarlanan Noguchi Serisi uygulandığı her mekana uyum sağlama becerisi ile göz dolduruyor. Hem duvarda hem de zeminde kullanabileceğiniz Noguchi Serisi güçlü teknik alt yapısını zarif tasarımı ile harmanlayarak stil sahibi alanlar yaratıyor .</span></ul>",
    "descriptionClean": "Doğal taşlardan ilham alınarak tasarlanan Noguchi Serisi uygulandığı her mekana uyum sağlama becerisi ile göz dolduruyor. Hem duvarda hem de zeminde kullanabileceğiniz Noguchi Serisi güçlü teknik alt yapısını zarif tasarımı ile harmanlayarak stil sahibi alanlar yaratıyor .",
    "source": "duratiles"
  },
  {
    "id": "dura_2089",
    "brand": "Duratiles",
    "title": "NOGUCHI Gri 30x60",
    "seriesName": "NOGUCHI",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2089",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6994754992250685.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6994754992250685.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Doğal taşlardan ilham alınarak tasarlanan Noguchi Serisi uygulandığı her mekana uyum sağlama becerisi ile göz dolduruyor. Hem duvarda hem de zeminde kullanabileceğiniz Noguchi Serisi güçlü teknik alt yapısını zarif tasarımı ile harmanlayarak stil sahibi alanlar yaratıyor .</span></ul>",
    "descriptionClean": "Doğal taşlardan ilham alınarak tasarlanan Noguchi Serisi uygulandığı her mekana uyum sağlama becerisi ile göz dolduruyor. Hem duvarda hem de zeminde kullanabileceğiniz Noguchi Serisi güçlü teknik alt yapısını zarif tasarımı ile harmanlayarak stil sahibi alanlar yaratıyor .",
    "source": "duratiles"
  },
  {
    "id": "dura_2090",
    "brand": "Duratiles",
    "title": "NOGUCHI Krem 30x60",
    "seriesName": "NOGUCHI",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2090",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18174499524161247.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18174499524161247.jpg"
    ],
    "size": "30x60",
    "color": "Krem",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Doğal taşlardan ilham alınarak tasarlanan Noguchi Serisi uygulandığı her mekana uyum sağlama becerisi ile göz dolduruyor. Hem duvarda hem de zeminde kullanabileceğiniz Noguchi Serisi güçlü teknik alt yapısını zarif tasarımı ile harmanlayarak stil sahibi alanlar yaratıyor .</span></ul>",
    "descriptionClean": "Doğal taşlardan ilham alınarak tasarlanan Noguchi Serisi uygulandığı her mekana uyum sağlama becerisi ile göz dolduruyor. Hem duvarda hem de zeminde kullanabileceğiniz Noguchi Serisi güçlü teknik alt yapısını zarif tasarımı ile harmanlayarak stil sahibi alanlar yaratıyor .",
    "source": "duratiles"
  },
  {
    "id": "dura_2091",
    "brand": "Duratiles",
    "title": "NORR Sand 60x60",
    "seriesName": "NORR",
    "collection": "Taş",
    "category": "Taş",
    "sku": "71818",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7244333335173924.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7244333335173924.jpg"
    ],
    "size": "60x60",
    "color": "Sand",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Havuz",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Zamansızlığı ve yalınlığı beraberinde getiren Norr Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta .</span></ul>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Norr Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta .",
    "source": "duratiles"
  },
  {
    "id": "dura_2092",
    "brand": "Duratiles",
    "title": "NORR Gri 60x60",
    "seriesName": "NORR",
    "collection": "Taş",
    "category": "Taş",
    "sku": "65411",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.583840486701763.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.583840486701763.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Endüstriyel Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Zamansızlığı ve yalınlığı beraberinde getiren Norr Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta .</span></ul>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Norr Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta .",
    "source": "duratiles"
  },
  {
    "id": "dura_2093",
    "brand": "Duratiles",
    "title": "NORR Antrasit 60x60",
    "seriesName": "NORR",
    "collection": "Taş",
    "category": "Taş",
    "sku": "10300",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.054611319914941836.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.054611319914941836.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz",
      "V3",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Zamansızlığı ve yalınlığı beraberinde getiren Norr Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta .</span></ul>",
    "descriptionClean": "Zamansızlığı ve yalınlığı beraberinde getiren Norr Serisi benzersiz tasarımı ile seçkin bir deneyim sunmakta .",
    "source": "duratiles"
  },
  {
    "id": "dura_2094",
    "brand": "Duratiles",
    "title": "NOVI Burn 15x60",
    "seriesName": "NOVI",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2094",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5196449605933643.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5196449605933643.jpg"
    ],
    "size": "15x60",
    "color": "Burn",
    "surface": "Mat",
    "thickness": "",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2",
      "Banyo",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Dekorasyonunuzu tamamlayan, dokusu ile fark yaratan Novi serisi maximum konforu hedefleyen evler tasarlar</span></ul>",
    "descriptionClean": "Dekorasyonunuzu tamamlayan, dokusu ile fark yaratan Novi serisi maximum konforu hedefleyen evler tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_2095",
    "brand": "Duratiles",
    "title": "NOVI Coal 15x60",
    "seriesName": "NOVI",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2095",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.141888017784916.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.141888017784916.jpg"
    ],
    "size": "15x60",
    "color": "Coal",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2",
      "Banyo",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Dekorasyonunuzu tamamlayan, dokusu ile fark yaratan Novi serisi maximum konforu hedefleyen evler tasarlar</span></ul>",
    "descriptionClean": "Dekorasyonunuzu tamamlayan, dokusu ile fark yaratan Novi serisi maximum konforu hedefleyen evler tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_2096",
    "brand": "Duratiles",
    "title": "NOVI Cotto 15x60",
    "seriesName": "NOVI",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2096",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.713260780928329.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.713260780928329.jpg"
    ],
    "size": "15x60",
    "color": "Cotto",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Dekorasyonunuzu tamamlayan, dokusu ile fark yaratan Novi serisi maximum konforu hedefleyen evler tasarlar</span></ul>",
    "descriptionClean": "Dekorasyonunuzu tamamlayan, dokusu ile fark yaratan Novi serisi maximum konforu hedefleyen evler tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_2097",
    "brand": "Duratiles",
    "title": "NOVI Natura 15x60",
    "seriesName": "NOVI",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2097",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.713260780928329.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.713260780928329.jpg"
    ],
    "size": "15x60",
    "color": "Natura",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Dekorasyonunuzu tamamlayan, dokusu ile fark yaratan Novi serisi maximum konforu hedefleyen evler tasarlar</span></ul>",
    "descriptionClean": "Dekorasyonunuzu tamamlayan, dokusu ile fark yaratan Novi serisi maximum konforu hedefleyen evler tasarlar",
    "source": "duratiles"
  },
  {
    "id": "dura_2098",
    "brand": "Duratiles",
    "title": "OLD STONE Kahve 30x60",
    "seriesName": "OLD STONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2098",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12585306027453913.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.12585306027453913.jpg"
    ],
    "size": "30x60",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Old Stone serisi doğal taş dokusu ve mat yüzeyi mekanlarda natürel kurgular yaratmanıza yardımcı oluyor.</span></ul>",
    "descriptionClean": "Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Old Stone serisi doğal taş dokusu ve mat yüzeyi mekanlarda natürel kurgular yaratmanıza yardımcı oluyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2099",
    "brand": "Duratiles",
    "title": "OLD STONE Gri 30x60",
    "seriesName": "OLD STONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2099",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6410382956362832.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6410382956362832.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Old Stone serisi doğal taş dokusu ve mat yüzeyi mekanlarda natürel kurgular yaratmanıza yardımcı oluyor.</span></ul>",
    "descriptionClean": "Kullanıcılarına ürünlerini kişiselleştirme konusunda alternatif çözümler sunan Old Stone serisi doğal taş dokusu ve mat yüzeyi mekanlarda natürel kurgular yaratmanıza yardımcı oluyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2100",
    "brand": "Duratiles",
    "title": "OLYMPIA Bej 60x60",
    "seriesName": "OLYMPIA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "10942",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8831163922926143.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8831163922926143.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112); text-align: center;\">İddiası sadeliğinde gizli olan Olympia serisi bej ,antrasit ve gri renk alternatifleriyle zamansız güzellikte mekanlar yaratıyor.</span></ul>",
    "descriptionClean": "İddiası sadeliğinde gizli olan Olympia serisi bej ,antrasit ve gri renk alternatifleriyle zamansız güzellikte mekanlar yaratıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2101",
    "brand": "Duratiles",
    "title": "OLYMPIA Gri 60x60",
    "seriesName": "OLYMPIA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "10944",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4930343889852564.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4930343889852564.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112); text-align: center;\">İddiası sadeliğinde gizli olan Olympia serisi bej ,antrasit ve gri renk alternatifleriyle zamansız güzellikte mekanlar yaratıyor.</span></ul>",
    "descriptionClean": "İddiası sadeliğinde gizli olan Olympia serisi bej ,antrasit ve gri renk alternatifleriyle zamansız güzellikte mekanlar yaratıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2102",
    "brand": "Duratiles",
    "title": "OLYMPIA Antrasit 60x60",
    "seriesName": "OLYMPIA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "10946",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13925382472012482.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.13925382472012482.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112); text-align: center;\">İddiası sadeliğinde gizli olan Olympia serisi bej ,antrasit ve gri renk alternatifleriyle zamansız güzellikte mekanlar yaratıyor.</span></ul>",
    "descriptionClean": "İddiası sadeliğinde gizli olan Olympia serisi bej ,antrasit ve gri renk alternatifleriyle zamansız güzellikte mekanlar yaratıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2103",
    "brand": "Duratiles",
    "title": "OLYMPIA Graphite 60x60",
    "seriesName": "OLYMPIA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "10948",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7259274592068722.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7259274592068722.jpg"
    ],
    "size": "60x60",
    "color": "Graphite",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112); text-align: center;\">İddiası sadeliğinde gizli olan Olympia serisi bej ,antrasit ve gri renk alternatifleriyle zamansız güzellikte mekanlar yaratıyor.</span></ul>",
    "descriptionClean": "İddiası sadeliğinde gizli olan Olympia serisi bej ,antrasit ve gri renk alternatifleriyle zamansız güzellikte mekanlar yaratıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2104",
    "brand": "Duratiles",
    "title": "ORFE PLUS Antrasit 60x120",
    "seriesName": "ORFE PLUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2104",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5790010536923409.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5790010536923409.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde</span></ul>",
    "descriptionClean": "Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde",
    "source": "duratiles"
  },
  {
    "id": "dura_2105",
    "brand": "Duratiles",
    "title": "ORFE PLUS Bej 60x120",
    "seriesName": "ORFE PLUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2105",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.795738676832537.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.795738676832537.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde</span></ul>",
    "descriptionClean": "Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde",
    "source": "duratiles"
  },
  {
    "id": "dura_2106",
    "brand": "Duratiles",
    "title": "ORFE PLUS Gri 60x120",
    "seriesName": "ORFE PLUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2106",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6178125616832147.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6178125616832147.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde</span></ul>",
    "descriptionClean": "Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde",
    "source": "duratiles"
  },
  {
    "id": "dura_2107",
    "brand": "Duratiles",
    "title": "ORFE PLUS Antrasit 30x120",
    "seriesName": "ORFE PLUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2107",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17629788975537652.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.17629788975537652.jpg"
    ],
    "size": "30x120",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde</span></ul>",
    "descriptionClean": "Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde",
    "source": "duratiles"
  },
  {
    "id": "dura_2108",
    "brand": "Duratiles",
    "title": "ORFE PLUS Bej 30x120",
    "seriesName": "ORFE PLUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2108",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23681119170615184.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23681119170615184.jpg"
    ],
    "size": "30x120",
    "color": "Bej",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde</span></ul>",
    "descriptionClean": "Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde",
    "source": "duratiles"
  },
  {
    "id": "dura_2109",
    "brand": "Duratiles",
    "title": "ORFE PLUS Gri 30x120",
    "seriesName": "ORFE PLUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2109",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07878375313401598.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.07878375313401598.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde</span></ul>",
    "descriptionClean": "Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde",
    "source": "duratiles"
  },
  {
    "id": "dura_2110",
    "brand": "Duratiles",
    "title": "ORFE PLUS Antrasit 40x80",
    "seriesName": "ORFE PLUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2110",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2686560658952718.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2686560658952718.jpg"
    ],
    "size": "40x80",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde</span></ul>",
    "descriptionClean": "Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde",
    "source": "duratiles"
  },
  {
    "id": "dura_2111",
    "brand": "Duratiles",
    "title": "ORFE PLUS Bej 40x80",
    "seriesName": "ORFE PLUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2111",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03957716878376516.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.03957716878376516.jpg"
    ],
    "size": "40x80",
    "color": "Bej",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde</span></ul>",
    "descriptionClean": "Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde",
    "source": "duratiles"
  },
  {
    "id": "dura_2112",
    "brand": "Duratiles",
    "title": "ORFE PLUS Gri 40x80",
    "seriesName": "ORFE PLUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2112",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8822464566871862.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8822464566871862.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde</span></ul>",
    "descriptionClean": "Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde",
    "source": "duratiles"
  },
  {
    "id": "dura_2113",
    "brand": "Duratiles",
    "title": "ORFE PLUS Antrasit 60x60",
    "seriesName": "ORFE PLUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2113",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4514575802654872.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4514575802654872.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde</span></ul>",
    "descriptionClean": "Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde",
    "source": "duratiles"
  },
  {
    "id": "dura_2114",
    "brand": "Duratiles",
    "title": "ORFE PLUS Bej 60x60",
    "seriesName": "ORFE PLUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "11978",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.659011618009832.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.659011618009832.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde</span></ul>",
    "descriptionClean": "Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde",
    "source": "duratiles"
  },
  {
    "id": "dura_2115",
    "brand": "Duratiles",
    "title": "ORFE PLUS Gri 60x60",
    "seriesName": "ORFE PLUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "11981",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.47766682230252544.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.47766682230252544.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde</span></ul>",
    "descriptionClean": "Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde",
    "source": "duratiles"
  },
  {
    "id": "dura_2116",
    "brand": "Duratiles",
    "title": "ORFE PLUS Siyah 60x60",
    "seriesName": "ORFE PLUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "11919",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.635624461000608.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.635624461000608.jpg"
    ],
    "size": "60x60",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde</span></ul>",
    "descriptionClean": "Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde",
    "source": "duratiles"
  },
  {
    "id": "dura_2117",
    "brand": "Duratiles",
    "title": "ORFE PLUS Antrasit 40x40",
    "seriesName": "ORFE PLUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2117",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21079264807503473.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.21079264807503473.jpg"
    ],
    "size": "40x40",
    "color": "Antrasit",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde</span></ul>",
    "descriptionClean": "Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde",
    "source": "duratiles"
  },
  {
    "id": "dura_2118",
    "brand": "Duratiles",
    "title": "ORFE PLUS Bej 40x40",
    "seriesName": "ORFE PLUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2118",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7229954001707196.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7229954001707196.jpg"
    ],
    "size": "40x40",
    "color": "Bej",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde</span></ul>",
    "descriptionClean": "Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde",
    "source": "duratiles"
  },
  {
    "id": "dura_2119",
    "brand": "Duratiles",
    "title": "ORFE PLUS Gri 40x40",
    "seriesName": "ORFE PLUS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2119",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.054757321283533944.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.054757321283533944.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde</span></ul>",
    "descriptionClean": "Taş görünümü ve mat yüzey ile dikkat çeken Orfe Plus Serisi üç renk ve boyut alternatifi ile farklı beğenilere hitap etmekte. Göz alıcı mekanlar yaratırken iddiasını sadeliği ile veren seri ile farklı kombinasyonlar yapmak elinizde",
    "source": "duratiles"
  },
  {
    "id": "dura_2120",
    "brand": "Duratiles",
    "title": "PEDRA Azul 60x120",
    "seriesName": "PEDRA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2120",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7626816910770468.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7626816910770468.jpg"
    ],
    "size": "60x120",
    "color": "Azul",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Hareketli yüzeylerden , cesur tarzlardan hoşlananların tercihi olan Pedra Serisini isterseniz uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir hatta tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span></ul>",
    "descriptionClean": "Hareketli yüzeylerden , cesur tarzlardan hoşlananların tercihi olan Pedra Serisini isterseniz uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir hatta tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_2121",
    "brand": "Duratiles",
    "title": "PEDRA Azul 30x120",
    "seriesName": "PEDRA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2121",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.823681264031514.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.823681264031514.jpg"
    ],
    "size": "30x120",
    "color": "Azul",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Hareketli yüzeylerden , cesur tarzlardan hoşlananların tercihi olan Pedra Serisini isterseniz uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir hatta tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span></ul>",
    "descriptionClean": "Hareketli yüzeylerden , cesur tarzlardan hoşlananların tercihi olan Pedra Serisini isterseniz uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir hatta tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_2122",
    "brand": "Duratiles",
    "title": "PEDRA Azul 40x80",
    "seriesName": "PEDRA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2122",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0025179466589541066.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0025179466589541066.jpg"
    ],
    "size": "40x80",
    "color": "Azul",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Hareketli yüzeylerden , cesur tarzlardan hoşlananların tercihi olan Pedra Serisini isterseniz uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir hatta tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span></ul>",
    "descriptionClean": "Hareketli yüzeylerden , cesur tarzlardan hoşlananların tercihi olan Pedra Serisini isterseniz uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir hatta tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_2123",
    "brand": "Duratiles",
    "title": "PEDRA Azul 60x60",
    "seriesName": "PEDRA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2123",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9506026660730608.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9506026660730608.jpg"
    ],
    "size": "60x60",
    "color": "Azul",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Hareketli yüzeylerden , cesur tarzlardan hoşlananların tercihi olan Pedra Serisini isterseniz uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir hatta tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span></ul>",
    "descriptionClean": "Hareketli yüzeylerden , cesur tarzlardan hoşlananların tercihi olan Pedra Serisini isterseniz uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir hatta tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_2124",
    "brand": "Duratiles",
    "title": "PEDRA Azul 60x60",
    "seriesName": "PEDRA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2124",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0966716908164248.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0966716908164248.jpg"
    ],
    "size": "60x60",
    "color": "Azul",
    "surface": "Full Lappato, Mat",
    "thickness": "30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Hareketli yüzeylerden , cesur tarzlardan hoşlananların tercihi olan Pedra Serisini isterseniz uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir hatta tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span></ul>",
    "descriptionClean": "Hareketli yüzeylerden , cesur tarzlardan hoşlananların tercihi olan Pedra Serisini isterseniz uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir hatta tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_2125",
    "brand": "Duratiles",
    "title": "PEDRA Azul 40x40",
    "seriesName": "PEDRA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2125",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.911833168255444.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.911833168255444.jpg"
    ],
    "size": "40x40",
    "color": "Azul",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Hareketli yüzeylerden , cesur tarzlardan hoşlananların tercihi olan Pedra Serisini isterseniz uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir hatta tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.</span></ul>",
    "descriptionClean": "Hareketli yüzeylerden , cesur tarzlardan hoşlananların tercihi olan Pedra Serisini isterseniz uzman birine ihtiyaç duymadan pratik bir şekilde döşeyebilir hatta tekrar söküp başka bir yerde de rahatlıkla kullanabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_2126",
    "brand": "Duratiles",
    "title": "PINEWOOD Beyaz 15x90",
    "seriesName": "PINEWOOD",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2126",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4399464833995028.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4399464833995028.jpg"
    ],
    "size": "15x90",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Banyo & Dış Cephe & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Mekanlara doğallığı taşıyan Pinewood Serisi ile yaşam alanlarınıza sıcak bir dokunuş katabilirsiniz.</span></ul>",
    "descriptionClean": "Mekanlara doğallığı taşıyan Pinewood Serisi ile yaşam alanlarınıza sıcak bir dokunuş katabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_2127",
    "brand": "Duratiles",
    "title": "PINEWOOD Bej 15x90",
    "seriesName": "PINEWOOD",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2127",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9482430874883286.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9482430874883286.jpg"
    ],
    "size": "15x90",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Banyo & Dış Cephe & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "Banyo",
      "Dış Cephe",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Mekanlara doğallığı taşıyan Pinewood Serisi ile yaşam alanlarınıza sıcak bir dokunuş katabilirsiniz.</span></ul>",
    "descriptionClean": "Mekanlara doğallığı taşıyan Pinewood Serisi ile yaşam alanlarınıza sıcak bir dokunuş katabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_2128",
    "brand": "Duratiles",
    "title": "PINEWOOD Kahve 15x90",
    "seriesName": "PINEWOOD",
    "collection": "Taş",
    "category": "Taş",
    "sku": "65196",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3762770752431023.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3762770752431023.jpg"
    ],
    "size": "15x90",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "V3",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Mekanlara doğallığı taşıyan Pinewood Serisi ile yaşam alanlarınıza sıcak bir dokunuş katabilirsiniz.</span></ul>",
    "descriptionClean": "Mekanlara doğallığı taşıyan Pinewood Serisi ile yaşam alanlarınıza sıcak bir dokunuş katabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_2129",
    "brand": "Duratiles",
    "title": "PINEWOOD Beyaz 15x60",
    "seriesName": "PINEWOOD",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2129",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8626456625164498.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8626456625164498.jpg"
    ],
    "size": "15x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "V3",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Mekanlara doğallığı taşıyan Pinewood Serisi ile yaşam alanlarınıza sıcak bir dokunuş katabilirsiniz.</span></ul>",
    "descriptionClean": "Mekanlara doğallığı taşıyan Pinewood Serisi ile yaşam alanlarınıza sıcak bir dokunuş katabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_2130",
    "brand": "Duratiles",
    "title": "PINEWOOD Bej 15x60",
    "seriesName": "PINEWOOD",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2130",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9549857717870917.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9549857717870917.jpg"
    ],
    "size": "15x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "V3",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Mekanlara doğallığı taşıyan Pinewood Serisi ile yaşam alanlarınıza sıcak bir dokunuş katabilirsiniz.</span></ul>",
    "descriptionClean": "Mekanlara doğallığı taşıyan Pinewood Serisi ile yaşam alanlarınıza sıcak bir dokunuş katabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_2131",
    "brand": "Duratiles",
    "title": "PINEWOOD Kahve 15x60",
    "seriesName": "PINEWOOD",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2131",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5720703279886057.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5720703279886057.jpg"
    ],
    "size": "15x60",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "V3",
      "Balkon Teras"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Mekanlara doğallığı taşıyan Pinewood Serisi ile yaşam alanlarınıza sıcak bir dokunuş katabilirsiniz.</span></ul>",
    "descriptionClean": "Mekanlara doğallığı taşıyan Pinewood Serisi ile yaşam alanlarınıza sıcak bir dokunuş katabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_2132",
    "brand": "Duratiles",
    "title": "PIZARRA Açık 60x60",
    "seriesName": "PIZARRA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2132",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8549515096627618.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8549515096627618.jpg"
    ],
    "size": "60x60",
    "color": "Açık",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V4"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Pızarra Serisi ile tasarlanan mekanlar için ilk akla gelen sözler ;güçlü ,cesur ve modern.</span></ul>",
    "descriptionClean": "Pızarra Serisi ile tasarlanan mekanlar için ilk akla gelen sözler ;güçlü ,cesur ve modern.",
    "source": "duratiles"
  },
  {
    "id": "dura_2133",
    "brand": "Duratiles",
    "title": "PIZARRA Koyu 60x60",
    "seriesName": "PIZARRA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2133",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1329824296503077.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1329824296503077.jpg"
    ],
    "size": "60x60",
    "color": "Koyu",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V4"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Pızarra Serisi ile tasarlanan mekanlar için ilk akla gelen sözler ;güçlü ,cesur ve modern.</span></ul>",
    "descriptionClean": "Pızarra Serisi ile tasarlanan mekanlar için ilk akla gelen sözler ;güçlü ,cesur ve modern.",
    "source": "duratiles"
  },
  {
    "id": "dura_2134",
    "brand": "Duratiles",
    "title": "PORLAND Bej 60x60",
    "seriesName": "PORLAND",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2134",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.01591622679246496.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.01591622679246496.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V3",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112); text-align: center;\">Zamanın ruhunu, naturel dokunuşlarla resmeden Porland Porselen Karoları üst düzey lüks tanımını değiştirmeye hazırlanıyor.</span></ul>",
    "descriptionClean": "Zamanın ruhunu, naturel dokunuşlarla resmeden Porland Porselen Karoları üst düzey lüks tanımını değiştirmeye hazırlanıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2135",
    "brand": "Duratiles",
    "title": "PORLAND Gri 60x60",
    "seriesName": "PORLAND",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2135",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6988279321199625.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6988279321199625.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V3",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112); text-align: center;\">Zamanın ruhunu, naturel dokunuşlarla resmeden Porland Porselen Karoları üst düzey lüks tanımını değiştirmeye hazırlanıyor.</span></ul>",
    "descriptionClean": "Zamanın ruhunu, naturel dokunuşlarla resmeden Porland Porselen Karoları üst düzey lüks tanımını değiştirmeye hazırlanıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2136",
    "brand": "Duratiles",
    "title": "RAFIF Bej 45x45",
    "seriesName": "RAFIF",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2136",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7102818163856852.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7102818163856852.jpg"
    ],
    "size": "45x45",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Farklı boyutlarda ve farklı şekillerdeki taşların bir araya gelmesiyle oluşan bir desen... Kendine özgü bir tasarımın hikâyesi... Rafif serisi farklı olmak isteyenlerin bir numaralı tercihi.</span></ul>",
    "descriptionClean": "Farklı boyutlarda ve farklı şekillerdeki taşların bir araya gelmesiyle oluşan bir desen... Kendine özgü bir tasarımın hikâyesi... Rafif serisi farklı olmak isteyenlerin bir numaralı tercihi.",
    "source": "duratiles"
  },
  {
    "id": "dura_2137",
    "brand": "Duratiles",
    "title": "RAFIF Gri 45x45",
    "seriesName": "RAFIF",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2137",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8442069072396274.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8442069072396274.jpg"
    ],
    "size": "45x45",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Farklı boyutlarda ve farklı şekillerdeki taşların bir araya gelmesiyle oluşan bir desen... Kendine özgü bir tasarımın hikâyesi... Rafif serisi farklı olmak isteyenlerin bir numaralı tercihi.</span></ul>",
    "descriptionClean": "Farklı boyutlarda ve farklı şekillerdeki taşların bir araya gelmesiyle oluşan bir desen... Kendine özgü bir tasarımın hikâyesi... Rafif serisi farklı olmak isteyenlerin bir numaralı tercihi.",
    "source": "duratiles"
  },
  {
    "id": "dura_2138",
    "brand": "Duratiles",
    "title": "REGALE Krem 30x60",
    "seriesName": "REGALE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2138",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.062441752388499694.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.062441752388499694.jpg"
    ],
    "size": "30x60",
    "color": "Krem",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112); text-align: center;\">Taş duvarın zarafetini özel renklerle harmanladık,pastel renklerin kendine has albenisi ile Regale Serisini tasarladık. Sizler için özel olmanın tam karşılığı olacak bir tasarımın hikâyesi.</span></ul>",
    "descriptionClean": "Taş duvarın zarafetini özel renklerle harmanladık,pastel renklerin kendine has albenisi ile Regale Serisini tasarladık. Sizler için özel olmanın tam karşılığı olacak bir tasarımın hikâyesi.",
    "source": "duratiles"
  },
  {
    "id": "dura_2139",
    "brand": "Duratiles",
    "title": "REGALE Gri 30x60",
    "seriesName": "REGALE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2139",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5329379288289868.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5329379288289868.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112); text-align: center;\">Taş duvarın zarafetini özel renklerle harmanladık,pastel renklerin kendine has albenisi ile Regale Serisini tasarladık. Sizler için özel olmanın tam karşılığı olacak bir tasarımın hikâyesi.</span></ul>",
    "descriptionClean": "Taş duvarın zarafetini özel renklerle harmanladık,pastel renklerin kendine has albenisi ile Regale Serisini tasarladık. Sizler için özel olmanın tam karşılığı olacak bir tasarımın hikâyesi.",
    "source": "duratiles"
  },
  {
    "id": "dura_2140",
    "brand": "Duratiles",
    "title": "ROYAL Beyaz 100x100",
    "seriesName": "ROYAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2140",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6144360038285757.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6144360038285757.jpg"
    ],
    "size": "100x100",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor</span></ul>",
    "descriptionClean": "Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2141",
    "brand": "Duratiles",
    "title": "ROYAL Siyah 100x100",
    "seriesName": "ROYAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2141",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8363915199980417.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8363915199980417.jpg"
    ],
    "size": "100x100",
    "color": "Siyah",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ticari Alanlar & Balkon/Teras",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Ticari Alanlar",
      "Balkon Teras",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor</span></ul>",
    "descriptionClean": "Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2142",
    "brand": "Duratiles",
    "title": "ROYAL Gri 45x45",
    "seriesName": "ROYAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2142",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.02482489359071649.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.02482489359071649.jpg"
    ],
    "size": "45x45",
    "color": "Gri",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor</span></ul>",
    "descriptionClean": "Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2143",
    "brand": "Duratiles",
    "title": "ROYAL Bone 45x45",
    "seriesName": "ROYAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2143",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6018994200591202.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6018994200591202.jpg"
    ],
    "size": "45x45",
    "color": "Bone",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor</span></ul>",
    "descriptionClean": "Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2144",
    "brand": "Duratiles",
    "title": "ROYAL Bone 30x60",
    "seriesName": "ROYAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2144",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.29866049449212306.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.29866049449212306.jpg"
    ],
    "size": "30x60",
    "color": "Bone",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor</span></ul>",
    "descriptionClean": "Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2145",
    "brand": "Duratiles",
    "title": "ROYAL Bej 30x60",
    "seriesName": "ROYAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2145",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9596096021593412.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9596096021593412.jpg"
    ],
    "size": "30x60",
    "color": "Bej",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor</span></ul>",
    "descriptionClean": "Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2146",
    "brand": "Duratiles",
    "title": "ROYAL Kahve 30x60",
    "seriesName": "ROYAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2146",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.54944730259753.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.54944730259753.jpg"
    ],
    "size": "30x60",
    "color": "Kahve",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor</span></ul>",
    "descriptionClean": "Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2147",
    "brand": "Duratiles",
    "title": "ROYAL Açık Gri 30x60",
    "seriesName": "ROYAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2147",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2518539696353721.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2518539696353721.jpg"
    ],
    "size": "30x60",
    "color": "Açık Gri",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor</span></ul>",
    "descriptionClean": "Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2148",
    "brand": "Duratiles",
    "title": "ROYAL Gri 30x60",
    "seriesName": "ROYAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2148",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4659123102164061.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4659123102164061.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor</span></ul>",
    "descriptionClean": "Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2149",
    "brand": "Duratiles",
    "title": "ROYAL Antrasit 30x60",
    "seriesName": "ROYAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2149",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.893083194093415.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.893083194093415.jpg"
    ],
    "size": "30x60",
    "color": "Antrasit",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor</span></ul>",
    "descriptionClean": "Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2150",
    "brand": "Duratiles",
    "title": "ROYAL Bej Dekofon 30x60",
    "seriesName": "ROYAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2150",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9448091249075067.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9448091249075067.jpg"
    ],
    "size": "30x60",
    "color": "Bej Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor</span></ul>",
    "descriptionClean": "Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2151",
    "brand": "Duratiles",
    "title": "ROYAL Kahve Dekofon 30x60",
    "seriesName": "ROYAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2151",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6894203000770791.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6894203000770791.jpg"
    ],
    "size": "30x60",
    "color": "Kahve Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor</span></ul>",
    "descriptionClean": "Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2152",
    "brand": "Duratiles",
    "title": "ROYAL Geo Kahve Dekofon 30x60",
    "seriesName": "ROYAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2152",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7045289231445693.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7045289231445693.jpg"
    ],
    "size": "30x60",
    "color": "Geo Kahve Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor</span></ul>",
    "descriptionClean": "Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2153",
    "brand": "Duratiles",
    "title": "ROYAL Gri Dekofon 30x60",
    "seriesName": "ROYAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2153",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8045320258608303.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8045320258608303.jpg"
    ],
    "size": "30x60",
    "color": "Gri Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor</span></ul>",
    "descriptionClean": "Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2154",
    "brand": "Duratiles",
    "title": "ROYAL Geo Antrasit Dekofon 30x60",
    "seriesName": "ROYAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2154",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.995723906581031.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.995723906581031.jpg"
    ],
    "size": "30x60",
    "color": "Geo Antrasit Dekofon",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor</span></ul>",
    "descriptionClean": "Royal serisi mekanlarınıza mermer görünümüyle modern bir şıklık getirirken ,beyaz ve siyah renk seçenekleriyle farklı kombinasyonlar yapabilmenize de olanak sağlıyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2155",
    "brand": "Duratiles",
    "title": "SABATINO Gri 60x60",
    "seriesName": "SABATINO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "10938",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7741928778003354.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7741928778003354.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Uygulandığı yaşam alanlarında çağdaş ve güçlü bir etki yaratan Sabatino Porselen Karoları mekanlara yalın ve modern bir hava katar.</span></ul>",
    "descriptionClean": "Uygulandığı yaşam alanlarında çağdaş ve güçlü bir etki yaratan Sabatino Porselen Karoları mekanlara yalın ve modern bir hava katar.",
    "source": "duratiles"
  },
  {
    "id": "dura_2156",
    "brand": "Duratiles",
    "title": "SABATINO Antrasit 60x60",
    "seriesName": "SABATINO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "10940",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8990594789910842.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8990594789910842.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin & Banyo & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Banyo",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Uygulandığı yaşam alanlarında çağdaş ve güçlü bir etki yaratan Sabatino Porselen Karoları mekanlara yalın ve modern bir hava katar.</span></ul>",
    "descriptionClean": "Uygulandığı yaşam alanlarında çağdaş ve güçlü bir etki yaratan Sabatino Porselen Karoları mekanlara yalın ve modern bir hava katar.",
    "source": "duratiles"
  },
  {
    "id": "dura_2157",
    "brand": "Duratiles",
    "title": "SAHRA Sahra 45x90",
    "seriesName": "SAHRA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2157",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.995686372047114.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.995686372047114.jpg"
    ],
    "size": "45x90",
    "color": "Sahra",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Zamanın ruhunu, nostaljik dokunuşlarla resmeden Sahra Porselen Karoları stil sahibi bir tasarım anlayışının altını çiziyor</span></ul>",
    "descriptionClean": "Zamanın ruhunu, nostaljik dokunuşlarla resmeden Sahra Porselen Karoları stil sahibi bir tasarım anlayışının altını çiziyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2158",
    "brand": "Duratiles",
    "title": "SAHRA Sahra 45x90",
    "seriesName": "SAHRA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2158",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.995686372047114.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.995686372047114.jpg"
    ],
    "size": "45x90",
    "color": "Sahra",
    "surface": "Mat",
    "thickness": "30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Zamanın ruhunu, nostaljik dokunuşlarla resmeden Sahra Porselen Karoları stil sahibi bir tasarım anlayışının altını çiziyor</span></ul>",
    "descriptionClean": "Zamanın ruhunu, nostaljik dokunuşlarla resmeden Sahra Porselen Karoları stil sahibi bir tasarım anlayışının altını çiziyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2159",
    "brand": "Duratiles",
    "title": "SAHRA Sahra 60x120",
    "seriesName": "SAHRA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2159",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9195426291809762.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9195426291809762.jpg"
    ],
    "size": "60x120",
    "color": "Sahra",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Zamanın ruhunu, nostaljik dokunuşlarla resmeden Sahra Porselen Karoları stil sahibi bir tasarım anlayışının altını çiziyor</span></ul>",
    "descriptionClean": "Zamanın ruhunu, nostaljik dokunuşlarla resmeden Sahra Porselen Karoları stil sahibi bir tasarım anlayışının altını çiziyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2160",
    "brand": "Duratiles",
    "title": "SAHRA Sahra 100x100",
    "seriesName": "SAHRA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2160",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.04541517707223519.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.04541517707223519.jpg"
    ],
    "size": "100x100",
    "color": "Sahra",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Zamanın ruhunu, nostaljik dokunuşlarla resmeden Sahra Porselen Karoları stil sahibi bir tasarım anlayışının altını çiziyor</span></ul>",
    "descriptionClean": "Zamanın ruhunu, nostaljik dokunuşlarla resmeden Sahra Porselen Karoları stil sahibi bir tasarım anlayışının altını çiziyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2161",
    "brand": "Duratiles",
    "title": "SAHRA Sahra 80x80",
    "seriesName": "SAHRA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2161",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7200260574839037.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7200260574839037.jpg"
    ],
    "size": "80x80",
    "color": "Sahra",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Zamanın ruhunu, nostaljik dokunuşlarla resmeden Sahra Porselen Karoları stil sahibi bir tasarım anlayışının altını çiziyor</span></ul>",
    "descriptionClean": "Zamanın ruhunu, nostaljik dokunuşlarla resmeden Sahra Porselen Karoları stil sahibi bir tasarım anlayışının altını çiziyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2162",
    "brand": "Duratiles",
    "title": "SAHRA Sahra 40x80",
    "seriesName": "SAHRA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2162",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.06933895806498269.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.06933895806498269.jpg"
    ],
    "size": "40x80",
    "color": "Sahra",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar & Banyo",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar",
      "Banyo"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Zamanın ruhunu, nostaljik dokunuşlarla resmeden Sahra Porselen Karoları stil sahibi bir tasarım anlayışının altını çiziyor</span></ul>",
    "descriptionClean": "Zamanın ruhunu, nostaljik dokunuşlarla resmeden Sahra Porselen Karoları stil sahibi bir tasarım anlayışının altını çiziyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2163",
    "brand": "Duratiles",
    "title": "SAHRA Sahra 60x60",
    "seriesName": "SAHRA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2163",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4208972424180544.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4208972424180544.jpg"
    ],
    "size": "60x60",
    "color": "Sahra",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Zamanın ruhunu, nostaljik dokunuşlarla resmeden Sahra Porselen Karoları stil sahibi bir tasarım anlayışının altını çiziyor</span></ul>",
    "descriptionClean": "Zamanın ruhunu, nostaljik dokunuşlarla resmeden Sahra Porselen Karoları stil sahibi bir tasarım anlayışının altını çiziyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2164",
    "brand": "Duratiles",
    "title": "SAHRA Sahra 60x60",
    "seriesName": "SAHRA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2164",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4208972424180544.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4208972424180544.jpg"
    ],
    "size": "60x60",
    "color": "Sahra",
    "surface": "Mat , Sırlı Body",
    "thickness": "30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Zamanın ruhunu, nostaljik dokunuşlarla resmeden Sahra Porselen Karoları stil sahibi bir tasarım anlayışının altını çiziyor</span></ul>",
    "descriptionClean": "Zamanın ruhunu, nostaljik dokunuşlarla resmeden Sahra Porselen Karoları stil sahibi bir tasarım anlayışının altını çiziyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2165",
    "brand": "Duratiles",
    "title": "SAHRA Sahra 40x40",
    "seriesName": "SAHRA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2165",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.38249988363425236.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.38249988363425236.jpg"
    ],
    "size": "40x40",
    "color": "Sahra",
    "surface": "Mat , Sırlı Body",
    "thickness": "30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Havuz & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "V3",
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Havuz",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Zamanın ruhunu, nostaljik dokunuşlarla resmeden Sahra Porselen Karoları stil sahibi bir tasarım anlayışının altını çiziyor</span></ul>",
    "descriptionClean": "Zamanın ruhunu, nostaljik dokunuşlarla resmeden Sahra Porselen Karoları stil sahibi bir tasarım anlayışının altını çiziyor",
    "source": "duratiles"
  },
  {
    "id": "dura_2166",
    "brand": "Duratiles",
    "title": "SILVER TRAVERTEN Silver Traverten 60x120",
    "seriesName": "SILVER TRAVERTEN",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2166",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8758950001447371.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8758950001447371.jpg"
    ],
    "size": "60x120",
    "color": "Silver Traverten",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Doğayı Silver Traverten Serisiyle evinize davet edebilirsiniz. Nefes kesen dokusu ve tarzı ile Silver Traverten doğayı ve estetiği bir araya getiriyor. Yaşam alanlarınızda natürel kurgular yaratmak bu seri ile eğlenceye dönüşecektir.</span></ul>",
    "descriptionClean": "Doğayı Silver Traverten Serisiyle evinize davet edebilirsiniz. Nefes kesen dokusu ve tarzı ile Silver Traverten doğayı ve estetiği bir araya getiriyor. Yaşam alanlarınızda natürel kurgular yaratmak bu seri ile eğlenceye dönüşecektir.",
    "source": "duratiles"
  },
  {
    "id": "dura_2167",
    "brand": "Duratiles",
    "title": "SILVER TRAVERTEN Silver Traverten 30x120",
    "seriesName": "SILVER TRAVERTEN",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2167",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08054304537265522.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08054304537265522.jpg"
    ],
    "size": "30x120",
    "color": "Silver Traverten",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Doğayı Silver Traverten Serisiyle evinize davet edebilirsiniz. Nefes kesen dokusu ve tarzı ile Silver Traverten doğayı ve estetiği bir araya getiriyor. Yaşam alanlarınızda natürel kurgular yaratmak bu seri ile eğlenceye dönüşecektir.</span></ul>",
    "descriptionClean": "Doğayı Silver Traverten Serisiyle evinize davet edebilirsiniz. Nefes kesen dokusu ve tarzı ile Silver Traverten doğayı ve estetiği bir araya getiriyor. Yaşam alanlarınızda natürel kurgular yaratmak bu seri ile eğlenceye dönüşecektir.",
    "source": "duratiles"
  },
  {
    "id": "dura_2168",
    "brand": "Duratiles",
    "title": "SILVER TRAVERTEN Silver Traverten 40x80",
    "seriesName": "SILVER TRAVERTEN",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2168",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6021513310349927.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6021513310349927.jpg"
    ],
    "size": "40x80",
    "color": "Silver Traverten",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Doğayı Silver Traverten Serisiyle evinize davet edebilirsiniz. Nefes kesen dokusu ve tarzı ile Silver Traverten doğayı ve estetiği bir araya getiriyor. Yaşam alanlarınızda natürel kurgular yaratmak bu seri ile eğlenceye dönüşecektir.</span></ul>",
    "descriptionClean": "Doğayı Silver Traverten Serisiyle evinize davet edebilirsiniz. Nefes kesen dokusu ve tarzı ile Silver Traverten doğayı ve estetiği bir araya getiriyor. Yaşam alanlarınızda natürel kurgular yaratmak bu seri ile eğlenceye dönüşecektir.",
    "source": "duratiles"
  },
  {
    "id": "dura_2169",
    "brand": "Duratiles",
    "title": "SILVER TRAVERTEN Silver Traverten 60x60",
    "seriesName": "SILVER TRAVERTEN",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2169",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08100338001539364.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.08100338001539364.jpg"
    ],
    "size": "60x60",
    "color": "Silver Traverten",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Doğayı Silver Traverten Serisiyle evinize davet edebilirsiniz. Nefes kesen dokusu ve tarzı ile Silver Traverten doğayı ve estetiği bir araya getiriyor. Yaşam alanlarınızda natürel kurgular yaratmak bu seri ile eğlenceye dönüşecektir.</span></ul>",
    "descriptionClean": "Doğayı Silver Traverten Serisiyle evinize davet edebilirsiniz. Nefes kesen dokusu ve tarzı ile Silver Traverten doğayı ve estetiği bir araya getiriyor. Yaşam alanlarınızda natürel kurgular yaratmak bu seri ile eğlenceye dönüşecektir.",
    "source": "duratiles"
  },
  {
    "id": "dura_2170",
    "brand": "Duratiles",
    "title": "SILVER TRAVERTEN Silver Traverten 60x60",
    "seriesName": "SILVER TRAVERTEN",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2170",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.41489927034586016.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.41489927034586016.jpg"
    ],
    "size": "60x60",
    "color": "Silver Traverten",
    "surface": "Mat , Sırlı Body",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Doğayı Silver Traverten Serisiyle evinize davet edebilirsiniz. Nefes kesen dokusu ve tarzı ile Silver Traverten doğayı ve estetiği bir araya getiriyor. Yaşam alanlarınızda natürel kurgular yaratmak bu seri ile eğlenceye dönüşecektir.</span></ul>",
    "descriptionClean": "Doğayı Silver Traverten Serisiyle evinize davet edebilirsiniz. Nefes kesen dokusu ve tarzı ile Silver Traverten doğayı ve estetiği bir araya getiriyor. Yaşam alanlarınızda natürel kurgular yaratmak bu seri ile eğlenceye dönüşecektir.",
    "source": "duratiles"
  },
  {
    "id": "dura_2171",
    "brand": "Duratiles",
    "title": "SILVER TRAVERTEN Silver Traverten 40x40",
    "seriesName": "SILVER TRAVERTEN",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2171",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30361772312607305.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30361772312607305.jpg"
    ],
    "size": "40x40",
    "color": "Silver Traverten",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Doğayı Silver Traverten Serisiyle evinize davet edebilirsiniz. Nefes kesen dokusu ve tarzı ile Silver Traverten doğayı ve estetiği bir araya getiriyor. Yaşam alanlarınızda natürel kurgular yaratmak bu seri ile eğlenceye dönüşecektir.</span></ul>",
    "descriptionClean": "Doğayı Silver Traverten Serisiyle evinize davet edebilirsiniz. Nefes kesen dokusu ve tarzı ile Silver Traverten doğayı ve estetiği bir araya getiriyor. Yaşam alanlarınızda natürel kurgular yaratmak bu seri ile eğlenceye dönüşecektir.",
    "source": "duratiles"
  },
  {
    "id": "dura_2172",
    "brand": "Duratiles",
    "title": "SLATE Taupe 60x120",
    "seriesName": "SLATE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2172",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.41307664706710545.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.41307664706710545.jpg"
    ],
    "size": "60x120",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.</span></ul>",
    "descriptionClean": "Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2173",
    "brand": "Duratiles",
    "title": "SLATE Bone 60x120",
    "seriesName": "SLATE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2173",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6329637762439636.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6329637762439636.jpg"
    ],
    "size": "60x120",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.</span></ul>",
    "descriptionClean": "Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2174",
    "brand": "Duratiles",
    "title": "SLATE Gri 30x120",
    "seriesName": "SLATE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2174",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16490565310534977.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16490565310534977.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.</span></ul>",
    "descriptionClean": "Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2175",
    "brand": "Duratiles",
    "title": "SLATE Jade 30x120",
    "seriesName": "SLATE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2175",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8571620375443313.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8571620375443313.jpg"
    ],
    "size": "30x120",
    "color": "Jade",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.</span></ul>",
    "descriptionClean": "Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2176",
    "brand": "Duratiles",
    "title": "SLATE Taupe 40x80",
    "seriesName": "SLATE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2176",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7787606967706151.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7787606967706151.jpg"
    ],
    "size": "40x80",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.</span></ul>",
    "descriptionClean": "Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2177",
    "brand": "Duratiles",
    "title": "SLATE Bone 40x80",
    "seriesName": "SLATE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2177",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40789418870174665.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40789418870174665.jpg"
    ],
    "size": "40x80",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.</span></ul>",
    "descriptionClean": "Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2178",
    "brand": "Duratiles",
    "title": "SLATE Taupe 60x60",
    "seriesName": "SLATE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2178",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30969654046758965.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.30969654046758965.jpg"
    ],
    "size": "60x60",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.</span></ul>",
    "descriptionClean": "Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2179",
    "brand": "Duratiles",
    "title": "SLATE Bone 60x60",
    "seriesName": "SLATE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2179",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.011811273240758702.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.011811273240758702.jpg"
    ],
    "size": "60x60",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.</span></ul>",
    "descriptionClean": "Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2180",
    "brand": "Duratiles",
    "title": "SLATE Gri 60x60",
    "seriesName": "SLATE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2180",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3953792049903909.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3953792049903909.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.</span></ul>",
    "descriptionClean": "Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2181",
    "brand": "Duratiles",
    "title": "SLATE Jade 60x60",
    "seriesName": "SLATE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2181",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1442281319133628.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1442281319133628.jpg"
    ],
    "size": "60x60",
    "color": "Jade",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.</span></ul>",
    "descriptionClean": "Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2182",
    "brand": "Duratiles",
    "title": "SLATE Gri 40x40",
    "seriesName": "SLATE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2182",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2137362321027102.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2137362321027102.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.</span></ul>",
    "descriptionClean": "Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2183",
    "brand": "Duratiles",
    "title": "SLATE Jade 40x40",
    "seriesName": "SLATE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2183",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8322577212631385.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8322577212631385.jpg"
    ],
    "size": "40x40",
    "color": "Jade",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.</span></ul>",
    "descriptionClean": "Rafine tasarım anlayışını yaşam alanlarına taşıyan Slate serisi özgün görünümü ve renk seçenekleri ile mekanlara sıra dışı bir dinamizm katıyor. Güçlü yapısıyla teraslardan plajlara , araba yollarından eğitim binalarına ,havalimanlarından bahçelere kadar ihtiyaç duyduğunuz her yere uygulanabilir yapısıyla Slate Serisi modern tasarımlarıyla alanlarınıza derinlik katacaktır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2184",
    "brand": "Duratiles",
    "title": "SMART STONE Bej 45x45",
    "seriesName": "SMART STONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2184",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4565606456625999.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4565606456625999.jpg"
    ],
    "size": "45x45",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "V2",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Smart-Stone serisi ile kendinizi her zaman çakıllı bir sahilde, hafif bir meltem eşliğinde gezinirken bulacaksınız. Minik taşların rahatlatıcı etkisini her anınıza taşıyın. Yaşam alanlarınızı taşın verdiği huzurla süsleyin.</span></ul>",
    "descriptionClean": "Smart-Stone serisi ile kendinizi her zaman çakıllı bir sahilde, hafif bir meltem eşliğinde gezinirken bulacaksınız. Minik taşların rahatlatıcı etkisini her anınıza taşıyın. Yaşam alanlarınızı taşın verdiği huzurla süsleyin.",
    "source": "duratiles"
  },
  {
    "id": "dura_2185",
    "brand": "Duratiles",
    "title": "SMART STONE Gri 45x45",
    "seriesName": "SMART STONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2185",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22180827202023423.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22180827202023423.jpg"
    ],
    "size": "45x45",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "V2",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Smart-Stone serisi ile kendinizi her zaman çakıllı bir sahilde, hafif bir meltem eşliğinde gezinirken bulacaksınız. Minik taşların rahatlatıcı etkisini her anınıza taşıyın. Yaşam alanlarınızı taşın verdiği huzurla süsleyin.</span></ul>",
    "descriptionClean": "Smart-Stone serisi ile kendinizi her zaman çakıllı bir sahilde, hafif bir meltem eşliğinde gezinirken bulacaksınız. Minik taşların rahatlatıcı etkisini her anınıza taşıyın. Yaşam alanlarınızı taşın verdiği huzurla süsleyin.",
    "source": "duratiles"
  },
  {
    "id": "dura_2186",
    "brand": "Duratiles",
    "title": "SOFT STONE Antrasit 60x60",
    "seriesName": "SOFT STONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2186",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16080060696019738.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.16080060696019738.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Seramiğin avantajını ahşabın sıcaklığı ve doğallığı ile buluşturan Soft Stone Porselen Karoları farklı ebat ve ton alternatifleriyle dingin iç mekan kurguları için ideal bir seçenek.</span></ul>",
    "descriptionClean": "Seramiğin avantajını ahşabın sıcaklığı ve doğallığı ile buluşturan Soft Stone Porselen Karoları farklı ebat ve ton alternatifleriyle dingin iç mekan kurguları için ideal bir seçenek.",
    "source": "duratiles"
  },
  {
    "id": "dura_2187",
    "brand": "Duratiles",
    "title": "SOFT STONE Gri 60x60",
    "seriesName": "SOFT STONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2187",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8261948419984897.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8261948419984897.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Seramiğin avantajını ahşabın sıcaklığı ve doğallığı ile buluşturan Soft Stone Porselen Karoları farklı ebat ve ton alternatifleriyle dingin iç mekan kurguları için ideal bir seçenek.</span></ul>",
    "descriptionClean": "Seramiğin avantajını ahşabın sıcaklığı ve doğallığı ile buluşturan Soft Stone Porselen Karoları farklı ebat ve ton alternatifleriyle dingin iç mekan kurguları için ideal bir seçenek.",
    "source": "duratiles"
  },
  {
    "id": "dura_2188",
    "brand": "Duratiles",
    "title": "SOFT STONE Fildişi 60x60",
    "seriesName": "SOFT STONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2188",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.24214932664239952.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.24214932664239952.jpg"
    ],
    "size": "60x60",
    "color": "Fildişi",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Seramiğin avantajını ahşabın sıcaklığı ve doğallığı ile buluşturan Soft Stone Porselen Karoları farklı ebat ve ton alternatifleriyle dingin iç mekan kurguları için ideal bir seçenek.</span></ul>",
    "descriptionClean": "Seramiğin avantajını ahşabın sıcaklığı ve doğallığı ile buluşturan Soft Stone Porselen Karoları farklı ebat ve ton alternatifleriyle dingin iç mekan kurguları için ideal bir seçenek.",
    "source": "duratiles"
  },
  {
    "id": "dura_2189",
    "brand": "Duratiles",
    "title": "SOFT STONE Antrasit 30x60",
    "seriesName": "SOFT STONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2189",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6233915621016809.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6233915621016809.jpg"
    ],
    "size": "30x60",
    "color": "Antrasit",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Seramiğin avantajını ahşabın sıcaklığı ve doğallığı ile buluşturan Soft Stone Porselen Karoları farklı ebat ve ton alternatifleriyle dingin iç mekan kurguları için ideal bir seçenek.</span></ul>",
    "descriptionClean": "Seramiğin avantajını ahşabın sıcaklığı ve doğallığı ile buluşturan Soft Stone Porselen Karoları farklı ebat ve ton alternatifleriyle dingin iç mekan kurguları için ideal bir seçenek.",
    "source": "duratiles"
  },
  {
    "id": "dura_2190",
    "brand": "Duratiles",
    "title": "SOFT STONE Fildişi 30x60",
    "seriesName": "SOFT STONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2190",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0002910655324173117.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.0002910655324173117.jpg"
    ],
    "size": "30x60",
    "color": "Fildişi",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Seramiğin avantajını ahşabın sıcaklığı ve doğallığı ile buluşturan Soft Stone Porselen Karoları farklı ebat ve ton alternatifleriyle dingin iç mekan kurguları için ideal bir seçenek.</span></ul>",
    "descriptionClean": "Seramiğin avantajını ahşabın sıcaklığı ve doğallığı ile buluşturan Soft Stone Porselen Karoları farklı ebat ve ton alternatifleriyle dingin iç mekan kurguları için ideal bir seçenek.",
    "source": "duratiles"
  },
  {
    "id": "dura_2191",
    "brand": "Duratiles",
    "title": "SOFT STONE Gri 30x60",
    "seriesName": "SOFT STONE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2191",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23049958261219083.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.23049958261219083.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat , Sırlı Body",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Teknik Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Seramiğin avantajını ahşabın sıcaklığı ve doğallığı ile buluşturan Soft Stone Porselen Karoları farklı ebat ve ton alternatifleriyle dingin iç mekan kurguları için ideal bir seçenek.</span></ul>",
    "descriptionClean": "Seramiğin avantajını ahşabın sıcaklığı ve doğallığı ile buluşturan Soft Stone Porselen Karoları farklı ebat ve ton alternatifleriyle dingin iç mekan kurguları için ideal bir seçenek.",
    "source": "duratiles"
  },
  {
    "id": "dura_2192",
    "brand": "Duratiles",
    "title": "SONORA Cool 60x120",
    "seriesName": "SONORA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2192",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40433437100872616.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.40433437100872616.jpg"
    ],
    "size": "60x120",
    "color": "Cool",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Sadeliği ile mekanlara çağdaş bir görünüm kazandıran Sonora Serisi özgün mekanlar yaratır.</span></ul>",
    "descriptionClean": "Sadeliği ile mekanlara çağdaş bir görünüm kazandıran Sonora Serisi özgün mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2193",
    "brand": "Duratiles",
    "title": "SONORA Shadow 60x120",
    "seriesName": "SONORA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2193",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6754753729202633.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6754753729202633.jpg"
    ],
    "size": "60x120",
    "color": "Shadow",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Sadeliği ile mekanlara çağdaş bir görünüm kazandıran Sonora Serisi özgün mekanlar yaratır.</span></ul>",
    "descriptionClean": "Sadeliği ile mekanlara çağdaş bir görünüm kazandıran Sonora Serisi özgün mekanlar yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2195",
    "brand": "Duratiles",
    "title": "STONEROCK Açık Gri 60x60",
    "seriesName": "STONEROCK",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2195",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1713639025586724.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1713639025586724.jpg"
    ],
    "size": "60x60",
    "color": "Açık Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Dış Cephe & Havuz",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ev İçi Zemin",
      "V3",
      "Dış Cephe",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Doğanın ham dokusundan ilham alan Stonerock, mat yüzeyi ve taş etkisiyle mekanlara zamansız bir karakter kazandırıyor. Dayanıklılığı, doğal görünümü ve modern çizgisiyle yüzeylerde sade bir güç yaratır.</span></ul>",
    "descriptionClean": "Doğanın ham dokusundan ilham alan Stonerock, mat yüzeyi ve taş etkisiyle mekanlara zamansız bir karakter kazandırıyor. Dayanıklılığı, doğal görünümü ve modern çizgisiyle yüzeylerde sade bir güç yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2194",
    "brand": "Duratiles",
    "title": "STONEROCK Gri 60x60",
    "seriesName": "STONEROCK",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2194",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9285866160344028.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9285866160344028.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ev içi Zemin & Dış Cephe & Havuz",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ev İçi Zemin",
      "V3",
      "Dış Cephe",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Doğanın ham dokusundan ilham alan Stonerock, mat yüzeyi ve taş etkisiyle mekanlara zamansız bir karakter kazandırıyor. Dayanıklılığı, doğal görünümü ve modern çizgisiyle yüzeylerde sade bir güç yaratır.</span></ul>",
    "descriptionClean": "Doğanın ham dokusundan ilham alan Stonerock, mat yüzeyi ve taş etkisiyle mekanlara zamansız bir karakter kazandırıyor. Dayanıklılığı, doğal görünümü ve modern çizgisiyle yüzeylerde sade bir güç yaratır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2196",
    "brand": "Duratiles",
    "title": "TAJ MAHAL Krem 60x120",
    "seriesName": "TAJ MAHAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2196",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09161049317066294.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.09161049317066294.jpg"
    ],
    "size": "60x120",
    "color": "Krem",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.</span></ul>",
    "descriptionClean": "Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2197",
    "brand": "Duratiles",
    "title": "TAJ MAHAL Gri 60x120",
    "seriesName": "TAJ MAHAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2197",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28914968540312724.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.28914968540312724.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.</span></ul>",
    "descriptionClean": "Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2198",
    "brand": "Duratiles",
    "title": "TAJ MAHAL Krem 30x120",
    "seriesName": "TAJ MAHAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2198",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4430747237548278.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4430747237548278.jpg"
    ],
    "size": "30x120",
    "color": "Krem",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.</span></ul>",
    "descriptionClean": "Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2199",
    "brand": "Duratiles",
    "title": "TAJ MAHAL Gri 30x120",
    "seriesName": "TAJ MAHAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2199",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2765962470583765.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2765962470583765.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.</span></ul>",
    "descriptionClean": "Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2200",
    "brand": "Duratiles",
    "title": "TAJ MAHAL Krem 40x80",
    "seriesName": "TAJ MAHAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2200",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6787110093905563.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6787110093905563.jpg"
    ],
    "size": "40x80",
    "color": "Krem",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.</span></ul>",
    "descriptionClean": "Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2201",
    "brand": "Duratiles",
    "title": "TAJ MAHAL Gri 40x80",
    "seriesName": "TAJ MAHAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2201",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.41598416112163883.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.41598416112163883.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.</span></ul>",
    "descriptionClean": "Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2202",
    "brand": "Duratiles",
    "title": "TAJ MAHAL Krem 60x60",
    "seriesName": "TAJ MAHAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2202",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.25251527318376843.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.25251527318376843.jpg"
    ],
    "size": "60x60",
    "color": "Krem",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.</span></ul>",
    "descriptionClean": "Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2203",
    "brand": "Duratiles",
    "title": "TAJ MAHAL Gri 60x60",
    "seriesName": "TAJ MAHAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2203",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3939986592234469.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3939986592234469.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.</span></ul>",
    "descriptionClean": "Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2204",
    "brand": "Duratiles",
    "title": "TAJ MAHAL Krem 60x60",
    "seriesName": "TAJ MAHAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2204",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7404119493194141.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7404119493194141.jpg"
    ],
    "size": "60x60",
    "color": "Krem",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.</span></ul>",
    "descriptionClean": "Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2205",
    "brand": "Duratiles",
    "title": "TAJ MAHAL Gri 60x60",
    "seriesName": "TAJ MAHAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2205",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22539888364084182.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22539888364084182.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.</span></ul>",
    "descriptionClean": "Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2206",
    "brand": "Duratiles",
    "title": "TAJ MAHAL Krem 40x40",
    "seriesName": "TAJ MAHAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2206",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19337507603878756.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19337507603878756.jpg"
    ],
    "size": "40x40",
    "color": "Krem",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.</span></ul>",
    "descriptionClean": "Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2207",
    "brand": "Duratiles",
    "title": "TAJ MAHAL Gri 40x40",
    "seriesName": "TAJ MAHAL",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2207",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.37965397956530766.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.37965397956530766.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.</span></ul>",
    "descriptionClean": "Gözalıcı mekanlara kavuşmanın en estetik hali olan Taj Mahal Serisi ile dinamik mekanlar yaratmak çok basit .Güçlü yapısına karşın yumuşak renk paletinin kullanıldığı seri yaşanılası keyif dozu yüksek yaşam alanları vadediyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2208",
    "brand": "Duratiles",
    "title": "TERRAZO Glacier 60x60",
    "seriesName": "TERRAZO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "69651",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3057148668054884.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3057148668054884.jpg"
    ],
    "size": "60x60",
    "color": "Glacier",
    "surface": "Full Lappato, Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar & Ev içi Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Endüstriyel Zemin",
      "Ticari Alanlar",
      "V2",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Terrazo serisi ile size özel mekanlar tasarlayabilir , yaşam alanlarınıza stilizi yansıtabilirsiniz.</span></ul>",
    "descriptionClean": "Terrazo serisi ile size özel mekanlar tasarlayabilir , yaşam alanlarınıza stilizi yansıtabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_2209",
    "brand": "Duratiles",
    "title": "TERRAZO Bej 60x60",
    "seriesName": "TERRAZO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2209",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.014334649501008934.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.014334649501008934.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Full Lappato, Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Terrazo serisi ile size özel mekanlar tasarlayabilir , yaşam alanlarınıza stilizi yansıtabilirsiniz.</span></ul>",
    "descriptionClean": "Terrazo serisi ile size özel mekanlar tasarlayabilir , yaşam alanlarınıza stilizi yansıtabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_2210",
    "brand": "Duratiles",
    "title": "TERRAZO Gris 60x60",
    "seriesName": "TERRAZO",
    "collection": "Taş",
    "category": "Taş",
    "sku": "69875",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11608032890909625.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11608032890909625.jpg"
    ],
    "size": "60x60",
    "color": "Gris",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Endüstriyel Zemin",
      "Havuz",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Terrazo serisi ile size özel mekanlar tasarlayabilir , yaşam alanlarınıza stilizi yansıtabilirsiniz.</span></ul>",
    "descriptionClean": "Terrazo serisi ile size özel mekanlar tasarlayabilir , yaşam alanlarınıza stilizi yansıtabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_2211",
    "brand": "Duratiles",
    "title": "TRIBECA Taupe 60x60",
    "seriesName": "TRIBECA",
    "collection": "Taş",
    "category": "Taş",
    "sku": "69875",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8713795218384623.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8713795218384623.jpg"
    ],
    "size": "60x60",
    "color": "Taupe",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Havuz & Dış Cephe",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Ev İçi Zemin",
      "Havuz",
      "V3",
      "Dış Cephe"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Şehir dokusunun modern çizgilerinden ilham alan seri, doğal taşın güçlü karakteriyle mekanlara sade bir zarafet ve modern bir denge kazandırır.</span></ul>",
    "descriptionClean": "Şehir dokusunun modern çizgilerinden ilham alan seri, doğal taşın güçlü karakteriyle mekanlara sade bir zarafet ve modern bir denge kazandırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2212",
    "brand": "Duratiles",
    "title": "VENEZIANI Açık 60x60",
    "seriesName": "VENEZIANI",
    "collection": "Taş",
    "category": "Taş",
    "sku": "69875",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9242043992457709.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9242043992457709.jpg"
    ],
    "size": "60x60",
    "color": "Açık",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Aynı anda hem sade hem de zengin görünen mekanlar Veneziani Serisi ile çok basit.İki renk alternatifine sahip seri mat yüzeyiyle şık mekanların tercihi</span></ul>",
    "descriptionClean": "Aynı anda hem sade hem de zengin görünen mekanlar Veneziani Serisi ile çok basit.İki renk alternatifine sahip seri mat yüzeyiyle şık mekanların tercihi",
    "source": "duratiles"
  },
  {
    "id": "dura_2213",
    "brand": "Duratiles",
    "title": "VENEZIANI Koyu 60x60",
    "seriesName": "VENEZIANI",
    "collection": "Taş",
    "category": "Taş",
    "sku": "69875",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19679007953783145.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.19679007953783145.jpg"
    ],
    "size": "60x60",
    "color": "Koyu",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo & Endüstriyel Zemin",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<ul style=\"border-style: initial; border-color: initial; border-image: initial; outline: 0px; font-size: 16px; vertical-align: baseline; background: transparent; color: rgb(38, 38, 38); font-family: &quot;DIN[T] Light&quot;; display: table-row;\"><span style=\"color: rgb(112, 112, 112);\">Aynı anda hem sade hem de zengin görünen mekanlar Veneziani Serisi ile çok basit.İki renk alternatifine sahip seri mat yüzeyiyle şık mekanların tercihi</span></ul>",
    "descriptionClean": "Aynı anda hem sade hem de zengin görünen mekanlar Veneziani Serisi ile çok basit.İki renk alternatifine sahip seri mat yüzeyiyle şık mekanların tercihi",
    "source": "duratiles"
  },
  {
    "id": "dura_2214",
    "brand": "Duratiles",
    "title": "VENUE Açık Gri 30x60",
    "seriesName": "VENUE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "65661",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9413576145555693.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9413576145555693.jpg"
    ],
    "size": "30x60",
    "color": "Açık Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Banyo & Endüstriyel Zemin",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Yumuşak gri rengin betonun karakteristik dokusuyla birleştiği Venue Porselen Karoları mekanlara yaşanmışlık hissi katarak yaşam alanlarına nostaljik bir atmosfer getiriyor.</span>",
    "descriptionClean": "Yumuşak gri rengin betonun karakteristik dokusuyla birleştiği Venue Porselen Karoları mekanlara yaşanmışlık hissi katarak yaşam alanlarına nostaljik bir atmosfer getiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2215",
    "brand": "Duratiles",
    "title": "VOYAGE Gri 60x90",
    "seriesName": "VOYAGE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "74677",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.515713739219475.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.515713739219475.jpg"
    ],
    "size": "60x90",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "V3",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Voyage Serisi fonksiyonel ve üstün teknik performansı ile yaşam alanlarınızı hayallerinizde ki görünüme kavuşturuyor.</span>",
    "descriptionClean": "Voyage Serisi fonksiyonel ve üstün teknik performansı ile yaşam alanlarınızı hayallerinizde ki görünüme kavuşturuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2216",
    "brand": "Duratiles",
    "title": "VOYAGE Antrasit 60x90",
    "seriesName": "VOYAGE",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2216",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10010678290860231.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10010678290860231.jpg"
    ],
    "size": "60x90",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Ev içi Zemin & Endüstriyel Zemin & Havuz",
    "technology": "Teknik Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Havuz"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Voyage Serisi fonksiyonel ve üstün teknik performansı ile yaşam alanlarınızı hayallerinizde ki görünüme kavuşturuyor.</span>",
    "descriptionClean": "Voyage Serisi fonksiyonel ve üstün teknik performansı ile yaşam alanlarınızı hayallerinizde ki görünüme kavuşturuyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2217",
    "brand": "Duratiles",
    "title": "VULCON Antrasit 60x120",
    "seriesName": "VULCON",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2217",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5616617745319173.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5616617745319173.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansız bir güzelliğe sahip olan Vulcon Serisi , sadeliği ve şıklığı konforla sentezleyerek mekanlara çarpıcı bir modernlik getiriyor. Zengin ebat seçeneğinin yanı sıra antrasit ve gri renk alternatifi de sunan Vulcon Serisi dayanıklı ,fonksiyonel ve kesinlikle göz alıcı.</span>",
    "descriptionClean": "Zamansız bir güzelliğe sahip olan Vulcon Serisi , sadeliği ve şıklığı konforla sentezleyerek mekanlara çarpıcı bir modernlik getiriyor. Zengin ebat seçeneğinin yanı sıra antrasit ve gri renk alternatifi de sunan Vulcon Serisi dayanıklı ,fonksiyonel ve kesinlikle göz alıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_2218",
    "brand": "Duratiles",
    "title": "VULCON Gri 60x120",
    "seriesName": "VULCON",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2218",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2427783398997576.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2427783398997576.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansız bir güzelliğe sahip olan Vulcon Serisi , sadeliği ve şıklığı konforla sentezleyerek mekanlara çarpıcı bir modernlik getiriyor. Zengin ebat seçeneğinin yanı sıra antrasit ve gri renk alternatifi de sunan Vulcon Serisi dayanıklı ,fonksiyonel ve kesinlikle göz alıcı.</span>",
    "descriptionClean": "Zamansız bir güzelliğe sahip olan Vulcon Serisi , sadeliği ve şıklığı konforla sentezleyerek mekanlara çarpıcı bir modernlik getiriyor. Zengin ebat seçeneğinin yanı sıra antrasit ve gri renk alternatifi de sunan Vulcon Serisi dayanıklı ,fonksiyonel ve kesinlikle göz alıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_2219",
    "brand": "Duratiles",
    "title": "VULCON Antrasit 30x120",
    "seriesName": "VULCON",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2219",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7660732818523027.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7660732818523027.jpg"
    ],
    "size": "30x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansız bir güzelliğe sahip olan Vulcon Serisi , sadeliği ve şıklığı konforla sentezleyerek mekanlara çarpıcı bir modernlik getiriyor. Zengin ebat seçeneğinin yanı sıra antrasit ve gri renk alternatifi de sunan Vulcon Serisi dayanıklı ,fonksiyonel ve kesinlikle göz alıcı.</span>",
    "descriptionClean": "Zamansız bir güzelliğe sahip olan Vulcon Serisi , sadeliği ve şıklığı konforla sentezleyerek mekanlara çarpıcı bir modernlik getiriyor. Zengin ebat seçeneğinin yanı sıra antrasit ve gri renk alternatifi de sunan Vulcon Serisi dayanıklı ,fonksiyonel ve kesinlikle göz alıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_2220",
    "brand": "Duratiles",
    "title": "VULCON Gri 30x120",
    "seriesName": "VULCON",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2220",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3001018422234839.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3001018422234839.jpg"
    ],
    "size": "30x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansız bir güzelliğe sahip olan Vulcon Serisi , sadeliği ve şıklığı konforla sentezleyerek mekanlara çarpıcı bir modernlik getiriyor. Zengin ebat seçeneğinin yanı sıra antrasit ve gri renk alternatifi de sunan Vulcon Serisi dayanıklı ,fonksiyonel ve kesinlikle göz alıcı.</span>",
    "descriptionClean": "Zamansız bir güzelliğe sahip olan Vulcon Serisi , sadeliği ve şıklığı konforla sentezleyerek mekanlara çarpıcı bir modernlik getiriyor. Zengin ebat seçeneğinin yanı sıra antrasit ve gri renk alternatifi de sunan Vulcon Serisi dayanıklı ,fonksiyonel ve kesinlikle göz alıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_2221",
    "brand": "Duratiles",
    "title": "VULCON Antrasit 40x80",
    "seriesName": "VULCON",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2221",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5426408062428433.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5426408062428433.jpg"
    ],
    "size": "40x80",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansız bir güzelliğe sahip olan Vulcon Serisi , sadeliği ve şıklığı konforla sentezleyerek mekanlara çarpıcı bir modernlik getiriyor. Zengin ebat seçeneğinin yanı sıra antrasit ve gri renk alternatifi de sunan Vulcon Serisi dayanıklı ,fonksiyonel ve kesinlikle göz alıcı.</span>",
    "descriptionClean": "Zamansız bir güzelliğe sahip olan Vulcon Serisi , sadeliği ve şıklığı konforla sentezleyerek mekanlara çarpıcı bir modernlik getiriyor. Zengin ebat seçeneğinin yanı sıra antrasit ve gri renk alternatifi de sunan Vulcon Serisi dayanıklı ,fonksiyonel ve kesinlikle göz alıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_2222",
    "brand": "Duratiles",
    "title": "VULCON Gri 40x80",
    "seriesName": "VULCON",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2222",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8012255482108674.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8012255482108674.jpg"
    ],
    "size": "40x80",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansız bir güzelliğe sahip olan Vulcon Serisi , sadeliği ve şıklığı konforla sentezleyerek mekanlara çarpıcı bir modernlik getiriyor. Zengin ebat seçeneğinin yanı sıra antrasit ve gri renk alternatifi de sunan Vulcon Serisi dayanıklı ,fonksiyonel ve kesinlikle göz alıcı.</span>",
    "descriptionClean": "Zamansız bir güzelliğe sahip olan Vulcon Serisi , sadeliği ve şıklığı konforla sentezleyerek mekanlara çarpıcı bir modernlik getiriyor. Zengin ebat seçeneğinin yanı sıra antrasit ve gri renk alternatifi de sunan Vulcon Serisi dayanıklı ,fonksiyonel ve kesinlikle göz alıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_2223",
    "brand": "Duratiles",
    "title": "VULCON Antrasit 60x60",
    "seriesName": "VULCON",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2223",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7626411341112544.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7626411341112544.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansız bir güzelliğe sahip olan Vulcon Serisi , sadeliği ve şıklığı konforla sentezleyerek mekanlara çarpıcı bir modernlik getiriyor. Zengin ebat seçeneğinin yanı sıra antrasit ve gri renk alternatifi de sunan Vulcon Serisi dayanıklı ,fonksiyonel ve kesinlikle göz alıcı.</span>",
    "descriptionClean": "Zamansız bir güzelliğe sahip olan Vulcon Serisi , sadeliği ve şıklığı konforla sentezleyerek mekanlara çarpıcı bir modernlik getiriyor. Zengin ebat seçeneğinin yanı sıra antrasit ve gri renk alternatifi de sunan Vulcon Serisi dayanıklı ,fonksiyonel ve kesinlikle göz alıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_2224",
    "brand": "Duratiles",
    "title": "VULCON Gri 60x60",
    "seriesName": "VULCON",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2224",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6120091167063826.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6120091167063826.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm & 30mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansız bir güzelliğe sahip olan Vulcon Serisi , sadeliği ve şıklığı konforla sentezleyerek mekanlara çarpıcı bir modernlik getiriyor. Zengin ebat seçeneğinin yanı sıra antrasit ve gri renk alternatifi de sunan Vulcon Serisi dayanıklı ,fonksiyonel ve kesinlikle göz alıcı.</span>",
    "descriptionClean": "Zamansız bir güzelliğe sahip olan Vulcon Serisi , sadeliği ve şıklığı konforla sentezleyerek mekanlara çarpıcı bir modernlik getiriyor. Zengin ebat seçeneğinin yanı sıra antrasit ve gri renk alternatifi de sunan Vulcon Serisi dayanıklı ,fonksiyonel ve kesinlikle göz alıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_2225",
    "brand": "Duratiles",
    "title": "VULCON Antrasit 40x40",
    "seriesName": "VULCON",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2225",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15073860467572897.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.15073860467572897.jpg"
    ],
    "size": "40x40",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansız bir güzelliğe sahip olan Vulcon Serisi , sadeliği ve şıklığı konforla sentezleyerek mekanlara çarpıcı bir modernlik getiriyor. Zengin ebat seçeneğinin yanı sıra antrasit ve gri renk alternatifi de sunan Vulcon Serisi dayanıklı ,fonksiyonel ve kesinlikle göz alıcı.</span>",
    "descriptionClean": "Zamansız bir güzelliğe sahip olan Vulcon Serisi , sadeliği ve şıklığı konforla sentezleyerek mekanlara çarpıcı bir modernlik getiriyor. Zengin ebat seçeneğinin yanı sıra antrasit ve gri renk alternatifi de sunan Vulcon Serisi dayanıklı ,fonksiyonel ve kesinlikle göz alıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_2226",
    "brand": "Duratiles",
    "title": "VULCON Gri 40x40",
    "seriesName": "VULCON",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2226",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2023486403593544.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2023486403593544.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "20mm",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Endüstriyel Zemin",
    "technology": "Porselen Seramik",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "DURASTONE",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Zamansız bir güzelliğe sahip olan Vulcon Serisi , sadeliği ve şıklığı konforla sentezleyerek mekanlara çarpıcı bir modernlik getiriyor. Zengin ebat seçeneğinin yanı sıra antrasit ve gri renk alternatifi de sunan Vulcon Serisi dayanıklı ,fonksiyonel ve kesinlikle göz alıcı.</span>",
    "descriptionClean": "Zamansız bir güzelliğe sahip olan Vulcon Serisi , sadeliği ve şıklığı konforla sentezleyerek mekanlara çarpıcı bir modernlik getiriyor. Zengin ebat seçeneğinin yanı sıra antrasit ve gri renk alternatifi de sunan Vulcon Serisi dayanıklı ,fonksiyonel ve kesinlikle göz alıcı.",
    "source": "duratiles"
  },
  {
    "id": "dura_2227",
    "brand": "Duratiles",
    "title": "YENİ TOROS Kahve 45x45",
    "seriesName": "YENİ TOROS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2227",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3366959063866637.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3366959063866637.jpg"
    ],
    "size": "45x45",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Dağların kendine has doğal dokusu, minimalist dokunuşlarla şekillendi ve Toros serisini oluşturdu. Farklı geometrik şekillerden ve uyumlu renk tonlarından beslenen seri mekanlara sıra dışı bir güzellik getirecek</span>",
    "descriptionClean": "Dağların kendine has doğal dokusu, minimalist dokunuşlarla şekillendi ve Toros serisini oluşturdu. Farklı geometrik şekillerden ve uyumlu renk tonlarından beslenen seri mekanlara sıra dışı bir güzellik getirecek",
    "source": "duratiles"
  },
  {
    "id": "dura_2228",
    "brand": "Duratiles",
    "title": "YENİ TOROS Gri 45x45",
    "seriesName": "YENİ TOROS",
    "collection": "Taş",
    "category": "Taş",
    "sku": "2228",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8323918212758956.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8323918212758956.jpg"
    ],
    "size": "45x45",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Dağların kendine has doğal dokusu, minimalist dokunuşlarla şekillendi ve Toros serisini oluşturdu. Farklı geometrik şekillerden ve uyumlu renk tonlarından beslenen seri mekanlara sıra dışı bir güzellik getirecek</span>",
    "descriptionClean": "Dağların kendine has doğal dokusu, minimalist dokunuşlarla şekillendi ve Toros serisini oluşturdu. Farklı geometrik şekillerden ve uyumlu renk tonlarından beslenen seri mekanlara sıra dışı bir güzellik getirecek",
    "source": "duratiles"
  },
  {
    "id": "dura_2282",
    "brand": "Duratiles",
    "title": "GRAIN Bej 40x40",
    "seriesName": "GRAIN",
    "collection": "Mono",
    "category": "Mono",
    "sku": "2282",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8403647372191724.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8403647372191724.jpg"
    ],
    "size": "40x40",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V1"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Grain Serisi maxımum konforu hedefleyenlerin yeni gözdesi</span>",
    "descriptionClean": "Grain Serisi maxımum konforu hedefleyenlerin yeni gözdesi",
    "source": "duratiles"
  },
  {
    "id": "dura_2284",
    "brand": "Duratiles",
    "title": "GRAIN Antrasit 40x40",
    "seriesName": "GRAIN",
    "collection": "Mono",
    "category": "Mono",
    "sku": "2284",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9633881049147808.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9633881049147808.jpg"
    ],
    "size": "40x40",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V1"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Grain Serisi maxımum konforu hedefleyenlerin yeni gözdesi</span>",
    "descriptionClean": "Grain Serisi maxımum konforu hedefleyenlerin yeni gözdesi",
    "source": "duratiles"
  },
  {
    "id": "dura_2285",
    "brand": "Duratiles",
    "title": "MONO Süper Beyaz 60x120",
    "seriesName": "MONO",
    "collection": "Mono",
    "category": "Mono",
    "sku": "2285",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7721436395703672.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7721436395703672.jpg"
    ],
    "size": "60x120",
    "color": "Süper Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "V1",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mono serisi ile tasarıma yumuşak bir dokunuş yapın. Soft renklerin zarafetini modern tasarımlarla harmanlayın. Tarzınızı seramiğin doğallığı ile tamamlayın.</span>",
    "descriptionClean": "Mono serisi ile tasarıma yumuşak bir dokunuş yapın. Soft renklerin zarafetini modern tasarımlarla harmanlayın. Tarzınızı seramiğin doğallığı ile tamamlayın.",
    "source": "duratiles"
  },
  {
    "id": "dura_2286",
    "brand": "Duratiles",
    "title": "MONO Gri 60x120",
    "seriesName": "MONO",
    "collection": "Mono",
    "category": "Mono",
    "sku": "2286",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9686562443389811.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9686562443389811.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "V1",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mono serisi ile tasarıma yumuşak bir dokunuş yapın. Soft renklerin zarafetini modern tasarımlarla harmanlayın. Tarzınızı seramiğin doğallığı ile tamamlayın.</span>",
    "descriptionClean": "Mono serisi ile tasarıma yumuşak bir dokunuş yapın. Soft renklerin zarafetini modern tasarımlarla harmanlayın. Tarzınızı seramiğin doğallığı ile tamamlayın.",
    "source": "duratiles"
  },
  {
    "id": "dura_2287",
    "brand": "Duratiles",
    "title": "MONO Bej 60x120",
    "seriesName": "MONO",
    "collection": "Mono",
    "category": "Mono",
    "sku": "2287",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36699358100115076.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.36699358100115076.jpg"
    ],
    "size": "60x120",
    "color": "Bej",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "V1",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mono serisi ile tasarıma yumuşak bir dokunuş yapın. Soft renklerin zarafetini modern tasarımlarla harmanlayın. Tarzınızı seramiğin doğallığı ile tamamlayın.</span>",
    "descriptionClean": "Mono serisi ile tasarıma yumuşak bir dokunuş yapın. Soft renklerin zarafetini modern tasarımlarla harmanlayın. Tarzınızı seramiğin doğallığı ile tamamlayın.",
    "source": "duratiles"
  },
  {
    "id": "dura_2288",
    "brand": "Duratiles",
    "title": "MONO Beyaz 60x60",
    "seriesName": "MONO",
    "collection": "Mono",
    "category": "Mono",
    "sku": "2288",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5842970905918814.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5842970905918814.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "V1",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mono serisi ile tasarıma yumuşak bir dokunuş yapın. Soft renklerin zarafetini modern tasarımlarla harmanlayın. Tarzınızı seramiğin doğallığı ile tamamlayın.</span>",
    "descriptionClean": "Mono serisi ile tasarıma yumuşak bir dokunuş yapın. Soft renklerin zarafetini modern tasarımlarla harmanlayın. Tarzınızı seramiğin doğallığı ile tamamlayın.",
    "source": "duratiles"
  },
  {
    "id": "dura_2289",
    "brand": "Duratiles",
    "title": "MONO Gri 60x60",
    "seriesName": "MONO",
    "collection": "Mono",
    "category": "Mono",
    "sku": "2289",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3572225063503527.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.3572225063503527.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "V1",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mono serisi ile tasarıma yumuşak bir dokunuş yapın. Soft renklerin zarafetini modern tasarımlarla harmanlayın. Tarzınızı seramiğin doğallığı ile tamamlayın.</span>",
    "descriptionClean": "Mono serisi ile tasarıma yumuşak bir dokunuş yapın. Soft renklerin zarafetini modern tasarımlarla harmanlayın. Tarzınızı seramiğin doğallığı ile tamamlayın.",
    "source": "duratiles"
  },
  {
    "id": "dura_2290",
    "brand": "Duratiles",
    "title": "MONO Bej 60x60",
    "seriesName": "MONO",
    "collection": "Mono",
    "category": "Mono",
    "sku": "2290",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1282559550374449.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1282559550374449.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Full Lappato",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "V1",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Mono serisi ile tasarıma yumuşak bir dokunuş yapın. Soft renklerin zarafetini modern tasarımlarla harmanlayın. Tarzınızı seramiğin doğallığı ile tamamlayın.</span>",
    "descriptionClean": "Mono serisi ile tasarıma yumuşak bir dokunuş yapın. Soft renklerin zarafetini modern tasarımlarla harmanlayın. Tarzınızı seramiğin doğallığı ile tamamlayın.",
    "source": "duratiles"
  },
  {
    "id": "dura_2291",
    "brand": "Duratiles",
    "title": "SATEN Beyaz 45x45",
    "seriesName": "SATEN",
    "collection": "Mono",
    "category": "Mono",
    "sku": "2291",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8719901613022529.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8719901613022529.jpg"
    ],
    "size": "45x45",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V1",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Saten serisi yalın güzelliği ile mekanlara duru bir şıklık katacak. Onun tüm iddiası sadeliğinde</span>",
    "descriptionClean": "Saten serisi yalın güzelliği ile mekanlara duru bir şıklık katacak. Onun tüm iddiası sadeliğinde",
    "source": "duratiles"
  },
  {
    "id": "dura_2283",
    "brand": "Duratiles",
    "title": "GRAIN Gri 40x40",
    "seriesName": "GRAIN",
    "collection": "Mono",
    "category": "Mono",
    "sku": "2283",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8889250510081136.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8889250510081136.jpg"
    ],
    "size": "40x40",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V1"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Grain Serisi maxımum konforu hedefleyenlerin yeni gözdesi</span>",
    "descriptionClean": "Grain Serisi maxımum konforu hedefleyenlerin yeni gözdesi",
    "source": "duratiles"
  },
  {
    "id": "dura_2292",
    "brand": "Duratiles",
    "title": "SİYAH - BEYAZ Beyaz 30x60",
    "seriesName": "SİYAH - BEYAZ",
    "collection": "Mono",
    "category": "Mono",
    "sku": "2292",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8031916853257797.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8031916853257797.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "V1",
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Beyazın sakin , saf ve temiz görünümünü mat ve parlak versiyonları ile çeşitlendiren Siyah Beyaz Serisi mekanlara dingin bir görünüm kazandıracak</span>",
    "descriptionClean": "Beyazın sakin , saf ve temiz görünümünü mat ve parlak versiyonları ile çeşitlendiren Siyah Beyaz Serisi mekanlara dingin bir görünüm kazandıracak",
    "source": "duratiles"
  },
  {
    "id": "dura_2293",
    "brand": "Duratiles",
    "title": "SİYAH - BEYAZ Beyaz 30x60",
    "seriesName": "SİYAH - BEYAZ",
    "collection": "Mono",
    "category": "Mono",
    "sku": "2293",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7388720137568687.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7388720137568687.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "V1",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Beyazın sakin , saf ve temiz görünümünü mat ve parlak versiyonları ile çeşitlendiren Siyah Beyaz Serisi mekanlara dingin bir görünüm kazandıracak</span>",
    "descriptionClean": "Beyazın sakin , saf ve temiz görünümünü mat ve parlak versiyonları ile çeşitlendiren Siyah Beyaz Serisi mekanlara dingin bir görünüm kazandıracak",
    "source": "duratiles"
  },
  {
    "id": "dura_2294",
    "brand": "Duratiles",
    "title": "STAR Bej 40x40",
    "seriesName": "STAR",
    "collection": "Mono",
    "category": "Mono",
    "sku": "2294",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5730831483649904.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5730831483649904.jpg"
    ],
    "size": "40x40",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Teknik Porselen",
    "badge": "",
    "features": [
      "V1",
      "Balkon Teras",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Kullanıldığı ortama ferahlık ve aydınlık getiren bej renk Star Serisinde mat bir yüzey ile sunulmakta. Mekanlara modern bir dokunuş katan seri en kasvetli ortamları bile yumuşatacak kadar romantik</span>",
    "descriptionClean": "Kullanıldığı ortama ferahlık ve aydınlık getiren bej renk Star Serisinde mat bir yüzey ile sunulmakta. Mekanlara modern bir dokunuş katan seri en kasvetli ortamları bile yumuşatacak kadar romantik",
    "source": "duratiles"
  },
  {
    "id": "dura_123",
    "brand": "Duratiles",
    "title": "GALERIA Beyaz 60x120",
    "seriesName": "GALERIA",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "28310",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.34773273027165263.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.34773273027165263.jpg"
    ],
    "size": "60x120",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Ticari Alanlar",
      "V2",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Sade görünümü ve açık renk alternatifleriyle Galeria serisi, rafine bir dekorasyon tarzına hayat vermek için tasarlandı.</span>",
    "descriptionClean": "Sade görünümü ve açık renk alternatifleriyle Galeria serisi, rafine bir dekorasyon tarzına hayat vermek için tasarlandı.",
    "source": "duratiles"
  },
  {
    "id": "dura_2340",
    "brand": "Duratiles",
    "title": "ULTRA Beyaz 60x60",
    "seriesName": "ULTRA",
    "collection": "Mono",
    "category": "Mono",
    "sku": "2340",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8580696231333169.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8580696231333169.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V1",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ultra Serisi beyazın ferah ,temiz hissini yaşam alanlarına taşırken yalın şıklığı da beraberinde getirmeyi ihmal etmiyor.</span>",
    "descriptionClean": "Ultra Serisi beyazın ferah ,temiz hissini yaşam alanlarına taşırken yalın şıklığı da beraberinde getirmeyi ihmal etmiyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2341",
    "brand": "Duratiles",
    "title": "ULTRA Beyaz 45x45",
    "seriesName": "ULTRA",
    "collection": "Mono",
    "category": "Mono",
    "sku": "2341",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8988023572713552.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8988023572713552.jpg"
    ],
    "size": "45x45",
    "color": "Beyaz",
    "surface": "Parlak",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V1",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Ultra Serisi beyazın ferah ,temiz hissini yaşam alanlarına taşırken yalın şıklığı da beraberinde getirmeyi ihmal etmiyor.</span>",
    "descriptionClean": "Ultra Serisi beyazın ferah ,temiz hissini yaşam alanlarına taşırken yalın şıklığı da beraberinde getirmeyi ihmal etmiyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_128",
    "brand": "Duratiles",
    "title": "GALERIA Bone 60x120",
    "seriesName": "GALERIA",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "128",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5117980020791273.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5117980020791273.jpg"
    ],
    "size": "60x120",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Sade görünümü ve açık renk alternatifleriyle Galeria serisi, rafine bir dekorasyon tarzına hayat vermek için tasarlandı.</span>",
    "descriptionClean": "Sade görünümü ve açık renk alternatifleriyle Galeria serisi, rafine bir dekorasyon tarzına hayat vermek için tasarlandı.",
    "source": "duratiles"
  },
  {
    "id": "dura_129",
    "brand": "Duratiles",
    "title": "GALERIA Gri 60x120",
    "seriesName": "GALERIA",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "29286",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11193950391459606.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.11193950391459606.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "Ev İçi Zemin",
      "Banyo",
      "V1"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Sade görünümü ve açık renk alternatifleriyle Galeria serisi, rafine bir dekorasyon tarzına hayat vermek için tasarlandı.</span>",
    "descriptionClean": "Sade görünümü ve açık renk alternatifleriyle Galeria serisi, rafine bir dekorasyon tarzına hayat vermek için tasarlandı.",
    "source": "duratiles"
  },
  {
    "id": "dura_130",
    "brand": "Duratiles",
    "title": "GALERIA Beyaz 60x60",
    "seriesName": "GALERIA",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "130",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7866166042856255.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7866166042856255.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Endüstriyel Zemin",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Sade görünümü ve açık renk alternatifleriyle Galeria serisi, rafine bir dekorasyon tarzına hayat vermek için tasarlandı.</span>",
    "descriptionClean": "Sade görünümü ve açık renk alternatifleriyle Galeria serisi, rafine bir dekorasyon tarzına hayat vermek için tasarlandı.",
    "source": "duratiles"
  },
  {
    "id": "dura_132",
    "brand": "Duratiles",
    "title": "GALERIA Bone 60x60",
    "seriesName": "GALERIA",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "132",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2982288542342768.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2982288542342768.jpg"
    ],
    "size": "60x60",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Sade görünümü ve açık renk alternatifleriyle Galeria serisi, rafine bir dekorasyon tarzına hayat vermek için tasarlandı.</span>",
    "descriptionClean": "Sade görünümü ve açık renk alternatifleriyle Galeria serisi, rafine bir dekorasyon tarzına hayat vermek için tasarlandı.",
    "source": "duratiles"
  },
  {
    "id": "dura_133",
    "brand": "Duratiles",
    "title": "GALERIA Beyaz 30x60",
    "seriesName": "GALERIA",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "133",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2985604270344946.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.2985604270344946.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar & Banyo",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Sade görünümü ve açık renk alternatifleriyle Galeria serisi, rafine bir dekorasyon tarzına hayat vermek için tasarlandı.</span>",
    "descriptionClean": "Sade görünümü ve açık renk alternatifleriyle Galeria serisi, rafine bir dekorasyon tarzına hayat vermek için tasarlandı.",
    "source": "duratiles"
  },
  {
    "id": "dura_131",
    "brand": "Duratiles",
    "title": "GALERIA Bone 30x60",
    "seriesName": "GALERIA",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "131",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9526806883323709.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9526806883323709.jpg"
    ],
    "size": "30x60",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Endüstriyel Zemin & Ev içi Zemin & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2",
      "Banyo",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Sade görünümü ve açık renk alternatifleriyle Galeria serisi, rafine bir dekorasyon tarzına hayat vermek için tasarlandı.</span>",
    "descriptionClean": "Sade görünümü ve açık renk alternatifleriyle Galeria serisi, rafine bir dekorasyon tarzına hayat vermek için tasarlandı.",
    "source": "duratiles"
  },
  {
    "id": "dura_2295",
    "brand": "Duratiles",
    "title": "HERMES Bone 45x45",
    "seriesName": "HERMES",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "2295",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6068837174288298.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6068837174288298.jpg"
    ],
    "size": "45x45",
    "color": "Bone",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Yumuşak ,romantik bir renk kartelasına sahip Hermes Serisi sade naif tarzını ürün yelpazesine dahil ettiği dekofon ile daha da pekiştirmiş bu özellikleri mat yüzeyi ve üstün teknik alt yapısıyla harmanlayarak vazgeçilmez bir seri haline gelmiştir.</span>",
    "descriptionClean": "Yumuşak ,romantik bir renk kartelasına sahip Hermes Serisi sade naif tarzını ürün yelpazesine dahil ettiği dekofon ile daha da pekiştirmiş bu özellikleri mat yüzeyi ve üstün teknik alt yapısıyla harmanlayarak vazgeçilmez bir seri haline gelmiştir.",
    "source": "duratiles"
  },
  {
    "id": "dura_2296",
    "brand": "Duratiles",
    "title": "HERMES Bone 30x60",
    "seriesName": "HERMES",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "2296",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8097823971357859.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8097823971357859.jpg"
    ],
    "size": "30x60",
    "color": "Bone",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "V2",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Yumuşak ,romantik bir renk kartelasına sahip Hermes Serisi sade naif tarzını ürün yelpazesine dahil ettiği dekofon ile daha da pekiştirmiş bu özellikleri mat yüzeyi ve üstün teknik alt yapısıyla harmanlayarak vazgeçilmez bir seri haline gelmiştir.</span>",
    "descriptionClean": "Yumuşak ,romantik bir renk kartelasına sahip Hermes Serisi sade naif tarzını ürün yelpazesine dahil ettiği dekofon ile daha da pekiştirmiş bu özellikleri mat yüzeyi ve üstün teknik alt yapısıyla harmanlayarak vazgeçilmez bir seri haline gelmiştir.",
    "source": "duratiles"
  },
  {
    "id": "dura_2297",
    "brand": "Duratiles",
    "title": "HERMES Bone Dekofon 30x60",
    "seriesName": "HERMES",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "2297",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6272352880387958.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6272352880387958.jpg"
    ],
    "size": "30x60",
    "color": "Bone Dekofon",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "V2",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Yumuşak ,romantik bir renk kartelasına sahip Hermes Serisi sade naif tarzını ürün yelpazesine dahil ettiği dekofon ile daha da pekiştirmiş bu özellikleri mat yüzeyi ve üstün teknik alt yapısıyla harmanlayarak vazgeçilmez bir seri haline gelmiştir.</span>",
    "descriptionClean": "Yumuşak ,romantik bir renk kartelasına sahip Hermes Serisi sade naif tarzını ürün yelpazesine dahil ettiği dekofon ile daha da pekiştirmiş bu özellikleri mat yüzeyi ve üstün teknik alt yapısıyla harmanlayarak vazgeçilmez bir seri haline gelmiştir.",
    "source": "duratiles"
  },
  {
    "id": "dura_2298",
    "brand": "Duratiles",
    "title": "LIBERTY Beyaz 30x60",
    "seriesName": "LIBERTY",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "2298",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1328909741452441.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1328909741452441.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "V1"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tasarımda sınırları kaldırdık. Özgür evler, özgün tasarımlarla buluştu. Liberty serisi özgür hislerinizin vücut bulmuş hali.</span>",
    "descriptionClean": "Tasarımda sınırları kaldırdık. Özgür evler, özgün tasarımlarla buluştu. Liberty serisi özgür hislerinizin vücut bulmuş hali.",
    "source": "duratiles"
  },
  {
    "id": "dura_2299",
    "brand": "Duratiles",
    "title": "LIBERTY Kahve 30x60",
    "seriesName": "LIBERTY",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "2299",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4679935557381659.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4679935557381659.jpg"
    ],
    "size": "30x60",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "V1"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tasarımda sınırları kaldırdık. Özgür evler, özgün tasarımlarla buluştu. Liberty serisi özgür hislerinizin vücut bulmuş hali.</span>",
    "descriptionClean": "Tasarımda sınırları kaldırdık. Özgür evler, özgün tasarımlarla buluştu. Liberty serisi özgür hislerinizin vücut bulmuş hali.",
    "source": "duratiles"
  },
  {
    "id": "dura_2300",
    "brand": "Duratiles",
    "title": "LIBERTY Koyu Gri 30x60",
    "seriesName": "LIBERTY",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "2300",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8526259137121567.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.8526259137121567.jpg"
    ],
    "size": "30x60",
    "color": "Koyu Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Banyo & Ev içi Zemin & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Ticari Alanlar",
      "V1"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Tasarımda sınırları kaldırdık. Özgür evler, özgün tasarımlarla buluştu. Liberty serisi özgür hislerinizin vücut bulmuş hali.</span>",
    "descriptionClean": "Tasarımda sınırları kaldırdık. Özgür evler, özgün tasarımlarla buluştu. Liberty serisi özgür hislerinizin vücut bulmuş hali.",
    "source": "duratiles"
  },
  {
    "id": "dura_2301",
    "brand": "Duratiles",
    "title": "LIMESTONE Bej 60x60",
    "seriesName": "LIMESTONE",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "2301",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.710007407779539.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.710007407779539.jpg"
    ],
    "size": "60x60",
    "color": "Bej",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Kireç taşının ruhunu taşıyan Limestone porselen karoları uygulandığı mekâna yaptığı yumuşak dokunuşlarla dinginlik ve huzurun kaynağı haline geliyor.</span>",
    "descriptionClean": "Kireç taşının ruhunu taşıyan Limestone porselen karoları uygulandığı mekâna yaptığı yumuşak dokunuşlarla dinginlik ve huzurun kaynağı haline geliyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2302",
    "brand": "Duratiles",
    "title": "LIMESTONE Gri 60x60",
    "seriesName": "LIMESTONE",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "2302",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9523654000118527.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9523654000118527.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Kireç taşının ruhunu taşıyan Limestone porselen karoları uygulandığı mekâna yaptığı yumuşak dokunuşlarla dinginlik ve huzurun kaynağı haline geliyor.</span>",
    "descriptionClean": "Kireç taşının ruhunu taşıyan Limestone porselen karoları uygulandığı mekâna yaptığı yumuşak dokunuşlarla dinginlik ve huzurun kaynağı haline geliyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2303",
    "brand": "Duratiles",
    "title": "MOON Bone 40x120",
    "seriesName": "MOON",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "2303",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7160003020833857.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7160003020833857.jpg"
    ],
    "size": "40x120",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğadan gelen ahenk seramiğe yansıdı. Zıt renklerin uyumu ile şekillenen bir tasarım. Dikkat çeken bir dekor, doğal fonlarla buluştu ve Moon serisi hayat buldu.</span>",
    "descriptionClean": "Doğadan gelen ahenk seramiğe yansıdı. Zıt renklerin uyumu ile şekillenen bir tasarım. Dikkat çeken bir dekor, doğal fonlarla buluştu ve Moon serisi hayat buldu.",
    "source": "duratiles"
  },
  {
    "id": "dura_2304",
    "brand": "Duratiles",
    "title": "MOON Kahve 40x120",
    "seriesName": "MOON",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "2304",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1520798250845241.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.1520798250845241.jpg"
    ],
    "size": "40x120",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Duvar Karosu",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğadan gelen ahenk seramiğe yansıdı. Zıt renklerin uyumu ile şekillenen bir tasarım. Dikkat çeken bir dekor, doğal fonlarla buluştu ve Moon serisi hayat buldu.</span>",
    "descriptionClean": "Doğadan gelen ahenk seramiğe yansıdı. Zıt renklerin uyumu ile şekillenen bir tasarım. Dikkat çeken bir dekor, doğal fonlarla buluştu ve Moon serisi hayat buldu.",
    "source": "duratiles"
  },
  {
    "id": "dura_2305",
    "brand": "Duratiles",
    "title": "MOON Geo Dekofon 40x120",
    "seriesName": "MOON",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "2305",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.41565060420024136.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.41565060420024136.jpg"
    ],
    "size": "40x120",
    "color": "Geo Dekofon",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Dekofon",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2",
      "Banyo",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğadan gelen ahenk seramiğe yansıdı. Zıt renklerin uyumu ile şekillenen bir tasarım. Dikkat çeken bir dekor, doğal fonlarla buluştu ve Moon serisi hayat buldu.</span>",
    "descriptionClean": "Doğadan gelen ahenk seramiğe yansıdı. Zıt renklerin uyumu ile şekillenen bir tasarım. Dikkat çeken bir dekor, doğal fonlarla buluştu ve Moon serisi hayat buldu.",
    "source": "duratiles"
  },
  {
    "id": "dura_2306",
    "brand": "Duratiles",
    "title": "MOON Bone 60x60",
    "seriesName": "MOON",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "2306",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5018921852943105.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5018921852943105.jpg"
    ],
    "size": "60x60",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğadan gelen ahenk seramiğe yansıdı. Zıt renklerin uyumu ile şekillenen bir tasarım. Dikkat çeken bir dekor, doğal fonlarla buluştu ve Moon serisi hayat buldu.</span>",
    "descriptionClean": "Doğadan gelen ahenk seramiğe yansıdı. Zıt renklerin uyumu ile şekillenen bir tasarım. Dikkat çeken bir dekor, doğal fonlarla buluştu ve Moon serisi hayat buldu.",
    "source": "duratiles"
  },
  {
    "id": "dura_2307",
    "brand": "Duratiles",
    "title": "MOON Kahve 60x60",
    "seriesName": "MOON",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "2307",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5351497395530878.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5351497395530878.jpg"
    ],
    "size": "60x60",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Yer Karosu",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğadan gelen ahenk seramiğe yansıdı. Zıt renklerin uyumu ile şekillenen bir tasarım. Dikkat çeken bir dekor, doğal fonlarla buluştu ve Moon serisi hayat buldu.</span>",
    "descriptionClean": "Doğadan gelen ahenk seramiğe yansıdı. Zıt renklerin uyumu ile şekillenen bir tasarım. Dikkat çeken bir dekor, doğal fonlarla buluştu ve Moon serisi hayat buldu.",
    "source": "duratiles"
  },
  {
    "id": "dura_2308",
    "brand": "Duratiles",
    "title": "MOON Bone 60x60",
    "seriesName": "MOON",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "2308",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5760516654618757.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5760516654618757.jpg"
    ],
    "size": "60x60",
    "color": "Bone",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğadan gelen ahenk seramiğe yansıdı. Zıt renklerin uyumu ile şekillenen bir tasarım. Dikkat çeken bir dekor, doğal fonlarla buluştu ve Moon serisi hayat buldu.</span>",
    "descriptionClean": "Doğadan gelen ahenk seramiğe yansıdı. Zıt renklerin uyumu ile şekillenen bir tasarım. Dikkat çeken bir dekor, doğal fonlarla buluştu ve Moon serisi hayat buldu.",
    "source": "duratiles"
  },
  {
    "id": "dura_2309",
    "brand": "Duratiles",
    "title": "MOON Kahve 60x60",
    "seriesName": "MOON",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "2309",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5054280287081037.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5054280287081037.jpg"
    ],
    "size": "60x60",
    "color": "Kahve",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Doğadan gelen ahenk seramiğe yansıdı. Zıt renklerin uyumu ile şekillenen bir tasarım. Dikkat çeken bir dekor, doğal fonlarla buluştu ve Moon serisi hayat buldu.</span>",
    "descriptionClean": "Doğadan gelen ahenk seramiğe yansıdı. Zıt renklerin uyumu ile şekillenen bir tasarım. Dikkat çeken bir dekor, doğal fonlarla buluştu ve Moon serisi hayat buldu.",
    "source": "duratiles"
  },
  {
    "id": "dura_2310",
    "brand": "Duratiles",
    "title": "PRESTIGE Gri 60x120",
    "seriesName": "PRESTIGE",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "2310",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9068779040191334.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9068779040191334.jpg"
    ],
    "size": "60x120",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Eşsiz bir dokunuş, fark edilen tasarım... Prestige ile hayatın ritmini yakalayın.</span>",
    "descriptionClean": "Eşsiz bir dokunuş, fark edilen tasarım... Prestige ile hayatın ritmini yakalayın.",
    "source": "duratiles"
  },
  {
    "id": "dura_2311",
    "brand": "Duratiles",
    "title": "PRESTIGE Antrasit 60x120",
    "seriesName": "PRESTIGE",
    "collection": "Rustik",
    "category": "Rustik",
    "sku": "2311",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6610837084050629.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6610837084050629.jpg"
    ],
    "size": "60x120",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Endüstriyel Zemin & Ev içi Zemin & Dış Cephe",
    "technology": "Sırlı Porselen Karo",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "V2",
      "Banyo",
      "Dış Cephe",
      "Endüstriyel Zemin",
      "Ev İçi Zemin"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Eşsiz bir dokunuş, fark edilen tasarım... Prestige ile hayatın ritmini yakalayın.</span>",
    "descriptionClean": "Eşsiz bir dokunuş, fark edilen tasarım... Prestige ile hayatın ritmini yakalayın.",
    "source": "duratiles"
  },
  {
    "id": "dura_2312",
    "brand": "Duratiles",
    "title": "FIENTRA Beyaz 60x60",
    "seriesName": "FIENTRA",
    "collection": "Tekstil",
    "category": "Tekstil",
    "sku": "2312",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7607203838117249.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7607203838117249.jpg"
    ],
    "size": "60x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Ticari Alanlar & Banyo & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Ticari Alanlar",
      "Banyo",
      "Ev İçi Zemin",
      "V1"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Estetik ve dayanıklılığı bir araya getiren Fientra, tekstil dokusunu andıran doğal yüzeyiyle mekânlara zarif ve sade bir şıklık kazandırır. Modern tasarımlar için güçlü ve estetik bir zemin alternatifi sunar.</span>",
    "descriptionClean": "Estetik ve dayanıklılığı bir araya getiren Fientra, tekstil dokusunu andıran doğal yüzeyiyle mekânlara zarif ve sade bir şıklık kazandırır. Modern tasarımlar için güçlü ve estetik bir zemin alternatifi sunar.",
    "source": "duratiles"
  },
  {
    "id": "dura_2313",
    "brand": "Duratiles",
    "title": "GLAMOUR Gri 60x60",
    "seriesName": "GLAMOUR",
    "collection": "Tekstil",
    "category": "Tekstil",
    "sku": "2313",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.32806374736764965.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.32806374736764965.jpg"
    ],
    "size": "60x60",
    "color": "Gri",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Uygulandığı mekâna zengin ve zarif bir görünüm kazandıran Glamour serisi ile özgün bir tasarımın mimarı olabilirsiniz.</span>",
    "descriptionClean": "Uygulandığı mekâna zengin ve zarif bir görünüm kazandıran Glamour serisi ile özgün bir tasarımın mimarı olabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_2314",
    "brand": "Duratiles",
    "title": "GLAMOUR Antrasit 60x60",
    "seriesName": "GLAMOUR",
    "collection": "Tekstil",
    "category": "Tekstil",
    "sku": "2314",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9444265512321783.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9444265512321783.jpg"
    ],
    "size": "60x60",
    "color": "Antrasit",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Uygulandığı mekâna zengin ve zarif bir görünüm kazandıran Glamour serisi ile özgün bir tasarımın mimarı olabilirsiniz.</span>",
    "descriptionClean": "Uygulandığı mekâna zengin ve zarif bir görünüm kazandıran Glamour serisi ile özgün bir tasarımın mimarı olabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_2315",
    "brand": "Duratiles",
    "title": "GLAMOUR Multi Dekor 60x60",
    "seriesName": "GLAMOUR",
    "collection": "Tekstil",
    "category": "Tekstil",
    "sku": "2315",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9913230389229708.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.9913230389229708.jpg"
    ],
    "size": "60x60",
    "color": "Multi Dekor",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Porselen",
    "badge": "",
    "features": [
      "V2"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px;\">Uygulandığı mekâna zengin ve zarif bir görünüm kazandıran Glamour serisi ile özgün bir tasarımın mimarı olabilirsiniz.</span>",
    "descriptionClean": "Uygulandığı mekâna zengin ve zarif bir görünüm kazandıran Glamour serisi ile özgün bir tasarımın mimarı olabilirsiniz.",
    "source": "duratiles"
  },
  {
    "id": "dura_2316",
    "brand": "Duratiles",
    "title": "KETEN Gri 30x60",
    "seriesName": "KETEN",
    "collection": "Tekstil",
    "category": "Tekstil",
    "sku": "2316",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.35643355140487687.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.35643355140487687.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V2",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Geçmişten gelen güzellik anlayışı ile modern tasarımların buluşma noktası olan Keten serisi ile desenlerin uyumunu keşfedin.</span>",
    "descriptionClean": "Geçmişten gelen güzellik anlayışı ile modern tasarımların buluşma noktası olan Keten serisi ile desenlerin uyumunu keşfedin.",
    "source": "duratiles"
  },
  {
    "id": "dura_2317",
    "brand": "Duratiles",
    "title": "KETEN Antrasit 30x60",
    "seriesName": "KETEN",
    "collection": "Tekstil",
    "category": "Tekstil",
    "sku": "2317",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18363339173567117.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.18363339173567117.jpg"
    ],
    "size": "30x60",
    "color": "Antrasit",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Duvar & Yer & Balkon/Teras & Banyo & Ev içi Zemin & Ticari Alanlar",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "Sırlı Porselen",
    "badge": "",
    "features": [
      "V2",
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "<span style=\"color: rgb(112, 112, 112); font-family: &quot;DIN[T] Light&quot;; font-size: 16px; text-align: center;\">Geçmişten gelen güzellik anlayışı ile modern tasarımların buluşma noktası olan Keten serisi ile desenlerin uyumunu keşfedin.</span>",
    "descriptionClean": "Geçmişten gelen güzellik anlayışı ile modern tasarımların buluşma noktası olan Keten serisi ile desenlerin uyumunu keşfedin.",
    "source": "duratiles"
  },
  {
    "id": "dura_2343",
    "brand": "Duratiles",
    "title": "MONTEVIDEO Arce 15x90",
    "seriesName": "MONTEVIDEO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "2343",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6997010600141148.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6997010600141148.jpg"
    ],
    "size": "15x90",
    "color": "Arce",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Banyo & Balkon/Teras & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<font color=\"#707070\" face=\"DIN[T] Light\">Montevideo, modern yüzey estetiğiyle yorumlanan ahşap görünümü, yaşam alanlarında bütüncül ve zamansız bir zemin karakteri oluşturur.</font>",
    "descriptionClean": "Montevideo, modern yüzey estetiğiyle yorumlanan ahşap görünümü, yaşam alanlarında bütüncül ve zamansız bir zemin karakteri oluşturur.",
    "source": "duratiles"
  },
  {
    "id": "dura_2353",
    "brand": "Duratiles",
    "title": "PRAIA Beyaz 30x60",
    "seriesName": "PRAIA",
    "collection": "Mermer",
    "category": "Mermer",
    "sku": "2353",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5481934971550341.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5481934971550341.jpg"
    ],
    "size": "30x60",
    "color": "Beyaz",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Banyo & Balkon/Teras & Ev içi Zemin & Ticari Alanlar & İç Mekan",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "R9",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<font color=\"#707070\" face=\"DIN[T] Light\">Praia, zarif dokusu ve doğal görünümüyle mekânlara aydınlık ve zamansız bir şıklık kazandırır.</font>",
    "descriptionClean": "Praia, zarif dokusu ve doğal görünümüyle mekânlara aydınlık ve zamansız bir şıklık kazandırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2352",
    "brand": "Duratiles",
    "title": "STORM Gri 30x60",
    "seriesName": "STORM",
    "collection": "Beton",
    "category": "Beton",
    "sku": "2352",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.061078935003265555.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.061078935003265555.jpg"
    ],
    "size": "30x60",
    "color": "Gri",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Duvar & Banyo & Balkon/Teras & Ev içi Zemin & Ticari Alanlar & İç Mekan",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Ev İçi Zemin",
      "Ticari Alanlar",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<div><font color=\"#707070\" face=\"DIN[T] Light\">Storm, betonun ham ve modern dokusunu&nbsp;</font><span style=\"color: rgb(112, 112, 112);\">rustik bir ruhla birleştirerek mekânlarınıza zamansız&nbsp;</span><span style=\"color: rgb(112, 112, 112);\">bir karakter katıyor.</span></div>",
    "descriptionClean": "Storm, betonun ham ve modern dokusunu rustik bir ruhla birleştirerek mekânlarınıza zamansız bir karakter katıyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2350",
    "brand": "Duratiles",
    "title": "MIAMI Arce 15x90",
    "seriesName": "MIAMI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "2350",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.37027288044110607.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.37027288044110607.jpg"
    ],
    "size": "15x90",
    "color": "Arce",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Banyo & Balkon/Teras & Ev içi Zemin & İç Mekan",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "R9",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<font color=\"#707070\">Doğal ahşap dokusunun sıcaklığı, modern yüzey tasarımıyla yeniden yorumlandı. Yaşam alanlarına sade, dengeli ve zamansız bir zemin karakteri kazandırır.</font>",
    "descriptionClean": "Doğal ahşap dokusunun sıcaklığı, modern yüzey tasarımıyla yeniden yorumlandı. Yaşam alanlarına sade, dengeli ve zamansız bir zemin karakteri kazandırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2349",
    "brand": "Duratiles",
    "title": "BARNWOOD BUFF MATTE Barnwood Buff Matte 15x60",
    "seriesName": "BARNWOOD BUFF MATTE",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "2349",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7944501136918611.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.7944501136918611.jpg"
    ],
    "size": "15x60",
    "color": "Barnwood Buff Matte",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Balkon/Teras & Banyo & Ev içi Zemin & İç Mekan",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "R9",
    "chemicalResistance": "",
    "boxM2": "",
    "boxPcs": "",
    "bodyType": "",
    "badge": "",
    "features": [
      "Balkon Teras",
      "Banyo",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "Barnwood Buff Matte serisi, ahşabın doğal dokusunu seramiğin üstün dayanıklılığı ile birleştiriyor.",
    "descriptionClean": "Barnwood Buff Matte serisi, ahşabın doğal dokusunu seramiğin üstün dayanıklılığı ile birleştiriyor.",
    "source": "duratiles"
  },
  {
    "id": "dura_2348",
    "brand": "Duratiles",
    "title": "MINI Vail 15x60",
    "seriesName": "MINI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "2348",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5610327675346676.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5610327675346676.jpg"
    ],
    "size": "15x60",
    "color": "Vail",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Yer",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "R9",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "Mekânlarda dingin bir dokunuş: Mini. Gerçekçi dokusu ve modern ölçüleriyle ahşabın en dayanıklı hali.",
    "descriptionClean": "Mekânlarda dingin bir dokunuş: Mini. Gerçekçi dokusu ve modern ölçüleriyle ahşabın en dayanıklı hali.",
    "source": "duratiles"
  },
  {
    "id": "dura_2347",
    "brand": "Duratiles",
    "title": "MINI Roble 15x60",
    "seriesName": "MINI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "2347",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22592595685904726.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.22592595685904726.jpg"
    ],
    "size": "15x60",
    "color": "Roble",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Yer",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "R9",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "Mekânlarda dingin bir dokunuş: Mini. Gerçekçi dokusu ve modern ölçüleriyle ahşabın en dayanıklı hali.",
    "descriptionClean": "Mekânlarda dingin bir dokunuş: Mini. Gerçekçi dokusu ve modern ölçüleriyle ahşabın en dayanıklı hali.",
    "source": "duratiles"
  },
  {
    "id": "dura_2342",
    "brand": "Duratiles",
    "title": "MONTEVIDEO Gris 15x90",
    "seriesName": "MONTEVIDEO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "2342",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4506795302232339.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.4506795302232339.jpg"
    ],
    "size": "15x90",
    "color": "Gris",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Banyo & Balkon/Teras & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<font color=\"#707070\" face=\"DIN[T] Light\">Montevideo, modern yüzey estetiğiyle yorumlanan ahşap görünümü, yaşam alanlarında bütüncül ve zamansız bir zemin karakteri oluşturur.</font>",
    "descriptionClean": "Montevideo, modern yüzey estetiğiyle yorumlanan ahşap görünümü, yaşam alanlarında bütüncül ve zamansız bir zemin karakteri oluşturur.",
    "source": "duratiles"
  },
  {
    "id": "dura_2346",
    "brand": "Duratiles",
    "title": "MINI Dove 15x60",
    "seriesName": "MINI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "2346",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6248191796454534.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6248191796454534.jpg"
    ],
    "size": "15x60",
    "color": "Dove",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Yer",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "R9",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "Mekânlarda dingin bir dokunuş: Mini. Gerçekçi dokusu ve modern ölçüleriyle ahşabın en dayanıklı hali.",
    "descriptionClean": "Mekânlarda dingin bir dokunuş: Mini. Gerçekçi dokusu ve modern ölçüleriyle ahşabın en dayanıklı hali.",
    "source": "duratiles"
  },
  {
    "id": "dura_2351",
    "brand": "Duratiles",
    "title": "MIAMI Roble 15x90",
    "seriesName": "MIAMI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "2351",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5619050980980996.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.5619050980980996.jpg"
    ],
    "size": "15x90",
    "color": "Roble",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Banyo & Balkon/Teras & Ev içi Zemin & İç Mekan",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "R9",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<font color=\"#707070\">Doğal ahşap dokusunun sıcaklığı, modern yüzey tasarımıyla yeniden yorumlandı. Yaşam alanlarına sade, dengeli ve zamansız bir zemin karakteri kazandırır.</font>",
    "descriptionClean": "Doğal ahşap dokusunun sıcaklığı, modern yüzey tasarımıyla yeniden yorumlandı. Yaşam alanlarına sade, dengeli ve zamansız bir zemin karakteri kazandırır.",
    "source": "duratiles"
  },
  {
    "id": "dura_2345",
    "brand": "Duratiles",
    "title": "MINI Driftwood 15x60",
    "seriesName": "MINI",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "2345",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10989476873163684.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.10989476873163684.jpg"
    ],
    "size": "15x60",
    "color": "Driftwood",
    "surface": "",
    "thickness": "Standart",
    "usageArea": "Yer",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "",
    "slipResistance": "R9",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "V3",
      "Ev İçi Zemin",
      "Balkon Teras",
      "Banyo",
      "Ticari Alanlar"
    ],
    "pdfUrl": "",
    "description": "Mekânlarda dingin bir dokunuş: Mini. Gerçekçi dokusu ve modern ölçüleriyle ahşabın en dayanıklı hali.",
    "descriptionClean": "Mekânlarda dingin bir dokunuş: Mini. Gerçekçi dokusu ve modern ölçüleriyle ahşabın en dayanıklı hali.",
    "source": "duratiles"
  },
  {
    "id": "dura_2344",
    "brand": "Duratiles",
    "title": "MONTEVIDEO Roble 15x90",
    "seriesName": "MONTEVIDEO",
    "collection": "Ahşap",
    "category": "Ahşap",
    "sku": "2344",
    "image": "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6535637073672033.jpg",
    "images": [
      "https://xaamrmgvmedxaiacbejp.supabase.co/storage/v1/object/public/images/0.6535637073672033.jpg"
    ],
    "size": "15x90",
    "color": "Roble",
    "surface": "Mat",
    "thickness": "Standart",
    "usageArea": "Yer & Banyo & Balkon/Teras & Ev içi Zemin",
    "technology": "",
    "waterAbsorption": "",
    "frostResistance": "Resistant",
    "slipResistance": "R9",
    "chemicalResistance": "",
    "boxM2": 1.44,
    "boxPcs": 2,
    "bodyType": "",
    "badge": "",
    "features": [
      "Banyo",
      "Balkon Teras",
      "Ev İçi Zemin",
      "V3"
    ],
    "pdfUrl": "",
    "description": "<font color=\"#707070\" face=\"DIN[T] Light\">Montevideo, modern yüzey estetiğiyle yorumlanan ahşap görünümü, yaşam alanlarında bütüncül ve zamansız bir zemin karakteri oluşturur.</font>",
    "descriptionClean": "Montevideo, modern yüzey estetiğiyle yorumlanan ahşap görünümü, yaşam alanlarında bütüncül ve zamansız bir zemin karakteri oluşturur.",
    "source": "duratiles"
  }
]